I18n.translations || (I18n.translations = {}),
  (I18n.translations.pl = I18n.extend(I18n.translations.pl || {}, {
    active_admin: {
      action_impossible: "Operacja jest niemożliwa.",
      action_success: "Operacja zakończyła sie sukcesem.",
      actual_at_x: "dane na %{datetime}",
      add_tag_batch_action: {
        add_success: 'Tag "%{name}" został usunięty z wybranych rekordów.',
        remove_instead: "Usuń tag z wybranych rekordów? (zamiast dodawać)",
        remove_success: 'Tag "%{name}" został dodany do wybranych rekordów.',
      },
      basic_details: "Dane podstawowe",
      batch_actions: {
        button_label: "Akcje na wielu rekordach",
        labels: {
          add_category: "Przypisz kategorię do",
          add_location: "Przypisz lokalizację do",
          add_product_st_tag: "Przypisz znacznik ST do",
          add_tag: "Przypisz tag do",
          v1_st_balance_company_debt: "Rozlicz z Firmą",
          add_admin_user: "",
          add_payment_profile: "Przypisz profil płatności do",
          remove_payment_profile: "Usuń profil płatności z",
        },
      },
      company_edit: {
        possible_to_edit_only_by_global_admin: "Możliwe do edycji tylko przez głównego administratora.",
      },
      company_registrations: {
        approve: "Potwierdź",
        reject: "Odrzuć",
      },
      company_submit_monthly_invoicing_stats: {
        success: "Zamówienia zostały rozliczone.",
      },
      content_details: "Treść",
      dashboard: "Pulpit",
      dashboard_page: {
        approved_orders: {
          title: "Zamówienia zatwierdzone",
        },
        search_orders: {
          submit: "Szukaj",
          title: "Wyszukaj zamówienia",
        },
        summary: {
          title: "Podsumowanie",
        },
        upcoming_orders: {
          title: "Nadchodzące zamówienia",
        },
        waiting_for_company_approval_orders: {
          title: "Zamówienia oczekujące na potwierdzenie Firmy",
        },
        waiting_for_customer_approval_orders: {
          title: "Zamówienia oczekujące na potwierdzenie Klienta",
        },
      },
      default_menu: {
        add_new: "Dodaj",
        new_admin_company: "Dodaj firmę",
        new_admin_product_tag: "Dodaj znacznik ofert",
        new_admin_product_tags_category: "Dodaj kategorię znaczników ofert",
        others: "Pozostałe",
        users: "Użytkownicy",
      },
      delete_file: "Usuń plik",
      devise: {
        email: {
          title: "Adres e-mail",
        },
        links: {
          resend_unlock_instructions: "Odblokuj konto",
        },
        password: {
          title: "Hasło",
        },
        reset_password: {
          submit: "Zresetuj hasło",
        },
        unlock: {
          submit: "Wyślij instrukcje odblokowania",
          title: "Odblokuj konto",
        },
      },
      globalize: {
        language: {
          pl: "Polski",
          en: "Angielski",
          ru: "Rosyjski",
        },
        translations: "Tłumaczenia",
      },
      go_back: "Wróć",
      monthly_invoicing_stats: "Miesięczne rozliczenie zamówień",
      order_actions: {
        action_failed_error: "Akcja nie powiodła się z powodu błędu: %{error}",
        approve: "Potwierdź zamówienie",
        cancel: "Anuluj zamówienie",
        confirm: "Wyślij zamówienie",
        finish: "Zakończ zamówienie",
        redeliver_customer_order_email: "Wyślij ponownie email o zamówieniu do Klienta",
        reject: "Odrzuć zamówienie",
        successfully_approved: "Zamówienie %{id} zostało potwierdzone.",
        successfully_cancelled: "Zamówienie %{id} zostało anulowane.",
        successfully_confirmed: "Zamówienie %{id} zostało wysłane.",
        successfully_finished: "Zamówienie %{id} zostało oznaczone jako Zakończone.",
        successfully_redelivered_customer_order_email:
          "Email o zamówieniu został wysłany do Klienta ponownie na jego adres e-mail %{customer_email}.",
        successfully_rejected: "Zamówienie %{id} zostało odrzucone.",
        view_stats: "Statystyki zamówień",
        redeliver_supplier_order_email: "Wyślij email o zamówieniu do Dostawcy",
        successfully_redelivered_supplier_order_email:
          "Email o zamówieniu został wysłany do Dostawcy ponownie na jego adres e-mail %{customer_email}.",
      },
      order_edit: {
        order_not_yet_confirmed_error:
          "To zamówienie nie zostało jeszcze ukończone przez klienta. Jego edycja z poziomu panelu administratora jest na ten moment niemożliwa.",
      },
      order_show: {
        activities: {
          email_message_email: "Adres e-mail",
          email_message_subject: "Tytuł wiadomości",
          order_status_updated_action: "Akcja",
          order_status_updated_content: "Zmiana statusu na %{status}",
          sms_message_content: "Treść SMSa",
          sms_message_phone_number: "Nr telefonu",
          title: "Historia zamówienia",
        },
      },
      order_show_company_invoice: {
        invoice_retrieval_error: "Błąd podczas pobierania PDF faktury z iFirma: %{error}",
      },
      order_show_customer_invoice: {
        invoice_retrieval_error: "Błąd podczas pobierania PDF faktury z iFirma: %{error}",
      },
      order_v1_st_balance_company_debt: {
        success: "Zamówienie nr %{id} zostało rozliczone z Firmą.",
      },
      orders_stats: {
        average_orders_value_th: "Średnia kwota zamówień z X",
        in_average_th: "Średnio X",
        in_total_th: "Łącznie X",
        name_th: "Nazwa X",
        orders_count_th: "Liczba zamówień z X",
        title: "Statystyki zamówień",
        total_orders_value_th: "Łączna kwota zamówień z X",
      },
      orders_v1_st_balance_company_debt: {
        success: "Wybrane zamówienia zostały rozliczone.",
      },
      preview: "Podejrzyj",
      product_tags_index: {
        tag_stats: "%{products_count} otagowanych, %{all_products_count} w sumie",
      },
      products_index: {
        batch_action_add_product_tag: {
          add_success: 'Znacznik "%{name}" został dodany do wybranych ofert.',
          remove_instead: "Usuń znacznik z wybranych ofert? (zamiast dodawać)",
          remove_success: 'Znacznik "%{name}" został usunięty z wybranych ofert.',
        },
      },
      scopes: {
        abandoned: "Porzucone",
        all: "Wszystkie",
        approved: "Zatwierdzone",
        approved_finished_short: "Zatw. / zak.",
        building: "Szkic",
        cancelled: "Anulowane",
        category: "Kategorie",
        company_tag: "Tagi firm",
        customer_tag: "Tagi klientów",
        deprecated_v1_accomodation: "Noclegi",
        deprecated_v1_coupon: "Kupony / Zniżki",
        deprecated_v1_special_offer: "Oferty specjalne",
        deprecated_v1_trip: "Wycieczki",
        finished: "Zakończone",
        future_customers: "Przyszli",
        location: "Lokalizacje",
        lost_customers: "Utraceni",
        marketplace: "Marketplace",
        order_tag: "Tagi zamówień",
        past_customers: "Przeszli",
        product_st_tag: "Znaczniki ST",
        prospect_customers: "Potencjalni",
        rejected: "Odrzucone",
        saas: "SaaS",
        waiting_for_company_approval: "Oczekujące na potwierdzenie Firmy",
        waiting_for_customer_approval: "Oczekujące na potwierdzenie Klienta",
        product_company_tag: "Znaczniki Firmy",
      },
      search_status: {
        current_filters: "Obecne filtry:",
        current_scope: "Obecny zakres:",
        headline: "Zakres:",
        no_current_filters: "Brak",
      },
      sidebars: {
        relation_no_results: "Brak rezultatów.",
      },
      successfully_created: "%{model} został stworzony pomyślnie.",
      successfully_updated: "%{model} został zaktualizowany pomyślnie.",
      tabs: {
        availability: "Dostępność",
        base_details: "Dane podstawowe",
        description: "Opis",
        images: "Zdjęcia",
        invoicing: "Rozliczenia",
        location: "Lokalizacja",
        other_details: "Pozostałe ustawienia",
        pricelists: "Cennik",
        product_order_fields: "Opcje dodatkowe",
        product_variants: "Warianty",
      },
      widgets: "Widgety",
      wrong_lock_version_error:
        "Ten rekord %{resource_name} został zmieniony przez kogoś w międzyczasie. Otwórz formularz w nowej karcie i wprowadź zmiany ponownie.",
      location_details: "Lokalizacja",
      companies: {
        destroy: {
          action_impossible_company_has_orders_as_supplier:
            "Usunięcie tej Firmy nie jest możliwe - posiada ona zamówienia jako dostawca. Usuń najpierw jego zamówienia, by usunąć firmę.",
        },
      },
      pp_edit: "Edytuj w PP",
      add_admin_user_batch_action: {
        remove_instead: "",
        success: "",
      },
      add_payment_profile_action: {
        success: "Profil płatności został przypisany do wybranych rekordów",
      },
      pricing_plans: {
        new_elastic_plan: "Nowy plan elastyczny",
        new_not_refundable_plan: "Nowy plan bezzwrotny",
      },
      remove_payment_profile_action: {
        success: "Profil płatności został usunięty z wybranych rekordów",
      },
    },
    fe: {
      active_admin: {
        view_collection_item_nested_form: {
          toggle_show: "Pokaż / Schowaj własne atrybuty",
        },
      },
      ckeditor: {
        subsection_expand: {
          content:
            "Treść sekcji, która domyślnie będzie schowana, a użytkownik wyświetlić ją będzie mógł dopiero po kliknięciu na tytuł.",
          title: "Tytuł sekcji",
        },
        subsection_read_more: {
          content: 'Treść sekcji, która zostanie skrócona do linku "Czytaj więcej", jeśli będzie za długa.',
          title: "Tytuł sekcji",
        },
      },
      NewOrderCalendarForm: {
        help_tip: "Legenda (najedź myszką)",
        product_chosen: "Wybrałeś ofertę %{name} w terminie %{date_range}.",
        stock_available: "Termin dostępny",
        stock_available_but_impossible_as_end:
          "Termin dostępny, ale w ramach tej oferty nie można w tym dniu zakończyć pobytu",
        stock_available_but_impossible_as_start: "Termin dostępny, ale nie można w tym dniu rozpocząć pobytu",
        stock_busy: "Termin zajęty",
        stock_discounted: "Cena promocyjna",
        submit: "Dalej",
        previous_slots: "Poprzednie terminy",
        next_slots: "Następne terminy",
        stock_confirmed: "Termin potwierdzony",
      },
      NewOrderConfirmPricingForm: {
        submit: "Dalej",
      },
      NewOrderCustomerDetailsForm: {
        order_with_payment_requirement: "zamówienie z obowiązkiem zapłaty",
        participant_name_with_number: "Uczestnik nr %{i}",
        required_fields: "pola wymagane",
        submit: {
          make_order: "Rezerwuj",
          next: "Dalej",
        },
      },
      NewOrderPaymentForm: {
        almost_booked: "Gratulacje! Już tylko jedna minuta dzieli Cię od złożenia wstępnego zamówienia!",
        almost_finished: "Gratulacje! Już tylko jedna minuta dzieli Cię od dokończenia zamówienia.",
        cancelled_if_not_paid:
          "W przypadku nie dokonania wpłaty w powyższym terminie, Twoja zamówienie zostanie automatycznie odrzucone.",
        dotpay_go_back_button: "Wróć do formularza zamówienia",
        order_with_payment_requirement: "zamówienie z obowiązkiem zapłaty",
        pay_to_book: {
          marketplace:
            "Gdy tylko opłacisz %{confirmation_installment_transaction_amount} za pośrednictwem bezpiecznych płatności online, organizator będzie mógł potwierdzić Twoje zamówienie.",
          saas: "Gdy tylko opłacisz %{confirmation_installment_transaction_amount}, dostaniemy Twoje zamówienie i będziemy mogli je ostatecznie potwierdzić.",
        },
        pay_to_finish:
          "Gdy tylko opłacisz %{confirmation_installment_transaction_amount}, automatycznie przekażemy Ci voucher pdf z danymi Twojego zamówienia.",
        payment_deadline: "Termin płatności: %{pauses_at}.",
        please_pay_online_deposit:
          "Prosimy o dokonanie płatności na kwotę %{confirmation_installment_transaction_amount} poprzez nasz bezpieczny system płatności online.",
        safe_payments_guaranteed_by: "Bezpieczne płatności gwarantowane przez",
        submit: {
          book_and_pay: "Rezerwuj i zapłać teraz %{price}",
          pay: "Zapłać teraz %{price}",
          pay_with_dotpay: "Zapłać %{price} przez DotPay",
          pay_with_paypal: "Zapłać %{price} przez PayPal",
        },
        choose_payment_method: "Wybierz metodę płatności:",
        pay_by_bank_wire: "przelew bankowy",
        pay_by_credit_card: "Zapłać kartą (bez konta PayPal) lub zaloguj się i zapłać przez PayPal.",
        by_bank_wire: "przelew bankowy",
        by_credit_card:
          "Zapłać kartą (nie musisz mieć, ani zakładać konta PayPal) lub zaloguj się i zapłać przez PayPal.",
        by_bank_wire_or_credit_card: "Zapłać kartą lub internetowym przelewem bankowym.",
        by_paypal: "Zaloguj się, aby zapłacić przez PayPal.",
        pay_by_credit_card_or_paypal: "Zapłać kartą (bez konta PayPal) lub zaloguj się i zapłać przez PayPal.",
        by_payu: "Zapłać kartą debetową lub kredytową",
        payu_button: "Zapłać przez PayU",
      },
      NewOrderProductForm: {
        choose_payment_profile: "Wybierz sposób płatności",
        items_count: "Liczba %{items}",
        multiple_pricings_alert:
          'Uwaga: Ze względu na limity datowo-sprzedażowe, nie możemy rozliczyć wszystkich %{product_quantity} %{items} na podstawie cennika "%{product_pricelist_name}".',
        multiple_pricings_info:
          "Zamiast tego, wybrana przez Ciebie kombinacja zostanie rozliczona w następujący sposób:",
        custom_location_name_placeholder: "Wpisz adres z jakiego ma Cię odebrać organizator",
        submit: "Dalej",
      },
      NewOrderView: {
        building: "Zamawiasz",
        built: "Zamówiłeś",
        contact_us_if_problem_repeats: "Jeśli błąd będzie występował dalej, skontaktuj się z nami: %{email}.",
        loading_failed: "Wystąpił błąd podczas ładowania danych oferty. Odśwież stronę, by spróbować ponownie.",
        loading_in_progress: "Trwa ładowanie danych...",
        marketplace: {
          additional_bank_wire_deposit_required: "To zamówienie wymaga dodatkowej płatności na konto.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "Firma %{company_link} otrzyma Twoje wstępne zamówienie natychmiast po jego wysłaniu. Firma ma %{company_approval_time_limit} na odpowiedź, ale większość z nich odpowiada w ciągu 1h w lokalnych godzinach pracy.",
          bank_wire_deposit_deadline_warning:
            "Pamiętaj o dokonaniu przelewu na czas. Jeśli nie wpłacisz zaliczki na konto bankowe w odpowiednim terminie, Twoje zamówienie może zostać anulowane.",
          bank_wire_deposit_details: "Dane do przelewu bankowego",
          bank_wire_deposit_instructions:
            "W tytule przelewu prosimy wpisać tylko i wyłącznie numer zamówienia, który znajduje się w niniejszym potwierdzeniu. W przeciwnym wypadku nie możemy zagwarantować, że przelew zostanie zaksięgowany na czas.",
          building: "Zamawiasz",
          built: "Zamówiłeś",
          company_approved_your_order_request:
            'Firma %{company_link} potwierdziła Twoje zamówienie wstępne nr %{order_id} na "%{product_name}".',
          company_received_your_order_request_and_has_to_approve_it:
            "Firma %{company_link} otrzymała od nas Twoje wstępne zamówienie. Firma ma %{company_approval_time_limit} na odpowiedź, ale większość z nich odpowiada w ciągu 1h w lokalnych godzinach pracy.",
          contact_us_if_problem_repeats: "Jeśli błąd będzie występował dalej, skontaktuj się z nami: %{email}.",
          customer_full_name: "Imię i nazwisko zamawiającego",
          download_order_data_confirmation: "Pobierz potwierdzenie zamówienia",
          further_details: "Dalsze informacje",
          if_no_online_payment_your_order_will_be_cancelled:
            "W przypadku braku płatności Twoje zamówienie zostanie anulowane.",
          loading_failed: "Wystąpił błąd podczas ładowania danych oferty. Odśwież stronę, by spróbować ponownie.",
          loading_in_progress: "Trwa ładowanie danych...",
          order_is_waiting_for_company_approval:
            "Twoje zamówienie oczekuje teraz na potwierdzenie przez firmę %{company_link}.",
          order_name: "Zamówienie nr %{id}",
          order_status: "Status zamówienia",
          please_pay_bank_wire_deposit: "Prosimy o dokonanie płatności poprzez przelew bankowy.",
          repeat_payment: "Ponów płatność",
          share_us_to_friends: "Chcesz być na bieżąco z najciekawszymi ofertami i zniżkami? Polub nas lub poleć innym!",
          thank_you_for_order: "Dziękujemy za złożenie zamówienia!",
          thank_you_for_order_and_share_to_fb:
            "Dziękujemy za złożenie zamówienia. Pomóż nam i poleć tą ofertę Twoim znajomym na Facebooku!",
          thank_you_for_order_request: "Dziękujemy za złożenie wstępnego zamówienia.",
          we_received_all_required_order_informations: "Otrzymaliśmy już od Ciebie wszelkie potrzebne informacje.",
          we_received_all_required_order_informations_and_online_payment:
            "Otrzymaliśmy już od Ciebie wszelkie potrzebne informacje i płatność.",
          we_sended_order_confirmation_to_your_email:
            "Na Twój adres e-mail przesłaliśmy potwierdzenie Twojego zamówienia w formacie .pdf.",
          we_sended_order_request_confirmation_to_your_email:
            "Na Twój adres e-mail przesłaliśmy potwierdzenie Twojego wstępnego zamówienia.",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "Jeśli zamówienie zostanie zaakceptowane, wpłacona kwota przejdzie na poczet zamówienia. Jeśli natomiast partner %{company_link} odrzuci prośbę lub nie potwierdzi jej na czas, kwota %{confirmation_installment_st_name} przedpłaty online zostanie automatycznie zwrócona na rachunek bankowy w ciągu 24 h. Możesz wtedy złożyć zamówienie na inną ofertę.",
          when_company_approves_we_will_send_online_payment_email:
            "W przypadku, gdy firma %{company_link} potwierdzi Twoje wstępne zamówienie, otrzymasz e-mail wraz z linkiem do realizacji płatności online w wysokości %{confirmation_installment_amount}. Masz %{confirmation_installment_after_company_approval_time_limit} od momentu potwierdzenia zamówienia na realizację przelewu przez Dotpay.",
          when_company_approves_we_will_send_order_confirmation:
            "W przypadku, gdy firma %{company_link} potwierdzi Twoje wstępne zamówienie, otrzymasz e-mail z potwierdzeniem. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "Firma %{company_link} otrzyma Twoje wstępne zamówienie natychmiast po jego wysłaniu. Firma ma %{company_approval_time_limit} na odpowiedź, ale większość z nich odpowiada w ciągu 1h w lokalnych godzinach pracy.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "Po potwierdzeniu płatności otrzymasz e-mail z potwierdzeniem Twojego zamówienia. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "Plik ten możesz też pobrać za pomocą przycisku poniżej.",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "W potwierdzeniu zamówienia otrzymasz też informacje odnośnie pozostałej płatności na konto bankowe.",
          your_order_id: "Numer Twojego zamówienia",
          your_order_is_fully_confirmed: "Twoje zamówienie jest już w pełni zatwierdzone.",
          online_payment_failed: "Niestety, Twoja płatność online zakończyła się niepowodzeniem.",
          order_is_waiting_for_online_payment_info:
            "Twoje zamówienie oczekuje teraz na otrzymanie informacji o wykonanej przez Ciebie płatności.",
        },
        order_name: "Zamówienie nr %{id}",
        saas: {
          additional_bank_wire_deposit_required: "To zamówienie wymaga dodatkowej płatności na konto.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "Z chwilą dokonania wpłaty otrzymaliśmy Twoje wstępne zamówienie. Mamy %{company_approval_time_limit} na odpowiedź, ale zwykle odpowiadamy w ciągu 1h w godzinach pracy naszego biura.",
          bank_wire_deposit_deadline_warning:
            "Pamiętaj o dokonaniu przelewu na czas. Jeśli nie wpłacisz zaliczki na konto bankowe w podanym terminie, Twoja zamówienie może zostać anulowane.",
          bank_wire_deposit_details: "Dane do przelewu bankowego",
          bank_wire_deposit_instructions:
            "W tytule przelewu prosimy wpisać tylko i wyłącznie numer zamówienia, który znajduje się w niniejszym potwierdzeniu. W przeciwnym wypadku nie możemy zagwarantować, że przelew zostanie zaksięgowany na czas.",
          company_approved_your_order_request:
            'Potwierdziliśmy Twoje zamówienie wstępne nr %{order_id} na "%{product_name}".',
          company_received_your_order_request_and_has_to_approve_it:
            "Otrzymaliśmy Twoje wstępne zamówienie. Mamy %{company_approval_time_limit} na odpowiedź, ale zwykle odpowiadamy w ciągu 1h w godzinach pracy naszego biura.",
          customer_full_name: "Imię i nazwisko zamawiającego",
          download_order_data_confirmation: "Pobierz potwierdzenie zamówienia",
          further_details: "Dalsze informacje",
          if_no_online_payment_your_order_will_be_cancelled:
            "W przypadku braku płatności Twoje zamówienie zostanie anulowane.",
          order_is_waiting_for_company_approval: "Twoje zamówienie oczekuje obecnie na nasze potwierdzenie.",
          order_status: "Status zamówienia",
          please_pay_bank_wire_deposit: "Prosimy o dokonanie płatności poprzez przelew bankowy.",
          repeat_payment: "Ponów płatność",
          thank_you_for_order: "Dziękujemy za złożenie zamówienia!",
          thank_you_for_order_request: "Dziękujemy za złożenie wstepnego zamówienia.",
          we_received_all_required_order_informations: "Otrzymaliśmy już od Ciebie wszelkie potrzebne informacje.",
          we_received_all_required_order_informations_and_online_payment:
            "Otrzymaliśmy już od Ciebie wszelkie potrzebne informacje i płatność.",
          we_sended_order_confirmation_to_your_email:
            "Na Twój adres e-mail przesłaliśmy potwierdzenie Twojego zamówienia w formacie .pdf.",
          we_sended_order_request_confirmation_to_your_email:
            "Na Twój adres e-mail przesłaliśmy potwierdzenie Twojego wstępnego zamówienia.",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "Jeśli będziemy zmuszeni odrzucić Twoją prośbę lub pozwolimy jej wygasnąć, %{confirmation_installment_st_name} online zostanie automatycznie zwrócona na Twój rachunek bankowy w ciągu 24h. Możesz również skontaktować się z nami i wybrać inną ofertę.",
          when_company_approves_we_will_send_online_payment_email:
            "W przypadku, gdy potwierdzimy Twoje wstępne zamówienie, otrzymasz e-mail wraz z linkiem do realizacji płatności online w wysokości %{cconfirmation_installmentamount}. Masz %{confirmation_installment_after_company_approval_time_limit} od momentu potwierdzenia zamówienia na realizację płatności przez Dotpay.",
          when_company_approves_we_will_send_order_confirmation:
            "W przypadku, gdy potwierdzimy Twoje wstępne zamówienie, otrzymasz e-mail z potwierdzeniem. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "Otrzymamy Twoje wstępne zamówienie natychmiast po jego wysłaniu. Mamy %{company_approval_time_limit} na odpowiedź, ale zwykle odpowiadamy w ciągu 1h w godzinach pracy naszego biura.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "Po potwierdzeniu płatności otrzymasz e-mail z potwierdzeniem Twojego zamówienia. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "Plik ten możesz też pobrać za pomocą przycisku poniżej.",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "W potwierdzeniu zamówienia otrzymasz też informacje odnośnie pozostałej płatności na konto bankowe.",
          your_order_id: "Numer Twojego zamówienia",
          your_order_is_fully_confirmed: "Twoje zamówienie jest już w pełni zatwierdzone.",
          online_payment_failed: "Niestety, Twoja płatność online zakończyła się niepowodzeniem.",
          order_is_waiting_for_online_payment_info:
            "Twoje zamówienie oczekuje obecnie na otrzymanie informacji o wykonanej przez Ciebie płatności.",
        },
        step_number: "Krok %{i}",
        title: "Zamówienie nr %{order_id} - %{site_name}",
        show_on_map: "Pokaż na mapie",
        marketplace_booking_unavailable_message_html:
          "Niestety, w obecnym momencie nie ma wolnych terminów. Jeśli mimo to byłbyś zainteresowany, napisz do nas na %{email}, zadzwoń pod %{phone_number} lub %{open_chat} już teraz.",
        saas_booking_unavailable_message_html:
          "Niestety, w obecnym momencie nie ma wolnych terminów. Jeśli mimo to byłbyś zainteresowany, napisz do nas na %{email} lub zadzwoń pod %{phone_number}.",
        open_chat: "otwórz czat z naszym konsultantem",
        choose_date_step_title: "Wybierz datę",
        fill_order_step_title: "Uzupełnij zamówienie",
        confirm_payment_details_step_title: "Potwierdź szczegóły płatności",
        fill_customer_details_step_title: "Podaj swoje dane",
        make_online_payment_step_title: "Zapłać online",
        order_is_waiting_for_your_approval: "Zamówienie oczekuje na Twoje potwierdzenie.",
        click_below_to_approve: "Kliknij poniżej, by je potwierdzić.",
        reject_order: "Odrzuć zamówienie",
        approve_order: "Potwierdź zamówienie",
        approve_order_failed:
          "Wystąpił błąd podczas połączenia z serwerem. Spróbuj jeszcze raz. W przypadku dalszych kłopotów, skontaktuj się z nami info@tripsomnia.com.",
        order_is_finished: "Twoje zamówienie zostało oznaczone jako zakończone.",
        we_havent_received_your_review_yet:
          "Nie otrzymaliśmy jednak jeszcze Twojej recenzji na temat naszej usługi. Podziel się nią z innymi użytkownikami!",
        write_a_review: "Napisz opinię",
      },
      navbar_search: {
        products_count: "%{count} ofert",
        categories: "Kategorie",
        suppliers: "Dostawcy",
        products: "Oferty",
        search_nearby: "Szukaj w pobliżu",
        search_query: "Szukaj po frazie",
      },
      new_order: {
        errors: {
          connection_error_during_saving: "Nastąpił błąd podczas zapisywania zamówienia na serwerze.",
          insufficient_product_quantity:
            "Wybrana liczba %{items} może pomieścić maksymalnie %{max_persons_count} osób. Zwiększ liczbę %{items} do %{desired_quantity} lub zmniejsz liczbę osób.",
          max_quantity_limit: "Ta oferta w wybranym terminie dostępna jest w maksymalnej liczbie %{max_quantity}.",
          missing_value: "Uzupełnij wartość.",
          personal_data_agreement_missing: "Musisz wyrazić zgodę na przetwarzanie swoich danych osobowych.",
          product_not_found: "Wybrana oferta nie została znaleziona.",
          product_schedule_slot_missing: "Wybrany termin oferty nie jest już dostępny.",
          product_variant_not_found: "Wybrany wariant oferty nie został znaleziony.",
          rules_agreement_missing: "Musisz wyrazić zgodę na nasz regulamin.",
          online_payment_impossible_for_selected_parameters:
            "Niestety, płatność online nie jest obecnie możliwa dla tego zamówienia przy użyciu %{payment_method}. Prosimy, wybierz inny sposób płatności.",
          partners_agreement_missing: "Musisz wyrazić zgodę na umowę dotyczącą danych partnerów.",
          rodo_agreement_missing: "Musisz wyrazić zgodę na przetwarzanie danych osobowych.",
        },
        marketplace_service_fee_tooltip:
          "Z tej opłaty finansujemy działalność portalu i świadczone usługi np. pomoc w trakcie podróży, obsługa płatności.",
        saas_service_fee_tooltip:
          "Z tej opłaty finansujemy działalność portalu i świadczone usługi np. pomoc w trakcie podróży, obsługa płatności.",
        v1_bank_wire_deposit_tooltip: {
          marketplace:
            "Dane rachunku do przelewu oraz termin płatności otrzymasz w potwierdzeniu zamówienia na podanego w formularzu maila.",
          saas: "Dane rachunku do przelewu oraz termin płatności otrzymasz w potwierdzeniu zamówienia na podanego w formularzu maila.",
        },
        v1_online_deposit_tooltip: {
          marketplace: {
            line1:
              "%{confirmation_installment_st_name} online służy zabezpieczeniu zamówienia. W przypadku Twojej rezygnacji zastosowanie mają warunki anulacji zawarte w danej ofercie.",
            line2:
              "Firma %{company_link} otrzyma Twoje wstępne zamówienie natychmiast po jego wysłaniu. Firma ma %{company_approval_time_limit} na odpowiedź, ale większość z nich odpowiada w ciągu 1h w lokalnych godzinach pracy.",
            line3:
              "Jeśli firma odrzuci Twoją prośbę lub pozwoli jej wygasnąć, %{confirmation_installment_st_name} przedpłaty online zostanie automatycznie zwrócona na Twój rachunek bankowy w ciągu 24h. Zachęcamy do kontaktu z nami w celu dostosowania oferty do Państwa potrzeb.",
          },
          saas: {
            line1:
              "%{confirmation_installment_st_name} online służy zabezpieczeniu zamówienia. W przypadku Twojej rezygnacji zastosowanie mają warunki anulacji zawarte w danej ofercie, w przypadku ich braku zastosowanie mają nasze warunki ogólne.",
            line2:
              "Otrzymamy Twoje wstępne zamówienie natychmiast po jego wysłaniu. Mamy %{company_approval_time_limit} na odpowiedź, ale zwykle odpowiadamy w ciągu 1h w godzinach pracy naszego biura.",
            line3:
              "Jeśli będziemy zmuszeni odrzucić Twoją prośbę lub pozwolimy jej wygasnąć, %{confirmation_installment_st_name} online zostanie automatycznie zwrócona na Twój rachunek bankowy w ciągu 24h. Możesz również skontaktować się z nami i wybrać inną ofertę.",
          },
        },
        confirmation_installment_st_name: {
          deposit: "Zaliczka",
          fee: "Opłata",
          prepayment: "Przedpłata",
        },
        v1_rest_deposit_tooltip: {
          on_the_arrival: "Dopłać pozostałą kwotę w dniu rozpoczęcia oferty.",
          on_the_spot: "Dopłać pozostała kwotę na miejscu.",
          trip: "Dopłać pozostałą kwotę na początku wycieczki lub przed wycieczką w biurze.",
        },
      },
      order: {
        confirmation_installment_after_company_approval: "Do zapłaty po potwierdzeniu zamówienia przez firmę.",
        new_order_name: "Nowe zamówienie",
        order_name: "Zamówienie nr %{order_id}",
        v1_online_deposit_now: "Do zapłaty teraz",
        stock_useby_time_range: {
          between: "Od %{starts_at} do %{ends_at}",
          from: "Od %{starts_at}",
          to: "Do %{ends_at}",
        },
      },
      order_details: {
        bank_wire_deposit_account_description: "Dane do przelewu",
        company_details: "Dane organizatora",
        customer_details: "Dane zamawiającego",
        extra_paid_amount: "Wpłacono poza tym",
        marketplace_service_fee: "Opłata serwisowa",
        order_details: "Dane zamówienia",
        order_name: "Zamówienie nr %{order_id}",
        overpaid_total_amount: "Nadpłacono",
        paid_amount: "Wpłacono",
        product_details: "Dane oferty",
        refunded_amount: "Zwrócono",
        remaining_total_amount: "Pozostało do zapłaty",
        remaining_total_amount_short: "Do zapłaty",
        saas_service_fee: "Opłata serwisowa",
        total_amount: "Wartość zamówienia",
        total_amount_short: "Razem",
        to_be_paid_total_amount: "Razem do zapłaty",
        coupon_offer_price: "Cena końcowa",
        coupon_offer_price_before_discount: "Cena ogólna",
        coupon_discount_amount: "Nasz rabat",
        coupon_code_realisation_place_online_website_description:
          "Wpisz kod zniżki podczas składania zamówienia przez stronę internetową.",
        coupon_code_realisation_place_manual_description:
          "Podaj ten kod w wiadomości mail lub telefonicznie podczas składania zamówienia.",
        ends_at: "Do: %{ends_at}",
        starts_at: "Od: %{starts_at}",
      },
      personal_data_agreement: {
        label:
          "Wyrażam zgodę na przetwarzanie moich danych osobowych przez SocialTravel sp. z o.o. w celu realizacji zamówienia",
        tooltip:
          "Wyrażam zgodnie z art. 7 ust. 2 Rozporządzenia Parlamentu Europejskiego i Rady UE 2016/679 z 27 kwietnia 2016 r. tzw. RODO wyraźną i dobrowolną zgodę na przetwarzanie i zbieranie moich danych osobowych przez SocialTravel sp. z o.o., w celu komunikacji realizacji zamówienia oraz wsparcia posprzedażowego.",
      },
      pricelist_expiration_countdown: {
        discount_ends_today: "Promocja kończy się dzisiaj o %{expires_at}.",
        discount_ends_tomorrow: "Promocja kończy się jutro o %{expires_at}.",
        product_about_to_finish: "Ta oferta niedługo się kończy.",
        product_finished: "Ta oferta już się zakończyła.",
        x_days_left_to_end_of_discount: {
          one: "Został 1 dzień do końca promocji!",
          few: "Zostały %{count} dni do końca promocji!",
          many: "Zostało %{count} dni do końca promocji!",
          other: "Zostało %{count} dnia do końca promocji!",
        },
        x_left_to_end_of_discount: "Zostało %{time} do końca promocji!",
      },
      products_map: {
        buy_product: "Zarezerwuj termin",
      },
      reservation_calendar: {
        only_x_in_this_price: "Tylko %{count} w tej cenie",
        per_night: " / noc",
        valid_on: "Obowiązuje",
        last_stocks: "Ostatnie miejsca",
      },
      rules_agreement: {
        marketplace: {
          label:
            "Akceptuję %{link} i wyrażam zgodę na rozpoczęcie świadczenia usług przez SocialTravel przed upływem okresu na odstąpienie od umowy.",
          link: "Regulamin Serwisu",
        },
        saas: {
          label:
            "Akceptuję %{link} i wyrażam zgodę na rozpoczęcie świadczenia usług przez Organizatora przed upływem okresu na odstąpienie od umowy.",
          link: "Regulamin Organizatora",
        },
      },
      sidebar_section_order: {
        order_details: "Dane zamówienia",
        title: "Twoje zamówienie",
      },
      sidebar_section_product: {
        extend: "Rozwiń",
        product_details: "Informacje o ofercie",
      },
      common: {
        site_title: "Tripsomnia",
        loading_failed_message: "Wystąpił błąd podczas ładowania danych.",
        click_to_load_again: "Kliknij tutaj, by załadować ponownie.",
        loading_message: "Trwa ładowanie danych...",
        show_more: "Pokaż więcej",
        next_page: "Następna strona",
        previous_page: "Poprzednia strona",
        zendesk_livechat_window_title: "Wsparcie",
        zendesk_livechat_concierge_name: "Obsługa Klienta",
        zendesk_livechat_concierge_title: "Jesteśmy tu by Ci pomóc!",
        close: "Zamknij",
      },
      ProductsCalendarWidget: {
        site_title: "Kalendarz terminów",
      },
      ReviewsListWidget: {
        no_reviews_yet: "Brak jeszcze opinii.",
        add_first_review: "Chcesz dodać pierwszą?",
        add_new_review: "Napisz opinię",
        total_count: {
          one: "%{formatted_count} opinia",
          few: "%{formatted_count} opinie",
          many: "%{formatted_count} opinii",
          other: "%{formatted_count} opinii",
        },
        average_rating: "Średnia ocena",
        rating: "Ocena",
      },
      PaymentMethodsHelper: {
        cash_tooltip: "Płatność gotówką na miejscu",
        online_tooltip: "100% do zapłaty online",
        online_plus_cash_tooltip: "Zapłać teraz przedpłatę online + dopłać gotówkę na miejscu",
      },
      products_listing: {
        medium_priority: "Rekomendowany",
        high_priority: "Najlepsza oferta",
      },
      bslanding: {
        about_us_contact_form: {
          loading_message: "Ładowanie...",
          success_message: "Wiadomość została wysłana.",
          failure_message: "Wystąpił błąd podczas wysyłania wiadomości.",
        },
        for_companies_contact_form: {
          loading_message: "Ładowanie...",
          success_message: "Prośba o założenie konta została wysłana. Odezwiemy się do Ciebie już niedługo.",
          failure_message: "Wystąpił błąd podczas wysyłania wiadomości.",
        },
      },
      CouponsWidget: {
        title: "Wybierz ofertę",
        discount_amount: "Zniżka %{amount}",
        until_product_offer_ends: "%{timeDuration} do końca",
        only_x_coupons_left: "Pobrano %{total_stock_used} kuponów.",
        stock_useby_date_range: "Możliwe do wykorzystania %{date_range}",
        order_price: "Nasza cena",
        order_price_before_discount: "Cena przed zniżką",
        order_discount_amount: "Oszczędzasz",
        build_order_button: "Pobierz kupon",
        build_order_failed:
          "Wystąpił błąd podczas pobierania szczegółów oferty. Spróbuj ponownie lub wybierz inną ofertę.",
        confirm_order_button: "Pobierz voucher",
        confirm_order_failed:
          "Wystąpił błąd podczas zapisywania danych. Spróbuj ponownie lub spróbuj wybrać inną ofertę.",
        form_title: "Uzupełnij swoje dane",
        confirm_order_succeded:
          "Twój voucher został wysłany na podany adres e-mail, sprawdź swoją skrzynkę pocztową i wykorzystaj kupon podczas rezerwacji.",
        product_short_description: "Kluczowe informacje",
        product_description: "Opis oferty",
        product_variant_short_description: "Opis opcji",
        product_customer_requirements: "Warunki",
        extend_infos: "Pokaż więcej »",
        get_coupon: "Pobierz kupon",
        hint_title: "Skorzystaj z naszych promocji",
        hint_content:
          "<ol><li>Wybierz interesującą Cię promocję.</li><li>Zapoznaj się z jej opisem i warunkami.</li><li>Podaj potrzebne dane i pobierz kupon.</li><li>Wykorzystaj kupon promocyjny podczas rezerwacji.</li></ol>",
        less_than_x_coupons_left: "Pozostało mniej niż %{total_stock_left} kuponów dostępnych.",
        no_results_alert: "Niestety, nie mamy już dostępnych kuponów. Spróbuj ponownie później.",
      },
      partners_agreement: {
        label:
          "Zgadzam się na przetwarzanie moich danych osobowych przez Zaufanych Partnerów Tripsomnia w celu realizacji zamówienia.",
        tooltip:
          "Wyrażam zgodnie z art. 7 ust. 2 Rozporządzenia Parlamentu Europejskiego i Rady UE 2016/679 z 27 kwietnia 2016 r. tzw. RODO wyraźną i dobrowolną zgodę na przetwarzanie i zbieranie moich danych osobowych przez zaufanych partnerów w celu komunikacji realizacji zamówienia oraz wsparcia posprzedażowego.",
      },
      rodo_agreement: {
        label: "Jestem świadomy moich praw wynikających z art. 7 RODO",
        tooltip:
          "Jednocześnie oświadczam, że moja zgoda spełnia wszystkie warunki o których mowa w art. 7 RODO, tj. przysługuje mi możliwość jej wycofania w każdym czasie, zapytanie o zgodę zostało mi przedstawione w wyraźnej i zrozumiałej formie oraz poinformowano mnie o warunku możliwości jej rozliczalności. Zostałem również poinformowany o tym, że dane zbierane są przez SocialTravel sp. z o.o., o celu ich zbierania, dobrowolności podania, prawie wglądu i możliwości ich poprawiania oraz że dane te nie będą udostępniane innym podmiotom.",
      },
      tripsomnia_contact_email: "",
      tripsomnia_contact_phone_number: "",
    },
    ransack: {
      predicates: {
        eq: "równe",
      },
    },
    api: {
      base: {
        unauthorized: "Dostęp zabroniony. Zaloguj się ponownie.",
        company_inactive:
          "Firma, którą wybrałeś nie jest obecnie aktywna. Wybierz inną lub postaraj się o jej aktywację.",
        disabled: "",
        secret_invalid: "",
      },
    },
    activerecord: {
      attributes: {
        admin_user: {
          companies: "Zarządzane Firmy",
          companies_ids: "Zarządzane Firmy",
          company_admin: "Administrator firmy",
          company_employee: "Pracownik",
          editor_admin: "Editor Admin (ST)",
          global_admin: "Global Admin (SS)",
          main_admin: "Main Admin (S)",
          default_new_company_role: "Domyślna rola dla nowych firm",
        },
        agent_cooperation: {
          fixed_gross_pricing: "Ustalone ceny brutto",
          fixed_net_pricing: "Ustalone ceny netto",
          pricing_type: "Sposób ustalania cen",
          realtime_pricing: "Aktualne ceny",
          st_fixed_gross_pricing: "Ustalone ceny brutto",
          st_fixed_net_pricing: "Ustalone ceny netto",
          st_realtime_pricing: "Aktualne ceny",
        },
        company: {
          accepts_printed_customer_vouchers: "Czy wymagasz wydrukowanego voucheru z potwierdzeniem?",
          admin_users: "Użytkownicy firmy",
          admin_users_ids: "Użytkownicy firmy",
          contact_email: "Adres e-mail",
          contact_email_placeholder: "Kontaktowy adres e-mail",
          contact_facebook_url: "Adres do Fanpage'a na Facebooku",
          contact_facebook_url_placeholder: "Adres do Twojej strony na Facebooku",
          contact_full_address: "Adres firmy",
          contact_full_address_placeholder: "np. Swietego Jacka 14/5\n64-000 Koscian\nDojazd z drogi krajowej nr 5\n",
          contact_languages: "Języki kontaktowe",
          contact_languages_placeholder: "Języki, w jakich kontaktować się mogą z Tobą klienci",
          contact_opening_hours: "Obsługa klienta pracuje w godz.",
          contact_opening_hours_placeholder: 'Godziny otwarcia Twojego biura (np. "pon-pt od 8 do 16")',
          contact_phone_number: "Telefon kontaktowy",
          contact_phone_number_placeholder: "Kontaktowy numer telefonu",
          contact_website_url: "Strona WWW",
          contact_website_url_placeholder: "Adres strony WWW",
          default_product_price_currency: "Domyślna waluta dla nowych ofert",
          general_terms: "Regulamin",
          general_terms_placeholder:
            "Regulamin dla Twoich klientów, który będą musieli potwierdzić podczas składania u Ciebie zamówienia.",
          invoice_city: "Miasto",
          invoice_company_name: "Nazwa firmy",
          invoice_country_name: "Kraj",
          invoice_data: "Dane do faktury",
          invoice_email: "Adres e-mail",
          invoice_nip: "NIP",
          invoice_phone_number: "Telefon",
          invoice_postal_code: "Kod pocztowy",
          invoice_street_address: "Ulica, nr domu i mieszkania",
          locale: "Język główny",
          logo_image: "Logotyp firmy",
          marketplace_cover_image: "Zdjęcie w tle na stronie Tripsomnia",
          marketplace_meta_description: "Opis strony (SEO) (Marketplace)",
          marketplace_meta_title: "Tytuł strony (SEO) (Marketplace)",
          marketplace_name: "Nazwa publiczna (Marketplace)",
          marketplace_short_description: "Krótki opis (Marketplace)",
          marketplace_short_description_placeholder:
            "Krótki opis Twojej firmy, który wyświetlać się będzie na Twojej stronie firmowej w Tripsomnia",
          name: "Nazwa firmy",
          name_placeholder: "Powinna być nie dłuższa niż 100 znaków.",
          notifications_email: "Adres e-mail do powiadomień",
          notifications_phone_number: "Telefon kontaktowy do powiadomień",
          public_name: "Nazwa publiczna",
          saas_cover_image: "Zdjęcie w tle na Twojej stronie",
          saas_meta_description: "Opis strony (SEO) (SaaS)",
          saas_meta_title: "Tytuł strony (SEO) (SaaS)",
          saas_name: "Nazwa publiczna (SaaS)",
          saas_short_description: "Krótki opis (SaaS)",
          saas_short_description_placeholder:
            "Krótki opis Twojej firmy, który wyświetlać się będzie na Twojej stronie głównej.",
          saas_subdomain: "Subdomena SaaS",
          active: "Aktywna?",
          default_products_enable_frontend_slots_listing: "Domyślnie włącz listing terminów zamiast kalendarza",
          enable_saas: "Włącz SaaS",
          enable_marketplace: "Włącz Marketplace",
          affiliate_commision_calculation_type: "Metoda wyliczenia prowizji Afilianta",
          agent_earnings_percentage: "Procent od zarobku agenta od zamówienia (prowizja + opłata serwisowa)",
          total_base_amount_percentage: "Procent od podstawowej kwoty zamówienia",
        },
        company_member: {
          company_admin: "Administrator",
          company_employee: "Pracownik",
          editor_admin: "Editor Admin (ST)",
          global_admin: "Global Admin (SS)",
          main_admin: "Main Admin (S)",
        },
        customer: {
          display_name: "Nazwa",
          full_name: "Imię i nazwisko",
          full_name_contains: "Imię i nazwisko",
          future: "Przyszły",
          lost: "Utracony",
          orders_company_id: "Zamówienie: Firma",
          orders_product_id: "Zamówienie: Oferta",
          orders_product_name: "Zamówienie: Nazwa oferty",
          orders_product_product_tags_id: "Zamówienie: Znaczniki oferty",
          orders_product_variant_id: "Zamówienie: Wariant oferty",
          orders_status: "Zamówienie: Status",
          origin: "Źródło",
          past: "Przeszły",
          prospect: "Potencjalny",
        },
        installment: {
          confirmation_after_company_approval:
            "Najpierw potwierdzenie Firmy o ile wymagane, a następnie płatność potwierdzająca zamówienie.",
          confirmation_before_company_approval:
            "Najpierw płatność potwierdzająca zamówienie. Później potwierdzenie Firmy o ile wymagane.",
          remaining_amount: "Pozostała kwota",
          whole_amount: "Cała kwota",
        },
        order: {
          additional_information: "Dodatkowa informacja dla Klienta",
          confirmed_at: "Data wysłania",
          customer_display_name: "Nazwa klienta",
          manual: "Zamówienie ręczne",
          marketplace: "Zamówienie Marketplace",
          product_additional_pickup_instructions: "Wskazówki odjazdu",
          product_customer_hints: "Wskazówki podróżnicze",
          product_customer_requirements: "Warunki",
          product_excluded_items: "Cena nie zawiera",
          product_included_items: "Cena zawiera",
          product_price_currency: "Waluta oferty",
          saas: "Zamówienie SaaS",
          status_short: {
            waiting_for_company_approval: "Oczekujące na Firmę",
            waiting_for_customer_approval: "Oczekujące na Klienta",
          },
          stock_useby_ends_at: "Końcowa data ważności",
          stock_useby_starts_at: "Startowa data ważności",
          automatic: "Zamówienie automatyczne",
          source: "Źródło",
          pickup_point: "Miejsce zbiórki",
          agent_disbursement_status: "Status rozliczenia z Agentem",
          platform_disbursement_status: "Status rozliczenia z Tripsomnią",
          uncleared: "Nierozliczone",
          cleared: "Rozliczone",
          coupon_code_name: "Kod zniżki",
          author_place_cwa: "Nowa strona",
          author_place_frontend: "Strona www",
          author_place_partner: "Panel Partnera",
        },
        order_customer_participant: {
          display_name: "Uczestnik nr %{i}",
        },
        order_installment: {
          amount_hint: 'Ma sens, tylko jeśli pole "Pozostała kwota zamówienia?" nie jest zaznaczone.',
          confirmation_installment_hint:
            'Możliwe tylko w przypadku pierwszej raty o sposobie wpłaty "Płatność online".',
          paid_after_company_approval_hint:
            'Ma sens, tylko jeśli pole "Służy jako potwierdzenie zamówienia?" zostało zaznaczone.',
          paid_by_at_hint: 'Ma sens tylko wtedy, gdy "Typ określenia" jest równy "Określona data".',
          paid_by_time_duration_hint: 'Ma sens, z wyjątkiem gdy "Typ określenia" jest równy "Określona data".',
          remaining_amount: "Pozostała kwota zamówienia?",
          remaining_amount_hint: "Możliwe tylko w przypadku ostatniej raty.",
          account_description: "Dane konta bankowego",
        },
        order_item: {
          base_item: "Pozycja podstawowa?",
          item_type: "Typ pozycji",
          marketplace_service_fee: "Opłata serwisowa ST",
          name: "Nazwa pozycji",
          order_summary: "Razem",
          payment_profile_service_fee: "Opłata za profil płatności",
          product_coupon: "Kupon",
          product_custom: "Przedmiot niestandardowy",
          product_item: "Przedmiot oferty",
          product_option: "Opcja dodatkowa",
          product_refund: "Zwrot",
          quantity: "Liczba pozycji",
          saas_service_fee: "Opłata transakcyjna ST",
          service_fee: "Opłata serwisowa",
          unit_price: "Cena za sztukę",
        },
        order_status_history: {
          abandon: "Porzucenie zamówienia",
          auto_refund_issued: "Automatyczny zwrot płatności do Klienta",
          build: "Stworzenie zamówienia",
          company_approval_time_limit_exceeded: "Koniec limit czasowego na potwierdzenie zamówienia przez Firmę",
          company_approve: "Potwierdzenie zamówienia przez Firmę",
          company_cancel: "Anulacja zamówienia przez Firmę",
          company_reject: "Odrzucenie zamówienia przez Firmę",
          confirm: "Wysłanie zamówienia",
          confirmation_online_payment_time_limit_exceeded: "Koniec limitu czasowego na płatność online",
          customer_approval_time_limit_exceeded: "Koniec limit czasowego na potwierdzenie zamówienia przez Klienta",
          customer_approve: "Potwierdzenie zamówienia przez Klienta",
          expire: "Przedawnienie zamówienia",
          finish: "Zakończenie zamówienia",
          finish_online_payment: "Zakończenie płatności online",
          manual_status_change: "Ręczna zmiana statusu zamówienia",
          pause: "Koniec limitu czasowego zamówienia",
        },
        order_transfer: {
          agent: "Agent",
          bank_wire: "Przelew bankowy",
          cash: "Gotówka",
          custom: "Własny",
          customer: "Klient",
          dotpay: "DotPay",
          online_payment: "Płatność online",
          receiver: "Do",
          sender: "Od",
          socialtravel: "Tripsomnia",
          source_payload: "Notatka źródła",
          source_type: "Źródło wpłaty",
          transfer_type: "Sposób wpłaty",
          transferred_at: "Data wpłaty",
          refund_type: "Sposób zwrotu",
          refunded_at: "Data zwrotu",
          from_customer_frontend_name: "Wpłacono %{transfer_type} dn. %{transfer_date}",
          to_customer_frontend_name: "Zwrócono %{transfer_type} dn. %{transfer_date}",
          customer_to_supplier_backend_name: "Klient wpłacił Dostawcy %{transfer_type} dn. %{transfer_date}",
          customer_to_agent_backend_name: "Klient wpłacił Agentowi %{transfer_type} dn. %{transfer_date}",
          customer_to_socialtravel_backend_name: "Klient wpłacił Tripsomnii %{transfer_type} dn. %{transfer_date}",
          company_to_customer_backend_name: "Dostawca zwrócił Klientowi %{transfer_type} dn. %{transfer_date}",
          company_to_agent_backend_name: "Dostawca przekazał Agentowi %{transfer_type} dn. %{transfer_date}",
          company_to_socialtravel_backend_name: "Dostawca przekazał Tripsomnii %{transfer_type} dn. %{transfer_date}",
          agent_to_customer_backend_name: "Agent zwrócił Klientowi %{transfer_type} dn. %{transfer_date}",
          agent_to_supplier_backend_name: "Agent przekazał Dostawcy %{transfer_type} dn. %{transfer_date}",
          agent_to_socialtravel_backend_name: "Agent przekazał Tripsomnii %{transfer_type} dn. %{transfer_date}",
          socialtravel_to_customer_backend_name: "Tripsomnia zwróciła Klientowi %{transfer_type} dn. %{transfer_date}",
          socialtravel_to_agent_backend_name: "Tripsomnia przekazała Agentowi %{transfer_type} dn. %{transfer_date}",
          socialtravel_to_supplier_backend_name: "Tripsomnia przekazała Dostawcy %{transfer_type} dn. %{transfer_date}",
          supplier_to_agent_backend_name: "",
          supplier_to_customer_backend_name: "",
          supplier_to_socialtravel_backend_name: "Dostawca zapłacił Tripsomnia %{transfer_type} w %{transfer_date}",
        },
        payment_profile: {
          additional_fee: "Dodatkowa opłata (kwotowo)",
          additional_fee_name: "Nazwa dodatkowej opłaty",
          additional_fee_percentage: "Dodatkowa opłata (procentowo)",
          companies: "Przypisane firmy",
          companies_ids: "Przypisane firmy",
          default_additional_fee_name: "Opłata za wybrany profil płatności",
          has_additional_fee: "Czy naliczyć dodatkową opłatę serwisową podczas zamówienia z tym profilem?",
          marketplace: "Profil Marketplace",
          saas: "Profil SaaS",
          additional_fee_as_agent_fee: "Dolicz jako opłatę serwisową Agenta",
        },
        payment_profile_installment: {
          amount: "Wysokość raty kwotowo",
          amount_percentage: "Wysokość raty procentowo (% kwoty podstawowej zamówienia)",
          increase_amount_by_marketplace_commision: "Powiększ wysokość raty o wartość prowizji ST",
          increase_amount_by_marketplace_service_fee: "Powiększ wysokość raty o wartość opłaty serwisowej ST",
          account_description: "Dane konta bankowego",
        },
        payment_profile_product_attachment: {
          date_limit_type: "Rodzaj ograniczenia datowego",
          date_limit_type_label: "Ogranicz datowo",
          days_before_arrival_date_limit: "Od x do y dni przed datą rozpoczęcia oferty",
          max_days_before_arrival: "Maksymalna ilość dni do daty rozpoczęcia oferty",
          min_days_before_arrival: "Minimalna ilość dni do daty rozpoczęcia oferty",
          no_date_limit: "Brak ograniczenia",
        },
        pricing: {
          absolute_amount: "Kwotowo :=",
          absolute_amount_cents: "Kwotowo :=",
          absolute_percentage: "Procentowo :=",
          relative_amount: "Kwotowo +/-",
          relative_amount_cents: "Kwotowo +/-",
          relative_percentage: "Procentowo +/-",
        },
        product: {
          categories: "Kategorie",
          product_company_tags: "Tagi",
          active: "Aktywna",
          included_items_placeholder: "np. Wyżywienie",
          excluded_items_placeholder: "np. Ubezpieczenie",
          customer_requirements_placeholder: "np. wymagany wiek 18 lat lub opiekun pełnoletni",
          customer_hints_placeholder: "np. Pamiętaj, by zabrać ciepłe ubranie.",
          highlights_placeholder: "np. Atrakcyjny wyjazd dla pary",
          categories_placeholder: "Dodaj kategorię",
          enable_frontend_slots_listing: "Włącz listing terminów zamiast kalendarza",
          coupon_code_realisation_place_type: "Miejsce realizacji kodu zniżki",
          coupon_code_realisation_place_custom_description: "Opis miejsca realizacji kodu zniżki",
        },
        product_integration: {
          auto_update_description: "Czy automatycznie aktualizować opis",
          auto_update_images: "Czy automatycznie aktualizować zdjęcia",
          auto_update_prices: "Czy automatycznie aktualizować ceny",
          auto_update_calendar: "Czy automatycznie aktualizować dostępność"
        },
        product_option: {
          all_product_variants: "Wszystkie warianty",
          required: "Wartość wymagana do uzupełnienia przez Klienta",
        },
        product_order_field: {
          "ProductOrderField::BigText": "Duże pole tekstowe",
          "ProductOrderField::Boolean": "Pole wyboru (Checkbox)",
          "ProductOrderField::Date": "Data",
          "ProductOrderField::Email": "Adres e-mail",
          "ProductOrderField::Geopoint": "Lokalizacja geograficzna",
          "ProductOrderField::List": "Lista wyboru",
          "ProductOrderField::Number": "Liczba",
          "ProductOrderField::PhoneNumber": "Numer telefonu",
          "ProductOrderField::Text": "Pole tekstowe",
          assignation_per_person_label: "Wybór opcji per uczestnik (domyślnie: per zamówienie)",
          assignation_type: "Sposób uzupełniania",
          customer_hint: "Podpowiedź dla klienta",
          customer_hint_placeholder: "Wskazówka, która wyświetlać się będzie Klientowi w formularzu",
          list_options: "Wartości",
          max_value: "Wartość maksymalna",
          min_value: "Wartość minimalna",
          multiply_price_by_nights_count: "Pomnóż cenę przez długość pobytu (liczbę dób)",
          order_value_required: "Wartość wymagana",
          presets: {
            customer_email: {
              frontend_name: "Adres e-mail",
              name: "Adres e-mail zamawiającego",
            },
            customer_full_name: {
              frontend_name: "Imię i nazwisko",
              name: "Imię i nazwisko zamawiającego",
            },
            customer_note: {
              customer_hint: "Wpisz dodatkową informację dla organizatora.",
              frontend_name: "Wiadomość dla organizatora",
              name: "Wiadomość dla organizatora",
            },
            customer_phone_number: {
              customer_hint: "Numer kontaktowy na wypadek pytań dotyczących rezerwacji.",
              frontend_name: "Telefon kontaktowy",
              name: "Numer telefonu zamawiającego",
            },
            participant_birth_date: {
              frontend_name: "Data urodzenia",
              name: "Data urodzenia uczestnika",
            },
            participant_email: {
              frontend_name: "Adres e-mail",
              name: "Adres e-mail uczestnika",
            },
            participant_full_name: {
              frontend_name: "Imię i nazwisko",
              name: "Imię i nazwisko uczestnika",
            },
            participant_phone_number: {
              frontend_name: "Telefon kontaktowy",
              name: "Numer telefonu uczestnika",
            },
            customer_city: {
              frontend_name: "Miasto",
              name: "Miasto zamawiającego",
            },
            customer_postal_code: {
              frontend_name: "Kod pocztowy",
              name: "Kod pocztowy zamawiającego",
            },
            customer_country: {
              frontend_name: "Kraj",
              name: "Kraj zamawiającego",
            },
            customer_hotel_name: {
              name: "Hotel",
              customer_hint: "Podaj nazwę hotelu oraz jego adres i nr pokoju, jeśli posiadasz takie informacje.",
            },
            customer_dates_of_stay: {
              name: "Data pobytu",
            },
          },
          price_included_in_order_base_amount: "Wlicz cenę opcji do kosztu podstawowego zamówienia",
          price_none: "Brak",
          price_type: "Sposób wyliczania ceny",
          product_variants: "Warianty oferty",
          product_variants_assignation_all: "Wszystkie warianty",
          product_variants_assignation_some: "Niektóre warianty",
          product_variants_assignation_type: "Sposób przypisania do wariantów",
          product_variants_ids: "Warianty",
          show_on_manifest: "Pokaż na manifeście",
          type: "Typ wartości",
          "ProductOrderField::PickupPoint": "Miejsce zbiórki",
          undefined_pickup_point_option_name: "Nieokreślone",
          custom_pickup_point_option_name: "Odbiór z hotelu",
          custom_pickup_point_display_name: "Adres klienta: %{custom_location_name}",
          "ProductOrderField::Country": "Kraj",
          custom_field: "Pole własne",
        },
        product_pricelist_item: {
          preset_fixed: "Cennik ogólny",
          preset_id: "Typ kategorii",
          preset_item: "Przedmiot",
          preset_person_adult: "Dorosły",
          preset_person_child: "Dziecko",
          preset_person_custom: "Kategoria niestandardowa",
          preset_person_everyone: "Osoba",
          preset_person_group_1_plus_2: "Rodzina 1+2",
          preset_person_group_1_plus_3: "Rodzina 1+3",
          preset_person_group_2_plus_1: "Rodzina 2+1",
          preset_person_group_2_plus_2: "Rodzina 2+2",
          preset_person_group_2_plus_3: "Rodzina 2+3",
          preset_person_group_custom: "Grupa",
          preset_person_group_double: "2 osoby",
          preset_person_group_family_of_3: "Rodzina 3-os.",
          preset_person_group_family_of_4: "Rodzina 4-os.",
          preset_person_group_family_of_5: "Rodzina 5-os.",
          preset_person_group_quad: "4 osoby",
          preset_person_group_single: "1 osoba",
          preset_person_group_triple: "3 osób",
          preset_person_infant: "Niemowlę",
          preset_person_normal: "Normalny",
          preset_person_reduced: "Ulgowy",
          preset_person_senior: "Senior / Emeryt",
          preset_person_student: "Student",
          preset_person_teenager: "Niepełnoletni",
          price_type: "Typ ceny",
        },
        product_schedule_slot: {
          availability_type: "Rodzaj dostępności",
          available_with_company_approval: "Rezerwacja za potwierdzeniem Firmy",
          available_with_instant_booking: "Rezerwacja natychmiastowa",
          date: "Data terminu",
          datetime: "Data i czas terminu",
          total_stock_left: "Pozostała dostępność",
          total_stock_limit: "Limit dostępności",
          total_stock_used: "Brak dostępności",
          active: "Dostępny",
          available_with_instant_booking_help: "Wszystkie zamówienia są potwierdzane automatycznie.",
          available_with_company_approval_help:
            "Rezerwacja natychmiastowa wyłączona. Przyjmujesz wstępne zapytania i musisz potwierdzić każde zamówienie.",
          confirmed: "Potwierdzony",
        },
        product_tag: {
          category: "Kategoria",
          location: "Lokalizacja",
          parent: "Tag nadrzędny",
          product_st_tag: "Znacznik ST",
          product_company_tag: "Znacznik Firmy",
          show_on_fe_listing: "Pokazuj etykietę na listingu ofert",
          show_on_fe_product_page: "Pokazuj etykietę na podstronie oferty",
          fe_color: "Kolor na Front-endzie",
        },
        product_variant: {
          additional_pickup_instructions: "Dodatkowe wskazówki dojazdu",
          allow_custom_pickup_point: "Odbiór z hotelu",
          allow_no_pickup_point: 'Zezwól na wybranie "Miejsce zbiórki: Nieokreślone" przez Klienta',
          custom_pickup_point_additional_fee: "Dodatkowa opłata",
          default: "Wariant domyślny?",
          default_requires_company_approval: "Domyślnie wymaga potwierdzenia Firmy",
          default_total_stock_limit: "Domyślny limit dostępności",
          nb_requires_company_approval: "Wymaga potwierdzenia Firmy",
          nb_stock_useby_days_limit: "Data ważności zamówionej oferty (liczba dni)",
          nb_stock_useby_ends_at: "Data końcowa ważności zamówionej oferty",
          nb_stock_useby_starts_at: "Data startowa ważności zamówionej oferty",
          nb_total_stock_left: "Pozostały limit sprzedaży",
          nb_total_stock_limit: "Limit sprzedaży",
          nb_total_stock_used: "Zajęty limit sprzedaży",
          pickup_points_assignation_type: "Sposób przydzielania miejsc zbiórki w zamówieniu",
          pricelist_by_item: "Cennik za przedmiot",
          pricelist_by_order: "Cennik ogólny",
          pricelist_by_person: "Cennik za osobę",
          pricelist_type: "Rodzaj cennika",
          additional_pickup_instructions_placeholder: "Dodaj wskazówki",
          coupon_discount_amount: "Wartość zniżki",
          coupon_discount_percentage: "Procent zniżki",
          coupon_offer_price_before_discount: "Cena bez zniżki",
          coupon_offer_price: "Cena po zniżce",
        },
        view_collection_item: {
          related_model: "Powiązany rekord",
        },
        view_section: {
          name: "Tytuł",
          show_name: "Pokazuj tytuł?",
          type: "Typ sekcji",
          types: {
            "ViewSection::CompanyProducts": "Firma - lista ofert",
            "ViewSection::CustomCollection": "Własna kolekcja",
            "ViewSection::CustomContent": "Własna treść",
            "ViewSection::CustomCover": "Własna okładka",
            "ViewSection::ProductTagChildren": "Znacznik ofert - lista podznaczników",
            "ViewSection::ProductTagProducts": "Znacznik ofert - lista ofert",
            "ViewSection::ProductTagsCategoryProducts": "Kategoria znaczników ofert - lista ofert",
            "ViewSection::ProductTagsCategoryTags": "Kategoria znaczników ofert - lista znaczników",
            "ViewSection::ViewedProducts": "Ostatnio oglądane oferty",
            "ViewSection::SimilarToViewedProducts": "Oferty podobne do ostatnio oglądanych",
            "ViewSection::ViewedProductsTags": "Kategorie i lokalizacje ostatnio oglądanych ofert",
          },
          view_collection_items_limit: "Limit wyświetlonych rekordów",
          view_mode: "Tryb wyświetlania",
          view_modes: {
            cards_listing: "Listing kart szerokich",
            cards_slider: "Slider kart podłużnych",
            extended_cards_listing: "Listing kart szerokich rozszerzonych",
            items_carousel: "Karuzela",
            products_map: "Mapa",
            wide_cards_slider: "Slider kart szerokich",
            wide_cards_listing: "Listing kart szerokich",
          },
          with_similar_items: "Pokaż też elementy podobne",
        },
        activity: {
          customer_email_sent_title: "Wysłano e-mail do Klienta (%{recipient_email})",
          customer_email_sent_content: "Tytuł: %{email_subject}",
          customer_sms_sent_title: "Wysłano sms do Klienta (%{recipient_phone_number})",
          customer_sms_sent_content: "Treść: %{sms_content}",
          order_status_updated_content: 'Nowy status zamówienia: "%{new_status}"',
          review_created_title: "Klient dodał opinię na Twój temat z oceną %{rating}/%{max_rating}",
          review_created_content: "Treść opinii: %{content}",
          customer_to_supplier_order_transfer_created_title: "Klient wpłacił Dostawcy %{amount}",
          customer_to_agent_order_transfer_created_title: "Klient wpłacił Agentowi %{amount}",
          customer_to_socialtravel_order_transfer_created_title: "Klient wpłacił Tripsomnii %{amount}",
          company_to_customer_order_transfer_created_title: "Dostawca zwrócił Klientowi %{amount}",
          company_to_agent_order_transfer_created_title: "Dostawca przekazał Agentowi %{amount}",
          company_to_socialtravel_order_transfer_created_title: "Dostawca przekazał Tripsomnii %{amount}",
          agent_to_customer_order_transfer_created_title: "Agent zwrócił Klientowi %{amount}",
          agent_to_supplier_order_transfer_created_title: "Agent przekazał Dostawcy %{amount}",
          agent_to_socialtravel_order_transfer_created_title: "Agent przekazał Tripsomnii %{amount}",
          socialtravel_to_customer_order_transfer_created_title: "Tripsomnia zwróciła Klientowi %{amount}",
          socialtravel_to_agent_order_transfer_created_title: "Tripsomnia przekazała Agentowi %{amount}",
          socialtravel_to_supplier_order_transfer_created_title: "Tripsomnia przekazała Dostawcy %{amount}",
          supplier_email_sent_content: "Tytuł: %{email_subject}",
          supplier_email_sent_title: "Wysłano e-mail do Dostawcy (%{recipient_email})",
          supplier_sms_sent_content: "Treść: %{sms_content}",
          supplier_sms_sent_title: "Wysłano sms do Dostawcy (%{recipient_phone_number})",
          customer_sms_send_failed_content: "Komunikat błędu: %{error_message}",
          customer_sms_send_failed_title: "Wystąpił błąd podczas wysyłania sms do Klienta (%{recipient_phone_number})",
          supplier_sms_send_failed_content: "Komunikat błędu: %{error_message}",
          supplier_sms_send_failed_title: "Wystąpił błąd podczas wysyłania sms do Dostawcy (%{recipient_phone_number})",
          payment_issued_title: "Rozpoczęto: Płatność klienta na %{amount} poprzez %{source}.",
          payment_in_progress_title: "W toku: Płatność klienta na %{amount} poprzez %{source}.",
          payment_completed_title: "Zakończona powodzeniem: Płatność klienta na %{amount} poprzez %{source}.",
          payment_failed_title: "Zakończona niepowodzeniem: Płatność klienta na %{amount} poprzez %{source}.",
          refund_issued_title: "Zlecony: Zwrot dla klienta %{amount} przez %{source}.",
          refund_in_progress_title: "W toku: Zwrot dla klienta %{amount} przez %{source}.",
          refund_completed_title: "Zakończony powodzeniem: Zwrot dla klienta %{amount} przez %{source}.",
          refund_failed_title: "Zakończony niepowodzeniem: Zwrot dla klienta %{amount} przez %{source}.",
          sms_send_failed_content: "Komunikat błędu: %{error_message}",
          sms_send_failed_title: "Wystąpił błąd podczas wysyłania sms (%{recipient_phone_number})",
          sms_sent_content: "Treść: %{sms_content}",
          sms_sent_title: "Wys��ano sms (%{recipient_phone_number})",
          supplier_to_agent_order_transfer_created_title: "Dostawca przekazał Agentowi %{amount}",
          supplier_to_customer_order_transfer_created_title: "",
          supplier_to_socialtravel_order_transfer_created_title: "",
        },
        product_pickup_point: {
          additional_instructions_placeholder: "Dodaj szczegółowy opis miejsca zbiórki",
        },
        review: {
          single: "1 osoba",
          couple: "Para",
          friends: "Znajomi",
          family: "Rodzina",
          age_group: "Grupa wiekowa",
          group_type: "Typ grupy",
          author_name: "Imię opiniującego",
          author_email: "Adres e-mail opiniującego",
          content: "Treść",
          rating: "Ogólna ocena",
          st_feedback: "Opinia o ST",
          st_rating: "Ocena ST",
          rating_1: "Bardzo źle",
          rating_2: "Źle",
          rating_3: "Przyzwoicie",
          rating_4: "Dobrze",
          rating_5: "Wspaniale",
          st_rating_1: "Bardzo źle",
          st_rating_2: "Źle",
          st_rating_3: "Bueno promedio",
          st_rating_4: "Dobrze",
          st_rating_5: "Wspaniale",
          verified: "Opinia zweryfikowana",
          "18-24": "18-24 lat",
          "25-30": "25-30 lat",
          "31-40": "31-40 lat",
          "41-60": "41-60 lat",
          "60+": "60+ lat",
          anonymous: "Gość",
        },
        coupon_code: {
          total_stock_left: "Zostało wykorzystań",
          total_stock_limit: "Limit wykorzystań",
          total_stock_used: "Pobrano",
        },
        product_variant_additional_detail: {
          category: {
            one_person_room: "Pokój jednoosobowy",
            two_person_room: "Pokój dwuosobowy",
            three_person_room: "Pokój trzyosobowy",
            four_person_room: "Pokój czteroosobowy",
            multi_person_room: "Pokój wieloosobowy",
            bed_in_multi_person_room: "Łóżko w pokoju wieloosobowym",
            apartment: "Apartament",
            cottage: "Domek",
            villa: "Willa",
            holiday_house: "Dom wakacyjny",
            tent: "Namiot",
          },
        },
        product_types: {
          voucher: "Voucher",
          accommodation: "Nocleg",
          coupon: "Zniżka",
          standard: "Wycieczka",
          ticket: "Bilet",
        },
        pricing_plan: {
          preset: {
            elastic: {
              name: "Oferta elastyczna",
              company_description:
                "Oferta pozostawia większą swobodę klientowi, dzięki czemu znacznie szybciej podejmuje on decyzje zakupowe.",
              customer_description:
                "Elastyczne warunki rezerwacji pozostawiają Ci większą swobodę w zarządzaniu rezerwacją. Już teraz podejmij decyzję o dokonaniu rezerwacji zanim ktoś Cię uprzedzi.",
            },
            not_refundable: {
              name: "Oferta bezzwrotna",
              company_description:
                "Oferta nie daje klientowi możliwości anulowania rezerwacji przez co może zniechęcać go do jej kupna. Aby zwiększyć szansę jej sprzedaży ustaw w tym planie cenowym niższe, promocyjne ceny oraz dodaj droższy plan cenowy z elastycznymi warunkami rezerwacji.",
              customer_description: "",
            },
          },
        },
        pricing_plan_types: {
          not_refundable: "Oferta bezzwrotna",
          elastic: "Oferta elastyczna",
        },
      },
      errors: {
        models: {
          order: {
            inactive_product: "Wybrana oferta nie jest już aktywna.",
            missing_order_customer_participants_data: "Uzupełnij datę uczestników.",
            too_high_product_quantity:
              "Ta liczba %{unit_name_other} nie jest już dostępna. Wybierz wartość mniejszą niż lub równą %{available_stock}.",
            customer_display_name_missing:
              "Uzupełnij chociaż jedną daną zamawiającego (imię i nazwisko, adres e-mail lub numer telefonu).",
            too_low_product_quantity: "Wybrałeś 0 pakietów. Wybierz co najmniej jedną osobę.",
            agent_has_disabled_saas: "Wybrany Agent ma wyłączoną możliwość tworzenia zamówień SaaS.",
            supplier_has_disabled_saas: "Wybrany Dostawca ma wyłączoną możliwość tworzenia zamówień SaaS.",
            supplier_has_disabled_marketplace:
              "Wybrany Dostawca ma wyłączoną możliwość tworzenia zamówień Marketplace.",
            supplier_saas_subdomain_required:
              "Dostawca nie ma ustawionej domeny dla swojej strony WWW. Takie zamówienie nie jest możliwe. Skontaktuj się z administracją Tripsomnii, by naprawić problem.",
            agent_saas_subdomain_required:
              "Agent nie ma ustawionej domeny dla swojej strony WWW. Takie zamówienie nie jest możliwe. Skontaktuj się z administracją Tripsomnii, by naprawić problem.",
            confirmation_installment_impossible:
              "Niestety, obecnie niemożliwym jest zapłacenie za to zamówienie poprzez płatność online. Spróbuj wybrać inny profil płatności lub skontaktuj się z nami bezpośrednio.",
            stock_useby_date_passed: "Okres realizacji tej oferty minął. Nie można teraz złożyć rezerwacji.",
            product_expired: "Wybrana oferta wygasła.",
          },
          order_item: {
            wrong_price_currency:
              "Waluta ceny dla tego typu pozycji musi zawierać się w wartościach: %{valid_currencies}.",
          },
          product: {
            must_be_empty_when_product_has_no_booking:
              'Wartość %{value} jest niedozwolona w przypadku ofert z typem zamówienia "Brak zamówienia".',
            product_variant_with_percentage_amounts_defined:
              "Przynajmniej jeden z cenników tej oferty ma jedną z wartości typu 'Opłata serwisowa', 'Prowizja', 'Dopłata na konto bankowe' wyrażoną w procentach. Zanim zmienisz walutę cenników na inną niż PLN, zmień te wartości z procentowych na kwotowe.",
            product_pricelist_items_missing: "Uzupełnij chociaż jedną kategorię cenową.",
          },
          product_order_field: {
            pricing_disallowed_for_this_type: "Dla tego typu opcji włączenie cennika jest niemożliwe.",
          },
          product_tag: {
            parent_must_have_the_same_type: "Tag nadrzędny musi być tego samego typu co jego podtag.",
            parent_cant_be_self: "Znacznik nadrzędny znacznika nie może być tym samym znacznikiem.",
            parent_cant_be_its_child:
              "Znacznik nadrzędny znacznika nie może być jednocześnie jego znacznikiem podrzędnym.",
          },
        },
      },
      models: {
        admin_user: {
          one: "Administrator",
          few: "Administratorzy",
          many: "Administratorów",
          other: "Administratora",
        },
        attachment: {
          one: "Załącznik",
          few: "Załączniki",
          many: "Załączników",
          other: "Załącznika",
        },
        company: {
          one: "Firma",
          few: "Firmy",
          many: "Firm",
          other: "Firmy",
        },
        customer: {
          one: "Klient",
          few: "Klienci",
          many: "Klientów",
          other: "Klienta",
        },
        list_option: {
          one: "Opcja do wyboru",
          few: "Opcje do wyboru",
          many: "Opcji do wyboru",
          other: "Opcji do wyboru",
        },
        order: {
          one: "Zamówienie",
          few: "Zamówienia",
          many: "Zamówień",
          other: "Zamówienia",
        },
        order_installment: {
          one: "Rata płatności",
          few: "Raty płatności",
          many: "Rat płatności",
          other: "Raty płatności",
        },
        order_item: {
          one: "Przedmiot zamówienia",
          few: "Przedmioty zamówienia",
          many: "Przedmiotów zamówienia",
          other: "Przedmiotu zamówienia",
        },
        order_transfer: {
          one: "Wpłata/wypłata",
          few: "Wpłaty/wypłaty",
          many: "Wpłat/wypłat",
          other: "Wpłaty/wypłaty",
        },
        payment_profile: {
          one: "Profil płatności",
          few: "Profile płatności",
          many: "Profili płatności",
          other: "Profilu płatności",
        },
        payment_profile_installment: {
          one: "Rata płatności",
          few: "Raty płatności",
          many: "Rat płatności",
          other: "Raty płatności",
        },
        payment_profile_product_attachment: {
          one: "Powiązany profil płatności",
          few: "Powiązane profile płatności",
          many: "Powiązanych profili płatności",
          other: "Powiązanego profilu płatności",
        },
        pricing: {
          one: "Własny cena",
          few: "Własne ceny",
          many: "Własnych cen",
          other: "Własnej ceny",
        },
        product: {
          one: "Oferta",
          few: "Oferty",
          many: "Ofert",
          other: "Oferty",
        },
        product_option: {
          one: "Opcja dodatkowa",
          few: "Opcje dodatkowe",
          many: "Opcji dodatkowych",
          other: "Opcji dodatkowej",
        },
        product_option_value: {
          one: "Wartość",
          few: "Wartości",
          many: "Wartości",
          other: "Wartości",
        },
        product_order_field: {
          one: "Opcja dodatkowa / do wypełnienia",
          few: "Opcje dodatkowe / do wypełnienia",
          many: "Opcji dodatkowych / do wypełnienia",
          other: "Opcji dodatkowej / do wypełnienia",
        },
        product_pricelist_item: {
          one: "Kategoria cenowa",
          few: "Kategorie cenowe",
          many: "Kategorii cenowych",
          other: "Kategorii cenowej",
        },
        product_schedule: {
          one: "Reguła terminów",
          few: "Reguły terminów",
          many: "Reguł terminów",
          other: "Reguły terminów",
        },
        product_tag: {
          one: "Znacznik ofert",
          few: "Znaczniki ofert",
          many: "Znaczników ofert",
          other: "Znacznika ofert",
        },
        product_tags_category: {
          one: "Kategoria znaczników ofert",
          few: "Kategorie znaczników ofert",
          many: "Kategorii znaczników ofert",
          other: "Kategorii znaczników ofert",
        },
        product_variant: {
          one: "Wariant oferty",
          few: "Warianty oferty",
          many: "Wariantów oferty",
          other: "Wariantu oferty",
        },
        tag: {
          one: "Tag",
          few: "Tagi",
          many: "Tagów",
          other: "Tagu",
        },
        view_collection_item: {
          one: "Przedmiot kolekcji",
          few: "Przedmioty kolekcji",
          many: "Przedmiotów kolekcji",
          other: "Przedmiotu kolekcji",
        },
        view_page: {
          one: "Podstrona",
          few: "Podstrony",
          many: "Podstron",
          other: "Podstrony",
        },
        view_section: {
          one: "Sekcja widoku",
          few: "Sekcje widoku",
          many: "Sekcji widoku",
          other: "Sekcji widoku",
        },
        company_registration: {
          one: "Rejestracja firmy",
          few: "Rejestracje firmy",
          many: "Rejestracji firmy",
          other: "Rejestracji firmy",
        },
      },
    },
    attributes: {
      abandoned: "Porzucone",
      accomodation: "Nocleg",
      action: "Akcja",
      active: "Aktywny?",
      active_www: "Aktywny na WWW",
      additional_fee: "Dodatkowa opłata",
      additional_instructions: "Dodatkowe instrukcje",
      address: "Adres",
      admin_user: "Administrator",
      agent: "Agent",
      agent_commision: "Prowizja Agenta",
      agent_commision_amount: "Prowizja Agenta",
      agent_commision_amount_cents: "Prowizja Agenta [w groszach]",
      agent_commision_percent: "Prowizja Agenta [procent]",
      agent_note: "Prywatna notatka Agenta",
      all_day_event: "Termin całodniowy?",
      all_products: "Wszystkie oferty",
      all_tagged_products: "Wszystkie oferty (należące do tego tagu lub jego podtagów)",
      amount: "Kwota",
      amount_cents: "Kwota",
      amount_percentage: "Kwota procentowo",
      amount_type: "Sposób ustalenia kwoty",
      api_version: "Wersja API",
      approved: "Zatwierdzone",
      arrival_time: "przyjazd o",
      assignation_per_item: "per pakiet zamówienia",
      assignation_per_order: "per zamówienie",
      assignation_per_person: "per uczestnik",
      attachments: "Załączniki",
      balance: "Saldo klienta",
      balance_status: "Status płatności",
      balance_status_for_today: "Status płatności na dziś",
      bank_wire: "Przelew bankowy",
      bank_wire_account_description: "Dane konta do przelewu bankowego",
      bank_wire_account_description_hint: "Możliwe do edycji tylko przez głównego administratora.",
      birth_date: "Data urodzenia",
      booking_type: "Typ zamówienia",
      boolean_value_type: "Checkbox (tak/nie)",
      build: "Stworzenie zamówienia",
      building: "Szkic",
      cancellation_policy: "Polityka anulacji",
      cancelled: "Anulowane",
      cash: "Gotówka",
      categories: "Kategorie",
      change_status: "Zmiana statusu",
      companies_count: "Liczba firm",
      company: "Firma",
      company_approval_time_limit: "Limit czasu na potwierdzenie zamówienia przez Firmę",
      company_approval_time_limit_exceeded: "Przekroczenie czasu na potwierdzenie przez Firmę",
      company_approval_time_limit_in_hours: "Limit czasu na potwierdzenie zamówienia przez Firmę [w godzinach]",
      company_approve: "Potwierdzenie zamówienia przez Firmę",
      company_automatic_invoice_amount: "Kwota do automatycznego rozliczenia z Firmą",
      company_automatic_invoice_date: "Data automatycznego rozliczenia z Firmą",
      company_cancel: "Anulowanie zamówienia przez Firmę",
      company_given_amount_through_online_deposit: "Kwota przekazana Firmie przez płatność online",
      company_invoice_id: "ID faktury Firmy",
      company_name: "Nazwa firmy",
      company_over_received_amount_through_online_deposit:
        "Łączne saldo Tripsomnia względem Firmy, biorąc pod uwagę tylko płatność online",
      company_received_amount_through_online_deposit: "Kwota otrzymana od Firmy przez płatność online",
      company_reject: "Odrzucenie zamówienia przez Firmę",
      company_remaining_invoice_amount: "Pozostała kwota do rozliczenia z Firmą",
      company_tag: "Tag firm",
      company_total_invoice_amount: "Całkowita kwota do rozliczenia z Firmą",
      confirm: "Wysłanie zamówienia",
      confirmation_installment: "Służy jako potwierdzenie zamówienia?",
      confirmation_installment_after_company_approval: "Przedpłata online płatna dopiero po potwierdzeniu zamówienia?",
      confirmation_installment_after_company_approval_hint:
        "W przeciwnym wypadku przedpłata online wykonywana jest jeszcze przed wysłaniem zamówienia (czyli podczas składania zamówienia przez Klienta).",
      confirmation_installment_after_company_approval_time_limit:
        "Limit czasu na przedpłatę online, po potwierdzeniu zamówienia przez Firmy",
      confirmation_online_payment_time_limit_exceeded: "Przekroczenie czasu na płatność online",
      country: "Kraj",
      coupon: "Kupon / Zniżka",
      coupon_price: "Cena kuponu",
      created_at: "Data stworzenia",
      currency: "Waluta",
      current_password: "Obecne hasło",
      current_sign_in_at: "Data obecnego zalogowania",
      current_sign_in_ip: "IP obecnego zalogowania",
      customer: "Klient",
      customer_approval_time_limit: "Limit czasu na potwierdzenie zamówienia przez Klienta",
      customer_approval_time_limit_exceeded: "Przekroczenie czasu na potwierdzenie przez Klienta",
      customer_approval_time_limit_in_hours: "Limit czasu na potwierdzenie zamówienia przez Klienta [w godzinach]",
      customer_automatic_invoice_amount: "Kwota do automatycznego rozliczenia z Klientem",
      customer_email: "Adres e-mail klienta",
      customer_full_name: "Imię i nazwisko klienta",
      customer_full_name_contains: "Imię i nazwisko klienta",
      customer_hints: "Wskazówki podróżnicze",
      customer_invoice_id: "ID faktury Klienta",
      customer_invoiced_amount: "Kwota rozliczona z Klientem",
      customer_locale: "Język klienta",
      customer_note: "Wiadomość dla organizatora",
      customer_phone_number: "Telefon klienta",
      customer_remaining_invoice_amount: "Pozostała kwota do rozliczenia z Klientem",
      customer_requirements: "Warunki",
      customer_rules_agreement: "Zgoda klienta na regulamin",
      customer_tag: "Tag klientów",
      customer_total_invoice_amount: "Całkowita kwota do rozliczenia z Klientem",
      customers_count: "Liczba klientów",
      dates: "Daty",
      datetime: "Data i czas",
      days_count: "Ilość dni",
      default_marketplace_commision_amount: "Domyślna prowizja (Marketplace) [kwotowo]",
      default_marketplace_commision_percentage: "Domyślna prowizja (Marketplace) [procentowo]",
      default_marketplace_service_fee_amount: "Domyślna opłata serwisowa (Marketplace) [kwotowo]",
      default_marketplace_service_fee_percentage: "Domyślna opłata serwisowa (Marketplace) [procentowo]",
      default_saas_commision_amount: "Domyślna prowizja systemowa (SaaS) [kwotowo]",
      default_saas_commision_percentage: "Domyślna prowizja systemowa (SaaS) [procentowo]",
      departure_time: "odjazd o",
      deprecated_v1_bank_wire_company_deposit: "Konto bankowe Firmy",
      deprecated_v1_bank_wire_socialtravel_deposit: "Konto bankowe Tripsomnia",
      deprecated_v1_excludes_content: "Cena nie zawiera (v1)",
      deprecated_v1_includes_content: "Cena zawiera (v1)",
      deprecated_v1_location_alternative_map_content: "Alternatywny kod mapy na stronie oferty (np. iframe)",
      deprecated_v1_requirements_content: "Warunki (v1)",
      description: "Opis",
      discount: "Zniżka",
      discount_amount: "Zniżka",
      discount_amount_cents: "Zniżka [kwota w groszach]",
      discounted: "Oferta przeceniona?",
      draft: "Szkic",
      email: "Adres e-mail",
      end_date: "Data zakończenia",
      end_time: "Czas zakończenia",
      ends_at: "Data i czas zakończenia",
      exact_amount: "Kwotowo",
      exact_date: "Określona data",
      excluded_items: "Cena nie zawiera",
      expire: "Przedawnienie zamówienia",
      expired: "Przedawniony",
      expired_at: "Data przedawnienia",
      expires_at: "Data przedawnienia",
      featured_price: "Cena prezentowana",
      featured_price_before_discount: "Cena prezentowana przed obniżką",
      file: "Plik",
      finish: "Zakończenie zamówienia",
      finish_online_payment: "Zakończenie płatności online",
      finished: "Zakończone",
      first_name: "Imię",
      fluid_date_booking: "Zamówienie bloku o płynnej długości (v1)",
      frontend_name: "Nazwa (Frontend)",
      frontend_view: "Widok (Frontend)",
      full_name: "Imię i nazwisko",
      full_person_name: "Imię i nazwisko",
      fully_paid: "Opłacone",
      global_role: "Rola globalna (PA)",
      highlights: "Kluczowe informacje",
      id: "ID",
      inactive: "Nieaktywny",
      inactive_www: "Nieaktywny na WWW",
      included_items: "Cena zawiera",
      includes_time: "Zawiera czas?",
      increase_orders_amount_by_saas_commision: "Dorzuć prowizję systemową (SaaS) do całkowitej kwoty zamówienia",
      installments: "Raty płatności",
      internal_note: "Notatka wewnętrzna (widzą wszyscy)",
      invoice_date: "Data rozliczenia",
      issuer: "Autor akcji",
      last_sign_in_at: "Data ostatniego zalogowania",
      last_sign_in_ip: "IP obecnego zalogowania",
      last_status_action: "Ostatnia akcja",
      locale: "Język",
      location: "Lokalizacja",
      location_coordinates: "Współrzędne geograficzne",
      location_lat: "Szerokość geograficzna",
      location_lng: "Długość geograficzna",
      location_name: "Nazwa lokalizacji",
      locations: "Lokalizacje",
      logo_image: "Logo",
      main_company: "Firma",
      main_image: "Zdjęcie główne",
      marketplace: "Marketplace",
      marketplace_commision: "Prowizja ST",
      marketplace_commision_amount: "Prowizja ST",
      marketplace_commision_amount_cents: "Prowizja ST [w groszach]",
      marketplace_commision_percent: "Prowizja ST [procent]",
      marketplace_featured_price: "Cena prezentowana (Marketplace)",
      marketplace_featured_price_before_discount: "Cena prezentowana przed obniżką (Marketplace)",
      marketplace_service_fee: "Opłata serwisowa ST",
      marketplace_service_fee_amount: "Opłata serwisowa ST",
      marketplace_service_fee_amount_cents: "Opłata serwisowa ST [w groszach]",
      marketplace_service_fee_percent: "Opłata serwisowa ST [procent]",
      max_days_count: "Maksymalna ilość dni",
      max_nights_count: "Maksymalna ilość dób",
      max_number_value: "Maksymalna wartość liczbowa",
      max_order_stock_count: "Maksymalna łączna liczba pakietów w zamówieniu",
      max_person_age: "Maksymalny wiek",
      max_persons_count: "Maksymalna liczba osób",
      meta_description: "Opis strony (SEO)",
      meta_title: "Tytuł strony (SEO)",
      min_days_count: "Minimalna ilość dni",
      min_nights_count: "Minimalna ilość dób",
      min_order_stock_count: "Minimalna łączna liczba pakietów w zamówieniu",
      min_person_age: "Minimalny wiek",
      min_persons_count: "Minimalna liczba osób",
      name: "Nazwa",
      nb_stock_useby_date: "Data ważności zamówionej oferty",
      nb_stock_useby_days_limit: "X dni po potwierdzeniu zamówienia",
      nb_stock_useby_ends_at: "Data końcowa ważności zamówionej oferty",
      nb_stock_useby_starts_at: "Data startowa ważności zamówionej oferty",
      new_status: "Nowy status",
      nights_count: "Ilość dób",
      no_booking: "Brak zamówienia",
      note: "Notatka",
      number_value_multiplies_price: "Pomnóż cenę opcji przez wartość liczbową (wybieraną przez Klienta)",
      number_value_type: "Liczba (0-n)",
      offers_count: "Liczba ofert",
      on_stock_starts_at: "w dniu rozpoczęcia oferty",
      online_payment: "Płatność online",
      order: "Zamówienie",
      order_bill: "Rachunek",
      order_customer_participants: "Uczestnicy",
      order_items: "Przedmioty zamówienia",
      order_tag: "Tag zamówień",
      order_transfers: "Wpłaty i wypłaty",
      ordered_product_order_fields: "Opcje dodatkowe / wypełnione",
      ordered_product_pricelist_items: "Zamówione pakiety",
      orders: "Zamówienia",
      orders_count: "Liczba zamówień",
      orders_marketplace_commision_amount_sum: "Łączna prowizja zamówień",
      orders_total_amount_sum: "Kwota zamówień",
      overpaid: "Nadpłacone",
      paid_after_company_approval: "Płatna po potwierdzeniu przez Firmę?",
      paid_amount: "Wpłacono",
      paid_amount_sum: "Wpłacono",
      paid_before_company_approval: "Płatna przed potwierdzeniem przez Firmę?",
      paid_by_at: "Termin wpłaty",
      paid_by_at_formatted: {
        on_stock_starts_at: "w dniu rozpoczęcia oferty",
        x_days_after_order_company_approval: "%{count} po potwierdzenu zamówienia przez Firmę",
        x_days_after_order_creation: "%{count} po stworzeniu zamówienia",
        x_days_after_order_full_approval: "%{count} po pełnym zatwierdzeniu zamówienia",
        x_days_after_previous_installment:
          "%{count} po poprzedniej racie (lub zatwierdzeniu/wysłaniu zamówienia, jeśli to pierwsza rata)",
        x_days_before_stock_starts_at: "%{count} przed datą rozpoczęcia oferty",
        immediately: "przed zapisaniem zamówienia",
      },
      paid_by_time_duration: "Czas (x) określony w typie terminie wpłaty",
      paid_by_type: "Typ określenia terminu wpłaty",
      parent: "Rodzic",
      partly_paid: "Opł. częściowo",
      password: "Hasło",
      password_confirmation: "Potwierdź hasło",
      pause: "Wstrzymanie zamówienia",
      payment: "Płatność",
      payment_completed: "Ukończona",
      payment_failed: "Nieudana",
      payment_in_progress: "W trakcie",
      payment_operations: "Operacje płatności",
      payment_profile: "Profil płatności",
      payment_status: "Status płatności",
      payment_type: "Typ płatności",
      payment_type_offline: "Offline",
      payment_type_online: "Online",
      payments: "Płatności",
      pdf_voucher: "Voucher potwierdzenia zamówienia (PDF)",
      pending: "Oczekujące",
      per_group: "za grupę",
      per_item: "za pakiet",
      per_order: "za zamówienie",
      per_person: "za osobę",
      per_product: "za ofertę",
      percentage_amount: "Procentowo",
      persons_count: "Liczba osób",
      phone_number: "Telefon",
      position: "Pozycja",
      price: "Cena",
      price_currency: "Waluta ceny",
      price_per_group: "cena za grupę",
      price_per_item: "cena za pakiet",
      price_per_night: "cena za dobę",
      price_per_order: "cena za zamówienie",
      price_per_person: "cena za osobę",
      price_per_person_night: "cena za osobodobę",
      price_per_product: "cena za ofertę",
      price_type: "Typ ceny",
      pricing_per_night: "Cennik z ceną za dobę (v1)",
      pricing_per_person: "Cennnik z ceną za osobę",
      pricing_per_person_night: "Cennik z ceną za osobodobę",
      pricing_per_product: "Cennik z ceną całościową za ofertę (v1)",
      priority: "Priorytet",
      product: "Oferta",
      product_highlights: "Kluczowe informacje o ofercie",
      product_images: "Zdjęcia oferty",
      product_name: "Nazwa oferty",
      product_option_values: "Wartości do wyboru",
      product_options: "Opcje dodatkowe",
      product_or_variant: "Oferta / Wariant",
      product_order_fields: "Opcje dodatkowe / do wypełnienia",
      product_pricelist: "Cennik",
      product_pricelist_item: "Kategoria cenowa",
      product_pricelist_order_target: "Cennik",
      product_product_tags_id: "Znacznik oferty",
      product_quantity: "Liczba pakietów",
      product_short_description: "Krótki opis oferty",
      product_st_tags: "Znaczniki ST",
      product_tag: "Tag",
      product_tags: "Tagi",
      product_tags_category: "Kategoria tagów",
      product_tags_id: "Tag",
      product_tags_relation_type: "Typ relacji ofert",
      product_unit_name: {
        coupon: {
          one: "kupon",
          few: "kupony",
          many: "kuponów",
          other: "kupona",
        },
        person: {
          one: "osoba",
          few: "osoby",
          many: "osób",
          other: "osób",
        },
        product: {
          one: "pakiet",
          few: "pakiety",
          many: "pakietów",
          other: "pakietu",
        },
        room: {
          one: "pokój",
          few: "pokoje",
          many: "pokoi",
          other: "pokoju",
        },
      },
      product_variant: "Wariant oferty",
      product_variant_name: "Nazwa wariantu oferty",
      product_variant_order_target: "Wariant",
      product_variants_count: "Liczba wariantów oferty",
      products_count: "Liczba ofert",
      products_have_all_tags: "Koniunkcja (oferty należą do wszystkich tagów tej kategorii)",
      products_have_one_tag: "Alternatywa (oferty należą do przynajmniej jednego z tagów tej kategorii)",
      published: "Opublikowany",
      published_at: "Data publikacji",
      refund: "Zwrot zamówienia",
      refund_completed: "Ukończony",
      refund_failed: "Nieudany",
      refund_in_progress: "W trakcie",
      refund_new: "Zlecony",
      refund_none: "brak",
      refund_status: "Status zwrotu",
      refunded: "Zwrócone",
      refunded_amount: "Zwrócono",
      refunded_amount_sum: "Zwrócono",
      rejected: "Odrzucone",
      related_model: "Powiązany rekord",
      remaining_amount: "Pozostała kwota",
      remaining_total_amount: "Do zapłaty",
      remaining_total_amount_sum: "Do zapłaty",
      requires_company_approval: "Zamówienie wymaga potwierdzenia przez Firmę?",
      role: "Rola",
      saas: "SaaS",
      saas_featured_price: "Cena prezentowana (SaaS)",
      saas_featured_price_before_discount: "Cena prezentowana przed obniżką (SaaS)",
      saas_service_fee: "Opłata transakcyjna ST",
      select_value_type: "Lista wybierana",
      service_fee: "Opłata serwisowa",
      short_description: "Krótki opis",
      show_page_title: "Pokazuj tytuł strony?",
      sign_in_count: "Liczba zalogowań",
      slug: "Skrócony odnośnik",
      slug_hint: "Zostaw pole puste, a będzie wygenerowany automatycznie.",
      special_offer: "Oferta specjalna",
      st_note: "Prywatna notatka pracowników Tripsomnia",
      start_date: "Data rozpoczęcia",
      start_dates: "Daty rozpoczęcia",
      start_time: "Czas rozpoczęcia",
      start_times: "Czasy rozpoczęcia",
      starts_at: "Data i czas rozpoczęcia",
      static_date_booking: "Zamówienie bloku o stałej długości",
      status: "Status",
      stock_end_date: "Koniec terminu",
      stock_end_datetime: "Czas wyjazdu",
      stock_ends_at: "Czas wyjazdu",
      stock_start_date: "Początek terminu",
      stock_start_datetime: "Czas przyjazdu",
      stock_starts_at: "Czas przyjazdu",
      stock_time_range: "Termin",
      stock_useby_time_range: "Termin realizacji",
      supplier: "Dostawca",
      supplier_note: "Prywatna notatka Dostawcy",
      tag: "Tag",
      tagged_products: "Oferty (należące do tego tagu)",
      tags: "Tagi",
      time_duration: "Czas trwania",
      time_zone: "Strefa czasowa",
      time_zone_name: "Strefa czasowa",
      title: "Tytuł",
      total_amount: "Kwota zamówienia",
      total_amount_sum: "Kwota zamówienia",
      total_base_amount: "Kwota podstawowa zamówienia",
      total_discount: "Zniżka całkowita",
      total_discount_amount: "Zniżka całkowita",
      total_price: "Cena całkowita",
      total_product_options_price: "Cena całkowita za opcje dodatkowe",
      total_product_price: "Cena całkowita za ofertę",
      total_product_price_before_discount: "Cena całkowita za ofertę przed zniżką",
      total_stock_left: "Pozostały limit sprzedaży",
      total_stock_limit: "Limit sprzedaży",
      total_stock_used: "Wykorzystany limit sprzedaży",
      transfer_type: "Sposób wpłaty",
      translations: "Tłumaczenia",
      translations_name: "Nazwa",
      trip: "Wycieczka",
      type: "Typ",
      type_amount: "Kwotowo",
      type_percent: "Procentowo",
      unpaid: "Nieopłacone",
      updated_at: "Data ostatniej edycji",
      v1_bank_wire_deposit: "Dopłata na konto bankowe",
      v1_bank_wire_deposit_amount: "Dopłata na konto bankowe",
      v1_bank_wire_deposit_amount_cents: "Dopłata na konto bankowe [w groszach]",
      v1_bank_wire_deposit_deadline: "Termin dopłaty na konto bankowe",
      v1_bank_wire_deposit_max_payment_date: "Określona data",
      v1_bank_wire_deposit_percent: "Dopłata na konto bankowe [procent]",
      v1_bank_wire_deposit_postorder_days_limit: "X dni po potwierdzeniu zamówienia",
      v1_bank_wire_deposit_postorder_x_days: "%{value} dni po potwierdzeniu zamówienia",
      v1_bank_wire_deposit_prearrival_days_limit: "X dni przed rozpoczęciem oferty",
      v1_bank_wire_deposit_prearrival_x_days: "%{value} dni przed rozpoczęciem oferty",
      v1_cash_deposit: "Dodatkowa dopłata na miejscu (w walucie obcej)",
      v1_cash_deposit_amount: "Dodatkowa dopłata na miejscu (w walucie obcej)",
      v1_cash_deposit_amount_cents: "Dodatkowa dopłata na miejscu (w walucie obcej) [w centach]",
      v1_full_bank_wire_deposit: "Płatność za ofertę w 100% poprzez dopłatę na konto bankowe",
      v1_full_bank_wire_deposit_hint:
        "Zaznacz, jeśli oferta zamiast być opłacana na miejscu, ma być opłacana przelewem na konto bankowe (w wysokości 100% całkowitej ceny oferty).",
      v1_online_deposit: "Przedpłata online",
      v1_online_deposit_percent: "Przedpłata online [procent]",
      v1_online_deposit_st_type: {
        deposit: {
          b: "zaliczkę",
          d: "zaliczki",
          m: "zaliczka",
        },
        fee: {
          b: "opłatę",
          d: "opłaty",
          m: "opłata",
        },
        prepayment: {
          b: "przedpłaty",
          d: "przedpłaty",
          m: "przedpłata",
        },
      },
      v1_rest_deposit: "Pozostała kwota do dopłaty na miejscu",
      v1_rest_deposit_amount: "Pozostała kwota do dopłaty na miejscu",
      v1_rest_deposit_amount_cents: "Pozostała kwota do dopłaty na miejscu [w groszach/centach]",
      v1_st_company_debt_status: "Status rozliczenia z Firmą",
      v1_st_company_debt_status_amount_to_give: "Przekaż wpłatę Firmie",
      v1_st_company_debt_status_amount_to_receive: "Pobierz prowizję od Firmy",
      v1_st_company_debt_status_short: "Status rozliczenia",
      v1_st_company_debt_status_zero_amount: "Rozliczony",
      v1_st_company_invoiced_amount: "Kwota rozliczona z Firmą",
      v1_st_company_manually_given_amount: "Kwota dodatkowo przekazana Firmie",
      v1_st_company_manually_received_amount: "Kwota dodatkowo otrzymana od Firmy",
      v1_st_remaining_given_amount: "Pozostała kwota do przekazania Firmie",
      v1_st_remaining_received_amount: "Pozostała kwota do otrzymania od Firmy",
      v1_st_total_given_amount: "Łączna kwota przekazana Firmie",
      v1_st_total_over_received_amount: "Łączne saldo Trispomnia względem Firmy",
      v1_st_total_received_amount: "Łączna kwota otrzymana od Firmy",
      v2_pricing: "Cennik wg. kategorii cenowych (v2)",
      v2_static_date_booking: "Zamówienie bloku o stałej długości (v2)",
      value_type: "Typ wartości",
      variant: "Wariant",
      video_url: "Wideo URL (YouTube / Vimeo)",
      video_url_hint: "Jeśli uzupełnione, film pojawi się zamiast zdjęcia (tylko w trybie widoku 'Karuzela').",
      view: "Widok",
      view_sections: "Sekcje widoku",
      waiting_for_company_approval: "Oczekujące na Firmę",
      waiting_for_confirmation_online_payment: "Oczekujące na płatność Klienta",
      waiting_for_customer_approval: "Oczekujące na Klienta",
      website: "Strona internetowa",
      website_url: "Strona WWW",
      week_days: "Dni tygodnia",
      x_days_after_order_company_approval: "x dni po potwierdzenu zamówienia przez Firmę",
      x_days_after_order_creation: "x dni po stworzeniu zamówienia",
      x_days_after_order_full_approval: "x dni po pełnym zatwierdzeniu zamówienia",
      x_days_after_previous_installment:
        "x dni po poprzedniej racie (lub zatwierdzeniu/wysłaniu zamówienia, jeśli to pierwsza rata)",
      x_days_before_stock_starts_at: "x dni przed datą rozpoczęcia oferty",
      x_price_per_item: "%{x} za pakiet",
      x_price_per_item_night: "%{x} za pakiet za noc",
      x_price_per_order: "%{x}",
      x_price_per_order_night: "%{x} za dobę",
      x_price_per_person: "%{x} za osobę",
      x_price_per_person_night: "%{x} za osobodobę",
      agent_service_fee: "Opłata serwisowa Agenta",
      agent_service_fee_amount: "Opłata serwisowa Agenta",
      agent_service_fee_amount_cents: "Opłata serwisowa Agenta [w groszach]",
      agent_service_fee_percent: "Opłata serwisowa Agenta [procent]",
      agent_paid_amount: "Agent przekazał",
      agent_received_amount: "Agent dostał",
      agent_remaining_paid_amount: "Do pobrania od Agenta",
      agent_remaining_received_amount: "Do przekazania Agentowi",
      customer_paid_amount: "Klient zapłacił",
      customer_received_amount: "Zwrócono klientowi",
      customer_remaining_paid_amount: "Do zapłaty przez Klienta",
      customer_remaining_received_amount: "Do zwrotu Klientowi",
      socialtravel_paid_amount: "Tripsomnia przekazała",
      socialtravel_received_amount: "Tripsomnia pobrała",
      socialtravel_remaining_paid_amount: "Do pobrania od Tripsomnia",
      socialtravel_remaining_received_amount: "Do przekazania Tripsomnia",
      supplier_paid_amount: "Dostawca przekazał",
      supplier_received_amount: "Dostawca otrzymał",
      supplier_remaining_paid_amount: "Do zapłaty przez Dostawcę",
      supplier_remaining_received_amount: "Do przekazania Dostawcy",
      author_place: "Źródło",
      author_place_frontend: "Strona WWW",
      author_place_partnerapp: "Panel Partnera",
      product_locations: "Lokalizacje oferty",
      product_pickup_points: "Punkty zbiórki",
      customer_fields: "Kwestionariusz",
      priced_fields: "Opcje dodatkowe",
      product_id: "ID oferty",
      product_variant_id: "ID wariantu oferty",
      pricelist: "Cennik",
      payment_profiles: "Profile płatności",
      remove_location_coordinates: "Wyczyść współrzędne geograficzne",
      test_mode: "Tryb testowy",
      saas_priority: "Priorytet (SaaS)",
      marketplace_priority: "Priorytet (Marketplace)",
      created_on: "Data stworzenia",
      updated_on: "Data ostatniej edycji",
      affiliate_commision: "Prowizja Afilianta",
      affiliate_commision_amount: "Prowizja Afilianta",
      affiliate: "Afiliant",
      confirmation_installment_amount: "Przedpłata online",
      bank_wire_account_description_placeholder: "Nr konta bankowego i ewentualne dodatkowe informacje",
      fully_refunded: "Zwrócone",
      over_refunded: "Nad zwrócone",
      partly_refunded: "Zwr. częściowo",
      dotpay: "DotPay",
      paypal: "PayPal",
      agent_outcome: "Przychód Agenta",
      socialtravel_outcome: "Przychód Tripsomnia",
      supplier_outcome: "Przychód Dostawcy",
      total_company_outcome: "Przychód Firmy",
      agent_disbursement: "Rozliczenie z Agentem",
      agent_disbursement_id: "ID rozliczenia z Agentem",
      customer_invoice_amount: "Suma do automatycznego rozliczenia z Klientem",
      doesnt_require_company_approval: "Nie wymaga potwierdzenia Firmy",
      custom_online_payment: "Inna płatność online",
      agent_bank_wire: "Konto bankowe Agenta",
      supplier_bank_wire: "Konto bankowe Dostawcy",
      agent_cash: "Gotówką do/od Agenta",
      supplier_cash: "Gotówką do/od Dostawcy",
      none: "Brak",
      expire_at: "Termin ważności",
      publish_at: "Data publikacji",
      expire_from: "Termin ważności",
      stripe: "Stripe",
      author_place_customerapp: "Nowa strona",
      deprecated_v1_booking_type: "Typ zamówienia (v1)",
      deprecated_v1_location_address: "Adres",
      deprecated_v1_location_description: "Wskazówki dojazdu",
      deprecated_v1_location_full_address: "Pełen adres",
      deprecated_v1_location_full_address_hint_html:
        '<div class="u-inline-block">\n  <strong>Format:</strong><br />\n  Nazwa lokalu<br />\n  Ulica, nr domu i mieszkania<br />\n  Kod pocztowy, Miasto<br />\n  Województwo\n</div> <div class="u-inline-block">\n  <strong>Przykład:</strong><br />\n  Hotel pod Stuletnim Drzewem<br />\n  ul. Kowalskich 24/3<br />\n  64-000 Kościan<br />\n  Wielkopolska<br />\n</div>\n',
      deprecated_v1_location_full_address_placeholder:
        "Hotel pod Stuletnim Drzewem\nul. Kowalskich 24/3\n64-000 Kościan\nWielkopolska\n",
      deprecated_v1_order_target_type: "Cel zamówienia (v1)",
      deprecated_v1_pricing_type: "Typ cennika (v1)",
      deprecated_v1_product_type: "Typ oferty (v1)",
      price_show_cash_deposit_amount: "Kwota do zapłaty na miejscu w walucie obcej",
      price_show_coupon_price: "Cena kuponu",
      price_show_discount_amount: "Zniżka promocyjna",
      price_show_discount_percent: "Zniżka promocyjna [procent]",
      price_show_marketplace_service_fee_amount: "Opłata serwisowa",
      price_show_online_deposit_amount: "Przedpłata online",
      price_show_price_per_person: "Cena za osobę (cena oferty / liczba osób)",
      price_show_total_amount: "Kwota zamówienia (cena oferty + opłata serwisowa)",
      price_show_total_amount_with_cash_deposit:
        "Całkowita kwota zamówienia (wraz z kwotą do zapłaty na miejscu w walucie obcej)",
      price_show_total_price: "Cena oferty",
      price_show_type: "Sposób prezentacji ceny",
      message: "Wiadomość",
      requested_date: "Data",
      seller: "Sprzedawca",
      discount_percent: "Zniżka [procent]",
      total_discount_amount_cents: "Zniżka całkowita [w groszach]",
      total_price_cents: "Cena całkowita [w groszach/centach]",
      total_product_options_price_cents: "Cena całkowita za opcje dodatkowe [w groszach/centach]",
      total_product_price_before_discount_cents: "Cena całkowita za ofertę przed zniżką [w groszach/centach]",
      total_product_price_cents: "Cena całkowita za ofertę [w groszach/centach]",
      confirmation_installment_amount_cents: "Przedpłata online [w groszach]",
      confirmation_installment_paid_amount: "Wpłacono online",
      receptionist: "Rezerwujący",
      available_to: "Dostępna do",
      available_from: "Dostępna od",
      product_type: "Typ produktu",
      pricing_plan_type: "Typ planu cenowego",
    },
    errors: {
      messages: {
        already_exists: "taka wartość już istnieje.",
        has_to_be_in_future: "musi być datą w przyszłości.",
        installment_not_supported: "Ta kombinacja raty płatności nie jest obecnie wspierana przez system Tripsomnia.",
        invalid_installments_position: "Raty płatności mają niepoprawnie ustaloną kolejność.",
        invalid_online_payment_installments:
          'Raty płatności mają nieodpowiednią kombinację sposobu płatności. W obecnej chwili ewentualna rata płatności typu "Płatność online" musi być pierwszą i jedyną tego typu ratą płatności.',
        invalid_participant_data: 'Nieprawidłowe dane uczestnika "%{participant_name}".',
        invalid_participant_product_option_value:
          'Podano nieprawidłową wartość w polu "%{product_option_name}" dla uczestnika "%{participant_name}".',
        invalid_phone_number_characters: "zawiera nieprawidłowe znaki (powinien zawierać tylko cyfry)",
        invalid_product_option_value: 'Podano nieprawidłową wartość dla opcji dodatkowej "%{product_option_name}".',
        invalid_video_url:
          "jest nieprawidłowego formatu. Czy jesteś pewien, że to poprawny link do filmu YouTube/Vimeo?",
        missing_participant_product_option_value:
          'Wybierz wartość w polu "%{product_option_name}" dla uczestnika "%{participant_name}".',
        missing_product_option_value: 'Wybierz wartość dla wymaganej opcji dodatkowej "%{product_option_name}".',
        v1_invalid: "wartość niedozwolona dla modeli pochodzących z wersji v1.",
        v1_invalid_installments_transfer_type:
          'Raty płatności mają nieodpowiednią kombinację sposobu płatności. W przypadku zamówienia v1 musi to być kolejność typu "Płatność online" -> "Konto bankowe" -> "Gotówka", z ew. pominięciem niektórych z tych rat.',
        invalid_participant_ordered_item:
          'Nieprawidłowy przedmiot zamówienia przypisany do uczestnika "%{participant_name}".',
        invalid_ordered_item_participants_count:
          'Nieprawidłowa liczba uczestników dla przedmiotu zamówienia "%{ordered_item_name}".',
        empty: "Wymagane pole",
        greater_than: "Proszę podać kwotę większą niż 0.",
        too_short: "Tekst jest za krótki.",
        greater_than_or_equal_to: "Wartość musi być większa lub równa %{count}.",
        less_than_or_equal_to: "Wartość musi być mniejsza lub równa %{count}.",
        invalid: "Niepoprawna wartość.",
      },
      action_impossible_error: {
        code: "",
        http_code: "",
        message: "",
      },
      record_not_found_error: {
        code: "",
        http_code: "",
        message: "",
      },
      wrong_product_order_field_error: {
        code: "",
        http_code: "",
        message: "",
      },
    },
    base: {
      choose: "Wybierz",
      connection_error: "Wystąpił błąd podczas połączenia z serwerem.",
      date: {
        day: "Dzień",
        month: "Miesiąc",
        year: "Rok",
      },
      discount: "Zniżka",
      discount_coupon: "Zniżka",
      every_each: "co, każde",
      extend: "Rozwiń",
      from: "od",
      from_x: "od %{count}",
      from_x_to_y: "od %{x} do %{y}",
      in_weekdays_xyz: "w %{xyz}",
      loading: "Ładowanie",
      no: "Nie",
      read_more: "Czytaj więcej",
      see_more: "Zobacz więcej",
      to: "do",
      to_x: "do %{count}",
      x_days: {
        one: "%{count} dzień",
        few: "%{count} dni",
        many: "%{count} dni",
        other: "%{count} dnia",
      },
      x_hours: {
        one: "%{count} godzina",
        few: "%{count} godziny",
        many: "%{count} godzin",
        other: "%{count} godziny",
      },
      x_minutes: {
        one: "%{count} minuta",
        few: "%{count} minuty",
        many: "%{count} minut",
        other: "%{count} minuty",
      },
      x_nights: {
        one: "%{count} noc",
        few: "%{count} noce",
        many: "%{count} nocy",
        other: "%{count} nocy",
      },
      x_orders: {
        one: "%{count} zamówienie",
        few: "%{count} zamówienia",
        many: "%{count} zamówień",
        other: "%{count} zamówienia",
      },
      x_persons: {
        one: "%{count} osoba",
        few: "%{count} osoby",
        many: "%{count} osób",
        other: "%{count} osób",
      },
      x_seconds: {
        one: "%{count} sekunda",
        few: "%{count} sekundy",
        many: "%{count} sekund",
        other: "%{count} sekundy",
      },
      yes: "Tak",
      x_years: {
        one: "%{count} rok",
        few: "%{count} lata",
        many: "%{count} lat",
        other: "%{count} lat",
      },
      choose_date: "Wybierz datę",
      x_selected_records: {
        one: "%{count} zaznaczone",
        few: "%{count} zaznaczone",
        many: "%{count} zaznaczone",
        other: "%{count} zaznaczone",
      },
      since_x: "od %{x}",
      since_x_until_y: "od %{x} do %{y}",
      until_x: "do %{x}",
      for_x_days: {
        one: "przez %{count} dzień",
        few: "przez %{count} dni",
        many: "przez %{count} dni",
        other: "przez %{count} dni",
      },
    },
    components: {
      view_sections: {
        title: {
          read_more: "Zobacz więcej ofert",
        },
      },
    },
    date: {
      formats: {
        default: "%d-%m-%Y",
        long: "%A, %e %B %Y",
        short: "%d %b",
        short2: "%e %B %Y",
      },
    },
    helpers: {
      select: {
        no_results_message: "Brak wyników",
        prompt: "Wybierz",
      },
    },
    languages: {
      en: "angielski",
      pl: "polski",
      ru: "rosyjski",
      bg: "bułgarski",
      hr: "chorwacki",
      cs: "czeski",
      da: "duński",
      nl: "holenderski",
      et: "estoński",
      fi: "fiński",
      fr: "francuski",
      de: "niemiecki",
      el: "grecki",
      hu: "węgierski",
      is: "islandzki",
      ga: "irlandzki",
      it: "włoski",
      lv: "łotewski",
      lt: "litewski",
      lb: "luksemburski",
      mk: "macedoński",
      mt: "maltański",
      pt: "portugalski",
      ro: "rumuński",
      sr: "serbski",
      sk: "słowacki",
      sl: "słoweński",
      es: "hiszpański",
      sv: "szwedzki",
      tr: "turecki",
      uk: "ukraiński",
      cy: "walijski",
      ar: "arabski",
      ca: "kataloński",
      he: "hebrajski",
      th: "tajlandzki",
      vi: "Wietnamski",
    },
    number: {
      currency: {
        format: {
          format: "%n %u",
        },
      },
    },
    order_actions: {
      send_approved_order_has_paid_online_deposit_company_sms: {
        sms_content: {
          marketplace:
            "Zamówienie nr %{order_id} jest potwierdzone i zostało opłacone przez klienta. Szczegóły wysłane na maila.",
          saas: "Zamówienie nr %{order_id} jest potwierdzone i zostało opłacone przez klienta. Szczegóły wysłane na maila.",
        },
      },
      send_order_awaits_approval_company_sms: {
        sms_content: {
          marketplace: "Zamówienie nr %{order_id} oczekuje na pilne potwierdzenie. Szczegóły wysłane na maila.",
          saas: "Zamówienie nr %{order_id} oczekuje na pilne potwierdzenie. Szczegóły wysłane na maila.",
        },
      },
      send_order_has_been_approved_customer_sms: {
        sms_content: {
          after_company_approval: {
            marketplace:
              "Zamówienie nr %{order_id} zostało potwierdzone. Prosimy o dokonanie płatności. Szczegóły wysłane na maila.",
            saas: "Zamówienie nr %{order_id} zostało potwierdzone. Prosimy o dokonanie płatności. Szczegóły wysłane na maila.",
          },
          default: {
            marketplace: "Zamówienie nr %{order_id} zostało potwierdzone. Szczegóły wysłane na maila.",
            saas: "Zamówienie nr %{order_id} zostało potwierdzone. Szczegóły wysłane na maila.",
          },
        },
      },
      send_order_has_been_rejected_customer_sms: {
        sms_content: {
          marketplace: "Zamówienie nr %{order_id} zostało odrzucone przez firmę. Szczegóły wysłane na maila.",
          saas: "Zamówienie nr %{order_id} zostało odrzucone. Szczegóły wysłane na maila.",
        },
      },
      send_order_has_been_cancelled_customer_sms: {
        sms_content: {
          marketplace: "Zamówienie nr %{order_id} zostało anulowane. Szczegóły wysłane na maila.",
          saas: "Zamówienie nr %{order_id} zostało anulowane. Szczegóły wysłane na maila.",
        },
      },
    },
    product_pricelist: {
      lowest_price_is_on: "Najniższa cena obowiązuje %{schedule_range}.",
      price_name: "%{price} dla %{people}",
      price_per_coupon: "cena za kupon",
      price_per_item: "cena za pakiet/ grupę",
      price_per_night: "cena za noc",
      price_per_product: "cena za ofertę",
      price_per_stay: "cena za pobyt",
      price_per_tour: "cena za wycieczkę",
      sold_out_already: "Ta oferta została już wyprzedana.",
      x_coupons_left: {
        one: "Pozostał jeden kupon.",
        few: "Pozostały %{count} kupony.",
        many: "Pozostało %{count} kuponów.",
        other: "Pozostało %{count} kupona.",
      },
      x_stocks_left: "Tylko %{count} w tej cenie.",
    },
    "social_travel/new_company_registration_form": {
      errors: {
        company_already_exists: "Firma z takim adresem e-mail jest już zarejestrowana w naszym serwisie.",
      },
    },
    time: {
      formats: {
        long: "%A, %e %B %Y o %H:%M",
        short: "%e %b o %H:%M",
        time: "%H:%M",
        short2: "%e %B %Y",
      },
    },
    view_collection_item_decorator: {
      offer_read_more: "Zobacz ofertę",
      offers_read_more: "Zobacz oferty",
    },
    frontend: {
      companies: {
        show: {
          reviews_title: "Opinie o %{marketplace_name}",
          products_calendar: "Kalendarz terminów",
          products: "Oferty",
          reviews: "Opinie",
          reviews_title_html: "Opinie o %{marketplace_name}",
        },
      },
      company_orders: {
        approve: {
          action_impossible: "Operacja niemożliwa. Być może zamówienie już zostało potwierdzone lub odrzucone?",
          success: 'Zamówienie nr #%{id} na "%{product_name}" (klient: %{customer_full_name}) zostało potwierdzone.',
        },
        finish: {
          action_impossible: "Operacja niemożliwa. Być może zamówienie już zostało zakończone?",
          success: 'Zamówienie nr #%{id} na "%{product_name}" (klient: %{customer_full_name}) zostało zakończone.',
        },
        reject: {
          action_impossible: "Operacja niemożliwa. Być może zamówienie już zostało potwierdzone lub odrzucone?",
          success: 'Zamówienie nr #%{id} na "%{product_name}" (klient: %{customer_full_name}) zostało odrzucone.',
          success_with_slot_deactivated:
            'Zamówienie nr #%{id} na "%{product_name}" (klient: %{customer_full_name}) zostało odrzucone. Ponadto, wybrany termin rezerwacji został zdezaktywowany - dalsze zamówienia na ten termin nie będą już przyjmowane.',
        },
        show: {
          admin_app_info_html:
            'Polecamy zalogować się do naszego <a href="%{partnerapp_order_url}">panelu do zarządzania dostępnością</a>. Przy jego użyciu możesz w pełni zarządzać swoimi ofertami i zamówieniami klientów.',
          approve_order: "Potwierdź zamówienie",
          finish_order: "Oznacz jako Zakończone",
          order_name: 'Zamówienie nr %{order_id} na "%{product_name}"',
          order_status: "Status zamówienia: %{status_i18n}",
          reject_order: "Odrzuć zamówienie",
        },
      },
      errors: {
        show: {
          general_error: "Spróbuj odświeżyć stronę ponownie.",
          general_error_hint_html:
            "Jeśli błąd się powtarza, spróbuj jeszcze raz za kilka minut lub zgłoś ten problem do nas na %{email}.",
          header: "Wystąpił błąd %{error_code}",
          page_not_found: "Wybrana strona nie została znaleziona.",
          page_not_found_hint_html:
            'Wróć na <a href="%{root_url}">stronę główną</a> lub użyj wyszukiwarki by znaleźć interesującą Cię ofertę.',
          title: "Błąd %{error_code}",
        },
      },
      orders: {
        confirm: {
          already_abandoned_error:
            "To zamówienie zostało już anulowane. By dokonać zamówienia, wróć do pierwszego kroku formularza zamówienia.",
          already_confirmed_error:
            "To zamówienie jest już w realizacji. Odśwież stronę, by rozpocząć kolejną zamówienie.",
        },
        new: {
          title: "Rezerwuj: %{product_name}",
        },
        show: {
          title: "Zamówienie nr %{id}",
        },
        update: {
          already_abandoned_error:
            "To zamówienie zostało już anulowane. By dokonać zamówienia, przejdź do początku formularza ponownie.",
          already_confirmed_error:
            "To zamówienie jest już w realizacji. Odśwież stronę, by rozpocząć kolejne zamówienie.",
        },
      },
      products: {
        show: {
          draft_notice:
            "Przeglądasz obecnie ofertę, która nie jest opublikowana. Pozostałym użytkownikom serwisu ta strona wyświetlana będzie jako niedostępna (404).",
          instead_of: "zamiast",
          location_address: "Adres",
          location_tips: "Wskazówki dojazdu",
          make_an_order: "Rezerwuj",
          pay_on_the_spot: "Zapłać na miejscu",
          product_shown_in_different_locale_notice:
            "Niestety ta oferta nie ma obecnie opisu w wybranym przez Ciebie języku.",
          product_unavailable: "Brak terminów",
          see_map: "Pokaż mapę",
          select_product_variant: "Wybierz opcję",
          similar_locations_title: "Zobacz więcej ofert w tej lokalizacji",
          similar_products_title: "Zainteresują Cię również",
          youre_saving: "Oszczędzasz",
          pickup_points: "Miejsca zbiórki",
          custom_pickup_point_possible: "Odbiór z hotelu",
          reviews_title: "Opinie o %{company_name}",
          recently_viewed_products_title: "Ostatnio przeglądane oferty",
          recently_viewed_products_and_categories_title: "Ostatnio przeglądane oferty i kategorie",
          other_locations: "Inne lokalizacje",
          buy_product_cta_button: "Kup",
          buy_coupon_cta_button: "Pobierz kupon",
          see_product_availability_cta_button: "Zobacz terminy",
          choose_coupon: "Wybierz opcję",
          offer_finished_cta_button: "Oferta zakończona",
          coupon_finished: "Promocja zakończona",
          product_finished: "Oferta zakończona",
          product_expires_at: "Oferta wygasa %{datetime}",
          product_expired_notice:
            "Oferta, na którą spoglądasz, wygasła. Nie jest już możliwym złożenie na nią zamówienia.",
          product_expired: "Oferta wygasła",
          only_x_coupons_left: "Pobrano %{total_stock_used} kuponów.",
          nb_stock_useby_date_range: "Możliwe do wykorzystania %{date_range}",
          no_coupons_left: "Wariant wyprzedany. Limit sprzedaży został osiągnięty.",
          less_than_x_coupons_left: "Pozostało mniej niż %{total_stock_left} kuponów dostępnych.",
          quicknav: {
            description: "Opis",
            includes: "Cena zawiera",
            requirements: "Wymagania",
            map: "Mapa",
            reviews: "Recenzje",
          },
          reviews_title_html: 'Opinie o <a href="%{company_url}">%{company_name}</a>',
          not_available_notice: "",
        },
        search: {
          filter_query_title: "Szukaj po tekście",
          toggle_filters: "Filtruj wyniki",
          filter_query_placeholder: "Wpisz frazę wyszukiwania",
          location_query_title: "Szukaj w pobliżu",
          location_query_label: "w odległości",
          location_query_placeholder: "Gdzie?",
          date_query_title: "Termin",
          categories_query_title: "Kategorie",
          locations_query_title: "Regiony",
          locales_query_title: "Język",
          no_results_message:
            "Niestety, nie znaleźliśmy żadnych ofert dla Twojego wyszukiwania. Spróbuj je sprecyzować inaczej.",
          shown_results: "Wyświetlanie %{start} - %{end}  z %{total_count}",
          previous_page: "Poprzednia strona",
          next_page: "Następna strona",
          site_title: {
            around_location: "W pobliżu %{location}",
            with_category_and_location: "Oferty z kategorii %{category} w %{location}",
            with_category: "Oferty z kategorii %{category}",
            with_location: "Oferty w %{location}",
            default: "Oferty",
          },
        },
        history: {
          site_title: "Ostatnio oglądane oferty",
          viewed_products_title: "Ostatnio przeglądałeś",
          similar_to_viewed_products_title: "Zainteresuje Cię też",
          viewed_products_tags_title: "Zobacz także",
        },
      },
      reviews: {
        new: {
          site_title: "Dodaj opinię",
          review_details_title: "Twoja opinia",
          content_placeholder: "Opisz kilkoma słowami co było dobrze, a co można byłoby poprawić.",
          rating_label: "Wybierz ocenę...",
          personal_details_title: "Twoje dane",
          locale_label: "Język",
          age_group_label: "Twój wiek",
          group_type_label: "Typ grupy",
          author_name_label: "Twoje imię",
          author_email_label: "Twój adres e-mail",
          st_details_title: "Jak ocenisz proces rezerwacji?",
          st_rating_label: "Wybierz ocenę...",
          st_feedback_placeholder: "Dlaczego?",
          submit: "Wyślij opinię",
          add_success_message: "Twoja opinia została przekazana do weryfikacji. Dziękujemy!",
          error_message: "Wystąpił błąd podczas zapisywania formularza.",
          review_for_given_order_already_exists:
            "Opinia dla tego zamówienia została już dodana. Ponowne napisanie opinii lub jej edycja nie jest możliwe.",
          order_id: "Numer zamówienia",
          product: "Oferta",
          author_email_hint: "Nie będziemy go nikomu pokazywać.",
          add_review_title_about_product: 'Dodaj opinię o "%{product_name}" oraz %{company_name}',
          add_review_title_about_company: "Dodaj opinię o %{company_name}",
        },
      },
    },
    layouts: {
      application: {
        contact: {
          about_us: {
            title: "O nas",
          },
          contact_us: {
            title: "Skontaktuj się z nami",
          },
          cooperating_with: {
            dotpay_payments: "Płatności obsługiwane przez systemy DotPay i PayPal",
            title: "Współpracujemy z",
          },
          see_us_on_facebook: {
            title: "Obserwuj nas na Facebooku",
          },
          write_to_us: {
            title: "Napisz do nas",
          },
          payment_gateways: {
            title: "Obsługiwane metody płatności",
            description: "Przyjmujemy płatności kartami płatniczymi, poprzez przelew bankowy oraz PayPal.",
          },
        },
        footer: {
          about_us: "O nas",
          careers: "Praca",
          cooperation: "Współpraca",
          faq: "FAQ",
          help: "Pomoc",
          privacy_policy: "Polityka prywatności",
          rules_note_html: 'Korzystanie z serwisu oznacza akceptację <a href="%{rules_url}">regulaminu</a>.',
        },
        guaranteed: {
          read_more: "Zobacz, jak działa Tripsomnia",
          s1: {
            line1: "Starannie dobrane oferty",
            line2: "i sprawdzeni organizatorzy.",
            title: "Najwyższa jakość",
          },
          s2: {
            line1: "Zniżki nawet do 50%!",
            line2: "Wynegocjowane specjalnie dla Was.",
            title: "Najniższe ceny",
          },
          s3: {
            currency: "zł",
            line1: "Płać w ratach poprzez płatność online lub bezpośrednio na konto firmy albo gotówką na miejscu.",
            title: "Bezpieczne płatności",
          },
          s4: {
            line1: "Najciekawsze oferty wycieczek i atrakcji w jednym miejscu!",
            title: "Rezerwuj online",
          },
          title: "Gwarantujemy",
        },
        navbar: {
          about_us: "O nas",
          for_business: "Współpraca",
          products_calendar: "Kalendarz terminów",
          search_placeholder: "Wyszukaj ofertę, lokalizację lub kategorię",
          products_history: "Historia (%{count})",
          contact: "Kontakt",
          faq: "Często zadawane pytania",
          open_chat: "Czat",
          cart: "Koszyk (%{count})",
          finish_order: "Dokończ zamówienie: %{product_name} (%{total_amount})",
          company_reviews: "Opinie",
        },
      },
      mailer: {
        greetings: "Pozdrawiamy,",
        marketplace: {
          footer_headline: "Tripsomnia - Lubimy Podróżować!",
        },
        footer_phone: "Tel.",
        footer_email: "E-mail:",
      },
    },
    pdfs: {
      order_voucher: {
        cancellation_policy: "Warunki rezygnacji",
        cancellation_policy_description:
          "Oferta bezzwrotna. Brak możliwości dokonywania zmian w zamówieniu oraz jego anulowania. W przypadku nie pojawienia się uczestnika, nie przysługuje prawo zwrotu wpłaconych środków.",
        company_details: "Dane organizatora",
        contact_email: "Adres e-mail",
        contact_facebook_url: "Facebook",
        contact_full_address: "Adres",
        contact_phone_number: "Telefon kontaktowy",
        contact_website_url: "Strona WWW",
        generated_date: "Wygenerowano: %{date}",
        got_any_questions: "Masz pytania?",
        order_details: "Twoje dane kontaktowe",
        order_number: "Numer zamówienia",
        product_details: "Szczegóły oferty",
        st_headline: "Tripsomnia (SocialTravel Sp. z o.o.)",
        title: "Potwierdzenie zamówienia nr %{order_id}",
        wish_you_great_journey: "Życzymy niepowtarzalnych wrażeń!",
        your_order: "Twoje zamówienie",
        footer_phone: "Tel. ",
        footer_email: "E-mail: ",
        code: "Kod: %{code}",
      },
      slot_manifest: {
        customer_name_placeholder: "Zamówienie",
        generated_on: "Data wygenerowania %{date}",
        page_title: "Manifest terminu",
      },
    },
    admin_user_mailer: {
      company_created_you_an_account: {
        action: "Ustaw swoje hasło",
        greeting: "Cześć %{recipient}!",
        instruction:
          "Firma %{company_name} założyła Ci konto w Panelu Tripsomnia, służącego do obsługi zamówień i ofert wycieczek turystycznych.",
        instruction_2:
          "Aby zalogować się do serwisu, kliknij w poniższy link, który pozwoli Ci na ustawienie Twojego hasła do serwisu.",
        instruction_3: "Jeśli nie żądałeś dostępu do tego serwisu, zignoruj tę wiadomość.",
        subject: "Firma %{company_name} założyła Ci konto w Panelu Partnera ST",
      },
      company_invited_you_to_become_a_member: {
        action: "Przejdź do panelu Firmy",
        greeting: "Cześć %{recipient}!",
        instruction:
          "Firma %{company_name} przydzieliła Ci dostęp do Panelu Partnera Tripsomnia, służącego do obsługi zamówień i ofert wycieczek turystycznych.",
        instruction_2: "Kliknij w poniższy link, aby przejść do panelu.",
        subject: "Firma %{company_name} przydzieliła Ci dostęp do Panelu Partnera ST",
      },
    },
    company_mailer: {
      agent_invitation_received: {
        action: "Przejdź do panelu współpracy",
        greeting: "Cześć %{company_name}!",
        instruction: "Firma %{supplier_name} zaprosiła Cię do współpracy agencyjnej, byś mógł sprzedawać jej oferty.",
        instruction_2: "Kliknij w poniższy link, by przejść do panelu i zobaczyć szczegóły współpracy.",
        subject: "Firma %{supplier_name} zaprosiła Cię do współpracy w społeczności Tripsomnia.com",
      },
      company_and_user_created_agent_invitation_received: {
        action: "Ustal swoje hasło",
        greeting: "Cześć %{company_name}!",
        instruction: "Firma %{supplier_name} zaprosiła Cię do współpracy agencyjnej, byś mógł sprzedawać jej oferty.",
        instruction_2: "",
        instruction_3: "Kliknij w poniższy link, by ustalić swoje hasło do konta i zobaczyć szczegóły współpracy.",
        subject: "Firma %{supplier_name} zaprosiła Cię do współpracy agencyjnej",
      },
      company_created_and_agent_invitation_received: {
        action: "Przejdź do panelu współpracy",
        greeting: "Cześć %{company_name}!",
        instruction: "Firma %{supplier_name} zaprosiła Cię do współpracy agencyjnej, byś mógł sprzedawać jej oferty.",
        instruction_2: "Kliknij w poniższy link, by przejść do panelu i zobaczyć szczegóły współpracy.",
        subject: "Firma %{supplier_name} zaprosiła Cię do współpracy agencyjnej",
      },
      company_registration_approved: {
        action: "Przejdź do panelu",
        greeting: "Cześć %{company_name}!",
        instruction:
          "Stworzyliśmy Ci konto firmy %{company_name} w naszym panelu Tripsomnia do zarządzania zamówieniami i ofertami wycieczek turystycznych.",
        instruction_2:
          'Kliknij w poniższy link, by przejść do panelu i zobaczyć szczegóły współpracy. Link jest aktywny przez 48h, jeżeli w tym czasie nie uda się Państwu zalogować, prosimy skorzystać z opcji "Przypomnienie hasła", aby odzyskać dostęp do konta.',
        subject: "Konto firmy %{company_name} zostało założone w panelu Tripsomnia",
      },
      company_registration_approved_and_user_created: {
        action: "Ustal swoje hasło",
        greeting: "Cześć %{company_name}!",
        instruction:
          "Stworzyliśmy Ci konto firmy %{company_name} w naszym panelu Tripsomnia do zarządzania zamówieniami i ofertami wycieczek turystycznych.",
        instruction_2: "",
        instruction_3:
          'Kliknij w poniższy link, by przejść do panelu i zobaczyć szczegóły współpracy. Link jest aktywny przez 48h, jeżeli w tym czasie nie uda się Państwu zalogować, należy skorzystać z opcji "Przypomnienie hasła", aby odzyskać dostęp do konta.',
        subject: "Konto firmy %{company_name} zostało założone w panelu Tripsomnia",
      },
      company_registration_created: {
        action: "Zobacz szczegóły rejestracji",
        greeting: "Cześć!",
        instruction: "Ktoś wypełnił formularz rejestracji firmy na poniższe dane:",
        subject: "Firma %{company_name} chce zarejestrować się w panelu ST",
      },
      customer_review_submitted: {
        greeting: "Cześć %{company_name}!",
        new_review_has_been_submitted: "W serwisie Tripsomnia została dodana opinia na Twój temat.",
        action: "Zobacz opinię",
        subject: "Dodano nową opinię na Twój temat",
      },
      company_and_user_created_supplier_invitation_received: {
        action: "Ustal swoje hasło",
        greeting: "Cześć %{supplier_name}!",
        instruction: "Firma %{agent_name} zaprosiła Cię do współpracy agencyjnej, aby mogła sprzedawać Twoje oferty.",
        instruction_2: "",
        instruction_3: "Kliknij w poniższy link, by przejść do panelu i zobaczyć szczegóły współpracy.",
        subject: "Firma %{agent_name} zaprosiła Cię do współpracy w społeczności Tripsomnia.com",
      },
      company_created_and_supplier_invitation_received: {
        action: "Przejdź do panelu współpracy",
        greeting: "Cześć %{supplier_name}!",
        instruction: "Firma %{agent_name} zaprosiła Cię do współpracy agencyjnej, aby mogła sprzedawać Twoje oferty.",
        instruction_2: "Kliknij w poniższy link, by przejść do panelu i zobaczyć szczegóły współpracy.",
        subject: "Firma %{agent_name} zaprosiła Cię do współpracy w społeczności Tripsomnia.com",
      },
      supplier_invitation_received: {
        action: "Przejdź do panelu współpracy",
        greeting: "Cześć %{supplier_name}!",
        instruction: "Firma %{agent_name} zaprosiła Cię do współpracy agencyjnej, aby mogła sprzedawać Twoje oferty.",
        instruction_2: "Kliknij w poniższy link, by przejść do panelu i zobaczyć szczegóły współpracy.",
        subject: "Firma %{agent_name} zaprosiła Cię do współpracy w społeczności Tripsomnia.com",
      },
    },
    order_mailer: {
      base: {
        company_approve_order: "Potwierdź zamówienie",
        company_finish_order: "Oznacz jako Zakończone",
        company_reject_order: "Odrzuć zamówienie",
        company_see_order: "Podejrzyj zamówienie",
        customer_repeat_order: "Powtórz zamówienie",
        customer_see_all_offers: "Zobacz wszystkie dostępne oferty",
        customer_see_nearby_offers: "Zobacz inne oferty w okolicy",
        customer_see_offer: "Zobacz ofertę",
        hello_company: "Witaj %{company_name}!",
        hello_customer: "Witaj %{customer_full_name},",
        order_status: "Status zamówienia: %{status_i18n}",
        company_reject_order_and_deactivate_slot: "Odrzuć zamówienie i wyłącz ten termin ze sprzedaży",
      },
      company_order_footer: {
        line1_html: "Twoja oferta dostępna jest w serwisie pod linkiem: %{product_link}.",
        line2_html: 'Możesz nią zarządzać z poziomu <a href="%{partnerapp_order_url}">Panelu Partnera</a>.',
      },
      order_about_to_start_reminder_company_email: {
        p1_html:
          'Zamówienie klienta %{customer_full_name} nr %{order_id} na "%{product_name}" rozpoczyna się już za %{days_to_start} dni (%{stock_start_date}).',
        p2_html:
          'W ramach przypomnienia, przesyłamy Ci szczegóły zamówienia. Potwierdzenie zamówienia w wersji do druku przesłaliśmy w poprzednim mailu, ale jeśli nie możesz go znaleźć, plik pdf możesz także pobrać przez <a href="%{customer_pdf_order_url}">ten link</a>.',
        subject:
          'Zatwierdzone zamówienie nr %{order_id} na "%{product_name}" rozpoczyna się za %{days_to_start} dni (klient: %{customer_full_name})',
      },
      order_about_to_start_reminder_customer_email: {
        marketplace: {
          p1_html:
            'Twoje zamówienie nr %{order_id} na "%{product_name}" rozpoczyna się już za %{days_to_start} dni, tj. w %{stock_start_date}!',
          p2_html:
            'Mamy nadzieję, że Twoje plany nie uległy zmianie, w przeciwnym wypadku prosimy o kontakt. W ramach przypomnienia, przesyłamy Ci szczegóły Twojego zamówienia. Potwierdzenie zamówienia w wersji do druku przesłaliśmy w poprzednim mailu, ale jeśli nie możesz go znaleźć, plik pdf możesz także pobrać przez <a href="%{customer_pdf_order_url}">ten link</a>.',
        },
        saas: {
          p1_html:
            'Twoje zamówienie nr %{order_id} na "%{product_name}" rozpoczyna się już za %{days_to_start} dni, tj. w %{stock_start_date}!',
          p2_html:
            'Mamy nadzieję, że Twoje plany nie uległy zmianie, w przeciwnym wypadku prosimy o kontakt. W ramach przypomnienia, przesyłamy Ci szczegóły Twojego zamówienia. Potwierdzenie zamówienia w wersji do druku przesłaliśmy w poprzednim mailu, ale jeśli nie możesz go znaleźć, plik pdf możesz także pobrać przez <a href="%{customer_pdf_order_url}">ten link</a>.',
        },
        subject: 'Twoje zamówienie "%{product_name}" rozpoczyna się za %{days_to_start} dni',
      },
      order_company_approval_time_limit_exceeded_company_email: {
        line1:
          'Niestety, byliśmy zmuszeni odrzucić wstępne zamówienie nr %{order_id} od %{customer_full_name} na "%{product_name}" w terminie %{stock_time_range} w związku z brakiem Twojej odpowiedzi na zapytanie w wymaganym terminie.',
        line2:
          "Jeżeli nie masz dostępnych miejsc w terminie podanym przez to zamówienie, prosimy o aktualizację dostępności miejsc w panelu partnera.",
        subject:
          "Zamówienie nr %{order_id} zostało odrzucone - nie potwierdziłeś zamówienia w terminie (klient: %{customer_full_name})",
        line1_html:
          'Niestety, byliśmy zmuszeni odrzucić wstępne zamówienie nr <a href="%{partnerapp_order_url}">%{order_id}</a> od %{customer_full_name} na "%{product_name}" w terminie (%{stock_time_range}) w związku z brakiem Twojej odpowiedzi na zapytanie w wymaganym terminie.',
      },
      order_company_approval_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>Niestety byliśmy zmuszeni automatycznie odrzucić Twoje zamówienie nr %{order_id} na "%{product_name}" (%{stock_time_range})</strong>, w związku z brakiem odpowiedzi naszego partnera %{company_name} na Twoje zamówienie w wymaganym terminie %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
        },
        saas: {
          line1_html:
            '<strong>Niestety byliśmy zmuszeni automatycznie odrzucić Twoje zamówienie nr %{order_id} na "%{product_name}" (%{stock_time_range})</strong>, w związku z przekroczeniem maksymalnego czasu na potwierdzenie - %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
        },
        subject:
          "Zamówienie nr %{order_id} zostało odrzucone - nie otrzymaliśmy potwierdzenia zamówienia w wymaganym terminie",
      },
      order_current_status_customer_email: {
        marketplace: {
          p1: "Przesyłamy Ci obecny status zamówienia.",
        },
        saas: {
          p1: "Przesyłamy Ci obecny status zamówienia.",
        },
        subject: 'Zamówienie nr %{order_id}, obecny status: %{status_i18n} ("%{product_name}")',
      },
      order_finished_add_opinion_reminder_customer_email: {
        marketplace: {
          add_review: "Dodaj opinię",
          contact_us:
            "Jeżeli masz uwagi co do działania naszego systemu i biura obsługi klienta Tripsomnia, skontaktuj się z nami!",
          share_your_opinion_html:
            "Pomóż innym turystom i wyraź opinię na temat firmy %{company_link} oraz oferty %{product_link}.",
          thank_you_html: "Dziękujemy za złożenie zamówienia poprzez Tripsomnia i skorzystanie z usług firmy.",
        },
        saas: {
          add_review: "Dodaj opinię",
          contact_us:
            "Jeżeli masz uwagi co do działania naszego systemu i biura obsługi klienta skontaktuj się z nami!",
          share_your_opinion_html:
            "Pomóż innym turystom i wyraź opinię na nasz temat %{company_link} oraz oferty %{product_link}.",
          thank_you_html: "Dziękujemy za skorzystanie z naszych usług.",
        },
        subject: 'Dodaj opinię nt. "%{product_name}" (%{company_name})',
      },
      order_is_approved_company_email: {
        no_online_deposit_subject: "Zamówienie nr %{order_id} zostało potwierdzone (klient: %{customer_full_name})",
        online_deposit_after_company_approval_subject:
          "Zamówienie nr %{order_id} zostało potwierdzone i opłacone (klient: %{customer_full_name})",
        online_deposit_before_company_approval_subject:
          "Zamówienie nr %{order_id} zostało opłacone i potwierdzone (klient: %{customer_full_name})",
        online_deposit_paid:
          "Klient wpłacił zaliczkę %{confirmation_installment_paid_amount} na poczet zamówienia nr %{order_id} na %{product_name}. Zamówienie otrzymało status zatwierdzone.",
        order_approved: 'Zamówienie nr %{order_id} na "%{product_name}" zostało potwierdzone.',
        order_cant_be_cancelled_now: "Od tej chwili, nie mogą Państwo już anulować tego zamówienia.",
        order_infos_below:
          "Poniżej znajdziesz szczegóły zamówienia. W załączniku umieściliśmy voucher pdf z potwierdzeniem zamówienia, który został przesłany do Klienta.",
        remember_to_set_order_as_finished: 'Po zrealizowaniu zamówienia pamiętaj o oznaczeniu go jako "Zakończone".',
        voucher: {
          line1_html:
            "Rezerwacja z wykorzystaniem <strong>Bonu Turystycznego</strong>. Po przyjeździe klienta na miejsce zrealizuj Bon na stronie https://bonturystyczny.zus.pl/ oraz przyjmij ewentualną dopłatę reszty kwoty.",
          line2_html:
            "Aby zrealizować Bon poproś klienta o podanie numeru <strong>Bonu oraz kodu autoryzacji płatności</strong>, który otrzyma SMS-em w momencie realizacji. Możesz również poprosić klienta o weryfikację bonu przed przyjazdem kontaktując się z klientem telefonicznie lub e-mailowo.",
        },
      },
      order_is_approved_customer_email: {
        marketplace: {
          bank_wire_deposit_additional_info:
            "W tytule przelewu prosimy wpisać tylko i wyłącznie numer zamówienia, który znajduje się w niniejszym potwierdzeniu. W przeciwnym wypadku nie możemy zagwarantować, że przelew zostanie zaksięgowany na czas.",
          bank_wire_deposit_deadline_html:
            "<strong>Pamiętaj o dokonaniu przelewu na czas.</strong> Jeśli nie wpłacisz zaliczki na konto bankowe w jej terminie, Twoje zamówienie może zostać anulowane.",
          bank_wire_deposit_make_html: "Prosimy o dokonanie płatności poprzez przelew bankowy.",
          bank_wire_deposit_required: "To zamówienie wymaga jednak dodatkowej płatności na konto.",
          order_approved_by_company:
            'Twoje zamówienie nr %{order_id} na "%{product_name}" zostało zatwierdzone przez %{company_name}!',
          order_created: "Dziękujemy za złożenie zamówienia przez Tripsomnię.",
          order_data_and_deposit_received: "Otrzymaliśmy od Ciebie wszelkie potrzebne informacje i płatność.",
          order_data_received: "Otrzymaliśmy od Ciebie wszelkie potrzebne informacje.",
          this_is_confirmation:
            "Ten e-mail jest potwierdzeniem Twojego zamówienia. W załączniku znajdziesz potwierdzenie zawierające najważniejsze informacje. Możesz zabrać je ze sobą na telefonie lub wydrukowane.",
          order_approved_by_customer: 'Twoje zamówienie nr %{order_id} na "%{product_name}" zostało potwierdzone.',
          voucher: {
            line1_html:
              "Rezerwacja z wykorzystaniem <strong>Bonu Turystycznego</strong>. Po przyjeździe na miejsce zrealizuj Bon oraz dopłać ewentualną pozostałą kwotę.",
            line2_html:
              "Aby zrealizować Bon podaj sprzedawcy <strong>kwotę, którą chcesz zapłacić oraz numeru Bonu</strong>. Następnie podaj <strong>kod autoryzacji płatności</strong>, który otrzymasz SMS-em w momencie realizacji. Obiekt może również skontaktować się z Tobą wcześniej telefonicznie lub e-mailowo w celu realizacji Bonu, aby potwierdzić rezerwację.",
          },
        },
        saas: {
          bank_wire_deposit_additional_info:
            "W tytule przelewu prosimy wpisać tylko i wyłącznie numer zamówienia, który znajduje się w niniejszym potwierdzeniu. W przeciwnym wypadku nie możemy zagwarantować, że przelew zostanie zaksięgowany na czas.",
          bank_wire_deposit_deadline_html:
            "<strong>Pamiętaj o dokonaniu przelewu na czas.</strong> Jeśli nie wpłacisz zaliczki na konto bankowe w podanym terminie, Twoje zamówienie może zostać anulowane.",
          bank_wire_deposit_make_html: "Prosimy o dokonanie płatności poprzez przelew bankowy.",
          bank_wire_deposit_required: "To zamówienie wymaga jednak dodatkowej płatności na konto.",
          order_approved_by_company: 'Potwierdziliśmy Twoje zamówienie nr %{order_id} na "%{product_name}"!',
          order_created: "Dziękujemy za złożenie zamówienia!",
          order_data_and_deposit_received: "Otrzymaliśmy od Ciebie wszelkie potrzebne informacje i płatność.",
          order_data_received: "Otrzymaliśmy od Ciebie wszelkie potrzebne informacje.",
          this_is_confirmation:
            "Ten e-mail jest potwierdzeniem Twojego zamówienia. W załączniku znajdziesz potwierdzenie zawierające najważniejsze informacje. Możesz zabrać je ze sobą na telefonie lub wydrukowane.",
          order_approved_by_customer: 'Twoje zamówienie nr %{order_id} na "%{product_name}" zostało potwierdzone.',
          voucher: {
            line1_html:
              "Rezerwacja z wykorzystaniem <strong>Bonu Turystycznego</strong>. Po przyjeździe na miejsce zrealizuj Bon oraz dopłać ewentualną pozostałą kwotę.",
            line2_html:
              "Aby zrealizować Bon podaj sprzedawcy <strong>kwotę, którą chcesz zapłacić oraz numeru Bonu</strong>. Następnie podaj <strong>kod autoryzacji płatności</strong>, który otrzymasz SMS-em w momencie realizacji. Możemy również skontaktować się z Tobą wcześniej telefonicznie lub e-mailowo w celu realizacji Bonu, aby potwierdzić rezerwację.",
          },
        },
        subject: 'Potwierdzenie zamówienia nr %{order_id} na "%{product_name}"',
      },
      order_is_waiting_for_company_approval_company_email: {
        confirmation_deadline_warning:
          'Prosimy o sprawdzenie szczegółów zamówienia i kliknięcie "Potwierdź zamówienie", jeśli są Państwo w stanie je zrealizować.\nW przypadku braku potwierdzenia w tym terminie zamówienie zostanie automatycznie odrzucone. Jeżeli nie mogą Państwo zrealizować poniższego zamówienia w podanym terminie, prosimy o kontakt z klientem, aby zaproponować zmianę daty lub skorzystanie z innej oferty. Jeśli ostatecznie nie uda się z klientem porozumieć prosimy o kliknięcie "Odrzuć zamówienie". Mogą Państwo również odrzucić zamówienie oraz wstrzymać sprzedaż tego terminu oferty klikając odpowiedni przycisk.',
        future_online_deposit_info:
          "W przypadku gdy potwierdzą Państwo zamówienie, klient będzie miał %{confirmation_installment_after_company_approval_time_limit} godzin na wpłatę %{confirmation_installment_st_name_d} online o kwocie %{confirmation_installment_transaction_amount} na poczet zamówienia.",
        order_received: 'Otrzymaliśmy wstępne zamówienie nr %{order_id} na "%{product_name}".',
        past_online_deposit_info:
          "Klient wykonał %{confirmation_installment_st_name_b} online na kwotę %{confirmation_installment_paid_amount} w celu zabezpieczenia zamówienia wstępnego. W przypadku odrzucenia zamówienia przez Państwa %{confirmation_installment_st_name} online zostanie automatycznie zwrócona klientowi.",
        please_confirm:
          "Prosimy o potwierdzenie zamówienia w ciągu 48h. W przeciwnym wypadku zostanie ono automatycznie odrzucone.",
        subject: "Zamówienie nr %{order_id} oczekuje na potwierdzenie (klient: %{customer_full_name})",
        order_approved_by_customer: 'Klient potwierdził wstępne zamówienie nr %{order_id} na "%{product_name}".',
        voucher: {
          line1_html:
            "Rezerwacja z wykorzystaniem <strong>Bonu Turystycznego</strong>. Po przyjeździe klienta na miejsce zrealizuj Bon na stronie https://bonturystyczny.zus.pl/ oraz przyjmij ewentualną dopłatę reszty kwoty.",
          line2_html:
            "Aby zrealizować Bon poproś klienta o podanie numeru <strong>Bonu oraz kodu autoryzacji płatności</strong>, który otrzyma SMS-em w momencie realizacji. Możesz również poprosić klienta o weryfikację bonu przed przyjazdem kontaktując się z klientem telefonicznie lub e-mailowo.",
        },
      },
      order_is_waiting_for_company_approval_customer_email: {
        marketplace: {
          company_approval_deadline:
            "Firma ma %{company_approval_time_limit} na odpowiedź. W większości z przypadków odpowiada jednak już w ciągu 1h w godzinach pracy biura.",
          order_is_waiting_for_company_approval:
            'Zamówienie nr %{order_id} na "%{product_name}" oczekuje teraz na potwierdzenie przez naszego Partnera %{company_name}.',
          thank_you_for_order: "dziękujemy za złożenie wstępnego zamówienia za pośrednictwem serwisu Tripsomnia.",
          thank_you_for_order_and_online_deposit:
            "dziękujemy za złożenie wstępnego zamówienia za pośrednictwem serwisu Tripsomnia oraz wykonanie %{confirmation_installment_st_name_d} online na kwotę %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "Jeśli zamówienie zostanie zaakceptowane, otrzymasz e-mail z potwierdzeniem wstępnego zamówienia wraz z linkiem do realizacji %{confirmation_installment_st_name_d} online w wysokości %{confirmation_installment_amount}. Od momentu potwierdzenia zamówienia przez Partnera, będziesz miał %{confirmation_installment_after_company_approval_time_limit} na zrealizowanie tego przelewu przez nasz system płatności online.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "W przypadku braku płatności, Twoje zamówienie zostanie automatycznie odrzucone.",
          what_with_no_deposit_if_order_gets_approved:
            "Jeśli zamówienie zostanie zaakceptowane, otrzymasz e-mail z potwierdzeniem zamówienia wraz z informacjami odnośnie płatności.",
          what_with_paid_deposit_if_order_gets_approved:
            "Jeśli zamówienie zostanie zaakceptowane, wpłacona kwota przejdzie na poczet zamówienia. Jeśli nasz partner będzie zmuszony odrzucić Twoje zamówienie lub nie potwierdzi go w wymaganym czasie, Twój depozyt zostanie automatycznie zwrócony na Twój rachunek bankowy w ciągu następnych 24 godzin. Możesz wysłać wtedy prośbę o zamówienie innej oferty.",
          thank_you_for_order_approval:
            "dziękujemy za potwierdzenie wstępnego zamówienia za pośrednictwem serwisu Tripsomnia",
        },
        saas: {
          company_approval_deadline:
            "Mamy %{company_approval_time_limit} na odpowiedź, ale zwykle odpowiadamy w ciągu 1h w godzinach pracy naszego biura.",
          order_is_waiting_for_company_approval:
            'Zamówienie nr %{order_id} na "%{product_name}" oczekuje obecnie na nasze potwierdzenie.',
          thank_you_for_order: "dziękujemy za złożenie wstępnego zamówienia.",
          thank_you_for_order_and_online_deposit:
            "dziękujemy za złożenie wstępnego zamówienia oraz wykonanie %{confirmation_installment_st_name_d} online na kwotę %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "W przypadku, gdy potwierdzimy Twoje wstępne zamówienie, otrzymasz e-mail wraz z linkiem do realizacji %{confirmation_installment_st_name_d} online w wysokości %{confirmation_installment_amount}. Masz %{confirmation_installment_after_company_approval_time_limit} od momentu potwierdzenia zamówienia na realizację płatności przez Dotpay.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "W przypadku braku płatności, Twoje zamówienie zostanie automatycznie odrzucone.",
          what_with_no_deposit_if_order_gets_approved:
            "W przypadku, gdy potwierdzimy Twoje wstępne zamówienie, otrzymasz e-mail z potwierdzeniem oraz informacjami odnośnie płatności.",
          what_with_paid_deposit_if_order_gets_approved:
            "Jeśli będziemy zmuszeni odrzucić Twoją prośbę lub pozwolimy jej wygasnąć, %{confirmation_installment_st_name} online zostanie automatycznie zwrócona na Twój rachunek bankowy w ciągu 24h. Możesz również skontaktować się z nami i wybrać inną ofertę.",
          thank_you_for_order_approval: "dziękujemy za potwierdzenie wstępnego zamówienia.",
        },
        subject: 'Zamówienie nr %{order_id} oczekuje na potwierdzenie ("%{product_name}")',
      },
      order_is_waiting_for_confirmation_online_payment_company_email: {
        line1:
          'Zamówienie nr %{order_id} na "%{product_name}" zostało potwierdzone i oczekuje obecnie na wpłatę przez Klienta %{confirmation_installment_transaction_amount} poprzez nasz system płatności online.',
        line2:
          "W przypadku braku realizacji płatności przez Klienta w ustalonym terminie płatności, zamówienie zostanie automatycznie anulowane.",
        subject: "Zamówienie nr %{order_id} oczekuje na płatność (klient: %{customer_full_name})",
      },
      order_is_waiting_for_confirmation_online_payment_customer_email: {
        after_company_approval_subject: "Zamówienie nr %{order_id} oczekuje na płatność (%{product_name})",
        default_subject: 'Zamówienie nr %{order_id} oczekuje na płatność ("%{product_name}")',
        marketplace: {
          deadline_warning: "W przypadku nie dokonania wpłaty, Twoje zamówienie zostanie automatycznie odrzucone.",
          order_approved: 'Otrzymaliśmy Twoje zamówienie wstępne nr %{order_id} na "%{product_name}".',
          pay_button: "Zapłać online",
          payment_deadline: "Termin płatności: %{pauses_at}",
          please_pay:
            "Prosimy o dokonanie płatności na kwotę %{confirmation_installment_transaction_amount} poprzez nasz bezpieczny system płatności online.",
        },
        saas: {
          deadline_warning: "W przypadku nie dokonania wpłaty, Twoje zamówienie zostanie automatycznie odrzucone.",
          order_approved: 'Otrzymaliśmy Twoje wstępne zamówienie nr %{order_id} na "%{product_name}".',
          pay_button: "Zapłać online",
          payment_deadline: "Termin płatności: %{pauses_at}",
          please_pay:
            "Prosimy o dokonanie płatności na kwotę %{confirmation_installment_transaction_amount} poprzez nasz bezpieczny system płatności online.",
        },
      },
      order_is_waiting_for_customer_approval_customer_email: {
        marketplace: {
          action: "Potwierdź zamówienie",
          approval_deadline: "",
          deadline_warning:
            "W przypadku nie potwierdzenia zamówienia, Twoje zamówienie zostanie automatycznie anulowane.",
          order_approved:
            'Firma %{company_name} przesyła szczegóły Twojego zamówienia nr %{order_id} na "%{product_name}".',
          please_approve: "Prosimy o potwierdzenie zamówienia poprzez link poniżej.",
          approve_action: "Potwierdź zamówienie",
          reject_action: "Odrzuć zamówienie",
        },
        saas: {
          action: "Potwierdź zamówienie",
          approval_deadline: "",
          deadline_warning:
            "W przypadku nie potwierdzenia zamówienia, Twoje zamówienie zostanie automatycznie anulowane.",
          order_approved: 'Zatwierdziliśmy Twoje zamówienie nr %{order_id} na "%{product_name}".',
          please_approve: "Prosimy o potwierdzenie zamówienia poprzez link poniżej.",
          approve_action: "Potwierdź zamówienie",
          reject_action: "Odrzuć zamówienie",
        },
        subject: 'Prosimy o potwierdzenie zamówienia nr %{order_id} ("%{product_name}")',
      },
      order_online_deposit_time_limit_exceeded_company_email: {
        line1:
          'Byliśmy zmuszeni odrzucić wstępne zamówienie nr %{order_id} od %{customer_full_name} na "%{product_name}" (%{stock_time_range}) w związku z nie wykonaniem przez Klienta płatności online w wymaganym terminie. Skontaktuj się z klientem w celu wyjaśnienia okoliczności i odzyskania klienta.',
        subject:
          "Zamówienie nr %{order_id} zostało odrzucone - Klient nie wpłacił %{confirmation_installment_st_name_d} w wymaganym terminie (klient: %{customer_full_name})",
      },
      order_online_deposit_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>Niestety byliśmy zmuszeni odrzucić Twoje zamówienie nr %{order_id} na "%{product_name}"</strong>, w związku z brakiem płatności za zamówienie w wymaganym terminie.',
          line2:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
          line3_html: "Jeżeli chciałbyś ponownie zamówić ofertę, przejdź do podstrony z ofertą: %{product_link}",
        },
        saas: {
          line1_html:
            '<strong>Niestety byliśmy zmuszeni odrzucić Twoje zamówienie nr %{order_id} na "%{product_name}" (%{stock_time_range})</strong>, w związku z brakiem płatności za zamówienie w wymaganym terminie.',
          line2:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
          line3_html: "Jeżeli chciałbyś ponownie zamówić ofertę, przejdź do podstrony z ofertą: %{product_link}",
        },
        subject:
          "Zamówienie nr %{order_id} zostało odrzucone - nie wpłaciłeś %{confirmation_installment_st_name_d} w wymaganym terminie",
      },
      order_online_payment_reminder_customer_email: {
        marketplace: {
          contact_us_if_problems: "Jeżeli masz jakiś problem z zamówieniem, skontaktuj się z nami.",
          line1:
            'do tej pory nie odnotowaliśmy płatności za Twoje wstępne zamówienie nr %{order_id} na "%{product_name}". Z powodu przekroczenia czasu na płatność, byliśmy zmuszeni je anulować. Możesz jednak dokonać zamówienia ponownie.',
          offer_details_below: "Poniżej szczegóły oferty:",
        },
        saas: {
          contact_us_if_problems: "Jeżeli masz jakiś problem z zamówieniem, skontaktuj się z nami.",
          line1:
            'do tej pory nie odnotowaliśmy płatności za Twoje wstępne zamówienie nr %{order_id} na "%{product_name}". Z powodu przekroczenia czasu na płatność, byliśmy zmuszeni je anulować. Możesz jednak dokonać zamówienia ponownie.',
          offer_details_below: "Poniżej szczegóły oferty:",
        },
        subject: 'Przypominamy o dokończeniu zamówienia na "%{product_name}"',
      },
      order_company_rejected_company_email: {
        line1: 'Odrzuciłeś wstępne zamówienie nr %{order_id} od %{customer_full_name} na "%{product_name}".',
        line2:
          "Jeżeli chcesz zmienić termin, limit sprzedaży lub inne ustawienia, prosimy o dokonanie aktualizacji w Panelu Partnera.",
        subject: "Zamówienie nr %{order_id} zostało odrzucone (klient: %{customer_full_name})",
        line1_html:
          'Odrzuciłeś wstępne zamówienie nr <a href="%{partnerapp_order_url}">%{order_id}</a> od %{customer_full_name} na "%{product_name}".',
      },
      order_company_rejected_customer_email: {
        marketplace: {
          line1:
            'Firma %{company_name} odrzuciła Twoje zamówienie nr %{order_id} na "%{product_name}" w związku z brakiem dostępności miejsc w terminie %{stock_time_range}.',
          see_offer_html: "Zobacz ofertę w innych terminach: %{product_link}",
          confirmation_installment_refund_info:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
        },
        saas: {
          line1:
            'Odrzuciliśmy Twoje zamówienie nr %{order_id} na "%{product_name}" w związku z brakiem dostępności miejsc w terminie %{stock_time_range}.',
          see_offer_html: "Zobacz ofertę w innych terminach: %{product_link}",
          confirmation_installment_refund_info:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
        },
        subject: 'Zamówienie nr %{order_id} na "%{product_name}" zostało odrzucone',
      },
      order_customer_rejected_company_email: {
        line1: 'Klient odrzucił wstępne zamówienie nr %{order_id} od %{customer_full_name} na "%{product_name}".',
        subject: "Zamówienie nr %{order_id} zostało odrzucone przez klienta (klient: %{customer_full_name})",
      },
      order_customer_rejected_customer_email: {
        marketplace: {
          line1: 'Twoje zamówienie nr %{order_id} na "%{product_name}" zostało odrzucone.',
          see_offer_html: "Zobacz ofertę jeszcze raz: %{product_link}",
          confirmation_installment_refund_info:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
        },
        saas: {
          line1: 'Twoje zamówienie nr %{order_id} na "%{product_name}" zostało odrzucone.',
          see_offer_html: "Zobacz ofertę jeszcze raz: %{product_link}",
          confirmation_installment_refund_info:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
        },
        subject: 'Zamówienie nr %{order_id} na "%{product_name}" zostało odrzucone',
      },
      order_current_status_company_email: {
        line1: "Przesyłamy Ci obecny status zamówienia.",
        subject: "Zamówienie nr %{order_id}, obecny status: %{status_i18n} (klient: %{customer_full_name})",
      },
      order_company_cancelled_company_email: {
        line1: 'Zamówienie nr %{order_id} od %{customer_full_name} na "%{product_name}" zostało anulowane.',
        subject: "Zamówienie nr %{order_id} zostało anulowane (klient: %{customer_full_name})",
        line1_html:
          'Zamówienie nr <a href="%{partnerapp_order_url}">%{order_id}</a> od %{customer_full_name} na "%{product_name}" zostało anulowane.',
      },
      order_company_cancelled_customer_email: {
        marketplace: {
          line1:
            'Firma %{company_name} anulowała Twoje zamówienie nr %{order_id} na "%{product_name}" w terminie %{stock_time_range}.',
          see_offer_html: "Zobacz ofertę w innych terminach: %{product_link}",
          confirmation_installment_refund_info:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
        },
        saas: {
          line1: 'Anulowaliśmy Twoje zamówienie nr %{order_id} na "%{product_name}" w terminie %{stock_time_range}.',
          see_offer_html: "Zobacz ofertę w innych terminach: %{product_link}",
          confirmation_installment_refund_info:
            "Otrzymaną wpłatę %{confirmation_installment_paid_amount} zwrócimy na Państwa konto w ciągu najbliższych 24 godzin.",
        },
        subject: 'Zamówienie nr %{order_id} na "%{product_name}" zostało anulowane',
      },
      order_abandonment_followup_customer_email: {
        see_product: "Zobacz ponownie: %{product_name}",
        find_other_products_in_this_location: "Znajdź inne oferty w podobnej lokalizacji:",
        line1: 'ostatnio oglądałeś ofertę "%{product_name}". Czy jesteś nią nadal zainteresowany?',
        subject: 'Zobacz propozycje podobne do "%{product_name}"',
        go_to_product: "Zobacz ofertę",
      },
    },
    papp: {
      components: {
        EditableBillRow: {
          placeholder: "Wpisz nazwę",
        },
        InstallmentFormSection: {
          exact_date_label: "Określona data",
          how: "Jak?",
          on_stock_starts_at_label: "w dniu rozpoczęcia oferty",
          paid_after_company_approval_label:
            "W przypadku terminów na potwierdzenie, wymagaj najpierw przedpłaty Klienta",
          remaining_amount: "Pozostała kwota",
          when: "Kiedy?",
          whole_amount: "Cała kwota",
          x_days_after_order_creation_label: "po wysłaniu zamówienia",
          x_days_after_order_full_approval_label: "po zatwierdzeniu zamówienia",
          x_days_after_previous_installment_label: "po poprzedniej racie",
          x_days_before_stock_starts_at_label: "przed rozpoczęciem oferty",
          how_much: "Ile?",
          to: "Do?",
        },
        InstallmentsListFormSection: {
          add_new: "Dodaj kolejną ratę",
        },
        LocationFormControl: {
          placeholder: "Podaj lokalizację",
        },
        MainView: {
          default_error_title: "Błąd połączenia z serwerem",
          error_date: "Data zdarzenia",
          error_description: "W razie powtarzajacego się problemu, napisz do nas na %{email}.",
          error_id: "Numer błędu",
          loading: "Ładowanie...",
          retry: "Spróbuj ponownie",
        },
        MultipleDateFormControl: {
          add_new: "Dodaj datę",
        },
        MultipleInputFormControl: {
          placeholder: "Dodaj kolejny wiersz",
        },
        MultipleTimeFormControl: {
          add_new: "Dodaj godzinę",
        },
        OrderSidebarPreview: {
          edit_slot: "Zmień termin",
          see_slot: "Zobacz termin",
        },
        PaginationNavigation: {
          out_of: "z",
        },
        PaymentProfileProductAttachmentFormSection: {
          active: "Aktywny",
          additional_fee: "Opłata",
          days_before_arrival_date_limit: "Wybrane daty",
          days_before_arrival_date_limit_label: "Z wyprzedzeniem",
          installment: "Rata",
          no_date_limit: "Zawsze",
        },
        ProductCustomerOrderFieldFormSection: {
          add_list_option: "Dodaj pozycję do listy",
          add_new: "Dodaj nowe pole",
          show_on_manifest: "Pokaż na manifeście",
          value_required: "Wartość wymagana",
          value_type: "Typ wartości",
        },
        ProductPricedOrderFieldFormSection: {
          add_list_option: "Dodaj pozycję do listy",
          ask_customer: "Pytaj klienta",
          different_currency_base_amount_note:
            "Opcje dodatkowe zdefiniowane w walucie innej niż Waluta Oferty zawsze liczone są poza kosztem podstawowym.",
          for_all_variants: "Dla wszystkich wariantów",
          remove: "Usuń opcję",
          show_on_manifest: "Pokaż na manifeście",
          value_type: "Typ wartości",
        },
        SlotsCalendar: {
          agenda: "Lista",
          allDay: "Cały dzień",
          availability_mode: "Dostępność",
          date: "Data",
          day: "Dzień",
          event: "Termin",
          month: "Miesiąc",
          next: "Następny",
          previous: "Poprzedni",
          price_mode: "Ceny",
          showMore: "%{count} więcej...",
          time: "Czas",
          today: "Dzisiaj",
          week: "Tydzień",
          slot_confirmed: "Termin potwierdzony",
        },
        TagsInputFormControl: {
          addition_label: "Dodaj:",
          no_results_message: "Brak wyników",
          placeholder: "Dodaj kolejny",
        },
        TypeaheadInputFormControl: {
          no_results_message: "Brak wyników",
          placeholder: "Wszystko",
        },
        SaleWindowRuleFormGroup: {
          sale_starts_at_label: "Otwarcie sprzedaży",
          sale_ends_at_label: "Zamknięcie sprzedaży",
          offset_label: "z wyprzedzeniem",
          from_date_label: "od daty",
          until_date_label: "do daty",
          before_slot_start: "przed terminem",
          resolved_preview: "Dla terminu %{slot} przypada %{resolved}.",
        },
        UsebyDateRangeFormGroup: {
          days_limit_label: "x dni",
          days_since_order_creation: "dni od daty zamówienia",
          ends_at_label: "do dnia",
          starts_at_and_ends_at_label: "w dniach",
          starts_at_label: "od dnia",
        },
        ProductsListItem: {
          preview_marketplace: "Pokaż",
          preview_saas: "WWW",
          new_order: "Rezerwuj",
          active_switch_label: "Aktywna",
          published_on_saas_switch_label: "WWW",
        },
        OrderedProductOrderFieldFormControl: {
          custom_location_name_placeholder: "Wpisz adres Klienta",
        },
        ProductsSelectControl: {
          blank_label: "Brak przypisanej oferty",
        },
      },
      order: {
        approve: "Potwierdź",
        cancel_order: "Anuluj zamówienie",
        confirm: "Złóż rezerwację",
        customer_name_placeholder: "Brak danych klienta",
        delete_order: "Usuń zamówienie",
        finish: "Zakończ",
        redeliver_customer_order_email: "Wyślij szczegóły zamówienia",
        reject: "Odrzuć",
        redeliver_supplier_order_email: "Wyślij szczegóły zamówienia do Dostawcy",
        finish_order: "Zakończ zamówienie",
        automatic_icon: "A",
        manual_icon: "R",
        no_stock_date: "Brak daty",
      },
      common: {
        search: "Szukaj...",
        no_results_message: "Nic nie znaleziono.",
        discard_changes_confirm_message: "Nie zapisałeś zmian. Czy na pewno chcesz wyjść z tej strony?",
        go_back: "Wróć",
        remove: "Usuń",
        save: "Zapisz",
        none: "brak",
        poland: "Polska",
        edit: "Edytuj",
        manage: "Zarządzaj",
        save_changes: "Zapisz zmiany",
        submit_success_message: "Zmiany zostały zapisane.",
        default_value: "Domyślnie: %{value}",
        attention: "Uwaga",
        no_name: "(brak nazwy)",
        close: "Zamknij",
        in_total: "Razem",
        filters_title: "Filtruj",
        form_validation_error_message: "Jedno z pól w formularzu jest wypełnione niepoprawnie.",
        cancel: "Anuluj",
        go_next: "Dalej",
        st_email: "kontakt@socialtravel.pl",
        st_phone_number: "+48 690 670 581",
        are_you_sure: "Czy jesteś pewien?",
        translations_locale: "Język wprowadzania danych",
        x_per_page: "%{count} na stronę",
        show_filters: "Pokaż filtry",
        hide_filters: "Ukryj filtry",
        download_csv: "Pobierz CSV",
        weekdayAbbreviations: ["Pon", "Wt", "Śr", "Czw", "Pt", "Sb", "Nd"],
      },
      agents: {
        AgentsListView: {
          title: "Agenci",
          add_new: "Zaproś agenta do współpracy",
          no_records_title: "Brak agentów",
          no_records_message: "Jeszcze nie zaproszono żadnego agenta do współpracy.",
          no_records_add_new_link: "Chcesz zaprosić pierwszego?",
        },
        EditAgentCooperationView: {
          default_pricing: "Stawki domyślne",
          activate_all: "Udostępnij wszystkie",
          remove_confirm_message: "Czy na pewno chcesz zerwać tę współpracę agencyjną?",
          title: "Współpraca agencyjna",
          title_with_company_name: "Współpraca agencyjna z %{company_name}",
          products: "Oferty",
          price_change: "Podwyżka / obniżka o",
          gross_price: "Cena brutto",
          net_price: "Cena netto",
          include_product_options_price: "wlicz cenę opcji dodatkowych",
          st_cooperation_hint: {
            p1: "Współpraca z Tripsomnia",
            p2: "Nie możesz edytować warunków współpracy z nami.",
            p3: "Jeśli chciałbyś dokonać jakichkolwiek zmian skontaktuj się z doradcą drogą mailową lub telefonicznie: %{email} /  %{tel}",
          },
        },
        NewAgentPrompt: {
          title: "Nowy agent",
          email_label: "Wpisz adres e-mail agenta",
          submit: "Zaproś do współpracy",
        },
        SuppliersListView: {
          title: "Dostawcy",
          no_records_title: "Brak dostawców",
          no_records_message: "Jeszcze nie otrzymano żadnego zaproszenia od innego dostawcy współpracy agencyjnej.",
          add_new: "Zaproś organizatora do współpracy",
        },
      },
      app: {
        App: {
          fetch_app_error_title: "Błąd podczas połączenia z serwerem",
        },
        ForbiddenView: {
          title: "Błąd 403",
          message: "Wstęp wzbroniony",
        },
        LeftBar: {
          dashboard: "Pulpit",
          calendar: "Kalendarz",
          orders: "Zamówienia",
          products: "Oferty",
          customers: "Klienci",
          agents: "Agenci",
          suppliers: "Dostawcy",
          finances: "Finanse",
          raports: "Raporty",
          settings: "Ustawienia",
          reviews: "Opinie",
          affiliate: "Finanse",
          accommodation: "Zakwaterowanie",
          connectly: "Connectly"
        },
        NotFoundView: {
          title: "Błąd 404",
          message: "Strona nieznaleziona",
        },
        requireAuth: {
          company_forbidden: "Nie masz dostępu do tej firmy (ID: %{company_id}).",
          no_companies_error_title: "Brak przydzielonych firm do Twojego konta użytkownika",
        },
        TopBar: {
          logout: "Wyloguj się",
          marketplace_homepage: "Tripsomania",
          new_order: "Rezerwuj",
          saas_homepage: "Twoja strona WWW",
          your_account: "Ustawienia użytkownika",
        },
      },
      auth: {
        LoginView: {
          send_confirmation_instructions_link: "Wyślij ponownie link aktywacyjny",
          send_reset_password_instructions_link: "Przypomnienie hasła",
          send_unlock_instructions_link: "Mam zablokowane konto",
          submit: "Zaloguj się",
          title: "Logowanie do panelu Tripsomnia",
        },
        ResetPasswordView: {
          submit: "Zmień hasło",
          title: "Wygeneruj nowe hasło",
        },
        SendResetPasswordInstructionsView: {
          email_help: "Prześlemy Ci na niego link pozwalający na wygenerowanie nowego hasła do Twojego konta.",
          email_label: "Twój adres e-mail",
          submit: "Wyślij",
          success_message:
            "Wysłaliśmy Ci wiadomość z linkiem do wygenerowania nowego hasła. Sprawdź swoją skrzynkę odbiorczą.",
          title: "Przypomnienie hasła",
        },
        index: {
          fetch_user_failed_message: "Twoje dane logowania wygasły. Zaloguj się ponownie.",
        },
      },
      calendar: {
        CalendarView: {
          all_products: "Wszystkie oferty",
          all_suppliers: "Wszyscy dostawcy",
          title: "Kalendarz rezerwacji",
          filter_all: "Wszystkie",
          filter_available: "Dostępne",
          filter_awaiting: "Oczekujące",
          filter_booked: "Zarezerwowane",
          show_inactive_offers: "Pokaż nieaktywne oferty",
        },
        ShowSlotModal: {
          active_orders_title: "Aktywne zamówienia",
          build_order: "Rezerwuj",
          no_orders_message: "Brak zamówień na ten termin.",
          open_manifest: "Zobacz manifest",
          open_manifest_failure_message: "Błąd podczas pobierania manifestu.",
          other_orders_title: "Pozostałe zamówienia",
          download_manifest: "Pobierz manifest",
          booked_orders_title: "Zarezerwowane",
          pending_orders_title: "Oczekujące",
          awaiting_orders_title: "Oczekujące",
          sale_window_title: "Okno sprzedaży",
          sale_starts_at_label: "Otwarcie sprzedaży",
          sale_ends_at_label: "Zamknięcie sprzedaży",
          within_sale_window_yes: "Aktualnie sprzedawalny",
          within_sale_window_no: "Poza oknem sprzedaży",
          within_sale_window_past: "Termin już minął",
          biledo_block_title: "Powiązanie z Biledo",
          biledo_term_uuid: "Term UUID",
          biledo_pricelist_uuid: "Pricelist UUID",
          biledo_overwrite_warning:
            "Twoja zmiana zostanie nadpisana przy najbliższej synchronizacji z Biledo.",
        },
      },
      customers: {
        CustomersListView: {
          no_records_add_new_link: "Chcesz dodać?",
          no_records_message: "Jeszcze nie stworzono żadnego klienta.",
          no_records_title: "Brak klientów",
          title: "Klienci",
          query_filter: "Nazwisko, e-mail lub telefon",
          add_new_customer: "Nowy klient",
        },
        EditCustomerModal: {
          existing_customer_title: "Edycja klienta",
          new_customer_title: "Nowy klient",
          remove_confirm_message: "Czy na pewno chcesz usunąć tego klienta?",
        },
        ShowCustomerView: {
          no_name: "(brak nazwy)",
          orders_title: "Zamówienia",
          title: "Klient",
        },
      },
      dashboard: {
        DashboardView: {
          created_orders_number_label: "Liczba stworzonych zamówień",
          finished_orders_number_label: "zakończonych zamówień",
          finished_orders_total_amount_label: "kwota zakończonych zamówień",
          new_orders_title: "Nowe zamówienia (ostatnie 30 dni)",
          no_graph_data_message: "Brak danych do wyświetlenia statystyk.",
          no_orders_waiting_message: "Brak zamówień do potwierdzenia.",
          orders_number_label: "zamówień",
          orders_waiting_for_your_approval_title: "Zamówienia oczekujące na potwierdzenie",
          participants_number_label: "uczestników",
          see_all_orders: "Zobacz wszystkie (%{count})",
          title: "Pulpit",
          hint: {
            p1: "Zacznij sprzedawać swoje oferty",
            p2: "Uzupełnij ustawienia konta użytkownika i firmy.",
            p3: "Dodaj oferty: opis, ustawienia cen i rezerwacji, a następnie terminy.",
            p4: "Utwórz i wstaw widgety na swoją stronę www.",
            p5: "Zbieraj zamówienia online od klientów lub sam je dodawaj w panelu.",
            p6: "W razie pytań i wątpliwości prosimy o kontakt przez czat, telefonicznie %{tel} lub poprzez e-mail %{email}.",
            p2_html:
              'Uzupełnij ustawienia konta swojej firmy, wybierając zakładkę <a href="https://panel.tripsomnia.com/c/100/settings/company/account" target="_blank">Dane firmy</a>.',
            p3_html:
              'Zweryfikuj swoje konto w systemie płatności internetowych w podzakładce <a href="https://panel.tripsomnia.com/c/100/settings/company/stripe" target="_blank">Rejestracja płatności</a>',
            p4_html:
              'Dodaj oferty, wybierając sekcję <a href="https://panel.tripsomnia.com/c/100/products" target="_blank">Oferty</a>, widoczną po lewej stronie ekranu. Więcej informacji dotyczących tego, jak poprawnie dodać ofertę znajdziesz w <a href="http://partners.tripsomnia.com/183/tworzenie-ofert-wycieczek-i-atrakcji/" target="_blank">bazie wiedzy</a>.',
            p7: "W razie pytań i wątpliwości prosimy o kontakt przez czat, telefonicznie %{tel} lub poprzez e-mail %{email}.",
            p6_html:
              'Dowiedz się więcej na temat Panelu Partnera i skorzystaj z jego zaawansowanych funkcji, aby jak najefektywniej sprzedawać swoje oferty, czytając naszą <a href="http://partners.tripsomnia.com/category/panel-partnera/" target="_blank">bazę wiedzy</a>.',
          },
          stats_title: "Statystyki (%{date_from} - %{date_to})",
        },
      },
      finances: {
        FinancesListView: {
          no_records_message: "Jeszcze nie dodano żadnego zamówienia.",
          no_records_title: "Brak zamówień",
          title: "Finanse",
          summary_row: "Łącznie (dla wierszy %{start}-%{end}):",
          create_agent_disbursement: "Rozlicz z Agentem",
          create_platform_disbursement: "Rozlicz z Tripsomnią",
          agent_received_paid_th: "Agent dostał / oddał",
          socialtravel_received_paid_th: "Tripsomnia pobrała / oddała",
          supplier_received_paid_th: "Dostawca dostał / oddał",
          orders_count: "%{count} zamówień",
        },
      },
      settings: {
        SettingsLayout: {
          title: "Ustawienia",
          user: "Użytkownik",
          user_account_settings: "Ustawienia użytkownika",
          company: "Firma",
          company_account_settings: "Dane firmy",
          company_members_settings: "Uprawnienia użytkowników",
          products_settings: "Ust. ofert",
          payments_settings: "Ust. płatności",
          billing_settings: "Dane do faktury",
          integrations: "Integracje",
          marketplace_settings: "Marketplace Tripsomnia",
          saas_settings: "Twoja strona WWW",
          widgets_settings: "Widgety",
          readonly_access_message:
            "Nie masz dostępu do aktualizacji tych danych. By je zmodyfikować, zaloguj się na administratora Firmy.",
          stripe: "Rejestracja płatności",
        },
        BillingSettingsView: {
          title: "Dane firmy",
          invoice_company_name_placeholder: "Domyślnie: Nazwa firmy (%{default_value})",
          invoice_contact_email_placeholder: "Domyślnie: Adres e-mail firmy (%{default_value})",
          invoice_contact_phone_number_placeholder: "Domyślnie: Telefon kontaktowy firmy (%{default_value})",
          invoice_details_title: "Dane do faktury",
          hint: {
            p1: "Dane do rozliczeń",
            p2: "Podaj dane firmowe, na podstawie których będziemy wystawiać faktury.",
          },
        },
        CompanyMembersView: {
          title: "Użytkownicy",
          new_member: "Dodaj użytkownika",
          no_members: "Brak użytkowników",
          hint: {
            p1: "Dodawanie użytkowników",
            p2: "Przyznaj dostęp do Twojej firmy innym osobom. Dla nowego konta możesz nadać uprawnienia administratora lub pracownika (ograniczony dostęp).",
          },
        },
        CompanySettingsView: {
          title: "Dane firmy",
          contact_details: "Dane kontaktowe dla Twoich klientów",
          contact_phone_number_placeholder: "np. +48 690 670 581",
          notifications_details: "Dane do obsługi zamówień",
          notifications_email_placeholder: "Domyślnie: Adres e-mail firmy (%{default_value})",
          notifications_email_label: "Adres do potwierdzania zamówień",
          notifications_phone_number_placeholder: "Domyślnie: Telefon kontaktowy firmy (%{default_value})",
          notifications_phone_number_label: "Komórkowy z nr kierunkowym kraju",
          other_details: "Pozostałe ustawienia",
          hint: {
            p1: "Nazwa",
            p2: "Krótka nazwa do komunikacji w Panelu Partnera.",
            p3: "Zdjęcie profilowe",
            p4: "Widoczne w Panelu Partnera oraz dla klientów. Najlepiej wstawić logo firmy.",
            p5: "Dane kontaktowe",
            p6: "Wyświetlą się klientowi w potwierdzeniu zamówienia.",
            p7: "Dane do obsługi zamówień",
            p8: "Na podany adres e-mail będą wysyłane powiadomienia i zapytania o zamówienia do potwierdzenia.",
            p9: "Język główny",
            p10: "W tym języku nasz system będzie się komunikował z Twoją firmą przez e-mail.",
            p11: "Strefa czasowa",
            p12: "W tej strefie czasowej będziesz wprowadzał terminy swoich ofert w Panelu. Jeśli zmienisz te ustawienie nie wpłynie to na dodane już terminy.",
          },
        },
        MarketplaceSettingsView: {
          title: "Marketplace Tripsomnia",
          marketplace_homepage_url_label: "Adres Twojej firmy na marketplace",
          hint: {
            p1: "Profil Twojej firmy na Tripsomnia",
            p2: "Te informacje pokażą się klientom na podstronie Twojej firmy w naszej platformie sprzedażowej Tripsomnia.",
          },
        },
        PaymentsSettingsView: {
          title: "Ustawienia płatności",
          your_profiles_title: "Profile płatności na Twojej stronie WWW",
          marketplace_profiles_title: "Profile płatności w Marketplace Tripsomnia i kanałach afiliacyjnych",
          add_new_profile: "Dodaj nowy profil",
          hint: {
            p1: "Domyślna waluta ofert",
            p2: "Wybierz domyślną walutę, aby ułatwić sobie konfigurowanie ofert.",
            p3: "Dane konta bankowego",
            p4: "Informacje, które podasz w tym okienku zostaną wysłane do klientów, którzy zarezerwowali ofertę z profilem płatności na konto bankowe.",
            p5: "Profile płatności na Twojej stronie WWW",
            p6: "Edytuj i dodawaj profile płatności dla klientów Twojej firmy.",
            p7: "Profile płatności w Marketplace Tripsomnia i kanałach afiliacyjnych",
            p8: "Te profile płatności są proponowane przez nas w ramach naszej współpracy. W celu edycji tych profilów skontaktuj się z Twoim doradcą.",
          },
          no_your_profiles_warning:
            "Aktywuj lub dodaj przynajmniej jeden profil płatności dla Twojej strony WWW, aby umożliwić składanie zamówień.",
          enable_for_all_product_variants: "Włącz dla wszystkich ofert",
          access_possible_only_for_supplier:
            "Zarządzanie profilami płatności jest możliwe tylko, jeśli jesteś dostawcą ofert. Skonsultuj się z dostawcami swoich ofert, by dowiedzieć się, jakie profile płatności są możliwe dla zamówień z ich ofertami.",
          increase_orders_amount_by_saas_commision_label: "Dodaj opłatę za obsługę do całkowitej kwoty zamówienia",
          increase_orders_amount_by_saas_commision_enabled_hint: "Klient poniesie koszt obsługi zamówienia",
          increase_orders_amount_by_saas_commision_disabled_hint: "Firma poniesie koszt obsługi zamówienia",
        },
        ProductsSettingsView: {
          title: "Ustawienia ofert",
          hint: {
            p1: "Regulamin",
            p2: "Wstaw w tym miejscu tekst regulaminu, który klienci będą musieli zaakceptować dokonując rezerwacji Twoich ofert.",
            p3: "Mobilny voucher",
            p4: "Zaznacz, czy wymagasz wydrukowania przez klientó potwierdzenie / vouchera. Jeśli tego nie zaznaczysz klienci będą mogli pokazać zamówienie na swoim smartfonie.",
          },
        },
        SaasSettingsView: {
          title: "Twoja strona WWW",
          saas_homepage_url: "Adres Twojej strony WWW",
          contact_us_if_want_to_change: "Skontaktuj się z nami, jeśli chciałbyś ją zmienić.",
          hint: {
            p1: "Twoja strona WWW",
            p2: "Te informacje pokażą się klientom na Twojej dedykowanej stronie WWW.",
          },
        },
        UserAccountView: {
          title: "Ustawienia użytkownika",
          site_settings_title: "Ustawienia konta",
          password_change_title: "Zmiana hasła",
          hint: {
            p1: "Ustawienia konta użytkownika",
            p2: "Ustawienia te mają wpływ jedynie w obszarze Twojego konta użytkownika. Nie mają wpływu na główne ustawienia firmy.",
          },
        },
        WidgetsSettingsView: {
          title: "Widgety",
          iframe: "IFrame",
          button: "Przycisk",
          navbar: "Belka",
          detect_from_visitor_browser: "Z przeglądarki użytkownika",
          locale: "Język strony",
          currency: "Waluta klienta",
          bubble: "Bubble",
          active: "Opublikuj",
          scrollWidget: "Aktywuj widget pop-up po przewinięciu do końca strony",
          exitWidget: "Aktywuj widget pop-up przy próbie opuszczenia strony przez klienta",
        },
        ButtonWidgetView: {
          book_now: "Rezerwuj teraz",
          small_size: "mały",
          normal_size: "średni",
          large_size: "duży",
          bottom_right: "prawy dolny róg",
          bottom_left: "lewy dolny róg",
          top_right: "prawy górny róg",
          top_left: "lewy górny róg",
          in_modal: "w modalu",
          in_new_tab: "w nowym oknie",
          title: "Przycisk",
          button_content: "Treść przycisku",
          open: "Otwórz",
          color: "Kolor",
          size: "Rozmiar",
          stick_to_window_corner: "Pozycja",
          generate_code: "Zapisz",
          place_code_anywhere:
            "Umieść ten kod w dowolnym miejscu strony. Proponujemy umieścić go na początku, tuż przed %{head}, lub pod jej koniec, tuż przed %{body_end}.",
          put_widget_anywhere:
            "Jeśli nie chcesz wybierać domyślnych pozycji widgetu na stronie, wklej poniższy kod w wybrane przez Ciebie miejsce.",
          preview: "Podgląd",
          button_type: "Zwykły przycisk",
          flag_type: "Flaga",
          what_type: "Rodzaj przycisku",
          center_right: "prawy środek",
          center_left: "lewy środek",
        },
        NavBarWidgetView: {
          new_link: "Dodaj element",
          our_products: "Nasza oferta",
          products_calendar: "Kalendarz terminów",
          book: "Rezerwuj",
          white_blue: "biały z niebieskim akcentem",
          white_teal: "biały z morskim akcentem",
          white_orange: "biały z pomarańczowym akcentem",
          black_blue: "czarny z niebieskim akcentem",
          black_teal: "czarny z morskim akcentem",
          black_orange: "czarny z pomarańczowym akcentem",
          blue: "niebieski",
          teal: "morski",
          orange: "pomarańczowy",
          to_window_bottom: "do dołu strony",
          to_window_top: "do góry strony",
          in_modal: "w modalu",
          in_new_tab: "w nowym oknie",
          none: "Brak",
          company_name: "Nazwa firmy",
          company_logo: "Logo firmy",
          title: "Belka",
          show_company_name: "Wyświetl nazwę firmy",
          show_toggle_button: 'Wyświetl przycisk "Zwiń" / "Rozwiń"',
          open: "Otwórz",
          color: "Kolor",
          stick: "Pozycja",
          cta_button: "Przycisk główny",
          navigation: "Zakładki",
          contact: "Kontakt",
          generate_code: "Zapisz",
          place_code_anywhere:
            "Umieść ten kod w dowolnym miejscu strony. Proponujemy umieścić go na początku, tuż przed %{head}, lub pod jej koniec, tuż przed %{body_end}.",
          put_widget_anywhere: "Następnie umieść interesujący Cię widget w wybranym przez Ciebie miejscu.",
          preview: "Podgląd",
          link_type_link: "Link",
          link_type_none: "Brak",
          link_type_text: "Tekst",
          link_type_phone: "Telefon",
          link_type_email: "E-mail",
          link_type_custom_link: "Własny link",
          black: "czarny",
          white: "biały",
          green: "zielony",
          type1: "Typ 1",
          type2: "Typ 2",
          type3: "Typ 3",
          red: "czerwony",
          percentage: "procent",
          activity: "oferta",
          cart: "koszyk",
          notification: "powiadomienie",
          offer: "zniżka",
          search: "wyszukiwarka",
          star: "gwiazdka",
          negotiate: "negocjacje",
          discount: "zniżka",
          chat: "czat"
        },
        IframeWidgetView: {
          title: "IFrame",
          iframe_width: "Szerokość Iframe'a",
          iframe_height: "Wysokość Iframe'a",
          generate_code: "Wygeneruj kod",
          put_widget_anywhere: "Skopiuj i wklej poniższy kod w wybranym przez Ciebie miejscu na Twojej stronie.",
          preview: "Podgląd",
        },
        WidgetRouteFormSection: {
          homepage_page: "Strona główna",
          products_list_page: "Listing ofert",
          products_calendar_page: "Kalendarz terminów",
          product_page: "Podstrona oferty",
          new_order_page: "Formularz rezerwacyjny oferty",
          on_slot_click_show_product: "Podstronę oferty",
          on_slot_click_new_order: "Formularz rezerwacyjny na dany termin",
          type: "Typ",
          product: "Oferta",
          all_products: "Wszystkie oferty",
          on_slot_click_action_type: "Kliknięcie na termin otworzy",
          reviews_page: "Strona z opiniami",
          product_location_tag: "Lokalizacja",
          product_location_tag_page: "Strona lokalizacji",
          product_category_tag: "Strona kategorii",
          product_category_tag_page: "Strona kategorii",
          coupons_page: "Listing kuponów",
        },
        EditPaymentProfileModal: {
          profile_change_affects_all_products_warning:
            "Pamiętaj, że wszelkie zmiany jakie tu wprowadzisz mają wpływ na wszystkie oferty wszystkich firm, do których jest obecnie przypisany ten profil płatności.",
          remove_confirm_message: "Czy na pewno chcesz usunąć ten profil płatności?",
          edit_profile_title: "Edytuj profil płatności",
          new_profile_title: "Nowy profil płatności",
          name_label: "Nazwa profilu",
          name_hint:
            "Zostanie wyświetlona klientowi podczas składania zamówienia, jeśli będzie miał do wyboru więcej niż jeden profil.",
          has_additional_fee_label: "Dodatkowa opłata",
          cancellation_policy_hint:
            "Do kiedy zamówienie może zostać anulowane? Do jakiej kwoty może ubiegać się klient o zwrot?",
          installments_label: "Raty płatności",
          additional_fee_as_agent_fee_label: "Dolicz jako opłatę serwisową Agenta",
        },
        EditCompanyMemberModal: {
          edit_member_title: "Edytuj użytkownika",
          new_member_title: "Dodaj użytkownika",
          remind_password: "Przypomnij hasło",
        },
        BubbleWidgetView: {
          balloon_line1_value: "Nasze oferty",
          balloon_line2_value: "Kliknij tu by je zdobyć!",
          balloon_line1_label: "Pierwsza linijka tekstu",
          balloon_line2_label: "Druga linijka tekstu",
          generate_code: "Zapisz",
          large_size: "duży",
          normal_size: "średni",
          place_code_anywhere:
            "Umieść ten kod w dowolnym miejscu strony. Proponujemy umieścić go na początku, tuż przed %{head}, lub pod jej koniec, tuż przed %{body_end}.",
          placement: "Pozycja",
          preview: "Podgląd",
          put_widget_anywhere: "Następnie umieść interesujący Cię widget w wybranym przez Ciebie miejscu.",
          small_size: "mały",
          title: "Bubble",
          bottom_left_corner: "lewy dolny róg",
          bottom_right_corner: "prawy dolny róg",
          color_label: "Kolor",
          placement_label: "Pozycja",
          size_label: "Rozmiar",
          top_left_corner: "lewy górny róg",
          top_right_corner: "prawy górny róg",
          show_after_label: "Pokaż widget po",
          show_balloon_after_label: "Pokaż tekst po",
          play_sound_label: "Odtwarzaj dźwięk",
          animation_type: "Animacja",
          icon: "Ikonka",
        },
        IndexWidgetsView: {
          header1: "Instrukcja instalacji widgetów",
          header2: "Starsze widgety",
          text1:
            "Zapraszamy do skorzystania z naszych widgetów na Twojej stronie www. Aby rozpocząć wystarczy, że umieścisz jednokrotnie poniższy kod w dowolnym miejscu strony. Proponujemy umieścić go na początku, tuż przed </head>, lub pod jej koniec, tuż przed </body></html>.",
          text2:
            "Następnie możesz przejść do edycji widgetów Bubble lub Button, wybrać odpowiednie ustawienia, aktywować wybrany widget i od razu oglądać efekt na Twojej stronie www.",
          text3:
            "Miło nam poinformować, że od 1 marca 2019 wprowadziliśmy zmiany w naszych widgetach. Stare widgety i ich kody pozostaną aktywne i będą zawsze działać, ale rekomendujemy przejście na korzystanie z nowej, ulepszonej wersji widgetów.",
          text4:
            "O tym, dlaczego warto zacząć korzystać z nowych widgetów można przeczytać powyżej. W celu zamiany należy wykasować stare kody i dalej postępować wg instrukcji dla nowych widgetów. W razie jakichkolwiek wątpliwości prosimy o kontakt pod adresem info@tripsomnia.com",
          widgetCodeHasBeenCopied: "Kod widgetu został pomyślnie skopiowany!",
          widgetCodeHasnBeenCopied: "Skopiuj kod widgetu",
          copyWidgetCode: "Skopiuj kod widgetu",
        },
        StripeSettingsView: {
          title: "Rejestracja płatności - Stripe",
          stripe_verification_failure: "Niestety, Twoja próba rejestracji w Stripe zakończyła się niepowodzeniem.",
          stripe_verification:
            "Kliknij poniższy link, aby zalogować się do panelu Stripe i podejrzeć swoje ustawienia, bilans konta oraz historię wypłat. Możesz również zaktualizować swoje dane. Będziesz w tym celu potrzebować telefonu podanego przy rejestracji, aby zweryfikować swoją tożsamość.",
          stripe_verification_success: "Rejestracja w STRIPE zakończyła się powodzeniem.",
          line1_html:
            "Dbając o najwyższe standardy bezpieczeństwa transakcji internetowych Tripsomnia.com współpracuje z globalnym dostawcą usług płatności Stripe, działającym w strategicznym partnerstwie z Przelewy24. Weryfikacja w Stripe jest <strong>niezbędna</strong> aby przyjmować od klientów bezpieczne płatności online ze wszystkich kanałów sprzedaży (portale wojewódzkie, miejskie, Tripsomnia, strony internetowe innych przedsiębiorców) oraz automatycznie rozliczać zamówienia po ich zakończeniu przelewając środki na Państwa konto bankowe.",
          line2_html:
            "Rozpoczynając weryfikację zostaną Państwo przekierowani bezpośrednio do formularza Stripe, którego wypełnienie powinno potrwać <strong>mniej niż 10 min</strong>",
          line4_html:
            "Podczas procesu rejestracji prosimy o podawanie tylko <strong>prawdziwych danych</strong> - skróci to proces weryfikacji!",
          line3: "Aby zarejestrować się w Stripe potrzebujesz:",
          line3_1: "Adresu mailowego",
          line3_2: "Numeru telefonu, na który przyjdzie kod weryfikacyjny SMS",
          line3_3: "Dokumentu tożsamości (dowód osobisty, prawo jazdy)",
          line3_4: "Danych Twojej firmy",
          line5_html:
            "Formularz Stripe będzie prosił Państwa także o podanie witryny internetowej Państwa firmy. <strong>Jeżeli nie posiadają Państwo własnej domeny, prosimy o wpisanie: tripsomnia.com</strong>",
          line6_html:
            'Więcej informacji dotyczących tego, jak poprawnie zarejestrować się w Stripe znajdziesz <a href="/pdf/instrukcja-rejestracji-konta-stripe.pdf" target="_blank">tutaj</a>.',
          line7:
            "W razie pytań bądź problemów technicznych nasz zespół pozostaje do Państwa dyspozycji pod numerem telefonu:  +48 512 154 254, info@tripsomnia.com lub na czacie.",
          line1:
            "Dbając o najwyższe standardy bezpieczeństwa transakcji internetowych Tripsomnia.com współpracuje z globalnym dostawcą usług płatności Stripe, działającym w strategicznym partnerstwie z Przelewy24. Weryfikacja w Stripe jest niezbędna, aby przyjmować od klientów bezpieczne płatności online ze wszystkich kanałów sprzedaży (portale wojewódzkie, miejskie, Tripsomnia, strony internetowe innych przedsiębiorców) oraz automatycznie rozliczać zamówienia po ich zakończeniu przelewając środki na Państwa konto bankowe.",
          line2:
            "Rozpoczynając weryfikację zostaną Państwo przekierowani bezpośrednio do formularza Stripe, którego wypełnienie powinno potrwać mniej niż 10 min.",
        },
      },
      orders: {
        AddOrderTransferModal: {
          default_title: "Nowa wpłata / zwrot",
          new_refund_title: "Nowy zwrot",
          new_transfer_title: "Nowa wpłata",
        },
        ChangeOrderScheduleSlotModal: {
          title: "Zmiana terminu zamówienia",
        },
        EditOrderCustomerDetailsModal: {
          title: "Dane zamówienia",
          customer_details: "Dane zamawiającego",
        },
        EditOrderInstallmentsModal: {
          title: "Raty płatności zamówienia",
        },
        EditOrderItemsModal: {
          title: "Rachunek zamówienia",
          changed_order_item_name: "Zmiana: %{item_name}",
          changed_order_option_name: 'Zmiana opcji z "%{prev_item_name}" na "%{next_item_name}"',
          removed_order_option_name: 'Usunięcie opcji "%{prev_item_name}"',
          added_order_option_name: 'Dodanie opcji "%{next_item_name}"',
          order_items_title: "Rachunek",
          order_item_index: "Pozycja",
          order_item_unit_price: "Cena szt.",
          order_item_quantity: "Ilość",
          order_item_total_price: "Razem",
          add_new_order_item: "Dodaj nową pozycję",
          extra_participants_existing:
            "Liczba uczestników przypisanych do zamówienia przewyższa liczbę osób wybranych na rachunku. Usuń je z zamówienia, klikając na krzyżyk przy wybranej osobie.",
          installments_require_manual_change_warning:
            "Pamiętaj, że kwoty zaliczek nie zostaną zaktualizowane automatycznie. Jeśli chcesz zmienić kwoty rat płatności, musisz zrobić to ręcznie zmieniając profil płatności tego zamówienia po zmianie jego rachunku.",
        },
        NewOrderItemsForm: {
          select_agent: "Wybierz agenta",
          reset_agent_commision: "Zresetuj",
          product_options: "Opcje dodatkowe",
          other_order_items: "Pozostałe",
          add_new_order_item: "Dodaj nową pozycję",
        },
        NewOrderPaymentsForm: {
          accept_deposit: "Przyjmij płatność teraz",
          plan_payments: "Zaplanuj płatność",
          no_payments: "Nie teraz (zapisz szkic)",
          deposit_accepted_as_agent: "(płatność zostanie oznaczona jako przyjęta przez Agenta)",
          deposit_accepted_as_supplier: "(płatność zostanie oznaczona jako przyjęta przez Dostawcę)",
          only_deposit_now: "Teraz tylko depozyt",
          rest_payment: "Dopłata reszty",
          order_status: "Status zamówienia",
          notify_customer: "Wyślij powiadomienie do Klienta",
          notify_customer_impossible_no_customer_email_given:
            "Brak adresu e-mail Klienta, wysłanie powiadomienia jest niemożliwe.",
          note_placeholder: "Dodaj notatkę",
          choose_payments_mode: "Wybierz tryb płatności / zapłaty przy klienta.",
          choose_payments_mode_error: "Wybierz sposób, w jaki klient zapłaci za to zamówienie.",
          order_status_message: "Po zapisaniu zamówienia jego status zostanie ustawiony na: ",
        },
        NewOrderProductModal: {
          no_products_found: "Nie znaleziono żadnych ofert.",
          static_date_booking_label: "Zamówienie na określony termin.",
          with_custom_product_title: "Rezerwacja niestandardowa (bez oferty)",
          choose_product_variant: "Wybierz wariant oferty",
          default_title: "Nowe zamówienie",
          search_products: "Szukaj oferty",
          use_custom_product_button: "Rezerwacja niestandardowa (bez oferty)",
          info1:
            "Możesz stworzyć rezerwację na życzenie klienta i wysłać mu link do jej opłacenia online. Rezerwacja nie będzie powiązana z żadną istniejącą ofertą. Podaj nazwę rezerwacji, która będzie informowała klienta o tym co zamówił. Opcjonalnie dodaj tyle szczegółów zamówienia ile uważasz za potrzebne: cena zawiera, nie zawiera itp.",
          order_name: "Nazwa rezerwacji",
        },
        NewOrderModal: {
          confirm_abandon_message: "Czy na pewno chcesz wyjść bez zapisywania (utracisz wszystkie wprowadzone dane)?",
          confirm_abandon_cancel: "Nie, wróć do zamówienia",
          confirm_abandon_ok: "Tak, porzuć zamówienie",
          schedule_step_title: "Wybierz termin",
          order_items_step_title: "Dobierz rachunek zamówienia",
          customer_details_step_title: "Uzupełnij dane klienta",
          payments_step_title: "Płatność",
          abandon_failed_message:
            "Nie mogliśmy porzucić Twojego zamówienia. Prawdopodobnie zostało ono dalej w bazie danych. Jeśli chcesz je anulować, przejdź do podstrony zamówienia i usuń je ręcznie.",
          payments_step_profiles_instruction: "Wybierz metodę płatności",
          payments_step_choose_payments: "Wybierz sposób płatności online",
          payments_step_choose_payments_reseller: "Zapłać teraz przez STRIPE",
          payments_step_choose_payments_customer: "Wyślij link do płatności",
          payments_step_choose_payments_reseller_hint1:
            "Wybierz tę opcję i kliknij zapisz, aby przenieść się teraz do płatności online i zapłacić za zamówienie.",
          payments_step_choose_payments_reseller_hint2: "",
          payments_step_choose_payments_customer_hint1:
            "Wybierz tę opcję i kliknij zapisz, aby wysłać klientowi e-mail z linkiem do płatności. Wymagane jest podanie adresu e-mail klienta w poprzednim kroku.",
          payments_step_choose_payments_customer_hint2: "",
          payments_step_prebook: "Zarezerwuj",
          payments_step_choose_payments_terminal_hint1:
            "Wprowadź na terminalu płatności Tripsomnia kwotę zamówienia i przyjmij płatność od klienta.",
          payments_step_choose_payments_terminal_hint2:
            "Jeżeli płatność została przyjęta pomyślnie, zapisz zamówienie, aby dokończyć rezerwację. Zamówienie zostanie złożone, a klient dostanie potwierdzenie e-mailem.",
          payments_step_choose_payments_terminal: "Płatność 100% przez terminal Tripsomnia.",
        },
        OrderScheduleForm: {
          select_existing_slot: "Wybierz istniejący termin",
          upcoming_slots: "Najbliższe terminy",
          no_slots_found: "Nie znaleziono wolnych terminów dla tej oferty.",
          all_day: "[Cały dzień]",
          add_new_slot: "Dodaj termin",
        },
        OrdersListView: {
          title: "Zamówienia",
          add_new_order: "Nowe zamówienie",
          no_orders_title: "Brak zamówień",
          no_orders_message: "Jeszcze nie dodano żadnego zamówienia.",
          no_orders_add_new_button: "Chcesz stworzyć?",
          customer_query_filter: "Nazwisko, e-mail lub telefon",
          other_filters: "Inne",
          marketplace_filter: "Marketplace",
          saas_filter: "SaaS",
          manual_filter: "Ręczne",
          automatic_filter: "Automatyczne",
          requires_company_approval_filter: "Wymaga potwierdzenia Firmy",
          doesnt_require_company_approval_filter: "Nie wymaga potwierdzenia Firmy",
          no_booking_filter: "Bez rezerwacji",
          static_date_booking_filter: "Z rezerwacją",
          total_amount_currencies_filter: "Waluta",
          customer_payment_methods_filter: "Metoda płatności",
          with_agent_commision_filter: "Z prowizją Agenta",
          with_agent_service_fee_filter: "Z opł. serwisową Agenta",
          with_both_agent_commision_and_service_fee_filter: "Z prowizją oraz opł. serwisową Agenta",
          with_saas_commision_filter: "Z prowizją systemową",
          customer_transfer_date_filter: "Data płatności",
          without_agent_commision_and_service_fee_filter: "Bez prowizji i opłaty serwisowej Agenta",
          notes_filter: "Notatki",
          with_notes_filter: "Z notatką",
          notes_filter_placeholder: "Szukaj treści notatki",
          with_affiliate_filter: "Z Afiliantem",
          with_agent_filter: "Z Agentem",
          with_agent: "Z Agentem",
          static_date_range_booking_filter: "Nocleg",
        },
        ChangeOrderStatusPrompt: {
          title: "Zmiana statusu zamówienia",
          choose_new_status: "Wybierz nowy status zamówienia",
          save_and_notify_customer: "Zapisz i wyślij powiadomienie do klienta",
          notify_supplier: "Powiadom Dostawcę",
          save_and_send_opinion_request: "Zapisz i wyślij prośbę o opinię do klienta",
        },
        ShowOrderView: {
          add_new_transfer: "Nowa wpłata",
          add_new_refund: "Nowy zwrot",
          edit_note: "Notatka",
          change_status: "Zmień status",
          print: "Drukuj",
          customer_title: "Klient",
          see_details: "(zobacz dane)",
          send_notification: "(wyślij powiadomienie)",
          order_items_title: "Rachunek",
          order_item_unit_price: "Cena szt.",
          order_item_quantity: "Ilość",
          payments_title: "Płatności",
          agent_title: "Rozliczenie z Agentem",
          platform_title: "Rozliczenie z Tripsomnią",
          platform_fee: "Opłata platformowa",
          activities_title: "Historia zamówienia",
          title: "Zamówienie %{order_id}",
          approve_warning: "Potwierdź",
          one_night: "%{i} dzień",
          nights: "%{i} dni",
          approve_until_warning: "Potwierdź do %{date}",
          send_opinion_reminder_notification: "(wyślij przypomnienie o dodaniu opinii)",
          pay_now: {
            tooltip: {
              no_payment_needed: "Te zamówienie jest w pełni opłacone.",
              too_low_amount: "Kwota płatności jest zbyt niska.",
            },
            0: "Zapłać przez STRIPE",
          },
        },
        utils: {
          confirm_approve_message: "Czy na pewno chcesz potwierdzić to zamówienie?",
          confirm_reject_message: "Czy na pewno chcesz odrzucić to zamówienie?",
          confirm_finish_message: "Czy na pewno chcesz oznaczyć to zamówienie jako zakończone?",
          confirm_cancel_message: "Czy na pewno chcesz anulować to zamówienie?",
          confirm_delete_message: "Czy na pewno chcesz usunąć to zamówienie?",
          redeliver_customer_order_email_success_message:
            "Wiadomość e-mail do klienta z aktualnymi informacjami o zamówieniu została wysłana.",
          redeliver_supplier_order_email_success_message:
            "Wiadomość e-mail z aktualnymi informacjami o zamówieniu została wysłana do Dostawcy.",
          create_agent_disbursement_success_message:
            "Wybrane zamówienia zostały rozliczone (ID rozliczenia: %{agent_disbursement_id}).",
          create_platform_disbursement_success_message: {
            one: "Rozliczono z Tripsomnią – utworzono %{count} transakcję wypłaty do dostawcy.",
            few: "Rozliczono z Tripsomnią – utworzono %{count} transakcje wypłaty do dostawcy.",
            many: "Rozliczono z Tripsomnią – utworzono %{count} transakcji wypłaty do dostawcy.",
            other: "Rozliczono z Tripsomnią – utworzono %{count} transakcji wypłaty do dostawcy.",
          },
          create_platform_disbursement_collected_message: {
            one: "Pobrano opłatę platformową od dostawcy – utworzono %{count} transakcję wpłaty do Tripsomnii.",
            few: "Pobrano opłatę platformową od dostawcy – utworzono %{count} transakcje wpłaty do Tripsomnii.",
            many: "Pobrano opłatę platformową od dostawcy – utworzono %{count} transakcji wpłaty do Tripsomnii.",
            other: "Pobrano opłatę platformową od dostawcy – utworzono %{count} transakcji wpłaty do Tripsomnii.",
          },
          create_platform_disbursement_nothing_to_settle_message: {
            one: "Rozliczono %{count} zamówienie – po stronie Tripsomnii nie było nic do przelania.",
            few: "Rozliczono %{count} zamówienia – po stronie Tripsomnii nie było nic do przelania.",
            many: "Rozliczono %{count} zamówień – po stronie Tripsomnii nie było nic do przelania.",
            other: "Rozliczono %{count} zamówień – po stronie Tripsomnii nie było nic do przelania.",
          },
          create_platform_disbursement_underfunded_message: {
            one: "%{count} zamówienie pozostało nierozliczone – dostawcy nadal się należy, ale platforma nie ma na to środków.",
            few: "%{count} zamówienia pozostały nierozliczone – dostawcy nadal się należy, ale platforma nie ma na to środków.",
            many: "%{count} zamówień pozostało nierozliczonych – dostawcy nadal się należy, ale platforma nie ma na to środków.",
            other:
              "%{count} zamówień pozostało nierozliczonych – dostawcy nadal się należy, ale platforma nie ma na to środków.",
          },
          redeliver_customer_order_opinion_reminder_email_success_message:
            "Wiadomość e-mail do klienta z powiadomieniem o dodaniu opinii o zamówieniu została wysłana.",
          send_opinion_request_to_customer: "Wyślij prośbę o wystawienie opinii do klienta",
        },
        OrderCustomerDetailsFormSection: {
          participants_details: "Dane uczestników",
        },
        EditOrderNotesModal: {
          title: "Notatki zamówienia",
        },
      },
      products: {
        EditProductView: {
          StepAdditional: {
            form_title: "Ustawienia Tripsomnia",
            marketplace_settings: "Marketplace",
            saas_commision_settings: "Prowizja / Opłata serwisowa SaaS",
            hint: {
              p1: "Ustawienia prowizji",
              p2: "Resztę ustawień znajdziesz w agentach.",
            },
          },
          StepAvailability: {
            all_product_variants: "Wszystkie warianty",
            remove_all_slots_confirm: {
              title: "Usuwanie terminu",
              message: "Czy na pewno chcesz usunąć ten termin i jego kolejne wystąpienia?",
              confirm: "Usuń wszystkie terminy od %{all_slots_initial_date}",
            },
            remove_single_slot_confirm: {
              title: "Usuwanie terminu",
              message:
                "Ten termin się powtarza. Czy chcesz usunąć ten termin i jego wszystkie kolejne wystąpienia, czy tylko ten wybrany termin?",
              select_all_slots: "Przejdź do edycji wszystkich terminów od %{all_slots_initial_date}",
              confirm: "Usuń tylko ten termin",
            },
            remove_booked_slot_alert: {
              message:
                "Usunięcie tego terminu nie jest możliwe, bo jest zarezerowany przez aktywne zamówienia. Jeśli chcesz go usunąć, musisz je najpierw anulować.",
              go_to_slot_view: "Przejdź do widoku terminu",
            },
            remove_slot_confirm: {
              title: "Usuwanie terminu",
              message: "Czy na pewno chcesz usunąć ten termin?",
              confirm: "Usuń ten termin",
            },
            edit_all_slots_confirm: {
              title: "Edycja terminu",
              message:
                "Wprowadziłeś zmiany do powtarzalności tego terminu. Czy na pewno chcesz nadpisać ten termin i jego kolejne wystąpienia?",
              confirm: "Zmień wszystkie terminy od %{all_slots_initial_date}",
            },
            edit_single_slot_confirm: {
              title: "Edycja terminu",
              message:
                "Ten termin się powtarza. Czy chcesz nadpisać tylko ten termin, czy przejść do edycji jego wszystkich kolejnych wystąpień?",
              select_all_slots: "Przejdź do edycji wszystkich terminów od %{all_slots_initial_date}",
              confirm: "Zmień tylko ten termin",
            },
            add_slot: "Dodaj termin",
            add_many_slots: "Dodaj wiele terminów",
            select_first_slot_date: "Wybierz datę pierwszego, pojedynczego terminu",
            select_slot_date: "Wybierz datę pierwszego, pojedynczego terminu",
            prices_title: "Cennik",
            no_prices_message: 'Nie ustawiono cen domyślnych. Przejdź do zakładki "Ceny", by wprowadzić cenniki.',
            availability_title: "Dostępność",
            hint: {
              p1: "Zanim zaczniesz dodawać terminy swojej oferty dostosuj domyślne ustawienia cen i rezerwacji dla tej oferty.",
              p2: "Dodawanie terminu",
              p3: "Aby dodać jeden termin wystarczy wybrać datę na kalendarzu, dostosować opcje i zapisać zmiany.",
              p4: "Dodawanie wielu terminów",
              p5: "Aby dodać wiele terminów skorzystaj z opcji powtarzania terminu.",
            },
            normal_start_dates_assignation_type: "wybrane",
            recursion_start_dates_assignation_type: "cyklicznie",
            edit_slot: "Edytuj termin",
            repeat_on_days: "Powtarzaj w dni",
            repeat_until: "Powtarzaj do",
            repeat_in_hours: "Powtarzaj w godzinach",
            repeat_slot: "Powtarzaj termin",
          },
          StepBookingSettings: {
            already_used_stock: "(%{used_stock} już sprzedanych)",
            nb_stock_useby_date_label: "Termin realizacji",
            nb_dont_require_company_approval_label: "Rezerwacja natychmiastowa (bez potwierdzenia)",
            slots_will_be_removed_warning:
              "W momencie zapisania zmian, wyłączymy i/lub usuniemy wszystkie obecnie istniejące terminy tej oferty, jeśli takowe istnieją.",
            form_title: "Ustawienia rezerwacji",
            static_date_booking_label: "Czy oferta ma rezerwację terminów?",
            qr_redemption_enabled_label: "Generuj kod QR do realizacji w Panelu Biletera",
            qr_redemption_enabled_help:
              "Po zakupie klient otrzyma w mailu i w PDF kod QR, który bileter zeskanuje w Panelu Biletera, żeby potwierdzić wejście.",
            global_settings: "Ustawienia globalne",
            default_settings: "Ustawienia domyślne dla dodawania nowych terminów",
            hint: {
              p1: "Wybierz, czy Twoja oferta ma rezerwację terminów w kalendarzu, czy jest to oferta bez rezerwacji np. kupon, voucher do wykorzystania na określonych warunkach.",
              p2: "Domyślny limit dostępności / sprzedaży",
              p3: "Będzie to domyślna wartość dla każdego nowego terminu dodawanego w kalendarzu. W przypadku ofert bez rezerwacji jest to ogólny limit sprzedaży oferty.",
              p4: "Domyślne ustawienie rezerwacji",
              p5: "Zdecyduj, czy przyjmujesz zamówienia natychmiastowe, które nie wymagają Twojego potwierdzenia, czy wolisz mieć pełną kontrolę nad zamówieniami i będziesz potwierdzał osobno każde zamówienie.",
              p6: "Termin realizacji",
              p7: "W przypadku kuponu, voucheru, zniżki możesz ustawić także zakres dat, w którym można go wykorzystać.",
            },
            enable_frontend_slots_listing_label: "Pokazuj klientom listing terminów zamiast kalendarza",
            expire_at_label: "Termin wygaśnięcia oferty",
            availability_limit_label: "Ograniczenie terminu dostępności oferty do kupienia / pobrania przez klienta.",
          },
          StepCustomerFields: {
            customer_fields: "Formularz zamawiającego",
            participant_fields: "Formularz dla uczestników",
            hint: {
              p1: "Pola formularza rezerwacyjnego",
              p2: "Wybierz, które jakie pola będę wyświetlne klientom prz składaniu zamówienia. Dla każdego pola możesz ustawić, czy jest ono wymagane do uzupełnienia oraz czy chcesz wyświetlać te pole na manifeście - liście uczestników.",
            },
          },
          ProductVariantMigrateModal: {
            copy_description_label: "Opis",
            copy_pricelist_label: "Ceny",
            copy_payments_label: "Płatności",
            copy_booking_settings_label: "Ust. rezerwacji",
            copy_pickup_points_label: "Miejsca zbiórki",
            copy_priced_fields_label: "Opcje dodatkowe",
            copy_customer_fields_label: "Kwestionariusz",
            copy_description_hint:
              'Nadpisane zostaną wszystkie atrybuty z zakładki "Opis" dotyczące wybranego wariantu docelowego.',
            copy_pricelist_hint:
              'Nadpisane zostaną wszystkie atrybuty z zakładki "Ceny" dotyczące wybranego wariantu docelowego.',
            copy_payments_hint:
              'Nadpisane zostaną wszystkie atrybuty z zakładki "Płatności" dotyczące wybranego wariantu docelowego.',
            copy_booking_settings_hint:
              'Nadpisane zostaną wszystkie atrybuty z zakładki "Ust. rezerwacji" dotyczące wybranego wariantu docelowego.',
            copy_pickup_points_hint:
              'Nadpisane zostaną wszystkie atrybuty z zakładki "Miejsca zbiórki" dotyczące wybranego wariantu docelowego, a także wartość "Pytaj każdą osobę osobno o miejsce zbiórki" w jej ofercie.',
            copy_priced_fields_hint: 'Nadpisane zostaną wszystkie "Opcje dodatkowe" w ofercie wariantu docelowego.',
            copy_customer_fields_hint:
              'Nadpisane zostaną wszystkie okna "Kwestionariusza" w ofercie wariantu docelowego.',
            title: "Skopiuj atrybuty z innej oferty / wariantu",
            source_variant: "Źródłowa oferta / wariant",
            target_variant: "Docelowa oferta / wariant",
            copy_label: "Kopiuj",
            submit: "Kopiuj dane",
          },
          StepDescription: {
            remove_variant: "Usuń wariant",
            migrate_data_from_other_product: "Skopiuj dane z innej oferty/wariantu",
            new_variant_default_name: "Wariant %{index}",
            add_variant_message:
              "Jeśli Twoja oferta ma zróżnicowane wersje, których nie możesz ustawić za pomocą opcji dodatkowych, możesz %{link}",
            add_variant_message_link: "dodać kolejny wariant oferty.",
            hint: {
              p1: "Nazwa oferty",
              p2: "Jednoznacznie zidentyfikuj swoją ofertę, aby klient od początku wiedział co ogląda.",
              p3: "Kluczowe informacje",
              p4: "Co jest najważniejsze w Twojej ofercie? Zachęć tym swoich klientów!",
              p5: "Opis",
              p6: "Dokładnie i przejrzyście opisz swoją ofertę - im dokładniej to zrobisz, tym mniej wątpliwości będzie miał klient i szybciej zdecyduje się na zamówienie Twojej oferty. Korzystaj z nagłówków i stylizacji tekstu podkreślając najważniejsze aspekty. Jeśli masz klientów z różnych krajów dodaj więcej wersji językowych oferty.",
              p7: "Cena zawiera / Cena nie zawiera",
              p8: "Opisz co jest w cenie oferty, a co jest dodatkowo płatne i jaka jest tego cena.",
              p9: "Warunki",
              p10: "Dodaj szczególne warunki, które musi spełnić klient, aby wziąć udział w ofercie.",
              p11: "Wskazówki podróżnicze",
              p12: "Dodaj rady dla klienta, które pomogą mu odpowiednio przygotować się do udziału w ofercie.",
              p13: "Warianty oferty",
              p14: "Jeśli oferujesz podobne wycieczki, które różnią się tylko drobnymi elementami możesz skorzystać z utworzenia wariantów tej samej wycieczki. Dodatkowo możesz skopiować poszczególne ustawienia z innej przygotowanej wcześniej oferty lub wariantu.",
            },
          },
          StepLocation: {
            main_location_label: "Lokalizacja główna",
            other_locations_label: "Lokalizacje szczegółowe",
            new_pickup_point_title: "Nowe miejsce zbiórki",
            edit_pickup_point_title: "Edycja miejsca zbiórki",
            remove_pickup_point: "Usuń miejsce zbiórki",
            add_new_pickup_point: "Dodaj miejsce zbiórki",
            locations_title: "Lokalizacje oferty",
            pickup_points_title: "Punkty zbiórek",
            pickup_point_assignation_per_person_label: "Pytaj każdą osobę osobno o miejsce zbiórki",
            additional_settings: "Pozostałe ustawienia",
            hint: {
              p1: "Lokalizacje oferty",
              p2: "Ustaw lokalizację główną Twojej oferty oraz dodatkowe punkty z nią związane.",
              p3: "Masz już mapę stworzoną na Google maps? Wklej jej kod, aby wyświetlić ją w ofercie.",
              p4: "Punkty zbiórek",
              p5: "Dodaj miejsca zbiórki określając ich adres, ewentualne godziny wyjazdu i powrotu oraz dodatkową opłatę. Możesz dodać instrukcje oraz dokonać korekty położenia pinezki na mapie, aby ułatwić klientowi dotarcie na punkt zbiórki.",
              p6: "Zdecyduj, czy klient wybiera jedno miejsce zbiórki dla całego zamówienia, czy każdy uczestnik może wybrać swoje miejsce.",
              p7: "Klient nie zawsze przy rezerwacji jest w stanie podać miejsce zbiórki. Zdecyduj, czy pozwalasz klientowi na podanie odpowiedzi “Jeszcze nie wiem”.",
              p8: "Jeśli oferujesz dojazd do miejsca wskazanego przez klienta, zostanie on zapytany o adres odbioru.",
              p9: "Wskazówki dojazdu",
              p10: "Możesz podać tu instrukcje dojazdu do Twojego miejsca lub np. obszar dojazdu do klienta.",
            },
            pickup_points_price_per_person_label: "Naliczaj opłatę od zbiórki od każdej osoby osobno",
            custom_pickup_point_name: "Odbiór z hotelu",
            no_pickup_point_name: "Nieokreślone miejsce",
          },
          StepPayments: {
            supplier_profiles_title: "Wybierz profile, które będą dostępne dla Twoich klientów",
            marketplace_profiles_title: "Wybierz profile, które będą dostępne dla klientów Tripsomnia.",
            add_new_payment_profile: "Dodaj nowy profil",
            form_title: "Profile płatności",
            hint: {
              p1: "Profile płatności",
              p2: "Określ w jaki sposób klienci mogą zapłacić za Twoją ofertę. Ustal liczbę i wysokość rat, metodę płatności oraz warunki anulacji.",
              p3: "Wybierz dla swoich klientów profile z obecnych lub stwórz nowy.",
              p4: "Wybierz dla klientów Tripsomnia profile z obecnych lub skontaktuj się z nami w celu dostosowania współpracy na innych warunkach.",
            },
            no_supplier_profiles_warning:
              "Zalecamy włączyć przynajmniej jeden profil płatności w tym kanale dla Twojej oferty. W przeciwnym wypadku, wykonywanie zamówień na tę ofertę przez klientów na Twojej Stronie WWW będzie niemożliwe.",
            no_marketplace_profiles_warning:
              "Zalecamy włączyć przynajmniej jeden profil płatności w tym kanale dla Twojej oferty. W przeciwnym wypadku, wykonywanie zamówień na tę ofertę przez klientów na SocialTravel.pl będzie niemożliwe.",
            access_temporarily_enabled_only_for_supplier:
              "Podgląd dostępnych profili płatności dla tej oferty jest obecnie możliwy tylko dla Dostawcy oferty. Skontaktuj się z Dostawcą, jeśli chcesz dowiedzieć się, jakie są możliwe do wybrania profile płatności na tą ofertę.",
          },
          StepPhotos: {
            cover_photo: "Zdjęcie okładki",
            name_placeholder: "Wpisz nazwę",
            form_title: "Dodaj zdjęcia, by uatrakcyjnić swoją ofertę",
            click_or_drag_and_drop_to_add_photos:
              "Kliknij lub przeciągnij pliki w to pole, by dodać zdjęcie/zdjęcia. Używaj tylko zdjęć w formacie .jpg, .jpeg .gif .png. Minimalna rozdzielczość plików to 1400 x 600 a rozmiar max 5MB.",
            add_video: "lub dodaj film (YouTube/Vimeo)",
            add_video_submit: "Dodaj",
            hint: {
              p1: "Dodaj ciekawe zdjęcia, które przekonają klientów do skorzystania właśnie z Twojej oferty. Możesz podpisać każde zdjęcie, a także załączyć link do filmiku. Wszystkie materiały możesz uszeregować w dowolnej kolejności przeciągając ich miniaturki.",
              p2: "Pamiętaj, aby umieszczać wyłącznie materiały, do których masz prawa autorskie lub które są udostępnione na otwartej licencji z możliwości ponownego wykorzystania do celów komercyjnych.",
            },
          },
          StepPricedFields: {
            form_title: "Opcje dodatkowe",
            add_new_field: "Nowa opcja dodatkowa",
            hint: {
              p1: "Skonfiguruj dodatkowe opcje dla klientów",
              p2a: "Pole wyboru (Checkbox)",
              p2b: "Klient wybiera opcję tak lub nie.",
              p3a: "Lista wyboru",
              p3b: "Klient wybiera jedną pozycję z listy.",
              p4a: "Liczba",
              p4b: "Klient wybiera liczbę z podanego zakresu.",
              p5: "Zdecyduj, czy pytanie jest zadawane raz dla całego zamówienia, czy osobno dla każdego uczestnika.",
              p6: "Manifest",
              p7: "Zdecyduj, czy pole będzie wyświetlane na manifeście - liście uczestników.",
              p8: "Wymóg wypełnienia",
              p9: "Zdecyduj, czy Klient musi uzupełnić pole, aby złożyć zamówienie",
            },
          },
          StepPricelist: {
            form_title: "Ceny",
            hint: {
              p1: "Musisz wybrać jeden z trzech rodzajów podawania cen:",
              p2: "Cena za osobę",
              p3: "Stwórz standardowy cennik dla osób dorosłych, dzieci, seniorów określając progi wiekowe. Możesz dodać także cennik dla grupy, rodziny ustawiając limity osób lub stworzyć swoją własną kategorię. Dla każdej pozycji cennikowej możesz ustawić minimalną i maksymalną liczbę sztuk do zakupu (np. kup min. 3 bilety). Uwaga: limity osób i limity sztuk nie mogą być ustawione jednocześnie.",
              p4: "Cena za pakiet",
              p5: "Możesz oferować pakiety dla ograniczonej liczby osób np. rower wodny dla 1-4 osób.",
              p6: "Cena za zamówienie",
              p7: "Ustal stałą cenę za zamówienie bez względu na liczbę uczestników np. wynajęcie jachtu.",
            },
            persons_count: "L. os.",
            persons_count_from: "L. os. od",
            age_from: "Wiek od",
            min_quantity: "Min. szt.",
            max_quantity: "Maks. szt.",
            person_category_name: "Nazwa kategorii",
            add_new_item: "Dodaj pakiet",
            item_name: "Nazwa pakietu",
            coupon_code_name: "Kod zniżki",
            new_coupon_code_name: "Nowy kod znizki",
            add_new_coupon: "Dodaj nową zniżkę",
            coupon_codes_title: "Kody zniżek",
            coupon_codes_description:
              "Jeśli chcesz wysłać do klientów konkretne kody zniżek do pobrania, podaj te kody poniżej.",
            coupon_code_realisation_place_type_label: "Gdzie można zrealizować kod zniżki?",
            coupon_codes_realisation_place_online_website:
              "na stronie internetowej (np. za pośrednictwem koszyka e-commerce)",
            coupon_codes_realisation_place_manually: "ręcznie (telefonicznie / mailowo)",
            coupon_codes_realisation_place_custom: "niestandardowe",
            coupon_code_realisation_place_custom_description_placeholder:
              "Sprecyzuj, gdzie i jak można zrealizować kod kuponu",
            generate_coupon_codes: "Wygeneruj losowe kody zniżek",
            saas_featured_price: "Ceny prezentacyjne na Twojej stronie",
          },
          menu: {
            description: "Opis",
            add_locale: "Dodaj / usuń język",
            translate: "Przetłumacz",
            translate_modal: {
              title: "Przetłumacz ofertę",
              explanation: "Żeby przetłumaczyć ofertę, dodaj docelowy język w menu po lewej stronie nad przyciskiem 'Przetłumacz' i zapisz zmiany",
              select_source_locale: "Wybierz język źródłowy",
              select_locale: "Wybierz język docelowy",
              submit: "Przetłumacz",
            },
            pricelist: "Harmonogram i ceny",
            availability: "Dostępność",
            prices: "Ceny",
            payments: "Płatności",
            booking_settings: "Ust. rezerwacji",
            photos: "Zdjęcia",
            location: "Lokalizacja i dojazd",
            priced_fields: "Opcje dodatkowe",
            customer_fields: "Kwestionariusz",
            additional_settings: "Ust. Tripsomnia",
            title: "Menu edycji oferty",
            accommodation_settings: "Ustawienia noclegów",
            integrations: "Ustawienia integracji"
          },
          common: {
            remove_confirm_message: "Czy na pewno chcesz usunąć tę ofertę?",
            orders_button: "Zamówienia",
            preview_st: "Podgląd",
            preview_saas: "WWW",
            save_success_message: "Zmiany w ofercie zostały zapisane.",
            remove_success_message: "Oferta została usunięta.",
            add_photos_success_message: "Zdjęcia zostały dodane.",
          },
          StepAccommodationSettings: {
            form_title: "Ustawienia noclegów",
            accommodation_settings: {
              category: "Typ jednostki noclegowej",
              categoryOption: {
                one_person_room: "Pokój jednoosobowy",
                two_person_room: "Pokój dwuosobowy",
                three_person_room: "Pokój trzyosobowy",
                four_person_room: "Pokój czteroosobowy",
                multi_person_room: "Pokój wieloosobowy",
                bed_in_multi_person_room: "Łóżko w pokoju wieloosobowym",
                apartment: "Apartament",
                cottage: "Domek",
                villa: "Willa",
                holiday_house: "Dom wakacyjny",
                tent: "Namiot",
              },
              categoryTitle: {
                room: "Pokoje/Salony",
                bathroom: "Łazienka",
                view: "Widok",
                food_and_drinks: "Wyżywienie",
              },
              categoryDescription:
                "Wybierz jakiego typu noclegu dotyczy oferta, a następnie ustal ile sztuk/jednostek będzie domyślnie dostępnych do sprzedaży każdego dnia, tą wartość będziesz mógł później zmieniać dla wybranych dat wg Twoich potrzeb.",
            },
            default_total_stock_limit: "Domyślna liczba dostępnych jednostek",
            accommodation_detail: {
              single_beds_count: "Liczba łóżek pojedynczych",
              double_beds_count: "Liczba łóżek podwójnych",
              extra_beds_count: "Liczba dostawek",
              bathrooms_count: "Liczba łazienek",
              rooms_count: "Liczba pokoi/sypialni",
              area: "Powierzchnia",
            },
            presented_price: 'Cena prezentowana "od"',
            accommodationUnitSettings: "Ustawienia jednostki noclegowej",
            facilities: "Udogodnienia",
            accommodationUnitSettingsDescription:
              "Podaj liczbę łóżek pojedynczych, podwójnych oraz możliwych dostawek. Informacje te określą ile osób może skorzystać z nocowania w jednej jednostce wybranego typu. Następnie podaj cenę, która będzie podstawową ceną prezentowaną klientom. Poinformuj klienta o liczbie łazienek, pokoi/sypialni oraz powierzchni, które dotyczą jednej jednostki wybranego typu. Te informacje pojawią się na stronie oferty.",
            facilitiesDescription:
              "Zaznacz, na jakie udogodnienia mogą liczyć Twoi goście korzystający z tego typu jednostki noclegowej.",
          },
          StepIntegrations: {
            log_integration_date: "Data",
            log_integration_action: "Akcja",
            log_integration_company_id: "Firma ID",
            log_integration_uuid: "Task UUID",
            filter_all_logs: "Wszystkie",
            filter_succeeded: "Pomyślne",
            filter_all_failed: "Niepomyślne"
          }
        },
        ManageLocalesPrompt: {
          title: "Wersje językowe oferty",
          select_locale: "Wybierz języki",
        },
        NewProductPrompt: {
          title: "Nowa oferta",
          name_placeholder: "Wpisz nazwę oferty",
          submit: "Stwórz ofertę",
          coupon_label: "Chcę dodać zniżkę / kod rabatowy.",
          offer_type_header: "Wybierz typ oferty",
          offer_type_standard_header: "Standard",
          offer_type_standard_description:
            "Oferta z rezerwacją terminu - jednodniowe wycieczki, wycieczki fakultatywne, turnusy, pakiety noclegowe.",
          offer_type_coupon_header: "Zniżka",
          offer_type_coupon_description:
            "Prosta oferta zniżki - bez rezerwacji terminu, może zawierać wygenerowany kod zniżkowy.",
          offer_type_ticket_header: "Bilet",
          offer_type_ticket_description: "Typ oferty przeznaczony dla atrakcji, parków rozrywki, muzeów.",
          offer_type_voucher_header: "Voucher",
          offer_type_voucher_description:
            "Kupony i vouchery bezzwrotne, które klient kupuje wcześniej, a wykorzystuje w przyszłości.",
          offer_type_accommodation_header: "Noclegi",
          offer_type_accommodation_description: "Oferta z cennikiem za noc. Dla ofert hoteli, pensjonatów itp.",
        },
        ProductsListView: {
          products: "Oferty",
          settings: "Ustawienia",
          add_new_product: "Nowa oferta",
          no_products_message: "Jeszcze nie stworzono żadnej oferty.",
          no_products_message_link: "Dodaj swoją pierwszą ofertę!",
          no_products_title: "Brak ofert.",
          search_top_bar: "Wyszukaj oferty, lokalizacje, organizatorów",
        },
        StepAdditional: {
          hide_description_for_variants: "Ukryj warianty oferty poza pierwszym.",
        },
      },
      reviews: {
        ReviewsListView: {
          no_records_message: "Żaden z Twoich klientów nie napisał jeszcze dla Ciebie opinii.",
          no_records_title: "Brak opinii",
          title: "Opinie",
        },
        EditReviewModal: {
          title: "Opinia",
          remove_confirm_message: "Czy na pewno chcesz usunąć tę opinię?",
        },
      },
      affiliate: {
        AffiliateListView: {
          no_records_message: "Jeszcze nie dodano żadnego zamówienia.",
          no_records_title: "Brak zamówień.",
          summary_row: "Łącznie (dla wierszy %{start}-%{end}):",
          title: "Program Afiliacyjny - statystyki zamówień",
        },
      },
      suppliers: {
        NewSupplierPrompt: {
          email_label: "Wpisz adres e-mail organizatora",
        },
      },
      pagination: {
        show_10: "Pokaż 10",
        show_20: "Pokaż 20",
        show_30: "Pokaż 30",
        show_50: "Pokaż 50",
        show_100: "Pokaż 100",
      },
      accommodation: {
        AccommodationSchedulerView: {
          title: "Wprowadź zmiany w cenach i dostępnościach ofert zakwaterowania",
          calendarLink: "Pokaż kalendarz",
          noProductsInfo: "Musisz posiadać przynajmniej jedną ofertę, żeby móc używać tego ustawienia.",
          availabilityTypes: {
            available_with_instant_booking: "Rezerwacja natychmiastowa",
            available_with_company_approval: "Rezerwacja na zapytanie",
            no_changes: "Bez zmian",
          },
          productsHeader: "Oferty / typy pokoi",
          pricingPlansHeader: "Plany cenowe",
          availabilityTypeHeader: "Tryb rezerwacji",
          datesHeader: "Wybierz daty do wprowadzenia zmian",
          hintHeader: "Edycja cen i dostępności",
          hintContent:
            "Możesz szybko edytować masowo wiele ofert i terminów. Maksymalny zakres edycji do 180 dni do przodu. Wybierz oferty oraz przedział dat, których ma dotyczyć zmiana, a następnie ustaw tylko te parametry, które Cię interesują: cenę, pozostałą do rezerwacji dostępność oraz tryb rezerwacji.",
          errors: {
            maxDatesDifference: "Zakres nie może być dłuższy niż %{maxDatesDifference} dni.",
            daysNotIncluded: "Zakres dat nie zawiera wybranych dni.",
          },
          totalStockLimit: "Dostępność",
        },
        AccommodationCalendarView: {
          title: "Kalendarz cen i dostępności zakwaterowania",
          schedulerLink: "Edycja zaawansowana",
        },
        Accommodation: {
          totalStockLeftTypes: {
            noChanges: "Bez zmian",
            unavailable: "Niedostępna",
            specified: "Określona",
          },
        },
      },
    },
    st: {
      pricelist_order_installment_item: {
        paid_by_cash: "gotówką",
        paid_by_online_payment: "online",
        paid_by_bank_wire: "na konto bankowe",
        already_paid: "Wpłacono %{paid_by}",
        to_be_paid_right_now: "Do zapłaty teraz",
        to_be_paid_right_after_company_approval: "Do zapłaty po potwierdzeniu zamówienia przez firmę.",
        to_be_paid_on_spot: "Do zapłaty %{paid_by} na miejscu",
        to_be_paid_until: "Do zapłaty %{paid_by} w terminie do %{date}",
        to_be_paid_after_previous_installment: "Do zapłaty %{paid_by} w terminie do %{date} po poprzedniej racie",
        to_be_paid_now: "Do zapłaty %{paid_by} teraz",
        to_be_paid_after_order_creation: "Do zapłaty %{paid_by} w terminie do %{date} po złożeniu zamówienia",
        to_be_paid_after_company_approval:
          "Do zapłaty %{paid_by} w terminie do %{date} po potwierdzeniu zamówienia przez Firmę",
        to_be_paid_after_approval: "Do zapłaty %{paid_by} w terminie do %{date} po potwierdzeniu zamówienia",
        to_be_paid_before_stock_start_date: "Do zapłaty %{paid_by} w terminie do %{date} przed rozpoczęciem oferty",
        in_your_currency_it_is: "W Twojej walucie jest to około",
        payment_accepted_in_website_currency: "Waluta płatności",
        payment_accepted_in_company_currency: "Waluta płatności",
        payments_are_converted_with_following_rates: "Opłaty szacowane są na podstawie kursów:",
        your_bank_can_issue_an_additional_fee_for_the_transaction:
          "Twój bank może pobrać dodatkową opłatę za transakcję w obcej walucie.",
        to_supplier: "Dostawcy",
        to_agent: "Agentowi",
        to_socialtravel: "Tripsomnii",
        paid_by_dotpay: "przez DotPay",
        paid_by_paypal: "przez PayPal",
        marketplace_bank_wire_transfer_title: "Tripsomnia zamówienie nr %{order_id}",
        saas_bank_wire_transfer_title: "Zamówienie nr %{order_id}",
        bank_wire_transfer_details:
          'Jeżeli wpłata tej kwoty została już dokonana nie musisz nic robić. W przeciwnym razie podajemy dane do przelewu: %{account_description}. Tytuł przelewu: "%{transfer_title}"',
        paid_by_payu: "przez PayU",
        paid_by_stripe: "przez Stripe",
        paid_by_terminal: "przez terminal",
      },
      app_config: {
        saas_service_fee_name: "Opłata transakcyjna",
        site_short_description:
          "Zarezerwuj online lokalne wycieczki i atrakcje turystyczne z całego świata! Wycieczki i Atrakcje w 1 miejscu. Najciekawsze oferty turystyczne.",
        pdf_voucher_st_address_details: "NIP: 1132941467; ul. Grodzka 42/1, 31-044 Kraków, Polska",
        tripsomnia_company_name: "Tripsomnia",
        tripsomnia_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_full_address:
          "Tripsomnia sp. z o.o.\nNIP: 1132941467\nul. Grodzka 42/1\n31-044 Kraków, Polska",
        tripsomnia_service_fee_name: "Opłata serwisowa Tripsomnia",
        agent_service_fee_name: "Opłata serwisowa Agenta",
        socialtravel_company_name: "Tripsomnia",
        socialtravel_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_opening_hours: "poniedziałek - piątek 9:00 - 17:00, sobota - niedziela 11:00 - 17:00",
        socialtravel_service_fee_name: "Opłata serwisowa Tripsomnia",
        socialtravel_contact_phone_number: "+48 690 670 581",
        tripsomnia_contact_phone_number: "+48 690 670 581",
      },
      create_agent_disbursement: {
        no_orders_error: "Nie wybrano zamówień.",
        no_order_agent_error: "Jedno z wybranych zamówień nie ma przypisanego Agenta.",
        incorrect_order_company_error: "Wszystkie wybrane zamówienia muszą mieć tego samego dostawcę i agenta.",
      },
      create_platform_disbursement: {
        no_orders_error: "Nie wybrano zamówień.",
        marketplace_order_error:
          "Jedno z wybranych zamówień jest zamówieniem marketplace – rozlicz je przez rozliczenie z Agentem.",
        incorrect_order_company_error: "Wszystkie wybrane zamówienia muszą mieć tego samego dostawcę.",
      },
    },
    countries: {
      pl: "Polska",
    },
    customer_mailer: {
      order_marketing_info: {
        subject: "",
      },
      reset_password: {
        action: "Ustaw hasło",
        greeting: "Cześć %{recipient}!",
        instruction: "Właśnie utworzyłeś własne konto na Tripsomnia.",
        instruction_2: "",
        instruction_3: "Kliknij poniższy link, aby ustawić hasło do konta.",
        subject: "",
      },
    },
    product_request_mailer: {
      customer_requested_discount_company_email: {
        hello_company: "Cześć %{company_name}!",
        content: {
          line1: "Popularność Twojego profilu na platformie Tripsomnia rośnie!",
          line2:
            "Nasi klienci są zainteresowani Twoimi produktami. Poniżej znajdziesz zapytanie klienta wysłane w odpowiedzi na wizytówkę Twojej firmy na naszym portalu.",
          line3:
            "Kliknij w link i wypełnij formularz lub skontaktuj się z nami pod adresem kontakt@socialtravel.pl, aby przejąć kontrolę nad profilem Twojej firmy. Więcej o tym kim jesteśmy i co robimy dowiesz się na naszej stronie pobierzkupon.socialtravel.pl.",
        },
        details_header: "%{product-url}",
        customer_details_header: "Wiadomość od klienta",
        info: {
          line1_html: "Twój profil: %{company-url}.",
          line2_html: "Zdobądź dostęp do edycji profilu firmy: %{get_company_access_url}",
          line3_html: "O nas: pobierzkupon.socialtravel.pl",
        },
        subject: "Zapytanie klientów o ofertę z portalu Tripsomnia",
      },
      customer_requested_discount: {
        content: {
          line1: "Popularność Twojego profilu na platformie Tripsomnia rośnie!",
        },
        info: {
          line1_html: "Twój profil: %{company-url}.",
          line2_html: "Uzyskaj dostęp do profilu %{get_company_access_url}.",
          line3_html: "O nas: pobierzkupon.socialtravel.pl",
        },
        subject: "Zapytanie klientów o zniżkę z portalu Tripsomnia",
      },
      customer_requested_product: {
        subject: "Zapytanie klientów o ofertę z portalu Tripsomnia",
      },
      customer_requested_product_company_email: {
        content: {
          line1: "Klient jest zainteresowany Twoją ofertą i chciałby dowiedzieć się więcej na jej temat.",
          line2:
            "Powodem przesłania zapytania może być brak aktualnych terminów, niewystrarczające szczegóły opisujące ofertę lub specjalne życzenia klienta. Prosimy w razie potrzeby zaktualizuj ofertę i skontaktuj się z klientem.",
          line3: "Skontaktuj się z nami jeśli potrzebujesz jakiejkolwiek pomocy: info@tripsomnia.com",
        },
        customer_details_header: "Wiadomość od klienta",
        details_header_html: '<a href="%{product_link}">%{product_name}</a>',
        hello_company: "Cześć %{company_name}!",
        info: {
          line1_html: 'Wiadomość została wysłana na tej <a href="%{product_link}">stronie</a>.',
          line2_html:
            'Zarządzaj opisami i dostępnością oferty w <a href="%{partnerapp_product_url}">Panelu Partnera</a>.',
          line3_html: 'Zapomniałeś hasła? Odzyskaj je <a href="%{partnerapp_reset_password_url}">tutaj</a>.',
        },
        subject: "Zapytanie klientów o ofertę z portalu Tripsomnia",
      },
    },
    pl: {
      papp: {
        settings: {
          StripeSettingsView: {
            stripe_login_button: "Zaloguj do Stripe",
            stripe_register_button: "Rejestracja w Stripe",
          },
        },
      },
    },
    ordered_item: {
      accommodation: {
        name: {
          one: "%{name} x %{count} noc",
          few: "%{name} x %{count} noce",
          many: "%{name} x %{count} nocy",
          other: "%{name} x %{count} nocy",
        },
      },
      product: {
        name: "%{unit_price}: %{name}",
      },
    },
    en: {
      activerecord: {
        attributes: {
          pricing_plan: {
            preset: {
              elastic: {
                company_description: "",
                customer_description: "",
              },
              not_refundable: {
                company_description: "",
                customer_description: "",
              },
            },
          },
        },
      },
    },
  })),
  (I18n.translations.en = I18n.extend(I18n.translations.en || {}, {
    active_admin: {
      action_impossible: "Operation is not possible",
      action_success: "Operation successful.",
      actual_at_x: "data for %{datetime}",
      add_tag_batch_action: {
        add_success: 'Tag "%{name}" was deleted from selected records.',
        remove_instead: "Delete tag from selected records? (instead of adding)",
        remove_success: 'Tag "%{name}" was added to selected records.',
      },
      basic_details: "Basic info",
      batch_actions: {
        button_label: "Multi-record actions",
        labels: {
          add_category: "Assign category to",
          add_location: "Assign a localisation to",
          add_product_st_tag: "Assign a Tripsomnia tag to",
          add_tag: "Assign a tag to",
          v1_st_balance_company_debt: "Settle with Company",
          add_admin_user: "Assign an AdminUser to",
          add_payment_profile: "Assign payment profile to",
          remove_payment_profile: "Remove payment profile from",
        },
      },
      company_edit: {
        possible_to_edit_only_by_global_admin: "Can be edited only by the main admin. ",
      },
      company_registrations: {
        approve: "Confirm",
        reject: "Reject",
      },
      company_submit_monthly_invoicing_stats: {
        success: "Orders have been settled.",
      },
      content_details: "Contents",
      dashboard: "Dashboard",
      dashboard_page: {
        approved_orders: {
          title: "Orders confirmed",
        },
        search_orders: {
          submit: "Search",
          title: "Search for orders",
        },
        summary: {
          title: "Summary",
        },
        upcoming_orders: {
          title: "Upcoming orders",
        },
        waiting_for_company_approval_orders: {
          title: "Orders waiting for Company confirmation",
        },
        waiting_for_customer_approval_orders: {
          title: "Orders waiting for Customer confirmation",
        },
      },
      default_menu: {
        add_new: "Add new",
        new_admin_company: "New company",
        new_admin_product_tag: "New product tag",
        new_admin_product_tags_category: "New product tags category",
        others: "Others",
        users: "Users",
      },
      delete_file: "Delete file",
      devise: {
        email: {
          title: "Email address",
        },
        links: {
          resend_unlock_instructions: "Unlock account",
        },
        password: {
          title: "Password",
        },
        reset_password: {
          submit: "Reset password",
        },
        unlock: {
          submit: "Send unlock instructions",
          title: "Unlock account",
        },
      },
      globalize: {
        language: {
          pl: "Polish",
          en: "English",
          ru: "Russian",
        },
        translations: "Translations",
      },
      go_back: "Go back",
      monthly_invoicing_stats: "Monthly order settlement",
      order_actions: {
        action_failed_error: "An action was unsuccessful because of the error: %{error}",
        approve: "Confirm order ",
        cancel: "Cancel order",
        confirm: "Send order ",
        finish: "Finish order",
        redeliver_customer_order_email: "Resent the email regarding the order to the Customer",
        reject: "Reject order",
        successfully_approved: "Order %{id} has been confirmed.",
        successfully_cancelled: "Order No. %{id} has been cancelled. ",
        successfully_confirmed: "Order %{id} has been sent.",
        successfully_finished: 'Order %{id} has been marked as "finished".',
        successfully_redelivered_customer_order_email:
          "Email regarding the order was resent to the Customer at his email address %{customer_email}",
        successfully_rejected: "Order %{id} has been rejected. ",
        view_stats: "Order statistics",
        redeliver_supplier_order_email: "Send email to Supplier",
        successfully_redelivered_supplier_order_email:
          "Email about order has been sent to Supplier again to the following email address %{customer_email}.",
      },
      order_edit: {
        order_not_yet_confirmed_error:
          "This order has not yet been completed by the customer. Editing from the admin panel is not possible at this moment.",
      },
      order_show: {
        activities: {
          email_message_email: "Email address",
          email_message_subject: "Message subject",
          order_status_updated_action: "Action",
          order_status_updated_content: "Status change to %{status}",
          sms_message_content: "SMS content",
          sms_message_phone_number: "Phone number",
          title: "Order history",
        },
      },
      order_show_company_invoice: {
        invoice_retrieval_error: "Error occured while downloading a .pdf invoice from iFirma:% {error}",
      },
      order_show_customer_invoice: {
        invoice_retrieval_error: "Error occured while downloading a .pdf invoice from iFirma:% {error}",
      },
      order_v1_st_balance_company_debt: {
        success: "Order nr. %{id} has been settled with the Company",
      },
      orders_stats: {
        average_orders_value_th: "Average amount of orders from X",
        in_average_th: "Average X",
        in_total_th: "Total X",
        name_th: "Name X",
        orders_count_th: "Number of orders from X",
        title: "Order statistics",
        total_orders_value_th: "Total amount of orders from ",
      },
      orders_v1_st_balance_company_debt: {
        success: "Selected order have been settled.",
      },
      preview: "Preview",
      product_tags_index: {
        tag_stats: "%{products_count} tagged, %{all_products_count} in total",
      },
      products_index: {
        batch_action_add_product_tag: {
          add_success: 'A tag "%{name}" was selected for the chosen offers. ',
          remove_instead: "Do you want to delete a tag from the chosen offers? (instead of adding it)",
          remove_success: 'A tag "%{name}" has been removed from the chosen offers.',
        },
      },
      scopes: {
        abandoned: "Abandoned",
        all: "All",
        approved: "Confirmed ",
        approved_finished_short: "Conf./ done.",
        building: "Draft",
        cancelled: "Cancelled",
        category: "Categories",
        company_tag: "Company tags",
        customer_tag: "Customer tags",
        deprecated_v1_accomodation: "Accommodations",
        deprecated_v1_coupon: "Vouchers / Discounts",
        deprecated_v1_special_offer: "Special offers",
        deprecated_v1_trip: "Tours",
        finished: "Finished.",
        future_customers: "Future",
        location: "Localizations",
        lost_customers: "Lost",
        marketplace: "Marketplace",
        order_tag: "Order tags",
        past_customers: "Past",
        product_st_tag: "ST tags",
        prospect_customers: "Potential",
        rejected: "Rejected",
        saas: "SaaS",
        waiting_for_company_approval: "Waiting for Company confirmation",
        waiting_for_customer_approval: "Waiting for Customer confirmation",
        product_company_tag: "Company tags",
      },
      search_status: {
        current_filters: "Current filters:",
        current_scope: "Current range:",
        headline: "Scope:",
        no_current_filters: "None",
      },
      sidebars: {
        relation_no_results: "No results.",
      },
      successfully_created: "%{model} has been created successfully.",
      successfully_updated: "%{model} has been updated successfully.",
      tabs: {
        availability: "Availability",
        base_details: "Basic info",
        description: "Description",
        images: "Photos",
        invoicing: "Settlements",
        location: "Location",
        other_details: "Other settings",
        pricelists: "Price list",
        product_order_fields: "Additional options",
        product_variants: "Variants",
      },
      widgets: "Widgets",
      wrong_lock_version_error:
        "This record %{resource_name} was changed by someone in the meantime. Open the form in a new tab and make the changes again.",
      location_details: "Localisation",
      companies: {
        destroy: {
          action_impossible_company_has_orders_as_supplier:
            "Deleting this Company is impossible - it has orders also as a Supplier. Delete its orders first to delete the Company. ",
        },
      },
      pp_edit: "Edit in PP",
      add_admin_user_batch_action: {
        remove_instead: "Delete user from selected companies? (instead of adding)",
        success: "Operation was successfull",
      },
      add_payment_profile_action: {
        success: "Success",
      },
      pricing_plans: {
        new_elastic_plan: "New flexible plan",
        new_not_refundable_plan: "New not-refundable plan",
      },
      remove_payment_profile_action: {
        success: "Payment profile has been removed from the selected records",
      },
    },
    fe: {
      active_admin: {
        view_collection_item_nested_form: {
          toggle_show: "Show / Hide your customized attributes",
        },
      },
      ckeditor: {
        subsection_expand: {
          content:
            "The section content that will be hidden by default and user will be able to display it just by clicking on the title.",
          title: "Section title",
        },
        subsection_read_more: {
          content: 'The section content that will be shortened to "Read more" link, if too long.',
          title: "Section title",
        },
      },
      NewOrderCalendarForm: {
        help_tip: "Legend (hover with mouse)",
        product_chosen: "You have chosen an offer %{name} on %{date_range}.",
        stock_available: "Date available",
        stock_available_but_impossible_as_end: "Slot available, but it's impossible to finish your stay on that day",
        stock_available_but_impossible_as_start: "Slot available, but it's impossible to begin your stay on that day",
        stock_busy: "Date unavailable",
        stock_discounted: "Special price",
        submit: "Next",
        previous_slots: "Previous dates",
        next_slots: "Following dates",
        stock_confirmed: "Date confirmed",
      },
      NewOrderConfirmPricingForm: {
        submit: "Continue",
      },
      NewOrderCustomerDetailsForm: {
        order_with_payment_requirement: "order with payment requirement",
        participant_name_with_number: "Participant No. %{i}",
        required_fields: "requiered fields",
        submit: {
          make_order: "Book",
          next: "Continue",
        },
      },
      NewOrderPaymentForm: {
        almost_booked: "Congratulations! Just another minute and you'll complete your pre-order!",
        almost_finished: "Congratulations! Just another minute and you'll complete your order!",
        cancelled_if_not_paid: "If not paid for in time, your order will be rejected.",
        dotpay_go_back_button: "Go back to the booking form",
        order_with_payment_requirement: "order with payment requirement",
        pay_to_book: {
          marketplace:
            "Please pay %{confirmation_installment_transaction_amount} through our secure online payment platform, the order will be sent waiting for the organizer's confirmation.",
          saas: "As soon as you pay %{confirmation_installment_transaction_amount} by online payment platform, we will receive your order and will be able to confirm it.",
        },
        pay_to_finish:
          "As soon as you pay %{confirmation_installment_transaction_amount} by online payment platform, we will automatically send you a .pdf voucher with your order details.",
        payment_deadline: "Payment deadline: %{pauses_at}.",
        please_pay_online_deposit:
          "Please make a payment for %{confirmation_installment_transaction_amount} by our safe online payment system.",
        safe_payments_guaranteed_by: "Payment safety guaranteed by",
        submit: {
          book_and_pay: "Book and pay now %{price}",
          pay: "Pay now %{price}",
          pay_with_dotpay: "Pay %{price} by online payment platform",
          pay_with_paypal: "Pay %{price} by PayPal",
        },
        choose_payment_method: "Choose payment method:",
        pay_by_bank_wire: "by bank wire transfer",
        pay_by_credit_card: "Pay by card (without PayPal account) or log in to pay via PayPal.",
        by_bank_wire: "by bank wire transfer",
        by_credit_card: "Pay by card (without having to create a PayPal account) or log in to pay via PayPal.",
        by_bank_wire_or_credit_card: "Pay by credit card or bank wire transfer.",
        by_paypal: "Log in to pay via PayPal.",
        pay_by_credit_card_or_paypal: "Pay by card (without PayPal account) or log in to pay via PayPal.",
        by_payu: "Pay debit or credit card",
        payu_button: "Pay with PayU",
      },
      NewOrderProductForm: {
        choose_payment_profile: "Choose payment profile",
        items_count: "Number of %{items}",
        multiple_pricings_alert:
          'Note: Due to the date and time limits, we can not account for %{product_quantity} %{items} on the basis of the price list of "%{product_pricelist_name}".',
        multiple_pricings_info: "Instead, the combination you have selected will be settled as follows:",
        custom_location_name_placeholder: "Enter address, from where the organiser should pick you up",
        submit: "Next",
      },
      NewOrderView: {
        building: "You are booking",
        built: "You have booked",
        contact_us_if_problem_repeats: "If the error repeats, contact us: %{email}",
        loading_failed: "Error while loading offer details. Refresh the page to try again.",
        loading_in_progress: "Loading...",
        marketplace: {
          additional_bank_wire_deposit_required: "This order requires additional payment.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "The Company %{company_link} will receive your pre-order as soon as it is sent. Standard response time is %{company_approval_time_limit} hours, however during local working hours they usually respond within an hour.",
          bank_wire_deposit_deadline_warning:
            "Remember to pay in time. If you are late with the payment, your order may be cancelled.",
          bank_wire_deposit_details: "Bank transfer details",
          bank_wire_deposit_instructions:
            "In a transfer title please place only the order number, which you can find in this confirmation. Otherwise, we cannot guarantee that the transfer will be booked in time.",
          building: "You are booking",
          built: "You have booked",
          company_approved_your_order_request:
            'The Company %{company_link} has confirmed your pre-order No %{order_id} for "%{product_name}".',
          company_received_your_order_request_and_has_to_approve_it:
            "We have sent your pre-order to the Company %{company_link}. Standard response time is %{company_approval_time_limit} hours, however during working hours they usually respond within an hour.",
          contact_us_if_problem_repeats: "If the error repeats, contact us: %{email}",
          customer_full_name: "Customer name and surname",
          download_order_data_confirmation: "Download order confirmation",
          further_details: "Further details",
          if_no_online_payment_your_order_will_be_cancelled:
            "If the payment is not received, your order will be cancelled.",
          loading_failed: "Error while loading offer details. Refresh the page to try again.",
          loading_in_progress: "Loading...",
          order_is_waiting_for_company_approval:
            "Your order is waiting for confirmation from the Company %{company_link}.",
          order_name: "Order No. %{id}",
          order_status: "Order status",
          please_pay_bank_wire_deposit: "Please pay by bank transfer.",
          repeat_payment: "Repeat the payment",
          share_us_to_friends: "Want to know the most interesting offers and special promotions? Like us or share!",
          thank_you_for_order: "Thank you for placing your order!",
          thank_you_for_order_and_share_to_fb:
            "Thank you for placing your order! You can support us by sharing this offer on Facebook!",
          thank_you_for_order_request: "Thank you for your pre-order.",
          we_received_all_required_order_informations: "We have received all necessary information from you.",
          we_received_all_required_order_informations_and_online_payment:
            "We have received all necessary information from you as well as your online payment.",
          we_sended_order_confirmation_to_your_email:
            "We have sent an order confirmation in .pdf to your email address.",
          we_sended_order_request_confirmation_to_your_email:
            "We have sent a pre-order confirmation to your email address.",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "If the order is accepted, the paid amount will be assigned to the order. If the Company %{company_link} rejects the request or does not confirm it in time, the amount of %{confirmation_installment_st_name} online prepayment will be automatically refunded to your bank account within 24 hours. You may then place another order.",
          when_company_approves_we_will_send_online_payment_email:
            "If the Company %{company_link} has confirmed your pre-order, you will receive an email notification with an online payment link for %{confirmation_installment_amount}. You have %{confirmation_installment_after_company_approval_time_limit} after order confirmation to make a transfer by online payment platform.",
          when_company_approves_we_will_send_order_confirmation:
            "If the Company %{company_link} has confirmed your pre-order, you will receive an email notification containing the order confirmation. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "The Company %{company_link} will receive your pre-order as soon as it is sent. Standard response time is %{company_approval_time_limit} hours, however during local working hours they usually respond within an hour.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "After online payment platform confirms the payment, you will receive an email notification with an order confirmation. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "You can also download this file by clicking the button below.",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "Along with the order confirmation, you will get information about further payment.",
          your_order_id: "Your order number",
          your_order_is_fully_confirmed: "Your order is fully confirmed.",
          online_payment_failed: "Unfortunately, your online payment was unsuccessful.",
          order_is_waiting_for_online_payment_info:
            "Your order is waiting for online payment platform to confirm the payment.",
        },
        order_name: "Order No. %{id}",
        saas: {
          additional_bank_wire_deposit_required: "This order requires additional payment.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "We have just received your pre-order. Standard response time is %{company_approval_time_limit} hours but during working hours we usually respond within an hour.",
          bank_wire_deposit_deadline_warning:
            "Remember to pay in time. If you don't make a deposit transfer until the specified period, your order may be cancelled.",
          bank_wire_deposit_details: "Bank transfer details",
          bank_wire_deposit_instructions:
            "In a transfer title please place only the order number, which you can find in this confirmation. Otherwise, we cannot guarantee that the transfer will be booked in time.",
          company_approved_your_order_request:
            'We have confirmed your pre-order No. %{order_id} for "%{product_name}".',
          company_received_your_order_request_and_has_to_approve_it:
            "We have just received your pre-order. Standard response time is %{company_approval_time_limit} hours but during working hours we usually respond within an hour.",
          customer_full_name: "Customer name and surname",
          download_order_data_confirmation: "Download order confirmation",
          further_details: "Further details",
          if_no_online_payment_your_order_will_be_cancelled:
            "If the payment is not received, your order will be cancelled.",
          order_is_waiting_for_company_approval: "Your order is waiting for our approval.",
          order_status: "Order status",
          please_pay_bank_wire_deposit: "Please pay by bank transfer.",
          repeat_payment: "Repeat the payment",
          thank_you_for_order: "Thank you for your order.",
          thank_you_for_order_request: "Thank you for your pre-order.",
          we_received_all_required_order_informations: "We have received all necessary information from you.",
          we_received_all_required_order_informations_and_online_payment:
            "We have received all necessary information from you as well as your online payment.",
          we_sended_order_confirmation_to_your_email:
            "We have sent an order confirmation in .pdf to your email address.",
          we_sended_order_request_confirmation_to_your_email:
            "We have sent a pre-order confirmation to your email address.",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "If we are forced to reject your request or let it expire, online %{confirmation_installment_st_name} will be automatically refunded to your bank account within 24 hour. You can also contact us and choose another offer.",
          when_company_approves_we_will_send_online_payment_email:
            "If we have confirmed your pre-order, you will receive an email notification with an online payment link for %{confirmation_installment_amount}. You have %{confirmation_installment_after_company_approval_time_limit} after order confirmation  to make a transfer by online payment platform.",
          when_company_approves_we_will_send_order_confirmation:
            "When we approve your pre-order, you will receive an order confirmation via email. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "We will receive your pre-order as soon as you send it. Standard response time is %{company_approval_time_limit} hours but during working hours we usually respond in less than 1 hour.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "After online payment platform confirms the payment, you will receive an email notification with an order confirmation. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "You can also download this file by clicking the button below.",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "Along with the order confirmation, you will receive information about further payment.",
          your_order_id: "Your order number",
          your_order_is_fully_confirmed: "Your order is fully confirmed.",
          online_payment_failed: "Unfortunately, your online payment was unsuccessful.",
          order_is_waiting_for_online_payment_info:
            "Your order is currently waiting for online payment platform confirmation.",
        },
        step_number: "Step %{i}",
        title: "Order No. %{order_id} - %{site_name}",
        show_on_map: "Show on map",
        marketplace_booking_unavailable_message_html:
          "Unfortunately, there are no available terms at the moment. If you are still interested, feel free to email us at %{email}, call %{phone_number} or %{open_chat} now.",
        saas_booking_unavailable_message_html:
          "Unfortunately, there are no available terms at the moment. If you are still interested, feel free to email us at %{email} or call %{phone_number}",
        open_chat: "open chat with our consultant",
        choose_date_step_title: "Choose date",
        fill_order_step_title: "Complete an order",
        confirm_payment_details_step_title: "Confirm payment details",
        fill_customer_details_step_title: "Provide your data",
        make_online_payment_step_title: "Pay online",
        order_is_waiting_for_your_approval: "Order is waiting for your confirmation.",
        click_below_to_approve: "Click below to confirm it.",
        reject_order: "Reject order",
        approve_order: "Confirm order",
        approve_order_failed:
          "An error occured while connecting to the server. Try again. In case of further problems, please contact with us info@tripsomnia.com.",
        order_is_finished: "Your order has been marked as finished.",
        we_havent_received_your_review_yet:
          "We have not received your review about the service yet. Please share your opinion with other users!",
        write_a_review: "Write review",
      },
      navbar_search: {
        products_count: "%{count} offers",
        categories: "Categories",
        suppliers: "Suppliers",
        products: "Offers",
        search_nearby: "Search nearby",
        search_query: "Search by phrase",
      },
      new_order: {
        errors: {
          connection_error_during_saving: "Error while saving the order on the server.",
          insufficient_product_quantity:
            "The chosen amount of %{items} can hold a maximum of %{max_persons_count} people. Increse the number of %{items} to %{desired_quantity} or decrease the number of people.",
          max_quantity_limit: "This offer is available within a maximum of %{max_quantity} within the selected date.",
          missing_value: "Fill in the value.",
          personal_data_agreement_missing: "You must agree to the processing of your personal data.",
          product_not_found: "Chosen offer has not been found.",
          product_schedule_slot_missing: "Chosen date is not available anymore.",
          product_variant_not_found: "Chosen offer variant has not been found.",
          rules_agreement_missing: "You have to accept the terms and conditions.",
          online_payment_impossible_for_selected_parameters:
            "Unfortunately, online payment is impossible in this order using %{payment_method}. Please, choose other payment method to pay for the order.",
          partners_agreement_missing: "You must agree to partners data agreement.",
          rodo_agreement_missing: "You must agree to RODO.",
        },
        marketplace_service_fee_tooltip:
          "From this fee, we finance the portal's activity and provided services e.g. travel assistance or payment service.",
        saas_service_fee_tooltip:
          "From this fee, we finance the portal's activity and provided services e.g. travel assistance or payment service.",
        v1_bank_wire_deposit_tooltip: {
          marketplace:
            "You will receive account details for the transfer and the payment deadline in order confirmation sent to your email.",
          saas: "You will receive account details for the transfer and the payment deadline in an order confirmation sent to your email.",
        },
        v1_online_deposit_tooltip: {
          marketplace: {
            line1:
              "Online %{confirmation_installment_st_name} is to secure your order. In case of your resignation the conditions of cancellation described in the offer are applied.",
            line2:
              "The Company %{company_link} will receive your pre-order as soon as it is sent. Standard response time is %{company_approval_time_limit} hours, however during working hours they usually respond within an hour.",
            line3:
              "If Company rejects your request or lets it expire, %{confirmation_installment_st_name} online prepayment will automatically be credited back to your bank account within 24 hour. You can also contact us and choose another offer.",
          },
          saas: {
            line1:
              "Online %{confirmation_installment_st_name} is to secure your order. In case of your resignation the conditions of cancellation described in the offer are applied. Otherwise, if there are no such, our general cancellation conditions apply.",
            line2:
              "We will receive your pre-order as soon as you send it. Standard response time is %{company_approval_time_limit} hours but during working hours we usually respond in less than 1 hour.",
            line3:
              "If we are forced to reject your request or let it expire, online %{confirmation_installment_st_name} will automatically be credited back to your bank account within 24 hour. You can also contact us and choose another offer.",
          },
        },
        confirmation_installment_st_name: {
          deposit: "Deposit",
          fee: "Payment",
          prepayment: "Prepayment",
        },
        v1_rest_deposit_tooltip: {
          on_the_arrival: "Pay the remaining ammount on the day of the beginning of the offer.",
          on_the_spot: "Pay remaining ammount on the spot. ",
          trip: "Pay the rest at the beginning of the tour or before the trip in the office.",
        },
      },
      order: {
        confirmation_installment_after_company_approval: "Amount to be paid after the Comapny's approval of the order",
        new_order_name: "New order",
        order_name: "Order No. %{order_id}",
        v1_online_deposit_now: "To pay",
        stock_useby_time_range: {
          between: "From %{starts_at} to %{ends_at}",
          from: "From %{starts_at}",
          to: "To %{ends_at}",
        },
      },
      order_details: {
        bank_wire_deposit_account_description: "Bank transfer details",
        company_details: "Company details",
        customer_details: "Customer details",
        extra_paid_amount: "Also paid",
        marketplace_service_fee: "Service fee",
        order_details: "Order details",
        order_name: "Order No. %{order_id}",
        overpaid_total_amount: "Overpaid",
        paid_amount: "Paid",
        product_details: "Offer details",
        refunded_amount: "Refunded",
        remaining_total_amount: "Remaining payment amount",
        remaining_total_amount_short: "To pay",
        saas_service_fee: "Service fee",
        total_amount: "Total amount",
        total_amount_short: "Total",
        to_be_paid_total_amount: "Total payment",
        coupon_offer_price: "Final price",
        coupon_offer_price_before_discount: "General price",
        coupon_discount_amount: "Our discount",
        coupon_code_realisation_place_online_website_description:
          "Put this discount code while ordering the offer on its' website.",
        coupon_code_realisation_place_manual_description:
          "Mention this code in your e-mail or phone call while ordering the offer.",
        ends_at: "To: %{ends_at}",
        starts_at: "From: %{starts_at}",
      },
      personal_data_agreement: {
        label:
          "I hereby consent to processing of my personal data by SocialTravel sp. z o. o. for the purpose of execution of the contract.",
        tooltip:
          "I hereby consent to collection and processing of my personal data for the purposes of my booking and post-sale support by SocialTravel sp. z o.o., in accordance with the Point 2, Article 7 of the Regulation (EU) 2016/679 of the European Parliament and of the Council, also known as GDPR.",
      },
      pricelist_expiration_countdown: {
        discount_ends_today: "The special offer ends today at %{expires_at}.",
        discount_ends_tomorrow: "The special offer ends tomorrow at %{expires_at}",
        product_about_to_finish: "This offer is about to end.",
        product_finished: "This offer has ended.",
        x_days_left_to_end_of_discount: {
          one: "One day left before the discount ends!",
          other: "%{count} days left before the discount ends!",
        },
        x_left_to_end_of_discount: "%{time} left before the discount ends!",
      },
      products_map: {
        buy_product: "Book the term",
      },
      reservation_calendar: {
        only_x_in_this_price: "Only %{count} in this price",
        per_night: "/ night",
        valid_on: "Applies",
        last_stocks: "Last places",
      },
      rules_agreement: {
        marketplace: {
          label:
            "I accept the %{link} and give my consent to provision of services by Tripsomnia before the expiration of the withdrawal period.",
          link: "Terms of Platform",
        },
        saas: {
          label:
            "I accept the %{link} and give my consent to provision of services by the Organiser before the expiration of the withdrawal period.",
          link: "Organiser Terms and Conditions",
        },
      },
      sidebar_section_order: {
        order_details: "Order details",
        title: "Your order",
      },
      sidebar_section_product: {
        extend: "Toggle",
        product_details: "Offer details",
      },
      common: {
        site_title: "Tripsomnia",
        loading_failed_message: "An error occurred while loading data.",
        click_to_load_again: "Click here to reload.",
        loading_message: "Loading data...",
        show_more: "Show more",
        next_page: "Next page",
        previous_page: "Previous page ",
        zendesk_livechat_window_title: "Support",
        zendesk_livechat_concierge_name: "Customer service",
        zendesk_livechat_concierge_title: "We are here to help you!",
        close: "Close",
      },
      ProductsCalendarWidget: {
        site_title: "Offer calendar",
      },
      ReviewsListWidget: {
        no_reviews_yet: "No reviews yet. ",
        add_first_review: "Do you want to add first?",
        add_new_review: "Write review",
        total_count: {
          one: "%{formatted_count} reviews",
          other: "%{formatted_count} reviews",
        },
        average_rating: "Average score",
        rating: "Score",
      },
      PaymentMethodsHelper: {
        cash_tooltip: "Cash payment on the spot",
        online_tooltip: "100% to be paid online",
        online_plus_cash_tooltip: "Pay now only deposit + cash on the spot",
      },
      products_listing: {
        medium_priority: "Recommended",
        high_priority: "Best offer",
      },
      bslanding: {
        about_us_contact_form: {
          loading_message: "Loading...",
          success_message: "The message has been sent successfully.",
          failure_message: "There has been an error while sending the message.",
        },
        for_companies_contact_form: {
          loading_message: "Loading...",
          success_message: "The request has been sent successfully. We will write you back shortly.",
          failure_message: "There has been an error while sending the message.",
        },
      },
      CouponsWidget: {
        title: "Choose your offer",
        discount_amount: "%{amount} discount",
        until_product_offer_ends: "%{timeDuration} until end",
        only_x_coupons_left: "%{total_stock_used} coupons downloaded.",
        stock_useby_date_range: "Possible to be used %{date_range}",
        order_price: "Final price",
        order_price_before_discount: "General price",
        order_discount_amount: "Our discount",
        build_order_button: "Get voucher",
        build_order_failed:
          "We had some problems while getting the details for this offer. Please try again, or choose another offer.",
        confirm_order_button: "Download voucher",
        confirm_order_failed: "We had some problems while saving the data. Please try again, or choose another offer.",
        form_title: "Write in your details",
        confirm_order_succeded:
          "Your voucher has been sent to provided e-mail address, check your inbox and use coupon when booking.",
        product_short_description: "Product highlights",
        product_description: "Product description",
        product_variant_short_description: "Offer description",
        product_customer_requirements: "Customer requirements",
        extend_infos: "Show details »",
        get_coupon: "Get coupon",
        hint_title: "Take advantage of our promotions",
        hint_content:
          "<ol><li>Wybierz interesującą Cię promocję.</li><li>Zapoznaj się z jej opisem i warunkami.</li><li>Podaj potrzebne dane i pobierz kupon.</li><li>Wykorzystaj kupon promocyjny podczas rezerwacji.</li></ol>",
        less_than_x_coupons_left: "Less than %{total_stock_left} vouchers available.",
        no_results_alert: "Unfortunately, we have run out of all the available vouchers. Come here again later.",
      },
      partners_agreement: {
        label:
          "I agree to the processing of my personal data by Trusted Partners of Tripsomnia for the purpose of fulfilling the order.",
        tooltip:
          "In accordance with art. 7 par. 2 of the Regulation of the European Parliament and the EU Council 2016/679 of April 27, 2016, I agree and voluntary consent to the processing and collection of my personal data by trusted partners in order to communicate the implementation of the contract and after-sales support.",
      },
      rodo_agreement: {
        label:
          "I am aware of my rights under art. 7 of the Regulation of the European Parliament and the EU Council 2016/679 of April 27, 2016",
        tooltip:
          "At the same time, I declare that my consent meets all the conditions referred to in art. 7 of the Regulation of the European Parliament and the EU Council 2016/679 of April 27, 2016, i.e. I am entitled to withdraw it at any time, the request for consent has been presented to me in a clear and comprehensible form and I have been informed about the condition of its accountability. I was also informed that the data is collected by Tripsomnia (SocialTravel sp. z o.o.) about the purpose of their collection, voluntary submission, the right of access and the possibility of correcting them, and that these data will not be made available to other entities.",
      },
      tripsomnia_contact_email: "info@tripsomnia.com",
      tripsomnia_contact_phone_number: "+48 690 670 581",
    },
    ransack: {
      predicates: {
        eq: "equal",
      },
    },
    api: {
      base: {
        unauthorized: "Access denied. Log in again.",
        company_inactive: "The company you selected is not currently active. Choose another or try to activate it.",
        disabled: "Access denied. This action has been disabled.",
        secret_invalid: "Access denied. API secret is invalid.",
      },
    },
    activerecord: {
      attributes: {
        admin_user: {
          companies: "Managed Companies",
          companies_ids: "Managed Companies",
          company_admin: "Company Admin",
          company_employee: "Employee",
          editor_admin: "Editor Admin (TP)",
          global_admin: "Global Admin (SS)",
          main_admin: "Main Admin (S)",
          default_new_company_role: "Default role for new companies",
        },
        agent_cooperation: {
          fixed_gross_pricing: "Fixed gross prices",
          fixed_net_pricing: "Fixed net prices",
          pricing_type: "Setting pricing",
          realtime_pricing: "Current prices",
          st_fixed_gross_pricing: "Fixed gross prices",
          st_fixed_net_pricing: "Fixed net prices",
          st_realtime_pricing: "Current prices",
        },
        company: {
          accepts_printed_customer_vouchers: "Do you accept our printed .pdf voucher presented by the Customer?",
          admin_users: "Company users",
          admin_users_ids: "Company users",
          contact_email: "Email address",
          contact_email_placeholder: "Contact email address",
          contact_facebook_url: "Facebook funpage address",
          contact_facebook_url_placeholder: "Your website Facebook address",
          contact_full_address: "Company address",
          contact_full_address_placeholder:
            "e.g. 319 Harry Potter Road\nLondon SW15 2PG\nUnited Kingdom\nAccess from the highway M9",
          contact_languages: "Contact languages",
          contact_languages_placeholder: "Languages into which customers can contact you",
          contact_opening_hours: "Office working hours",
          contact_opening_hours_placeholder: 'Your office working hours (e.g. "Mon-Fri from 8 am to 4 pm")',
          contact_phone_number: "Contact number",
          contact_phone_number_placeholder: "Contact number",
          contact_website_url: "Website",
          contact_website_url_placeholder: "Website address",
          default_product_price_currency: "Default currency for new offers",
          general_terms: "Terms and Conditions",
          general_terms_placeholder:
            "Terms and conditions that have to be accepted by your customers when submitting an order.",
          invoice_city: "City",
          invoice_company_name: "Company name",
          invoice_country_name: "Country",
          invoice_data: "Invoice details",
          invoice_email: "Email address",
          invoice_nip: "Tax No.",
          invoice_phone_number: "Phone",
          invoice_postal_code: "Postal code",
          invoice_street_address: "Street, building and flat number",
          locale: "Main language",
          logo_image: "Avatar / Logo",
          marketplace_cover_image: "Background photo on Tripsomnia website",
          marketplace_meta_description: "Page description (SEO) (Marketplace)",
          marketplace_meta_title: "Page title (SEO) (Marketplace)",
          marketplace_name: "Public name (Marketplace)",
          marketplace_short_description: "Short description (Marketplace)",
          marketplace_short_description_placeholder:
            "Short description of your company that will be presented on your company's page on Tripsomnia.",
          name: "Company name",
          name_placeholder: "It should be no longer than 100 characters.",
          notifications_email: "Email address for notifications",
          notifications_phone_number: "Contact number for notifications",
          public_name: "Public name",
          saas_cover_image: "Background photo for your website",
          saas_meta_description: "Page description (SEO) (SaaS)",
          saas_meta_title: "Page title (SEO) (SaaS)",
          saas_name: "Public name (SaaS)",
          saas_short_description: "Short description (SaaS)",
          saas_short_description_placeholder:
            "Short description of your company that will be presented on your homepage. ",
          saas_subdomain: "SaaS subdomain ",
          active: "Active",
          default_products_enable_frontend_slots_listing: "Show dates on a list instead of calendar by default",
          enable_saas: "Enable SaaS",
          enable_marketplace: "Enable Marketplace",
          affiliate_commision_calculation_type: "Affiliate commision calculation type",
          agent_earnings_percentage: "Percentage of order's agent earnings (commision + service fee)",
          total_base_amount_percentage: "Percentage of order's basic amount",
        },
        company_member: {
          company_admin: "Admin",
          company_employee: "Employee",
          editor_admin: "Editor Admin (TP)",
          global_admin: "Global Admin (SS)",
          main_admin: "Main Admin (S)",
        },
        customer: {
          display_name: "Name",
          full_name: "Name and surname",
          full_name_contains: "Name and surname",
          future: "Future",
          lost: "Lost",
          orders_company_id: "Order: Company",
          orders_product_id: "Order: Offer",
          orders_product_name: "Order: Offer name",
          orders_product_product_tags_id: "Order: Offer tags",
          orders_product_variant_id: "Order: Offer variant",
          orders_status: "Order: Status",
          origin: "Source",
          past: "Past",
          prospect: "Potential ",
        },
        installment: {
          confirmation_after_company_approval: "It serves as an order confirmation after Company confirmation",
          confirmation_before_company_approval: "It serves as an order confirmation before Company confirmation",
          remaining_amount: "Remaining amount",
          whole_amount: "Total amount",
        },
        order: {
          additional_information: "Additional information for Customer",
          confirmed_at: "Date of submission",
          customer_display_name: "Customer name",
          manual: "Manual order",
          marketplace: "Marketplace Order",
          product_additional_pickup_instructions: "Directions",
          product_customer_hints: "Tips",
          product_customer_requirements: "Requirements ",
          product_excluded_items: "Price does not include",
          product_included_items: "Price includes",
          product_price_currency: "Offer currency",
          saas: "SaaS order",
          status_short: {
            waiting_for_company_approval: "Waiting for Company",
            waiting_for_customer_approval: "Waiting for Customer",
          },
          stock_useby_ends_at: "Validity end date",
          stock_useby_starts_at: "Validity start date",
          automatic: "Automatic order",
          source: "Source",
          pickup_point: "Meeting point",
          agent_disbursement_status: "Agent disbursement status",
          platform_disbursement_status: "Tripsomnia disbursement status",
          uncleared: "Uncleared",
          cleared: "Cleared",
          coupon_code_name: "Discount code",
          author_place_cwa: "New webiste",
          author_place_frontend: "Website",
          author_place_partner: "Partner's Pannel",
        },
        order_customer_participant: {
          display_name: "Participant No. %{i}",
        },
        order_installment: {
          amount_hint: 'Makes sense only if "Remaining Order Quantity?" is not marked.',
          confirmation_installment_hint: 'Only possible with the first installment payment in method "Online payment".',
          paid_after_company_approval_hint: 'Makes sense only if "Serves as order confirmation?" is marked.',
          paid_by_at_hint: 'Makes sense only if "Determination type" is equal to "Specified date".',
          paid_by_time_duration_hint: 'Makes sense, except when "Determination type" is equal to "Specified date".',
          remaining_amount: "Remaining offer amount?",
          remaining_amount_hint: "Only possible with the last installment.",
          account_description: "Bank account description",
        },
        order_item: {
          base_item: "Basic position?",
          item_type: "Position type",
          marketplace_service_fee: "Tripsomnia service fee",
          name: "Position name",
          order_summary: "Total",
          payment_profile_service_fee: "Payment profile fee",
          product_coupon: "Coupon",
          product_custom: "Non-standard item",
          product_item: "Offer item",
          product_option: "Additional option",
          product_refund: "Refund",
          quantity: "Number of items",
          saas_service_fee: "Tripsomnia transaction fee",
          service_fee: "Service fee",
          unit_price: "Price per item",
        },
        order_status_history: {
          abandon: "Order abandoned",
          auto_refund_issued: "Payment automatically refunded to the Customer",
          build: "Order created",
          company_approval_time_limit_exceeded: "The end of Company order confirmation time limit",
          company_approve: "Order confirmed by the Company",
          company_cancel: "Order cancelled by the Company",
          company_reject: "Ordered rejected by the Company",
          confirm: "Order sent",
          confirmation_online_payment_time_limit_exceeded: "The end of online payment time limit",
          customer_approval_time_limit_exceeded: "The end of Customer order confirmation time limit",
          customer_approve: "Order confirmed by the Customer",
          expire: "Order expired",
          finish: "Order completed",
          finish_online_payment: "Online payment completed",
          manual_status_change: "Manual change of order status",
          pause: "End of the order time limit",
        },
        order_transfer: {
          agent: "Agent",
          bank_wire: "Bank transfer",
          cash: "Cash",
          custom: "Custom",
          customer: "Customer",
          dotpay: "Online payment platform",
          online_payment: "Online payment",
          receiver: "To",
          sender: "From",
          socialtravel: "Tripsomnia",
          source_payload: "Source note",
          source_type: "Withdrawal source",
          transfer_type: "Payment method",
          transferred_at: "Payment date",
          refund_type: "Refund method",
          refunded_at: "Refund date",
          from_customer_frontend_name: "Paid %{transfer_type} on %{transfer_date}",
          to_customer_frontend_name: "Refunded %{transfer_type} on %{transfer_date}",
          customer_to_supplier_backend_name: "Customer paid Supplier %{transfer_type} on %{transfer_date}",
          customer_to_agent_backend_name: "Customer paid Agent %{transfer_type} on %{transfer_date}",
          customer_to_socialtravel_backend_name: "Customer paid Tripsomnia %{transfer_type} on %{transfer_date}",
          company_to_customer_backend_name: "Supplier refunded to Customer %{transfer_type} on %{transfer_date}",
          company_to_agent_backend_name: "Supplier payend Agent %{transfer_type} on %{transfer_date}",
          company_to_socialtravel_backend_name: "Supplier paid Tripsomnia %{transfer_type} on %{transfer_date}",
          agent_to_customer_backend_name: "Agent refunded to Customer %{transfer_type} on %{transfer_date}",
          agent_to_supplier_backend_name: "Agent paid Supplier %{transfer_type} on %{transfer_date}",
          agent_to_socialtravel_backend_name: "Agent paid Tripsomnia %{transfer_type} on %{transfer_date}",
          socialtravel_to_customer_backend_name: "Tripsomnia refunded to Customer %{transfer_type} on %{transfer_date}",
          socialtravel_to_agent_backend_name: "Tripsomnia paid Agent %{transfer_type} on %{transfer_date}",
          socialtravel_to_supplier_backend_name: "Tripsomnia paid Supplier %{transfer_type} on %{transfer_date}",
          supplier_to_agent_backend_name: "Supplier payend Agent %{transfer_type} on %{transfer_date}",
          supplier_to_customer_backend_name: "Supplier refunded to Customer %{transfer_type} on %{transfer_date}",
          supplier_to_socialtravel_backend_name: "Supplier paid Tripsomnia %{transfer_type} on %{transfer_date}",
        },
        payment_profile: {
          additional_fee: "Surcharge (amount)",
          additional_fee_name: "Additional option name",
          additional_fee_percentage: "Surcharge (%)",
          companies: "Assigned companies",
          companies_ids: "Assigned companies",
          default_additional_fee_name: "Fee for the selected payment profile",
          has_additional_fee: "Do you charge an additional service fee for orders with this profile?",
          marketplace: "Marketplace profile",
          saas: "SaaS profile",
          additional_fee_as_agent_fee: "Add the fee as an agent service fee",
        },
        payment_profile_installment: {
          amount: "Installment amount ",
          amount_percentage: "Installment amount in percents (% basic order amount)",
          increase_amount_by_marketplace_commision: "Increase an installment amount by Tripsomnia commission ",
          increase_amount_by_marketplace_service_fee: "Increase an installment amount by Tripsomnia service fee ",
          account_description: "Bank account description",
        },
        payment_profile_product_attachment: {
          date_limit_type: "Date limit type",
          date_limit_type_label: "Limit the date",
          days_before_arrival_date_limit: "From x to y days before the offer beginning date",
          max_days_before_arrival: "Maximum days to offer beginning date",
          min_days_before_arrival: "Minimum days to offer beginning date",
          no_date_limit: "No limit",
        },
        pricing: {
          absolute_amount: "Amount :=",
          absolute_amount_cents: "Amount :=",
          absolute_percentage: "Percentage :=",
          relative_amount: "Amount +/-",
          relative_amount_cents: "Amount +/-",
          relative_percentage: "Percentage +/-",
        },
        product: {
          categories: "Categories",
          product_company_tags: "Tags",
          active: "Active",
          included_items_placeholder: "e.g. Full board",
          excluded_items_placeholder: "e.g. Insurance",
          customer_requirements_placeholder: "e.g. Required minimal age of 18 y.o. or a major attendant",
          customer_hints_placeholder: "e.g. Remember to have proper clothes with you.",
          highlights_placeholder: "e.g. A great trip for couples",
          categories_placeholder: "Add category",
          enable_frontend_slots_listing: "Show dates on a list instead of calendar",
          coupon_code_realisation_place_type: "Discount code realisation place",
          coupon_code_realisation_place_custom_description: "Discount code realisation place description",
        },
        product_integration: {
          auto_update_description: "auto update description",
          auto_update_images: "auto update photos",
          auto_update_prices: "auto update price",
          auto_update_calendar: "auto update calendar"
        },
        product_option: {
          all_product_variants: "All variants",
          required: "Required value to be filled by the Customer",
        },
        product_order_field: {
          "ProductOrderField::BigText": "Large textbox",
          "ProductOrderField::Boolean": "Checkbox",
          "ProductOrderField::Date": "Date",
          "ProductOrderField::Email": "Email address",
          "ProductOrderField::Geopoint": "Geographical location",
          "ProductOrderField::List": "Selection list",
          "ProductOrderField::Number": "Number",
          "ProductOrderField::PhoneNumber": "Phone number",
          "ProductOrderField::Text": "Textbox",
          assignation_per_person_label: "Choice of options per participant (default: per order)",
          assignation_type: "Method of filling in",
          customer_hint: "Tip for a Customer ",
          customer_hint_placeholder: "A tip that will be presented to the Customer when filling out blank",
          list_options: "Values",
          max_value: "Max. value",
          min_value: "Min. value",
          multiply_price_by_nights_count: "Multiply the price by length of stay (number of days)",
          order_value_required: "Required value",
          presets: {
            customer_email: {
              frontend_name: "Email address",
              name: "Customer email address",
            },
            customer_full_name: {
              frontend_name: "Name and surname",
              name: "Customer name and surname",
            },
            customer_note: {
              customer_hint: "Enter your message to organizator.",
              frontend_name: "Note for supplier",
              name: "Note for supplier",
            },
            customer_phone_number: {
              customer_hint: "Contact number in case there are any questions about your booking.",
              frontend_name: "Contact number",
              name: "Customer contact number",
            },
            participant_birth_date: {
              frontend_name: "Birth date",
              name: "Participant birth date",
            },
            participant_email: {
              frontend_name: "Email address",
              name: "Participant email address",
            },
            participant_full_name: {
              frontend_name: "Name and surname",
              name: "Participant name and surname",
            },
            participant_phone_number: {
              frontend_name: "Contact number",
              name: "Participant contact number",
            },
            customer_city: {
              frontend_name: "City",
              name: "Customer city",
            },
            customer_postal_code: {
              frontend_name: "Postal code",
              name: "Customer postal code",
            },
            customer_country: {
              frontend_name: "Country",
              name: "Customer country",
            },
            customer_hotel_name: {
              name: "Hotel",
              customer_hint: "Enter the hotel name, address and room number if you have this information.",
            },
            customer_dates_of_stay: {
              name: "Date of stay",
            },
          },
          price_included_in_order_base_amount: "Include the option price into the basic order cost",
          price_none: "None",
          price_type: "Method of price calculation",
          product_variants: "Offer variants",
          product_variants_assignation_all: "All variants",
          product_variants_assignation_some: "Some variants",
          product_variants_assignation_type: "Method of linking to variants ",
          product_variants_ids: "Variants",
          show_on_manifest: "Show on List of Participants",
          type: "Value type",
          "ProductOrderField::PickupPoint": "Meeting point",
          undefined_pickup_point_option_name: "Undefined",
          custom_pickup_point_option_name: "Hotel pickup",
          custom_pickup_point_display_name: "Customer address: %{custom_location_name}",
          "ProductOrderField::Country": "Country",
          custom_field: "Custom field",
        },
        product_pricelist_item: {
          preset_fixed: "General price list",
          preset_id: "Category type",
          preset_item: "Item",
          preset_person_adult: "Adult",
          preset_person_child: "Child",
          preset_person_custom: "Custom category",
          preset_person_everyone: "Person",
          preset_person_group_1_plus_2: "Family 1+2",
          preset_person_group_1_plus_3: "Family 1+3",
          preset_person_group_2_plus_1: "Family 2+1",
          preset_person_group_2_plus_2: "Family 2+2",
          preset_person_group_2_plus_3: "Family 2+3",
          preset_person_group_custom: "Group",
          preset_person_group_double: "2 people",
          preset_person_group_family_of_3: "3-person family",
          preset_person_group_family_of_4: "4-person family",
          preset_person_group_family_of_5: "5-person family",
          preset_person_group_quad: "4 people",
          preset_person_group_single: "1 person",
          preset_person_group_triple: "3 people",
          preset_person_infant: "Infant",
          preset_person_normal: "Normal",
          preset_person_reduced: "Reduced",
          preset_person_senior: "Senior / Retired",
          preset_person_student: "Student",
          preset_person_teenager: "Underage",
          price_type: "Price type",
        },
        product_schedule_slot: {
          availability_type: "Types of availability",
          available_with_company_approval: "Booking upon Company confirmation",
          available_with_instant_booking: "Instant booking",
          date: "Term date",
          datetime: "Term date and time ",
          total_stock_left: "Remaining availability",
          total_stock_limit: "Availability limit",
          total_stock_used: "Availability taken",
          active: "Available",
          available_with_instant_booking_help: "All order are confirmed automatically.",
          available_with_company_approval_help:
            "Instant booking is turn off. You receive initial inquiries and must confirm each order.",
          confirmed: "Confirmed",
        },
        product_tag: {
          category: "Category",
          location: "Location",
          parent: "Parent tag",
          product_st_tag: "Tripsomnia tag",
          product_company_tag: "Company tag",
          show_on_fe_listing: "Show label on offers listing",
          show_on_fe_product_page: "Show label on offer's page",
          fe_color: "Front-end color",
        },
        product_variant: {
          additional_pickup_instructions: "Additional directions",
          allow_custom_pickup_point: "Hotel pickup",
          allow_no_pickup_point: 'Allow the Customer to select "Meeting Point: Not Specified"',
          custom_pickup_point_additional_fee: "Pickup surcharge",
          default: "Default variant?",
          default_requires_company_approval: "By default, it requires Company confirmation",
          default_total_stock_limit: "Default availability limit",
          nb_requires_company_approval: "Requires Company confirmation",
          nb_stock_useby_days_limit: "Ordered offer validity date (number of days)",
          nb_stock_useby_ends_at: "End date of ordered offer validity",
          nb_stock_useby_starts_at: "Start date of ordered offer validity",
          nb_total_stock_left: "Remaining offer limit",
          nb_total_stock_limit: "Offer limit",
          nb_total_stock_used: "Booked offer limit",
          pickup_points_assignation_type: "Method of assigning meeting points in order",
          pricelist_by_item: "Price list per item",
          pricelist_by_order: "General price list",
          pricelist_by_person: "Price list per person",
          pricelist_type: "Price list type",
          additional_pickup_instructions_placeholder: "Add directions",
          coupon_discount_amount: "Discount amount",
          coupon_discount_percentage: "Discount percentage",
          coupon_offer_price_before_discount: "Price before discount",
          coupon_offer_price: "Price after discount",
        },
        view_collection_item: {
          related_model: "Related record",
        },
        view_section: {
          name: "Title",
          show_name: "Show title? ",
          type: "Section type",
          types: {
            "ViewSection::CompanyProducts": "Company - offer list",
            "ViewSection::CustomCollection": "Custom collection",
            "ViewSection::CustomContent": "Custom content",
            "ViewSection::CustomCover": "Custom cover",
            "ViewSection::ProductTagChildren": "Offer tag - subtags list",
            "ViewSection::ProductTagProducts": "Offer tag - offer list",
            "ViewSection::ProductTagsCategoryProducts": "Offer tags categories - tag list",
            "ViewSection::ProductTagsCategoryTags": "Offer tags categories - tag list",
            "ViewSection::ViewedProducts": "Recently viewed offers",
            "ViewSection::SimilarToViewedProducts": "Similar offers to the last seen",
            "ViewSection::ViewedProductsTags": "Categories and localizations of recently viewed offers",
          },
          view_collection_items_limit: "Displayed records limit",
          view_mode: "Display mode",
          view_modes: {
            cards_listing: "Wide tab pages listing",
            cards_slider: "Long tab pages slider",
            extended_cards_listing: "Widen tab pages listing",
            items_carousel: "Carousel",
            products_map: "Map",
            wide_cards_slider: "Wide tab pages slider",
            wide_cards_listing: "Wide tab pages lisitng",
          },
          with_similar_items: "Show similar elements",
        },
        activity: {
          customer_email_sent_title: "An email has been sent to the customer (%{recipient_email})",
          customer_email_sent_content: "Title: %{email_subject}",
          customer_sms_sent_title: "SMS has been sent to the Customer (%{recipient_phone_number})",
          customer_sms_sent_content: "Content: %{sms_content}",
          order_status_updated_content: 'New order status: "%{new_status}"',
          review_created_title: "Customer had added a review about you with a rating %{rating}/%{max_rating}",
          review_created_content: "Review content: %{content}",
          customer_to_supplier_order_transfer_created_title: "Customer paid Supplier %{amount}",
          customer_to_agent_order_transfer_created_title: "Customer paid Agent %{amount}",
          customer_to_socialtravel_order_transfer_created_title: "Customer paid Tripsomnia %{amount}",
          company_to_customer_order_transfer_created_title: "Supplier refunded to Customer %{amount}",
          company_to_agent_order_transfer_created_title: "Supplier transferred to Agent %{amount}",
          company_to_socialtravel_order_transfer_created_title: "Supplier transferred to Tripsomnia %{amount}",
          agent_to_customer_order_transfer_created_title: "Agent refunded to Customer %{amount}",
          agent_to_supplier_order_transfer_created_title: "Agent refunded to Supplier %{amount}",
          agent_to_socialtravel_order_transfer_created_title: "Agent transferred to Tripsomnia %{amount}",
          socialtravel_to_customer_order_transfer_created_title: "Tripsomnia refunded to Customer %{amount}",
          socialtravel_to_agent_order_transfer_created_title: "Tripsomnia transferred to Agent %{amount}",
          socialtravel_to_supplier_order_transfer_created_title: "Tripsomnia paid Supplier %{amount}",
          supplier_email_sent_content: "Title: %{email_subject}",
          supplier_email_sent_title: "Email sent to Supplier (%{recipient_email})",
          supplier_sms_sent_content: "Content: %{sms_content}",
          supplier_sms_sent_title: "SMS sent to Supplier (%{recipient_phone_number})",
          customer_sms_send_failed_content: "Error Message: %{error_message}",
          customer_sms_send_failed_title:
            "An error occurred while sending an SMS to the Customer (%{recipient_phone_number})",
          supplier_sms_send_failed_content: "Error Message: %{error_message}",
          supplier_sms_send_failed_title:
            "An error occurred while sending an SMS to the Supplier (%{recipient_phone_number})",
          payment_issued_title: "Started: customer %{source} payment operation (%{amount})",
          payment_in_progress_title: "In progress: customer %{source} payment operation (%{amount})",
          payment_completed_title: "Successfully completed: customer %{source} payment operation (%{amount})",
          payment_failed_title: "Failed: customer %{source} payment operation (%{amount})",
          refund_issued_title: "Started: customer %{source} refund operation (%{amount})",
          refund_in_progress_title: "In progress: customer %{source} refund operation (%{amount})",
          refund_completed_title: "Completed: customer %{source} refund operation (%{amount})",
          refund_failed_title: "Failed: customer %{source} refund operation (%{amount})",
          sms_send_failed_content: "Error Message: %{error_message}",
          sms_send_failed_title: "An error occurred while sending an SMS (%{recipient_phone_number})",
          sms_sent_content: "Content: %{sms_content}",
          sms_sent_title: "SMS sent (%{recipient_phone_number})",
          supplier_to_agent_order_transfer_created_title: "Supplier transferred to Agent %{amount}",
          supplier_to_customer_order_transfer_created_title: "Supplier refunded to Customer %{amount}",
          supplier_to_socialtravel_order_transfer_created_title: "Supplier transferred to Tripsomnia %{amount}",
        },
        product_pickup_point: {
          additional_instructions_placeholder: "Add a detailed description of meeting point",
        },
        review: {
          single: "Single",
          couple: "Pair",
          friends: "Friends",
          family: "Family",
          age_group: "Age group",
          group_type: "Group type",
          author_name: "Reviewer's name",
          author_email: "Reviewer's email address",
          content: "Content",
          rating: "General score",
          st_feedback: "Review of Tripsomnia",
          st_rating: "Score of Tripsomnia",
          rating_1: "Very bad",
          rating_2: "Bad",
          rating_3: "Acceptable",
          rating_4: "Good",
          rating_5: "Very good",
          st_rating_1: "Very bad",
          st_rating_2: "Bad",
          st_rating_3: "Decent",
          st_rating_4: "Good",
          st_rating_5: "Great",
          verified: "Verified review ",
          "18-24": "18-24 years",
          "25-30": "25-30 years",
          "31-40": "31-40 years",
          "41-60": "41-60 years",
          "60+": "60+ years",
          anonymous: "Anonymous",
        },
        coupon_code: {
          total_stock_left: "Remaining usage",
          total_stock_limit: "Usage limit",
          total_stock_used: "Usage taken",
        },
        product_variant_additional_detail: {
          category: {
            one_person_room: "Single room",
            two_person_room: "Two-person room",
            three_person_room: "Triple room",
            four_person_room: "Four-person room",
            multi_person_room: "Shared room",
            bed_in_multi_person_room: "Bed in a dormitory room",
            apartment: "Apartment",
            cottage: "The cottage",
            villa: "Villa",
            holiday_house: "Holiday house",
            tent: "Tent",
          },
        },
        product_types: {
          voucher: "Voucher",
          accommodation: "Accommodation",
          coupon: "Discount",
          standard: "Standard",
          ticket: "Ticket",
        },
        pricing_plan: {
          preset: {
            elastic: {
              name: "Flexible offer",
              company_description: "",
              customer_description: "",
            },
            not_refundable: {
              name: "Not-refundable offer",
              company_description: "",
              customer_description: "",
            },
          },
        },
        pricing_plan_types: {
          not_refundable: "Not-refundable offer",
          elastic: "Flexible offer",
        },
      },
      errors: {
        models: {
          order: {
            inactive_product: "Chosen offer is not available anymore. ",
            missing_order_customer_participants_data: "Complete participants date.",
            too_high_product_quantity:
              "This number %{unit_name_other} is not available anymore. Choose a value less than or equal to %{available_stock}.",
            customer_display_name_missing:
              "Fill out at least one value of the Customer (name, email address or phone number).",
            too_low_product_quantity: "You have chosen 0 packages. Choose at least one person.",
            agent_has_disabled_saas:
              "The agent has his SaaS cooperation with Tripsomnia disabled. Such an order is impossible right now.",
            supplier_has_disabled_saas:
              "The supplier has his SaaS cooperation with Tripsomnia disabled. Such an order is impossible right now.",
            supplier_has_disabled_marketplace:
              "The supplier has his cooperation with Tripsomnia marketplace disabled. Such an order is impossible right now.",
            supplier_saas_subdomain_required:
              "The supplier doesn't have domain set for their orders website. Such order is impossible. Please contact Tripsomnia administration in order to fix the issue.",
            agent_saas_subdomain_required:
              "The agent doesn't have domain set for his orders website. Such order is impossible. Please contact Tripsomnia administration in order to fix the issue.",
            confirmation_installment_impossible:
              "Unfortunately, currently it is impossible to pay for this order with an online payment. Please choose another payment profile if possible, or contact us directly.",
            stock_useby_date_passed: "Realisation date of this offer has already passed. It's too late to book it now.",
            product_expired: "Chosen offer is not available anymore.",
          },
          order_item: {
            wrong_price_currency: "The price currency for this type of item must be in: %{valid_currencies}.",
          },
          product: {
            must_be_empty_when_product_has_no_booking:
              'Value %{value} is not allowed in case of offers with "No orders" order type. ',
            product_variant_with_percentage_amounts_defined:
              "At least one of the price lists of this offer has one of the 'Service Fee', 'Commission', 'Bank Deposit Fee' as a percentage. Before changing the currency of the price lists to anything other than PLN, change these values from percentages to quotas.",
            product_pricelist_items_missing: "Fill out at least one price category. ",
          },
          product_order_field: {
            pricing_disallowed_for_this_type: "For this type of option, activation of the price list is not possible.",
          },
          product_tag: {
            parent_must_have_the_same_type: "The parent tag must be of the same type as its subtag.",
            parent_cant_be_self: "The parent tag cannot be itself.",
            parent_cant_be_its_child: "The parent tag cannot be its' child at the same time.",
          },
        },
      },
      models: {
        admin_user: {
          one: "Admin",
          other: "Admins",
        },
        attachment: {
          one: "Attachment",
          other: "Attachments",
        },
        company: {
          one: "Company",
          other: "Companies",
        },
        customer: {
          one: "Customer",
          other: "Customers",
        },
        list_option: {
          one: "Option to choose",
          other: "Options to choose",
        },
        order: {
          one: "Order",
          other: "Orders",
        },
        order_installment: {
          one: "Installment",
          other: "Installments",
        },
        order_item: {
          one: "Ordered item",
          other: "Ordered items",
        },
        order_transfer: {
          one: "Payment/ withdrawal",
          other: "Payments/ withdrawals",
        },
        payment_profile: {
          one: "Payment profile",
          other: "Payment profiles",
        },
        payment_profile_installment: {
          one: "Installment",
          other: "Installments",
        },
        payment_profile_product_attachment: {
          one: "Related payment profile",
          other: "Related payment profiles",
        },
        pricing: {
          one: "Customized price",
          other: "Customized prices",
        },
        product: {
          one: "Offer",
          other: "Offers",
        },
        product_option: {
          one: "Additional option",
          other: "Additional options",
        },
        product_option_value: {
          one: "Value",
          other: "Values",
        },
        product_order_field: {
          one: "Additional option / field to fill out",
          other: "Additional options / fields to fill out",
        },
        product_pricelist_item: {
          one: "Price category",
          other: "Price categories",
        },
        product_schedule: {
          one: "Dates rule",
          other: "Dates rules",
        },
        product_tag: {
          one: "Offer tag",
          other: "Offer tags",
        },
        product_tags_category: {
          one: "Offer tags category",
          other: "Offer tags categories",
        },
        product_variant: {
          one: "Offer variant",
          other: "Offer variants",
        },
        tag: {
          one: "Tag",
          other: "Tags",
        },
        view_collection_item: {
          one: "Collection item",
          other: "Collection items",
        },
        view_page: {
          one: "Subpage",
          other: "Subpages",
        },
        view_section: {
          one: "View section",
          other: "View sections",
        },
        company_registration: {
          one: "Company registration",
          other: "Company registrations",
        },
      },
    },
    attributes: {
      abandoned: "Abandoned",
      accomodation: "Accomodation",
      action: "Action",
      active: "Active?",
      additional_fee: "Surcharge",
      additional_instructions: "Additional instructions",
      address: "Address",
      admin_user: "Admin",
      agent: "Agent",
      agent_commision: "Agent commission",
      agent_commision_amount: "Agent commission",
      agent_commision_amount_cents: "Agent commission [in groszy]",
      agent_commision_percent: "Agent commission [%]",
      agent_note: "Private Agent note",
      all_day_event: "All day term?",
      all_products: "All offers",
      all_tagged_products: "All offers (with this tag or its subtags)",
      amount: "Amount",
      amount_cents: "Amount",
      amount_percentage: "Percentage amount",
      amount_type: "Pricing method",
      api_version: "API version",
      approved: "Confirmed",
      arrival_time: "arrival at",
      assignation_per_item: "per package",
      assignation_per_order: "per order",
      assignation_per_person: "per person",
      attachments: "Attachments",
      balance: "Customer balance",
      balance_status: "Payment status",
      balance_status_for_today: "Payment status for today",
      bank_wire: "Bank transfer",
      bank_wire_account_description: "Bank transfer details",
      bank_wire_account_description_hint: "Can be edited only by the main admin. ",
      birth_date: "Birth date",
      booking_type: "Booking type",
      boolean_value_type: "Checkbox (yes/no)",
      build: "Create order",
      building: "Draft",
      cancellation_policy: "Cancellation policy",
      cancelled: "Cancelled",
      cash: "In cash",
      categories: "Categories",
      change_status: "Status change",
      companies_count: "Number of companies",
      company: "Company",
      company_approval_time_limit: "Company order confirmation time limit",
      company_approval_time_limit_exceeded: "Company confirmation time exceeded",
      company_approval_time_limit_in_hours: "Company order confirmation time limit [in hours]",
      company_approve: "Company order confirmation",
      company_automatic_invoice_amount: "Amount for automatic settlement with the Company",
      company_automatic_invoice_date: "Date of automatic settlement with Company",
      company_cancel: "Order cancelled by Company",
      company_given_amount_through_online_deposit: "Amount transferred to the Company by online payment",
      company_invoice_id: "Company invoice ID",
      company_name: "Comoany name",
      company_over_received_amount_through_online_deposit:
        "Total Tripsomnia balance to Company, taking into account only online payments",
      company_received_amount_through_online_deposit: "Amount received from the Company by online payment",
      company_reject: "Order rejection by Company",
      company_remaining_invoice_amount: "Remaining amount to settle with Company",
      company_tag: "Company tags",
      company_total_invoice_amount: "Total amount to settle with Company",
      confirm: "Order sent",
      confirmation_installment: "Serves as order confirmation?",
      confirmation_installment_after_company_approval: "Online deposit payment only after order confirmation?",
      confirmation_installment_after_company_approval_hint:
        "Otherwise, the online deposit is made before the order is submitted (i.e. when placing the order).",
      confirmation_installment_after_company_approval_time_limit:
        "Time limit for online deposit payment, after the Company order confirmation.",
      confirmation_online_payment_time_limit_exceeded: "Online payment time exceeded",
      country: "Country",
      coupon: "Coupon / Discount ",
      coupon_price: "Voucher price",
      created_at: "Creation date",
      currency: "Currency",
      current_password: "Current password",
      current_sign_in_at: "Current login date",
      current_sign_in_ip: "Current login IP",
      customer: "Customer",
      customer_approval_time_limit: "Customer offer confirmation time limit",
      customer_approval_time_limit_exceeded: "Customer confirmation time exceeded",
      customer_approval_time_limit_in_hours: "Customer offer confirmation time limit [in hours]",
      customer_automatic_invoice_amount: "Amount for automatic settlement with Customer",
      customer_email: "Customer email address",
      customer_full_name: "Customer name and surname",
      customer_full_name_contains: "Customer name and surname",
      customer_hints: "Tips",
      customer_invoice_id: "Customer invoice ID",
      customer_invoiced_amount: "Amount settled with Customer",
      customer_locale: "Customer language",
      customer_note: "Note for supplier",
      customer_phone_number: "Customer phone number",
      customer_remaining_invoice_amount: "Remaining amount to settle with Customer",
      customer_requirements: "Requirements ",
      customer_rules_agreement: "Customer agreement on the terms and conditions",
      customer_tag: "Customer tag",
      customer_total_invoice_amount: "Remaining amount to settle with Customer",
      customers_count: "Number of customers",
      dates: "Dates",
      datetime: "Date and time ",
      days_count: "Days quantity",
      default_marketplace_commision_amount: "Default commission (Marketplace) [amount]",
      default_marketplace_commision_percentage: "Default commission (Marketplace) [%]",
      default_marketplace_service_fee_amount: "Default service fee (Marketplace) [amount]",
      default_marketplace_service_fee_percentage: "Default service fee (Marketplace) [%]",
      default_saas_commision_amount: "Default system commission (SaaS) [amount]",
      default_saas_commision_percentage: "Default system commission (SaaS) [%]",
      departure_time: "departure at",
      deprecated_v1_bank_wire_company_deposit: "Company bank account",
      deprecated_v1_bank_wire_socialtravel_deposit: "Tripsomnia bank account",
      deprecated_v1_excludes_content: "Price does not include (v1)",
      deprecated_v1_includes_content: "Price includes (v1)",
      deprecated_v1_location_alternative_map_content: "Alternative map code on offer page (e.g. iframe)",
      deprecated_v1_requirements_content: "Requirements (v1)",
      description: "Description",
      discount: "Discount",
      discount_amount: "Discount",
      discount_amount_cents: "Discount [in groszy]",
      discounted: "Offer discounted?",
      draft: "Draft",
      email: "Email address",
      end_date: "End date",
      end_time: "End time",
      ends_at: "Date and time of completion",
      exact_amount: "Amount",
      exact_date: "Specified date",
      excluded_items: "Price does not include",
      expire: "Expired offers",
      expired: "Expired",
      expired_at: "Expired date",
      expires_at: "Expired date",
      featured_price: "Presented price",
      featured_price_before_discount: "Presented price before discount",
      file: "File",
      finish: "Finishing order",
      finish_online_payment: "Finishing online payment",
      finished: "Finished",
      first_name: "Name",
      fluid_date_booking: "Flexible length block order (v2)",
      frontend_name: "Title (Frontend)",
      frontend_view: "View (Frontend)",
      full_name: "Name and surname",
      full_person_name: "Name and surname",
      fully_paid: "Paid",
      global_role: "Global role (PA)",
      highlights: "Highlights",
      id: "ID",
      inactive: "Not active",
      included_items: "Price includes",
      includes_time: "Includes time?",
      increase_orders_amount_by_saas_commision: "Add system commission (SaaS) to the total order amount",
      installments: "Payment installments",
      internal_note: "Internal note (avaible for everyone)",
      invoice_date: "Settlement date",
      issuer: "Action author",
      last_sign_in_at: "Last login date",
      last_sign_in_ip: "current login IP",
      last_status_action: "Last action",
      locale: "Language",
      location: "Location",
      location_coordinates: "Geographical coordinates",
      location_lat: "Latitude",
      location_lng: "Longitude",
      location_name: "New localisation",
      locations: "Localisation",
      logo_image: "Logo",
      main_company: "Company",
      main_image: "Main photo",
      marketplace: "Marketplace",
      marketplace_commision: "Tripsomnia commission",
      marketplace_commision_amount: "Tripsomnia commission",
      marketplace_commision_amount_cents: "Tripsomnia commission [in groszy]",
      marketplace_commision_percent: "Tripsomnia commission [%]",
      marketplace_featured_price: "Presented price (Marketplace)",
      marketplace_featured_price_before_discount: "Presented price before discount (Marketplace)",
      marketplace_service_fee: "Tripsomnia service fee [in groszy]",
      marketplace_service_fee_amount: "Tripsomnia service fee",
      marketplace_service_fee_amount_cents: "Tripsomnia service fee [in groszy]",
      marketplace_service_fee_percent: "Tripsomnia service fee [%]",
      max_days_count: "Max. number of days",
      max_nights_count: "Max. number of days (24 hours) ",
      max_number_value: "Max. number value",
      max_order_stock_count: "Maximum total number of packages in the order",
      max_person_age: "Max. age",
      max_persons_count: "Max. number of people",
      meta_description: "Page description (SEO)",
      meta_title: "Page title (SEO)",
      min_days_count: "Min. number of days",
      min_nights_count: "Min. number of days (24h)",
      min_order_stock_count: "Minimum total number of packages in the order",
      min_person_age: "Min. age",
      min_persons_count: "Min. number of peopel",
      name: "Name",
      nb_stock_useby_date: "Ordered offer validity date",
      nb_stock_useby_days_limit: "X days after order confirmation",
      nb_stock_useby_ends_at: "End date of ordered offer validity",
      nb_stock_useby_starts_at: "Start date of ordered offer validity",
      new_status: "New status",
      nights_count: "Number of days (24 hours) ",
      no_booking: "No orders",
      note: "Note",
      number_value_multiplies_price: "Multiply the option price by a numerical value (selected by Customer)",
      number_value_type: "Number (0-n)",
      offers_count: "Number of offers",
      on_stock_starts_at: "on offer beginning day",
      online_payment: "Online payment",
      order: "Order",
      order_bill: "Bill",
      order_customer_participants: "Participants",
      order_items: "Ordered items",
      order_tag: "Orders tag",
      order_transfers: "Payments and withdrawals",
      ordered_product_order_fields: "Additional options / fields to fill out",
      ordered_product_pricelist_items: "Ordered packages",
      orders: "Orders",
      orders_count: "Number of orders",
      orders_marketplace_commision_amount_sum: "Total order commission \n",
      orders_total_amount_sum: "Orders total amount",
      overpaid: "Overpaid",
      paid_after_company_approval: "To be paid after Company's confirmation?",
      paid_amount: "Paid",
      paid_amount_sum: "Paid",
      paid_before_company_approval: "To be paid before Company's confirmation?",
      paid_by_at: "Payment deadline",
      paid_by_at_formatted: {
        on_stock_starts_at: "on offer beginning day",
        x_days_after_order_company_approval: "%{count} after order confirmation by the Company",
        x_days_after_order_creation: "%{count} after order creation",
        x_days_after_order_full_approval: "%{count} after full order confirmation",
        x_days_after_previous_installment:
          "%{count} after last installment (or confirmation/ sending of the order, if it is a first installment)",
        x_days_before_stock_starts_at: "%{count} before the offer beginning date",
        immediately: "before saving the booking",
      },
      paid_by_time_duration: "Time (x) specified in payment deadline",
      paid_by_type: "Type of payment deadline",
      parent: "Parent",
      partly_paid: "Partially paid",
      password: "Password",
      password_confirmation: "Confirm password",
      pause: "Order on hold",
      payment: "Payment",
      payment_completed: "Finished",
      payment_failed: "Unsuccessful",
      payment_in_progress: "Processing",
      payment_operations: "Payment operations",
      payment_profile: "Payment profile",
      payment_status: "Payment status",
      payment_type: "Payment type",
      payment_type_offline: "Offline",
      payment_type_online: "Online",
      payments: "Payments",
      pdf_voucher: "Order confirmation voucher (PDF)",
      pending: "Waiting",
      per_group: "per group",
      per_item: "per package",
      per_order: "per order",
      per_person: "per person",
      per_product: "per offer",
      percentage_amount: "%",
      persons_count: "Number of people",
      phone_number: "Phone number",
      position: "Position",
      price: "Price",
      price_currency: "Price currency",
      price_per_group: "price per group",
      price_per_item: "price per package",
      price_per_night: "price per day",
      price_per_order: "price per order",
      price_per_person: "price per person ",
      price_per_person_night: "price per guest night",
      price_per_product: "Price per offer",
      price_type: "Price type",
      pricing_per_night: "Price list with price per day (v1)",
      pricing_per_person: "Price list with price per person",
      pricing_per_person_night: "Price list with price per guest night",
      pricing_per_product: "Price list with total price per offer (v1)",
      priority: "Priorities",
      product: "Offer",
      product_highlights: "Offer highlights",
      product_images: "Offer photos",
      product_name: "Offer name",
      product_option_values: "Values for selection",
      product_options: "Additional options",
      product_or_variant: "Offer / Variant",
      product_order_fields: "Additional options / field to fill out",
      product_pricelist: "Price list",
      product_pricelist_item: "Price category",
      product_pricelist_order_target: "Price list",
      product_product_tags_id: "Offer tags",
      product_quantity: "Number of packages",
      product_short_description: "Short offer description",
      product_st_tags: "Tripsomnia tags",
      product_tag: "Tag",
      product_tags: "Tags",
      product_tags_category: "Tag category",
      product_tags_id: "Tag",
      product_tags_relation_type: "Type of offer relation",
      product_unit_name: {
        coupon: {
          one: "voucher",
          other: "vouchers",
        },
        person: {
          one: "person",
          other: "people",
        },
        product: {
          one: "package",
          other: "packages",
        },
        room: {
          one: "room",
          other: "rooms",
        },
      },
      product_variant: "Offer variant",
      product_variant_name: "Offer variant name",
      product_variant_order_target: "Variant",
      product_variants_count: "Number of offer variants",
      products_count: "Number of offers",
      products_have_all_tags: "Conjunction (offers with all tags from this category)",
      products_have_one_tag: "Alternative (offers with at least one tag from this category)",
      published: "Published",
      published_at: "Publishing date",
      refund: "Offer refund",
      refund_completed: "Completed",
      refund_failed: "Failed",
      refund_in_progress: "In progress",
      refund_new: "Commissioned",
      refund_none: "none",
      refund_status: "Refund status",
      refunded: "Refunded",
      refunded_amount: "Refunded",
      refunded_amount_sum: "Refunded",
      rejected: "Rejected",
      related_model: "Related record",
      remaining_amount: "Remaining amount",
      remaining_total_amount: "Total amount",
      remaining_total_amount_sum: "Total amount",
      requires_company_approval: "Does order require a Company confirmation?",
      role: "Role",
      saas: "SaaS",
      saas_featured_price: "Presented price (SaaS)",
      saas_featured_price_before_discount: "Presented price before discount (SaaS)",
      saas_service_fee: "Tripsomnia transaction fee",
      select_value_type: "Selected list",
      service_fee: "Service fee",
      short_description: "Short description",
      show_page_title: "Show website title? ",
      sign_in_count: "Number of Logins",
      slug: "Shortened link",
      slug_hint: "Leave this field blank and it will be generated automatically.",
      special_offer: "Special offer",
      st_note: "Private note for Tripsomnia employees",
      start_date: "Start date ",
      start_dates: "Start date ",
      start_time: "Start time",
      start_times: "Start time",
      starts_at: "Start date and time",
      static_date_booking: "Fixed-length block order (v2)",
      status: "Status",
      stock_end_date: "End date",
      stock_end_datetime: "Departure time",
      stock_ends_at: "Departure time",
      stock_start_date: "Start date",
      stock_start_datetime: "Arrival time",
      stock_starts_at: "Arrival time",
      stock_time_range: "Date",
      stock_useby_time_range: "Realisation date",
      supplier: "Supplier",
      supplier_note: "Supplier private note",
      tag: "Tag",
      tagged_products: "Offers (for this tag)",
      tags: "Tags",
      time_duration: "Duration time ",
      time_zone: "Time zone",
      time_zone_name: "Time zone",
      title: "Title",
      total_amount: "Total amount",
      total_amount_sum: "Total amount",
      total_base_amount: "Order basic amount",
      total_discount: "Total discount amount",
      total_discount_amount: "Total discount amount",
      total_price: "Total price",
      total_product_options_price: "Total amount for additional options",
      total_product_price: "Total price per offer",
      total_product_price_before_discount: "Total offer price before discount",
      total_stock_left: "Remaining offer limit",
      total_stock_limit: "Offer limit",
      total_stock_used: "Offer limit used",
      transfer_type: "Payment method",
      translations: "Translations",
      translations_name: "Title",
      trip: "Trip",
      type: "Type",
      type_amount: "Amount",
      type_percent: "%",
      unpaid: "Unpaid",
      updated_at: "Last update",
      v1_bank_wire_deposit: "Bank transfer payment",
      v1_bank_wire_deposit_amount: "Bank transfer payment ",
      v1_bank_wire_deposit_amount_cents: "Bank transfer payment [in groszy]",
      v1_bank_wire_deposit_deadline: "Deadline of bank transfer surcharge",
      v1_bank_wire_deposit_max_payment_date: "Specified date",
      v1_bank_wire_deposit_percent: "Bank transfer payment [%]",
      v1_bank_wire_deposit_postorder_days_limit: "X days after order confirmation",
      v1_bank_wire_deposit_postorder_x_days: "%{value} days after order confirmation",
      v1_bank_wire_deposit_prearrival_days_limit: "X before beginning of the offer",
      v1_bank_wire_deposit_prearrival_x_days: "%{value} days before beginning of the offer",
      v1_cash_deposit: "Additional payment on the spot (in foreign currency) ",
      v1_cash_deposit_amount: "Additional payment on the spot (in foreign currency) ",
      v1_cash_deposit_amount_cents: "Additional payment on the spot (in foreign currency) [in cents]",
      v1_full_bank_wire_deposit: "Offer to be paid in 100% by bank transfer",
      v1_full_bank_wire_deposit_hint:
        "Mark if the offer instead of being paid on the spot should be paid by bank transfer (100% of the total price).",
      v1_online_deposit: "Online deposit",
      v1_online_deposit_percent: "Deposit online [%]",
      v1_online_deposit_st_type: {
        deposit: {
          b: "deposit",
          d: "deposit",
          m: "deposit",
        },
        fee: {
          b: "payment",
          d: "payments",
          m: "payment",
        },
        prepayment: {
          b: "deposit",
          d: "deposit",
          m: "deposit",
        },
      },
      v1_rest_deposit: "Remaining amout to be paid on the spot",
      v1_rest_deposit_amount: "Remaining amout to be paid on the spot",
      v1_rest_deposit_amount_cents: "Remaining amout to be paid on the spot [in groszy/ cents]",
      v1_st_company_debt_status: "Company settlement status",
      v1_st_company_debt_status_amount_to_give: "Transfer payment to Company",
      v1_st_company_debt_status_amount_to_receive: "Get commission from Company",
      v1_st_company_debt_status_short: "Settlement status",
      v1_st_company_debt_status_zero_amount: "Settled",
      v1_st_company_invoiced_amount: "Amount settled with Company",
      v1_st_company_manually_given_amount: "Amount additionally paid to Company",
      v1_st_company_manually_received_amount: "Additional amount received from Company",
      v1_st_remaining_given_amount: "Remaining amount for Company",
      v1_st_remaining_received_amount: "Remaining amount to be received from Company",
      v1_st_total_given_amount: "Total amount paid to Company",
      v1_st_total_over_received_amount: "Total Tripsomnia balance to Company",
      v1_st_total_received_amount: "Total amount received from Company",
      v2_pricing: "Price list by price categories (v2)",
      v2_static_date_booking: "Fixed-length block order (v2)",
      value_type: "Option type",
      variant: "Variant",
      video_url: "Video URL (YouTube / Vimeo)",
      video_url_hint: "If added corretly, the video should appear instead of the photo (only in 'Carousel' view mode).",
      view: "View",
      view_sections: "View sections",
      waiting_for_company_approval: "Waiting for Company",
      waiting_for_confirmation_online_payment: "Waiting for Customer payment",
      waiting_for_customer_approval: "Waiting for Customer",
      website: "Website",
      website_url: "Website",
      week_days: "Week days",
      x_days_after_order_company_approval: "x days after Company confirmation",
      x_days_after_order_creation: "x days after order creation",
      x_days_after_order_full_approval: "x days after full order confirmation",
      x_days_after_previous_installment:
        "X days after the previous installment (or confirmation/ submission of order if this is the first installment)",
      x_days_before_stock_starts_at: "x days before the offer beginning date",
      x_price_per_item: "%{x} per package",
      x_price_per_item_night: "%{x} per package per night",
      x_price_per_order: "%{x} ",
      x_price_per_order_night: "%{x} per day",
      x_price_per_person: "%{x} per person",
      x_price_per_person_night: "%{x} per guest night",
      agent_service_fee: "Agent service fee",
      agent_service_fee_amount: "Agent service fee",
      agent_service_fee_amount_cents: "Agent service fee [in groszy]",
      agent_service_fee_percent: "Agent service fee [%]",
      agent_paid_amount: "Agent paid",
      agent_received_amount: "Agent received",
      agent_remaining_paid_amount: "For withdrawal from Agent",
      agent_remaining_received_amount: "Remaining amount for Agent",
      customer_paid_amount: "Customer paid",
      customer_received_amount: "Refunded to Customer",
      customer_remaining_paid_amount: "To be paid by Customer",
      customer_remaining_received_amount: "To be refunded to Customer",
      socialtravel_paid_amount: "Tripsomnia paid",
      socialtravel_received_amount: "Tripsomnia withdrew",
      socialtravel_remaining_paid_amount: "For withdrawal from Tripsomnia",
      socialtravel_remaining_received_amount: "Remaining amount for Tripsomnia",
      supplier_paid_amount: "Supplier paid",
      supplier_received_amount: "Supplier received",
      supplier_remaining_paid_amount: "To be paid by Supplier",
      supplier_remaining_received_amount: "Remaining amount for Supplier",
      author_place: "Source",
      author_place_frontend: "Website",
      author_place_partnerapp: "Partner Panel",
      product_locations: "Offer locations",
      product_pickup_points: "Meeting points",
      customer_fields: "Questionnaire",
      priced_fields: "Additional opptions",
      product_id: "Offer ID",
      product_variant_id: "Offer variant ID",
      pricelist: "Price list",
      payment_profiles: "Payment profiles",
      remove_location_coordinates: "Clear geographical coordinates",
      test_mode: "Test Mode",
      saas_priority: "Priority (SaaS)",
      marketplace_priority: "Priority (Marketplace)",
      created_on: "Creation date",
      updated_on: "Last edition date",
      affiliate_commision: "Affiliate commission",
      affiliate_commision_amount: "Affiliate commission",
      affiliate: "Affiliate",
      confirmation_installment_amount: "Online deposit",
      bank_wire_account_description_placeholder: "Bank account number and related information.",
      fully_refunded: "Refunded",
      over_refunded: "Over refunded",
      partly_refunded: "Partially refunded",
      dotpay: "DotPay",
      paypal: "PayPal",
      agent_outcome: "Agent income",
      socialtravel_outcome: "Tripsomnia income",
      supplier_outcome: "Supplier income",
      total_company_outcome: "Company's income",
      agent_disbursement: "Agent disbursement",
      agent_disbursement_id: "Agent disbursement ID",
      customer_invoice_amount: "Amount for automatic settlement with Customer",
      doesnt_require_company_approval: "Order doesn't require the Company confirmation",
      custom_online_payment: "Custom online payment",
      agent_bank_wire: "Agent bank transfer",
      supplier_bank_wire: "Supplier bank transfer",
      agent_cash: "In cash from/to Agent",
      supplier_cash: "In cash from/to Supplier",
      none: "None",
      expire_at: "Expiration date",
      publish_at: "Publishing date",
      expire_from: "Expiration date",
      stripe: "Stripe",
      author_place_customerapp: "New website",
      deprecated_v1_booking_type: "Order type (v1)",
      deprecated_v1_location_address: "Address",
      deprecated_v1_location_description: "Directions",
      deprecated_v1_location_full_address: "Full address",
      deprecated_v1_location_full_address_hint_html:
        '<div class="u-inline-block">\n  <strong>Format:</strong><br />\n  Company name<br />\n  Street, building and flat number<br />\n  City, postal code<br />\n  Country\n</div> <div class="u-inline-block">\n  <strong>Example:</strong><br />\n  Hotel of Magic<br />\n  319 Harry Potter Road<br />\n  London SW15 2PG<br />\n  United Kingdom<br />\n</div>',
      deprecated_v1_location_full_address_placeholder:
        "Hotel of Magic \n319 Harry Potter Road\nLondon SW15 2PG\nUnited Kingdom",
      deprecated_v1_order_target_type: "Order purpose (v1)",
      deprecated_v1_pricing_type: "Price list type (v1)",
      deprecated_v1_product_type: "Offer type (v1)",
      price_show_cash_deposit_amount: "Amount to be paid on the spot in foreign currency",
      price_show_coupon_price: "Voucher price",
      price_show_discount_amount: "Promotional discount",
      price_show_discount_percent: "Promotional discount [%]",
      price_show_marketplace_service_fee_amount: "Service fee",
      price_show_online_deposit_amount: "Online deposit",
      price_show_price_per_person: "Price per person (offer price / number of people)",
      price_show_total_amount: "Order amount (offer price + service fee)",
      price_show_total_amount_with_cash_deposit:
        "Total order amount (together with amount to be paid on the spot in foreign currency)",
      price_show_total_price: "Offer price",
      price_show_type: "Way of presenting the price",
      message: "Message",
      requested_date: "Date",
      seller: "Seller",
      discount_percent: "Discount [percent]",
      total_discount_amount_cents: "Total discount [in groszy]",
      total_price_cents: "Total price [in groszy/cents]",
      total_product_options_price_cents: "Total price for additional options [in groszy/in cents]",
      total_product_price_before_discount_cents: "Total price before discount [in groszy/cents]",
      total_product_price_cents: "Total price for the offer [in groszy/cents]",
      confirmation_installment_amount_cents: "Online prepayment [in groszy]",
      confirmation_installment_paid_amount: "Paid online",
      receptionist: "Client",
      available_to: "Available until",
      available_from: "Available from",
      product_type: "Product type",
      pricing_plan_type: "Pricing plan type",
    },
    errors: {
      messages: {
        already_exists: "Such value already exists.",
        has_to_be_in_future: "It has to be a date in the future.",
        installment_not_supported:
          "This payment installment combination is not currently supported by Tripsomnia system. ",
        invalid_installments_position: "Payment installments have an incorrect order.",
        invalid_online_payment_installments:
          'Payment installments have an inadequate combination of payment method. At the moment, a possible installment "Online Payment" must be the first and only payment of this kind.',
        invalid_participant_data: 'Incorrect participant data "%{participant_name}".',
        invalid_participant_product_option_value:
          'Invalid value in field "%{product_option_name}" for participant "%{participant_name}".',
        invalid_phone_number_characters: "contains invalid characters (should contain only digits)",
        invalid_product_option_value: 'Invalid value for additional option "%{product_option_name}".',
        invalid_video_url: "has invalid format. Are you sure it is a correct link to YouTube/ Vimeo video?",
        missing_participant_product_option_value:
          'Select value in field "%{product_option_name}" for participant "%{participant_name}".',
        missing_product_option_value: 'Select value for required additional option "%{product_option_name}".',
        v1_invalid: "value not allowed for models deriving from v1.",
        v1_invalid_installments_transfer_type:
          'Payment installments have an inadequate combination of payment method. In case of order v1 it must be a sequence such as "Online Payment" -> "Bank Account" -> "Cash", with possible ommitment of these installments.',
        invalid_participant_ordered_item: 'Invalid order item assigned to the participant "%{participant_name}".',
        invalid_ordered_item_participants_count:
          'Invalid participants number for the order item "%{ordered_item_name}".',
        empty: "Required",
        greater_than: "Please enter a value greater than 0.",
        too_short: "The text is too short.",
        greater_than_or_equal_to: "The value must be more than or equal to %{count}.",
        less_than_or_equal_to: "The value must be less than or equal to %{count}.",
        invalid: "Invalid value.",
      },
      action_impossible_error: {
        code: "3",
        http_code: "403",
        message: "Action %{action} is impossible to call.",
      },
      record_not_found_error: {
        code: "1",
        http_code: "404",
        message: "%{model} with id=%{id} not found.",
      },
      wrong_product_order_field_error: {
        code: "2",
        http_code: "422",
        message: "Product_order_field with id=%{id} doesn't belong to the ordered product.",
      },
    },
    base: {
      choose: "Choose",
      connection_error: "There has been a connection error while trying to connect with our  server.",
      date: {
        day: "Day",
        month: "Month",
        year: "Year",
      },
      discount: "Discount",
      discount_coupon: "Discount",
      every_each: "every",
      extend: "Extend",
      from: "from",
      from_x: "from %{count}",
      from_x_to_y: "from %{x} to %{y}",
      in_weekdays_xyz: "in %{xyz}",
      loading: "Loading",
      no: "No",
      read_more: "Read more",
      see_more: "Show more",
      to: "to",
      to_x: "to %{count}",
      x_days: {
        one: "%{count} day",
        other: "%{count} days",
      },
      x_hours: {
        one: "%{count} hour",
        other: "%{count} hours",
      },
      x_minutes: {
        one: "%{count} minut",
        other: "%{count} minuts",
      },
      x_nights: {
        one: "%{count} night",
        other: "%{count} nights",
      },
      x_orders: {
        one: "%{count} order",
        other: "%{count} orders",
      },
      x_persons: {
        one: "%{count} person",
        other: "%{count} people",
      },
      x_seconds: {
        one: "%{count} second",
        other: "%{count} seconds",
      },
      yes: "Yes",
      x_years: {
        one: "%{count} year",
        other: "%{count} years",
      },
      choose_date: "Choose date",
      x_selected_records: {
        one: "%{count} selected",
        other: "%{count} selected",
      },
      since_x: "since %{x}",
      since_x_until_y: "since %{x} until %{y}",
      until_x: "until %{x}",
      for_x_days: {
        one: "for %{count} day",
        other: "for %{count} days",
      },
    },
    components: {
      view_sections: {
        title: {
          read_more: "Show more offers",
        },
      },
    },
    date: {
      formats: {
        default: "%d-%m-%Y",
        long: "%A, %e %B %Y",
        short: "%d %b",
        short2: "%e %B %Y",
      },
    },
    helpers: {
      select: {
        no_results_message: "No results",
        prompt: "Choose",
      },
    },
    languages: {
      en: "English",
      pl: "Polish",
      ru: "Russian",
      bg: "Bulgarian",
      hr: "Croatian",
      cs: "Czech",
      da: "Danish",
      nl: "Dutch",
      et: "Estonian",
      fi: "Finnish",
      fr: "French",
      de: "German",
      el: "Greek",
      hu: "Hungarian",
      is: "Icelandic",
      ga: "Irish",
      it: "Italian",
      lv: "Latvian",
      lt: "Lithuanian",
      lb: "Luxembourgish",
      mk: "Macedonian",
      mt: "Maltese",
      pt: "Portuguese",
      ro: "Romanian",
      sr: "Serbian",
      sk: "Slovak",
      sl: "Slovenian",
      es: "Spanish",
      sv: "Swedish",
      tr: "Turkish",
      uk: "Ukrainian",
      cy: "Welsh",
      ar: "Arabic",
      ca: "Catalan",
      he: "Hebrew",
      th: "Thai",
      vi: "Vietnamese",
    },
    number: {
      currency: {
        format: {
          format: "%n %u",
        },
      },
    },
    order_actions: {
      send_approved_order_has_paid_online_deposit_company_sms: {
        sms_content: {
          marketplace: "Order No %{order_id} is confirmed and paid by the customer. Details sent by email.\n",
          saas: "The order No. %{order_id} has been confirmed by the Customer. Details has been emailed.",
        },
      },
      send_order_awaits_approval_company_sms: {
        sms_content: {
          marketplace: "The order No. %{order_id} is waiting for urgent confirmation. Details have been emailed.",
          saas: "The order No. %{order_id} is waiting for urgent confirmation. Details have been emailed.",
        },
      },
      send_order_has_been_approved_customer_sms: {
        sms_content: {
          after_company_approval: {
            marketplace:
              "The order No. %{order_id} has been confirmed. Please make a payment. Details has been emailed.",
            saas: "The order No. %{order_id} has been confirmed. Please make a payment. Details has been emailed.",
          },
          default: {
            marketplace: "The order No. %{order_id} has been confirmed. Details have been emailed.",
            saas: "The order No. %{order_id} has been confirmed. Details have been emailed.",
          },
        },
      },
      send_order_has_been_rejected_customer_sms: {
        sms_content: {
          marketplace: "The order No. %{order_id} has been rejected by the Company. Details have been emailed.",
          saas: "The order No. %{order_id} has been rejected. Details have been emailed.",
        },
      },
      send_order_has_been_cancelled_customer_sms: {
        sms_content: {
          marketplace: "The order No. %{order_id} has been cancelled. Details sent by email. ",
          saas: "The order No. %{order_id} has been cancelled by the Company. Details sent by email. ",
        },
      },
    },
    product_pricelist: {
      lowest_price_is_on: "The lowest price applies to %{schedule_range}.",
      price_name: "%{price} for %{people}",
      price_per_coupon: "price per voucher",
      price_per_item: "price per package / group",
      price_per_night: "price per night",
      price_per_product: "price per product ",
      price_per_stay: "price per stay",
      price_per_tour: "price per tour",
      sold_out_already: "This offer has already been sold out.",
      x_coupons_left: {
        one: "One voucher left. ",
        other: "%{count} vouchers left.",
      },
      x_stocks_left: "Only %{count} for this price.",
    },
    "social_travel/new_company_registration_form": {
      errors: {
        company_already_exists: "Company with this email address had been already registered on our website. ",
      },
    },
    time: {
      formats: {
        long: "%A, %e %B %Y at %H:%M",
        short: "%e %b at %H:%M",
        time: "%H:%M",
        short2: "%e %B %Y",
      },
    },
    view_collection_item_decorator: {
      offer_read_more: "Show Offer",
      offers_read_more: "See offers",
    },
    frontend: {
      companies: {
        show: {
          reviews_title: "Reviews about %{marketplace_name}",
          products_calendar: "Offer calendar",
          products: "Offers",
          reviews: "Reviews",
          reviews_title_html: "Reviews about %{marketplace_name}",
        },
      },
      company_orders: {
        approve: {
          action_impossible: "Invalid operation. Perhaps the order has been already confirmed or rejected?",
          success: 'Order No. #%{id} for "%{product_name}" (customer: %{customer_full_name}) has been confirmed.',
        },
        finish: {
          action_impossible: "Invalid operation. Perhaps the order has been finished already?",
          success: 'Order No. #%{id} for "%{product_name}" (customer: %{customer_full_name}) has been finished.',
        },
        reject: {
          action_impossible: "Invalid operation. Perhaps the order has been already confirmed or rejected?",
          success: 'Order No. #%{id} for "%{product_name}" (customer: %{customer_full_name}) has been rejected.',
          success_with_slot_deactivated:
            'Order No. #%{id} for "%{product_name}" (customer: %{customer_full_name}) was rejected. Also, the chosen booking date was deactivated - all following orders for this date will not be accepted.',
        },
        show: {
          admin_app_info_html:
            'We recommend signing in to our <a href="%{partnerapp_order_url}"> accessibility management panel </a>. By using it, you can fully manage your offers and orders.',
          approve_order: "Approve order",
          finish_order: "Mark as finished",
          order_name: 'Order No. %{order_id} for "%{product_name}"',
          order_status: "Order status: %{status_i18n}",
          reject_order: "Reject order",
        },
      },
      errors: {
        show: {
          general_error: "Please try again to refresh the page.",
          general_error_hint_html: "If the error repeats, try again in a couple of minutes or contact us: %{email}.",
          header: "An error %{error_code} occurred",
          page_not_found: "Chosen page has not been found.",
          page_not_found_hint_html:
            'Go back to <a href="%{root_url}">home page</a> or use the search form in the navigation bar to find an offer that you are interested in.',
          title: "Error %{error_code}",
        },
      },
      orders: {
        confirm: {
          already_abandoned_error:
            "This order has been cancelled. If you wish to make a new order, go back to the first step of booking form.",
          already_confirmed_error: "This order is being processed. Refresh the page to select another product.",
        },
        new: {
          title: "Book: %{product_name}",
        },
        show: {
          title: "Order No. %{id}",
        },
        update: {
          already_abandoned_error:
            "This order has been cancelled. If you wish to make a new order, go back to the beginning of the booking form.",
          already_confirmed_error: "This order is being processed. Refresh the page to select another product.",
        },
      },
      products: {
        show: {
          draft_notice:
            "The offer that you are looking at has not been published yet. This page will be unavailable for other users  (error #404)",
          instead_of: "instead of",
          location_address: "Address",
          location_tips: "Location tips",
          make_an_order: "Book",
          pay_on_the_spot: "Pay on spot",
          product_shown_in_different_locale_notice:
            "Unfortunately, this product's description is not available in your language.",
          product_unavailable: "No terms",
          see_map: "Show map",
          select_product_variant: "Choose option",
          similar_locations_title: "Show similar offers in this location",
          similar_products_title: "You may also be interested in",
          youre_saving: "You are saving",
          pickup_points: "Meeting point",
          custom_pickup_point_possible: "Hotel pickup",
          reviews_title: "Reviews of %{company_name}",
          recently_viewed_products_title: "You recently viewed those offers",
          recently_viewed_products_and_categories_title: "You recently viewed those offers and categories",
          other_locations: "Other addresses",
          buy_product_cta_button: "Buy",
          buy_coupon_cta_button: "Download voucher",
          see_product_availability_cta_button: "Show availability",
          choose_coupon: "Choose option",
          offer_finished_cta_button: "Offer finished",
          coupon_finished: "Discount finished",
          product_finished: "Offer finished",
          product_expires_at: "Offer expires at %{datetime}",
          product_expired_notice:
            "The offer that you are looking at has expired. It is no longer possible to order it.",
          product_expired: "Offer expired",
          only_x_coupons_left: "%{total_stock_used} coupons downloaded.",
          nb_stock_useby_date_range: "Possible to be used %{date_range}",
          no_coupons_left: "No coupons left. Sales limit has been reached.",
          less_than_x_coupons_left: "Less than %{total_stock_left} vouchers available.",
          quicknav: {
            description: "Description",
            includes: "Price includes",
            requirements: "Requirements",
            map: "Map",
            reviews: "Reviews",
          },
          reviews_title_html: 'Reviews of <a href="%{company_url}">%{company_name}</a>',
          not_available_notice: "The offer is not available anymore",
        },
        search: {
          filter_query_title: "Search by text",
          toggle_filters: "Filter results",
          filter_query_placeholder: "Enter a search phrase",
          location_query_title: "Search nearby",
          location_query_label: "in radius of",
          location_query_placeholder: "Where?",
          date_query_title: "Date",
          categories_query_title: "Categories",
          locations_query_title: "Regions",
          locales_query_title: "language",
          no_results_message: "Sorry, we could not find any offers for your search. Try to specify them differently.",
          shown_results: "Display %{start} - %{end}  from %{total_count}",
          previous_page: "Previous page",
          next_page: "Next page",
          site_title: {
            around_location: "Near %{location}",
            with_category_and_location: "Offers from %{category} in %{location}",
            with_category: "Offers from %{category}",
            with_location: "Offers in %{location}",
            default: "Offers",
          },
        },
        history: {
          site_title: "Recently viewed offers",
          viewed_products_title: "Last seen",
          similar_to_viewed_products_title: "You will be also interested",
          viewed_products_tags_title: "See also",
        },
      },
      reviews: {
        new: {
          site_title: "Add review",
          review_details_title: "Your review",
          content_placeholder: "Describe in a few words what was good and what could be improved.",
          rating_label: "Select a rate...",
          personal_details_title: "Your data",
          locale_label: "Language",
          age_group_label: "Your age",
          group_type_label: "Group type",
          author_name_label: "Your name",
          author_email_label: "Your email address",
          st_details_title: "How do you rate the booking process?\n",
          st_rating_label: "Select a rate...",
          st_feedback_placeholder: "Why?",
          submit: "Send review",
          add_success_message: "Your review is waiting for verification. Thank you!",
          error_message: "An error occurred while saving the form.",
          review_for_given_order_already_exists:
            "Review for this order has been already added. Re-writing or editing the review is not possible.",
          order_id: "Order number",
          product: "Offer",
          author_email_hint: "Don't worry, we won't show it to anybody.",
          add_review_title_about_product: 'Add review about "%{product_name}" and %{company_name}',
          add_review_title_about_company: "Add review about %{company_name}",
        },
      },
    },
    layouts: {
      application: {
        contact: {
          about_us: {
            title: "About us",
          },
          contact_us: {
            title: "Contact us",
          },
          cooperating_with: {
            dotpay_payments: "Payments served by PayPal and other online payment platforms",
            title: "Cooperating with",
          },
          see_us_on_facebook: {
            title: "Follow us on Facebook",
          },
          write_to_us: {
            title: "Contact us",
          },
          payment_gateways: {
            title: "Payment gateways",
            description: "We support payments from all major credit cards, bank transfer and PayPal.",
          },
        },
        footer: {
          about_us: "About us",
          careers: "Career",
          cooperation: "Cooperation",
          faq: "FAQ",
          help: "Help",
          privacy_policy: "Privacy policy",
          rules_note_html: 'Using the website means you agree to our <a href="%{rules_url}">Terms and Conditions</a>.',
        },
        guaranteed: {
          read_more: "Check how Tripsomnia works",
          s1: {
            line1: "Carefully selected offers",
            line2: "from reliable organizers.",
            title: "High quality",
          },
          s2: {
            line1: "Discounts up to 50%!",
            line2: "Negotiated specially for you.",
            title: "Lowest prices",
          },
          s3: {
            currency: "PLN",
            line1:
              "Pay in installments, online through our online payment platform, directly to the Company account or in cash on the spot.",
            title: "Safe payments",
          },
          s4: {
            line1: "Amazing adventures, tours, attractions - all in one place!",
            title: "Book online",
          },
          title: "We guarantee",
        },
        navbar: {
          about_us: "About us",
          for_business: "Business",
          products_calendar: "Offer calendar",
          search_placeholder: "Search for an offer, location or category",
          products_history: "Last seen (%{count})",
          contact: "Contact",
          faq: "FAQ",
          open_chat: "Chat",
          cart: "Cart (%{count})",
          finish_order: "Complete your order: %{product_name} (%{total_amount})",
          company_reviews: "Reviews",
        },
      },
      mailer: {
        greetings: "Kind regards, ",
        marketplace: {
          footer_headline: "Tripsomnia - We Love To Travel",
        },
        footer_phone: "Tel.",
        footer_email: "E-mail:",
      },
    },
    pdfs: {
      order_voucher: {
        cancellation_policy: "Cancellation policy",
        cancellation_policy_description:
          "This offer is non-refundable. The order cannot be changed or cancelled. If the participant is absent, money will not be returned.",
        company_details: "Company details",
        contact_email: "Email address",
        contact_facebook_url: "Facebook",
        contact_full_address: "Address",
        contact_phone_number: "Contact phone number",
        contact_website_url: "Website",
        generated_date: "Generated: %{date}",
        got_any_questions: "Have you got any questions?",
        order_details: "Your contact details",
        order_number: "Order number",
        product_details: "Offer details",
        st_headline: "Tripsomnia (SocialTravel Company)",
        title: "Confirmation of order No. %{order_id} ",
        wish_you_great_journey: "We wish you a memorable experience!",
        your_order: "Your order",
        footer_phone: "Tel.",
        footer_email: "E-mail:",
        code: "Code: %{code} ",
      },
      slot_manifest: {
        customer_name_placeholder: "Order",
        generated_on: "Date generated %{date}",
        page_title: "Manifest",
      },
    },
    admin_user_mailer: {
      company_created_you_an_account: {
        action: "Set your password",
        greeting: "Hello %{recipient}!",
        instruction:
          "The company %{company_name} has created an account in Tripsomnia panel for you, for managing orders and travel offers. ",
        instruction_2: "To log into our website, please, click a link below, which will let you set your password. ",
        instruction_3: "If you didn't require access to this platform, please, ignore this message.",
        subject: "The company %{company_name} has created an account in Tripsomnia Partner Panel for you",
      },
      company_invited_you_to_become_a_member: {
        action: "Go to Company panel",
        greeting: "Hello %{recipient}!",
        instruction:
          "The company %{company_name} has assigned you access to the Tripsomnia Partner Panel, designed for managing orders and travel offers.",
        instruction_2: "Click the link below to go to the panel ",
        subject: "The company %{company_name} has assigned you access to the Tripsomnia Partner Panel",
      },
    },
    company_mailer: {
      agent_invitation_received: {
        action: "Go to cooperation panel",
        greeting: "Hello %{company_name}!",
        instruction:
          "The company %{supplier_name} has invited you to agency cooperation so that you could sell their offers.",
        instruction_2: "Click the link below to go to the panel and see the cooperation details.",
        subject: "The company %{supplier_name} has invited you to agency cooperation on Tripsomnia.com",
      },
      company_and_user_created_agent_invitation_received: {
        action: "Set your password",
        greeting: "Hello %{company_name}!",
        instruction:
          "The company %{supplier_name} has invited you to agency cooperation so that you could sell their offers.",
        instruction_2: "",
        instruction_3: "Click the link below to set your account password and see the cooperation details.",
        subject: "The company %{supplier_name} has invited you to agency cooperation",
      },
      company_created_and_agent_invitation_received: {
        action: "Go to cooperation panel",
        greeting: "Hello %{company_name}!",
        instruction:
          "The company %{supplier_name} has invited you to agency cooperation so that you could sell their offers.",
        instruction_2: "Click the link below to go to the panel and see the cooperation details.",
        subject: "The company %{supplier_name} has invited you to agency cooperation",
      },
      company_registration_approved: {
        action: "Go to panel",
        greeting: "Hello %{company_name}!",
        instruction:
          "We created a company %{company_name} account for you in our Tripsomnia panel for managing orders and travel offers.",
        instruction_2:
          'Click the link below to go to the panel and see the cooperation details. The link is active for 48 hours, if you can not log in within these hours, please use "Password reminder" option to recover account access.',
        subject: "Account of the company %{company_name} has been successfully created in the Tripsomnia panel",
      },
      company_registration_approved_and_user_created: {
        action: "Set your password",
        greeting: "Hello %{company_name}!",
        instruction:
          "We created a company %{company_name} account for you in our Tripsomnia panel for managing orders and travel offers.",
        instruction_2: "",
        instruction_3:
          'Click the link below to go to the panel and see the cooperation details. The link is active for 48 hours, if you can not log in within these hours, please use "Password reminder" option to recover account access.',
        subject: "Account of the company %{company_name} has been successfully created in the Tripsomnia panel",
      },
      company_registration_created: {
        action: "See the registration details",
        greeting: "Hello!",
        instruction: "Someone filled out a registration form with the following data:",
        subject: "The company %{company_name} would like to register in Tripsomnia panel",
      },
      customer_review_submitted: {
        greeting: "Hello %{company_name}!",
        new_review_has_been_submitted: "A review for you has been added on Tripsomnia platform.",
        action: "See review",
        subject: "A new review has been submitted for your company",
      },
      company_and_user_created_supplier_invitation_received: {
        action: "Set your password",
        greeting: "Hello %{supplier_name}!",
        instruction:
          "The company %{agent_name} has invited you to agency cooperation so that they could sell your offers.",
        instruction_2: "",
        instruction_3: "Click the link below to set your account password and see the cooperation details.",
        subject: "The company %{agent_name} has invited you to agency cooperation on Trispomnia.com",
      },
      company_created_and_supplier_invitation_received: {
        action: "Go to cooperation panel",
        greeting: "Hello %{supplier_name}!",
        instruction:
          "The company %{agent_name} has invited you to agency cooperation so that they could sell your offers.",
        instruction_2: "Click the link below to go to the panel and see the cooperation details.",
        subject: "The company %{agent_name} has invited you to cooperation on Tripsomnia.com",
      },
      supplier_invitation_received: {
        action: "Go to cooperation panel",
        greeting: "Hello %{supplier_name}!",
        instruction:
          "The company %{agent_name} has invited you to agency cooperation so that they could sell your offers.",
        instruction_2: "Click the link below to go to the panel and see the cooperation details.",
        subject: "The company %{agent_name} has invited you to agency cooperation on Tripsomnia.com",
      },
    },
    order_mailer: {
      base: {
        company_approve_order: "Confirm order",
        company_finish_order: "Mark as finished",
        company_reject_order: "Reject order",
        company_see_order: "See order",
        customer_repeat_order: "Repeat order",
        customer_see_all_offers: "See all available offers",
        customer_see_nearby_offers: "See nearby offers",
        customer_see_offer: "See offer",
        hello_company: "Hello %{company_name}!",
        hello_customer: "Dear %{customer_full_name},",
        order_status: "Order status: %{status_i18n}",
        company_reject_order_and_deactivate_slot: "Reject order and stop selling on this date",
      },
      company_order_footer: {
        line1_html: "Your offer is available on the website here: %{product_link}.",
        line2_html: 'You can manage it in the <a href="%{partnerapp_order_url}">availability management panel</a>.',
      },
      order_about_to_start_reminder_company_email: {
        p1_html:
          'The order of customer %{customer_full_name} No. %{order_id} for "%{product_name}" starts in %{days_to_start} days (%{stock_start_date}).',
        p2_html:
          'As a reminder, we are sending you details of your order. We have provided you with a printable version of the order confirmation in a previous email. However, if you cannot find it, you can download a .pdf file from <a href="%{customer_pdf_order_url}">the following link</a>.',
        subject:
          "The confirmed order of customer %{customer_full_name} No. %{order_id} for %{product_name} starts in %{days_to_start} days (%{stock_start_date}).",
      },
      order_about_to_start_reminder_customer_email: {
        marketplace: {
          p1_html:
            'Your order No. %{order_id} for "%{product_name}" starts in %{days_to_start} days, that is on %{stock_start_date}!',
          p2_html:
            'We hope that your plans have not changed. If, however, they have, please contact us. As a reminder, we are sending you details of your order. We have provided you with a printable version of the order confirmation in the previous email. However, if you cannot find it, you can download a .pdf file from <a href="%{customer_pdf_order_url}">the following link</a>.',
        },
        saas: {
          p1_html:
            'Your order No. %{order_id} for "%{product_name}" starts in %{days_to_start} days, that is on %{stock_start_date}!',
          p2_html:
            'We hope that your plans have not changed. If, however, they have, please contact us. As a reminder, we are sending you details of your order. We have provided you with a printable version of the order confirmation in the previous email. However, if you cannot find it, you can download a .pdf file from <a href="%{customer_pdf_order_url}">the following link</a>.',
        },
        subject: 'Your order for "%{product_name}" starts in %{days_to_start} days.',
      },
      order_company_approval_time_limit_exceeded_company_email: {
        line1:
          'Unfortunately, we had to reject your pre-order No. %{order_id} from %{customer_full_name} for "%{product_name}" (%{stock_time_range}), since we did not receive a response from you in time. ',
        line2: "If you do not have free places at a given date, please update the availability in the Partner Panel. ",
        subject:
          "The order No. %{order_id} has been rejected - you did not confirm it in time (customer: %{customer_full_name})",
        line1_html:
          'Unfortunately, we had to reject your pre-order No. <a href="%{partnerapp_order_url}">%{order_id}</a> from %{customer_full_name} for "%{product_name}", (%{stock_time_range}), since we did not receive a response from you in time. ',
      },
      order_company_approval_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>Unfortunately, we had to reject your order No. %{order_id} for "%{product_name}" (%{stock_time_range})</strong>, since we did not receive the Partner %{company_name} response to your order in time %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "We will refund received payment %{confirmation_installment_paid_amount} to your bank account in next 24 hours. ",
        },
        saas: {
          line1_html:
            '<strong>Unfortunately, we had to automatically reject your order No. %{order_id} for "%{product_name}" (%{stock_time_range})</strong>, since the max. time for confirmation has been exceeded - %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "We will refund received payment %{confirmation_installment_paid_amount} to your bank account in next 24 hours. ",
        },
        subject:
          "The order No. %{order_id} has been rejected - we did not receive an order confirmation in required time. ",
      },
      order_current_status_customer_email: {
        marketplace: {
          p1: "We are sending you a current order status.",
        },
        saas: {
          p1: "We are sending you a current order status.",
        },
        subject: 'Order No. %{order_id}, current status: %{status_i18n} ("%{product_name}")',
      },
      order_finished_add_opinion_reminder_customer_email: {
        marketplace: {
          add_review: "Add your opinion",
          contact_us:
            "If you have any comments about work of our system Tripsomnia or a customer service, please, contact us!",
          share_your_opinion_html:
            "Help other tourists and leave your opinion about the Company %{company_link} and the offer %{product_link}.",
          thank_you_html: "Thank you for placing your order via Tripsomnia and using the Company services. ",
        },
        saas: {
          add_review: "Add your opinion",
          contact_us:
            "If you have any comments about work of our system Tripsomnia or a customer service, please, contact us!",
          share_your_opinion_html:
            "Help other tourists and leave your opinion about the Company %{company_link} and the offer %{product_link}.",
          thank_you_html: "Thank you for using our services.",
        },
        subject: 'Add your opinion about: "%{product_name}" (%{company_name})',
      },
      order_is_approved_company_email: {
        no_online_deposit_subject: "Order No. %{order_id} has been confirmed (customer: %{customer_full_name})",
        online_deposit_after_company_approval_subject:
          "Order No. %{order_id} has been confirmed and paid (customer: %{customer_full_name})",
        online_deposit_before_company_approval_subject:
          "Order No. %{order_id} has been paid and confirmed (customer: %{customer_full_name})",
        online_deposit_paid:
          'The customer has paid the deposit %{confirmation_installment_paid_amount} for the order No. %{order_id} for %{product_name}. The order status has changed into "confirmed". ',
        order_approved: 'The order No. %{order_id} for "%{product_name}"  has been confirmed.',
        order_cant_be_cancelled_now: "From now on, you can no longer cancel this order.",
        order_infos_below:
          "Order details are presented below. In attachments you will find a .pdf voucher with order confirmation, that has been sent to the customer. ",
        remember_to_set_order_as_finished: 'After completing the order, remember to mark it as "Finished".  ',
        voucher: {
          line1_html:
            "Rezerwacja z wykorzystaniem <strong>Bonu Turystycznego</strong>. Po przyjeździe klienta na miejsce zrealizuj Bon na stronie https://bonturystyczny.zus.pl/ oraz przyjmij ewentualną dopłatę reszty kwoty.",
          line2_html:
            "Aby zrealizować Bon poproś klienta o podanie numeru <strong>Bonu oraz kodu autoryzacji płatności</strong>, który otrzyma SMS-em w momencie realizacji. Możesz również poprosić klienta o weryfikację bonu przed przyjazdem kontaktując się z klientem telefonicznie lub e-mailowo.",
        },
      },
      order_is_approved_customer_email: {
        marketplace: {
          bank_wire_deposit_additional_info:
            "In a transfer title please place only the order number, which you can find in this confirmation. Otherwise, we cannot guarantee that the transfer will be booked in time.",
          bank_wire_deposit_deadline_html:
            "<strong>Remember to pay in time.</strong> If you don't make a deposit transfer until the specified period, your order may be cancelled.",
          bank_wire_deposit_make_html: "Please pay with bank transfer",
          bank_wire_deposit_required: "This order requires an additional payment on bank account.",
          order_approved_by_company:
            'Your order No. %{order_id} for "%{product_name}" has been confirmed by %{company_name}!',
          order_created: "Thank you for placing your order via Tripsomnia!",
          order_data_and_deposit_received:
            "We have received all necessary information from you as well as your online payment.",
          order_data_received: "We have received all necessary information from you.",
          this_is_confirmation:
            "This email is your order confirmation. Attached you will find a confirmation with all important information. Please have it with you on your mobile phone or printed.",
          order_approved_by_customer: 'Your order No. %{order_id} for "%{product_name}" has been confirmed. ',
          voucher: {
            line1_html:
              "Rezerwacja z wykorzystaniem <strong>Bonu Turystycznego</strong>. Po przyjeździe na miejsce zrealizuj Bon oraz dopłać ewentualną pozostałą kwotę.",
            line2_html:
              "Aby zrealizować Bon podaj sprzedawcy <strong>kwotę, którą chcesz zapłacić oraz numeru Bonu</strong>. Następnie podaj <strong>kod autoryzacji płatności</strong>, który otrzymasz SMS-em w momencie realizacji. Obiekt może również skontaktować się z Tobą wcześniej telefonicznie lub e-mailowo w celu realizacji Bonu, aby potwierdzić rezerwację.",
          },
        },
        saas: {
          bank_wire_deposit_additional_info:
            "In a transfer title please place only the order number, which you can find in this confirmation. Otherwise, we cannot guarantee that the transfer will be booked in time.",
          bank_wire_deposit_deadline_html:
            "<strong>Remember to pay in time.</strong> If you don't make a deposit transfer until the specified period, your order may be cancelled.",
          bank_wire_deposit_make_html: "Please pay with bank transfer",
          bank_wire_deposit_required: "This order requires an additional payment on bank account. ",
          order_approved_by_company: 'We have confirmed your order No. %{order_id} for "%{product_name}"!',
          order_created: "Thank you for your order!",
          order_data_and_deposit_received:
            "We have received all necessary information from you as well as your online payment.",
          order_data_received: "We have received all necessary information from you.",
          this_is_confirmation:
            "This email is your order confirmation. Attached you will find a confirmation with all important information. Please have it with you on your mobile phone or printed.",
          order_approved_by_customer: 'Your order No. %{order_id} for "%{product_name}" has been confirmed. ',
          voucher: {
            line1_html:
              "Rezerwacja z wykorzystaniem <strong>Bonu Turystycznego</strong>. Po przyjeździe na miejsce zrealizuj Bon oraz dopłać ewentualną pozostałą kwotę.",
            line2_html:
              "Aby zrealizować Bon podaj sprzedawcy <strong>kwotę, którą chcesz zapłacić oraz numeru Bonu</strong>. Następnie podaj <strong>kod autoryzacji płatności</strong>, który otrzymasz SMS-em w momencie realizacji. Możemy również skontaktować się z Tobą wcześniej telefonicznie lub e-mailowo w celu realizacji Bonu, aby potwierdzić rezerwację.",
          },
        },
        subject: 'Confirmation of the order No. %{order_id} for "%{product_name}"',
      },
      order_is_waiting_for_company_approval_company_email: {
        confirmation_deadline_warning:
          'Please check below order details and click "Confirm order" if you can complete the order.\nIf an order is not confirmed in time, it will be automatically cancelled. In case you cannot complete the order at a given date, please contact with the customer and offer another date or another offer. If the order cannot be completed, please click "Reject order". You can also reject the order and stop selling on this date, by click another button.',
        future_online_deposit_info:
          "If you confirm the order, the customer will have %{confirmation_installment_after_company_approval_time_limit} hours for making the online deposit payment %{confirmation_installment_st_name_d} for %{confirmation_installment_transaction_amount}.",
        order_received: 'We have received a pre-order No. %{order_id} for "%{product_name}".',
        past_online_deposit_info:
          "The Customer made an online payment %{confirmation_installment_st_name_b} for %{confirmation_installment_paid_amount} for securing the pre-order. In case the order is rejected by you, payment %{confirmation_installment_st_name} will be automatically refunded to the customer. ",
        please_confirm: "Please confirm the order in maximum 48 h. Otherwise it will reject automatically.",
        subject: "Order No. %{order_id} is waiting for confirmation (customer: %{customer_full_name})",
        order_approved_by_customer: 'Customer has confirmed the pre-order No. %{order_id} for "%{product_name}".',
        voucher: {
          line1_html:
            "Rezerwacja z wykorzystaniem <strong>Bonu Turystycznego</strong>. Po przyjeździe klienta na miejsce zrealizuj Bon na stronie https://bonturystyczny.zus.pl/ oraz przyjmij ewentualną dopłatę reszty kwoty.",
          line2_html:
            "Aby zrealizować Bon poproś klienta o podanie numeru <strong>Bonu oraz kodu autoryzacji płatności</strong>, który otrzyma SMS-em w momencie realizacji. Możesz również poprosić klienta o weryfikację bonu przed przyjazdem kontaktując się z klientem telefonicznie lub e-mailowo.",
        },
      },
      order_is_waiting_for_company_approval_customer_email: {
        marketplace: {
          company_approval_deadline:
            "Standard response time of the Company is %{company_approval_time_limit}, however during working hours they usually respond within an hour.",
          order_is_waiting_for_company_approval:
            'Order No. %{order_id} for "%{product_name}" is waiting for the Company %{company_name} confirmation. ',
          thank_you_for_order: "Thank you for placing your pre-order via Tripsomnia.",
          thank_you_for_order_and_online_deposit:
            "Thank you for placing your pre-order via Tripsomnia and an online %{confirmation_installment_st_name_d} payment for %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "If your order is confirmed, you will receive an email notification with a link to online payment of {confirmation_installment_st_name_d} deposit for %{confirmation_installment_amount}. You have %{confirmation_installment_after_company_approval_time_limit} to make the payment by our online payment system from the moment of order confirmation by the Partner.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "If the payment is not made, your order will be automatically rejected.",
          what_with_no_deposit_if_order_gets_approved:
            "If your order is confirmed, you will receive an email notification with an order confirmation containing the payment details.",
          what_with_paid_deposit_if_order_gets_approved:
            "If the order is accepted, the paid amount will be assigned to the order. If the Company rejects the request or does not confirm it in time, your deposit will be automatically refunded to your bank account within 24 hours. You may then place another order.",
          thank_you_for_order_approval: "Thank you for confirming the pre-order through Tripsomnia",
        },
        saas: {
          company_approval_deadline:
            "Standard response time is %{company_approval_time_limit} hours but during working hours we usually respond within an hour.",
          order_is_waiting_for_company_approval:
            'The order No. %{order_id} for "%{product_name}" is awaiting our confirmation.',
          thank_you_for_order: "Thank you for your pre-order.",
          thank_you_for_order_and_online_deposit:
            "Thank you for your pre-order and an online %{confirmation_installment_st_name_d} deposit payment for %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "If your pre-order is confirmed, you will receive an email notification with a link to online payment of {confirmation_installment_st_name_d} deposit for %{confirmation_installment_amount}. You have %{confirmation_installment_after_company_approval_time_limit} to make the payment by online payment platform from the moment of order confirmation.",
          what_with_future_deposit_if_order_gets_approved_l2: "If not paid, your order will be rejected.",
          what_with_no_deposit_if_order_gets_approved:
            "If your pre-order is confirmed, you will receive an email notification with an order confirmation containing the payment details. ",
          what_with_paid_deposit_if_order_gets_approved:
            "If we are forced to reject your request or let it expire, online %{confirmation_installment_st_name} will be automatically refunded to your bank account within 24 hour. You can also contact us and choose another offer.",
          thank_you_for_order_approval: "Thank you for confirming the pre-order",
        },
        subject: 'The order No. %{order_id} for "%{product_name}" is waiting for confirmation.',
      },
      order_is_waiting_for_confirmation_online_payment_company_email: {
        line1:
          'The order No. %{order_id} for "%{product_name}" has been confirmed and it is waiting for customer\'s online %{confirmation_installment_transaction_amount} payment by our online payment system. ',
        line2: "If the customer does not make a payment in time, the order will be automatically cancelled.",
        subject: "The order No. %{order_id} is awaiting for a payment (customer: %{customer_full_name})",
      },
      order_is_waiting_for_confirmation_online_payment_customer_email: {
        after_company_approval_subject: "The order No. %{order_id} is awaiting a payment (%{product_name})",
        default_subject: 'Order No. %{order_id} is awaiting for a payment ("%{product_name}")',
        marketplace: {
          deadline_warning: "If the payment is not made, your order will be automatically rejected.",
          order_approved: 'We recived your order No. %{order_id} for "%{product_name}".',
          pay_button: "Pay online",
          payment_deadline: "Payment deadline: %{pauses_at}",
          please_pay:
            "Please make a payment for %{confirmation_installment_transaction_amount} by safe online payment system.",
        },
        saas: {
          deadline_warning: "In case the payment is not made, your order will be automatically rejected. ",
          order_approved: 'We received your order No. %{order_id} for "%{product_name}".',
          pay_button: "Pay online",
          payment_deadline: "Payment deadline: %{pauses_at}",
          please_pay:
            "Please make a payment for %{confirmation_installment_transaction_amount} by our safe online payment system.",
        },
      },
      order_is_waiting_for_customer_approval_customer_email: {
        marketplace: {
          action: "Confirm order",
          approval_deadline: "",
          deadline_warning: "If the order is not confirmed, your order will be automatically cancelled.",
          order_approved:
            'The Company %{company_name} sends details of your order No. %{order_id} for "%{product_name}".',
          please_approve: "Please confirm the order through the link below. ",
          approve_action: "Confirm order",
          reject_action: "Reject order",
        },
        saas: {
          action: "Confirm order",
          approval_deadline: "",
          deadline_warning: "In case your order is not confirmed, it will be automatically cancelled. ",
          order_approved: 'We confirmed your order No. %{order_id} for "%{product_name}".',
          please_approve: "Please confirm the order through the link below. ",
          approve_action: "Confirm order",
          reject_action: "Reject order",
        },
        subject: 'Please confirm the order No. %{order_id} ("%{product_name}")',
      },
      order_online_deposit_time_limit_exceeded_company_email: {
        line1:
          'Unfortunately, we had to reject the pre-order No. %{order_id} from %{customer_full_name} for "%{product_name}" (%{stock_time_range}), since the customer did not make an online payment in time. Contact the cutomer to clarify the circumstances and renew the contact. ',
        subject:
          "The order No. %{order_id} has been rejected - the customer did not make a payment %{confirmation_installment_st_name_d} in time (customer: %{customer_full_name})",
      },
      order_online_deposit_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>Unfortunately, we had to reject your order No. %{order_id} for "%{product_name}"</strong>, since the payment has not been made in time. ',
          line2:
            "We will refund received payment %{confirmation_installment_paid_amount} to your bank account in next 24 hours. ",
          line3_html: "If you would like to order the offer one more time, please go to the subpage: %{product_link}",
        },
        saas: {
          line1_html:
            '<strong>Unfortunately, we had to reject your order No. %{order_id} for "%{product_name}" (%{stock_time_range})</strong>, since the payment has not been made in time. ',
          line2:
            "We will refund received payment %{confirmation_installment_paid_amount} to your bank account in next 24 hours. ",
          line3_html: "If you would like to order the offer one more time, please go to the subpage: %{product_link}",
        },
        subject:
          "The order No. %{order_id} has been rejected - you did not make a payment %{confirmation_installment_st_name_d} in time ",
      },
      order_online_payment_reminder_customer_email: {
        marketplace: {
          contact_us_if_problems: "If you have any problems with the order, please, contact us. ",
          line1:
            'We have not received your payment for the pre-order No. %{order_id} for "%{product_name}" so far. Since the payment time was exceeded, we had to cancel your pre-order. However, you can place an order once again. ',
          offer_details_below: "Details of the offer below:",
        },
        saas: {
          contact_us_if_problems: "If you have any problems with the order, please, contact us.",
          line1:
            'We have not received your payment for the pre-order No. %{order_id} for "%{product_name}" so far. Since the payment time was exceeded, we had to cancel your pre-order. However, you can place an order once again. ',
          offer_details_below: "Details of the offer below:",
        },
        subject: 'Reminder: complete your order for "%{product_name}"',
      },
      order_company_rejected_company_email: {
        line1: 'You have rejected the pre-order No. %{order_id} from %{customer_full_name} for "%{product_name}".',
        line2:
          "If you want to change the date, sales limit or other settings of your offer, please make an update in the Partner Panel.",
        subject: "Order No. %{order_id} has been rejected (customer: %{customer_full_name})",
        line1_html:
          'You have rejected the pre-order No. <a href="%{partnerapp_order_url}">%{order_id}</a> from %{customer_full_name} for "%{product_name}".',
      },
      order_company_rejected_customer_email: {
        marketplace: {
          line1:
            'The Company %{company_name} has rejected your order No. %{order_id} for "%{product_name}", because of no free places for %{stock_time_range}.',
          see_offer_html: "See the offer in other dates: %{product_link}",
          confirmation_installment_refund_info:
            "We will refund received payment %{confirmation_installment_paid_amount} to your bank account in next 24 hours. ",
        },
        saas: {
          line1:
            'We have rejected your order No. %{order_id} for "%{product_name}", because of no free places for %{stock_time_range}.',
          see_offer_html: "See the offer in other dates: %{product_link}",
          confirmation_installment_refund_info:
            "We will refund received payment %{confirmation_installment_paid_amount} to your bank account in next 24 hours. ",
        },
        subject: 'The order No. %{order_id} for "%{product_name}" has been rejected',
      },
      order_customer_rejected_company_email: {
        line1: 'Customer has rejected pre-order No. %{order_id} from %{customer_full_name} for "%{product_name}".',
        subject: "Order No. %{order_id} has been rejected by the customer (customer: %{customer_full_name})",
      },
      order_customer_rejected_customer_email: {
        marketplace: {
          line1: 'Your order No. %{order_id} for "%{product_name}" has been rejected.',
          see_offer_html: "See offer once again: %{product_link}",
          confirmation_installment_refund_info:
            "We will refund your payment of %{confirmation_installment_paid_amount} to your account within the next 24 hours.",
        },
        saas: {
          line1: 'Your order No. %{order_id} for "%{product_name}" has been rejected. ',
          see_offer_html: "See offer once again: %{product_link}",
          confirmation_installment_refund_info:
            "We will refund your payment of %{confirmation_installment_paid_amount} to your account within the next 24 hours.",
        },
        subject: 'Your order No. %{order_id} for "%{product_name}" has been rejected. ',
      },
      order_current_status_company_email: {
        line1: "We are sending you a current order status. ",
        subject: "Order no. %{order_id}, current status: %{status_i18n} (customer: %{customer_full_name})",
      },
      order_company_cancelled_company_email: {
        line1: 'Order No. %{order_id} from %{customer_full_name} for "%{product_name}" was cancelled.',
        subject: "The order No. %{order_id} has been cancelled ",
        line1_html:
          'Order No. <a href="%{partnerapp_order_url}">%{order_id}</a> from %{customer_full_name} for "%{product_name}" was cancelled.',
      },
      order_company_cancelled_customer_email: {
        marketplace: {
          line1:
            '%{company_name} has cancelled your order No. %{order_id} for "%{product_name}" on %{stock_time_range}.',
          see_offer_html: "See offer in different dates: %{product_link}",
          confirmation_installment_refund_info:
            "Received payment %{confirmation_installment_paid_amount} will be refunded to you bank account in next 24 hours. ",
        },
        saas: {
          line1: 'We have cancelled your order No. %{order_id} for "%{product_name}" on %{stock_time_range}.',
          see_offer_html: "See offer in different dates: %{product_link}",
          confirmation_installment_refund_info:
            "Received payment %{confirmation_installment_paid_amount} will be refunded to you bank account in next 24 hours. ",
        },
        subject: 'Order No. %{order_id} for "%{product_name}" has been cancelled',
      },
      order_abandonment_followup_customer_email: {
        see_product: "See again: %{product_name}",
        find_other_products_in_this_location: "Find other offers in a similar location:",
        line1:
          'recently you have been browsing the following offer: "%{product_name}". Are you still interested in it?',
        subject: 'See similar offers to "%{product_name}"',
        go_to_product: "See the offer",
      },
    },
    papp: {
      components: {
        EditableBillRow: {
          placeholder: "Enter name",
        },
        InstallmentFormSection: {
          exact_date_label: "Exact date",
          how: "How?",
          on_stock_starts_at_label: "When offer begins",
          paid_after_company_approval_label: "If the date requires confirmations, ask the customer to prepay first",
          remaining_amount: "Remaining amount",
          when: "When?",
          whole_amount: "Whole amount",
          x_days_after_order_creation_label: "after sending the order",
          x_days_after_order_full_approval_label: "after order approval",
          x_days_after_previous_installment_label: "after previous installment",
          x_days_before_stock_starts_at_label: "before beginning of the offer",
          how_much: "How much?",
          to: "To?",
        },
        InstallmentsListFormSection: {
          add_new: "Add new installment",
        },
        LocationFormControl: {
          placeholder: "Enter location",
        },
        MainView: {
          default_error_title: "Server connection error",
          error_date: "Error date",
          error_description: "If the error reappears, please contact us via %{email}.",
          error_id: "Error ID",
          loading: "Loading",
          retry: "Retry",
        },
        MultipleDateFormControl: {
          add_new: "Add date",
        },
        MultipleInputFormControl: {
          placeholder: "Add another line",
        },
        MultipleTimeFormControl: {
          add_new: "Add an hour",
        },
        OrderSidebarPreview: {
          edit_slot: "Edit slot",
          see_slot: "See date",
        },
        PaginationNavigation: {
          out_of: "of",
        },
        PaymentProfileProductAttachmentFormSection: {
          active: "Active",
          additional_fee: "Payment",
          days_before_arrival_date_limit: "Chosen date",
          days_before_arrival_date_limit_label: "In advance",
          installment: "Installment",
          no_date_limit: "Always",
        },
        ProductCustomerOrderFieldFormSection: {
          add_list_option: "Add list option",
          add_new: "Add new ",
          show_on_manifest: "Show on List of Participants",
          value_required: "Value required",
          value_type: "Value type",
        },
        ProductPricedOrderFieldFormSection: {
          add_list_option: "Add list option",
          ask_customer: "Ask customer",
          different_currency_base_amount_note:
            "Additional options defined in a currency other than the Bid Currency are always counted beyond the base cost.",
          for_all_variants: "For all variants",
          remove: "Remove",
          show_on_manifest: "Show on List of Participants",
          value_type: "Value type",
        },
        SlotsCalendar: {
          agenda: "List",
          allDay: "All day",
          availability_mode: "Availability",
          date: "Date",
          day: "Day",
          event: "Event",
          month: "Month",
          next: "Next",
          previous: "Previous",
          price_mode: "Prices",
          showMore: "%{count} więcej...",
          time: "Time",
          today: "Today",
          week: "Week",
          slot_confirmed: "Date confirmed",
        },
        TagsInputFormControl: {
          addition_label: "Add:",
          no_results_message: "No results",
          placeholder: "Add next",
        },
        TypeaheadInputFormControl: {
          no_results_message: "No results",
          placeholder: "Everything",
        },
        SaleWindowRuleFormGroup: {
          sale_starts_at_label: "Sale opening",
          sale_ends_at_label: "Sale closing",
          offset_label: "in advance",
          from_date_label: "from date",
          until_date_label: "until date",
          before_slot_start: "before the date",
          resolved_preview: "For the date %{slot} this falls on %{resolved}.",
        },
        UsebyDateRangeFormGroup: {
          days_limit_label: "x days",
          days_since_order_creation: "days since order",
          ends_at_label: "until",
          starts_at_and_ends_at_label: "in days",
          starts_at_label: "from day",
        },
        ProductsListItem: {
          preview_marketplace: "Show",
          preview_saas: "WWW",
          new_order: "Book",
          active_switch_label: "Active",
          published_on_saas_switch_label: "WWW",
        },
        OrderedProductOrderFieldFormControl: {
          custom_location_name_placeholder: "Enter the customer's address",
        },
        ProductsSelectControl: {
          blank_label: "No offer assigned",
        },
      },
      order: {
        approve: "Confirm",
        cancel_order: "Cancel order",
        confirm: "Send",
        customer_name_placeholder: "No customer information.",
        delete_order: "Delete the order",
        finish: "Finish",
        redeliver_customer_order_email: "Send order details",
        reject: "Reject",
        redeliver_supplier_order_email: "Send order details to Supplier",
        finish_order: "Finish order",
        automatic_icon: "A",
        manual_icon: "M",
        no_stock_date: "No date",
      },
      common: {
        search: "Search...",
        no_results_message: "No results",
        discard_changes_confirm_message:
          "You haven't saved your changes. Are you sure you want to leave without finishing?",
        go_back: "Go back",
        remove: "Delete",
        save: "Save",
        none: "none",
        poland: "Poland",
        edit: "Edit",
        manage: "Manage",
        save_changes: "Save changes",
        submit_success_message: "Changes saved.",
        default_value: "By default: %{value}",
        attention: "Notice",
        no_name: "(no name)",
        close: "Close",
        in_total: "Total",
        filters_title: "Filter",
        form_validation_error_message: "One of fields in the form is filled out incorrectly.",
        cancel: "Cancel",
        go_next: "Continue",
        st_email: "cooperation@tripsomnia.com",
        st_phone_number: "+48 690 670 581",
        are_you_sure: "Are you sure?",
        translations_locale: "Choose locale",
        x_per_page: "%{count} per page",
        show_filters: "Show filters",
        hide_filters: "Hide filters",
        download_csv: "Download CSV",
        weekdayAbbreviations: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      },
      agents: {
        AgentsListView: {
          title: "Agents",
          add_new: "Invite agent",
          no_records_title: "No agents",
          no_records_message: "No agent has been invited to cooperation yet.",
          no_records_add_new_link: "Add new?",
        },
        EditAgentCooperationView: {
          default_pricing: "Default pricing",
          activate_all: "Activate all",
          remove_confirm_message: "Are you sure you want to cancel this cooperation?",
          title: "Agency cooperation",
          title_with_company_name: "Agency cooperation with %{company_name}",
          products: "Offers",
          price_change: "Increase / decrease by",
          gross_price: "Gross price",
          net_price: "Net price",
          include_product_options_price: "include additional options",
          st_cooperation_hint: {
            p1: "Cooperation with Tripsomnia",
            p2: "You cannot edit our cooperation conditions.",
            p3: "If you would like to make any changes, please, contact your assistant via phone or email: %{tel} or %{email}.",
          },
        },
        NewAgentPrompt: {
          title: "New agent",
          email_label: "Agent's e-mail",
          submit: "Invite to cooperation",
        },
        SuppliersListView: {
          title: "Suppliers",
          no_records_title: "No suppliers",
          no_records_message: "No invitations have been received from another agency cooperation provider.",
          add_new: "Invite the organizer to cooperate",
        },
      },
      app: {
        App: {
          fetch_app_error_title: "Server connection error.",
        },
        ForbiddenView: {
          title: "Error 403",
          message: "Access denied.",
        },
        LeftBar: {
          dashboard: "Dashboard",
          calendar: "Calendar",
          orders: "Orders",
          products: "Offers",
          customers: "Customers",
          agents: "Agents",
          suppliers: "Suppliers",
          finances: "Finances",
          raports: "Reports",
          settings: "Settings",
          reviews: "Reviews",
          affiliate: "Finances",
          accommodation: "Accommodation",
          connectly: "Connectly"
        },
        NotFoundView: {
          title: "Error 404",
          message: "Page not found",
        },
        requireAuth: {
          company_forbidden: "You do not have access to that company (ID: %{company_id}).",
          no_companies_error_title: "No companies attached to your account",
        },
        TopBar: {
          logout: "Log out",
          marketplace_homepage: "Tripsomania",
          new_order: "Book",
          saas_homepage: "Your website",
          your_account: "User settings",
        },
      },
      auth: {
        LoginView: {
          send_confirmation_instructions_link: "Resend activation link.",
          send_reset_password_instructions_link: "Remind password",
          send_unlock_instructions_link: "My account is blocked.",
          submit: "Log in",
          title: "Login to the Tripsomnia panel",
        },
        ResetPasswordView: {
          submit: "Change password",
          title: "Generate new password",
        },
        SendResetPasswordInstructionsView: {
          email_help: "We will send you a link to generate a new password for your account.",
          email_label: "Your email address",
          submit: "Send",
          success_message: "We've sent you an e-mail with a link to generate a new password. Please check your inbox.",
          title: "Remind password",
        },
        index: {
          fetch_user_failed_message: "Your session has expired. Please log in again.",
        },
      },
      calendar: {
        CalendarView: {
          all_products: "All products",
          all_suppliers: "All suppliers",
          title: "Booking calendar",
          filter_all: "All",
          filter_available: "Available",
          filter_awaiting: "Awaiting",
          filter_booked: "Booked",
          show_inactive_offers: "Show inactive offers",
        },
        ShowSlotModal: {
          active_orders_title: "Active orders",
          build_order: "Book",
          no_orders_message: "No orders for this day.",
          open_manifest: "Show List of Participants",
          open_manifest_failure_message: "Error while downloading the List of Participants.",
          other_orders_title: "Other orders",
          download_manifest: "Download manifest",
          booked_orders_title: "Booked",
          pending_orders_title: "Pending",
          awaiting_orders_title: "Awaiting",
          sale_window_title: "Sale window",
          sale_starts_at_label: "Sale opening",
          sale_ends_at_label: "Sale closing",
          within_sale_window_yes: "Currently sellable",
          within_sale_window_no: "Outside sale window",
          within_sale_window_past: "Date already passed",
          biledo_block_title: "Biledo linkage",
          biledo_term_uuid: "Term UUID",
          biledo_pricelist_uuid: "Pricelist UUID",
          biledo_overwrite_warning: "Your edit will be overwritten on the next Biledo sync.",
        },
      },
      customers: {
        CustomersListView: {
          no_records_add_new_link: "Add?",
          no_records_message: "No customer has been created yet",
          no_records_title: "No customers",
          title: "Customers",
          query_filter: "Name, email or phone",
          add_new_customer: "New customer",
        },
        EditCustomerModal: {
          existing_customer_title: "Customer edition",
          new_customer_title: "New customer",
          remove_confirm_message: "Are you sure you want to delete this customer?",
        },
        ShowCustomerView: {
          no_name: "(no name)",
          orders_title: "Orders",
          title: "customer",
        },
      },
      dashboard: {
        DashboardView: {
          created_orders_number_label: "Number of created orders",
          finished_orders_number_label: "finished orders",
          finished_orders_total_amount_label: "Finished orders total amount",
          new_orders_title: "New orders (last 30 days)",
          no_graph_data_message: "No data to display statistics.",
          no_orders_waiting_message: "No orders to confirm",
          orders_number_label: "orders",
          orders_waiting_for_your_approval_title: "Orders waiting for confirmation",
          participants_number_label: "participants",
          see_all_orders: "See all (%{count})",
          title: "Dashboard",
          hint: {
            p1: "Start selling your offers",
            p2: "Complete user account and company settings.",
            p3: "Add offers: description, pricing and booking settings, then dates.",
            p4: "Create and insert widgets on your website.",
            p5: "Collect online orders from customers or add them yourself in the panel.",
            p6: "If you have any questions or concerns, please feel free to contact us by phone %{tel} or by email %{email}.",
            p2_html:
              'Complete your company\'s account settings by selecting the tab <a href="https://panel.tripsomnia.com/c/100/settings/company/account" target="_blank">Company details</a>.',
            p3_html:
              'Verify your account in the online payment system in the sub-tab <a href="https://panel.tripsomnia.com/c/100/settings/company/stripe" target="_blank">Payment registration</a>',
            p4_html:
              'Add offers by selecting the <a href="https://panel.tripsomnia.com/c/100/products" target="_blank">Offers</a> section on the left side of the screen. More information on how to correctly add an offer can be found in the <a href="http://partners.tripsomnia.com/183/tworzenie-ofert-wycieczek-i-atrakcji/" target="_blank">knowledge base</a>.',
            p7: "If you have any questions or concerns, please feel free to contact us via chat, by phone %{tel} or by email %{email}.",
            p6_html:
              'Find out more about the Partner Panel and take advantage of its advanced features, to sell your offers as efficiently as possible, by reading our <a href="http://partners.tripsomnia.com/category/panel-partnera/" target="_blank">knowledge base</a>.',
          },
          stats_title: "Statistics (%{date_from} - %{date_to})",
        },
      },
      finances: {
        FinancesListView: {
          no_records_message: "No orders added.",
          no_records_title: "No orders.",
          title: "Finances",
          summary_row: "In total (for rows %{start}-%{end}):",
          create_agent_disbursement: "Agent disbursement",
          create_platform_disbursement: "Tripsomnia disbursement",
          agent_received_paid_th: "Agent received / paid",
          socialtravel_received_paid_th: "Tripsomnia received / paid",
          supplier_received_paid_th: "Supplier received / paid",
          orders_count: "%{count} orders",
        },
      },
      settings: {
        SettingsLayout: {
          title: "Settings",
          user: "User",
          user_account_settings: "User settings",
          company: "Company",
          company_account_settings: "Company details",
          company_members_settings: "Users access",
          products_settings: "Offer settings",
          payments_settings: "Payment settings",
          billing_settings: "Invoice details",
          integrations: "Integrations",
          marketplace_settings: "Marketplace Tripsomnia",
          saas_settings: "Your website",
          widgets_settings: "Widgets",
          readonly_access_message:
            "You cannot update this data. In order to do so, log in as the Company administrator.",
          stripe: "Payment registration",
        },
        BillingSettingsView: {
          title: "Company details",
          invoice_company_name_placeholder: "By default: Company name (%{default_value})",
          invoice_contact_email_placeholder: "By default: Company email address(%{default_value})",
          invoice_contact_phone_number_placeholder: "By default: Company contact numer (%{default_value})",
          invoice_details_title: "Invoice details",
          hint: {
            p1: "Invoice details",
            p2: "Enter the company data for invoices",
          },
        },
        CompanyMembersView: {
          title: "Users",
          new_member: "Add company user",
          no_members: "No members",
          hint: {
            p1: "Adding users",
            p2: "Grant access to your company to others. For a new account, you can assign admin or employee rights (limited access).",
          },
        },
        CompanySettingsView: {
          title: "Company details",
          contact_details: "Contact details for your customers",
          contact_phone_number_placeholder: "e.g +48 690 670 581",
          notifications_details: "Data for order processing",
          notifications_email_placeholder: "By default: Company email (%{default_value})",
          notifications_email_label: "Addresses to confirm orders",
          notifications_phone_number_placeholder: "By default: Company contact numer (%{default_value})",
          notifications_phone_number_label: "Cell number (with country code)",
          other_details: "Other settings",
          hint: {
            p1: "Name",
            p2: "Short name for communication the Partner Panel",
            p3: "Profile photo",
            p4: "Visible in the Partner Panel and for customers. It is best to insert a company logo.",
            p5: "Contact details",
            p6: "Will be displayed to customer in order confirmation.",
            p7: "Data for order processing",
            p8: "To presented email address will be sent notifications and order confirmation requests.",
            p9: "Main language",
            p10: "In this language our system will communicate with your company via email.",
            p11: "Time zone",
            p12: "The dates of your offers in the Panel will be added in selected time zone. If you change this setting, it will not affect dates already added.",
          },
        },
        MarketplaceSettingsView: {
          title: "Marketplace Tripsomnia",
          marketplace_homepage_url_label: "Your company's address on martkeplace",
          hint: {
            p1: "Your company profile on Tripsomnia",
            p2: "The information will be displayed to customers on your company subpage on our Tripsomnia sales platform.",
          },
        },
        PaymentsSettingsView: {
          title: "Payment settings",
          your_profiles_title: "Your customer payment profiles",
          marketplace_profiles_title: "Tripsomnia's customer payment profiles",
          add_new_profile: "Add a new profile",
          hint: {
            p1: "Default offer currency",
            p2: "Select the default currency to simplify offers configuration.",
            p3: "Bank transfer details",
            p4: "The information you provide in this box will be sent to customers who have booked an offer with a bank account payment profile.",
            p5: "Payment profiles for your company customers",
            p6: "Edit and add payment profiles for your company customers",
            p7: "Payment profiles for Tripsomnia customers",
            p8: "These payment profiles are offered by us in our cooperation framework. To edit these profiles, please contact your advisor.",
          },
          no_your_profiles_warning:
            "Add at least one payment profile for your customers. Otherwise, they will not be able to place orders on your Website.",
          enable_for_all_product_variants: "Enable for all offers",
          access_possible_only_for_supplier:
            "Payment profiles managment is possible only if you are offers Supplier. Contact your offers suppliers, to know which payment profiles are available for ",
          increase_orders_amount_by_saas_commision_label:
            "Add a fee for our system commission to the total order amount",
          increase_orders_amount_by_saas_commision_enabled_hint: "The customer will cover the system fee",
          increase_orders_amount_by_saas_commision_disabled_hint: "Your company will cover the system fee",
        },
        ProductsSettingsView: {
          title: "Offer settings",
          hint: {
            p1: "Terms and Conditions",
            p2: "Place here text of the Terms and Conditions which customers will have to accept when booking your offers.",
            p3: "Mobile voucher",
            p4: "Check if you require the customer to print out a confirmation / voucher. If you do not check it, customers will be able to show the order on their smartphone.",
          },
        },
        SaasSettingsView: {
          title: "Your website",
          saas_homepage_url: "Your website address",
          contact_us_if_want_to_change: "If you wish to change it, contact us.",
          hint: {
            p1: "Your website",
            p2: "This information will be displayed to customers on your dedicated website.",
          },
        },
        UserAccountView: {
          title: "User settings",
          site_settings_title: "Account settings",
          password_change_title: "Change your password",
          hint: {
            p1: "User account settings",
            p2: "These settings affect only the area of your user account. They do not affect your main company settings.",
          },
        },
        WidgetsSettingsView: {
          title: "Widgets",
          iframe: "IFrame",
          button: "Button",
          navbar: "Navbar",
          detect_from_visitor_browser: "From user's browser",
          locale: "Website language",
          currency: "Customer's currency",
          bubble: "Bubble",
          active: "Publish",
          scrollWidget: "Activate the pop-up widget after scrolling to the end of the page",
          exitWidget: "Activate the pop-up widget when the client tries to leave the page",
        },
        ButtonWidgetView: {
          book_now: "Book now",
          small_size: "Small",
          normal_size: "Normal",
          large_size: "Large",
          bottom_right: "bottom right corner",
          bottom_left: "bottom left corner",
          top_right: "top right corner",
          top_left: "top left corner",
          in_modal: "in modal",
          in_new_tab: "in new tab",
          title: "Button",
          button_content: "Button content",
          open: "Open",
          color: "Color",
          size: "Size",
          stick_to_window_corner: "Position",
          generate_code: "Save",
          place_code_anywhere:
            "Place this code anywhere on your site. We suggest you place it in the beginning, just before %{head}, or in the head, just before %{body_end}.",
          put_widget_anywhere:
            "Instead of using fix widget positions you can also place the desired widget anywhere you choose.",
          preview: "Preview",
          button_type: "Normal button",
          flag_type: "Flag",
          what_type: "Button type",
          center_right: "right center",
          center_left: "left center",
        },
        NavBarWidgetView: {
          new_link: "Add an element",
          our_products: "Our offer",
          products_calendar: "Offer calendar",
          book: "Book",
          white_blue: "white with blue tone",
          white_teal: "white with green tone",
          white_orange: "white with orange tone",
          black_blue: "black with blue tone",
          black_teal: "black with green tone",
          black_orange: "black with orange tone",
          blue: "blue",
          teal: "green",
          orange: "orange",
          to_window_bottom: "bottom of the window",
          to_window_top: "top of the window",
          in_modal: "in modal",
          in_new_tab: "in a new window",
          none: "Nothing to show",
          company_name: "Company name",
          company_logo: "Company logo",
          title: "Navbar",
          show_company_name: "Show company name",
          show_toggle_button: "Show toggle button",
          open: "Open",
          color: "Color",
          stick: "Position",
          cta_button: "Main button",
          navigation: "Tabs",
          contact: "Contact",
          generate_code: "Save",
          place_code_anywhere:
            "Place this code anywhere on your site. We suggest you place it in the beginning, just before %{head}, or in the head, just before %{body_end}.",
          put_widget_anywhere: "Next, place the desired widget anywhere you choose.",
          preview: "Preview",
          link_type_link: "Link",
          link_type_none: "None",
          link_type_text: "Content",
          link_type_phone: "Phone",
          link_type_email: "Email",
          link_type_custom_link: "Custom link",
          black: "black",
          white: "white",
          green: "green",
          type1: "Type 1",
          type2: "Type 2",
          type3: "Type 3",
          red: "red",
          percentage: "percent",
          activity: "offer",
          cart: "basket",
          notification: "notification",
          offer: "discount",
          search: "browser",
          star: "star",
          negotiate: "negotiate",
          discount: "discount",
          chat: "chat"
        },
        IframeWidgetView: {
          title: "IFrame",
          iframe_width: "IFrame width",
          iframe_height: "IFrame height",
          generate_code: "Generate code",
          put_widget_anywhere: "Copy and paste this code anywhere you want.",
          preview: "Preview",
        },
        WidgetRouteFormSection: {
          homepage_page: "Homepage",
          products_list_page: "List of offers",
          products_calendar_page: "Offer calendar",
          product_page: "Offer page",
          new_order_page: "Offer booking form",
          on_slot_click_show_product: "Offer page",
          on_slot_click_new_order: "Booking form for a specific date",
          type: "Type",
          product: "Offer",
          all_products: "All offers",
          on_slot_click_action_type: "Click on a date to open",
          reviews_page: "Reviews page",
          product_location_tag: "Location",
          product_location_tag_page: "Location page",
          product_category_tag: "Category",
          product_category_tag_page: "Category page",
          coupons_page: "List of promotions",
        },
        EditPaymentProfileModal: {
          profile_change_affects_all_products_warning:
            "Please note that any changes you make here will affect all offers all companies to which this payment profile is currently assigned.",
          remove_confirm_message: "Are you sure you want to remove this payment profile?",
          edit_profile_title: "Edit payment profile",
          new_profile_title: "New payment profile",
          name_label: "Profile's name'",
          name_hint:
            "It will be shown to the customer during the order creation, if he will have more than one profile to choose from.",
          has_additional_fee_label: "Additional fee",
          cancellation_policy_hint:
            "Until when can the order be cancelled? To what amount can the customer apply for the refund?",
          installments_label: "Payment installments",
          additional_fee_as_agent_fee_label: "Add the fee as an agent service fee",
        },
        EditCompanyMemberModal: {
          edit_member_title: "Edit company user",
          new_member_title: "Add company user",
          remind_password: "Remind password",
        },
        BubbleWidgetView: {
          balloon_line1_value: "All Excursions",
          balloon_line2_value: "Click here to get them!",
          balloon_line1_label: "First text line",
          balloon_line2_label: "Second text line",
          generate_code: "Save",
          large_size: "Large",
          normal_size: "Normal",
          place_code_anywhere:
            "Place this code anywhere on your site. We suggest you place it in the beginning, just before %{head}, or in the head, just before %{body_end}.",
          placement: "Position",
          preview: "Preview",
          put_widget_anywhere: "Next, place the desired widget anywhere you choose.",
          small_size: "Small",
          title: "Bubble",
          bottom_left_corner: "bottom left corner",
          bottom_right_corner: "bottom right corner",
          color_label: "Color",
          placement_label: "Position",
          size_label: "Size",
          top_left_corner: "top left corner",
          top_right_corner: "top right corner",
          show_after_label: "Show widget after",
          show_balloon_after_label: "Show description after",
          play_sound_label: "Play sound",
          animation_type: "Animation",
          icon: "Icon",
        },
        IndexWidgetsView: {
          header1: "Widget installation instructions",
          header2: "Older widgets",
          text1:
            "We encourage you to use our widgets on your website! To install a widget, copy and paste the following code anywhere on your website. We recommend pasting the code at the beginning, just before the </head> tag or before </body></html>.",
          text2:
            "As the next step, you can edit the Bubble or Button widget, choose appropriate settings, activate the widget and see the effect on your website.",
          text3:
            "It is our pleasure to inform you that we have introduced a range of changes to our widgets on 1 March 2019. Old widgets and their code will remain active and keep working, but we recommend performing an update and using new widgets.",
          text4:
            "Above mentioned are the numerous advantages of new widgets. In order to update the widgets, please delete the old code and follow the instructions for new widgets installation. Should you have any questions, please don't hesitate to contact us: info@tripsomnia.com",
          widgetCodeHasBeenCopied: "Widget code has been copied successfully!",
          widgetCodeHasnBeenCopied: "Copy widget code",
          copyWidgetCode: "Copy widget code",
        },
        StripeSettingsView: {
          title: "Payment registration - Stripe",
          stripe_verification_failure: "Unfortunately, your registration in Stripe was unsuccessful.",
          stripe_verification:
            "Click the link below to log in to the Stripe dashboard and view your settings, account balance, and payout history. You can also update your account details. For this you will need the phone number which you provided during registration to verify your identity.",
          stripe_verification_success: "Registration in STRIPE has been successfully completed.",
          line1_html:
            "Taking care of the highest standards of the security of online transactions, Tripsomnia cooperates with the global payment service provider Stripe. Verification of your company's account will allow you to transfer the funds from your sale and withdrawals directly to your bank account.",
          line2_html:
            "When starting the verification, you will be redirected to the Stripe form, which should take <strong>less than 10 minutes to complete</strong>",
          line4_html:
            "During the registration process, please <strong>provide only real data</strong> - it will shorten the verification process!",
          line3: "To register with Stripe you need:",
          line3_1: "Your e-mail address",
          line3_2: "The phone number to which the SMS verification code will be sent",
          line3_3: "Identity document (ID card, driving license)",
          line3_4: "Your company details",
          line5_html:
            "The Stripe form will also ask you to enter your company's website. <strong>If you do not have your own domain, please enter: tripsomnia.com</strong>",
          line6_html:
            'For more information on how to properly register with Stripe please go to Stripe official website <a href="https://stripe.com/docs/account/activate" target="_blank">here</a>.',
          line7:
            "If you have any questions or technical problems, please contact us: + 48 690-670-581, info@tripsomnia.com or by using our chat.",
          line1:
            "Taking care of the highest standards of the security of online transactions, Tripsomnia cooperates with the global payment service provider Stripe. Verification of your company's account will allow you to transfer the funds from your sale and withdrawals directly to your bank account.",
          line2:
            "When starting the verification, you will be redirected to the Stripe form, which should take less than 10 minutes to complete.",
        },
      },
      orders: {
        AddOrderTransferModal: {
          default_title: "New payment / refund",
          new_refund_title: "New refund",
          new_transfer_title: "New payment",
        },
        ChangeOrderScheduleSlotModal: {
          title: "Order date change",
        },
        EditOrderCustomerDetailsModal: {
          title: "Order details",
          customer_details: "Customer details",
        },
        EditOrderInstallmentsModal: {
          title: "Order payment installments ",
        },
        EditOrderItemsModal: {
          title: "Order invoice ",
          changed_order_item_name: "Change: %{item_name}",
          changed_order_option_name: 'Change option from "%{prev_item_name}" to "%{next_item_name}"',
          removed_order_option_name: 'Deleting option "%{prev_item_name}"',
          added_order_option_name: 'Adding option "%{next_item_name}"',
          order_items_title: "Bill",
          order_item_index: "Position",
          order_item_unit_price: "Price per item",
          order_item_quantity: "Quantity",
          order_item_total_price: "Total",
          add_new_order_item: "Add new position",
          extra_participants_existing:
            "Number of participants assigned to this order exceeds number of people chosen on the bill. Delete them from the order by clicking on the cross by the chosen person. ",
          installments_require_manual_change_warning:
            "Please note, that the amounts of installments in this order will not be changed automatically. If you want to change their amounts, change them by editing this order's payment profile after changing the order invoice.",
        },
        NewOrderItemsForm: {
          select_agent: "Choose agent",
          reset_agent_commision: "Restart",
          product_options: "Additional options",
          other_order_items: "Rest",
          add_new_order_item: "Add new position ",
        },
        NewOrderPaymentsForm: {
          accept_deposit: "Take a payment now",
          plan_payments: "Plan payment",
          no_payments: "Not now (save as draft)",
          deposit_accepted_as_agent: "(the payment will be marked as accepted by Agent)",
          deposit_accepted_as_supplier: "(the payment will be marked as accepted by Supplier)",
          only_deposit_now: "Only deposit now",
          rest_payment: "Paying the rest",
          order_status: "Order status",
          notify_customer: "Send notification to Customer",
          notify_customer_impossible_no_customer_email_given:
            "No email address of the Customer, impossible to send notification.",
          note_placeholder: "Add note",
          choose_payments_mode: "Choose the way with which the customer will pay for the order.",
          choose_payments_mode_error: "Choose the way with which the customer will pay for the order.",
          order_status_message: "After saving this booking will get status: ",
        },
        NewOrderProductModal: {
          no_products_found: "No offers found.",
          static_date_booking_label: "Order for specified date",
          with_custom_product_title: "Custom order (without offer)",
          choose_product_variant: "Choose offer variant",
          default_title: "New order",
          search_products: "Search offer",
          use_custom_product_button: "Custom order (without offer)",
          info1:
            "You can create a booking at customer's request and send them a link to pay for it online. The booking will not be linked to any existing offer. Enter the name of the booking, which will inform the client about what they ordered. Optionally add as many order details as you think necessary: price includes, does not include, etc.",
          order_name: "Booking name",
        },
        NewOrderModal: {
          confirm_abandon_message: "Are you sure you want to exit this order (you'll lost provided data)? ",
          confirm_abandon_cancel: "No, go back to order",
          confirm_abandon_ok: "Yes, abandon order",
          schedule_step_title: "Choose date",
          order_items_step_title: "Choose your options",
          customer_details_step_title: "Fill out customer data",
          payments_step_title: "Payments",
          abandon_failed_message:
            "We could not abandon your order. Probably it is still in our database. If you want to cancel it, go to the offer subpage and delete it manually.",
          payments_step_profiles_instruction: "Choose payment method",
          payments_step_choose_payments: "Choose online payment option",
          payments_step_choose_payments_reseller: "Pay now by STRIPE",
          payments_step_choose_payments_customer: "Send payment link",
          payments_step_choose_payments_reseller_hint1:
            "Choose this option and click save to redirect to online payment now and pay by card.",
          payments_step_choose_payments_reseller_hint2: "",
          payments_step_choose_payments_customer_hint1:
            "Choose this option and click save to send e-mail with payment link to the customer. Remember that you need to add customer e-mail address in previous form step.",
          payments_step_choose_payments_customer_hint2: "",
          payments_step_prebook: "Prebook",
          payments_step_choose_payments_terminal_hint1:
            "Enter the order amount on the Tripsomnia payment terminal and accept the payment from the customer.",
          payments_step_choose_payments_terminal_hint2:
            "If payment has been successfully performed, save the order to complete the booking. The order will be placed and the customer will receive an e-mail confirmation.",
          payments_step_choose_payments_terminal: "100% payment via Tripsomnia terminal",
        },
        OrderScheduleForm: {
          select_existing_slot: "Choose existing date",
          upcoming_slots: "The closest dates",
          no_slots_found: "No free dates were found for this offer.",
          all_day: "[All day]",
          add_new_slot: "Add date",
        },
        OrdersListView: {
          title: "Orders",
          add_new_order: "New order",
          no_orders_title: "No orders",
          no_orders_message: "No order has been added yet.",
          no_orders_add_new_button: "Do you want to create?",
          customer_query_filter: "Name, email or phone ",
          other_filters: "Others",
          marketplace_filter: "Marketplace",
          saas_filter: "SaaS",
          manual_filter: "Manual",
          automatic_filter: "Automatic",
          requires_company_approval_filter: "Requires supplier's confirmation",
          doesnt_require_company_approval_filter: "Doesn't require supplier's confirmation",
          no_booking_filter: "With no booking",
          static_date_booking_filter: "With booking",
          total_amount_currencies_filter: "Currency",
          customer_payment_methods_filter: "Payment method",
          with_agent_commision_filter: "With agent commision",
          with_agent_service_fee_filter: "With agent service fee",
          with_both_agent_commision_and_service_fee_filter: "With both agent commision and service fee",
          with_saas_commision_filter: "With system commision",
          customer_transfer_date_filter: "Payment date",
          without_agent_commision_and_service_fee_filter: "Without agent commision and service fee",
          notes_filter: "Notes",
          with_notes_filter: "With notes",
          notes_filter_placeholder: "Search for note's content",
          with_affiliate_filter: "With Affiliate",
          with_agent_filter: "With Agent",
          with_agent: "With Agent",
          static_date_range_booking_filter: "Accommodation",
        },
        ChangeOrderStatusPrompt: {
          title: "Change order status",
          choose_new_status: "Choose new order status",
          save_and_notify_customer: "Save and send notification to customer",
          notify_supplier: "Notify Supplier",
          save_and_send_opinion_request: "Save and send opinion request to customer",
        },
        ShowOrderView: {
          add_new_transfer: "New payment",
          add_new_refund: "New refund",
          edit_note: "Note",
          change_status: "Change status",
          print: "Print",
          customer_title: "Customer",
          see_details: "(see data)",
          send_notification: "(send again)",
          order_items_title: "Bill",
          order_item_unit_price: "Price per item",
          order_item_quantity: "Quantity",
          payments_title: "Payments",
          agent_title: "Settlement with Agent",
          platform_title: "Settlement with Tripsomnia",
          platform_fee: "Platform fee",
          activities_title: "Order history",
          title: "Order %{order_id}",
          approve_warning: "Confirm",
          one_night: "%{i} day",
          nights: "%{i} days",
          approve_until_warning: "Confirm before %{date}",
          send_opinion_reminder_notification: '(send "add review" reminder)',
          pay_now: {
            tooltip: {
              no_payment_needed: "This order is fully paid.",
              too_low_amount: "Payment amount is too low.",
            },
            0: "Pay via STRIPE",
          },
        },
        utils: {
          confirm_approve_message: "Are you sure you want to confirm this order?",
          confirm_reject_message: "Are you sure you want to reject this order?",
          confirm_finish_message: "Are you sure you want to mark this order as finished?",
          confirm_cancel_message: "Are you sure you want to cancel this order?",
          confirm_delete_message: "Are you sure you want to delete this order?",
          redeliver_customer_order_email_success_message: "An email with order information was sent to the customer.",
          redeliver_supplier_order_email_success_message:
            "Email with up to date information about the order has been sent to the Supplier. ",
          create_agent_disbursement_success_message:
            "Selected orders have been disbursed (Disbursement ID: %{agent_disbursement_id}).",
          create_platform_disbursement_success_message: {
            one: "Settled with Tripsomnia - %{count} payout transfer created.",
            other: "Settled with Tripsomnia - %{count} payout transfers created.",
          },
          create_platform_disbursement_collected_message: {
            one: "Collected the platform fee from the supplier - %{count} incoming transfer created.",
            other: "Collected the platform fee from the supplier - %{count} incoming transfers created.",
          },
          create_platform_disbursement_nothing_to_settle_message: {
            one: "Settled %{count} order - there was nothing for Tripsomnia to wire.",
            other: "Settled %{count} orders - there was nothing for Tripsomnia to wire.",
          },
          create_platform_disbursement_underfunded_message: {
            one: "%{count} order was left unsettled - the supplier is still owed, but the platform is not holding the money.",
            other:
              "%{count} orders were left unsettled - the supplier is still owed, but the platform is not holding the money.",
          },
          redeliver_customer_order_opinion_reminder_email_success_message:
            "An email notification of adding an order's review has been sent to the customer.",
          send_opinion_request_to_customer: "Send review request to customer",
        },
        OrderCustomerDetailsFormSection: {
          participants_details: "Participants data",
        },
        EditOrderNotesModal: {
          title: "Order notes",
        },
      },
      products: {
        EditProductView: {
          StepAdditional: {
            form_title: "Tripsomnia settings",
            marketplace_settings: "Marketplace",
            saas_commision_settings: "Commission / SaaS service fee",
            hint: {
              p1: "Commission setting",
              p2: "You can find the rest of settings in Agents.",
            },
          },
          StepAvailability: {
            all_product_variants: "All variants",
            remove_all_slots_confirm: {
              title: "Deleting date",
              message: "Are you sure you want to delete this date and its further repeats?",
              confirm: "Delete all dates from %{all_slots_initial_date}",
            },
            remove_single_slot_confirm: {
              title: "Deleting date",
              message:
                "This date is repeating. Do you want to delete this date and all its further repeats or only this particular date? ",
              select_all_slots: "Go to edition of all dates from %{all_slots_initial_date}",
              confirm: "Delete only this date",
            },
            remove_booked_slot_alert: {
              message:
                "Deleting this date is impossible, as it is booked with active orders. If you want to delete it, you need to cancel the orders first.",
              go_to_slot_view: "Go to date view",
            },
            remove_slot_confirm: {
              title: "Deleting date",
              message: "Are you sure you want to delete this date?",
              confirm: "Delete this date ",
            },
            edit_all_slots_confirm: {
              title: "Date edition",
              message:
                "You have made changes to the repeats of this date. Are you sure you want to overwrite this term and its subsequent repeats?",
              confirm: "Change all dates from %{all_slots_initial_date}",
            },
            edit_single_slot_confirm: {
              title: "Date edition",
              message:
                "This date is repeating. Do you want to overwrite just this date or go to edition of its all further repeats?",
              select_all_slots: "Go to edition of all dates from %{all_slots_initial_date}",
              confirm: "Change only this date",
            },
            add_slot: "Add date",
            add_many_slots: "Add many dates",
            select_first_slot_date: "Choose dat of the first, single term",
            select_slot_date: "Choose dat of the first, single term",
            prices_title: "Price list",
            no_prices_message: 'No default prices have been set. Go to the tab "Prices" to enter pricelist.',
            availability_title: "Availability",
            hint: {
              p1: "Before you start adding dates of your offer, please adjust the default price and booking settings for this offer.",
              p2: "Add date",
              p3: "To add one date just select a date on the calendar, customize options and save changes.",
              p4: "Add multiple dates",
              p5: "To add multiple dates, use the repeating option.",
            },
            normal_start_dates_assignation_type: "chosen",
            recursion_start_dates_assignation_type: "periodically",
            edit_slot: "Edit date",
            repeat_on_days: "Repeat on days",
            repeat_until: "Repeat until",
            repeat_in_hours: "Repeat in hours",
            repeat_slot: "Repeat date",
          },
          StepBookingSettings: {
            already_used_stock: "(%{used_stock} already sold)",
            nb_stock_useby_date_label: "Realisation date",
            nb_dont_require_company_approval_label: "Instant booking",
            slots_will_be_removed_warning:
              "When saving changes, all existing dates of this offer, if any, will be deactivated and / or deleted. ",
            form_title: "Booking settings",
            static_date_booking_label: "Does an offer have dates booking?",
            qr_redemption_enabled_label: "Generate QR code for redemption in the Ticket Scanner panel",
            qr_redemption_enabled_help:
              "After purchase, the customer will receive a QR code in the email and PDF. Ticket scanners use it in the Ticket Scanner panel to confirm entry.",
            global_settings: "Global settings",
            default_settings: "Default settings for adding new availabilities",
            hint: {
              p1: "Select if your offer has date booking in the calendar or if it is an offer without reservation, e.g. a coupon or a voucher to be used under certain conditions.",
              p2: "Default availability limit / offer limit",
              p3: "This will be the default value for each new date added in the calendar. In case of offers without reservation, this will be the total offer limit.",
              p4: "Default booking settings",
              p5: "Decide if you accept direct booking that does not require your confirmation, or prefer to have full control over your orders, and you will confirm each order individually.",
              p6: "Realisation date",
              p7: "In case of voucher, coupon, discount you can also set a date range when it can be used.",
            },
            enable_frontend_slots_listing_label: "Show Customers dates on a list instead of calendar",
            expire_at_label: "Offer expiration date",
            availability_limit_label: "Limiting the availability of the offer for purchase / download by the customer.",
          },
          StepCustomerFields: {
            customer_fields: "Customer form",
            participant_fields: "Participant form",
            hint: {
              p1: "Booking form field",
              p2: "Select which fields will be displayed to customers when placing an order. For each field you can set whether it is mandatory to fill in and whether you want to display it on the List of Participants.",
            },
          },
          ProductVariantMigrateModal: {
            copy_description_label: "Description",
            copy_pricelist_label: "Prices",
            copy_payments_label: "Payments",
            copy_booking_settings_label: "Booking settings",
            copy_pickup_points_label: "Meeting point",
            copy_priced_fields_label: "Additional options",
            copy_customer_fields_label: "Questionnaire",
            copy_description_hint:
              'All attributes in the tab "Descriptions" for the selected target variant will be overwritten.',
            copy_pricelist_hint:
              'All attributes in the tab "Prices" for the selected target variant will be overwritten.',
            copy_payments_hint:
              'All attributes in the tab "Payments" for the selected target variant will be overwritten.',
            copy_booking_settings_hint:
              'All attributes in the tab "Booking Settings" for the selected target variant will be overwritten.',
            copy_pickup_points_hint:
              'All attributes in the tab "Meeting point" for the selected target variant as well as the value "Ask each person individually about a meeting point" in this offer will be overwritten.',
            copy_priced_fields_hint: 'All "Additional options"  will be overwritten in the target offer variant. ',
            copy_customer_fields_hint: 'All "Questionnaire" fields will be overwritten in the target offer variant. ',
            title: "Copy attributes from another offer / variant",
            source_variant: "Source offer / variant",
            target_variant: "Target offer / variant",
            copy_label: "Copy",
            submit: "Copy data",
          },
          StepDescription: {
            remove_variant: "Delete variant",
            migrate_data_from_other_product: "Copy data from another offer/ variant",
            new_variant_default_name: "Variant %{index}",
            add_variant_message:
              "If your offer has various options that cannot be set in additional options, you can %{link}",
            add_variant_message_link: "add another offer variant.",
            hint: {
              p1: "Offer name",
              p2: "Clearly identify your offer so that the customers know what they are looking at from the very beginning.",
              p3: "Highlights",
              p4: "What is most important in your offer? Encourage your customers!",
              p5: "Description",
              p6: "Exactly and clearly describe your offer - the more accurately you do it, the less doubts will customer have and the faster he or she decides to order your product. Use headlines and text styling highlighting the most important aspects. If you have customers from different countries add more language versions of the offer.",
              p7: "Price includes / Price does not include",
              p8: "Describe what is included and not included in the price and what are the extra prices. ",
              p9: "Conditions",
              p10: "Add special terms that customers must meet to participate in the offer.",
              p11: "Tips",
              p12: "Add tips for the customer to help him prepare for participation.",
              p13: "Offer variants",
              p14: "If you offer similar tours that differ only slightly, you can create variants of the same tour. In addition, you can copy particular settings from another offer or variant.",
            },
          },
          StepLocation: {
            main_location_label: "Main location",
            other_locations_label: "Detailed locations",
            new_pickup_point_title: "New meeting point",
            edit_pickup_point_title: "Meeting point\n edition",
            remove_pickup_point: "Delete meeting point",
            add_new_pickup_point: "Add meeting point",
            locations_title: "Offer location",
            pickup_points_title: "Meeting points",
            pickup_point_assignation_per_person_label: "Ask each person individually about a meeting point",
            additional_settings: "Other settings",
            hint: {
              p1: "Offer location",
              p2: "Set your offer's main location and additional points associated with it.",
              p3: "Do you already have a map created on Google maps? Paste the code to show it in the offer.",
              p4: "Meeting point",
              p5: "Add meeting point by specifying the address, departure and return times, and additional fees. You can add instructions and correct your location on the map to help your customer reach the meeting point easily.",
              p6: "Decide if the customer selects one meeting point for the whole order or if each participant can select their own meeting point.",
              p7: 'The customer is not always able to provide a meeting point when booking. Decide if you allow the customer to reply "I don\'t know yet"',
              p8: "If you pickup form hotel or other customer's place, they will be asked to enter their location.",
              p9: "Directions",
              p10: "You can provide here instructions on how to get to your place or set customer pickup area.",
            },
            pickup_points_price_per_person_label: "Charge meeting point fee from each person separately",
            custom_pickup_point_name: "Hotel pickup",
            no_pickup_point_name: "Unspecified location",
          },
          StepPayments: {
            supplier_profiles_title: "Choose profiles that will be available for your customers",
            marketplace_profiles_title: "Choose profiles that will be available for Tripsomnia customers",
            add_new_payment_profile: "Add new profile",
            form_title: "Payment profiles",
            hint: {
              p1: "Payment profiles",
              p2: "Determine how your customers can pay for your offer. Determine the number and amount of installments, method of payment and cancellation policy.",
              p3: "Select profiles for your customers from already created or add a new one.",
              p4: "Select profiles for Tripsomnia customers from already created or contact us to adjust your cooperation on other terms.",
            },
            no_supplier_profiles_warning:
              "We recommend activating at least one payment profile in this channel for your offer. Otherwise, your customers will not be able to place orders for this offer on your Website.",
            no_marketplace_profiles_warning:
              "We recommend activating at least one payment profile in this channel for your offer. Otherwise, your customers will not be able to place orders for this offer on Tripsomnia.com.",
            access_temporarily_enabled_only_for_supplier:
              "Preview of the available payment profiles for this offer is available only to the offer Supplier for now. If you would like to know what are the available payment profiles for this offer, contact your Supplier . ",
          },
          StepPhotos: {
            cover_photo: "Cover photo",
            name_placeholder: "Enter name",
            form_title: "Add photos to make your offer more attractive",
            click_or_drag_and_drop_to_add_photos:
              "Click or drag files into this box to add a photo(s). Use only .jpg, .jpeg .gif .png. The minimum image resolution is 1400 x 600 and the maximum size is 5MB.",
            add_video: "or add video (YouTube/Vimeo)",
            add_video_submit: "Add",
            hint: {
              p1: "Add interesting photos that will convince your customers to use exactly your offer. You can sign each photo and also attach a link to the video. All materials can be ranged in any order by dragging their thumbnails.",
              p2: "Make sure you only use materials for which you have copyrights or that are released under an open license for commercial reuse.",
            },
          },
          StepPricedFields: {
            form_title: "Additional options",
            add_new_field: "New additional option",
            hint: {
              p1: "Configure additional options for customers",
              p2a: "Checkbox",
              p2b: "Customer selects option Yes or No.",
              p3a: "Selection list",
              p3b: "Customer selects one postion from the list.",
              p4a: "Number",
              p4b: "Customer chooses a number from given range.",
              p5: "Decide if the question is asked once for the entire order or separately for each participant.",
              p6: "List of Participants",
              p7: "Decide whether the field will appear on the List of Participants.",
              p8: "Must be filled in",
              p9: "Decide if customer has to fill in the field to place an order",
            },
          },
          StepPricelist: {
            form_title: "Prices",
            hint: {
              p1: "You have to choose one of three types of pricing:",
              p2: "Price per person",
              p3: "Create a standard price list for adults, children, seniors by specifying age limits. You can also add a price list for a group or a family by setting participants limits, or create your own category. For each price list item you can set a minimum and maximum number of units to purchase (e.g. buy min. 3 tickets). Note: person limits and unit limits cannot be set at the same time.",
              p4: "Price per package",
              p5: "You can offer packages for a limited number of people, e.g. a water bike for 1-4 people.",
              p6: "Price per order",
              p7: "Set a fixed price for the order regardless of participants number, e.g. price per renting a yacht.",
            },
            persons_count: "Pax",
            persons_count_from: "Pax from",
            age_from: "Age from",
            min_quantity: "Min. qty",
            max_quantity: "Max. qty",
            person_category_name: "Category name",
            add_new_item: "Add new package",
            item_name: "Package name",
            coupon_code_name: "Discount code",
            new_coupon_code_name: "New discount code",
            add_new_coupon: "Add new discount",
            coupon_codes_title: "Discount codes",
            coupon_codes_description:
              "If you want us to send a specific discount code to customers in the coupon they will download, specify the codes below.",
            coupon_code_realisation_place_type_label: "Where can you realise the discount code?",
            coupon_codes_realisation_place_online_website: "in the online website (f.e. via a ecommerce shop cart)",
            coupon_codes_realisation_place_manually: "manually (via phone or an e-mail)",
            coupon_codes_realisation_place_custom: "custom",
            coupon_code_realisation_place_custom_description_placeholder:
              "Specify how and where can you realise the coupon code",
            generate_coupon_codes: "Generate random discount codes",
            saas_featured_price: "Prices presented on your website",
          },
          menu: {
            description: "Description",
            add_locale: "Add / delete language",
            translate: "Translate",
            translate_modal: {
              title: "Translate the offer",
              explanation: "To translate the offer, add the target language in the menu on the left above the 'Translate' button and save the changes.",
              select_source_locale: "Select source language",
              select_locale: "Select target language",
              submit: "Translate",
            },
            pricelist: "Schedule and prices",
            availability: "Availability",
            prices: "Prices",
            payments: "Payments",
            booking_settings: "Booking settings",
            photos: "Photos",
            location: "Location and directions",
            priced_fields: "Additional options",
            customer_fields: "Questionnaire",
            additional_settings: "Tripsomnia settings",
            title: "Offer edit menu",
            accommodation_settings: "Accommodation",
            integrations: "Integration settings"
          },
          common: {
            remove_confirm_message: "Are you sure you want to delete this offer?",
            orders_button: "Orders",
            preview_st: "Preview ",
            preview_saas: "WWW",
            save_success_message: "Changes in offer were saved.",
            remove_success_message: "Offer was deleted.",
            add_photos_success_message: "Photos were added.",
          },
          StepAccommodationSettings: {
            form_title: "Accommodation settings",
            accommodation_settings: {
              category: "Accommodation unit type",
              categoryOption: {
                one_person_room: "Single room",
                two_person_room: "Double room",
                three_person_room: "Triple room",
                four_person_room: "Four-person room",
                multi_person_room: "Dormitory room",
                bed_in_multi_person_room: "Bed in dormitory room",
                apartment: "Apartment",
                cottage: "Cottage",
                villa: "Villa",
                holiday_house: "Holiday house",
                tent: "Tent",
              },
              categoryTitle: {
                room: "Rooms",
                bathroom: "Bathroom",
                view: "View",
                food_and_drinks: "Food and Drinks",
              },
              categoryDescription:
                "Choose what type of accommodation the offer applies to, and then determine how many units will be available for sale by default each day. You can later change this value for selected dates according to your needs.",
            },
            default_total_stock_limit: "Default availability",
            accommodation_detail: {
              single_beds_count: "Single beds",
              double_beds_count: "Double beds",
              extra_beds_count: "Extra beds",
              bathrooms_count: "Bathrooms",
              rooms_count: "Rooms/bedrooms",
              area: "Area",
            },
            presented_price: 'Presented price "from"',
            accommodationUnitSettings: "Accommodation unit settings",
            facilities: "Facilities",
            accommodationUnitSettingsDescription:
              "Enter the number of single beds, double beds and possible extra beds. This information will determine how many people can stay overnight in one unit of the selected type. Then enter a price which will be the base price presented to your customers. Inform the client about the number of bathrooms, rooms/bedrooms and size of the space regarding one unit of the selected type. This information will appear on the listing page.",
            facilitiesDescription: "Mark which amenities your guests can expect from the offered accommodation unit. ",
          },
          StepIntegrations: {
            log_integration_date: "Date",
            log_integration_action: "Action",
            log_integration_company_id: "Company ID",
            log_integration_uuid: "Task UUID",
            filter_all_logs: "All",
            filter_succeeded: "Succeeded",
            filter_all_failed: "Failed"
          }
        },
        ManageLocalesPrompt: {
          title: "Offer language versions",
          select_locale: "Choose language",
        },
        NewProductPrompt: {
          title: "New offer",
          name_placeholder: "Enter offer name",
          submit: "Create an offer",
          coupon_label: "I want to add only discounted code",
          offer_type_header: "Choose offer type",
          offer_type_standard_header: "Standard",
          offer_type_standard_description:
            "Offer with specific date availabilities - one day trips, city tours, excursions, fixed accommodation packages.",
          offer_type_coupon_header: "Discount",
          offer_type_coupon_description:
            "Simply offer - discount without booking the specific dates, can contain a discounted code",
          offer_type_ticket_header: "Ticket",
          offer_type_ticket_description: "Special offer type for attractions, amusement parks, museums.",
          offer_type_voucher_header: "Voucher",
          offer_type_voucher_description:
            "Coupons and vouchers, which customers can purchase now and use in the future.",
          offer_type_accommodation_header: "Accommodation",
          offer_type_accommodation_description:
            "Offer with price list per night. For offers from hotels, guesthouses etc.",
        },
        ProductsListView: {
          products: "Offers",
          settings: "Settings",
          add_new_product: "New offer",
          no_products_message: "No offers have been created yet.",
          no_products_message_link: "Add your first offer!",
          no_products_title: "No offers.",
          search_top_bar: "Search for offers, locations, companies",
        },
        StepAdditional: {
          hide_description_for_variants: "Hide variants except 1st.",
        },
      },
      reviews: {
        ReviewsListView: {
          no_records_message: "None of your customers has given you a review yet.",
          no_records_title: "No reviews",
          title: "Reviews",
        },
        EditReviewModal: {
          title: "Review",
          remove_confirm_message: "Are you sure you want to delete this review?",
        },
      },
      affiliate: {
        AffiliateListView: {
          no_records_message: "No orders yet.",
          no_records_title: "No orders.",
          summary_row: "In total (for rows %{start}-%{end}):",
          title: "Affiliate Program - orders statistics",
        },
      },
      suppliers: {
        NewSupplierPrompt: {
          email_label: "Enter the company's email address",
        },
      },
      pagination: {
        show_10: "Show 10",
        show_20: "Show 20",
        show_30: "Show 30",
        show_50: "Show 50",
        show_100: "Show 100",
      },
      accommodation: {
        AccommodationSchedulerView: {
          title: "Set pricings",
          calendarLink: "Show calendar",
          noProductsInfo: "You must have at least one offer enabled to be able to use this feature.",
          availabilityTypes: {
            available_with_instant_booking: "Instant booking",
            available_with_company_approval: "Company approval",
            no_changes: "No changes",
          },
          productsHeader: "Offers / room types",
          pricingPlansHeader: "Pricing plans",
          availabilityTypeHeader: "Availability type",
          datesHeader: "Select dates",
          hintHeader: "Editing prices and availability",
          hintContent:
            "You can quickly edit multiple offers and terms in bulk. Maximum editing range up to 180 days in advance. Select the offers and the date range you want to change, and then set only the parameters that interest you: price, remaining availability and booking mode.",
          errors: {
            maxDatesDifference: "Range can not be bigger than %{maxDatesDifference} days.",
            daysNotIncluded: "Date range does not include selected days.",
          },
          totalStockLimit: "Availability",
        },
        AccommodationCalendarView: {
          title: "Hotel calendar",
          schedulerLink: "Advanced options",
        },
        Accommodation: {
          totalStockLeftTypes: {
            noChanges: "No changes",
            unavailable: "Unavailable",
            specified: "Specified",
          },
        },
      },
    },
    st: {
      pricelist_order_installment_item: {
        paid_by_cash: "in cash",
        paid_by_online_payment: "online",
        paid_by_bank_wire: "by bank transfer",
        already_paid: "Paid %{paid_by}",
        to_be_paid_right_now: "Pay now",
        to_be_paid_right_after_company_approval: "To pay after the Company order confirmation.",
        to_be_paid_on_spot: "To pay %{paid_by} on the spot",
        to_be_paid_until: "To pay %{paid_by} before %{date}",
        to_be_paid_after_previous_installment: "To be paid %{paid_by} until %{date} after the first installment",
        to_be_paid_now: "Pay %{paid_by} now",
        to_be_paid_after_order_creation: "To be paid %{paid_by} until %{date} after order submission",
        to_be_paid_after_company_approval: "To be paid %{paid_by} until %{date} after Company order confirmation",
        to_be_paid_after_approval: "To be paid %{paid_by} until %{date} after confirmation",
        to_be_paid_before_stock_start_date: "To be paid %{paid_by} until %{date} before beginning of the offer",
        in_your_currency_it_is: "in your currency there is approximately",
        payment_accepted_in_website_currency: "Payment currency",
        payment_accepted_in_company_currency: "Payment currency",
        payments_are_converted_with_following_rates: "Fees are estimated on the base of rates:",
        your_bank_can_issue_an_additional_fee_for_the_transaction:
          "Your bank may charge an additional fee for the transaction in a foreign currency.",
        to_supplier: "Suppliers",
        to_agent: "Agent",
        to_socialtravel: "To Tripsomnia",
        paid_by_dotpay: "by DotPay",
        paid_by_paypal: "by PayPal",
        marketplace_bank_wire_transfer_title: "Tripsomnia Order No. %{order_id}",
        saas_bank_wire_transfer_title: "Order No. %{order_id}",
        bank_wire_transfer_details:
          'Please disregard this notice if payment has already been made. If you would like to pay for the order, here are bank details: %{account_description}. Transfer title: "%{transfer_title}"',
        paid_by_payu: "by PayU",
        paid_by_stripe: "with Stripe",
        paid_by_terminal: "with Terminal",
      },
      app_config: {
        saas_service_fee_name: "Transaction fee",
        site_short_description:
          "Book online local tours and tourist attractions from all over the world! Accommodations Excursions Attractions in 1 place. The most interesting tourist offers.",
        pdf_voucher_st_address_details: "Tax No.: 1132941467; ul. Grodzka 42/1, 31-044 Cracow, Poland",
        tripsomnia_company_name: "Tripsomnia",
        tripsomnia_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_full_address:
          "Booking Platform Tripsomnia - A SocialTravel Company\nTax No.: 1132941467\nul. Grodzka 42/1\n31-044 Cracow, Poland",
        tripsomnia_service_fee_name: "Tripsomnia service fee",
        agent_service_fee_name: "Agent service fee",
        socialtravel_company_name: "SocialTravel",
        socialtravel_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_opening_hours: "Mon-Fri 9am - 5pm, Sat-Sun 11am - 5pm",
        socialtravel_service_fee_name: "Tripsomnia service fee",
        socialtravel_contact_phone_number: "+48 690 670 581",
        tripsomnia_contact_phone_number: "+48 690 670 581",
      },
      create_agent_disbursement: {
        no_orders_error: "No orders have been selected.",
        no_order_agent_error: "One of the selected order has no agent defined.",
        incorrect_order_company_error: "All orders must have the same supplier and agent.",
      },
      create_platform_disbursement: {
        no_orders_error: "No orders have been selected.",
        marketplace_order_error:
          "One of the selected orders is a marketplace order - settle it with the agent disbursement instead.",
        incorrect_order_company_error: "All orders must have the same supplier.",
      },
    },
    countries: {
      pl: "Poland",
    },
    customer_mailer: {
      order_marketing_info: {
        subject: "Subject",
      },
      reset_password: {
        action: "Set your password",
        greeting: "Hello %{recipient}!",
        instruction: "You just created your own account at Tripsomnia.",
        instruction_2: "",
        instruction_3: "Click the link below to set your account password.",
        subject: "You just created your own account at Tripsomnia.",
      },
    },
    product_request_mailer: {
      customer_requested_discount_company_email: {
        hello_company: "Hello %{company_name}!",
        content: {
          line1: "The popularity of your profile on Tripsomnia platform is increasing!",
          line2:
            "Our customers are interested in your products. Below you will find a customer's enquiry sent based on your company profile on our website.",
          line3:
            "Click the link and fill out the form or contact us at kontakt@socialtravel.pl to take control of your company profile. You can find out more about who we are and what we do on our website getcoupon.tripsomnia.com",
        },
        details_header: "%{product-url}",
        customer_details_header: "Message from a customer",
        info: {
          line1_html: "Your profile: %{company-url}.",
          line2_html: "Get access to edit company profile %{get_company_access_url}",
          line3_html: "About us: getcoupon.tripsomnia.com",
        },
        subject: "Customer sent you a question regarding your offer on Tripsomnia",
      },
      customer_requested_discount: {
        content: {
          line1: "The popularity of your profile on Tripsomnia platform is increasing!",
        },
        info: {
          line1_html: "Your profile: %{company-url}.",
          line2_html: "Get access to company profile %{get_company_access_url}.",
          line3_html: "About us: getcoupon.tripsomnia.com",
        },
        subject: "Client's request for a discount from Tripsomnia website",
      },
      customer_requested_product: {
        subject: "Customer's enquiry for offer - Tripsomnia",
      },
      customer_requested_product_company_email: {
        content: {
          line1: "A client is interested in your offer and would like to get more information.",
          line2:
            "The reason for an enquiry being sent may be the lack of availability, insufficient information about the offer or special wishes of a customer. Kindly update your offer if possible and contact the customer.",
          line3: "Should you need any assistance, please contact us: info@tripsomnia.com",
        },
        customer_details_header: "Message from a customer",
        details_header_html: '<a href="%{product_link}">%{product_name}</a>',
        hello_company: "Hello %{company_name}!",
        info: {
          line1_html: 'The message has been sent on: <a href="%{product_link}">link</a>.',
          line2_html:
            'Manage descriptions of your offers and availavility in the <a href="%{partnerapp_product_url}">Partner\'s Panel</a>.',
          line3_html:
            'Forgot Password? Recover Password by clicking <a href="%{partnerapp_reset_password_url}">here</a>.',
        },
        subject: "Customer sent you a question regarding your offer on Tripsomnia",
      },
    },
    pl: {
      papp: {
        settings: {
          StripeSettingsView: {
            stripe_login_button: "Log in Stripe",
            stripe_register_button: "Registration in Stripe",
          },
        },
      },
    },
    ordered_item: {
      accommodation: {
        name: {
          one: "%{name} x %{count} night",
          few: "%{name} x %{count} nights",
          many: "%{name} x %{count} nights",
          other: "%{name} x %{count} nights",
        },
      },
      product: {
        name: "%{unit_price}: %{name}",
      },
    },
    en: {
      activerecord: {
        attributes: {
          pricing_plan: {
            preset: {
              elastic: {
                company_description: "xxx",
                customer_description: "xxx",
              },
              not_refundable: {
                company_description: "xxx",
                customer_description: "xxx",
              },
            },
          },
        },
      },
    },
  })),
  (I18n.translations.de = I18n.extend(I18n.translations.de || {}, {
    active_admin: {
      action_impossible: "",
      action_success: "",
      actual_at_x: "",
      add_tag_batch_action: {
        add_success: "",
        remove_instead: "",
        remove_success: "",
      },
      basic_details: "",
      batch_actions: {
        button_label: "",
        labels: {
          add_category: "",
          add_location: "",
          add_product_st_tag: "",
          add_tag: "",
          v1_st_balance_company_debt: "",
          add_admin_user: "",
          add_payment_profile: "",
          remove_payment_profile: "",
        },
      },
      company_edit: {
        possible_to_edit_only_by_global_admin: "",
      },
      company_registrations: {
        approve: "Bestätigen",
        reject: "Ablehnen",
      },
      company_submit_monthly_invoicing_stats: {
        success: "",
      },
      content_details: "",
      dashboard: "",
      dashboard_page: {
        approved_orders: {
          title: "Buchungen bestätigt",
        },
        search_orders: {
          submit: "Suchen",
          title: "",
        },
        summary: {
          title: "",
        },
        upcoming_orders: {
          title: "",
        },
        waiting_for_company_approval_orders: {
          title: "",
        },
        waiting_for_customer_approval_orders: {
          title: "",
        },
      },
      default_menu: {
        add_new: "",
        new_admin_company: "",
        new_admin_product_tag: "",
        new_admin_product_tags_category: "",
        others: "",
        users: "",
      },
      delete_file: "Datei stornieren",
      devise: {
        email: {
          title: "E-Mail Adresse",
        },
        links: {
          resend_unlock_instructions: "",
        },
        password: {
          title: "",
        },
        reset_password: {
          submit: "",
        },
        unlock: {
          submit: "",
          title: "",
        },
      },
      globalize: {
        language: {
          pl: "Polnisch",
          en: "Englisch",
          ru: "Russisch",
        },
        translations: "",
      },
      go_back: "Zurück",
      monthly_invoicing_stats: "",
      order_actions: {
        action_failed_error: "",
        approve: "",
        cancel: "",
        confirm: "",
        finish: "",
        redeliver_customer_order_email: "",
        reject: "",
        successfully_approved: "Buchung %{id} ist bestätigt geworden",
        successfully_cancelled: "Buchung Nr. %{id} ist storniert geworden.",
        successfully_confirmed: "Buchung %{id} ist geschickt geworden",
        successfully_finished: "",
        successfully_redelivered_customer_order_email: "",
        successfully_rejected: "Buchung Nr. %{id} ist abgelehnt geworden.",
        view_stats: "",
        redeliver_supplier_order_email: "E-Mail an dem Lieferanten gesendet",
        successfully_redelivered_supplier_order_email:
          "E-Mail zur Buchung wurde an den Lieferanten erneut an die folgende E-Mail-Adresse gesendet %{customer_email}.",
      },
      order_edit: {
        order_not_yet_confirmed_error: "",
      },
      order_show: {
        activities: {
          email_message_email: "E-Mail Adresse",
          email_message_subject: "",
          order_status_updated_action: "Aktion",
          order_status_updated_content: "",
          sms_message_content: "",
          sms_message_phone_number: "",
          title: "",
        },
      },
      order_show_company_invoice: {
        invoice_retrieval_error: "",
      },
      order_show_customer_invoice: {
        invoice_retrieval_error: "",
      },
      order_v1_st_balance_company_debt: {
        success: "",
      },
      orders_stats: {
        average_orders_value_th: "",
        in_average_th: "",
        in_total_th: "",
        name_th: "",
        orders_count_th: "",
        title: "",
        total_orders_value_th: "",
      },
      orders_v1_st_balance_company_debt: {
        success: "",
      },
      preview: "Vorschau",
      product_tags_index: {
        tag_stats: "",
      },
      products_index: {
        batch_action_add_product_tag: {
          add_success: "",
          remove_instead: "",
          remove_success: "",
        },
      },
      scopes: {
        abandoned: "Verlassen",
        all: "Alle",
        approved: "Bestätigt",
        approved_finished_short: "",
        building: "",
        cancelled: "Storniert",
        category: "",
        company_tag: "",
        customer_tag: "",
        deprecated_v1_accomodation: "Unterkünfte",
        deprecated_v1_coupon: "",
        deprecated_v1_special_offer: "Sonderangebote",
        deprecated_v1_trip: "",
        finished: "",
        future_customers: "",
        location: "",
        lost_customers: "",
        marketplace: "",
        order_tag: "",
        past_customers: "",
        product_st_tag: "",
        prospect_customers: "",
        rejected: "Abgelehnt",
        saas: "",
        waiting_for_company_approval: "",
        waiting_for_customer_approval: "",
        product_company_tag: "Firmentags",
      },
      search_status: {
        current_filters: "",
        current_scope: "",
        headline: "",
        no_current_filters: "",
      },
      sidebars: {
        relation_no_results: "",
      },
      successfully_created: "",
      successfully_updated: "",
      tabs: {
        availability: "",
        base_details: "",
        description: "Beschreibung",
        images: "Bilder",
        invoicing: "",
        location: "",
        other_details: "",
        pricelists: "Preisliste",
        product_order_fields: "Zusatzoptionen",
        product_variants: "Variante",
      },
      widgets: "",
      wrong_lock_version_error: "",
      location_details: "Ort",
      companies: {
        destroy: {
          action_impossible_company_has_orders_as_supplier:
            "Das Löschen dieser Firma ist unmöglich - sie hat auch Aufträge als Lieferant. Löschen Sie zuerst die Bestellungen, um die Firma zu löschen.",
        },
      },
      pp_edit: "In PP bearbeiten",
      add_admin_user_batch_action: {
        remove_instead: "",
        success: "",
      },
      add_payment_profile_action: {
        success: "",
      },
      pricing_plans: {
        new_elastic_plan: "",
        new_not_refundable_plan: "",
      },
      remove_payment_profile_action: {
        success: "",
      },
    },
    fe: {
      active_admin: {
        view_collection_item_nested_form: {
          toggle_show: "",
        },
      },
      ckeditor: {
        subsection_expand: {
          content: "",
          title: "",
        },
        subsection_read_more: {
          content: "",
          title: "",
        },
      },
      NewOrderCalendarForm: {
        help_tip: "Legende (mit Maus schweben)",
        product_chosen: "Sie haben Angebot %{name} im Termin %{date_range} ausgewählt.",
        stock_available: "Termin verfügbar",
        stock_available_but_impossible_as_end:
          "Termin verfügbar, aber an diesem Tag kann Aufenthalt nicht beendet werden",
        stock_available_but_impossible_as_start:
          "Termin verfügbar, aber an diesem Tag kann Aufenthalt nicht beginnt werden",
        stock_busy: "Termin belegt",
        stock_discounted: "Sonderpreis",
        submit: "Weiter",
        previous_slots: "Frühere Termine ",
        next_slots: "Spätere Termine",
        stock_confirmed: "Termin bestätigt",
      },
      NewOrderConfirmPricingForm: {
        submit: "Weiter",
      },
      NewOrderCustomerDetailsForm: {
        order_with_payment_requirement: "Bestellung mit Bezahlungspflicht",
        participant_name_with_number: "Teilnehmer Nr. %{i}",
        required_fields: "Angeforderte Felder",
        submit: {
          make_order: "Reservieren",
          next: "Weiter",
        },
      },
      NewOrderPaymentForm: {
        almost_booked: "Gratulation! Nur eine Minute bleibt bis einleitenden Bestellung!",
        almost_finished: "Gratulation! Nur eine Minute bleibt bis Ihre Bestellung fertig ist. ",
        cancelled_if_not_paid:
          "Falls Sie in oben genannten Termin nicht bezahlen, Ihre Bestellung wird automatisch storniert.",
        dotpay_go_back_button: "Zurück zu den Bestellungsformular",
        order_with_payment_requirement: "bestellung mit bezahlungspflicht",
        pay_to_book: {
          marketplace:
            "Sobald Sie %{confirmation_installment_transaction_amount} durch unsere sichere Online-Zahlungsplattform bezahlen, wird Ihre Buchung auf die Bestätigung des Reiseveranstalter gesendet.",
          saas: "Sobald Sie %{confirmation_installment_transaction_amount} bezahlen, bekommen wir Ihre Buchung und dann können wir sie endgültig bestätigen.",
        },
        pay_to_finish:
          "Sobald Sie %{confirmation_installment_transaction_amount} bezahlen, bekommen Sie automatisch ein Pdf-Voucher mit Ihren Buchungsdaten.",
        payment_deadline: "Bezahlungstermin: %{pauses_at}.",
        please_pay_online_deposit:
          "Bezahlen Sie bitte %{confirmation_installment_transaction_amount} über unseren Onlinezahlungsysten.",
        safe_payments_guaranteed_by: "Sichere Zahlungen garantiert von ",
        submit: {
          book_and_pay: "Reservieren und jetzt bezahlen %{price}",
          pay: "Jetzt bezahlen %{price}",
          pay_with_dotpay: "%{price} mit DotPay bezahlen",
          pay_with_paypal: "%{price} mit PayPal bezahlen",
        },
        choose_payment_method: "Zahlungsmethode auswählen:",
        pay_by_bank_wire: "Überweisung",
        pay_by_credit_card: "Mit Karte oder PayPal bezahlen",
        by_bank_wire: "Überweisung",
        by_credit_card: "Kreditkarte",
        by_bank_wire_or_credit_card: "Überweisung oder Kreditkarte",
        by_paypal: "PayPal",
        pay_by_credit_card_or_paypal: "Mit Kreditkarte oder über PayPal bezahlen",
        by_payu: "Mit Debit- oder Kreditkarte.",
        payu_button: "Mit PayU bezahlen",
      },
      NewOrderProductForm: {
        choose_payment_profile: "Zahlungsmethode auswählen",
        items_count: "Anzahl %{items}",
        multiple_pricings_alert:
          'Achtung: bezüglich Datum- und Verkaufslimite, können wir nicht alle %{product_quantity} %{items} mit "%{product_pricelist_name}" Preisliste abrechnen.',
        multiple_pricings_info: "Anstatt wird ausgewählte Kombination so berechnet:",
        custom_location_name_placeholder: "Woher soll Ihnen der Reiseveranstalter abholen?",
        submit: "Weiter",
      },
      NewOrderView: {
        building: "Sie bestellen",
        built: "Sie haben bestellt",
        contact_us_if_problem_repeats: "Falls der Fehler bleibt, kontaktieren Sie bitte uns: %{email}",
        loading_failed:
          "Fehler eingetroffen während Angebotsdatenladung. Aktualisieren Sie bitte die Webseite um noch einmal zu versuchen.",
        loading_in_progress: "Datenladung...",
        marketplace: {
          additional_bank_wire_deposit_required: "Bei dieser Buchung wird Zusatzüberweisung benötigt.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "Firma %{company_link} erhaltet Ihre Einleitendbestellung sofort. Die Firma hat %{company_approval_time_limit} auf einer Antwort, aber normalerweise wird es in 1 Stunde beantwortet. ",
          bank_wire_deposit_deadline_warning:
            "Vergessen Sie bitte nicht im Termin zu bezahlen. Falls Sie im Termin nicht bezahlen, Ihre Buchung kann storniert werden.",
          bank_wire_deposit_details: "Überweisungsdaten",
          bank_wire_deposit_instructions:
            "Als Überweisungstitel geben Sie bitte nur die Bestellungsnummer ein. Andernfalls können wir nicht garantieren, dass Ihre Überweisung zeitlich gebucht wird.",
          building: "Sie bestellen",
          built: "Sie haben bestellt",
          company_approved_your_order_request:
            'Firma %{company_link} hat Ihre Einleitendbestellung Nr. %{order_id} für "%{product_name}" bestätigt.',
          company_received_your_order_request_and_has_to_approve_it:
            "Firma %{company_link} hat Ihre Einleitendbestellung von uns bekommen. Die Firma hat %{company_approval_time_limit} um zu antworten, aber normalerweise kommt die Antwort in 1 Stunde. ",
          contact_us_if_problem_repeats: "Falls der Fehler bleibt, kontaktieren Sie bitte uns: %{email}.",
          customer_full_name: "Name und Vorname den Besteller",
          download_order_data_confirmation: "Bestellungsbestätigung herunterladen",
          further_details: "Weitere Infos",
          if_no_online_payment_your_order_will_be_cancelled:
            "Falls Sie nicht bezahlen, Ihre Bestellung wird annuliert werden.",
          loading_failed:
            "Fehler eingetroffen während Angebotdatenladung. Aktualisieren Sie bitte die Webseite um noch einmal zu versuchen. ",
          loading_in_progress: "Datenladung...",
          order_is_waiting_for_company_approval:
            "Ihre Buchung erwartet jetzt einer Bestätigung aus der Firma %{company_link}.",
          order_name: "Bestellung Nr. %{id}",
          order_status: "Bestellungsstatus",
          please_pay_bank_wire_deposit: "Bezahlen Sie bitte mit einer Überweisung. ",
          repeat_payment: "Noch einmal bezahlen",
          share_us_to_friends:
            "Möchten Sie aktuellste Angebote und Rabatte erhalten? Like uns auf Facebook und empfehlen Sie uns anderen. ",
          thank_you_for_order: "Dankeschön für die Bestellung!",
          thank_you_for_order_and_share_to_fb:
            "Dankeschön für die Bestellung. Helfen Sie uns bitte und empfehlen Sie bitte diese Angebot Ihren Freunden auf Facebook!",
          thank_you_for_order_request: "Dankeschön für die Einleitendbestellung.",
          we_received_all_required_order_informations: "Wir haben alle notwendige Daten von Ihnen erhalten.",
          we_received_all_required_order_informations_and_online_payment:
            "Wir haben schon von Ihnen alle notwendige Infos und Bezahlung erhalten.",
          we_sended_order_confirmation_to_your_email:
            "Auf Ihre E-mail Adresse haben wir eine .pdf-Bestätigung geschickt. ",
          we_sended_order_request_confirmation_to_your_email:
            "Auf Ihre E-mail Adresse haben wir eine Bestätigung Ihrer Einleitendbestellung geschickt. ",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "Falls Ihre Bestellung akzeptiert wird, bezahltes Geld wird bei Ihren Bestellung reichen. Falls der Partner %{company_link} sagt es ab oder antwortet nicht im Termin, Onlinevorauszahlung %{confirmation_installment_st_name} wird automatisch auf Ihren Bankkonto in 24 Stunden zurückgesendet. Sie können dann anderen Angebot buchen.",
          when_company_approves_we_will_send_online_payment_email:
            "Falls die Firma %{company_link} Ihre Einleitendbestellung bestätigt, bekommen Sie eine E-Mail mit einem Bezahlungslink, mit dem Sie %{confirmation_installment_amount} bezahlen können. Sie haben %{confirmation_installment_after_company_approval_time_limit} um mit DotPay-Überweisung zu bezahlen.",
          when_company_approves_we_will_send_order_confirmation:
            "Falls die Firma %{company_link} Ihre Einletendbestellung bestätigt, erhalten Sie eine E-Mail mit Bestätigung. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "Firma %{company_link} erhaltet Ihre Einleitendbestellung sofort. Die Firma hat %{company_approval_time_limit} auf einer Antwort, aber normalerweise wird es in 1 Stunde beantwortet. ",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "Nach der Bezahlung erhalten Sie eine Bestätigung über E-Mail. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "Diese Datei kann mit dem Knopf unten heruntergeladen werden. ",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "In der Bestätigung finden Sie auch Information bezüglich verbleibter Bezahlung auf Bankkonto.",
          your_order_id: "Ihre Bestellungsnummer",
          your_order_is_fully_confirmed: "Ihre Buchung ist schon vollig bestätigt geworden.",
          online_payment_failed: "Ihre Onlinezahlung ist leider nicht durchgegangen.",
          order_is_waiting_for_online_payment_info: "Ihre Buchung wartet jetzt auf Info über Ihrer Bezahlung.",
        },
        order_name: "Bestellungsnummer %{id}",
        saas: {
          additional_bank_wire_deposit_required: "Diese Bestellung erfordert Zuzahlung auf Bankkonto.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "Wir haben Ihre Buchung sofort nach der Bezahlung erhalten. Wir haben %{company_approval_time_limit} auf einer Antwort, aber normalerweise antworten wir in 1 Stunde.",
          bank_wire_deposit_deadline_warning:
            "Vergessen Sie bitte nicht im Termin Überweisung zu machen. Falls Sie im Termin Anzahlung nicht bezahlen, Ihre Buchung kann storniert werden.",
          bank_wire_deposit_details: "Daten für der Überweisung ",
          bank_wire_deposit_instructions:
            "Als Überweisungstitel geben Sie bitte nur die Bestellungsnummer, die in dieser Bestätigung sich befindet. Andernfalls können wir nicht garantieren dass Ihre Überweisung zeitlich durchkommt. ",
          company_approved_your_order_request:
            'Wir haben Ihre Einleitendbestellung Nr. %{order_id} für "%{product_name}" bestätigt.',
          company_received_your_order_request_and_has_to_approve_it:
            "Wir haben Ihre Einleitendbestellung erhalten. Wir haben %{company_approval_time_limit} für einer Antwort, aber normalerweise beantworten wir in 1 Stunde. ",
          customer_full_name: "Vorname und Nachname des Besteller",
          download_order_data_confirmation: "Bestellungsbestätigung herunterladen",
          further_details: "Weitere Infos",
          if_no_online_payment_your_order_will_be_cancelled: "Ohne Bezahlung wird Ihre Bestellung storniert.",
          order_is_waiting_for_company_approval: "Ihre Bestellung wartet jetzt auf unserer Bestätigung.",
          order_status: "Bestellungsstatus",
          please_pay_bank_wire_deposit: "Bezahlen Sie bitte mit Überweisung.",
          repeat_payment: "Noch einmal bezahlen",
          thank_you_for_order: "Dankeschön für die Bestellung!",
          thank_you_for_order_request: "Dankeschön für die Einleitendestellung!",
          we_received_all_required_order_informations: "Wir haben alle notwendigen Daten von Ihnen erhalten.",
          we_received_all_required_order_informations_and_online_payment:
            "Wir haben alle notwendigen Daten und Bezahlung von Ihnen erhalten.",
          we_sended_order_confirmation_to_your_email:
            "Auf Ihre E-mail Adresse haben wir Bestätigung Ihrer Bestellung im .pdf-Format geschickt. ",
          we_sended_order_request_confirmation_to_your_email:
            "Auf Ihre E-mail Adresse haben wir Bestätigung Ihrer Einleitendbestellung geschickt. ",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "Falls wir Ihre Anfrage absagen müssen oder antworten nicht, %{confirmation_installment_st_name} online wird automatisch auf Ihren Bankkonto in 24 Stunden zurückgeschickt. Sie können sich auch mit uns in Verbindung setzen und anderen Angebot auswählen.",
          when_company_approves_we_will_send_online_payment_email:
            "Sobald wir Ihre Einleitendbestellung bestätigen, erhalten Sie eine E-Mail mit einem Link für Onlinebezahlung von %{cconfirmation_installmentamount}. Sie haben %{confirmation_installment_after_company_approval_time_limit} um über Dotpay zu bezahlen.",
          when_company_approves_we_will_send_order_confirmation:
            "Falls wir Ihre Einleitendbestellung bestätigen, erhalten Sie eine Bestätigung über E-Mail. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "Wir erhalten Ihre Einleitendbestellung sofort. Wir haben %{company_approval_time_limit} auf einer Antwort, aber normalerweise antworten wir in 1 Stunde.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "Nach Bezahlungsbestätigung erhalten Sie eine E-Mail mit Bestätigung Ihrer Bestellung.  %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "Diese Datei kann mit dem Knopf darunter heruntergeladen werden. ",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "In der Bestätigung finden Sie auch Information bezüglich verbleibter Bezahlung auf Bankkonto.",
          your_order_id: "Ihre Bestellungsnummer",
          your_order_is_fully_confirmed: "Ihre Bestellung ist schon vollig bestätigt geworden. ",
          online_payment_failed: "Ihre Onlinezahlung ist leider nicht durchgegangen.",
          order_is_waiting_for_online_payment_info: "Ihre Buchung wartet jetzt auf Info über Ihrer Bezahlung.",
        },
        step_number: "Schritt %{i}",
        title: "Bestellung Nr. %{order_id} - %{site_name}",
        show_on_map: "Auf der Landkarte zeigen",
        marketplace_booking_unavailable_message_html:
          "Momentan gibt es leider keiner freier Termine. Falls Sie sich trotzdem dafür interessieren, schreiben Sie uns bitte an %{email}, rufen Sie uns bitte an %{phone_number}, oder %{open_chat} jetzt.",
        saas_booking_unavailable_message_html:
          "Momentan gibt es leider keiner freier Termine. Falls Sie sich trotzdem dafür interessieren, schreiben Sie uns bitte an %{email} oder rufen Sie uns bitte an %{phone_number}.",
        open_chat: "mit unserem berater chatten",
        choose_date_step_title: "Datum auswählen",
        fill_order_step_title: "Buchung ergänzen",
        confirm_payment_details_step_title: "Zahlungsdetails bestätigen",
        fill_customer_details_step_title: "Ihre Daten eingeben",
        make_online_payment_step_title: "Online bezahlen",
        order_is_waiting_for_your_approval: "Buchung wartet auf Ihrer Bestätigung.",
        click_below_to_approve: "Unten klicken um zu bestätigen.",
        reject_order: "Buchung abweisen",
        approve_order: "Buchung bestätigen",
        approve_order_failed:
          "Serverfehler eingetroffen. Versuchen Sie bitte noch einmal. Falls das Problem bleibt, kontaktieren Sie uns bitte an info@socialtravel.pl.",
        order_is_finished: "Ihre Buchung ist fertig.",
        we_havent_received_your_review_yet:
          "Sie haben unsere Service nicht rezensiert. Teilen Sie bitte Ihre Erfahrung mit anderen Kunden.",
        write_a_review: "Rezensieren",
      },
      navbar_search: {
        products_count: "%{count} Angebote",
        categories: "Kategorien",
        suppliers: "Lieferanten",
        products: "Angebote",
        search_nearby: "In der Nähe suchen",
        search_query: "Suchen",
      },
      new_order: {
        errors: {
          connection_error_during_saving: "Fehler eingetroffen während Bestellungspeicherung auf dem Server.",
          insufficient_product_quantity:
            "Ausgewählte Menge %{items} kann maximal %{max_persons_count} Personen empfangen. Erhöhen Sie bitte die Menge %{items} bis %{desired_quantity} oder reduzieren Sie bitte die Anzahl der Personen.  ",
          max_quantity_limit:
            "Dieses Angebot ist im ausgewählten Termin in der maximaler Menge %{max_quantity} verfügbar.",
          missing_value: "Wert ergänzen.",
          personal_data_agreement_missing: "Sie müssen akzeptieren, dass Ihre persönlichen Daten verarbeitet werden.",
          product_not_found: "Ausgewähltes Angebot nicht gefunden. ",
          product_schedule_slot_missing: "Ausgewählter Termin des Angebotes nicht mehr verfügbar.",
          product_variant_not_found: "Ausgewählte Variante des Angebotes nicht gefunden. ",
          rules_agreement_missing: "Sie müssen unseren Reglement akzeptieren. ",
          online_payment_impossible_for_selected_parameters:
            "Onlinezahlung mit %{payment_method} ist leider momentan für dieser Buchung nicht verfügbar. Wählen Sie bitte andere Zahlungsmethode aus. ",
          partners_agreement_missing: "Sie müssen der Datenvereinbarung des Partners zustimmen.",
          rodo_agreement_missing: "Sie müssen DSGVO zustimmen.",
        },
        marketplace_service_fee_tooltip:
          "Mit dieser Gebühr wird Betreibung des Portales und Erbringung der Dienstleistung, z. B. Hilfe während die Reise oder Bezahlungsbedienung finanziert. ",
        saas_service_fee_tooltip:
          "Mit dieser Gebühr wird Betreibung des Portales und Erbringung der Dienstleistung, z. B. Hilfe während die Reise oder Bezahlungsbedienung finanziert. ",
        v1_bank_wire_deposit_tooltip: {
          marketplace:
            "Überweisungsdaten und Bezahlungstermin erhalten Sie in der Bestellungsbestätigung auf eingegebene E-mail Adresse. ",
          saas: "Überweisungsdaten und Bezahlungstermin erhalten Sie in der Bestellungsbestätigung auf eingegebene E-mail Adresse.",
        },
        v1_online_deposit_tooltip: {
          marketplace: {
            line1:
              "%{confirmation_installment_st_name} online ist für sichern die Bestellung. Falls Sie darauf verzichten, Stornobedingungen des Angebotes gültig sind.",
            line2:
              "Firma  %{company_link} erhaltet Ihrer Einlteitendbestellung sofort. Die Firma hat %{company_approval_time_limit} auf einer Antwort, aber normalerweise antworten sie in 1 Stunde.",
            line3:
              "Falls die Firma sagt Ihre Anfrage ab oder antwortet nicht, %{confirmation_installment_st_name} Vorauszahlung wird in 24 Stunden auf Ihren Bankkonto automatisch zurückgeschickt. Wir drängen Ihnen Kontakt mit uns zu nehmen, damit wir den Angebot zu Ihren Bedarf anpassen können.",
          },
          saas: {
            line1:
              "%{confirmation_installment_st_name} online ist für sichern die Bestellung. Falls Sie darauf verzichten, Stornobedingungen des Angebotes gültig sind und falls es keine gibt, sind unsere AGBs gültig.",
            line2:
              "Wir erhalten Ihre Einleitendbestellung sofort. Wir haben %{company_approval_time_limit} auf einer Antwort, aber normalerweise beantworten wir in 1 Stunde.",
            line3:
              "Falls wir Ihre Anfrage absagen müssen oder antworten nicht, %{confirmation_installment_st_name} online wird automatisch auf Ihren Bankkonto in 24 Stunden zurückgeschickt. Sie können sich auch mit uns in Verbindung setzen und anderen Angebot auswählen.",
          },
        },
        confirmation_installment_st_name: {
          deposit: "Anzahlung",
          fee: "Gebühr",
          prepayment: "Vorauszahlung",
        },
        v1_rest_deposit_tooltip: {
          on_the_arrival: "",
          on_the_spot: "",
          trip: "",
        },
      },
      order: {
        confirmation_installment_after_company_approval: "Bezahlung nach einer Bestätigung von der Firma.",
        new_order_name: "Neue Bestellung",
        order_name: "Bestellung Nr. %{order_id}",
        v1_online_deposit_now: "Jetzt zu zahlen",
        stock_useby_time_range: {
          between: "",
          from: "",
          to: "",
        },
      },
      order_details: {
        bank_wire_deposit_account_description: "Überweisungsdaten",
        company_details: "Reiseveranstalterdaten",
        customer_details: "Bestellerdaten",
        extra_paid_amount: "Außerdem bezahlt",
        marketplace_service_fee: "Servicegebühr",
        order_details: "Bestellungsdaten",
        order_name: "Bestellung Nr. %{order_id}",
        overpaid_total_amount: "\tÜberzahlung",
        paid_amount: "Bezahlt",
        product_details: "Angebotdaten",
        refunded_amount: "Rückerstattet",
        remaining_total_amount: "Noch zu bezahlen",
        remaining_total_amount_short: "Zu bezahlen",
        saas_service_fee: "Servicegebühr",
        total_amount: "Bestellungssumme",
        total_amount_short: "Insgesamt",
        to_be_paid_total_amount: "Gesamtpreis",
        coupon_offer_price: "Gesamtpreis",
        coupon_offer_price_before_discount: "Generellpreis",
        coupon_discount_amount: "Unser Rabatt",
        coupon_code_realisation_place_online_website_description:
          "Geben Sie bitte den Couponcode beim Reservieren auf der Internetseite ein.",
        coupon_code_realisation_place_manual_description:
          "Geben Sie bitte den Couponcode über E-mail oder telefonisch beim Reservieren ein.",
        ends_at: "",
        starts_at: "",
      },
      personal_data_agreement: {
        label:
          "Ich stimme hiermit der Verarbeitung meiner persönlichen Daten von SocialTravel Sp. z o. o. zum Zweck der Ausführung des Vertrages zu.",
        tooltip:
          "Ich bin damit einverstanden, dass meine persönlichen Daten für die Zwecke meiner Buchung und der Unterstützung nach dem Kauf gesammelt und verarbeitet von SocialTravel sp. z o. o., Al. Ks. J. Poniatowskiego 1, 03-901 Warschau, Polen werden, in Übereinstimmung mit Verordnung (EU) 2016/679 des Europäischen Parlaments und des Rates, auch bekannt als DSGVO.",
      },
      pricelist_expiration_countdown: {
        discount_ends_today: "Sonderangebot endet heute um %{expires_at}.",
        discount_ends_tomorrow: "Sonderangebot endet morgen um %{expires_at}.",
        product_about_to_finish: "Dieses Angebot endet bald. ",
        product_finished: "Dieses Angebot ist schon beendet. ",
        x_days_left_to_end_of_discount: {
          one: "1 Tag bis ende des Sonderangebot!",
          other: "%{count} Tage bis ende des Sonderangebot!",
        },
        x_left_to_end_of_discount: "%{time} bis Ende des Sonderangebot!",
      },
      products_map: {
        buy_product: "Termin reservieren",
      },
      reservation_calendar: {
        only_x_in_this_price: "Nur %{count} mit dieser Preis",
        per_night: "/ Nacht",
        valid_on: "Gilt ",
        last_stocks: "Letzte Plätze",
      },
      rules_agreement: {
        marketplace: {
          label:
            "Ich akzeptiere %{link} und bin damit einverstanden, mit der Erbringung von Dienstleistungen von Tripsomnia zu beginnen vor Ablauf der Widerrufstfrist.",
          link: "Servicereglement",
        },
        saas: {
          label:
            "Ich akzeptiere %{link} und bin damit einverstanden, mit der Erbringung von Dienstleistungen von Reiseveranstalter zu beginnen vor Ablauf der Widerrufstfrist.",
          link: "Reiseveranstalterreglement",
        },
      },
      sidebar_section_order: {
        order_details: "Buchungsdaten",
        title: "Ihre Buchung",
      },
      sidebar_section_product: {
        extend: "Ausrollen",
        product_details: "Angebotsinfos",
      },
      common: {
        site_title: "Tripsomnia",
        loading_failed_message: "Fehler eingetroffen während Datenladung.",
        click_to_load_again: "Hier klicken um erneut zu laden.",
        loading_message: "Datenladung...",
        show_more: "Mehr",
        next_page: "Nächste Seite",
        previous_page: "Vorherige Seite",
        zendesk_livechat_window_title: "Unterstützung",
        zendesk_livechat_concierge_name: "Kundenservice",
        zendesk_livechat_concierge_title: "Wir sind hier um Ihnen zu helfen!",
        close: "Schließen",
      },
      ProductsCalendarWidget: {
        site_title: "Terminkalender",
      },
      ReviewsListWidget: {
        no_reviews_yet: "Keine Rezensionen.",
        add_first_review: "Möchten Sie die erste schreiben? ",
        add_new_review: "Rezensieren",
        total_count: {
          one: "%{formatted_count} Rezension\n%{formatted_count} Rezensionen",
          other: "",
        },
        average_rating: "Durchschnittliche Bewertung",
        rating: "Rezension",
      },
      PaymentMethodsHelper: {
        cash_tooltip: "Mit Bargeld vor Ort bezahlen",
        online_tooltip: "100% online bezahlen",
        online_plus_cash_tooltip: "Jetzt online vorauszahlen + Rest vor Ort mit Bargeld zuzahlen",
      },
      products_listing: {
        medium_priority: "Empfohlen",
        high_priority: "Bestes Angebot",
      },
      bslanding: {
        about_us_contact_form: {
          loading_message: "Laden...",
          success_message: "Nachricht gesendet",
          failure_message: "Fehler eingetroffen. Nachricht wird nicht gesendet. ",
        },
        for_companies_contact_form: {
          loading_message: "Laden...",
          success_message: "Kontoeinrichtungbitte gesendet. Wir setzen uns mit Ihnen bald im Kontant ein. ",
          failure_message: "Fehler eingetroffen. Nachricht wird nicht gesendet. ",
        },
      },
      CouponsWidget: {
        title: "Angebot auswählen",
        discount_amount: "%{amount} Ermäßigung",
        until_product_offer_ends: "%{timeDuration} geblieben",
        only_x_coupons_left: "%{total_stock_used} Coupons heruntergeladen.",
        stock_useby_date_range: "Verfügbar %{date_range}",
        order_price: "Unser Preis",
        order_price_before_discount: "Preis ohne Ermäßigung",
        order_discount_amount: "Sie sparen",
        build_order_button: "Coupon herunterladen",
        build_order_failed:
          "Fehler eingetroffen während Angebotdetails herunterladung. Versuchen Sie bitte noch einmal oder wählen Sie anderes Angebot aus.",
        confirm_order_button: "Voucher herunterladen",
        confirm_order_failed:
          "Fehler eingetroffen während Datenspeicherung. Versuchen Sie bitte noch einmal oder wählen Sie anderes Angebot aus.",
        form_title: "Ergänzen Sie bitte Ihre Daten",
        confirm_order_succeded:
          "Ihr Voucher ist auf eingegebene E-mail Adresse gesendet. Überprüfen Sie bitte Ihre E-mail und nutzen Sie den Coupon beim Reservieren.",
        product_short_description: "Wichtige Infos",
        product_description: "Angebotsbeschreibung",
        product_variant_short_description: "Optionenbeschreibung",
        product_customer_requirements: "Bedingungen",
        extend_infos: "Mehr",
        get_coupon: "Coupon herunterladen",
        hint_title: "Nehmen Sie unsere Sonderangebot in Anspruch",
        hint_content:
          "<ol><li>Gewünschtes Sonderangebot auswählen.</li><li>Beschreibung und Bedingungen durchlesen.</li><li>Angeforderte Infos eingeben und Coupon herunterladen.</li><li>Ermäßigungscoupon beim Reservieren benutzen.</li></ol>",
        less_than_x_coupons_left: "Weniger als %{total_stock_left} Coupons verfügbar.",
        no_results_alert: "Coupons leider nicht mehr verfügbar. Versuchen Sie bitte später.",
      },
      partners_agreement: {
        label:
          "Ich stimme der Verarbeitung meiner persönlichen Daten durch vertrauenswürdige SocialTravel-Partner zur Erfüllung der Bestellung zu.",
        tooltip:
          "Gemäß Artikel 7 Absatz 2 der Verordnung des Europäischen Parlaments und des Rates 2016/679 vom 27. April 2016 (GSDVO) stimme ich ausdrücklich und freiwillig der Verarbeitung und Sammlung meiner personenbezogenen Daten durch vertrauenswürdige Partner zu, um den Vertrag und die Unterstützung nach dem Kauf zu kommunizieren.",
      },
      rodo_agreement: {
        label: "Ich bin mit meiner Rechte gemäß Artikel 7 der GSDVO bewusst",
        tooltip:
          "Gleichzeitig erkläre ich, dass meine Zustimmung allen in Artikel 7 von GSDVO genannten Bedingungen entspricht, d. H. bin ich berechtigt, sie jederzeit zurückzuziehen, der Antrag auf Zustimmung wurde mir in klarer und verständlicher Form vorgelegt und ich wurde über die Möglichkeit ihrer Rechenschaftspflicht informiert. Ich wurde auch darüber informiert, dass die Daten von SocialTravel sp. z o. o., über den Zweck ihrer Sammlung, freiwillige Einreichung, das Recht auf Zugang und die Möglichkeit, sie zu korrigieren, und dass diese Daten anderen Einrichtungen nicht zur Verfügung gestellt werden.",
      },
      tripsomnia_contact_email: "info@tripsomnia.com",
      tripsomnia_contact_phone_number: "+48 690 670 581",
    },
    ransack: {
      predicates: {
        eq: "",
      },
    },
    api: {
      base: {
        unauthorized: "Zugriff abgelehnt. Nochmal anmelden.",
        company_inactive:
          "Die von Ihnen ausgewählte Firma ist derzeit nicht aktiv. Wähle einen anderen oder versuche ihn zu aktivieren.",
        disabled: "",
        secret_invalid: "",
      },
    },
    activerecord: {
      attributes: {
        admin_user: {
          companies: "Verwaltete Unternehmen",
          companies_ids: "Verwaltete Unternehmen",
          company_admin: "Company Admin",
          company_employee: "Mitarbeiter",
          editor_admin: "Editor Admin (TP)",
          global_admin: "Global Admin (SS)",
          main_admin: "Main Admin (S)",
          default_new_company_role: "Standardrolle für neue Firmen",
        },
        agent_cooperation: {
          fixed_gross_pricing: "Feste Bruttopreise",
          fixed_net_pricing: "Feste Nettopreise",
          pricing_type: "Preise festlegen",
          realtime_pricing: "Aktuelle Preise",
          st_fixed_gross_pricing: "Feste Bruttopreise",
          st_fixed_net_pricing: "Feste Nettopreise",
          st_realtime_pricing: "Aktuelle Preise",
        },
        company: {
          accepts_printed_customer_vouchers:
            "Akzeptieren Sie unseren gedruckten .pdf-Gutschein, den Sie vom Kunden erhalten haben?",
          admin_users: "Firmenmitglieder",
          admin_users_ids: "Firmenmitglieder",
          contact_email: "E-Mail Adresse",
          contact_email_placeholder: "Kontakt-E-Mailadresse",
          contact_facebook_url: "Facebook Funpage Adresse",
          contact_facebook_url_placeholder: "Ihre Website Facebook-Adresse",
          contact_full_address: "Büroadresse",
          contact_full_address_placeholder:
            "z. B. Harry-Potter-Straße 319\nLondon SW15 2PG\nGroßbritannien\nZugang von der Autobahn M9",
          contact_languages: "Kontaktsprachen",
          contact_languages_placeholder: "Sprachen, in denen Kunden Sie kontaktieren können",
          contact_opening_hours: "Geschäftsstunden",
          contact_opening_hours_placeholder: "",
          contact_phone_number: "Kontaktnummer",
          contact_phone_number_placeholder: "Kontaktnummer",
          contact_website_url: "Webseite",
          contact_website_url_placeholder: "",
          default_product_price_currency: "",
          general_terms: "Geschäftsbedingungen",
          general_terms_placeholder: "",
          invoice_city: "Stadt",
          invoice_company_name: "Firmenname",
          invoice_country_name: "Land",
          invoice_data: "",
          invoice_email: "E-Mail Adresse",
          invoice_nip: "",
          invoice_phone_number: "Telefon",
          invoice_postal_code: "",
          invoice_street_address: "",
          locale: "Hauptsprache",
          logo_image: "",
          marketplace_cover_image: "",
          marketplace_meta_description: "",
          marketplace_meta_title: "",
          marketplace_name: "",
          marketplace_short_description: "",
          marketplace_short_description_placeholder: "",
          name: "Firmenname",
          name_placeholder: "",
          notifications_email: "",
          notifications_phone_number: "",
          public_name: "",
          saas_cover_image: "",
          saas_meta_description: "",
          saas_meta_title: "",
          saas_name: "",
          saas_short_description: "",
          saas_short_description_placeholder: "",
          saas_subdomain: "",
          active: "Aktiv",
          default_products_enable_frontend_slots_listing:
            "Zeige standardmäßig Termine in einer Liste anstelle des Kalenders",
          enable_saas: "SaaS aktivieren",
          enable_marketplace: "Marketplace aktivieren",
          affiliate_commision_calculation_type: "Affiliate-Provisionsberechnungsart",
          agent_earnings_percentage: "Prozentsatz der Einnahmen des Auftragsagenten (Provision + Servicegebühr)",
          total_base_amount_percentage: "Prozentsatz des Grundbetrags der Bestellung",
        },
        company_member: {
          company_admin: "",
          company_employee: "Mitarbeiter",
          editor_admin: "Editor Admin (TP)",
          global_admin: "Global Admin (SS)",
          main_admin: "Main Admin (S)",
        },
        customer: {
          display_name: "",
          full_name: "",
          full_name_contains: "",
          future: "",
          lost: "",
          orders_company_id: "",
          orders_product_id: "Buchung: Angebot",
          orders_product_name: "",
          orders_product_product_tags_id: "",
          orders_product_variant_id: "",
          orders_status: "",
          origin: "",
          past: "",
          prospect: "",
        },
        installment: {
          confirmation_after_company_approval: "",
          confirmation_before_company_approval: "",
          remaining_amount: "",
          whole_amount: "",
        },
        order: {
          additional_information: "",
          confirmed_at: "",
          customer_display_name: "",
          manual: "",
          marketplace: "",
          product_additional_pickup_instructions: "Richtungen",
          product_customer_hints: "Tipps",
          product_customer_requirements: "Anforderungen",
          product_excluded_items: "Preis inkludiert nicht",
          product_included_items: "Preis inkludiert",
          product_price_currency: "Angebotswährung",
          saas: "",
          status_short: {
            waiting_for_company_approval: "",
            waiting_for_customer_approval: "",
          },
          stock_useby_ends_at: "",
          stock_useby_starts_at: "",
          automatic: "",
          source: "",
          pickup_point: "Treffpunkt",
          agent_disbursement_status: "Auszahlungsstatus des Agenten",
          uncleared: "Ungelöscht",
          cleared: "Gelöscht",
          coupon_code_name: "Gutscheincode",
          author_place_cwa: "",
          author_place_frontend: "",
          author_place_partner: "",
        },
        order_customer_participant: {
          display_name: "Teilnehmer Nr. %{i}",
        },
        order_installment: {
          amount_hint: "",
          confirmation_installment_hint: "",
          paid_after_company_approval_hint: "",
          paid_by_at_hint: "",
          paid_by_time_duration_hint: "",
          remaining_amount: "",
          remaining_amount_hint: "",
          account_description: "Bankkonto Beschreibung",
        },
        order_item: {
          base_item: "",
          item_type: "",
          marketplace_service_fee: "Tripsomnia Servicegebühr",
          name: "",
          order_summary: "Insgesamt",
          payment_profile_service_fee: "",
          product_coupon: "Coupon",
          product_custom: "",
          product_item: "",
          product_option: "Zusatzoption",
          product_refund: "Rückerstattung",
          quantity: "",
          saas_service_fee: "Tripsomnia Transaktionsgebühr",
          service_fee: "Servicegebühr",
          unit_price: "",
        },
        order_status_history: {
          abandon: "",
          auto_refund_issued: "",
          build: "",
          company_approval_time_limit_exceeded: "",
          company_approve: "Buchung von der Firma bestätigt",
          company_cancel: "Buchung von der Firma storniert",
          company_reject: "Buchung von der Firma storniert",
          confirm: "Buchung geschickt",
          confirmation_online_payment_time_limit_exceeded: "Das Ende der Online-Zahlungsfrist",
          customer_approval_time_limit_exceeded: "",
          customer_approve: "Buchung von dem Kunden bestätigt",
          expire: "",
          finish: "Buchung fertig",
          finish_online_payment: "",
          manual_status_change: "",
          pause: "",
        },
        order_transfer: {
          agent: "",
          bank_wire: "Überweisung",
          cash: "Bargeld",
          custom: "",
          customer: "Kunde",
          dotpay: "Onlinezahlungsplattform",
          online_payment: "Onlinebezahlung",
          receiver: "Bis",
          sender: "Ab",
          socialtravel: "Tripsomnia",
          source_payload: "",
          source_type: "",
          transfer_type: "",
          transferred_at: "",
          refund_type: "Rückerstattungsmethode",
          refunded_at: "Rückerstattungsdatum",
          from_customer_frontend_name: "Bezahlt %{transfer_type} an %{transfer_date}",
          to_customer_frontend_name: "Rückerstattet %{transfer_type} an %{transfer_date}",
          customer_to_supplier_backend_name:
            "Der Kunde hat dem Lieferanten %{transfer_type} an %{transfer_date} bezahlt",
          customer_to_agent_backend_name: "Der Kunde hat dem Agenten %{transfer_type} an %{transfer_date} bezahlt",
          customer_to_socialtravel_backend_name:
            "Der Kunde hat Tripsomnia %{transfer_type} an %{transfer_date} bezahlt",
          company_to_customer_backend_name:
            "Lieferant hat dem Kunden %{transfer_type} an %{transfer_date} rückerstattet",
          company_to_agent_backend_name: "Lieferant hat dem Agenten %{transfer_type} an %{transfer_date} bezahlt",
          company_to_socialtravel_backend_name: "Lieferant hat Tripsomnia %{transfer_type} an %{transfer_date} bezahlt",
          agent_to_customer_backend_name: "Agent hat dem Kunden %{transfer_type} an %{transfer_date} rückerstattet",
          agent_to_supplier_backend_name: "Agent hat dem Lieferanten %{transfer_type} an %{transfer_date} bezahlt",
          agent_to_socialtravel_backend_name: "Agent hat Tripsomnia %{transfer_type} an %{transfer_date} bezahlt",
          socialtravel_to_customer_backend_name:
            "Tripsomnia hat dem Kunden %{transfer_type} an %{transfer_date} rückerstattet",
          socialtravel_to_agent_backend_name: "Tripsomnia hat dem Agenten %{transfer_type} an %{transfer_date} bezahlt",
          socialtravel_to_supplier_backend_name:
            "Tripsomnia hat dem Lieferanten %{transfer_type} an %{transfer_date} bezahlt",
          supplier_to_agent_backend_name: "",
          supplier_to_customer_backend_name: "",
          supplier_to_socialtravel_backend_name: "",
        },
        payment_profile: {
          additional_fee: "",
          additional_fee_name: "",
          additional_fee_percentage: "",
          companies: "",
          companies_ids: "",
          default_additional_fee_name: "",
          has_additional_fee: "",
          marketplace: "",
          saas: "",
          additional_fee_as_agent_fee: "Fügen Sie die Gebühr als Agentsgebühr hinzu",
        },
        payment_profile_installment: {
          amount: "",
          amount_percentage: "",
          increase_amount_by_marketplace_commision: "",
          increase_amount_by_marketplace_service_fee: "",
          account_description: "Bankkonto Beschreibung",
        },
        payment_profile_product_attachment: {
          date_limit_type: "",
          date_limit_type_label: "",
          days_before_arrival_date_limit: "",
          max_days_before_arrival: "",
          min_days_before_arrival: "",
          no_date_limit: "",
        },
        pricing: {
          absolute_amount: "",
          absolute_amount_cents: "",
          absolute_percentage: "",
          relative_amount: "",
          relative_amount_cents: "",
          relative_percentage: "",
        },
        product: {
          categories: "",
          product_company_tags: "",
          active: "Aktiv",
          included_items_placeholder: "z.B. Vollpension",
          excluded_items_placeholder: "z.B. Versicherung",
          customer_requirements_placeholder: "z.B. Erforderliches Mindestalter von 18 Jahren oder ein Hauptbegleite",
          customer_hints_placeholder: "z.B. Denken Sie daran, warme Schuhe bei sich zu haben.",
          highlights_placeholder: "z.B. Ein toller Ausflug für Paare",
          categories_placeholder: "Kategorie hinfügen",
          enable_frontend_slots_listing: "Zeige Termine in einer Liste anstatt in einem Kalender",
          coupon_code_realisation_place_type: "Gutscheincode-Realisierungsplatz",
          coupon_code_realisation_place_custom_description: "Gutscheincode-Realisierungsplatzbeschreibung",
        },
        product_integration: {
          auto_update_description: "auto update description",
          auto_update_images: "auto update photos",
          auto_update_prices: "auto update price",
          auto_update_calendar: "auto update calendar"
        },
        product_option: {
          all_product_variants: "",
          required: "",
        },
        product_order_field: {
          "ProductOrderField::BigText": "",
          "ProductOrderField::Boolean": "",
          "ProductOrderField::Date": "Termin",
          "ProductOrderField::Email": "E-Mail Adresse",
          "ProductOrderField::Geopoint": "",
          "ProductOrderField::List": "",
          "ProductOrderField::Number": "Nummer",
          "ProductOrderField::PhoneNumber": "Telefonnummer",
          "ProductOrderField::Text": "",
          assignation_per_person_label: "",
          assignation_type: "",
          customer_hint: "",
          customer_hint_placeholder: "",
          list_options: "",
          max_value: "",
          min_value: "",
          multiply_price_by_nights_count: "",
          order_value_required: "",
          presets: {
            customer_email: {
              frontend_name: "E-Mail Adresse",
              name: "",
            },
            customer_full_name: {
              frontend_name: "Vorname und Nachname",
              name: "",
            },
            customer_note: {
              customer_hint:
                "Geben Sie bitte Ihre Spezialwünsche ein. Wir können nicht garantieren dass wir sie erfüllen, wir werden aber versuchen.",
              frontend_name: "Spezialwünsche",
              name: "Spezialwünsche",
            },
            customer_phone_number: {
              customer_hint: "Kontaktnummer für den Fall, dass es Rückfragen zu Ihrer Buchung gibt.",
              frontend_name: "Kontaktnummer",
              name: "",
            },
            participant_birth_date: {
              frontend_name: "Geburtsdatum",
              name: "Teilnehmer Geburtsdatum",
            },
            participant_email: {
              frontend_name: "E-Mail Adresse",
              name: "",
            },
            participant_full_name: {
              frontend_name: "Vorname und Nachname",
              name: "",
            },
            participant_phone_number: {
              frontend_name: "Kontaktnummer",
              name: "",
            },
            customer_city: {
              frontend_name: "Stadt",
              name: "Kundenstadt",
            },
            customer_postal_code: {
              frontend_name: "Postanzahl",
              name: "Kunden-Postleitzahl",
            },
            customer_country: {
              frontend_name: "Land",
              name: "Kundenland",
            },
            customer_hotel_name: {
              name: "Hotel",
              customer_hint:
                "Geben Sie bitte die Hotelname, die Adresse und die Zimmmernummer ein, falls Sie diese kennen.",
            },
            customer_dates_of_stay: {
              name: "Datum des Aufenthalts",
            },
          },
          price_included_in_order_base_amount: "",
          price_none: "Keine",
          price_type: "",
          product_variants: "Angebotsvariante",
          product_variants_assignation_all: "Alle Variante",
          product_variants_assignation_some: "Manche Variante",
          product_variants_assignation_type: "",
          product_variants_ids: "Variante",
          show_on_manifest: "Show on List of Participants",
          type: "",
          "ProductOrderField::PickupPoint": "Treffpunkt",
          undefined_pickup_point_option_name: "Undefiniert",
          custom_pickup_point_option_name: "Kundenspezifischer Aufnahmepunkt",
          custom_pickup_point_display_name: "Kundenadresse: %{custom_location_name}",
          "ProductOrderField::Country": "Land",
          custom_field: "Benutzerdefinierte Feld",
        },
        product_pricelist_item: {
          preset_fixed: "",
          preset_id: "",
          preset_item: "",
          preset_person_adult: "Erwachsenen",
          preset_person_child: "Kinder",
          preset_person_custom: "",
          preset_person_everyone: "Person",
          preset_person_group_1_plus_2: "Familie 1+2",
          preset_person_group_1_plus_3: "Familie 1+3",
          preset_person_group_2_plus_1: "Familie 2+1",
          preset_person_group_2_plus_2: "Familie 2+2",
          preset_person_group_2_plus_3: "Familie 2+3",
          preset_person_group_custom: "Gruppe",
          preset_person_group_double: "2 Personen",
          preset_person_group_family_of_3: "",
          preset_person_group_family_of_4: "",
          preset_person_group_family_of_5: "",
          preset_person_group_quad: "4 Personen",
          preset_person_group_single: "1 Person",
          preset_person_group_triple: "3 Personen",
          preset_person_infant: "Babys",
          preset_person_normal: "Normal",
          preset_person_reduced: "Ermäßigt",
          preset_person_senior: "Senioren / Rentner",
          preset_person_student: "Student",
          preset_person_teenager: "",
          price_type: "",
        },
        product_schedule_slot: {
          availability_type: "",
          available_with_company_approval: "",
          available_with_instant_booking: "Sofortbuchung",
          date: "",
          datetime: "",
          total_stock_left: "",
          total_stock_limit: "",
          total_stock_used: "",
          active: "Verfügbar",
          available_with_instant_booking_help: "Alle Buchungen werden automatisch bestätigt.",
          available_with_company_approval_help:
            "Sofortige Buchung ist deaktiviert. Sie erhalten erste Anfragen und müssen jede Buchung bestätigen.",
          confirmed: "Bestätigt",
        },
        product_tag: {
          category: "Kategorie",
          location: "",
          parent: "",
          product_st_tag: "",
          product_company_tag: "Firmentag",
          show_on_fe_listing: "Im Angebot anzeigen",
          show_on_fe_product_page: "Zeige auf der Angebotsseite",
          fe_color: "Front-end Farbe",
        },
        product_variant: {
          additional_pickup_instructions: "Zusatzeinrichtungen",
          allow_custom_pickup_point: "",
          allow_no_pickup_point: "",
          custom_pickup_point_additional_fee: "",
          default: "",
          default_requires_company_approval: "",
          default_total_stock_limit: "",
          nb_requires_company_approval: "",
          nb_stock_useby_days_limit: "",
          nb_stock_useby_ends_at: "",
          nb_stock_useby_starts_at: "",
          nb_total_stock_left: "",
          nb_total_stock_limit: "",
          nb_total_stock_used: "",
          pickup_points_assignation_type: "",
          pricelist_by_item: "",
          pricelist_by_order: "",
          pricelist_by_person: "",
          pricelist_type: "",
          additional_pickup_instructions_placeholder: "Richtungen hinfügen",
          coupon_discount_amount: "Gutschein Rabattbetrag",
          coupon_discount_percentage: "Coupon Rabatt Prozentsatz",
          coupon_offer_price_before_discount: "Preis ohne Gutschein-Rabatt",
          coupon_offer_price: "Preis mit Gutschein-Rabatt",
        },
        view_collection_item: {
          related_model: "",
        },
        view_section: {
          name: "Titel",
          show_name: "",
          type: "",
          types: {
            "ViewSection::CompanyProducts": "",
            "ViewSection::CustomCollection": "",
            "ViewSection::CustomContent": "",
            "ViewSection::CustomCover": "",
            "ViewSection::ProductTagChildren": "",
            "ViewSection::ProductTagProducts": "",
            "ViewSection::ProductTagsCategoryProducts": "",
            "ViewSection::ProductTagsCategoryTags": "",
            "ViewSection::ViewedProducts": "Kürzlich angesehene Angebote",
            "ViewSection::SimilarToViewedProducts": "Ähnliche Angebote zum letzten gesehen",
            "ViewSection::ViewedProductsTags": "Kategorien und Standorte kürzlich angesehener Angebote",
          },
          view_collection_items_limit: "",
          view_mode: "",
          view_modes: {
            cards_listing: "",
            cards_slider: "",
            extended_cards_listing: "",
            items_carousel: "",
            products_map: "",
            wide_cards_slider: "",
            wide_cards_listing: "Große Tab-Seiten-Liste",
          },
          with_similar_items: "Ähnliche Elemente anzeigen",
        },
        activity: {
          customer_email_sent_title: "",
          customer_email_sent_content: "Titel: %{email_subject}",
          customer_sms_sent_title: "",
          customer_sms_sent_content: "",
          order_status_updated_content: "",
          review_created_title:
            "Kunde hat eine Rezension für dich abgegeben mit einer Bewertung von %{rating}/%{max_rating}",
          review_created_content: "Rezensionsinhalt: %{content}",
          customer_to_supplier_order_transfer_created_title: "Der Kunde hat dem Lieferanten %{amount} bezahlt",
          customer_to_agent_order_transfer_created_title: "Der Kunde hat dem Agenten %{amount} bezahlt",
          customer_to_socialtravel_order_transfer_created_title: "Der Kunde hat Tripsomnia %{amount} bezahlt",
          company_to_customer_order_transfer_created_title: "Lieferant hat dem Kunden %{amount} rückerstattet",
          company_to_agent_order_transfer_created_title: "Lieferant hat dem Agenten %{amount} übertragen",
          company_to_socialtravel_order_transfer_created_title: "Lieferant hat Tripsomnia %{amount} übertragen",
          agent_to_customer_order_transfer_created_title: "Agent hat dem Kunden rückerstattet",
          agent_to_supplier_order_transfer_created_title: "Lieferant hat dem Kunden %{amount} rückerstattet",
          agent_to_socialtravel_order_transfer_created_title: "Agent hat Tripsomnia %{amount} übertragen",
          socialtravel_to_customer_order_transfer_created_title: "Tripsomnia hat dem Kunden %{amount} rückerstattet",
          socialtravel_to_agent_order_transfer_created_title: "übertragen",
          socialtravel_to_supplier_order_transfer_created_title: "Tripsomnia hat dem Lieferanten %{amount} bezahlt",
          supplier_email_sent_content: "Titel: %{email_subject}",
          supplier_email_sent_title: "E-Mail an dem Lieferanten (%{recipient_email}) gesendet",
          supplier_sms_sent_content: "Inhalt: %{sms_content}",
          supplier_sms_sent_title: "SMS an dem Lieferanten (%{recipient_phone_number}) gesendet",
          customer_sms_send_failed_content: "Fehlermeldung: %{error_message}",
          customer_sms_send_failed_title:
            "Beim Senden einer SMS an den Kunden ist ein Fehler aufgetreten (%{recipient_phone_number})",
          supplier_sms_send_failed_content: "Fehlermeldung: %{error_message}",
          supplier_sms_send_failed_title:
            "Beim Senden einer SMS an den Lieferanten ist ein Fehler aufgetreten (%{recipient_phone_number})",
          payment_issued_title: "Gestartet: Kunde %{source} Zahlungsvorgang (%{amount})",
          payment_in_progress_title: "In Bearbeitung: Kunde %{source} Zahlungsvorgang (%{amount})",
          payment_completed_title: "Erfolgreich abgeschlossen: Kunde %{source} Zahlungsvorgang (%{amount})",
          payment_failed_title: "Gescheitert: Kunde %{source} Zahlungsvorgang (%{amount})",
          refund_issued_title: "Gestartet: Kunde %{source} Rückerstattungsvorgang (%{amount})",
          refund_in_progress_title: "In Bearbeitung: Kunde %{source} Rückerstattungsvorgang (%{amount})",
          refund_completed_title: "Abgeschlossen: Kunde %{source} Rückerstattungsvorgang (%{amount})",
          refund_failed_title: "Gescheitert: Kunde %{source} Rückerstattungsvorgang (%{amount})",
          sms_send_failed_content: "Fehlermeldung: %{error_message}",
          sms_send_failed_title: "Beim Senden der SMS ist ein Fehler aufgetreten (%{recipient_phone_number})",
          sms_sent_content: "Inhalt: %{sms_content}",
          sms_sent_title: "SMS gesendet (%{recipient_phone_number})",
          supplier_to_agent_order_transfer_created_title: "",
          supplier_to_customer_order_transfer_created_title: "",
          supplier_to_socialtravel_order_transfer_created_title: "",
        },
        product_pickup_point: {
          additional_instructions_placeholder: "Fügen Sie eine detaillierte Beschreibung des Treffpunkts hinzu",
        },
        review: {
          single: "1 Person",
          couple: "Paar",
          friends: "Freunde",
          family: "Familie",
          age_group: "Altersgruppe",
          group_type: "Gruppentyp",
          author_name: "Name des Rezensent",
          author_email: "E-Mail Adresse des Rezensent",
          content: "Inhalt",
          rating: "Allgemeine Punktzahl",
          st_feedback: "Rezension von Tripsomnia",
          st_rating: "Bewertung von Tripsomnia",
          rating_1: "Sehr schlecht",
          rating_2: "Schlecht",
          rating_3: "Akzeptabel",
          rating_4: "Gut",
          rating_5: "Sehr gut",
          st_rating_1: "Sehr schlecht",
          st_rating_2: "Schlecht",
          st_rating_3: "Ausreichend",
          st_rating_4: "Gut",
          st_rating_5: "Wunderbar",
          verified: "Verifizierte Rezension",
          "18-24": "18-24 Jahre",
          "25-30": "25-30 Jahre",
          "31-40": "31-40 Jahre",
          "41-60": "41-60 Jahre",
          "60+": "60+ Jahre",
          anonymous: "Anonym",
        },
        coupon_code: {
          total_stock_left: "Verbleibende Nutzung",
          total_stock_limit: "Nutzungsbeschränkung",
          total_stock_used: "Verwendung genommen",
        },
        product_variant_additional_detail: {
          category: {
            one_person_room: "",
            two_person_room: "",
            three_person_room: "",
            four_person_room: "",
            multi_person_room: "",
            bed_in_multi_person_room: "",
            apartment: "",
            cottage: "",
            villa: "",
            holiday_house: "",
            tent: "",
          },
        },
        product_types: {
          voucher: "",
          accommodation: "",
          coupon: "",
          standard: "",
          ticket: "",
        },
        pricing_plan: {
          preset: {
            elastic: {
              name: "",
              company_description: "",
              customer_description: "",
            },
            not_refundable: {
              name: "",
              company_description: "",
              customer_description: "",
            },
          },
        },
        pricing_plan_types: {
          not_refundable: "",
          elastic: "",
        },
      },
      errors: {
        models: {
          order: {
            inactive_product: "Angebot nicht mehr aktiv",
            missing_order_customer_participants_data: "",
            too_high_product_quantity: "",
            customer_display_name_missing:
              "Füllen Sie mindestens einen Wert des Kunden aus (Name, E-Mail-Adresse oder Telefonnummer).",
            too_low_product_quantity: "Sie haben 0 Pakete ausgewählt. Wählen Sie mindestens eine Person aus.",
            agent_has_disabled_saas:
              "Der Agent hat seine SaaS-Kooperation mit Tripsomnia deaktiviert. Eine solche Bestellung ist momentan unmöglich.",
            supplier_has_disabled_saas:
              "Der Reiseveranstalter hat seine SaaS-Kooperation mit Tripsomnia deaktiviert. Eine solche Bestellung ist momentan unmöglich.",
            supplier_has_disabled_marketplace:
              "Der Reiseveranstalter hat seine Kooperation mit Tripsomnia deaktiviert. Eine solche Bestellung ist momentan unmöglich.",
            supplier_saas_subdomain_required:
              "Der Anbieter hat keine Domain für die Website seiner Buchung festgelegt. Eine solche Buchung ist unmöglich. Bitte kontaktieren Sie die Tripsomnia-Verwaltung, um das Problem zu beheben.",
            agent_saas_subdomain_required:
              "Der Agent hat keine Domain für die Website seiner Bestellung festgelegt. Eine solche Reihenfolge ist unmöglich. Bitte kontaktieren Sie die Tripsomnia-Verwaltung, um das Problem zu beheben.",
            confirmation_installment_impossible:
              "Leider ist es derzeit nicht möglich, diese Bestellung mit einer Online-Zahlung zu bezahlen. Bitte wählen Sie nach Möglichkeit einr andere Zahlungsmethode oder kontaktieren Sie uns direkt.",
            stock_useby_date_passed:
              "Das Realisierungsdatum dieses Angebots ist schon abgelaufen. Es ist zu spät, um es jetzt zu buchen.",
            product_expired: "Angebot nicht mehr gültig.",
          },
          order_item: {
            wrong_price_currency: "Die Preiswährung für diese Art von Artikel muss: %{valid_currencies} sein.",
          },
          product: {
            must_be_empty_when_product_has_no_booking:
              'Der Wert %{Wert} ist nicht zulässig bei Angeboten mit Buchungstyp "Keine Buchungen".',
            product_variant_with_percentage_amounts_defined:
              'Mindestens eine der Preislisten dieses Angebots enthält eine der "Servicegebühr", "Provision", "Bankeinzahlungsgebühr" als Prozentsatz. Bevor Sie die Währung der Preislisten in eine andere als PLN ändern, ändern Sie diese Werte von Prozentsätzen in Quoten.',
            product_pricelist_items_missing: "Füllen Sie mindestens eine Preiskategorie aus.",
          },
          product_order_field: {
            pricing_disallowed_for_this_type:
              "Für diese Art von Option ist die Aktivierung der Preisliste nicht möglich.",
          },
          product_tag: {
            parent_must_have_the_same_type: "Das übergeordnete Tag muss vom gleichen Typ sein wie sein Subtag.",
            parent_cant_be_self: "Das übergeordnete Tag darf nicht selbst sein.",
            parent_cant_be_its_child: "Das Eltern-Tag kann nicht gleichzeitig sein Kind sein.",
          },
        },
      },
      models: {
        admin_user: {
          one: "Admin",
          other: "Admins",
        },
        attachment: {
          one: "Anhang",
          other: "Anhänge",
        },
        company: {
          one: "Firma",
          other: "Firmen",
        },
        customer: {
          one: "Kunde",
          other: "Kunden",
        },
        list_option: {
          one: "Option zu wählen",
          other: "Optionen zur Auswahl",
        },
        order: {
          one: "Buchung",
          other: "Buchungen",
        },
        order_installment: {
          one: "Rate",
          other: "Raten",
        },
        order_item: {
          one: "Bestellte Artikel",
          other: "Bestellte Artikel",
        },
        order_transfer: {
          one: "Zahlung / Rücktritt",
          other: "Zahlungen / Rücktritte",
        },
        payment_profile: {
          one: "Zahlungsprofil",
          other: "Zahlungsprofile",
        },
        payment_profile_installment: {
          one: "Rate",
          other: "Raten",
        },
        payment_profile_product_attachment: {
          one: "Verwandet Zahlungsprofil",
          other: "Verwandte Zahlungsprofile",
        },
        pricing: {
          one: "Maßgeschneiderter Preis",
          other: "Maßgeschneiderte Preise",
        },
        product: {
          one: "Angebot",
          other: "Angebote",
        },
        product_option: {
          one: "Zusatzoption",
          other: "Zusatzoptionen",
        },
        product_option_value: {
          one: "Wert",
          other: "Werte",
        },
        product_order_field: {
          one: "Zusatzoption / zu ausfüllen",
          other: "Zusatzoptionen / zu ausfüllen",
        },
        product_pricelist_item: {
          one: "Preiskategorie",
          other: "Preiskategorien",
        },
        product_schedule: {
          one: "Datumsregel",
          other: "Datumsregeln",
        },
        product_tag: {
          one: "Angebots-Tag",
          other: "Angebottags",
        },
        product_tags_category: {
          one: "Angebottagskategorie",
          other: "Angebottagskategorien",
        },
        product_variant: {
          one: "Angebotvariant",
          other: "Angebotvariante",
        },
        tag: {
          one: "Tag",
          other: "Tags",
        },
        view_collection_item: {
          one: "Sammlungsgegenstand",
          other: "Sammlungsgegenstände",
        },
        view_page: {
          one: "Unterseite",
          other: "Unterseiten",
        },
        view_section: {
          one: "Abschnitt anzeigen",
          other: "Abschnitte anzeigen",
        },
        company_registration: {
          one: "Firmenregistrierung",
          other: "Firmenregistrierungen",
        },
      },
    },
    attributes: {
      abandoned: "Verlassen",
      accomodation: "Unterkunft",
      action: "Aktion",
      active: "Aktiv?",
      additional_fee: "Zuschlag",
      additional_instructions: "Zusatzanweisungen",
      address: "Adresse",
      admin_user: "Admin",
      agent: "Agent",
      agent_commision: "Agentprovision",
      agent_commision_amount: "Agentprovision",
      agent_commision_amount_cents: "Agentprovision [in groszy]",
      agent_commision_percent: "Agentprovision [%]",
      agent_note: "Private Agent-Notiz",
      all_day_event: "Den ganzen Tag lang?",
      all_products: "Alle Angebote",
      all_tagged_products: "Alle Angebote (mit diesem Tag oder seinen Untertags)",
      amount: "Menge",
      amount_cents: "Menge",
      amount_percentage: "Prozentsatzbetrag",
      amount_type: "Preismodell",
      api_version: "API-Version",
      approved: "Bestätigt",
      arrival_time: "Ankunft am",
      assignation_per_item: "pro Paket",
      assignation_per_order: "pro Buchung",
      assignation_per_person: "pro Person",
      attachments: "Anlagen",
      balance: "Kundensaldo",
      balance_status: "Zahlungsstatus",
      balance_status_for_today: "Zahlungsstatus für heute",
      bank_wire: "Banküberweisung",
      bank_wire_account_description: "Überweisungsdetails",
      bank_wire_account_description_hint: "Kann nur vom Hauptadministrator bearbeitet werden.",
      birth_date: "Geburtsdatum",
      booking_type: "Buchungsart",
      boolean_value_type: "Kontrollkästchen (ja / nein)",
      build: "Buchung anlegen",
      building: "Entwurf",
      cancellation_policy: "Stornierungsbedingungen",
      cancelled: "Storniert",
      cash: "In Bargeld",
      categories: "Kategorien",
      change_status: "Status Änderung",
      companies_count: "Anzahl der Unternehmen",
      company: "Unternehmen",
      company_approval_time_limit: "Frist für die Bestätigung der Auftragsbestätigung des Unternehmens",
      company_approval_time_limit_exceeded: "Die Bestätigungszeit des Unternehmens wurde überschritten",
      company_approval_time_limit_in_hours: "Auftragsbestätigungszeitlimit [in Stunden]",
      company_approve: "Buchungsbestätigung des Unternehmens",
      company_automatic_invoice_amount: "Betrag für die automatische Abrechnung mit der Gesellschaft",
      company_automatic_invoice_date: "Datum der automatischen Abrechnung mit der Firma",
      company_cancel: "Buchung von der Firma storniert",
      company_given_amount_through_online_deposit: "Betrag, der per Online-Zahlung an das Unternehmen überwiesen wird",
      company_invoice_id: "Rechnungsnummer des Unternehmens",
      company_name: "Firmenname",
      company_over_received_amount_through_online_deposit: "",
      company_received_amount_through_online_deposit: "",
      company_reject: "",
      company_remaining_invoice_amount: "",
      company_tag: "",
      company_total_invoice_amount: "",
      confirm: "",
      confirmation_installment: "",
      confirmation_installment_after_company_approval: "",
      confirmation_installment_after_company_approval_hint: "",
      confirmation_installment_after_company_approval_time_limit: "",
      confirmation_online_payment_time_limit_exceeded: "",
      country: "Land",
      coupon: "",
      coupon_price: "",
      created_at: "",
      currency: "",
      current_password: "",
      current_sign_in_at: "",
      current_sign_in_ip: "",
      customer: "Kunde",
      customer_approval_time_limit: "",
      customer_approval_time_limit_exceeded: "",
      customer_approval_time_limit_in_hours: "",
      customer_automatic_invoice_amount: "",
      customer_email: "",
      customer_full_name: "",
      customer_full_name_contains: "",
      customer_hints: "Tipps",
      customer_invoice_id: "",
      customer_invoiced_amount: "",
      customer_locale: "",
      customer_note: "Spezialwünsche",
      customer_phone_number: "",
      customer_remaining_invoice_amount: "",
      customer_requirements: "Anforderungen",
      customer_rules_agreement: "",
      customer_tag: "",
      customer_total_invoice_amount: "",
      customers_count: "",
      dates: "Termine",
      datetime: "Datum und Zeit",
      days_count: "",
      default_marketplace_commision_amount: "",
      default_marketplace_commision_percentage: "",
      default_marketplace_service_fee_amount: "",
      default_marketplace_service_fee_percentage: "",
      default_saas_commision_amount: "",
      default_saas_commision_percentage: "",
      departure_time: "Abfahrt um",
      deprecated_v1_bank_wire_company_deposit: "",
      deprecated_v1_bank_wire_socialtravel_deposit: "",
      deprecated_v1_excludes_content: "",
      deprecated_v1_includes_content: "Preis inkludiert (v1)",
      deprecated_v1_location_alternative_map_content: "",
      deprecated_v1_requirements_content: "",
      description: "Beschreibung",
      discount: "Ermäßigung",
      discount_amount: "Ermäßigung",
      discount_amount_cents: "",
      discounted: "",
      draft: "",
      email: "E-Mail Adresse",
      end_date: "",
      end_time: "",
      ends_at: "",
      exact_amount: "",
      exact_date: "",
      excluded_items: "Preis inkludiert nicht",
      expire: "",
      expired: "",
      expired_at: "",
      expires_at: "",
      featured_price: "",
      featured_price_before_discount: "",
      file: "Datei",
      finish: "",
      finish_online_payment: "",
      finished: "",
      first_name: "",
      fluid_date_booking: "",
      frontend_name: "",
      frontend_view: "",
      full_name: "",
      full_person_name: "Vorname und Nachname",
      fully_paid: "Bezahlt",
      global_role: "Global role (PA)",
      highlights: "",
      id: "",
      inactive: "",
      included_items: "Preis inkludiert",
      includes_time: "",
      increase_orders_amount_by_saas_commision: "",
      installments: "",
      internal_note: "",
      invoice_date: "",
      issuer: "Aktionsautor",
      last_sign_in_at: "Letzter Log-in",
      last_sign_in_ip: "",
      last_status_action: "",
      locale: "Sprache",
      location: "Ort",
      location_coordinates: "Geografische Koordinaten",
      location_lat: "Breite",
      location_lng: "Längengrad",
      location_name: "",
      locations: "",
      logo_image: "",
      main_company: "",
      main_image: "",
      marketplace: "",
      marketplace_commision: "",
      marketplace_commision_amount: "",
      marketplace_commision_amount_cents: "",
      marketplace_commision_percent: "",
      marketplace_featured_price: "",
      marketplace_featured_price_before_discount: "",
      marketplace_service_fee: "",
      marketplace_service_fee_amount: "",
      marketplace_service_fee_amount_cents: "",
      marketplace_service_fee_percent: "",
      max_days_count: "",
      max_nights_count: "",
      max_number_value: "",
      max_order_stock_count: "",
      max_person_age: "",
      max_persons_count: "",
      meta_description: "",
      meta_title: "",
      min_days_count: "",
      min_nights_count: "",
      min_order_stock_count: "",
      min_person_age: "",
      min_persons_count: "",
      name: "Name",
      nb_stock_useby_date: "",
      nb_stock_useby_days_limit: "",
      nb_stock_useby_ends_at: "",
      nb_stock_useby_starts_at: "",
      new_status: "Neuer Status",
      nights_count: "",
      no_booking: "Keine Buchungen",
      note: "",
      number_value_multiplies_price: "",
      number_value_type: "",
      offers_count: "",
      on_stock_starts_at: "",
      online_payment: "Onlinebezahlung",
      order: "Buchung",
      order_bill: "Rechnung",
      order_customer_participants: "Teilnehmer",
      order_items: "",
      order_tag: "",
      order_transfers: "",
      ordered_product_order_fields: "Zusatzoptionen / zu ausfüllen",
      ordered_product_pricelist_items: "Gebuchte Pakete",
      orders: "Buchungen",
      orders_count: "",
      orders_marketplace_commision_amount_sum: "",
      orders_total_amount_sum: "",
      overpaid: "",
      paid_after_company_approval: "",
      paid_amount: "Bezahlt",
      paid_amount_sum: "Bezahlt",
      paid_before_company_approval: "",
      paid_by_at: "Zahlungsfrist",
      paid_by_at_formatted: {
        on_stock_starts_at: "",
        x_days_after_order_company_approval: "",
        x_days_after_order_creation: "",
        x_days_after_order_full_approval: "",
        x_days_after_previous_installment: "",
        x_days_before_stock_starts_at: "",
        immediately: "",
      },
      paid_by_time_duration: "",
      paid_by_type: "",
      parent: "",
      partly_paid: "",
      password: "",
      password_confirmation: "",
      pause: "",
      payment: "",
      payment_completed: "",
      payment_failed: "",
      payment_in_progress: "",
      payment_operations: "",
      payment_profile: "",
      payment_status: "",
      payment_type: "Zahlungsart",
      payment_type_offline: "Offline",
      payment_type_online: "Online",
      payments: "",
      pdf_voucher: "",
      pending: "Erwartet",
      per_group: "Pro Gruppe",
      per_item: "Pro Paket",
      per_order: "Pro Buchung",
      per_person: "Pro Person",
      per_product: "Pro Angebot",
      percentage_amount: "%",
      persons_count: "Anzahl der Personen",
      phone_number: "Telefonnummer",
      position: "Position",
      price: "Preis",
      price_currency: "Preiswährung",
      price_per_group: "Preis pro Gruppe",
      price_per_item: "Preis pro Paket",
      price_per_night: "Preis pro Tag",
      price_per_order: "Preis pro Buchung",
      price_per_person: "Preis pro Person",
      price_per_person_night: "Preis pro Nacht",
      price_per_product: "Preis pro Angebot",
      price_type: "Preistyp",
      pricing_per_night: "",
      pricing_per_person: "",
      pricing_per_person_night: "",
      pricing_per_product: "",
      priority: "",
      product: "Angebot",
      product_highlights: "",
      product_images: "Angebotsbilder",
      product_name: "Angebotsname",
      product_option_values: "",
      product_options: "Zusatzoptionen",
      product_or_variant: "Angebot / Variant",
      product_order_fields: "Zusatzoptionen / zu ausfüllen",
      product_pricelist: "Preisliste",
      product_pricelist_item: "Preiskategorie",
      product_pricelist_order_target: "Preisliste",
      product_product_tags_id: "",
      product_quantity: "",
      product_short_description: "Kurze Angebotsbeschreibung",
      product_st_tags: "",
      product_tag: "",
      product_tags: "",
      product_tags_category: "",
      product_tags_id: "",
      product_tags_relation_type: "",
      product_unit_name: {
        coupon: {
          one: "",
          other: "",
        },
        person: {
          one: "Person",
          other: "Personen",
        },
        product: {
          one: "",
          other: "",
        },
        room: {
          one: "",
          other: "",
        },
      },
      product_variant: "",
      product_variant_name: "",
      product_variant_order_target: "",
      product_variants_count: "",
      products_count: "",
      products_have_all_tags: "",
      products_have_one_tag: "",
      published: "",
      published_at: "",
      refund: "",
      refund_completed: "",
      refund_failed: "",
      refund_in_progress: "",
      refund_new: "",
      refund_none: "",
      refund_status: "",
      refunded: "Rückerstattet",
      refunded_amount: "Rückerstattet",
      refunded_amount_sum: "Rückerstattet",
      rejected: "Abgelehnt",
      related_model: "",
      remaining_amount: "",
      remaining_total_amount: "",
      remaining_total_amount_sum: "",
      requires_company_approval: "",
      role: "",
      saas: "",
      saas_featured_price: "",
      saas_featured_price_before_discount: "",
      saas_service_fee: "",
      select_value_type: "",
      service_fee: "Servicegebühr",
      short_description: "Kurze Beschreibung",
      show_page_title: "",
      sign_in_count: "",
      slug: "",
      slug_hint: "",
      special_offer: "Sonderangebot",
      st_note: "",
      start_date: "",
      start_dates: "",
      start_time: "",
      start_times: "Startzeit",
      starts_at: "",
      static_date_booking: "",
      status: "Status",
      stock_end_date: "",
      stock_end_datetime: "Abfahrtzeit",
      stock_ends_at: "Abfahrtzeit",
      stock_start_date: "",
      stock_start_datetime: "",
      stock_starts_at: "",
      stock_time_range: "Datum",
      stock_useby_time_range: "",
      supplier: "",
      supplier_note: "",
      tag: "",
      tagged_products: "",
      tags: "",
      time_duration: "",
      time_zone: "Zeitzone",
      time_zone_name: "Zeitzone",
      title: "",
      total_amount: "Insgesamt",
      total_amount_sum: "Insgesamt",
      total_base_amount: "",
      total_discount: "",
      total_discount_amount: "",
      total_price: "Gesamtpreis",
      total_product_options_price: "Gesamtpreis für Zusatzoptionen",
      total_product_price: "",
      total_product_price_before_discount: "",
      total_stock_left: "",
      total_stock_limit: "",
      total_stock_used: "",
      transfer_type: "",
      translations: "",
      translations_name: "",
      trip: "",
      type: "",
      type_amount: "",
      type_percent: "",
      unpaid: "",
      updated_at: "",
      v1_bank_wire_deposit: "",
      v1_bank_wire_deposit_amount: "",
      v1_bank_wire_deposit_amount_cents: "",
      v1_bank_wire_deposit_deadline: "",
      v1_bank_wire_deposit_max_payment_date: "Spezifizierter Termin",
      v1_bank_wire_deposit_percent: "",
      v1_bank_wire_deposit_postorder_days_limit: "",
      v1_bank_wire_deposit_postorder_x_days: "",
      v1_bank_wire_deposit_prearrival_days_limit: "",
      v1_bank_wire_deposit_prearrival_x_days: "",
      v1_cash_deposit: "",
      v1_cash_deposit_amount: "",
      v1_cash_deposit_amount_cents: "",
      v1_full_bank_wire_deposit: "",
      v1_full_bank_wire_deposit_hint: "",
      v1_online_deposit: "",
      v1_online_deposit_percent: "",
      v1_online_deposit_st_type: {
        deposit: {
          b: "",
          d: "",
          m: "",
        },
        fee: {
          b: "Bezahlung",
          d: "Bezahlungen",
          m: "Bezahlung",
        },
        prepayment: {
          b: "",
          d: "",
          m: "",
        },
      },
      v1_rest_deposit: "",
      v1_rest_deposit_amount: "",
      v1_rest_deposit_amount_cents: "",
      v1_st_company_debt_status: "",
      v1_st_company_debt_status_amount_to_give: "",
      v1_st_company_debt_status_amount_to_receive: "",
      v1_st_company_debt_status_short: "",
      v1_st_company_debt_status_zero_amount: "",
      v1_st_company_invoiced_amount: "",
      v1_st_company_manually_given_amount: "",
      v1_st_company_manually_received_amount: "",
      v1_st_remaining_given_amount: "",
      v1_st_remaining_received_amount: "",
      v1_st_total_given_amount: "",
      v1_st_total_over_received_amount: "",
      v1_st_total_received_amount: "",
      v2_pricing: "",
      v2_static_date_booking: "",
      value_type: "Optionstyp",
      variant: "Variant",
      video_url: "",
      video_url_hint: "",
      view: "",
      view_sections: "",
      waiting_for_company_approval: "",
      waiting_for_confirmation_online_payment: "",
      waiting_for_customer_approval: "",
      website: "Webseite",
      website_url: "Webseite",
      week_days: "",
      x_days_after_order_company_approval: "",
      x_days_after_order_creation: "",
      x_days_after_order_full_approval: "",
      x_days_after_previous_installment: "",
      x_days_before_stock_starts_at: "",
      x_price_per_item: "",
      x_price_per_item_night: "",
      x_price_per_order: "",
      x_price_per_order_night: "",
      x_price_per_person: "%{x} pro Person",
      x_price_per_person_night: "%{x} pro Nacht",
      agent_service_fee: "Servicegebühr des Agenten",
      agent_service_fee_amount: "Servicegebühr des Agenten",
      agent_service_fee_amount_cents: "Servicegebühr des Agenten [in Groszy]",
      agent_service_fee_percent: "Servicegebühr für Agenten [%]",
      agent_paid_amount: "Agent hat bezahlt",
      agent_received_amount: "Agent bekommt",
      agent_remaining_paid_amount: "Für den Rückzug vom Agenten",
      agent_remaining_received_amount: "Verbleibender Betrag für Agent",
      customer_paid_amount: "Kunde hat bezahlt",
      customer_received_amount: "Dem Kunden zurückerstattet",
      customer_remaining_paid_amount: "Vom Kunden zu bezahlen",
      customer_remaining_received_amount: "Dem Kunden zurückerstattet werden",
      socialtravel_paid_amount: "Tripsomnia hat bezahlt",
      socialtravel_received_amount: "Tripsomnia hat zurückgezogen",
      socialtravel_remaining_paid_amount: "Für den Entzug von Tripsomnia",
      socialtravel_remaining_received_amount: "Verbleibender Betrag für Tripsomnia",
      supplier_paid_amount: "Lieferant hat bezahlt",
      supplier_received_amount: "Lieferant hat zurückgezogen",
      supplier_remaining_paid_amount: "Für den Rücktritt vom Lieferanten",
      supplier_remaining_received_amount: "Verbleibender Betrag für den Lieferanten",
      author_place: "",
      author_place_frontend: "Webseite",
      author_place_partnerapp: "",
      product_locations: "Angebotsorte",
      product_pickup_points: "Treffpunkte",
      customer_fields: "Pflichtliche Felder",
      priced_fields: "Zusatzoptionen",
      product_id: "Angebot ID",
      product_variant_id: "Angebotvariant-ID",
      pricelist: "Preisliste",
      payment_profiles: "Bezahlungsprofile",
      remove_location_coordinates: "Klare geografische Koordinaten",
      test_mode: "Testmodus",
      saas_priority: "Priorität (SaaS)",
      marketplace_priority: "Priorität (Marketplace)",
      created_on: "Erstellungsdatum",
      updated_on: "Datum der letzten Bearbeitung",
      affiliate_commision: "Affiliate-Provision",
      affiliate_commision_amount: "Affiliate-Provision",
      affiliate: "Affiliate",
      confirmation_installment_amount: "Online-Einzahlung",
      bank_wire_account_description_placeholder: "Kontonummer und verwandte Informationen.",
      fully_refunded: "Rückerstattet",
      over_refunded: "Übererstattung",
      partly_refunded: "Teilweise erstattet",
      dotpay: "DotPay",
      paypal: "PayPal",
      agent_outcome: "Agenteneinkommen",
      socialtravel_outcome: "Tripsomnia Einkommen",
      supplier_outcome: "Lieferanteneinkommen",
      total_company_outcome: "Das Einkommen der Firma",
      agent_disbursement: "Auszahlung des Agenten",
      agent_disbursement_id: "Auszahlung-ID des Agenten",
      customer_invoice_amount: "Betrag für die automatische Abrechnung mit dem Kunden",
      doesnt_require_company_approval: "Bestellung erfordert keine Bestätigung der Firma",
      custom_online_payment: "Benutzerdefinierte Online-Zahlung",
      agent_bank_wire: "Überweisung des Agenten",
      supplier_bank_wire: "Reiseveranstalterüberweisung",
      agent_cash: "In bar von / zu Agent",
      supplier_cash: "In bar vom / zum Reiseveranstalter",
      none: "Keine",
      expire_at: "Haltbarkeitsdatum",
      publish_at: "Veröffentlichungsdatum",
      expire_from: "",
      stripe: "Stripe",
      author_place_customerapp: "",
      deprecated_v1_booking_type: "",
      deprecated_v1_location_address: "",
      deprecated_v1_location_description: "",
      deprecated_v1_location_full_address: "",
      deprecated_v1_location_full_address_hint_html: "",
      deprecated_v1_location_full_address_placeholder: "",
      deprecated_v1_order_target_type: "",
      deprecated_v1_pricing_type: "",
      deprecated_v1_product_type: "",
      price_show_cash_deposit_amount: "",
      price_show_coupon_price: "",
      price_show_discount_amount: "",
      price_show_discount_percent: "",
      price_show_marketplace_service_fee_amount: "",
      price_show_online_deposit_amount: "",
      price_show_price_per_person: "",
      price_show_total_amount: "",
      price_show_total_amount_with_cash_deposit: "",
      price_show_total_price: "",
      price_show_type: "",
      message: "",
      requested_date: "",
      seller: "",
      discount_percent: "",
      total_discount_amount_cents: "",
      total_price_cents: "",
      total_product_options_price_cents: "",
      total_product_price_before_discount_cents: "",
      total_product_price_cents: "",
      confirmation_installment_amount_cents: "",
      confirmation_installment_paid_amount: "",
      receptionist: "",
      available_to: "",
      available_from: "",
      product_type: "",
      pricing_plan_type: "",
    },
    errors: {
      messages: {
        already_exists: "",
        has_to_be_in_future: "",
        installment_not_supported: "",
        invalid_installments_position: "",
        invalid_online_payment_installments: "",
        invalid_participant_data: "",
        invalid_participant_product_option_value: "",
        invalid_phone_number_characters: "",
        invalid_product_option_value: "",
        invalid_video_url: "",
        missing_participant_product_option_value: "",
        missing_product_option_value: "",
        v1_invalid: "",
        v1_invalid_installments_transfer_type: "",
        invalid_participant_ordered_item: 'Ungültiger Bestellartikel dem Teilnehmer "%{participant_name}" zugewiesen',
        invalid_ordered_item_participants_count:
          'Ungültige Teilnehmernummer für die Bestellposition "%{ordered_item_name}".',
        empty: "",
        greater_than: "",
        too_short: "",
        greater_than_or_equal_to: "",
        less_than_or_equal_to: "",
        invalid: "",
      },
      action_impossible_error: {
        code: "",
        http_code: "",
        message: "",
      },
      record_not_found_error: {
        code: "",
        http_code: "",
        message: "",
      },
      wrong_product_order_field_error: {
        code: "",
        http_code: "",
        message: "",
      },
    },
    base: {
      choose: "Auswählen",
      connection_error: "Fehler eingetroffen während verbindung mit dem Server.",
      date: {
        day: "Tag",
        month: "Monat",
        year: "Jahr",
      },
      discount: "Ermäßigung",
      discount_coupon: "Ermäßigungscoupon",
      every_each: "jede",
      extend: "verlängern",
      from: "ab",
      from_x: "ab %{count}",
      from_x_to_y: "ab %{x} bis %{y}",
      in_weekdays_xyz: "in %{xyz}",
      loading: "Laden",
      no: "Nein",
      read_more: "Mehr lesen",
      see_more: "Mehr anzeigen",
      to: "bis",
      to_x: "bis %{count}",
      x_days: {
        one: "%{count} Tag",
        other: "%{count} Tage",
      },
      x_hours: {
        one: "%{count} Stunde",
        other: "%{count} Stunden",
      },
      x_minutes: {
        one: "%{count} Minute",
        other: "%{count} Minuten",
      },
      x_nights: {
        one: "%{count} Nacht ",
        other: "%{count} Nächte",
      },
      x_orders: {
        one: "%{count} Buchung",
        other: "%{count} Buchungen",
      },
      x_persons: {
        one: "%{count} Person",
        other: "%{count} Personen",
      },
      x_seconds: {
        one: "%{count} Sekunde",
        other: "%{count} Sekunden",
      },
      yes: "Ja",
      x_years: {
        one: "%{count} Jahr",
        other: "%{count} Jahre",
      },
      choose_date: "Termin auswählen",
      x_selected_records: {
        one: "%{count} ausgewählt",
        other: "%{count} ausgewählt",
      },
      since_x: "seit %{x}",
      since_x_until_y: "seit %{x} bis %{y}",
      until_x: "bis %{x}",
      for_x_days: {
        one: "für %{count} Tag",
        other: "für %{count} Tage",
      },
    },
    components: {
      view_sections: {
        title: {
          read_more: "Mehr Angebote anzeigen",
        },
      },
    },
    date: {
      formats: {
        default: "%t-%m-%J",
        long: "%A, %e %B %Y",
        short: "%d %b",
        short2: "",
      },
    },
    helpers: {
      select: {
        no_results_message: "Keine Ergebnisse",
        prompt: "Auswählen",
      },
    },
    languages: {
      en: "englisch",
      pl: "polnisch",
      ru: "russisch",
      bg: "bulgarisch",
      hr: "kroatisch",
      cs: "tschechisch",
      da: "dänisch",
      nl: "niederländisch",
      et: "estnisch",
      fi: "finnisch",
      fr: "französisch",
      de: "deutsch",
      el: "griechisch",
      hu: "ungarisch",
      is: "isländisch",
      ga: "irisch",
      it: "italienisch",
      lv: "lettisch",
      lt: "litauisch",
      lb: "luxemburgisch",
      mk: "macedonisch",
      mt: "maltesisch",
      pt: "portugiesisch",
      ro: "rumänisch",
      sr: "serbisch",
      sk: "slovakisch",
      sl: "slowenisch",
      es: "spanisch",
      sv: "schwedisch",
      tr: "türkisch",
      uk: "ukrainisch",
      cy: "walisisch",
      ar: "Arabisch",
      ca: "Katalanisch",
      he: "Hebräisch",
      th: "Thailändisch",
      vi: "Vietnamesisch",
    },
    number: {
      currency: {
        format: {
          format: "%n %u",
        },
      },
    },
    order_actions: {
      send_approved_order_has_paid_online_deposit_company_sms: {
        sms_content: {
          marketplace:
            "Buchung Nr. %{order_id} ist von dem Kunden bezahlt und bestätigt. Details über E-Mail geschickt.",
          saas: "Buchung Nr. %{order_id} ist von dem Kunden bestätigt geworden. Details über E-Mail geschickt.",
        },
      },
      send_order_awaits_approval_company_sms: {
        sms_content: {
          marketplace: "Buchung Nr. %{order_id} wartet auf dringender Bestätigung. Details has been emailed.",
          saas: "Buchung Nr. %{order_id} wartet auf dringender Bestätigung. Details has been emailed.",
        },
      },
      send_order_has_been_approved_customer_sms: {
        sms_content: {
          after_company_approval: {
            marketplace:
              "Buchung Nr. %{order_id} ist bestätigt geworden. Bezahlen Sie bitte dafür. Details haben wir über E-Mail geschickt.",
            saas: "Buchung Nr. %{order_id} ist bestätigt geworden. Bezahlen Sie bitte dafür. Details haben wir über E-Mail geschickt.",
          },
          default: {
            marketplace: "Buchung Nr. %{order_id} ist bestätigt geworden. Details haben wir über E-Mail geschickt.",
            saas: "Buchung Nr. %{order_id} ist bestätigt geworden. Details haben wir über E-Mail geschickt.",
          },
        },
      },
      send_order_has_been_rejected_customer_sms: {
        sms_content: {
          marketplace:
            "Buchung Nr. %{order_id} ist von der Firma storniert geworden. Details haben wir über E-Mail geschickt.",
          saas: "Buchung Nr. %{order_id} ist storniert geworden. Details haben wir über E-Mail geschickt.",
        },
      },
      send_order_has_been_cancelled_customer_sms: {
        sms_content: {
          marketplace: "Buchung Nr. %{order_id} ist storniert geworden. Details über E-Mail geschickt.",
          saas: "Buchung Nr. %{order_id} ist von der Firma storniert geworden. Details über E-Mail geschickt.",
        },
      },
    },
    product_pricelist: {
      lowest_price_is_on: "Billigste Preis ist für %{schedule_range} gültig.",
      price_name: "%{price} für %{people}",
      price_per_coupon: "Preis pro Voucher",
      price_per_item: "Preis pro Paket / Gruppe",
      price_per_night: "Preis pro Nacht",
      price_per_product: "Preis pro Produkt",
      price_per_stay: "Preis pro Besuch",
      price_per_tour: "Preis pro Reise",
      sold_out_already: "Dieses Angebot ist schon ausgebucht",
      x_coupons_left: {
        one: "Ein Voucher verfügbar",
        other: "%{count} Vouchers verfügbar",
      },
      x_stocks_left: "Nur %{count} in dieser Preis",
    },
    "social_travel/new_company_registration_form": {
      errors: {
        company_already_exists: "Firma mit dieser E-Mail Adresse ist schon auf unserer Webseite registriert.",
      },
    },
    time: {
      formats: {
        long: "%A, %e %B %Y at %H:%M",
        short: "%e %b at %H:%M",
        time: "%H:%M",
        short2: "",
      },
    },
    view_collection_item_decorator: {
      offer_read_more: "Angebot anzeigen",
      offers_read_more: "Angebote sehen",
    },
    frontend: {
      companies: {
        show: {
          reviews_title: "Rezensionen für %{marketplace_name}",
          products_calendar: "Terminkalender",
          products: "Angebote",
          reviews: "Rezensionen",
          reviews_title_html: "Rezensionen für %{marketplace_name}",
        },
      },
      company_orders: {
        approve: {
          action_impossible: "Aktion nicht möglich. Vielleicht ist die Buching schon bestätigt oder gelöscht?",
          success: 'Buchung Nr. #%{id} für "%{product_name}" (Kunde: %{customer_full_name}) ist bestätigt geworden.',
        },
        finish: {
          action_impossible: "Aktion nicht möglich. Vielleicht ist die Buchung schon fertig?",
          success: 'Buchung Nr. #%{id} für "%{product_name}" (Kunde: %{customer_full_name}) ist fertig.',
        },
        reject: {
          action_impossible: "Aktion nicht möglich. Vielleicht ist die Buching schon bestätigt oder gelöscht?",
          success: 'Buchung Nr. #%{id} für "%{product_name}" (Kunde: %{customer_full_name}) ist gelöscht geworden.',
          success_with_slot_deactivated:
            'Buchung Nr. #%{id} für "%{product_name}" (Kunde: %{customer_full_name}) ist gelöscht geworden. Gewünschter Termin wird dazu deaktiviert- man kann dieser Termin nicht mehr buchen.',
        },
        show: {
          admin_app_info_html:
            'Wir empfehlen dass Sie zu unseren <a href="%{partnerapp_order_url}">Verfugbarkeitmanagementpanel</a> einloggen. Damit können Sie Ihre Angebote und Kundenbuchungen managen.',
          approve_order: "Buchung bestätigen",
          finish_order: "Als Fertig markieren",
          order_name: 'Buchung Nr. %{order_id} für "%{product_name}"',
          order_status: "Buchungsstatus: %{status_i18n}",
          reject_order: "Buchung löschen",
        },
      },
      errors: {
        show: {
          general_error: "Versuchen Sie bitte die Webseite zu aktualisieren",
          general_error_hint_html:
            "Falls der Fehler bleibt, versuchen Sie bitte noch einmal in einpaar Minuten oder informieren Sie uns bitte darüber an %{email}.",
          header: "Fehler eingetroffen %{error_code}",
          page_not_found: "Seite nicht gefunden",
          page_not_found_hint_html:
            'Gehen Sie bitte zurück zu die <a href="%{root_url}">Hauptseite</a> oder benutzen Sie bitte die Suchfunktion um interessante Angebote zu finden. ',
          title: "Fehler %{error_code}",
        },
      },
      orders: {
        confirm: {
          already_abandoned_error:
            "Diese Buchung ist schon annuliert geworden. Um zu buchen, gehen Sie bitte zurück zu dem ersten Schritt den Formular.",
          already_confirmed_error:
            "Diese Buchung wird schon realisiert. Aktualisieren Sie bitte die Webseite um neue Buchung zu machen.",
        },
        new: {
          title: "Reservieren: %{product_name}",
        },
        show: {
          title: "Buchung Nr. %{id}",
        },
        update: {
          already_abandoned_error:
            "Diese Buchung ist schon annuliert geworden. Um zu buchen, gehen Sie bitte zurück zu den Anfang den Formular.",
          already_confirmed_error:
            "Diese Buchung wird schon realisiert. Aktualisieren Sie bitte die Webseite um neue Buchung zu machen.",
        },
      },
      products: {
        show: {
          draft_notice:
            "Sie schauen eine Angebot, die nicht Veröffentlicht wird. Andere Benutzer sehen diese Seite als nicht verfügbar (404).",
          instead_of: "anstatt",
          location_address: "Adresse",
          location_tips: "Richtungen",
          make_an_order: "Reservieren",
          pay_on_the_spot: "Vor Ort bezahlen",
          product_shown_in_different_locale_notice:
            "Diese Angebot hat leider momentan keiner Bechreibung in ausgewählter Sprache.",
          product_unavailable: "Keine Termine",
          see_map: "Landkarte anzeigen",
          select_product_variant: "Option auswählen",
          similar_locations_title: "Mehr Angebote in diesem Ort sehen",
          similar_products_title: "Sie werden sich auch dafür interessieren",
          youre_saving: "Sie sparen",
          pickup_points: "Treffpunkte",
          custom_pickup_point_possible: "Direkt vom Hotel abholen",
          reviews_title: "Rezensionen für %{company_name}",
          recently_viewed_products_title: "Zuletzt angesehene Angebote",
          recently_viewed_products_and_categories_title: "Zuletzt angesehene Angebote und Kategorien",
          other_locations: "Andere Orte",
          buy_product_cta_button: "Kaufen",
          buy_coupon_cta_button: "Coupon herunterladen",
          see_product_availability_cta_button: "Termine ansehen",
          choose_coupon: "Option auswählen",
          offer_finished_cta_button: "Angebot nicht mehr gültig",
          coupon_finished: "Sonderangebot nicht mehr gültig",
          product_finished: "Angebot nicht mehr gültig",
          product_expires_at: "Das Angebot erlischt %{datetime}",
          product_expired_notice: "Dieses Angebot ist erloschen. Man kann es nicht mehr buchen.",
          product_expired: "Angebot ist erloschen",
          only_x_coupons_left: "%{total_stock_used} Coupons heruntergeladen.",
          nb_stock_useby_date_range: "Verfügbar %{date_range}",
          no_coupons_left: "Variant ausgebucht. Verkaufslimit erreicht. ",
          less_than_x_coupons_left: "Weniger als %{total_stock_left} Coupons verfügbar.",
          quicknav: {
            description: "Beschreibung",
            includes: "Preis inkludiert",
            requirements: "Anforderungen",
            map: "Landkarte",
            reviews: "Rezensionen",
          },
          reviews_title_html: 'Rezensionen von <a href="%{company_url}">%{company_name}</a>',
          not_available_notice: "",
        },
        search: {
          filter_query_title: "Text suchen",
          toggle_filters: "Ergebnisse filtern",
          filter_query_placeholder: "Was suchen Sie?",
          location_query_title: "in der Nähe suchen",
          location_query_label: "in der Ferne",
          location_query_placeholder: "Wo?",
          date_query_title: "Termin",
          categories_query_title: "Kategorien",
          locations_query_title: "Regionen ",
          locales_query_title: "Angebotssprache",
          no_results_message:
            "Wir haben leider keine Angebote für Ihre Nachfrage gefunden. Versuchen Sie bitte sie irgendwie anders präzisieren.",
          shown_results: "%{start} - %{end} von %{total_count} Ergebnissen",
          previous_page: "Vorherige Seite",
          next_page: "Nächste Seite",
          site_title: {
            around_location: "In der Nähe von %{location}",
            with_category_and_location: "Angebote der Kategorie %{category} in %{location}",
            with_category: "Angebote der Kategorie %{category}",
            with_location: "Angebote in %{location}",
            default: "Angebote",
          },
        },
        history: {
          site_title: "Zuletzt angesehene Angebote",
          viewed_products_title: "Zuletzt angesehen",
          similar_to_viewed_products_title: "Sie werden auch dafür interessiert",
          viewed_products_tags_title: "Auch sehen",
        },
      },
      reviews: {
        new: {
          site_title: "Rezensieren",
          review_details_title: "Ihre Rezension",
          content_placeholder: "Beschreiben Sie bitte kurz was gut war und was konnte besser gemacht werden.",
          rating_label: "Bewertung auswählen...",
          personal_details_title: "Ihre Daten",
          locale_label: "Sprache",
          age_group_label: "Ihres Alter",
          group_type_label: "Gruppentyp",
          author_name_label: "Ihre Name",
          author_email_label: "Ihre E-mail Adresse",
          st_details_title: "Wie bewerten Sie den Reservierungsprozess?",
          st_rating_label: "Bewertung auswählen...",
          st_feedback_placeholder: "Warum?",
          submit: "Rezension senden",
          add_success_message: "Ihre Rezension ist eingegeben. Danke!",
          error_message: "Fehler eingetroffen während Formularspeicherung. ",
          review_for_given_order_already_exists:
            "Rezension schon eingegeben. Editieren oder neue Rezension ist nicht möglich.",
          order_id: "Buchungsnummer",
          product: "Angebot",
          author_email_hint: "Wir zeigen es niemandem.",
          add_review_title_about_product: '"%{product_name}" und %{company_name} rezensieren',
          add_review_title_about_company: "%{company_name} rezensieren",
        },
      },
    },
    layouts: {
      application: {
        contact: {
          about_us: {
            title: "Über uns",
          },
          contact_us: {
            title: "Setzen Sie sich bitte mit uns im Kontakt",
          },
          cooperating_with: {
            dotpay_payments: "Bezahlungen von DotPay und PayPal bedient",
            title: "Wir arbeiten mit ",
          },
          see_us_on_facebook: {
            title: "Folgen Sie uns auf Facebook",
          },
          write_to_us: {
            title: "Schreiben Sie an uns",
          },
          payment_gateways: {
            title: "Akzeptierte Zahlungsmethoden ",
            description: "Wir akzeptieren Kredit- und Debitkarten, Überweisungen und PayPal.",
          },
        },
        footer: {
          about_us: "Über uns",
          careers: "Karriere",
          cooperation: "Zusammenarbeit",
          faq: "HGF",
          help: "Hilfe",
          privacy_policy: "Datenschutz-Bestimmungen",
          rules_note_html: 'Mit benutzung unseren Service akzeptieren Sie den <a href="%{rules_url}">Reglement</a>.',
        },
        guaranteed: {
          read_more: "Sehen Sie wie Tripsomnia.com funktioniert",
          s1: {
            line1: "Pfleglich ausgewählte Angebote",
            line2: "und vertraute Reiseveranstalter.",
            title: "Höchste Qualität",
          },
          s2: {
            line1: "Ermäßigungen bis 50%!",
            line2: "Unterhandelt besonders für Sie.",
            title: "Billigste Preise",
          },
          s3: {
            currency: "EUR",
            line1: "Bezahlen Sie in Raten online, direkt auf den Firmenkonto oder mit Bargeld vor Ort.",
            title: "Sichere Zahlungsmethoden",
          },
          s4: {
            line1: "Interessanteste Reisen- und Atraktionsangebote an einem Ort!",
            title: "Online reservieren",
          },
          title: "Wir garantieren",
        },
        navbar: {
          about_us: "Über uns",
          for_business: "Zusammenarbeit",
          products_calendar: "Terminkalender",
          search_placeholder: "Angebot, Ort oder Kategorie suchen",
          products_history: "Geschichte (%{count})",
          contact: "Kontakt",
          faq: "Häufig gestellte Fragen",
          open_chat: "Chat",
          cart: "Einkaufswagen (%{count})",
          finish_order: "Buchung finalisieren: %{product_name} (%{total_amount})",
          company_reviews: "Kundenrezensionen",
        },
      },
      mailer: {
        greetings: "Mit freundlichen Grüßen",
        marketplace: {
          footer_headline: "Tripsomnia.com - Wir lieben Reisen ",
        },
        footer_phone: "Tel. ",
        footer_email: "E-mail:",
      },
    },
    pdfs: {
      order_voucher: {
        cancellation_policy: "Entsagungsbedingungen",
        cancellation_policy_description:
          "Angebot ohne Rückgaben. Verändern oder annulieren nicht möglich. Falls ein Teilnehmer nicht kommt, bekommt der Kunde keine Rückerstattung.",
        company_details: "Daten von Reiseveranstalter",
        contact_email: "E-mail Adresse",
        contact_facebook_url: "Facebook",
        contact_full_address: "Adresse",
        contact_phone_number: "Kontaktnummer",
        contact_website_url: "Webseite",
        generated_date: "Generiert: %{date}",
        got_any_questions: "Haben Sie Fragen?",
        order_details: "Ihre Kontaktdaten",
        order_number: "Buchungsnummer",
        product_details: "Angebotdetails",
        st_headline: "Tripsomnia (SocialTravel Sp. z o.o.)",
        title: "Bestätigung für Buchung Nr. %{order_id}",
        wish_you_great_journey: "Wir wünschen Ihnen einzigartigen Empfindungen!",
        your_order: "Ihre Buchung",
        footer_phone: "Tel.",
        footer_email: "E-mail:",
        code: "",
      },
      slot_manifest: {
        customer_name_placeholder: "Buchung",
        generated_on: "Generierungsdatum %{date}",
        page_title: "Terminmanifest",
      },
    },
    admin_user_mailer: {
      company_created_you_an_account: {
        action: "Passwort einstellen ",
        greeting: "Hallo %{recipient}!",
        instruction:
          "Firma %{company_name} hat ein Konto im Tripsomniapaneel für Sie eingestellt um Buchungen und Angebote zu managen.",
        instruction_2:
          "Um sich auf unserer Website einzuloggen, klicken Sie bitte den Link unten um Ihr Passwort einzustellen.",
        instruction_3: "Falls Sie Zugang zu diese Plattform nicht benötigen, ignorieren Sie bitte diese Nachricht.",
        subject: "Firma %{company_name} hat ein Konto im Tripsomniapaneel für Sie eingestellt",
      },
      company_invited_you_to_become_a_member: {
        action: "Zum Firmenpaneel",
        greeting: "Hallo %{recipient}!",
        instruction:
          "Firma %{company_name} hat Ihnen Zugang zu Tripsomnia Partnerpaneel hinzugefügt um Buchungen und Angebote zu managen.",
        instruction_2: "Unten klicken um zu den Paneel gehen",
        subject: "Firma %{company_name} hat Ihnen Zugang zu Tripsomnia Partnerpaneel hinzugefügt",
      },
    },
    company_mailer: {
      agent_invitation_received: {
        action: "Zum Kooperationspaneel",
        greeting: "Hallo %{company_name}!",
        instruction: "Firma %{supplier_name} hat Ihnen zu Kooperation eingeladen, damit Sie ihre Angebote.",
        instruction_2: "Unten klicken um zu zu Paneel gehen und Kooperationsdetails zu sehen.",
        subject: "Firma %{supplier_name} hat Ihnen zu Kooperation eingeladen",
      },
      company_and_user_created_agent_invitation_received: {
        action: "Passwort einstellen",
        greeting: "Hallo %{company_name}!",
        instruction: "Firma %{supplier_name} hat Ihnen zu Kooperation eingeladen, damit Sie ihre Angebote.",
        instruction_2: "",
        instruction_3: "Unten klicken um Ihr Passwort einzustellen und Kooperationsdetails zu sehen.",
        subject: "Firma %{supplier_name} hat Ihnen zu Kooperation eingeladen",
      },
      company_created_and_agent_invitation_received: {
        action: "Zum Kooperationspaneel",
        greeting: "Hallo %{company_name}!",
        instruction: "Firma %{supplier_name} hat Ihnen zu Kooperation eingeladen, damit Sie ihre Angebote.",
        instruction_2: "Unten klicken um zu zu Paneel gehen und Kooperationsdetails zu sehen.",
        subject: "Firma %{supplier_name} hat Ihnen zu Kooperation eingeladen",
      },
      company_registration_approved: {
        action: "Zum Paneel",
        greeting: "Hallo %{company_name}!",
        instruction:
          "Wir haben Ihnen einen Firmenkonto %{company_name} in unserem Tripsomniapaneel um Buchungen und Angebote zu managen eingestellt.",
        instruction_2:
          "Link unten klicken um zu Paneel zu gehen und Kooperationsdetails zu sehen. Link ist 48 Stunden aktiv. Falls Sie in dieser Zeit nicht einloggen.",
        subject: "Firmenkonto für %{company_name} erfolgreich in Tripsomniapaneel eingestellt.",
      },
      company_registration_approved_and_user_created: {
        action: "Passwort einstellen",
        greeting: "Hallo %{company_name}!",
        instruction:
          "Wir haben Ihnen einen Firmenkonto %{company_name} in unserem Tripsomniapaneel eingestellt um Buchungen und Reiseangebote zu managen eingestellt.",
        instruction_2: "",
        instruction_3:
          "Klicken Sie bitte unten um zu den Paneel zu gehen und Kooperationsdetails zu sehen. Der Link ist 48 Stunden aktiv.",
        subject: "Firmenkonto von %{company_name} ist erfolgreich im Tripsomniapaneel eingestellt geworden",
      },
      company_registration_created: {
        action: "Registrierungsdetails ansehen",
        greeting: "Hallo!",
        instruction: "Jemand hat einen Anmeldeformular mit folgenden Daten ausgefüllt:",
        subject: "Firma %{company_name} wollte sich bei Tripsomniapaneel registrieren",
      },
      customer_review_submitted: {
        greeting: "Hallo %{company_name}!",
        new_review_has_been_submitted: "Eine Rezension ist für Sie auf Tripsomniaplattform eingegeben geworden.",
        action: "Rezension ansehen ",
        subject: "Neue Rezension eingegeben für Ihre Firma",
      },
      company_and_user_created_supplier_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
      company_created_and_supplier_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
      supplier_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
    },
    order_mailer: {
      base: {
        company_approve_order: "Buchung bestätigen",
        company_finish_order: "Als fertig markieren",
        company_reject_order: "Buchung stornieren",
        company_see_order: "Buchung ansehen",
        customer_repeat_order: "Buchung wiederholen",
        customer_see_all_offers: "Alle verfügbare Angebote ansehen",
        customer_see_nearby_offers: "Angebote in der Nähe ansehen",
        customer_see_offer: "Angebot ansehen",
        hello_company: "Hallo %{company_name}!",
        hello_customer: "Liebe / Lieber %{customer_full_name},",
        order_status: "Buchungsstatus: %{status_i18n}",
        company_reject_order_and_deactivate_slot: "Buchung stornieren und an diesem Datum nicht mehr buchen",
      },
      company_order_footer: {
        line1_html: "Ihres Angebot ist auf der Website: %{product_link} verfügbar.",
        line2_html: 'Sie können das im <a href="%{partnerapp_order_url}">Verfügbarkeitsverwaltungpaneel</a>.',
      },
      order_about_to_start_reminder_company_email: {
        p1_html:
          'Buchung des Kundes %{customer_full_name} Nr. %{order_id} für "%{product_name}" startet in %{days_to_start} Tage (%{stock_start_date}).',
        p2_html:
          'Als Erinnerung schicken wir Ihnen Ihre Buchungdetails. Im früheren E-mail finden Sie eine druckbare Bestätigung. Falls Sie es nicht finden können, hier können Sie es als .pdf- Datei herunterladen: <a href="%{customer_pdf_order_url}">der Folgenge Link</a>.',
        subject:
          "Bestätigte Buchung des Kundes %{customer_full_name} Nr. %{order_id} für %{product_name} startet in %{days_to_start} Tage (%{stock_start_date}).",
      },
      order_about_to_start_reminder_customer_email: {
        marketplace: {
          p1_html:
            'Ihre Buchung Nr. %{order_id} für "%{product_name}" startet in %{days_to_start} Tage, am %{stock_start_date}!',
          p2_html:
            'Als Erinnerung schicken wir Ihnen Ihre Buchungdetails. Im früheren E-mail finden Sie eine druckbare Bestätigung. Falls Sie es nicht finden können, hier können Sie es als .pdf- Datei herunterladen: <a href="%{customer_pdf_order_url}">der Folgenge Link</a>.',
        },
        saas: {
          p1_html:
            'Ihre Buchung Nr. %{order_id} für "%{product_name}" startet in %{days_to_start} Tage, am %{stock_start_date}!',
          p2_html:
            'Als Erinnerung schicken wir Ihnen Ihre Buchungdetails. Im früheren E-mail finden Sie eine druckbare Bestätigung. Falls Sie es nicht finden können, hier können Sie es als .pdf- Datei herunterladen: <a href="%{customer_pdf_order_url}">der Folgenge Link</a>.',
        },
        subject: 'Ihre Buchung für "%{product_name}" startet in %{days_to_start} Tage.',
      },
      order_company_approval_time_limit_exceeded_company_email: {
        line1:
          'Leider mussten wir Ihre Vorbuchung Nr. %{order_id} von %{customer_full_name} für "%{product_name}" (%{stock_time_range}) stornieren, weil wir keine zeitliche Antwort von Ihnen erhalten haben.',
        line2:
          "Falls Sie keinen freien Plätze in diesem Termin haben, aktualisieren Sie bitte die Verfügbarkeit im Partnerpaneel.",
        subject:
          "Buchung Nr. %{order_id} ist storniert geworden- Sie haben es nicht zeitlich bestätigt (Kunde: %{customer_full_name})",
        line1_html:
          'Leider mussten wir Ihre Vorbuchung Nr <a href="%{partnerapp_order_url}">%{order_id}</a> von %{customer_full_name} für "%{product_name}", (%{stock_time_range}) stornieren, weil wir nicht reichtzeitig eine Antwort von Ihnen erhalten haben.',
      },
      order_company_approval_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>Leider mussten wir Ihre Buchung Nr. %{order_id} für  "%{product_name}" (%{stock_time_range}) stornieren</strong>, weil wir keine Antwort von dem Partner %{company_name} im Termin %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "Wir rückerstatten Bezahlung %{confirmation_installment_paid_amount} auf Ihren Bankkonto in 24 Std.",
        },
        saas: {
          line1_html:
            '<strong>Leider mussten wir Ihre Buchung Nr. %{order_id} für "%{product_name}" (%{stock_time_range})</strong>, weil maximale Zeit für Bestätigung abgelaufen ist - %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "Wir rückerstatten Bezahlung %{confirmation_installment_paid_amount} auf Ihren Bankkonto in 24 Std.",
        },
        subject: "Buchung Nr. %{order_id} ist storniert geworden - wir haben keine Bestätigung zeitlich erhalten.",
      },
      order_current_status_customer_email: {
        marketplace: {
          p1: "Wir schicken Ihnen aktuellen Buchungsstatus.",
        },
        saas: {
          p1: "Wir schicken Ihnen aktuellen Buchungsstatus.",
        },
        subject: 'Buchung Nr. %{order_id}, aktueller Status: %{status_i18n} ("%{product_name}")',
      },
      order_finished_add_opinion_reminder_customer_email: {
        marketplace: {
          add_review: "Ihre Rezension eingeben",
          contact_us:
            "Falls Sie irgendwelche Kommentare bezüglich unserem System oder Kundenservice haben, setzen Sie sich bitte mit uns im Kontakt!",
          share_your_opinion_html:
            "Helfen Sie bitte anderen Touristen und rezensieren Sie bitte die Firma %{company_link} und Angebot %{product_link}.",
          thank_you_html: "Danke für Ihre Buchung mit Tripsomnia.com und dass Sie unseren Service nutzen.",
        },
        saas: {
          add_review: "Ihre Rezension eingeben",
          contact_us:
            "Falls Sie irgendwelche Kommentare bezüglich unserem System oder Kundenservice haben, setzen Sie sich bitte mit uns im Kontakt!",
          share_your_opinion_html:
            "Helfen Sie bitte anderen Touristen und rezensieren Sie bitte die Firma %{company_link} und Angebot %{product_link}.",
          thank_you_html: "Danke, dass Sie unseren Service nutzen.",
        },
        subject: 'Ihre Rezension bezüglich "%{product_name}" (%{company_name}) eingeben',
      },
      order_is_approved_company_email: {
        no_online_deposit_subject: "Buchung Nr. %{order_id} ist bestätigt geworden (Kunde: %{customer_full_name})",
        online_deposit_after_company_approval_subject:
          "Buchung Nr. %{order_id} ist bezahlt und bestätigt (Kunde: %{customer_full_name})",
        online_deposit_before_company_approval_subject:
          "Buchung Nr. %{order_id} ist bezahlt und bestätigt (Kunde: %{customer_full_name})",
        online_deposit_paid:
          'Der Kunde hat die Vorauszahlung %{confirmation_installment_paid_amount} für Buchung Nr. %{order_id} für %{product_name}. Buchungsstatus ist jetzt "bestätigt".',
        order_approved: 'Buchung Nr. %{order_id} für "%{product_name}" ist bestätigt geworden.',
        order_cant_be_cancelled_now: "Von jetzt an kann diese Buchung nicht storniert werden.",
        order_infos_below:
          "Buchungdetails werden unten präsentiert. Im Anhang finden Sie .pdf-Voucher und Bestätigung die dem Kunden geschickt geworden sind. ",
        remember_to_set_order_as_finished: "Wenn die Buchung komplett ist, markieren Sie es bitte als 'Fertig\".",
        voucher: {
          line1_html: "",
          line2_html: "",
        },
      },
      order_is_approved_customer_email: {
        marketplace: {
          bank_wire_deposit_additional_info:
            "Als Überweisungstitel geben Sie bitte nur die Buchungsnummer, die in dieser Bestätigung gefunden werden kann. Andernfalls können wir nicht garantieren dass Ihre Bezahlung zeitlich durchkommt.",
          bank_wire_deposit_deadline_html:
            "<strong>Vergessen Sie bitte nicht zeitlich zu bezahlen.</strong> Falls Sie keine Vorauszahlung zeitlich machen, Ihre Buchung kann storniert werden.",
          bank_wire_deposit_make_html: "Bitte mit Überweisung bezahlen",
          bank_wire_deposit_required: "Bei dieser Buchung wird eine Zuzahlung auf dem Bankkonto erfordert.",
          order_approved_by_company:
            'Ihre Buchung Nr. %{order_id} für "%{product_name}" ist von %{company_name} bestätigt geworden!',
          order_created: "Danke für Buchung mit Tripsomnia.com!",
          order_data_and_deposit_received: "Wir haben alle notwendige Daten und Bezahlung von Ihnen erhalten.",
          order_data_received: "Wir haben alle notwendige Daten von Ihnen erhalten. ",
          this_is_confirmation:
            "Diese E-mail ist Ihre Buchungsbestätigung. Anbei finden Sie die Bestätigung mit allen wichtigen Informationen. Bringen Sie es bitte mit auf Ihrem Handy oder ausgedrückt.",
          order_approved_by_customer: 'Ihre Buchung Nr. %{order_id} für "%{product_name}" ist bestätigt geworden. ',
          voucher: {
            line1_html: "",
            line2_html: "",
          },
        },
        saas: {
          bank_wire_deposit_additional_info:
            "Als Überweisungstitel geben Sie bitte nur die Buchungsnummer, die in dieser Bestätigung gefunden werden kann. Andernfalls können wir nicht garantieren dass Ihre Bezahlung zeitlich durchkommt.",
          bank_wire_deposit_deadline_html:
            "<strong>Vergessen Sie bitte nicht zeitlich zu bezahlen.</strong> Falls Sie keine Vorauszahlung zeitlich machen, Ihre Buchung kann storniert werden.",
          bank_wire_deposit_make_html: "Bitte mit Überweisung bezahlen",
          bank_wire_deposit_required: "Bei dieser Buchung wird eine Zuzahlung auf dem Bankkonto erfordert.",
          order_approved_by_company: 'Wir haben Ihre Buchung Nr. %{order_id} für "%{product_name}" bestätigt!',
          order_created: "Danke für Ihre Buchung!",
          order_data_and_deposit_received: "Wir haben alle notwendige Daten und Bezahlung von Ihnen erhalten.",
          order_data_received: "Wir haben alle notwendige Daten von Ihnen erhalten. ",
          this_is_confirmation:
            "Diese E-mail ist Ihre Buchungsbestätigung. Anbei finden Sie die Bestätigung mit allen wichtigen Informationen. Bringen Sie es bitte mit auf Ihrem Handy oder ausgedrückt.",
          order_approved_by_customer: 'Ihre Buchung Nr. %{order_id} für "%{product_name}" ist bestätigt geworden.',
          voucher: {
            line1_html: "",
            line2_html: "",
          },
        },
        subject: 'Buchungsbestätigung Nr. %{order_id} für "%{product_name}"',
      },
      order_is_waiting_for_company_approval_company_email: {
        confirmation_deadline_warning:
          'Überprüfen Sie bitte Buchungsdetails und klicken Sie bitte "Buchung bestätigen" wenn Sie die Buchung erfüllen können. \nFalls die Buchung nicht zeitlich bestätigt wird, wird es automatisch storniert werden. Falls Sie im ausgewählten Termin die Buchung nicht erfüllen können, bieten Sie bitte anderen Termin oder anderen Angebot. Falls die Buchung nicht erfüllt werden kann, klicken Sie bitte "Buchung stornieren". Sie können auch die Buchung stornieren und nicht mehr an diesem Termin buchen lassen wenn Sie anderen Knopf klicken.',
        future_online_deposit_info:
          "Falls Sie die Buchung bestätigen, hat der Kunde %{confirmation_installment_after_company_approval_time_limit} Stunden um Online- Vorauszahlung %{confirmation_installment_st_name_d} in der höhe von %{confirmation_installment_transaction_amount}.",
        order_received: 'Wir haben Vorbuchung Nr. %{order_id} für "%{product_name}" erhalten.',
        past_online_deposit_info:
          "Der Kunde hat Onlinebezahlung %{confirmation_installment_st_name_b} für %{confirmation_installment_paid_amount} um Vorbuchung zu sichern gemacht. Falls die Buchung von Ihnen storniert wird, Bezahlung %{confirmation_installment_st_name} automatisch dem Kunden rückerstattet wird.",
        please_confirm: "Bitte die Buchung vor %{pauses_at} finalisieren.",
        subject: "Buchung Nr. %{order_id} wartet auf Bestätigung (Kunde: %{customer_full_name})",
        order_approved_by_customer: 'Der Kunde hat die Vorbuchung Nr. %{order_id} für "%{product_name}".',
        voucher: {
          line1_html: "",
          line2_html: "",
        },
      },
      order_is_waiting_for_company_approval_customer_email: {
        marketplace: {
          company_approval_deadline:
            "Normalerweise antwortet die Firma in %{company_approval_time_limit} Stunden, aber während Geschäftszeiten antwortet sie in 1 Stunde.",
          order_is_waiting_for_company_approval:
            'Buchung Nr. %{order_id} für "%{product_name}" wartet auf Bestätigung von der Firma %{company_name}.',
          thank_you_for_order: "Danke für Ihre Vorbuchung mit Tripsomnia.com",
          thank_you_for_order_and_online_deposit:
            "Danke für Ihre Vorbuchung mit Tripsomnia.com und online %{confirmation_installment_st_name_d} Bezahlung in der höhe von %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "Falls Ihre Buchung bestätigt wird, erhalten Sie eine E-Mail mit einem Link zu Onlinebezahlung {confirmation_installment_st_name_d} in der Höhe von %{confirmation_installment_amount}. Sie haben %{confirmation_installment_after_company_approval_time_limit} um Bezahlung durchzuführen.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "Falls Sie nicht zeitlich bezahlen, Ihre Buchung wird automatisch storniert geworden.",
          what_with_no_deposit_if_order_gets_approved:
            "Falls Ihre Buchung bestätigt wird, erhalten Sie eine E-Mail mit Bestätigung und Bezahlungsdetails.",
          what_with_paid_deposit_if_order_gets_approved:
            "Falls Ihre Buchung akzeptiert wird, bezahltes Geld wird dazu hinzugefügt werden. Falls der Reiseveranstalter Ihre Buchung storniert oder sie nicht zeitlich bestätigt, Ihre Anzahlung wird automatisch in 24 Stunden auf Ihren Konto rückerstattet. Dann können Sie erneut buchen.",
          thank_you_for_order_approval: "Danke für Bestätigung von Vorbuchung über Tripsomnia.com",
        },
        saas: {
          company_approval_deadline:
            "Standart Reaktionszeit ist %{company_approval_time_limit} Stunden, aber während der Geschäftszeiten antworten wir normalerweise in 1 Stunde.",
          order_is_waiting_for_company_approval:
            'Buchung Nr. %{order_id} für "%{product_name}" wartet auf unserer Bestätigung.',
          thank_you_for_order: "Danke für die Vorbuchung.",
          thank_you_for_order_and_online_deposit:
            "Danke für die Vorbuchung und %{confirmation_installment_st_name_d} Online- Vorauszahlung für %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "Falls Ihre Vorbuchung bestätigt wird, erhalten Sie eine E-Mail mit einem Link zu Onlinebezahlung {confirmation_installment_st_name_d} in der Höhe von %{confirmation_installment_amount}. Sie haben %{confirmation_installment_after_company_approval_time_limit} um Bezahlung durchzuführen.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "Falls Sie nicht zeitlich bezahlen, Ihre Buchung wird storniert geworden.",
          what_with_no_deposit_if_order_gets_approved:
            "Falls Ihre Vorbuchung bestätigt wird, bekommen Sie eine E-Mail mit Bestätigung und Zahlungsdetails.",
          what_with_paid_deposit_if_order_gets_approved:
            "Falls wir Ihre Vorbuchung stornieren mussen oder bestätigen wir es nicht zeitlich, online %{confirmation_installment_st_name} wird automatisch auf Ihren Bankkonto in 24 Stunden rückerstattet werden. Sie können auch uns kontaktieren und anderen Angebot auswählen.",
          thank_you_for_order_approval: "Danke für Bestätigung von Vorbuchung",
        },
        subject: 'Buchung Nr. %{order_id} für "%{product_name}" wartet auf Bestätigung.',
      },
      order_is_waiting_for_confirmation_online_payment_company_email: {
        line1:
          'Buchung Nr. %{order_id} für "%{product_name}" ist bestätigt geworden und wartet auf Online %{confirmation_installment_transaction_amount} Bezahlung von dem Kunden. ',
        line2: "Falls der Kunde nicht zeitlich bezahlt, wird die Buchung automatisch storniert.",
        subject: "Buchung Nr. %{order_id} wartet auf Bezahlung (Kunde: %{customer_full_name})",
      },
      order_is_waiting_for_confirmation_online_payment_customer_email: {
        after_company_approval_subject: "Buchung Nr. %{order_id} wartet auf Bezahlung (%{product_name})",
        default_subject: 'Buchung Nr. %{order_id} wartet auf Bezahlung ("%{product_name}")',
        marketplace: {
          deadline_warning:
            "Falls die Bezahlung nicht zeitlich gemacht werden wird, wird Ihre Buchung automatisch storniert. ",
          order_approved: 'Firma hat Ihre Buchung Nr. %{order_id} für "%{product_name}" bestätigt.',
          pay_button: "Online bezahlen",
          payment_deadline: "Bezahlungstermin: %{pauses_at}",
          please_pay:
            "Bezahlen Sie bitte %{confirmation_installment_transaction_amount} über unserem sicherem Onlinezahlungssystem.",
        },
        saas: {
          deadline_warning:
            "Falls die Bezahlung nicht zeitlich durchgeführt wird, wird Ihre Buchung automatisch storniert.",
          order_approved: 'Wir haben Ihre Bezahlung Nr. %{order_id} für "%{product_name}" bestätigt.',
          pay_button: "Online bezahlen",
          payment_deadline: "Bezahlungstermin läuft an %{pauses_at} ab",
          please_pay:
            "Bezahlen Sie bitte %{confirmation_installment_transaction_amount} über unserem sicherem Onlinezahlungssystem.",
        },
      },
      order_is_waiting_for_customer_approval_customer_email: {
        marketplace: {
          action: "Buchung bestätigen",
          approval_deadline: "",
          deadline_warning:
            "Falls Ihre Buchung nicht zeitlich bestätigt wird, wird Ihre Buchung automatisch storniert.",
          order_approved:
            'Die Firma %{company_name} schickt Ihnen Details von Buchung Nr. %{order_id} für "%{product_name}".',
          please_approve: "Bestätigen Sie bitte die Buchung mit dem Link unten.",
          approve_action: "Buchung bestätigen",
          reject_action: "Buchung stornieren ",
        },
        saas: {
          action: "Buchung bestätigen",
          approval_deadline: "",
          deadline_warning: "Falls Ihre Buchung im Termin nicht bestätigt wird, wird es automatisch storniert werden.",
          order_approved: 'Wir haben Ihre Buchung Nr.  %{order_id} für "%{product_name}" bestätigt.',
          please_approve: "Bestätigen Sie bitte die Buchung mit dem Link unten.",
          approve_action: "Buchung bestätigen",
          reject_action: "Buchung stornieren",
        },
        subject: 'Bestätigen Sie bitte die Buchung Nr. %{order_id} ("%{product_name}")',
      },
      order_online_deposit_time_limit_exceeded_company_email: {
        line1:
          'Leider mussten wir Vorbuchung Nr. %{order_id} von %{customer_full_name} für "%{product_name}" (%{stock_time_range}) storniert, weil der Kunde zeitlich nicht bezahlt hat. Kontaktieren Sie bitte dem Kunden um Situation zu erklärenund Kontakt zu erneuen.',
        subject:
          "Buchung Nr. %{order_id} ist storniert geworden - der Kunde hat nicht zeitlich bezahlt %{confirmation_installment_st_name_d} (Kunde: %{customer_full_name})",
      },
      order_online_deposit_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>Leider mussten wir Ihre Buchung Nr. %{order_id} für "%{product_name}" stornieren</strong>, weil die Bezahlung ist nicht zeitlich durchgegangen. ',
          line2:
            "Wir rückerstatten erhaltene Bezahlung %{confirmation_installment_paid_amount} auf Ihren Bankkonto in 24 Stunden.",
          line3_html: "Falls Sie den Angebot erneut buchen wollten, gehen Sie bitte zu: %{product_link}",
        },
        saas: {
          line1_html:
            '<strong>Leider mussten wir Ihre Buchung Nr. %{order_id} für "%{product_name}" (%{stock_time_range}) stornieren</strong>, weil Bezahlung nicht gemacht geworden ist.',
          line2:
            "Wir rückerstatten erhaltene Bezahlung %{confirmation_installment_paid_amount} auf Ihren Bankkonto in 24 Stunden.",
          line3_html: "Falls Sie den Angebot noch einmal buchen möchten, gehen Sie bitte zu: %{product_link}",
        },
        subject:
          "Buchung Nr. %{order_id} ist storniert geworden- Sie haben nicht zeitlich bezahlt %{confirmation_installment_st_name_d}",
      },
      order_online_payment_reminder_customer_email: {
        marketplace: {
          contact_us_if_problems: "Falls Sie Probleme mit der Buchung haben, setzen Sie sich bitte mit uns im Kontakt.",
          line1:
            'Wir haben keine Bezahlung für Ihre Vorbuchung Nr. %{order_id} für "%{product_name}". Weil Bezahlungstermin abgelaufen ist, mussten wir Ihre Einleitendbuchung stornieren. Sie können aber erneut buchen.',
          offer_details_below: "Details von Angebot unten: ",
        },
        saas: {
          contact_us_if_problems: "Falls Sie egalwelche Probleme mit der Buchung haben, kontaktieren Sie bitte uns.",
          line1:
            'Wir haben keine Bezahlung für Ihre Vorbuchung Nr. %{order_id} für "%{product_name}". Weil Bezahlungstermin abgelaufen ist, mussten wir Ihre Einleitendbuchung stornieren. Sie können aber erneut buchen.',
          offer_details_below: "Details von Angebot unten: ",
        },
        subject: 'Erinnerung: finalisieren Sie bitte die Buchung für "%{product_name}"',
      },
      order_company_rejected_company_email: {
        line1: 'Sie haben Vorbuchung Nr. %{order_id} von %{customer_full_name} für "%{product_name}" storniert.',
        line2:
          "Falls Sie angegebenen Datum noch einmal anbieten möchten, aktualisieren Sie bitte die Verfügbarkeit im Paneel. ",
        subject: "Buchung Nr. %{order_id} ist storniert geworden (Kunde: %{customer_full_name})",
        line1_html:
          'Sie haben Vorbuchung Nr <a href="%{partnerapp_order_url}">%{order_id}</a> von %{customer_full_name} für "%{product_name}" abgelehnt.',
      },
      order_company_rejected_customer_email: {
        marketplace: {
          line1:
            'Firma %{company_name} hat Ihre Buchung Nr. %{order_id} für "%{product_name}" storniert, weil es keine freie Plätze mehr am %{stock_time_range} gibt.',
          see_offer_html: "Angebot in anderen Termine ansehen: %{product_link}",
          confirmation_installment_refund_info:
            "Wir rückerstatten Bezahlung %{confirmation_installment_paid_amount} auf Ihren Bankkonto in 24 Std.",
        },
        saas: {
          line1:
            'Wir haben Ihre Buchung Nr. %{order_id} für "%{product_name}" storniert, weil es keine freie Plätze mehr am %{stock_time_range} gibt.',
          see_offer_html: "Angebot in anderen Termine ansehen: %{product_link}",
          confirmation_installment_refund_info:
            "Wir rückerstatten Bezahlung %{confirmation_installment_paid_amount} auf Ihren Bankkonto in 24 Std.",
        },
        subject: 'Buchung Nr. %{order_id} für "%{product_name}" ist storniert geworden',
      },
      order_customer_rejected_company_email: {
        line1: 'Der Kunde hat Vorbuchung Nr. %{order_id} von %{customer_full_name} für "%{product_name}".',
        subject: "Buchung Nr. %{order_id} ist von dem Kunden storniert geworden (Kunde: %{customer_full_name})",
      },
      order_customer_rejected_customer_email: {
        marketplace: {
          line1: 'Ihre Buchung Nr. %{order_id} für "%{product_name}" ist storniert geworden.',
          see_offer_html: "Angebot noch einmal ansehen: %{product_link}",
          confirmation_installment_refund_info:
            "Wir rückerstatten Bezahlung %{confirmation_installment_paid_amount} auf Ihren Bankkonto in 24 Std.",
        },
        saas: {
          line1: 'Ihre Buchung Nr. %{order_id} für "%{product_name}" ist storniert geworden.',
          see_offer_html: "Angebot noch einmal ansehen: %{product_link}",
          confirmation_installment_refund_info:
            "Wir rückerstatten Bezahlung %{confirmation_installment_paid_amount} auf Ihren Bankkonto in 24 Std.",
        },
        subject: 'Ihre Buchung Nr. %{order_id} für "%{product_name}" ist storniert geworden.',
      },
      order_current_status_company_email: {
        line1: "Wir schicken Ihnen aktuellen Buchungsstatus.",
        subject: "Buchung Nr. %{order_id}, aktueller Status: %{status_i18n} (Kunde: %{customer_full_name})",
      },
      order_company_cancelled_company_email: {
        line1: 'Buchung Nr. %{order_id} von %{customer_full_name} für "%{product_name}" is storniert geworden.',
        subject: "Buchung Nr. %{order_id} ist storniert geworden",
        line1_html:
          'Buchung Nr <a href="%{partnerapp_order_url}">%{order_id}</a> von %{customer_full_name} für "%{product_name}" ist storniert geworden.',
      },
      order_company_cancelled_customer_email: {
        marketplace: {
          line1:
            '%{company_name} hat Ihre Buchung Nr. %{order_id} für "%{product_name}" an %{stock_time_range} storniert.',
          see_offer_html: "Angebot in anderem Termin ansehen; %{product_link}",
          confirmation_installment_refund_info:
            "Bezahlung %{confirmation_installment_paid_amount} wird auf Ihren Bankkonto in 24 Std. rückerstattet werden.",
        },
        saas: {
          line1: 'Wir haben Ihre Buchung Nr. %{order_id} für "%{product_name}" an %{stock_time_range} storniert.',
          see_offer_html: "Angebot in anderen Termine ansehen: %{product_link}",
          confirmation_installment_refund_info:
            "Bezahlung %{confirmation_installment_paid_amount} wird auf Ihren Bankkonto in 24 Std. rückerstattet werden.",
        },
        subject: 'Buchung Nr. %{order_id} für "%{product_name}" ist storniert geworden. ',
      },
      order_abandonment_followup_customer_email: {
        see_product: "Noch einmal ansehen: %{product_name}",
        find_other_products_in_this_location: "Angebote in ähnlichen Ort finden: ",
        line1: 'letztens haben Sie "%{product_name}" Angebot angesehen. Sind Sie noch dafür interessiert?',
        subject: 'Angebote ähnlich zu "%{product_name}" ansehen',
        go_to_product: "Angebot ansehen",
      },
    },
    papp: {
      components: {
        EditableBillRow: {
          placeholder: "Name eingeben",
        },
        InstallmentFormSection: {
          exact_date_label: "Exaktes Datum",
          how: "Wie?",
          on_stock_starts_at_label: "Wann das Angebot beginnt",
          paid_after_company_approval_label:
            "Wenn das Datum Bestätigungen erfordert, bitten Sie den Kunden, zuerst die Vorauszahlung zu leisten",
          remaining_amount: "Restbetrag",
          when: "Wann?",
          whole_amount: "Ganze Menge",
          x_days_after_order_creation_label: "nach dem Absenden der Buchung",
          x_days_after_order_full_approval_label: "nach der Genehmigung der Buchung",
          x_days_after_previous_installment_label: "nach vorherige Rate",
          x_days_before_stock_starts_at_label: "vor Beginn des Angebots",
          how_much: "Wie viel?",
          to: "Nach?",
        },
        InstallmentsListFormSection: {
          add_new: "Neue Rate hinzufügen",
        },
        LocationFormControl: {
          placeholder: "Ort eingeben",
        },
        MainView: {
          default_error_title: "Serververbindungsfehler",
          error_date: "Fehlersdatum",
          error_description: "Falls der Fehler wieder kommt, kontaktieren Sie uns bitte an %{email}.",
          error_id: "Fehler ID",
          loading: "Laden",
          retry: "Wiederholen",
        },
        MultipleDateFormControl: {
          add_new: "Termin hinzufügen",
        },
        MultipleInputFormControl: {
          placeholder: "Fügen Sie eine weitere Zeile hinzu",
        },
        MultipleTimeFormControl: {
          add_new: "Fügen Sie eine Stunde hinzu",
        },
        OrderSidebarPreview: {
          edit_slot: "Slot bearbeiten",
          see_slot: "Siehe Datum",
        },
        PaginationNavigation: {
          out_of: "von",
        },
        PaymentProfileProductAttachmentFormSection: {
          active: "Aktiv",
          additional_fee: "Zahlung",
          days_before_arrival_date_limit: "Gewähltes Datum",
          days_before_arrival_date_limit_label: "Im Voraus",
          installment: "Rate",
          no_date_limit: "Immer",
        },
        ProductCustomerOrderFieldFormSection: {
          add_list_option: "Listenoption hinzufügen",
          add_new: "Neue hinzufügen",
          show_on_manifest: "Auf der Teilnehmerliste anzeigen",
          value_required: "Wert erforderlich",
          value_type: "Werttyp",
        },
        ProductPricedOrderFieldFormSection: {
          add_list_option: "Listenoption hinzufügen",
          ask_customer: "Kunden nachfragen",
          different_currency_base_amount_note:
            "Zusätzliche Optionen, die in einer anderen Währung als der Gebotswährung definiert sind, werden immer über die Basiskosten hinaus gezählt.",
          for_all_variants: "Für alle Varianten",
          remove: "Löschen",
          show_on_manifest: "Auf der Teilnehmerliste anzeigen",
          value_type: "Werttyp",
        },
        SlotsCalendar: {
          agenda: "Liste",
          allDay: "Den ganzen Tag",
          availability_mode: "Verfügbarkeit",
          date: "Termin",
          day: "Tag",
          event: "Veranstaltung",
          month: "Monat",
          next: "Weiter",
          previous: "zurück",
          price_mode: "Preise",
          showMore: "%{count} noch...",
          time: "Zeit",
          today: "Heute",
          week: "Woche",
          slot_confirmed: "Datum bestätigt",
        },
        TagsInputFormControl: {
          addition_label: "Hinzufügen:",
          no_results_message: "Keine Ergebnisse",
          placeholder: "Hinzufügen als nächstes",
        },
        TypeaheadInputFormControl: {
          no_results_message: "Keine Ergebnisse",
          placeholder: "Alles",
        },
        SaleWindowRuleFormGroup: {
          sale_starts_at_label: "Verkaufsstart",
          sale_ends_at_label: "Verkaufsende",
          offset_label: "im Voraus",
          from_date_label: "ab Datum",
          until_date_label: "bis Datum",
          before_slot_start: "vor dem Termin",
          resolved_preview: "Für den Termin %{slot} fällt das auf %{resolved}.",
        },
        UsebyDateRangeFormGroup: {
          days_limit_label: "x Tage",
          days_since_order_creation: "Tage seit Buchung",
          ends_at_label: "bis",
          starts_at_and_ends_at_label: "in Tage",
          starts_at_label: "vom Tag",
        },
        ProductsListItem: {
          preview_marketplace: "Vorschau",
          preview_saas: "WWW",
          new_order: "Buchen",
          active_switch_label: "Aktiv",
          published_on_saas_switch_label: "WWW",
        },
        OrderedProductOrderFieldFormControl: {
          custom_location_name_placeholder: "Kundenname eingeben",
        },
        ProductsSelectControl: {
          blank_label: "Kein Angebot zugewiesen",
        },
      },
      order: {
        approve: "Bestätigen",
        cancel_order: "Buchung stornieren",
        confirm: "Senden",
        customer_name_placeholder: "Keine Kundeninformationen.",
        delete_order: "Löschen Sie die Buchung",
        finish: "Fertig",
        redeliver_customer_order_email: "Sende Bestelldetails",
        reject: "Ablehnen",
        redeliver_supplier_order_email: "Buchungdetails an dem Lieferanten senden",
        finish_order: "Bestellung abschließen",
        automatic_icon: "A",
        manual_icon: "M",
        no_stock_date: "Kein Termin",
      },
      common: {
        search: "Suchen...",
        no_results_message: "Keine Ergebnisse",
        discard_changes_confirm_message:
          "Sie haben Ihre Änderungen nicht gespeichert. Sind Sie sicher, dass Sie gehen wollen, ohne zu beenden?",
        go_back: "Zurück",
        remove: "Stornieren",
        save: "Speichern",
        none: "keine",
        poland: "Polen",
        edit: "Bearbeiten",
        manage: "Verwalten",
        save_changes: "Änderungen speichern",
        submit_success_message: "Änderungen gespeichert.",
        default_value: "Standardmäßig: %{value}",
        attention: "",
        no_name: "",
        close: "Schließen",
        in_total: "Insgesamt",
        filters_title: "",
        form_validation_error_message: "",
        cancel: "Canceln",
        go_next: "Weiter",
        st_email: "cooperation@tripsomnia.com",
        st_phone_number: "+48 690 670 581",
        are_you_sure: "Sind Sie sicher?",
        translations_locale: "Wählen Sie das Gebietsschema",
        x_per_page: "%{count} pro Seite",
        show_filters: "",
        hide_filters: "",
        download_csv: "",
        weekdayAbbreviations: ["", "", "", "", "", "", ""],
      },
      agents: {
        AgentsListView: {
          title: "Agenten",
          add_new: "Neuer Agent",
          no_records_title: "Keine Agenten",
          no_records_message: "Zur Kooperation wurde noch kein Agent eingeladen.",
          no_records_add_new_link: "Neue hinzufügen?",
        },
        EditAgentCooperationView: {
          default_pricing: "Standardpreis",
          activate_all: "Aktiviere alle",
          remove_confirm_message: "Sind Sie sicher, dass Sie diese Kooperation abbrechen möchten?",
          title: "Agenturkooperation",
          title_with_company_name: "Agenturkooperation mit %{Firmenname}",
          products: "Angebote",
          price_change: "Erhöhen / verringern um",
          gross_price: "Bruttopreis",
          net_price: "Nettopreis",
          include_product_options_price: "Zusatzoptionen inkludieren",
          st_cooperation_hint: {
            p1: "Kooperation mit Tripsomnia",
            p2: "Sie können unsere Kooperationsbedingungen nicht bearbeiten.",
            p3: "Wenn Sie Änderungen vornehmen möchten, wenden Sie sich bitte per Telefon oder E-Mail an Ihren Assistenten: %{tel} oder %{email}.",
          },
        },
        NewAgentPrompt: {
          title: "Neuer Agent",
          email_label: "E-Mail des Agenten",
          submit: "Zu Zusammenarbeit einladen",
        },
        SuppliersListView: {
          title: "Lieferanten",
          no_records_title: "Keine Lieferanten",
          no_records_message: "Es sind keine Einladungen von einem anderen Agenturkooperationspartner eingegangen.",
          add_new: "",
        },
      },
      app: {
        App: {
          fetch_app_error_title: "Serververbindungsfehler",
        },
        ForbiddenView: {
          title: "Fehler 403",
          message: "Zugang verboten.",
        },
        LeftBar: {
          dashboard: "Dashboard",
          calendar: "Kalender",
          orders: "Buchungen",
          products: "Angebote",
          customers: "Kunden",
          agents: "Agenten",
          suppliers: "Lieferanten",
          finances: "Finanzen",
          raports: "Berichte",
          settings: "Einstellungen",
          reviews: "Rezensionen",
          affiliate: "Finanzen",
          accommodation: "",
          connectly: "Connectly"
        },
        NotFoundView: {
          title: "Fehler 404",
          message: "Seite nicht gefunden",
        },
        requireAuth: {
          company_forbidden: "Sie haben keinen Zugriff auf diese Firma (ID: %{company_id}).",
          no_companies_error_title: "Keine an Ihr Konto angegliederten Unternehmen",
        },
        TopBar: {
          logout: "Abmelden",
          marketplace_homepage: "Tripsomania.com",
          new_order: "Buchen",
          saas_homepage: "Ihre Webseite",
          your_account: "Ihr Konto",
        },
      },
      auth: {
        LoginView: {
          send_confirmation_instructions_link: "Aktivationslink noch einmal senden",
          send_reset_password_instructions_link: "Passwort erinnern",
          send_unlock_instructions_link: "Mein Konto ist blockiert",
          submit: "Einloggen",
          title: "Zu Tripsomnia.com Paneel einloggen",
        },
        ResetPasswordView: {
          submit: "Passwort ändern",
          title: "Neues Passwort generieren",
        },
        SendResetPasswordInstructionsView: {
          email_help: "Wir senden Ihnen einen Link, um ein neues Passwort für Ihr Konto zu erstellen.",
          email_label: "Ihre E-Mail Adresse",
          submit: "Senden",
          success_message:
            "Wir haben Ihnen eine E-Mail mit einem Link gesendet, um ein neues Passwort zu generieren. Bitte überprüfen Sie Ihren Posteingang.",
          title: "Passwort erinnern",
        },
        index: {
          fetch_user_failed_message: "Deine Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.\n",
        },
      },
      calendar: {
        CalendarView: {
          all_products: "Alle Produkte",
          all_suppliers: "Alle Lieferanten",
          title: "Buchungskalender",
          filter_all: "Alle",
          filter_available: "Verfügbar",
          filter_awaiting: "Erwartet",
          filter_booked: "Gebucht",
          show_inactive_offers: "Inaktive Angebote anzeigen",
        },
        ShowSlotModal: {
          active_orders_title: "Aktive Buchungen",
          build_order: "Buchen",
          no_orders_message: "Keine Buchungen für diesen Tag.",
          open_manifest: "Teilnehmerliste anzeigen",
          open_manifest_failure_message: "Fehler beim Herunterladen der Teilnehmerliste.",
          other_orders_title: "Andere Bestellungen",
          download_manifest: "Manifest herunterladen",
          booked_orders_title: "Gebucht",
          pending_orders_title: "Steht aus",
          awaiting_orders_title: "Erwartet",
          sale_window_title: "Verkaufsfenster",
          sale_starts_at_label: "Verkaufsstart",
          sale_ends_at_label: "Verkaufsende",
          within_sale_window_yes: "Derzeit verkäuflich",
          within_sale_window_no: "Außerhalb des Verkaufsfensters",
          within_sale_window_past: "Termin bereits vergangen",
          biledo_block_title: "Biledo-Verknüpfung",
          biledo_term_uuid: "Term UUID",
          biledo_pricelist_uuid: "Pricelist UUID",
          biledo_overwrite_warning: "Ihre Änderung wird beim nächsten Biledo-Sync überschrieben.",
        },
      },
      customers: {
        CustomersListView: {
          no_records_add_new_link: "Hinfügen?",
          no_records_message: "Es wurde noch kein Kunde erstellt",
          no_records_title: "Keine Kunden",
          title: "Kunde",
          query_filter: "",
          add_new_customer: "Neuer Kunde",
        },
        EditCustomerModal: {
          existing_customer_title: "Kundenbearbeitung",
          new_customer_title: "Neuer Kunde",
          remove_confirm_message: "Sind Sie sicher dass Sie diesen Kunden stornieren wollen?",
        },
        ShowCustomerView: {
          no_name: "(keine Name)",
          orders_title: "Buchungen",
          title: "Kunde",
        },
      },
      dashboard: {
        DashboardView: {
          created_orders_number_label: "Anzahl der angelegten Bestellungen",
          finished_orders_number_label: "abgeschlossene Buchungen",
          finished_orders_total_amount_label: "Angeschlossene Buchungen Gesamtbetrag",
          new_orders_title: "Neue Bestellungen (letzte 30 Tage)",
          no_graph_data_message: "Keine Daten zur Anzeige von Statistiken.",
          no_orders_waiting_message: "Keine Buchungen zu bestätigen",
          orders_number_label: "Buchungen",
          orders_waiting_for_your_approval_title: "Bestellungen warten auf Ihre Bestätigung",
          participants_number_label: "mitglieder",
          see_all_orders: "Alle (%{count}) sehen",
          title: "Dashboard",
          hint: {
            p1: "Beginnen Sie mit dem Verkauf Ihrer Angebote",
            p2: "Vervollständigen Sie Ihre Konto- und Unternehmenseinstellungen.",
            p3: "Angebote hinzufügen: Beschreibung, Preis- und Buchungseinstellungen, dann Daten.",
            p4: "Erstellen und fügen Sie Widgets auf Ihrer Website ein.",
            p5: "Sammeln Sie Online-Bestellungen von Kunden oder fügen Sie sie selbst in das Panel ein.",
            p6: "Wenn Sie Fragen oder Bedenken haben, kontaktieren Sie uns bitte per Telefon %{tel} oder per Email %{email}.",
            p2_html: "",
            p3_html: "",
            p4_html: "",
            p7: "",
            p6_html: "",
          },
          stats_title: "Statistiken (%{date_from}-%{date_to})",
        },
      },
      finances: {
        FinancesListView: {
          no_records_message: "Keine Buchungen hinzugefügt.",
          no_records_title: "Keine Buchungen.",
          title: "Finanzen",
          summary_row: "Insgesamt (für Zeilen %{start}-%{end}):",
          create_agent_disbursement: "Auszahlung des Agenten",
          agent_received_paid_th: "Agent erhalten / bezahlt",
          socialtravel_received_paid_th: "Tripsomnia zurückgezogen / bezahlt",
          supplier_received_paid_th: "Lieferant zurückgezogen / bezahlt",
          orders_count: "%{count} Buchungen",
        },
      },
      settings: {
        SettingsLayout: {
          title: "Einstellungen",
          user: "Sie",
          user_account_settings: "Ihr Konto",
          company: "Firma",
          company_account_settings: "Firmeneinstellungen",
          company_members_settings: "Mitglieder und Berechtigungen",
          products_settings: "Angebotseinstellungen",
          payments_settings: "Zahlungseinstellungen",
          billing_settings: "Zahlungen",
          integrations: "Integrationen",
          marketplace_settings: "Marketplace Tripsomnia",
          saas_settings: "Ihre Webseite",
          widgets_settings: "Widgets",
          readonly_access_message:
            "Sie können diese Daten nicht aktualisieren. Melden Sie sich dazu als Unternehmensadministrator an.",
          stripe: "",
        },
        BillingSettingsView: {
          title: "Firmeneinstellungen",
          invoice_company_name_placeholder: "Standardmäßig: Firmenname (%{default_value})",
          invoice_contact_email_placeholder: "Standardmäßig: Firmen-E-Mail-Adresse (%{default_value})",
          invoice_contact_phone_number_placeholder: "Standardmäßig: Firmenkontaktnummer (%{default_value})",
          invoice_details_title: "",
          hint: {
            p1: "Rechnungsdaten",
            p2: "Geben Sie die Firmendaten für Rechnungen ein",
          },
        },
        CompanyMembersView: {
          title: "Mitglieder und Berechtigungen",
          new_member: "Neues Firmenmitglied",
          no_members: "Keine Mitglieder",
          hint: {
            p1: "Mitarbeiter hinfügen",
            p2: "Gewähren Sie anderen Ihren Zugriff auf Ihr Unternehmen. Für ein neues Konto können Sie Administrator- oder Mitarbeiterrechte vergeben (eingeschränkter Zugriff).",
          },
        },
        CompanySettingsView: {
          title: "Firmeneinstellungen",
          contact_details: "Kontaktdaten für Ihre Kunden",
          contact_phone_number_placeholder: "z. B. +48 690 670 581",
          notifications_details: "Daten zur Auftragsabwicklung",
          notifications_email_placeholder: "Standardmäßig: Firmen-E-Mail-Adresse (% {default_value})",
          notifications_email_label: "Adressen zur Bestätigung von Buchungen",
          notifications_phone_number_placeholder: "Standardmäßig: Firmenkontaktnummer (% {default_value})",
          notifications_phone_number_label: "Zellennummer (mit Ländercode)",
          other_details: "Andere Einstellungen",
          hint: {
            p1: "Name",
            p2: "",
            p3: "Profilbild",
            p4: "",
            p5: "",
            p6: "",
            p7: "",
            p8: "",
            p9: "Hauptsprache",
            p10: "",
            p11: "Zeitzone",
            p12: "",
          },
        },
        MarketplaceSettingsView: {
          title: "Marketplace Tripsomnia",
          marketplace_homepage_url_label: "Die Adresse Ihres Unternehmens auf dem Marketplace",
          hint: {
            p1: "",
            p2: "",
          },
        },
        PaymentsSettingsView: {
          title: "Bezahlungseinstellungen",
          your_profiles_title: "Ihre Kundenzahlungsprofile",
          marketplace_profiles_title: "Tripsomnia.com Kundenzahlungsprofile",
          add_new_profile: "Fügen Sie ein neues Profil hinzu",
          hint: {
            p1: "",
            p2: "",
            p3: "",
            p4: "",
            p5: "",
            p6: "",
            p7: "",
            p8: "",
          },
          no_your_profiles_warning:
            "Fügen Sie mindestens ein Zahlungsprofil für Ihre Kunden hinzu. Andernfalls können sie keine Buchungen auf Ihrer Website aufgeben.",
          enable_for_all_product_variants: "Für alle Angebote aktivieren",
          access_possible_only_for_supplier:
            "Die Verwaltung von Zahlungsprofilen ist nur möglich, wenn Sie Anbieter sind. Wenden Sie sich an Ihre Angebotsanbieter, um zu erfahren, welche Zahlungsprofile verfügbar sind",
          increase_orders_amount_by_saas_commision_label:
            "Fügen Sie eine Gebühr für unsere Systemprovision zum Gesamtbestellbetrag hinzu",
          increase_orders_amount_by_saas_commision_enabled_hint: "Der Kunde übernimmt die Systemgebühr",
          increase_orders_amount_by_saas_commision_disabled_hint: "Ihre Firma übernimmt die Systemgebühr",
        },
        ProductsSettingsView: {
          title: "Angeboteinstellungen",
          hint: {
            p1: "",
            p2: "",
            p3: "",
            p4: "",
          },
        },
        SaasSettingsView: {
          title: "Ihre Webseite",
          saas_homepage_url: "Ihre Website-Adresse",
          contact_us_if_want_to_change: "Wenn Sie es ändern möchten, kontaktieren Sie uns.",
          hint: {
            p1: "Ihre Webseite",
            p2: "",
          },
        },
        UserAccountView: {
          title: "Ihr Konto",
          site_settings_title: "Serviceeinstellungen",
          password_change_title: "Ihr Passwort ändern",
          hint: {
            p1: "",
            p2: "",
          },
        },
        WidgetsSettingsView: {
          title: "Widgets",
          iframe: "IFrame",
          button: "Knopf",
          navbar: "Navigationsbereich",
          detect_from_visitor_browser: "Sprache basierend auf dem Browser des Benutzers erkennen",
          locale: "Webseitesprache",
          currency: "Währung des Kunden",
          bubble: "Blase",
          active: "",
          scrollWidget: "",
          exitWidget: "",
        },
        ButtonWidgetView: {
          book_now: "Jetzt buchen",
          small_size: "Klein",
          normal_size: "Normal",
          large_size: "Groß",
          bottom_right: "unten rechts",
          bottom_left: "unten links",
          top_right: "oben rechts",
          top_left: "oben links",
          in_modal: "in modal",
          in_new_tab: "in neuem Tab",
          title: "Knopf",
          button_content: "Schaltfläche Inhalt",
          open: "Öffnen",
          color: "Farbe",
          size: "Größe",
          stick_to_window_corner: "Bleib bei der Fensterecke",
          generate_code: "Code generieren",
          place_code_anywhere:
            "Platzieren Sie diesen Code irgendwo auf Ihrer Site. Wir empfehlen Ihnen, es am Anfang, kurz vor %{head} oder im Head, kurz vor %{body_end} zu platzieren.",
          put_widget_anywhere: "Als nächstes platzieren Sie das gewünschte Widget an einer beliebigen Stelle.",
          preview: "Vorschau",
          button_type: "Normale Taste",
          flag_type: "Flagge",
          what_type: "Tastentyp",
          center_right: "",
          center_left: "",
        },
        NavBarWidgetView: {
          new_link: "Fügen Sie ein Element hinzu",
          our_products: "Unseres Angebot",
          products_calendar: "Angebotkalender",
          book: "Buchen",
          white_blue: "Weiß mit Blauton",
          white_teal: "weiß mit grünem Ton",
          white_orange: "weiß mit orangem Ton",
          black_blue: "schwarz mit Blauton",
          black_teal: "schwarz mit grünem Ton",
          black_orange: "schwarz mit orangem Ton",
          blue: "blau",
          teal: "grün",
          orange: "orange",
          to_window_bottom: "Unterseite des Fensters",
          to_window_top: "oben im Fenster",
          in_modal: "in modal",
          in_new_tab: "in einem neuen Fenster",
          none: "Nichts zu zeigen",
          company_name: "Name der Firma",
          company_logo: "Firmenlogo",
          title: "Navigationsbereich",
          show_company_name: "Firmenname anzeigen",
          show_toggle_button: "Umschalttaste anzeigen",
          open: "Öffnen",
          color: "Farbe",
          stick: "Halten",
          cta_button: "Haupttaste",
          navigation: "Navigation",
          contact: "Kontakt",
          generate_code: "Code generieren",
          place_code_anywhere:
            "Platzieren Sie diesen Code irgendwo auf Ihrer Site. Wir empfehlen Ihnen, es am Anfang, kurz vor %{head} oder im Head, kurz vor% {body_end} zu platzieren.",
          put_widget_anywhere: "Als nächstes platzieren Sie das gewünschte Widget an einer beliebigen Stelle.",
          preview: "Vorschau",
          link_type_link: "Link",
          link_type_none: "Keine",
          link_type_text: "Inhalt",
          link_type_phone: "Telefonnummer",
          link_type_email: "E-Mail  Adresse ",
          link_type_custom_link: "Benutzerdefinierten Link",
          black: "",
          white: "",
          green: "",
          type1: "",
          type2: "",
          type3: "",
          red: "",
          percentage: "",
          activity: "",
          cart: "",
          notification: "",
          offer: "",
          search: "",
          star: "",
          negotiate: "",
          discount: "",
          chat: ""
        },
        IframeWidgetView: {
          title: "IFrame",
          iframe_width: "IFrame Breite",
          iframe_height: "IFrame Höhe",
          generate_code: "Code generieren",
          put_widget_anywhere: "Platziere das gewünschte Widget an einer beliebigen Stelle.",
          preview: "Vorschau",
        },
        WidgetRouteFormSection: {
          homepage_page: "Startseite",
          products_list_page: "Liste der Angebote",
          products_calendar_page: "Angebot Kalender",
          product_page: "Angebotsseite",
          new_order_page: "Angebot Buchungsformular",
          on_slot_click_show_product: "Angebotsseite",
          on_slot_click_new_order: "Buchungsformular für ein bestimmtes Datum",
          type: "Typ",
          product: "Angebot",
          all_products: "Alle Angebote",
          on_slot_click_action_type: "Klicken Sie auf ein Datum, um es zu öffnen",
          reviews_page: "Rezensionen",
          product_location_tag: "Ort",
          product_location_tag_page: "Ortsseite",
          product_category_tag: "Kategorie",
          product_category_tag_page: "Kategorieseite",
          coupons_page: "Liste des Sonderangebote",
        },
        EditPaymentProfileModal: {
          profile_change_affects_all_products_warning:
            "Beachten Sie, dass alle Änderungen, die Sie hier vornehmen, Auswirkungen auf alle Angebote haben, denen dieses Zahlungsprofil derzeit zugewiesen ist.",
          remove_confirm_message: "Möchten Sie dieses Zahlungsprofil wirklich entfernen?",
          edit_profile_title: "Zahlungsprofil bearbeiten",
          new_profile_title: "Neues Zahlungsprofil",
          name_label: "Profilname",
          name_hint:
            "Es wird dem Kunden bei der Auftragserstellung angezeigt, wenn er mehr als ein Profil zur Auswahl hat.",
          has_additional_fee_label: "Zusatzgebühr",
          cancellation_policy_hint:
            "Bis wann kann die Buchung storniert werden? In welcher Höhe kann der Kunde die Rückerstattung beantragen?",
          installments_label: "Zahlungsraten",
          additional_fee_as_agent_fee_label: "Fügen Sie die Gebühr als Agentsgebühr hinzu",
        },
        EditCompanyMemberModal: {
          edit_member_title: "Bearbeiten Sie das Mitglied der Firma",
          new_member_title: "Neues Firmenmitglied",
          remind_password: "Passwort vergessen",
        },
        BubbleWidgetView: {
          balloon_line1_value: "Kostenlose Rabatte für unsere Dienstleistungen",
          balloon_line2_value: "Klicken Sie hier, um sie zu bekommen!",
          balloon_line1_label: "Erste Textzeile",
          balloon_line2_label: "Zweite Textzeile",
          generate_code: "Code generieren",
          large_size: "Groß",
          normal_size: "Normal",
          place_code_anywhere:
            "Platzieren Sie diesen Code irgendwo auf Ihrer Site. Wir empfehlen Ihnen, es am Anfang, kurz vor %{head} oder im Head, kurz vor %{body_end} zu platzieren.",
          placement: "Bleib bei",
          preview: "Vorschau",
          put_widget_anywhere: "Als nächstes platzieren Sie das gewünschte Widget an einer beliebigen Stelle.",
          small_size: "Klein",
          title: "Blase",
          bottom_left_corner: "untere linke Ecke",
          bottom_right_corner: "rechte untere Ecke",
          color_label: "Farbe",
          placement_label: "Bleib bei",
          size_label: "Größe",
          top_left_corner: "obere linke Ecke",
          top_right_corner: "obere rechte Ecke",
          show_after_label: "Zeige Widget nach",
          show_balloon_after_label: "Beschreibung anzeigen nach",
          play_sound_label: "Ton abspielen",
          animation_type: "",
          icon: "",
        },
        IndexWidgetsView: {
          header1: "",
          header2: "",
          text1: "",
          text2: "",
          text3: "",
          text4: "",
          widgetCodeHasBeenCopied: "",
          widgetCodeHasnBeenCopied: "",
          copyWidgetCode: "",
        },
        StripeSettingsView: {
          title: "",
          stripe_verification_failure: "",
          stripe_verification: "",
          stripe_verification_success: "",
          line1_html: "",
          line2_html: "",
          line4_html: "",
          line3: "",
          line3_1: "",
          line3_2: "",
          line3_3: "",
          line3_4: "",
          line5_html: "",
          line6_html: "",
          line7: "",
          line1: "",
          line2: "",
        },
      },
      orders: {
        AddOrderTransferModal: {
          default_title: "",
          new_refund_title: "",
          new_transfer_title: "",
        },
        ChangeOrderScheduleSlotModal: {
          title: "",
        },
        EditOrderCustomerDetailsModal: {
          title: "",
          customer_details: "Kundendetails",
        },
        EditOrderInstallmentsModal: {
          title: "",
        },
        EditOrderItemsModal: {
          title: "",
          changed_order_item_name: "",
          changed_order_option_name: "",
          removed_order_option_name: "",
          added_order_option_name: "",
          order_items_title: "Rechnung",
          order_item_index: "",
          order_item_unit_price: "",
          order_item_quantity: "",
          order_item_total_price: "Insgesamt",
          add_new_order_item: "",
          extra_participants_existing:
            "Die Anzahl der dieser Buchung zugewiesenen Teilnehmer übersteigt die Anzahl der auf der Rechnung ausgewählten Personen. Löschen Sie sie aus der Buchung, indem Sie auf das Kreuz der ausgewählten Person klicken.",
          installments_require_manual_change_warning:
            "Bitte beachten Sie, dass die Beträge der Raten in dieser Reihenfolge nicht automatisch geändert wird. Wenn Sie ihre Beträge ändern möchten, ändern Sie sie in das Zahlungsprofil des Auftrags, nachdem Sie die Rechnungsstellung geändert haben.",
        },
        NewOrderItemsForm: {
          select_agent: "",
          reset_agent_commision: "",
          product_options: "Zusatzoptionen",
          other_order_items: "",
          add_new_order_item: "",
        },
        NewOrderPaymentsForm: {
          accept_deposit: "Zahlung annehmen",
          plan_payments: "",
          no_payments: "Nicht jetzt",
          deposit_accepted_as_agent: "",
          deposit_accepted_as_supplier: "",
          only_deposit_now: "",
          rest_payment: "",
          order_status: "Buchungsstatus",
          notify_customer: "",
          notify_customer_impossible_no_customer_email_given: "",
          note_placeholder: "",
          choose_payments_mode: "Wählen Sie die Art und Weise, wie der Kunde für die Bestellung bezahlen wird.",
          choose_payments_mode_error: "Wählen Sie die Art und Weise, wie der Kunde für die Bestellung bezahlen wird.",
          order_status_message: "",
        },
        NewOrderProductModal: {
          no_products_found: "",
          static_date_booking_label: "",
          with_custom_product_title: "",
          choose_product_variant: "",
          default_title: "Neue Buchung",
          search_products: "Angebot suchen",
          use_custom_product_button: "",
          info1: "",
          order_name: "",
        },
        NewOrderModal: {
          confirm_abandon_message: "",
          confirm_abandon_cancel: "Nein, zurück zur Buchung",
          confirm_abandon_ok: "Ja, Buchung verlassen",
          schedule_step_title: "Termin auswählen",
          order_items_step_title: "",
          customer_details_step_title: "",
          payments_step_title: "",
          abandon_failed_message: "",
          payments_step_profiles_instruction: "",
          payments_step_choose_payments: "",
          payments_step_choose_payments_reseller: "",
          payments_step_choose_payments_customer: "",
          payments_step_choose_payments_reseller_hint1: "",
          payments_step_choose_payments_reseller_hint2: "",
          payments_step_choose_payments_customer_hint1: "",
          payments_step_choose_payments_customer_hint2: "",
          payments_step_prebook: "",
          payments_step_choose_payments_terminal_hint1: "",
          payments_step_choose_payments_terminal_hint2: "",
          payments_step_choose_payments_terminal: "",
        },
        OrderScheduleForm: {
          select_existing_slot: "",
          upcoming_slots: "",
          no_slots_found: "",
          all_day: "",
          add_new_slot: "Termin hinzufügen",
        },
        OrdersListView: {
          title: "Buchungen\n",
          add_new_order: "Neue Buchung",
          no_orders_title: "",
          no_orders_message: "",
          no_orders_add_new_button: "",
          customer_query_filter: "",
          other_filters: "Andere",
          marketplace_filter: "Marketplace",
          saas_filter: "SaaS",
          manual_filter: "Benutzerhandbuch",
          automatic_filter: "Automatisch",
          requires_company_approval_filter: "Erfordert die Bestätigung des Reiseveranstalter",
          doesnt_require_company_approval_filter: "Erfordert keine Bestätigung des Reiseveranstalter",
          no_booking_filter: "Ohne Buchung",
          static_date_booking_filter: "Mit Buchung",
          total_amount_currencies_filter: "Währung",
          customer_payment_methods_filter: "Zahlungsmethode",
          with_agent_commision_filter: "Mit Agentprovision",
          with_agent_service_fee_filter: "Mit Agentservicegebühr",
          with_both_agent_commision_and_service_fee_filter: "Mit Agentprovision und Servicegebühr",
          with_saas_commision_filter: "Mit Systemkommission",
          customer_transfer_date_filter: "Bezahlungstermin",
          without_agent_commision_and_service_fee_filter: "Ohne Agentprovision und Servicegebühr",
          notes_filter: "Anmerkungen",
          with_notes_filter: "Mit Anmerkungen",
          notes_filter_placeholder: "Nach Anmerkungeninhalt suchen",
          with_affiliate_filter: "",
          with_agent_filter: "",
          with_agent: "",
          static_date_range_booking_filter: "",
        },
        ChangeOrderStatusPrompt: {
          title: "",
          choose_new_status: "",
          save_and_notify_customer: "",
          notify_supplier: "Lieferanten benachrichtigen",
          save_and_send_opinion_request: "Speichern und senden Sie eine Rezenesionsanfrage an den Kunden",
        },
        ShowOrderView: {
          add_new_transfer: "Neue Bezahlung",
          add_new_refund: "Neue Rückerstattung",
          edit_note: "",
          change_status: "Buchungsstatus ändern",
          print: "Drücken",
          customer_title: "Kunde",
          see_details: "",
          send_notification: "",
          order_items_title: "",
          order_item_unit_price: "",
          order_item_quantity: "",
          payments_title: "Bezahlungen",
          agent_title: "",
          activities_title: "Buchungsgeschichte",
          title: "Buchung %{order_id}",
          approve_warning: "Bestätigen",
          approve_until_warning: "",
          send_opinion_reminder_notification: '("Rezension eingeben" Erinnerung senden)',
          pay_now: {
            tooltip: {
              no_payment_needed: "",
              too_low_amount: "",
            },
            0: "",
          },
        },
        utils: {
          confirm_approve_message: "",
          confirm_reject_message: "",
          confirm_finish_message: "",
          confirm_cancel_message: "",
          confirm_delete_message: "",
          redeliver_customer_order_email_success_message:
            "Eine E-Mail mit Buchunginformationen wurde an den Kunden gesendet.",
          redeliver_supplier_order_email_success_message:
            "E-Mail mit aktuellen Informationen über die Buchung wurde an den Lieferanten gesendet.",
          create_agent_disbursement_success_message:
            "Ausgewählte Buchungen wurden ausgezahlt (Auszahlungs-ID: %{agent_disbursement_id}).",
          redeliver_customer_order_opinion_reminder_email_success_message:
            "Eine E-Mail-Benachrichtigung zum Hinzufügen der Überprüfung eines Auftrags wurde an den Kunden gesendet.",
          send_opinion_request_to_customer: "Den Kunden um Rezension bitten",
        },
        OrderCustomerDetailsFormSection: {
          participants_details: "Teilnehmerdaten",
        },
        EditOrderNotesModal: {
          title: "Bestellhinweise",
        },
      },
      products: {
        EditProductView: {
          StepAdditional: {
            form_title: "",
            marketplace_settings: "",
            saas_commision_settings: "",
            hint: {
              p1: "Einstellung der Kommission",
              p2: "Sie können die restlichen Einstellungen in Agents finden.",
            },
          },
          StepAvailability: {
            all_product_variants: "Alle Variante",
            remove_all_slots_confirm: {
              title: "",
              message: "",
              confirm: "",
            },
            remove_single_slot_confirm: {
              title: "",
              message: "",
              select_all_slots: "",
              confirm: "",
            },
            remove_booked_slot_alert: {
              message: "",
              go_to_slot_view: "",
            },
            remove_slot_confirm: {
              title: "",
              message: "",
              confirm: "",
            },
            edit_all_slots_confirm: {
              title: "",
              message: "",
              confirm: "",
            },
            edit_single_slot_confirm: {
              title: "",
              message: "",
              select_all_slots: "",
              confirm: "",
            },
            add_slot: "Termin hinzufügen",
            add_many_slots: "",
            select_first_slot_date: "",
            select_slot_date: "",
            prices_title: "Preisliste",
            no_prices_message: "",
            availability_title: "Verfügbarkeit",
            hint: {
              p1: "Bevor Sie mit dem Hinzufügen von Daten zu Ihrem Angebot beginnen, ändern Sie bitte die Standardpreise und Buchungseinstellungen für dieses Angebot.",
              p2: "Termin hinzufügen",
              p3: "Um ein Datum hinzuzufügen, wählen Sie einfach ein Datum im Kalender aus, passen Sie die Optionen an und speichern Sie die Änderungen.",
              p4: "Fügen Sie mehrere Daten hinzu",
              p5: "Verwenden Sie die Wiederholungsoption, um mehrere Daten hinzuzufügen.",
            },
            normal_start_dates_assignation_type: "gewählt",
            recursion_start_dates_assignation_type: "regelmäßig",
            edit_slot: "Termin bearbeiten",
            repeat_on_days: "An Tagen wiederholen",
            repeat_until: "Wiederholen bis",
            repeat_in_hours: "Wiederhole in Stunden",
            repeat_slot: "Datum wiederholen",
          },
          StepBookingSettings: {
            already_used_stock: "",
            nb_stock_useby_date_label: "",
            nb_dont_require_company_approval_label: "",
            slots_will_be_removed_warning: "",
            form_title: "Buchungseinstellungen",
            static_date_booking_label: "",
            global_settings: "",
            default_settings: "",
            hint: {
              p1: "Wählen Sie aus, ob Ihr Angebot eine Datumsbuchung im Kalender enthält oder ob es sich um ein Angebot ohne Reservierung handelt, z. ein Gutschein oder ein Gutschein, der unter bestimmten Bedingungen verwendet werden kann.",
              p2: "Standardverfügbarkeitslimit / Angebotslimit",
              p3: "Dies ist der Standardwert für jedes neue Datum, das im Kalender hinzugefügt wird. Bei Angeboten ohne Reservierung ist dies das Angebotslimit.",
              p4: "Standardbuchungseinstellungen",
              p5: "Entscheiden Sie, ob Sie eine direkte Buchung akzeptieren, die keine Bestätigung erfordert, oder bevorzugen Sie die volle Kontrolle über Ihre Bestellungen, und Sie werden jede Bestellung einzeln bestätigen.",
              p6: "Realisierungsdatum",
              p7: "Im Falle eines Gutscheins können Sie auch einen Datumsbereich festlegen, wenn er verwendet werden kann.",
            },
            enable_frontend_slots_listing_label: "Zeige Kundentermine in einer Liste anstelle eines Kalenders",
            expire_at_label: "Haltbarkeitsdatum",
            availability_limit_label: "",
          },
          StepCustomerFields: {
            customer_fields: "",
            participant_fields: "",
            hint: {
              p1: "Formularfeld buchen",
              p2: "Wählen Sie aus, welche Felder den Kunden bei der Bestellung angezeigt werden. Sie können für jedes Feld festlegen, ob es ausgefüllt werden soll und ob es in der Teilnehmerliste angezeigt werden soll.",
            },
          },
          ProductVariantMigrateModal: {
            copy_description_label: "Beschreibung",
            copy_pricelist_label: "Preise",
            copy_payments_label: "Bezahlungen",
            copy_booking_settings_label: "",
            copy_pickup_points_label: "Treffpunkt",
            copy_priced_fields_label: "Zusatzoptionen",
            copy_customer_fields_label: "",
            copy_description_hint: "",
            copy_pricelist_hint: "",
            copy_payments_hint: "",
            copy_booking_settings_hint: "",
            copy_pickup_points_hint: "",
            copy_priced_fields_hint: "",
            copy_customer_fields_hint: "",
            title: "",
            source_variant: "",
            target_variant: "",
            copy_label: "",
            submit: "",
          },
          StepDescription: {
            remove_variant: "",
            migrate_data_from_other_product: "",
            new_variant_default_name: "",
            add_variant_message: "",
            add_variant_message_link: "Fügen Sie eine weitere Angebotsvariante hinzu",
            hint: {
              p1: "Angebotsname",
              p2: "Identifizieren Sie Ihr Angebot klar, damit die Kunden von Anfang an wissen, was sie sehen.",
              p3: "Höhepunkte",
              p4: "Was ist in Ihrem Angebot am wichtigsten? Ermutigen Sie Ihre Kunden!",
              p5: "Beschreibung",
              p6: "Beschreiben Sie Ihr Angebot genau und übersichtlich: Je genauer Sie es tun, desto weniger Zweifel haben Kunden und desto schneller entscheidet er oder sie, Ihr Produkt zu bestellen. Verwenden Sie Überschriften und Textstile, die die wichtigsten Aspekte hervorheben. Wenn Sie Kunden aus verschiedenen Ländern haben, fügen Sie weitere Sprachversionen des Angebots hinzu.",
              p7: "Preis inkludiert / Preis inkludiert nicht",
              p8: "Beschreiben Sie, was enthalten ist und nicht im Preis enthalten ist und wie hoch die zusätzlichen Preise sind.",
              p9: "Bedingungen",
              p10: "Fügen Sie spezielle Bedingungen hinzu, die Kunden erfüllen müssen, um am Angebot teilzunehmen.",
              p11: "Tipps",
              p12: "Fügen Sie Tipps für den Kunden hinzu, damit er sich auf die Teilnahme vorbereiten kann.",
              p13: "Angebotsvariante",
              p14: "Wenn Sie ähnliche Touren anbieten, die sich nur geringfügig unterscheiden, können Sie Varianten derselben Tour erstellen. Darüber hinaus können Sie bestimmte Einstellungen aus einem anderen Angebot oder einer anderen Variante kopieren.",
            },
          },
          StepLocation: {
            main_location_label: "",
            other_locations_label: "",
            new_pickup_point_title: "Neuer Treffpunkt",
            edit_pickup_point_title: "",
            remove_pickup_point: "",
            add_new_pickup_point: "",
            locations_title: "Angebotsort",
            pickup_points_title: "Treffpunkte",
            pickup_point_assignation_per_person_label: "",
            additional_settings: "Andere Einstellungen",
            hint: {
              p1: "Angebotsort",
              p2: "Legen Sie den Hauptstandort Ihres Angebots und weitere damit verknüpfte Punkte fest.",
              p3: "Haben Sie bereits eine Karte auf Google Maps erstellt? Fügen Sie den Code ein, um ihn im Angebot anzuzeigen.",
              p4: "Treffpunkt",
              p5: "Fügen Sie einen Treffpunkt hinzu, indem Sie die Adresse, Abfahrts- und Ankunftszeiten sowie zusätzliche Gebühren angeben. Sie können Anweisungen hinzufügen und Ihren Standort auf der Karte korrigieren, damit Ihr Kunde den Treffpunkt leicht erreichen kann.",
              p6: "Entscheiden Sie, ob der Kunde einen Treffpunkt für die gesamte Bestellung auswählt oder ob jeder Teilnehmer seinen eigenen Treffpunkt auswählen kann.",
              p7: 'Der Kunde kann bei der Buchung nicht immer einen Treffpunkt angeben. Entscheiden Sie, ob Sie dem Kunden erlauben, "Ich weiß es noch nicht" zu beantworten.',
              p8: "Wenn Sie vom Hotel oder einem anderen Kunden abgeholt werden, werden Sie gebeten, ihren Standort anzugeben.",
              p9: "Richtungen",
              p10: "Sie können hier Anweisungen geben, wie Sie zu Ihrem Standort gelangen oder den Kundenabholbereich festlegen.",
            },
            pickup_points_price_per_person_label: "Laden Sie die Treffpunktgebühr von jeder Person separat auf",
            custom_pickup_point_name: "Kundenadresse",
            no_pickup_point_name: "Unspezifieziertes Ort",
          },
          StepPayments: {
            supplier_profiles_title: "",
            marketplace_profiles_title: "",
            add_new_payment_profile: "",
            form_title: "",
            hint: {
              p1: "Bezahlungsprofile",
              p2: "Bestimmen Sie, wie Ihre Kunden für Ihr Angebot bezahlen können. Bestimmen Sie die Anzahl und den Betrag der Raten, die Zahlungsart und die Stornierungsbedingungen.",
              p3: "Wählen Sie Profile für Ihre bereits erstellten Kunden aus oder fügen Sie neue hinzu.",
              p4: "Wählen Sie Profile für Tripsomnia-Kunden aus bereits erstellten oder kontaktieren Sie uns, um Ihre Zusammenarbeit zu anderen Bedingungen anzupassen.",
            },
            no_supplier_profiles_warning:
              "Wir empfehlen, in diesem Kanal mindestens ein Zahlungsprofil für Ihr Angebot zu aktivieren. Andernfalls können Ihre Kunden keine Buchungen für dieses Angebot auf Ihrer Website aufgeben.",
            no_marketplace_profiles_warning:
              "Wir empfehlen, in diesem Kanal mindestens ein Zahlungsprofil für Ihr Angebot zu aktivieren. Andernfalls können Ihre Kunden keine Buchungen für dieses Angebot auf Tripsomnia.com aufgeben.",
            access_temporarily_enabled_only_for_supplier:
              "Eine Vorschau der verfügbaren Zahlungsprofile für dieses Angebot ist derzeit nur für den Anbieter verfügbar. Wenn Sie wissen möchten, welche Zahlungsprofile für dieses Angebot verfügbar sind, wenden Sie sich an Ihren Lieferanten.",
          },
          StepPhotos: {
            cover_photo: "",
            name_placeholder: "Name eingeben",
            form_title: "",
            click_or_drag_and_drop_to_add_photos: "",
            add_video: "",
            add_video_submit: "Hinzufügen",
            hint: {
              p1: "Fügen Sie interessante Fotos hinzu, die Ihre Kunden davon überzeugen, genau Ihr Angebot zu nutzen. Sie können jedes Foto signieren und auch einen Link zum Video hinzufügen. Alle Materialien können durch Ziehen ihrer Miniaturbilder in beliebiger Reihenfolge angeordnet werden.",
              p2: "Stellen Sie sicher, dass Sie nur Materialien verwenden, für die Sie Urheberrechte besitzen oder die im Rahmen einer offenen Lizenz zur kommerziellen Wiederverwendung freigegeben sind.",
            },
          },
          StepPricedFields: {
            form_title: "Zusatzoptionen",
            add_new_field: "",
            hint: {
              p1: "Konfigurieren Sie zusätzliche Optionen für Kunden",
              p2a: "Checkbox",
              p2b: "Der Kunde wählt die Option Ja oder Nein.",
              p3a: "Auswahlliste",
              p3b: "Kunde wählt eine Position aus der Liste aus.",
              p4a: "Nummer",
              p4b: "Der Kunde wählt eine Nummer aus dem angegebenen Bereich.",
              p5: "Entscheiden Sie, ob die Frage einmal für den gesamten Auftrag oder separat für jeden Teilnehmer gestellt werden soll.",
              p6: "Teilnehmerliste",
              p7: "Entscheiden Sie, ob das Feld in der Teilnehmerliste angezeigt wird.",
              p8: "Musst ausgefüllt werden",
              p9: "Entscheiden Sie, ob der Kunde das Feld ausfüllen muss, um eine Bestellung aufzugeben",
            },
          },
          StepPricelist: {
            form_title: "Preise",
            hint: {
              p1: "Sie müssen eine von drei Arten von Preisen wählen:",
              p2: "Preis pro Person",
              p3: "Erstellen Sie eine Standardpreisliste für Erwachsene, Kinder und Senioren unter Angabe von Altersgrenzen. Sie können auch eine Preisliste für eine Gruppe oder eine Familie hinzufügen, indem Sie Teilnehmerlimits festlegen oder eine eigene Kategorie erstellen. Für jede Preislistenposition können Sie eine Mindest- und Höchstanzahl der zu kaufenden Einheiten festlegen (z.B. mind. 3 Tickets). Hinweis: Personenlimits und Stücklimits können nicht gleichzeitig gesetzt werden.",
              p4: "Preis pro Paket",
              p5: "Sie können Pakete für eine begrenzte Anzahl von Personen anbieten, z. B. ein Wasserfahrrad für 1-4 Personen.",
              p6: "Preis pro Buchung",
              p7: "Legen Sie einen festen Preis für die Bestellung fest, unabhängig von der Anzahl der Teilnehmer, z. B. Preis pro Anmietung einer Yacht.",
            },
            persons_count: "Pax",
            persons_count_from: "Pax aus",
            age_from: "Alter ab",
            person_category_name: "Kategoriename",
            add_new_item: "Neues Paket hinzufügen",
            item_name: "Paketnamen",
            coupon_code_name: "Gutscheincode",
            new_coupon_code_name: "Neuer Gutscheincode",
            add_new_coupon: "Neuen Gutschein hinzufügen",
            coupon_codes_title: "Gutscheincodes",
            coupon_codes_description:
              "Wenn Sie möchten, dass wir einen bestimmten Gutscheincode an Kunden in dem Coupon senden, den sie herunterladen, geben Sie die Codes unten an.",
            coupon_code_realisation_place_type_label: "Wo können Sie den Gutscheincode realisieren?",
            coupon_codes_realisation_place_online_website:
              "in der Online-Website (zB über einen E-Commerce-Shop Warenkorb)",
            coupon_codes_realisation_place_manually: "manuell (per Telefon oder E-Mail)",
            coupon_codes_realisation_place_custom: "maßgeschneidert",
            coupon_code_realisation_place_custom_description_placeholder:
              "Geben Sie an, wie und wo man den Gutscheincode realisieren kann",
            generate_coupon_codes: "Generieren Sie zufällige Gutscheincodes",
            saas_featured_price: "",
          },
          menu: {
            description: "Beschreibung",
            add_locale: "Sprache hinzufügen / löschen",
            translate: "Übersetzen",
            translate_modal: {
              title: "Angebot übersetzen",
              explanation: "Um das Angebot zu übersetzen, fügen Sie die Zielsprache im Menü links über die Schaltfläche 'Übersetzen' hinzu und speichern Sie die Änderungen.",
              select_source_locale: "Ausgangssprache wählen",
              select_locale: "Zielsprache auswählen",
              submit: "Übersetzen",
            },
            pricelist: "Zeitplan und Preise",
            availability: "Verfügbarkeit",
            prices: "Preise",
            payments: "Bezahlungen",
            booking_settings: "Buchungseinstellungen",
            photos: "Bilder",
            location: "",
            priced_fields: "Zusatzoptionen",
            customer_fields: "",
            additional_settings: "",
            title: "",
            accommodation_settings: "",
            integrations: ""
          },
          common: {
            remove_confirm_message: "",
            orders_button: "Buchungen",
            preview_st: "Vorschau",
            preview_saas: "WWW",
            save_success_message: "",
            remove_success_message: "Angebot ist annuliert geworden.",
            add_photos_success_message: "",
          },
          StepAccommodationSettings: {
            form_title: "",
            accommodation_settings: {
              category: "",
              categoryOption: {
                one_person_room: "",
                two_person_room: "",
                three_person_room: "",
                four_person_room: "",
                multi_person_room: "",
                bed_in_multi_person_room: "",
                apartment: "",
                cottage: "",
                villa: "",
                holiday_house: "",
                tent: "",
              },
              categoryTitle: {
                room: "",
                bathroom: "",
                view: "",
                food_and_drinks: "",
              },
              categoryDescription: "",
            },
            default_total_stock_limit: "",
            accommodation_detail: {
              single_beds_count: "",
              double_beds_count: "",
              extra_beds_count: "",
              bathrooms_count: "",
              rooms_count: "",
              area: "",
            },
            presented_price: "",
            accommodationUnitSettings: "",
            facilities: "",
            accommodationUnitSettingsDescription: "",
            facilitiesDescription: "",
          },
          StepIntegrations: {
            log_integration_date: "Date",
            log_integration_action: "Action",
            log_integration_company_id: "Company ID",
            log_integration_uuid: "Task UUID",
            filter_all_logs: "",
            filter_succeeded: "",
            filter_all_failed: ""
          }
        },
        ManageLocalesPrompt: {
          title: "",
          select_locale: "Sprache auswählen",
        },
        NewProductPrompt: {
          title: "Neues Angebot",
          name_placeholder: "Angebotsname eingeben",
          submit: "Angebot hinfügen",
          coupon_label: "Es ist ein Gutscheinangebot",
          offer_type_header: "",
          offer_type_standard_header: "",
          offer_type_standard_description: "",
          offer_type_coupon_header: "",
          offer_type_coupon_description: "",
          offer_type_ticket_header: "",
          offer_type_ticket_description: "",
          offer_type_voucher_header: "",
          offer_type_voucher_description: "",
          offer_type_accommodation_header: "",
          offer_type_accommodation_description: "",
        },
        ProductsListView: {
          products: "Angebote",
          settings: "Einstellungen",
          add_new_product: "Neues Angebot",
          no_products_message: "",
          no_products_message_link: "",
          no_products_title: "",
          search_top_bar: "",
        },
        StepAdditional: {
          hide_description_for_variants: "",
        },
      },
      reviews: {
        ReviewsListView: {
          no_records_message: "Keiner Ihrer Kunden hat Ihnen noch eine Rezension gegeben.",
          no_records_title: "Keine rezensionen",
          title: "Rezensionen",
        },
        EditReviewModal: {
          title: "Rezension",
          remove_confirm_message: "Möchten Sie diese Rezension wirklich löschen?",
        },
      },
      affiliate: {
        AffiliateListView: {
          no_records_message: "Noch keine Bestellungen.",
          no_records_title: "Keine Buchungen.",
          summary_row: "Insgesamt (für Zeilen %{start}-%{end}):",
          title: "Partnerprogramm - Buchungsstatistiken",
        },
      },
      suppliers: {
        NewSupplierPrompt: {
          email_label: "",
        },
      },
      pagination: {
        show_10: "",
        show_20: "",
        show_30: "",
        show_50: "",
        show_100: "",
      },
      accommodation: {
        AccommodationSchedulerView: {
          title: "",
          calendarLink: "",
          noProductsInfo: "",
          availabilityTypes: {
            available_with_instant_booking: "",
            available_with_company_approval: "",
            no_changes: "",
          },
          productsHeader: "",
          pricingPlansHeader: "",
          availabilityTypeHeader: "",
          datesHeader: "",
          hintHeader: "",
          hintContent: "",
          errors: {
            maxDatesDifference: "",
            daysNotIncluded: "",
          },
          totalStockLimit: "",
        },
        AccommodationCalendarView: {
          title: "",
          schedulerLink: "",
        },
        Accommodation: {
          totalStockLeftTypes: {
            noChanges: "",
            unavailable: "",
            specified: "",
          },
        },
      },
    },
    st: {
      pricelist_order_installment_item: {
        paid_by_cash: "mit Bargeld",
        paid_by_online_payment: "online",
        paid_by_bank_wire: "mit Überweisung",
        already_paid: "Bezahlt %{paid_by}",
        to_be_paid_right_now: "Jetzt bezahlen ",
        to_be_paid_right_after_company_approval: "",
        to_be_paid_on_spot: "%{paid_by} vor Ort bezahlen",
        to_be_paid_until: "%{paid_by} vor %{date} bezahlen",
        to_be_paid_after_previous_installment: "%{paid_by} bis %{date} nach der Erste Rate bezahlen",
        to_be_paid_now: "Jetzt %{paid_by} bezahlen",
        to_be_paid_after_order_creation: "%{paid_by} bis %{date} nach Bestellung bezahlen",
        to_be_paid_after_company_approval: "%{paid_by} bis %{date} nachdem die Firma die Buchung bestätigt bezahlen",
        to_be_paid_after_approval: "%{paid_by} bis %{date} nach der Bestätigung bezahlen",
        to_be_paid_before_stock_start_date: "",
        in_your_currency_it_is: "",
        payment_accepted_in_website_currency: "Währung",
        payment_accepted_in_company_currency: "Währung",
        payments_are_converted_with_following_rates: "",
        your_bank_can_issue_an_additional_fee_for_the_transaction: "",
        to_supplier: "Lieferanten",
        to_agent: "Agent",
        to_socialtravel: "An Tripsomnia",
        paid_by_dotpay: "mit DotPay",
        paid_by_paypal: "mit PayPal",
        marketplace_bank_wire_transfer_title: "Tripsomnia Buchung Nr. %{order_id}",
        saas_bank_wire_transfer_title: "Buchung Nr. %{order_id}",
        bank_wire_transfer_details:
          'Bankleitungskonto Beschreibung: %{account_description}. Überweisungstitel: "%{transfer_title}"',
        paid_by_payu: "mit PayU",
        paid_by_stripe: "",
        paid_by_terminal: "",
      },
      app_config: {
        saas_service_fee_name: "Transaktionsgebühr",
        site_short_description:
          "Buchen Sie online lokale Touren und Touristenattraktionen aus der ganzen Welt! Unterkünfte Ausflüge Sehenswürdigkeiten in 1 Ort. Die interessantesten touristischen Angebote.",
        pdf_voucher_st_address_details: "Steuernummer: 1132941467; Al. Ks. J. Poniatowskiego 1, 03-901 Warsaw, Poland",
        tripsomnia_company_name: "Tripsomnia",
        tripsomnia_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_full_address:
          "Buchungsplattform Tripsomnia - A SocialTravel Company\nSteuernummer: 1132941467\nAl. Ks. J. Poniatowskiego 1\n03-901 Warsaw, Poland",
        tripsomnia_service_fee_name: "Tripsomnia Servicegebühr",
        agent_service_fee_name: "Servicegebühr des Agenten",
        socialtravel_company_name: "SocialTravel",
        socialtravel_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_opening_hours: "Montag - Freitag 9:00 - 17:00",
        socialtravel_service_fee_name: "Tripsomnia Servicegebühr",
        socialtravel_contact_phone_number: "+48 690 670 581",
        tripsomnia_contact_phone_number: "+48 690 670 581",
      },
      create_agent_disbursement: {
        no_orders_error: "Es wurden keine Bestellungen ausgewählt.",
        no_order_agent_error: "Für einen der ausgewählten Aufträge ist kein Agent definiert.",
        incorrect_order_company_error: "Alle Buchungen müssen denselben Lieferanten und Agenten haben.",
      },
    },
    countries: {
      pl: "Polen",
    },
    customer_mailer: {
      order_marketing_info: {
        subject: "",
      },
      reset_password: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
    },
    product_request_mailer: {
      customer_requested_discount_company_email: {
        hello_company: "",
        content: {
          line1: "",
          line2: "",
          line3: "",
        },
        details_header: "",
        customer_details_header: "",
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "",
      },
      customer_requested_discount: {
        content: {
          line1: "",
        },
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "",
      },
      customer_requested_product: {
        subject: "",
      },
      customer_requested_product_company_email: {
        content: {
          line1: "",
          line2: "",
          line3: "",
        },
        customer_details_header: "",
        details_header_html: '<a href="%{product_link}">%{product_name}</a>',
        hello_company: "",
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "",
      },
    },
    pl: {
      papp: {
        settings: {
          StripeSettingsView: {
            stripe_login_button: "",
            stripe_register_button: "",
          },
        },
      },
    },
    ordered_item: {
      accommodation: {
        name: {
          one: "",
          few: "",
          many: "",
          other: "",
        },
      },
      product: {
        name: "",
      },
    },
    en: {
      activerecord: {
        attributes: {
          pricing_plan: {
            preset: {
              elastic: {
                company_description: "",
                customer_description: "",
              },
              not_refundable: {
                company_description: "",
                customer_description: "",
              },
            },
          },
        },
      },
    },
  })),
  (I18n.translations.es = I18n.extend(I18n.translations.es || {}, {
    active_admin: {
      action_impossible: "La operacion no es posible",
      action_success: "Operación exitosa.",
      actual_at_x: "datos para %{datetime}",
      add_tag_batch_action: {
        add_success: 'La etiqueta "%{name}" se eliminó de los registros seleccionados.',
        remove_instead: "Eliminar la etiqueta de los registros seleccionados?\n(instead of adding)",
        remove_success: 'La etiqueta "%{name}" ha sido añadida a los registros \nseleccionados.',
      },
      basic_details: "Información basica",
      batch_actions: {
        button_label: "Acciones de registro multiple",
        labels: {
          add_category: "Asignar categoria a",
          add_location: "Asignar localización a",
          add_product_st_tag: "Asignar la etiqueta tripsomia a ",
          add_tag: "Asigna una etiqueta a ",
          v1_st_balance_company_debt: "Liquidar cuentas con la empresa",
          add_admin_user: "Asignar un usuario administrador a",
          add_payment_profile: "",
          remove_payment_profile: "",
        },
      },
      company_edit: {
        possible_to_edit_only_by_global_admin: "Solo puede ser eliminado por el administrador.",
      },
      company_registrations: {
        approve: "Confirmar",
        reject: "Rechazar",
      },
      company_submit_monthly_invoicing_stats: {
        success: "Los pedidos han sido liquidados.",
      },
      content_details: "Contenidos",
      dashboard: "Tablero",
      dashboard_page: {
        approved_orders: {
          title: "Ordenes confirmadas",
        },
        search_orders: {
          submit: "Buscar",
          title: "Buscar pedidos",
        },
        summary: {
          title: "Resumen",
        },
        upcoming_orders: {
          title: "Proximos pedidos",
        },
        waiting_for_company_approval_orders: {
          title: "Pedidos esperando la confirmación de la Compañía",
        },
        waiting_for_customer_approval_orders: {
          title: "Pedidos esperando la confirmación del cliente",
        },
      },
      default_menu: {
        add_new: "Añadir nuevo",
        new_admin_company: "Nueva compañia",
        new_admin_product_tag: "Nueva etiqueta de producto",
        new_admin_product_tags_category: "Nueva categoría de etiquetas de producto",
        others: "Otros",
        users: "Usuarios",
      },
      delete_file: "Eliminar archivo",
      devise: {
        email: {
          title: "Direccion de correo electronico",
        },
        links: {
          resend_unlock_instructions: "Desbloquear la cuenta",
        },
        password: {
          title: "Contraseña",
        },
        reset_password: {
          submit: "Reestablece tu contraseña",
        },
        unlock: {
          submit: "Enviar instrucciones de desbloqueo",
          title: "Desbloquear la cuenta",
        },
      },
      globalize: {
        language: {
          pl: "Polaco",
          en: "Ingles",
          ru: "Ruso",
        },
        translations: "Traductores",
      },
      go_back: "Volver",
      monthly_invoicing_stats: "Liquidación mensual de pedidos",
      order_actions: {
        action_failed_error: "Una acción no tuvo éxito debido al error: %{error}",
        approve: "Confirme su pedido",
        cancel: "Cancele su pedido",
        confirm: "Envie su pedido",
        finish: "Finalice su orden",
        redeliver_customer_order_email: "Reenviar el correo electrónico sobre el pedido al cliente",
        reject: "Rechazar el pedido",
        successfully_approved: "El pedido %{id} ha sido confirmado.",
        successfully_cancelled: "El pedido %{id} ha sido cancelado.",
        successfully_confirmed: "El pedido %{id} ha sido enviado.",
        successfully_finished: 'La orden %{id} ha sido marcada como "finalizada".',
        successfully_redelivered_customer_order_email:
          "El correo electrónico relacionado con el pedido se reenvió al Cliente a su dirección de correo electrónico %{customer_email}",
        successfully_rejected: "La orden %{id} ha sido rechazada. ",
        view_stats: "Estadisticas de epdidos",
        redeliver_supplier_order_email: "Enviar correo elctronico al prooverdor",
        successfully_redelivered_supplier_order_email:
          "El correo electrónico sobre el pedido se envió nuevamente al Proveedor a la siguiente dirección de correo electrónico %{customer_email}.",
      },
      order_edit: {
        order_not_yet_confirmed_error:
          "Este pedido aún no ha sido completado por el cliente. La edición desde el panel de administración no es posible en este momento.",
      },
      order_show: {
        activities: {
          email_message_email: "Direccion de correo electronico",
          email_message_subject: "Tema del mensaje",
          order_status_updated_action: "Acción",
          order_status_updated_content: "Cambio de estado a %{status}",
          sms_message_content: "Contenido de SMS",
          sms_message_phone_number: "Numero de telefono",
          title: "Historia de pedidos",
        },
      },
      order_show_company_invoice: {
        invoice_retrieval_error: "Se produjo un error al descargar una factura .pdf desde iFirma:% {error}",
      },
      order_show_customer_invoice: {
        invoice_retrieval_error: "Se produjo un error al descargar una factura .pdf desde iFirma:% {error}",
      },
      order_v1_st_balance_company_debt: {
        success: "Pedido nr. %{id} se ha liquidado con la empresa",
      },
      orders_stats: {
        average_orders_value_th: "Cantidad promedio de pedidos de X",
        in_average_th: "Promedio X",
        in_total_th: "Total X",
        name_th: "Nombre X",
        orders_count_th: "Numero de pedidos de X",
        title: "Estadísticas de pedidos",
        total_orders_value_th: "cantidad total de pedidos de",
      },
      orders_v1_st_balance_company_debt: {
        success: "El orden seleccionado ha sido resuelto.",
      },
      preview: "Avance",
      product_tags_index: {
        tag_stats: "%{products_count} etiquetado, %{all_products_count} en total",
      },
      products_index: {
        batch_action_add_product_tag: {
          add_success: 'Se seleccionó una etiqueta "%{name}" para las ofertas elegidas.',
          remove_instead: "¿Desea eliminar una etiqueta de las ofertas elegidas? (instead of adding it)",
          remove_success: 'Se eliminó una etiqueta "%{name}" de las ofertas elegidas.',
        },
      },
      scopes: {
        abandoned: "Abandonado",
        all: "Todo",
        approved: "Confirmado",
        approved_finished_short: "Conf./ done.",
        building: "Borrador",
        cancelled: "Cancelado",
        category: "Categorias",
        company_tag: "Etiquetas de la compañia",
        customer_tag: "Etiquetas del cliente",
        deprecated_v1_accomodation: "Alojamientos",
        deprecated_v1_coupon: "Vouchers / Descuentos",
        deprecated_v1_special_offer: "Ofertas especiales",
        deprecated_v1_trip: "Tures",
        finished: "Finalizado.",
        future_customers: "Futuro",
        location: "Localizaciones",
        lost_customers: "Perdido",
        marketplace: "Mercado",
        order_tag: "Ordenar etiquetas",
        past_customers: "Pasado",
        product_st_tag: "Etiquetas ST",
        prospect_customers: "Potencial",
        rejected: "Rechazados",
        saas: "SaaS",
        waiting_for_company_approval: "Esperando la confirmación de la compañia",
        waiting_for_customer_approval: "Esperando la confirmación del cleinte",
        product_company_tag: "Etiquetas de la compañia",
      },
      search_status: {
        current_filters: "Filtros actuales:",
        current_scope: "Rangos actuales:",
        headline: "Alcance:",
        no_current_filters: "Ninguna",
      },
      sidebars: {
        relation_no_results: "Sin resultados.",
      },
      successfully_created: "%{model} ha sido creado exitosamente.",
      successfully_updated: "%{model} ha sido  exitosaactualizado exitosamente.",
      tabs: {
        availability: "Disponibilidad",
        base_details: "Informacion basica",
        description: "Descripción",
        images: "Fotos",
        invoicing: "Acuerdos",
        location: "Localización",
        other_details: "Otros ajustes",
        pricelists: "Lista de precios",
        product_order_fields: "Opciones adicionales",
        product_variants: "Variantes",
      },
      widgets: "Widgets",
      wrong_lock_version_error:
        "Mientras tanto, alguien cambia este registro %{resource_name}. Abre el formulario en una nueva pestaña y realiza los cambios nuevamente.",
      location_details: "Localización",
      companies: {
        destroy: {
          action_impossible_company_has_orders_as_supplier:
            "Eliminar esta empresa es imposible: tiene pedidos como proveedor. Eliminar sus pedidos primero para eliminar la empresa.",
        },
      },
      pp_edit: "Editar en PP",
      add_admin_user_batch_action: {
        remove_instead: "Borre el usuario de las compañias seleccionadas\n(instead of adding)",
        success: "Operación exitosa.",
      },
      add_payment_profile_action: {
        success: "",
      },
      pricing_plans: {
        new_elastic_plan: "",
        new_not_refundable_plan: "",
      },
      remove_payment_profile_action: {
        success: "",
      },
    },
    fe: {
      active_admin: {
        view_collection_item_nested_form: {
          toggle_show: "Mostrar / Ocultar sus atributos personalizados",
        },
      },
      ckeditor: {
        subsection_expand: {
          content:
            "El contenido de la sección que estará oculto por defecto y el usuario podrá mostrarlo simplemente haciendo clic en el título.",
          title: "Sección de título",
        },
        subsection_read_more: {
          content: 'El contenido de la sección que se acortará al enlace "Leer más", si es demasiado largo.',
          title: "Sección de título",
        },
      },
      NewOrderCalendarForm: {
        help_tip: "Leyenda (pasa el cursor del ratón)",
        product_chosen: "Has elegido la oferta %{name} en el día %{date_range}.",
        stock_available: "Fecha disponible",
        stock_available_but_impossible_as_end: "Fecha disponible pero no es posible acabar su estancia en este día",
        stock_available_but_impossible_as_start: "Fecha disponible pero no es posible empezar su estancia en este día",
        stock_busy: "Fecha no disponible",
        stock_discounted: "Precio especial",
        submit: "Siguiente",
        previous_slots: "Fechas anteriores",
        next_slots: "Próximas fechas",
        stock_confirmed: "Fecha confirmada",
      },
      NewOrderConfirmPricingForm: {
        submit: "Siguiente",
      },
      NewOrderCustomerDetailsForm: {
        order_with_payment_requirement: "prereserva con la obligación de pagar",
        participant_name_with_number: "Participante núm. %{i}",
        required_fields: "campo requerido",
        submit: {
          make_order: "Reservar",
          next: "Siguiente",
        },
      },
      NewOrderPaymentForm: {
        almost_booked: "¡Enhorabuena! ¡En un minuto completará su prereserva!",
        almost_finished: "¡Enhorabuena! ¡En un minuto completará su prereserva!",
        cancelled_if_not_paid:
          "En caso de que no se realice pago dentro del plazo previsto, su prereserva se rechazará automáticamente.",
        dotpay_go_back_button: "Volver al formulario de la reserva",
        order_with_payment_requirement: "prereserva con la obligación de pagar",
        pay_to_book: {
          marketplace:
            "En cuanto pague %{confirmation_installment_transaction_amount} a través del sistema de pagos seguros en línea, el organizador podrá confirmar su prereserva.",
          saas: "En cuanto pague %{confirmation_installment_transaction_amount}, recibiremos su prereserva y podremos confirmarla.",
        },
        pay_to_finish:
          "En cuanto pague %{confirmation_installment_transaction_amount}, le enviaremos automáticamente un vale en pdf con los datos de su prereserva.",
        payment_deadline: "Plazo de pago: %{pauses_at}.",
        please_pay_online_deposit:
          "Por favor, realice el pago por la cantidad de %{confirmation_installment_transaction_amount} a través de nuestro sistema de pagos en línea seguro.",
        safe_payments_guaranteed_by: "Pagos seguros garantizados por",
        submit: {
          book_and_pay: "Reservar y pagar ahora %{price}",
          pay: "Pagar ahora %{price}",
          pay_with_dotpay: "Pagar %{price} por DotPay",
          pay_with_paypal: "Pagar %{price} por PayPal",
        },
        choose_payment_method: "Elija el método de pago:",
        pay_by_bank_wire: "transferencia bancaria",
        pay_by_credit_card:
          "Pague con tarjeta (sin necesidad de crear una cuenta de Paypal) o inicie sesión y efectue el pago por Paypal.",
        by_bank_wire: "transferencia bancaria",
        by_credit_card:
          "Pague con tarjeta (sin necesidad de crear una cuenta de Paypal) o inicie sesión en su cuenta de PayPal y efectue el pago.",
        by_bank_wire_or_credit_card: "Pague con tarjeta de crédito o por transferencia bancaria.",
        by_paypal: "Inicie sesión en su cuenta de PayPal para efectuar el pago.",
        pay_by_credit_card_or_paypal:
          "Pague con tarjeta (sin necesidad de crear una cuenta de Paypal) o inicie sesión en su cuenta de PayPal y efectua el pago.",
        by_payu: "Pagar con tarjeta de débito o crédito",
        payu_button: "Pagar con PayU",
      },
      NewOrderProductForm: {
        choose_payment_profile: "Elija el método de pago",
        items_count: "Número %{items}",
        multiple_pricings_alert:
          'Nota: Debido a los límites de fechas y ventas, no se puede liquidar todos %{product_quantity} %{items} basándose en la lista de precios "%{product_pricelist_name}".',
        multiple_pricings_info: "En lugar de eso, la combinación que ha seleccionado se liquidará de manera siguiente:",
        custom_location_name_placeholder:
          "Proporcione la dirección de donde te gustaría que le recogiera el organizador",
        submit: "Siguiente",
      },
      NewOrderView: {
        building: "Estás haciendo una prereserva",
        built: "Has pedido",
        contact_us_if_problem_repeats: "Si el error vuelve a ocurrir, contáctenos: %{email}.",
        loading_failed:
          "Se ha producido un error al cargar los datos de la oferta. Refresque la página para intentar de nuevo.",
        loading_in_progress: "Cargando...",
        marketplace: {
          additional_bank_wire_deposit_required: "Esta prereserva requiere un pago adicional.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "La empresa %{company_link} recibirá su prereserva inmediatamente después de que se envíe. Tendrá %{company_approval_time_limit} para responderle, sin embargo, la mayoría de las empresas responde en una hora, durante el horario laboral local.",
          bank_wire_deposit_deadline_warning:
            "Acuérdese de hacer la transferencia a tiempo. Si no paga el adelantado a la cuenta en el plazo previsto, su prereserva se podrá cancelar.",
          bank_wire_deposit_details: "Datos de la transferancia bancaria",
          bank_wire_deposit_instructions:
            "En el título de la transferencia, ponga por favor solamente el número de la prereserva que está en esta confirmación. En caso contrario, no podemos garantizar que la transferencia sea liquidada a tiempo.",
          building: "Estás haciendo una prereserva",
          built: "Has pedido",
          company_approved_your_order_request:
            'La empresa %{company_link} ha confirmado su prereserva núm. %{order_id} de "%{product_name}".',
          company_received_your_order_request_and_has_to_approve_it:
            'La empresa %{company_link} ha recibidoo su prereserva núm. %{order_id} de "%{product_name}". Tiene %{company_approval_time_limit} para contestarte, sin embargo, la mayoría de las empresas responde en 1 hora durante el horario laboral local.',
          contact_us_if_problem_repeats: "Si el error vuelve a ocurrir, contáctenos: %{email}.",
          customer_full_name: "Nombre y apellido del contratante",
          download_order_data_confirmation: "Descarga la confirmación de la prereserva",
          further_details: "Más información ",
          if_no_online_payment_your_order_will_be_cancelled:
            "En caso de que no se realice el pago, su prereserva se cancelará.",
          loading_failed:
            "Se ha producido un error al cargar los datos de la oferta. Refresque la página para intentar de nuevo.",
          loading_in_progress: "Cargando los datos...",
          order_is_waiting_for_company_approval:
            "Su prereservaestá pendiente de la confirmación de la empresa %{company_link}.",
          order_name: "Prereserva núm. %{id}",
          order_status: "Estado de la reserva",
          please_pay_bank_wire_deposit: "Por favor, realice el pago por transferencia bancaria.",
          repeat_payment: "Repita el pago",
          share_us_to_friends:
            "¿Quieres conocer la ofertas más interesantes y las promociones especiales? ¡Danos Me gusta o compártelo!",
          thank_you_for_order: "¡Gracias por hacer la prereserva!",
          thank_you_for_order_and_share_to_fb:
            "¡Gracias por hacer la prereserva! ¡Apóyanos compartiendo esta oferta en Facebook!",
          thank_you_for_order_request: "Gracias por hacer la prereserva.",
          we_received_all_required_order_informations: "Hemos recibido toda la información necesaria.",
          we_received_all_required_order_informations_and_online_payment:
            "Hemos recibido toda la información necesaria, así como el pago en línea.",
          we_sended_order_confirmation_to_your_email:
            "Hemos enviado la confirmación de su reserva en pdf a su correo electrónico.",
          we_sended_order_request_confirmation_to_your_email:
            "Hemos enviado la confirmación de su prereserva en pdf a su correo electrónico.",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "Si su prereserva se confirma, el pago realizado será asignado a la reserva. Si la empresa %{company_link} rechaza la prereserva o no la confirma a tiempo, la cantidad de %{confirmation_installment_st_name} será automáticamente reembolsada a su cuenta bancaria en 24 horas.",
          when_company_approves_we_will_send_online_payment_email:
            "Si la empresa %{company_link} confirma su prereserva, recibirá un correo electrónico con el enlace para realizar el pago en línea por la cantidad de %{confirmation_installment_amount}. Tiene %{confirmation_installment_after_company_approval_time_limit} desde el momento en el que se confirme la prereserva para realizar la transferencia por Dotpay.",
          when_company_approves_we_will_send_order_confirmation:
            "Si la empresa %{company_link} confirma su prereserva, recibirá un correo electrónico con la confirmación. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "La empresa %{company_link} recibirá su prereserva inmediatamente después de que se envíe. Tendrá %{company_approval_time_limit} para responderle, sin embargo, la mayoría de las empresas responde en una hora durante el horario laboral local.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "Después de que se confirme el pago, recibirá un correo electrónico con la confirmación de su reserva. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "Puede descargar este archivo haciendo clic en el botón de abajo.",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "En la confirmación de la preseserva recibirá también información acerca del pago pendiente a la cuenta bancaria.",
          your_order_id: "Localizador se su prereserva",
          your_order_is_fully_confirmed: "Su reserva ya está confirmada.",
          online_payment_failed: "Desgraciadamente, su pago en línea no ha sido completado con éxito.",
          order_is_waiting_for_online_payment_info:
            "Ahora su prereserva está pendiente de información del pago realizado.",
        },
        order_name: "Prereserva núm. %{id}",
        saas: {
          additional_bank_wire_deposit_required: "Su prereserva requiere un pago adicional a la cuenta.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "En el momento de la realización del pago recibimos su prereserva. El tiempo estándar de respuesta es de %{company_approval_time_limit} horas pero durante el horario laboral normalmente respondemos en una hora.",
          bank_wire_deposit_deadline_warning:
            "Acuérdese de hacer la transferencia a tiempo. Si no paga el adelantado a la cuenta en el plazo previsto, su prereserva podrá cancelarse.",
          bank_wire_deposit_details: "Datos de transferencia bancaria",
          bank_wire_deposit_instructions:
            "En el título de la transferencia ponga, por favor, el localizador de la prereserva que está en esta confirmación. En caso contrario, no podemos garantizar que la transferencia sea liquidada a tiempo.",
          company_approved_your_order_request: 'Hemos confirmado su prereserva núm. %{order_id} de "%{product_name}".',
          company_received_your_order_request_and_has_to_approve_it:
            "Acabamos de recibir su prereserva. Tiempo estándar de respuesta es %{company_approval_time_limit} horas pero durante el horario laboral normalmente respondemos en una hora.",
          customer_full_name: "Nombre y apellido del cliente",
          download_order_data_confirmation: "Descargar la confirmación de la reserva",
          further_details: "Más detalles",
          if_no_online_payment_your_order_will_be_cancelled: "Si su pago no se recibe, su prereserva se cancelará.",
          order_is_waiting_for_company_approval: "Su reserva está pendiente de su aceptación.",
          order_status: "Estado de la prereserva",
          please_pay_bank_wire_deposit: "Por favor, pague por transferencia bancaria.",
          repeat_payment: "Repita el pago",
          thank_you_for_order: "¡Gracias por su reserva!",
          thank_you_for_order_request: "Gracias por su reserva.",
          we_received_all_required_order_informations: "Hemos recibido toda la información necesaria.",
          we_received_all_required_order_informations_and_online_payment:
            "Hemos recibido toda la información necesaria, así como el pago en línea.",
          we_sended_order_confirmation_to_your_email:
            "Hemos enviado la confirmación de la reserva en pdf a su correo electrónico.",
          we_sended_order_request_confirmation_to_your_email:
            "Hemos enviado la confirmación de la prereserva en pdf a su correo electrónico.",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "En caso de que nos veamos obligados a rechazar su prereserva o le dejemos expirar, el pago de %{confirmation_installment_st_name} en línea será automáticamente reembolsado a su cuenta bancaria en 24 horas. Podrá también ponerse en contacto con nosotros y elegir otra oferta.",
          when_company_approves_we_will_send_online_payment_email:
            "En caso de que se confirme su prereserva, recibirá un correo electrónico con un enlace para realizar el pago en línea por la cantidad de %{cconfirmation_installment_amount}. Tiene %{confirmation_installment_after_company_approval_time_limit} a partir del momento en que se confirme la prereserva para realizar el pago por Dotpay.",
          when_company_approves_we_will_send_order_confirmation:
            "En caso de que se confirme su prereserva, recibirá un correo electrónico con la confirmación. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "En el momento de la realización del pago recibiremos su prereserva. El tiempo estándar de respuesta es de %{company_approval_time_limit} horas pero durante el horario laboral normalmente respondemos en una hora.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "Después de que se confirme su prereserva, recibirá una notificación y un correo electrónico con la confirmación. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "Puede descargar este archivo haciendo clic en el botón de abajo.",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "En la confirmación de la prereserva va a recibir también información sobre el pago pendiente.",
          your_order_id: "Localizador de su prereserva",
          your_order_is_fully_confirmed: "Su prereserva ya se ha confirmado.",
          online_payment_failed: "Desgraciadamente, su pago en línea no ha sido completado con éxito.",
          order_is_waiting_for_online_payment_info:
            "Ahora su prereserva está pendiente de información del pago realizado.",
        },
        step_number: "Paso %{i}",
        title: "Prereserva núm. %{order_id} - %{site_name}",
        show_on_map: "Mostrar en el mapa",
        marketplace_booking_unavailable_message_html:
          "Desgraciadamente, en este momento no hay fechas disponibles. No obstante, si está interesado, escríbanos a %{email}, llame a %{phone_number} o %{open_chat} ahora mismo.",
        saas_booking_unavailable_message_html:
          "Desgraciadamente, en este momento no hay fechas disponibles. No obstante, si está interesado, escríbanos a %{email} o llame a %{phone_number}.",
        open_chat: "abrir chat con nuestro asistente",
        choose_date_step_title: "Elija una fecha",
        fill_order_step_title: "Complete la preseserva",
        confirm_payment_details_step_title: "Confirme los datos del pago",
        fill_customer_details_step_title: "Proporcione sus datos",
        make_online_payment_step_title: "Pagar en línea",
        order_is_waiting_for_your_approval: "Tu prereserva está pendiente de confirmación",
        click_below_to_approve: "Haga clic abajo para confirmarlos.",
        reject_order: "Rechazar la prereserva",
        approve_order: "Confirmar la prereserva",
        approve_order_failed:
          "Se ha producido un error al conectarse con el servidor. Intente de nuevo. En caso de que el problema permanezca, contáctenos a info@tripsomnia.com.",
        order_is_finished: "Su reserva ha sido clasificada como realizada.",
        we_havent_received_your_review_yet:
          "Todavía no hemos recibido su opinión acerca de nuestro servicio. ¡Compártala con otros usuarios!",
        write_a_review: "Escriba una opinión",
      },
      navbar_search: {
        products_count: "%{count} ofertas",
        categories: "Categorías",
        suppliers: "Proveedores",
        products: "Ofertas",
        search_nearby: "Buscar en esta zona",
        search_query: "Buscar por una frase",
      },
      new_order: {
        errors: {
          connection_error_during_saving:
            "Se ha producido un error al guardar los datos de la prereserva en el servidor.",
          insufficient_product_quantity:
            "En el número seleccionado %{items} puede caber un máximo de %{max_persons_count} personas. Incremente el número %{items} hasta %{desired_quantity} o reduzca el número de las personas.",
          max_quantity_limit: "Esta oferta en la fecha seleccionada está disponible para un máximo de %{max_quantity}.",
          missing_value: "Complete el valor.",
          personal_data_agreement_missing: "Debe aceptar el tratamiento de los datos personales.",
          product_not_found: "No se ha encontrado la oferta seleccionada.",
          product_schedule_slot_missing: "La fecha seleccionada ya no está disponible.",
          product_variant_not_found: "No se ha encontrado la opción de la oferta que ha seleccionado.",
          rules_agreement_missing: "Debe aceptar nuestro reglamento.",
          online_payment_impossible_for_selected_parameters:
            "Desgraciadamente, el pago en línea en es posible en este momento a través del uso de %{payment_method}. Por favor, elija otro método de pago.",
          partners_agreement_missing: "Debe aceptar el acuerdo concerniente a los datos de los socios.",
          rodo_agreement_missing: "Debe aceptar el tratamiento de los datos personales.",
        },
        marketplace_service_fee_tooltip:
          "Gracias a esta tarifa cubrimos los gastos de nuestra plataforma y podemos ofrecerle servicios como el de asistencia en el viaje y servicio de cobranzas.",
        saas_service_fee_tooltip:
          "Gracias a esta tarifa cubrimos los gastos de nuestra plataforma y podemos ofrecerle servicios como el de asistencia en el viaje y servicio de cobranzas.",
        v1_bank_wire_deposit_tooltip: {
          marketplace:
            "Los datos de la cuenta a la que habrá que hacer la transferencia, así como el plazo de pago, los recibirá en la confirmación de la prereserva enviada al correo electrónico proporcionado en el formulario.",
          saas: "Los datos de la cuenta a la que habrá que hacer la transferencia, así como el plazo de pago, los recibirá en la confirmación de la prereserva enviada al correo electrónico proporcionado en el formulario.",
        },
        v1_online_deposit_tooltip: {
          marketplace: {
            line1:
              "%{confirmation_installment_st_name} en línea sirve para asegurar su prereserva. Si cancela la prereserva, se aplicarán las condiciones de la cancelación incluidas en la oferta en cuestión.",
            line2:
              "La empresa %{company_link} recibirá su prereserva inmediatamente después de que se envíe. Tendrá %{company_approval_time_limit} para responderle, sin embargo, la mayoría de las empresas responde en una hora durante el horario laboral local.",
            line3:
              "Si la empresa rechaza su prereserva o le deja expirar, %{confirmation_installment_st_name} del pago adelantado serán automáticamente reembolsados a su cuenta bancaria en 24 horas. No dude en ponerse en contacto con nosotros para que podamos ajustar nuestra oferta a sus necesidades.",
          },
          saas: {
            line1:
              "%{confirmation_installment_st_name} en línea sirve para asegurar su prereserva. En caso de que la cancele, se aplicarán las condiciones de la cancelación incluidas en la oferta en cuestión.",
            line2:
              "Vamos a recibir su prereserva inmediatamente después de que se envíe. Tiempo estándar de respuesta es de %{company_approval_time_limit} horas pero durante el horario laboral normalmente respondemos en una hora.",
            line3:
              "En el caso de que tengamos que rechazar su prereserva o la prereserva expire, la cuota de %{confirmation_installment_st_name} se devolverá automáticamente a su cuenta bancaria dentro de 24 horas. Puede también ponerse en contacto con nosotros y elegir otra oferta.",
          },
        },
        confirmation_installment_st_name: {
          deposit: "Adelantado",
          fee: "Cuota",
          prepayment: "Prepago",
        },
        v1_rest_deposit_tooltip: {
          on_the_arrival: "",
          on_the_spot: "",
          trip: "",
        },
      },
      order: {
        confirmation_installment_after_company_approval:
          "Cantidad a pagar después de que la empresa confirme la reserva",
        new_order_name: "Nueva prereserva",
        order_name: "Prereserva núm. %{order_id}",
        v1_online_deposit_now: "A pagar ahora",
        stock_useby_time_range: {
          between: "",
          from: "",
          to: "",
        },
      },
      order_details: {
        bank_wire_deposit_account_description: "Datos de transferencia bancaria",
        company_details: "Datos del organizador",
        customer_details: "Datos del contratante",
        extra_paid_amount: "Además se ha pagado ",
        marketplace_service_fee: "Tarifa de servicio",
        order_details: "Datos de la prereserva",
        order_name: "Prereserva núm. %{order_id}",
        overpaid_total_amount: "Pagado en exceso",
        paid_amount: "Pagado",
        product_details: "Datos de la oferta",
        refunded_amount: "Se ha devuelto",
        remaining_total_amount: "Falta a pagar",
        remaining_total_amount_short: "A pagar",
        saas_service_fee: "Tarifa de servicio",
        total_amount: "Importe total",
        total_amount_short: "Total",
        to_be_paid_total_amount: "Total a pagar",
        coupon_offer_price: "Precio final",
        coupon_offer_price_before_discount: "Precio general",
        coupon_discount_amount: "Nuestro descuento",
        coupon_code_realisation_place_online_website_description:
          "Introduzca este código promocional al hacer la reserva en la página web correspondiente.",
        coupon_code_realisation_place_manual_description:
          "Mencione este código promocional en su correo electrónico o en la llamada telefónica al hacer la reserva de la oferta.",
        ends_at: "",
        starts_at: "",
      },
      personal_data_agreement: {
        label:
          "Autorizo el tratamiento de mis datos personales por parte de SocialTravel sp. z o. o. para el fin de la ejecución del contrato.",
        tooltip:
          "Autorizo la recopilación y el tratamiento de mis datos personales para fines de realización de mi reserva y el soporte post venta por parte de SocialTravel sp. z o. o., con arreglo al artículo 7, apartado 2 del Reglamento núm. 2016/679 del Parlamento Europeo y del Consejo de la UE, de 27 de abril de 2016, el llamado RGPD.",
      },
      pricelist_expiration_countdown: {
        discount_ends_today: "La oferta especial vence hoy a las %{expires_at}.",
        discount_ends_tomorrow: "La oferta especial vence mañana a las %{expires_at}",
        product_about_to_finish: "La oferta está a punto de terminar.",
        product_finished: "Esta oferta ha terminado.",
        x_days_left_to_end_of_discount: {
          one: "¡Solo queda un día antes de que la oferta termine!",
          other: "¡Quedan %{count} días antes de que la oferta termine!",
        },
        x_left_to_end_of_discount: "¡Quedan %{time} antes de que el descuento expire!",
      },
      products_map: {
        buy_product: "Reservar",
      },
      reservation_calendar: {
        only_x_in_this_price: "Solo %{count} a este precio",
        per_night: "/ noche",
        valid_on: "Se aplica",
        last_stocks: "Últimas plazas",
      },
      rules_agreement: {
        marketplace: {
          label:
            "Acepto %{link} y doy mi consentimiento para que se inicie la prestación de servicios por el Organizador antes de que finalice el plazo de desistimiento del contrato.",
          link: "Condiciones de Servicio",
        },
        saas: {
          label:
            "Acepto %{link} y doy mi consentimiento para que se inicie la prestación de servicios por el Organizador antes de que finalice el plazo de desistimiento del contrato.",
          link: "Reglamento de Organizador",
        },
      },
      sidebar_section_order: {
        order_details: "Datos de la prereserva",
        title: "Su prereserva",
      },
      sidebar_section_product: {
        extend: "Extender",
        product_details: "Información sobre la oferta",
      },
      common: {
        site_title: "Tripsomnia",
        loading_failed_message: "Se ha producido un error al cargar los datos.",
        click_to_load_again: "Haga clic aquí para cargar de nuevo.",
        loading_message: "Los datos se están cargando...",
        show_more: "Muestra más",
        next_page: "Siguiente",
        previous_page: "Anterior",
        zendesk_livechat_window_title: "Soporte",
        zendesk_livechat_concierge_name: "Servicio al cliente",
        zendesk_livechat_concierge_title: "¡Estaremos encantados de ayudarle!",
        close: "Cerrar",
      },
      ProductsCalendarWidget: {
        site_title: "Calendario de fechas",
      },
      ReviewsListWidget: {
        no_reviews_yet: "Todavía no hay opiniones.",
        add_first_review: "¿Quiere añadir la primera?",
        add_new_review: "Escriba una opinión",
        total_count: {
          one: "%{formatted_count} opinión",
          other: "%{formatted_count} opiniones",
        },
        average_rating: "Puntuación media",
        rating: "Puntuación",
      },
      PaymentMethodsHelper: {
        cash_tooltip: "Pago en efectivo en el lugar",
        online_tooltip: "Pago 100% en línea",
        online_plus_cash_tooltip: "Pague un adelantado en línea ahora + el resto en efectivo en el acto",
      },
      products_listing: {
        medium_priority: "Recomendado",
        high_priority: "La mejor oferta",
      },
      bslanding: {
        about_us_contact_form: {
          loading_message: "Cargando...",
          success_message: "El mensaje ha sido enviado correctamente.",
          failure_message: "Se ha producido un error al eviar el mensaje.",
        },
        for_companies_contact_form: {
          loading_message: "Cargando...",
          success_message: "La solicitud ha sido enviada correctamente. Le vamos a contestar en breve.",
          failure_message: "Se ha producido un error al enviar el mensaje.",
        },
      },
      CouponsWidget: {
        title: "Elija la oferta",
        discount_amount: "Descuento %{amount}",
        until_product_offer_ends: "La oferta acaba en %{timeDuration}",
        only_x_coupons_left: "Se han descargado %{total_stock_used} cupones.",
        stock_useby_date_range: "Disponibles para usar %{date_range}",
        order_price: "Nuestro precio",
        order_price_before_discount: "Precio antes de aplicar el descuento",
        order_discount_amount: "Ahorras",
        build_order_button: "Descarga el cupón",
        build_order_failed:
          "Se ha producido un error al descargar los detalles de la oferta. Por favor, intente de nuevo o elija otra oferta.",
        confirm_order_button: "Descargar el vale",
        confirm_order_failed:
          "Se ha producido un error al guardar los datos. Por favor, intente de nuevo o elija otra oferta.",
        form_title: "Rellene con sus datos",
        confirm_order_succeded:
          "Su vale se ha enviado al correo electrónico que ha proporcionado, compruebe su correo y utilice el vale al hacer la reserva.",
        product_short_description: "Información clave",
        product_description: "Descripción de la oferta",
        product_variant_short_description: "Descripción de la opción",
        product_customer_requirements: "Requisitos",
        extend_infos: "Más »",
        get_coupon: "Descargar cupón",
        hint_title: "Disfruta de nuestras promociones",
        hint_content:
          "<ol><li>Elige la promoción que te gusta.</li><li>Lee su descripción y requisitos.</li><li>Proporciona los datos necesarios y descarga tu cupón.</li><li>Utiliza el cupón de descuento al hacer la reserva.</li></ol>",
        less_than_x_coupons_left: "Quedan menos de %{total_stock_left} cupones disponibles.",
        no_results_alert: "Desgraciadamente, ya no quedan cupones disponibles. Por favor, intente más tarde.",
      },
      partners_agreement: {
        label:
          "Otorgo mi consentimiento para el procesamiento de mis datos personales por los Socios Confiables de Tripsomnia para fines de realización de la reserva.",
        tooltip:
          "Otorgo mi consentimiento expreso y libre para el procesamiento y recopilación de mis datos personales por los socios confiables a fines de comunicación para facilitar realización de reserva y soporte postventa, con arreglo al artículo 7, apartado 2 del Reglamento no 2016/679 del Parlamento Europeo y del Consejo de la UE, de 27 de abril de 2016, el llamado RGPD.",
      },
      rodo_agreement: {
        label: "Soy consciente de mis derechos derivados del artículo 7 del RGDP.",
        tooltip:
          "Al mismo tiempo, declaro que mi consentimiento cumple todas las condiciones contempladas en el artículo 7, apartado 2 del Reglamento núm. 2016/679 del Parlamento Europeo y del Consejo de la UE, de 27 de abril de 2016, es decir, tengo derecho a retirarlo en cualquier momento, la solicitud de aprobación me ha sido presentada de forma clara y comprensible y he sido informado sobre el estado de su rendición de cuentas. Asimismo, he sido informado que los datos son recopilados por Tripsomnia (SocialTravel sp. z o. o.), así como sobre la finalidad para la que se recopilan, sobre su presentación voluntaria, el derecho al acceso y la posibilidad de corregirlos y que los datos en cuestión no se compartirán con otras entidades.",
      },
      tripsomnia_contact_email: "info@tripsomnia.com",
      tripsomnia_contact_phone_number: "+48 690 670 581",
    },
    ransack: {
      predicates: {
        eq: "igual",
      },
    },
    api: {
      base: {
        unauthorized: "Acceso denegado. Ingresar de nuevo.",
        company_inactive: "La empresa que seleccionó no está actualmente activa. Elija otro o intente activarlo.",
        disabled: "Acceso denegado. Esta acción ha sido deshabilitada.",
        secret_invalid: "Acceso denegado. El secreto de la API no es válido.",
      },
    },
    activerecord: {
      attributes: {
        admin_user: {
          companies: "Compañias administradas",
          companies_ids: "Compañias administradas",
          company_admin: "Administrador de la empresa",
          company_employee: "Empleado",
          editor_admin: "Administrador del editor (TP)",
          global_admin: "Administrador global (SS)",
          main_admin: "Administrador principal (S)",
          default_new_company_role: "Rol predeterminado para nuevas empresas",
        },
        agent_cooperation: {
          fixed_gross_pricing: "Precios brutos fijos",
          fixed_net_pricing: "Precios netos fijos",
          pricing_type: "Establecer precios",
          realtime_pricing: "Precios actuales",
          st_fixed_gross_pricing: "Precios brutos fijos",
          st_fixed_net_pricing: "Precios netos fijos",
          st_realtime_pricing: "Precios actuales",
        },
        company: {
          accepts_printed_customer_vouchers: "¿Acepta nuestro comprobante .pdf impreso presentado por el Cliente?",
          admin_users: "Usuarios de la compañia",
          admin_users_ids: "Usuarios de la compañia",
          contact_email: "Dirección de correo electrónico",
          contact_email_placeholder: "Correo electrónico de contacto",
          contact_facebook_url: "Dirección de la página de Facebook",
          contact_facebook_url_placeholder: "La dirección de Facebook de tu sitio web",
          contact_full_address: "Dirección de la oficina",
          contact_full_address_placeholder: "",
          contact_languages: "Idiomas de contacto",
          contact_languages_placeholder: "Idiomas en los que los clientes pueden contactarlo",
          contact_opening_hours: "Horario de oficina",
          contact_opening_hours_placeholder:
            'El horario laboral de su oficina (p. Ej., "Lunes a viernes de 8 a.m a 4 p.m¨)',
          contact_phone_number: "Número de contacto",
          contact_phone_number_placeholder: "Número de contacto",
          contact_website_url: "Sitio web",
          contact_website_url_placeholder: "Dirección web",
          default_product_price_currency: "Moneda predeterminada para nuevas ofertas",
          general_terms: "Términos y Condiciones",
          general_terms_placeholder: "Términos y condiciones que sus clientes deben aceptar al enviar un pedido.",
          invoice_city: "Ciudad",
          invoice_company_name: "Nombre de empresa",
          invoice_country_name: "País",
          invoice_data: "Detalles de la factura",
          invoice_email: "Dirección de correo electrónico",
          invoice_nip: "Sin impuesto.",
          invoice_phone_number: "Teléfono",
          invoice_postal_code: "código postal",
          invoice_street_address: "Calle, edificio y número de piso",
          locale: "Lenguaje principal",
          logo_image: "Avatar / Logo",
          marketplace_cover_image: "Foto de fondo en el sitio web de Tripsomnia",
          marketplace_meta_description: "Descripción de la página (SEO) (Marketplace)",
          marketplace_meta_title: "Título de la página (SEO) (Marketplace)",
          marketplace_name: "Nombre público (Marketplace)",
          marketplace_short_description: "Breve descripción (Marketplace)",
          marketplace_short_description_placeholder:
            "Breve descripción de su empresa que se presentará en la página de su empresa en Tripsomnia.",
          name: "Nombre de empresa",
          name_placeholder: "No debe tener más de 100 caracteres.",
          notifications_email: "Dirección de correo electrónico para notificaciones",
          notifications_phone_number: "Número de contacto para notificaciones",
          public_name: "Nombre público",
          saas_cover_image: "Foto de fondo para su sitio web",
          saas_meta_description: "Descripción de la página (SEO) (SaaS)",
          saas_meta_title: "Título de la página (SEO) (SaaS)",
          saas_name: "Nombre público (SaaS)",
          saas_short_description: "Breve descripción (SaaS)",
          saas_short_description_placeholder:
            "Breve descripción de su empresa que se presentará en su página de inicio.",
          saas_subdomain: "Subdominio SaaS",
          active: "Activo",
          default_products_enable_frontend_slots_listing:
            "Mostrar fechas en una lista en lugar de calendario de forma predeterminada",
          enable_saas: "Habilitar SaaS",
          enable_marketplace: "Habilitar Marketplace",
          affiliate_commision_calculation_type: "Tipo de cálculo de comisión de afiliado",
          agent_earnings_percentage:
            "Porcentaje de los ingresos del agente de la orden (comisión + tarifa de servicio)",
          total_base_amount_percentage: "Porcentaje de la cantidad básica del pedido",
        },
        company_member: {
          company_admin: "Administración",
          company_employee: "Empleado",
          editor_admin: "Administrador del editor (TP)",
          global_admin: "Administrador global (SS)",
          main_admin: "Administrador principal (S)",
        },
        customer: {
          display_name: "Nombre",
          full_name: "Nombre y apellido",
          full_name_contains: "Nombre y apellido",
          future: "Futuro",
          lost: "Perdió",
          orders_company_id: "Orden: Empresa",
          orders_product_id: "Orden: Oferta",
          orders_product_name: "Orden: Nombre de la oferta",
          orders_product_product_tags_id: "Pedido: Etiquetas de oferta",
          orders_product_variant_id: "Pedido: Variante de oferta",
          orders_status: "Orden: Estado",
          origin: "Fuente",
          past: "Pasado",
          prospect: "Potencial",
        },
        installment: {
          confirmation_after_company_approval:
            "Sirve como confirmación de pedido después de la confirmación de la Compañía",
          confirmation_before_company_approval:
            "Sirve como confirmación de pedido antes de la confirmación de la empresa",
          remaining_amount: "Cantidad restante",
          whole_amount: "Cantidad total",
        },
        order: {
          additional_information: "Información adicional para el cliente",
          confirmed_at: "Fecha de presentación",
          customer_display_name: "Nombre del cliente",
          manual: "Orden manual",
          marketplace: "Orden de mercado",
          product_additional_pickup_instructions: "Direcciones",
          product_customer_hints: "Consejos",
          product_customer_requirements: "Requisitos",
          product_excluded_items: "El precio no incluye",
          product_included_items: "Precio incluye",
          product_price_currency: "Oferta de moneda",
          saas: "Orden SaaS",
          status_short: {
            waiting_for_company_approval: "Esperando empresa",
            waiting_for_customer_approval: "Esperando a un cliente",
          },
          stock_useby_ends_at: "Fecha de finalización de validez",
          stock_useby_starts_at: "Fecha de inicio de validez",
          automatic: "Orden automática",
          source: "Fuente",
          pickup_point: "Punto de encuentro",
          agent_disbursement_status: "Estado de desembolso del agente",
          uncleared: "No aclarado",
          cleared: "Despejado",
          coupon_code_name: "Código de descuento",
          author_place_cwa: "",
          author_place_frontend: "",
          author_place_partner: "",
        },
        order_customer_participant: {
          display_name: "Participante No. %{i}",
        },
        order_installment: {
          amount_hint: 'Tiene sentido solo si "Cantidad de pedido restante"? no está marcado.',
          confirmation_installment_hint:
            'Solo es posible con el pago de la primera cuota en el método "Pago en línea".',
          paid_after_company_approval_hint:
            'Tiene sentido solo si "¿Sirve como confirmación del pedido?" está marcado.',
          paid_by_at_hint: 'Tiene sentido solo si "Tipo de determinación" es igual a "Fecha especificada".',
          paid_by_time_duration_hint:
            'Tiene sentido, excepto cuando "Tipo de determinación" es igual a "Fecha especificada".',
          remaining_amount: "Cantidad restante de la oferta?",
          remaining_amount_hint: "Solo posible con la última entrega.",
          account_description: "Descripción de la cuenta bancaria",
        },
        order_item: {
          base_item: "¿Posición básica?",
          item_type: "Tipo de Posición",
          marketplace_service_fee: "Tarifa de servicio de Tripsomnia",
          name: "Nombre del puesto",
          order_summary: "Total",
          payment_profile_service_fee: "Tarifa de perfil de pago",
          product_coupon: "Cupón",
          product_custom: "Artículo no estándar",
          product_item: "Artículo de oferta",
          product_option: "Opcion adicional",
          product_refund: "Reembolso",
          quantity: "Número de items",
          saas_service_fee: "Tarifa de transacción de Tripsomnia",
          service_fee: "Tarifa de servicio",
          unit_price: "Precio por ítem",
        },
        order_status_history: {
          abandon: "Orden abandonada",
          auto_refund_issued: "Pago reembolsado automáticamente al cliente",
          build: "Pedido creado",
          company_approval_time_limit_exceeded: "Fin del límite de tiempo de confirmación de pedido de la Compañía",
          company_approve: "Pedido confirmado por la empresa",
          company_cancel: "Pedido cancelado por la empresa",
          company_reject: "Pedido rechazado por la empresa",
          confirm: "Pedido enviado",
          confirmation_online_payment_time_limit_exceeded: "El final del límite de tiempo de pago en línea",
          customer_approval_time_limit_exceeded: "Fin del límite de tiempo de confirmación del pedido del cliente",
          customer_approve: "Pedido confirmado por el cliente",
          expire: "Pedido caducado",
          finish: "Pedido completado",
          finish_online_payment: "Pago en línea completado",
          manual_status_change: "Cambio manual del estado del pedido",
          pause: "Fin del tiempo límite del pedido",
        },
        order_transfer: {
          agent: "Agente",
          bank_wire: "Transferencia bancaria",
          cash: "Efectivo",
          custom: "Personalizado",
          customer: "Cliente",
          dotpay: "Plataforma de pago en línea",
          online_payment: "Pago en línea",
          receiver: "A",
          sender: "De",
          socialtravel: "Tripsomnia",
          source_payload: "Nota fuente",
          source_type: "Fuente de retiro",
          transfer_type: "Método de pago",
          transferred_at: "Fecha de pago",
          refund_type: "Método de reembolso",
          refunded_at: "Fecha de Devolución",
          from_customer_frontend_name: "Pagó %{transfer_type} en %{transfer_date}",
          to_customer_frontend_name: "Reembolsado %{transfer_type} en %{transfer_date}",
          customer_to_supplier_backend_name: "El cliente pagó al proveedor %{transfer_type} el %{transfer_date}",
          customer_to_agent_backend_name: "El cliente pagó al Agente %{transfer_type} el %{transfer_date}",
          customer_to_socialtravel_backend_name: "El cliente pagó Tripsomnia %{transfer_type} el %{transfer_date}",
          company_to_customer_backend_name: "Proveedor reembolsado al Cliente %{transfer_type} en %{transfer_date}",
          company_to_agent_backend_name: "Agente de pago del proveedor %{transfer_type} en %{transfer_date}",
          company_to_socialtravel_backend_name: "El proveedor pagó Tripsomnia %{transfer_type} el %{transfer_date}",
          agent_to_customer_backend_name: "Agente ha reembolsado al Cliente %{transfer_type} en %{transfer_date}",
          agent_to_supplier_backend_name: "El agente pagó al proveedor %{transfer_type} el %{transfer_date}",
          agent_to_socialtravel_backend_name: "El agente pagó Tripsomnia %{transfer_type} el %{transfer_date}",
          socialtravel_to_customer_backend_name:
            "Tripsomnia reembolsado al Cliente %{transfer_type} en %{transfer_date}",
          socialtravel_to_agent_backend_name: "Tripsomnia pagó al Agente %{transfer_type} el %{transfer_date}",
          socialtravel_to_supplier_backend_name: "Tripsomnia pagó al Proveedor %{transfer_type} el %{transfer_date}",
          supplier_to_agent_backend_name: "Agente de pago del proveedor %{transfer_type} en %{transfer_date}",
          supplier_to_customer_backend_name: "Proveedor reembolsado al Cliente %{transfer_type} en %{transfer_date}",
          supplier_to_socialtravel_backend_name: "El proveedor pagó Tripsomnia %{transfer_type} el %{transfer_date}",
        },
        payment_profile: {
          additional_fee: "Recargo (cantidad)",
          additional_fee_name: "Nombre de opción adicional",
          additional_fee_percentage: "Recargo (%)",
          companies: "Compañías asignadas",
          companies_ids: "Compañías asignadas",
          default_additional_fee_name: "Tarifa por el perfil de pago seleccionado",
          has_additional_fee: "¿Cobra una tarifa de servicio adicional por pedidos con este perfil?",
          marketplace: "Perfil del mercado",
          saas: "Perfil SaaS",
          additional_fee_as_agent_fee: "Agregue la tarifa como tarifa de servicio del agente",
        },
        payment_profile_installment: {
          amount: "Monto a plazos",
          amount_percentage: "Importe a plazos en porcentajes (% del importe del pedido básico)",
          increase_amount_by_marketplace_commision: "Aumentar una cantidad a plazos por comisión Tripsomnia",
          increase_amount_by_marketplace_service_fee:
            "Aumentar el monto de una cuota por la tarifa de servicio de Tripsomnia",
          account_description: "Descripción de la cuenta bancaria",
        },
        payment_profile_product_attachment: {
          date_limit_type: "Tipo de límite de fecha",
          date_limit_type_label: "Limitar la fecha",
          days_before_arrival_date_limit: "De x a y días antes de la fecha de inicio de la oferta",
          max_days_before_arrival: "Días máximos para ofrecer la fecha de inicio",
          min_days_before_arrival: "Días mínimos para ofrecer la fecha de inicio",
          no_date_limit: "Sin límite",
        },
        pricing: {
          absolute_amount: "Cantidad: =",
          absolute_amount_cents: "Cantidad: =",
          absolute_percentage: "Porcentaje: =",
          relative_amount: "Cantidad +/-",
          relative_amount_cents: "Cantidad +/-",
          relative_percentage: "Porcentaje +/-",
        },
        product: {
          categories: "Categorias",
          product_company_tags: "Etiquetas",
          active: "Activo",
          included_items_placeholder: "p.ej. Pensión completa",
          excluded_items_placeholder: "p.ej. Seguro",
          customer_requirements_placeholder: "p.ej. Edad mínima requerida de 18 años. o un asistente importante",
          customer_hints_placeholder: "p.ej. Recuerda llevar ropa adecuada contigo.",
          highlights_placeholder: "p.ej. Un gran viaje para parejas.",
          categories_placeholder: "Añadir categoría",
          enable_frontend_slots_listing: "Mostrar fechas en una lista en lugar de calendario",
          coupon_code_realisation_place_type: "Lugar de realización del código de descuento",
          coupon_code_realisation_place_custom_description:
            "Descripción del lugar de realización del código de descuento",
        },
        product_option: {
          all_product_variants: "Todas las variantes",
          required: "Valor requerido para ser llenado por el Cliente",
        },
        product_integration: {
          auto_update_description: "auto update description",
          auto_update_images: "auto update photos",
          auto_update_prices: "auto update price",
          auto_update_calendar: "auto update calendar"
        },
        product_order_field: {
          "ProductOrderField::BigText": "Cuadro de texto grande",
          "ProductOrderField::Boolean": "Caja",
          "ProductOrderField::Date": "Fecha",
          "ProductOrderField::Email": "Dirección de correo electrónico",
          "ProductOrderField::Geopoint": "Localización geográfica",
          "ProductOrderField::List": "Lista de selección",
          "ProductOrderField::Number": "Número",
          "ProductOrderField::PhoneNumber": "Número de teléfono",
          "ProductOrderField::Text": "Caja de texto",
          assignation_per_person_label: "Elección de opciones por participante (predeterminado: por pedido)",
          assignation_type: "Método de completar",
          customer_hint: "Consejo para un cliente",
          customer_hint_placeholder: "Un consejo que se presentará al Cliente cuando complete el espacio en blanco",
          list_options: "Valores",
          max_value: "Max. valor",
          min_value: "Min. valor",
          multiply_price_by_nights_count: "Multiplique el precio por la duración de la estadía (número de días)",
          order_value_required: "Valor requerido",
          presets: {
            customer_email: {
              frontend_name: "Dirección de correo electrónico",
              name: "Dirección de correo electrónico del cliente",
            },
            customer_full_name: {
              frontend_name: "Nombre y apellido",
              name: "Nombre y apellido del cliente",
            },
            customer_note: {
              customer_hint: "Ingrese su mensaje al organizador.",
              frontend_name: "Nota para el proveedor",
              name: "Nota para el proveedor",
            },
            customer_phone_number: {
              customer_hint: "Número de contacto por si hay alguna pregunta sobre su reserva.",
              frontend_name: "Número de contacto",
              name: "Número de contacto del cliente",
            },
            participant_birth_date: {
              frontend_name: "Fecha de nacimiento",
              name: "Fecha de nacimiento del participante",
            },
            participant_email: {
              frontend_name: "Dirección de correo electrónico",
              name: "Dirección de correo electrónico del participante",
            },
            participant_full_name: {
              frontend_name: "Nombre y apellido",
              name: "Nombre del participante y apellido",
            },
            participant_phone_number: {
              frontend_name: "Número de contacto",
              name: "Número de contacto del participante",
            },
            customer_city: {
              frontend_name: "Ciudad",
              name: "Ciudad del cliente",
            },
            customer_postal_code: {
              frontend_name: "código postal",
              name: "Código postal del cliente",
            },
            customer_country: {
              frontend_name: "País",
              name: "País del cliente",
            },
            customer_hotel_name: {
              name: "Hotel",
              customer_hint:
                "Ingrese el nombre del hotel, la dirección y el número de habitación si tiene esta información.",
            },
            customer_dates_of_stay: {
              name: "Fecha de estadia",
            },
          },
          price_included_in_order_base_amount: "Incluya el precio de la opción en el costo básico del pedido",
          price_none: "Ninguna",
          price_type: "Método de cálculo de precios.",
          product_variants: "Oferta de variantes",
          product_variants_assignation_all: "Todas las variantes",
          product_variants_assignation_some: "Algunas variantes",
          product_variants_assignation_type: "Método de vinculación a variantes",
          product_variants_ids: "Variantes",
          show_on_manifest: "Mostrar en la lista de participantes",
          type: "Tipo de valor",
          "ProductOrderField::PickupPoint": "Punto de encuentro",
          undefined_pickup_point_option_name: "Indefinido",
          custom_pickup_point_option_name: "Recogida en el hotel",
          custom_pickup_point_display_name: "Dirección del cliente: %{custom_location_name}",
          "ProductOrderField::Country": "País",
          custom_field: "Campo personalizado",
        },
        product_pricelist_item: {
          preset_fixed: "Lista general de precios",
          preset_id: "Tipo de categoría",
          preset_item: "Articulo",
          preset_person_adult: "Adulto",
          preset_person_child: "Niño",
          preset_person_custom: "Categoría personalizada",
          preset_person_everyone: "Persona",
          preset_person_group_1_plus_2: "Familia 1 + 2",
          preset_person_group_1_plus_3: "Familia 1 + 3",
          preset_person_group_2_plus_1: "Familia 2 + 1",
          preset_person_group_2_plus_2: "Familia 2 + 2",
          preset_person_group_2_plus_3: "Familia 2 + 3",
          preset_person_group_custom: "Grupo",
          preset_person_group_double: "2 personas",
          preset_person_group_family_of_3: "Familia de 3 personas",
          preset_person_group_family_of_4: "Familia de 4 personas",
          preset_person_group_family_of_5: "Familia de 5 personas",
          preset_person_group_quad: "4 personas",
          preset_person_group_single: "1 persona",
          preset_person_group_triple: "3 personas",
          preset_person_infant: "Infantil",
          preset_person_normal: "Normal",
          preset_person_reduced: "Reducido",
          preset_person_senior: "Senior / jubilado",
          preset_person_student: "Estudiante",
          preset_person_teenager: "Menor de edad",
          price_type: "Tipo de precio",
        },
        product_schedule_slot: {
          availability_type: "Tipos de disponibilidad",
          available_with_company_approval: "Reserva previa confirmación de la empresa",
          available_with_instant_booking: "Reserva instantanea",
          date: "Fecha de plazo",
          datetime: "Plazo fecha y hora",
          total_stock_left: "Disponibilidad restante",
          total_stock_limit: "Límite de disponibilidad",
          total_stock_used: "Disponibilidad tomada",
          active: "Disponible",
          available_with_instant_booking_help: "Todos los pedidos se confirman automáticamente.",
          available_with_company_approval_help:
            "La reserva instantánea está desactivada. Recibe consultas iniciales y debe confirmar cada pedido.",
          confirmed: "Confirmado",
        },
        product_tag: {
          category: "Categoría",
          location: "Ubicación",
          parent: "Etiqueta principal",
          product_st_tag: "Etiqueta de Tripsomnia",
          product_company_tag: "Etiqueta de la empresa",
          show_on_fe_listing: "Mostrar etiqueta en el listado de ofertas",
          show_on_fe_product_page: "Mostrar etiqueta en la página de la oferta",
          fe_color: "Color frontal",
        },
        product_variant: {
          additional_pickup_instructions: "Direcciones adicionales",
          allow_custom_pickup_point: "Recogida en el hotel",
          allow_no_pickup_point: 'Permita que el Cliente seleccione "Punto de encuentro: no especificado"',
          custom_pickup_point_additional_fee: "Recargo por recogida",
          default: "¿Variante predeterminada?",
          default_requires_company_approval: "Por defecto, requiere la confirmación de la Compañía",
          default_total_stock_limit: "Límite de disponibilidad predeterminado",
          nb_requires_company_approval: "Requiere confirmación de la empresa",
          nb_stock_useby_days_limit: "Fecha de validez de la oferta ordenada (número de días)",
          nb_stock_useby_ends_at: "Fecha de finalización de la validez de la oferta ordenada",
          nb_stock_useby_starts_at: "Fecha de inicio de validez de la oferta ordenada",
          nb_total_stock_left: "Límite de oferta restante",
          nb_total_stock_limit: "Límite de oferta",
          nb_total_stock_used: "Límite de oferta reservado",
          pickup_points_assignation_type: "Método de asignación de puntos de encuentro en orden",
          pricelist_by_item: "Lista de precios por artículo",
          pricelist_by_order: "Lista general de precios",
          pricelist_by_person: "Lista de precios por persona",
          pricelist_type: "Tipo de lista de precios",
          additional_pickup_instructions_placeholder: "Agregar direcciones",
          coupon_discount_amount: "Importe de descuento",
          coupon_discount_percentage: "Porcentaje de descuento",
          coupon_offer_price_before_discount: "Precio antes del descuento",
          coupon_offer_price: "Precio despues de descuento",
        },
        view_collection_item: {
          related_model: "Registro relacionado",
        },
        view_section: {
          name: "Título",
          show_name: "¿Mostrar título?",
          type: "Tipo de sección",
          types: {
            "ViewSection::CompanyProducts": "Empresa - lista de ofertas",
            "ViewSection::CustomCollection": "Colección personalizada",
            "ViewSection::CustomContent": "Contenido personalizado",
            "ViewSection::CustomCover": "Cubierta personalizada",
            "ViewSection::ProductTagChildren": "Etiqueta de oferta - lista de subetiquetas",
            "ViewSection::ProductTagProducts": "Etiqueta de oferta - lista de ofertas",
            "ViewSection::ProductTagsCategoryProducts": "Categorías de etiquetas de oferta: lista de etiquetas",
            "ViewSection::ProductTagsCategoryTags": "Categorías de etiquetas de oferta: lista de etiquetas",
            "ViewSection::ViewedProducts": "Ofertas vistas recientemente",
            "ViewSection::SimilarToViewedProducts": "Ofertas similares a las vistas por última vez.",
            "ViewSection::ViewedProductsTags": "Categorías y localizaciones de ofertas vistas recientemente",
          },
          view_collection_items_limit: "Límite de registros mostrados",
          view_mode: "Modo de visualización",
          view_modes: {
            cards_listing: "Lista de páginas con pestañas anchas",
            cards_slider: "Control deslizante de páginas con pestañas largas",
            extended_cards_listing: "Ampliar listado de páginas de pestañas",
            items_carousel: "Carrusel",
            products_map: "Mapa",
            wide_cards_slider: "Control deslizante de páginas con pestañas anchas",
            wide_cards_listing: "Páginas de pestaña ancha",
          },
          with_similar_items: "Mostrar elementos similares",
        },
        activity: {
          customer_email_sent_title: "Ha sido enviado un correo electronico al cliente (%{recipient_email})",
          customer_email_sent_content: "Titulo: %{email_subject}",
          customer_sms_sent_title: "Un SMS ha sido enviado al cliente (%{recipient_phone_number})",
          customer_sms_sent_content: "Contenido: %{sms_content}",
          order_status_updated_content: 'nuevo estatus del pedido: "%{new_status}"',
          review_created_title:
            "El cliente ha añadido una reseña sobre ti con una clasisficación %{rating}/%{max_rating}",
          review_created_content: "Reseña de contenido: %{content}",
          customer_to_supplier_order_transfer_created_title: "El  cliente ha pagado al proveror %{amount}",
          customer_to_agent_order_transfer_created_title: "El  cliente ha pagado al agente %{amount}",
          customer_to_socialtravel_order_transfer_created_title: "El  cliente ha pagado a Tripsomia %{amount}",
          company_to_customer_order_transfer_created_title: "El provedor hizo una transferencia al cliente %{amount}",
          company_to_agent_order_transfer_created_title: "El provedor hizo una transferencia al agente %{amount}",
          company_to_socialtravel_order_transfer_created_title:
            "El provrdor hizo una transferencia al Tripsomia %{amount}",
          agent_to_customer_order_transfer_created_title: "El agenteha  reembolsado al Cliente %{amount}",
          agent_to_supplier_order_transfer_created_title: "El agente ha reembolzado al provedor %{amount}",
          agent_to_socialtravel_order_transfer_created_title:
            "El agente ha hecho una transferencia a Tripsomnia %{amount}",
          socialtravel_to_customer_order_transfer_created_title:
            "Tripsomnia ha hecho un reembolso al cliente %{amount}",
          socialtravel_to_agent_order_transfer_created_title: "Tripsomnia ha transferido al Agente %{amount}",
          socialtravel_to_supplier_order_transfer_created_title: "Tripsomnia ha pagado al provedor %{amount}",
          supplier_email_sent_content: "Titulo: %{email_subject}",
          supplier_email_sent_title: "Correo electronico enviado al provedor (%{recipient_email})",
          supplier_sms_sent_content: "Contenido: %{sms_content}",
          supplier_sms_sent_title: "SMS enviado al provedor (%{recipient_phone_number})",
          customer_sms_send_failed_content: "Mensaje de error: %{error_message}",
          customer_sms_send_failed_title:
            "Ha ocurrido un error mientras se mandaba un SMS al cliente (%{recipient_phone_number})",
          supplier_sms_send_failed_content: "Mensaje erroneo: %{error_message}",
          supplier_sms_send_failed_title:
            "Ha ocurrido un error mientras enviavamos un mensaje al provedor (%{recipient_phone_number})",
          payment_issued_title: "Iniciado: operación de pago del cliente %{source} (%{amount})",
          payment_in_progress_title: "En progreso: %{source} Pago de la operación (%{amount})",
          payment_completed_title: "Completado exitosamente: cliente %{source} operacion de pago (%{amount})",
          payment_failed_title: "Failed: customer %{source} payment operation (%{amount})",
          refund_issued_title: "Iniciado: cliente %{source} operación de reembolso  (%{amount})",
          refund_in_progress_title: "En progreso: cliente %{source} operación de reembolso  (%{amount})",
          refund_completed_title: "Completado: cliente %{source} operación de reembolso  (%{amount})",
          refund_failed_title: "Falló: cliente %{source} operación de reembolso (%{amount})",
          sms_send_failed_content: "Error de mensaje: %{error_message}",
          sms_send_failed_title: "Ha ocurrido un error al enviar el  SMS (%{recipient_phone_number})",
          sms_sent_content: "Contenido: %{sms_content}",
          sms_sent_title: "SMS enviado (%{recipient_phone_number})",
          supplier_to_agent_order_transfer_created_title: "El provedor ha transferido al agente %{amount}",
          supplier_to_customer_order_transfer_created_title: "El provedor ha reembolsado al cliente %{amount}",
          supplier_to_socialtravel_order_transfer_created_title: "El provedor ha transferido a Tripsomia %{amount}",
        },
        product_pickup_point: {
          additional_instructions_placeholder: "Agregar una descripción detallada del punto de encuentro",
        },
        review: {
          single: "1 persona",
          couple: "Par",
          friends: "Amigos",
          family: "Familia",
          age_group: "Grupo de edad",
          group_type: "Tipo de grupo",
          author_name: "Nombre del revisor",
          author_email: "Dirección de correo electrónico del revisor",
          content: "Contenido",
          rating: "Puntuación general",
          st_feedback: "Reseña de Tripsomnia",
          st_rating: "Puntuación de Tripsomnia",
          rating_1: "Muy mal",
          rating_2: "Malo",
          rating_3: "Bueno promedio",
          rating_4: "Bueno",
          rating_5: "Muy bien",
          st_rating_1: "Muy mal",
          st_rating_2: "Malo",
          st_rating_3: "Bueno promedio",
          st_rating_4: "Bueno",
          st_rating_5: "Excelente",
          verified: "Revisión verificada",
          "18-24": "18-24 años",
          "25-30": "25-30 años",
          "31-40": "31-40 años",
          "41-60": "41-60 años",
          "60+": "60+ años",
          anonymous: "Anónimo",
        },
        coupon_code: {
          total_stock_left: "Uso restante",
          total_stock_limit: "Límite de uso",
          total_stock_used: "Uso tomado",
        },
        product_variant_additional_detail: {
          category: {
            one_person_room: "",
            two_person_room: "",
            three_person_room: "",
            four_person_room: "",
            multi_person_room: "",
            bed_in_multi_person_room: "",
            apartment: "",
            cottage: "",
            villa: "",
            holiday_house: "",
            tent: "",
          },
        },
        product_types: {
          voucher: "",
          accommodation: "",
          coupon: "",
          standard: "",
          ticket: "",
        },
        pricing_plan: {
          preset: {
            elastic: {
              name: "Oferta elástica",
              company_description: "",
              customer_description: "xxx",
            },
            not_refundable: {
              name: "Oferta no reembolsable",
              company_description: "xxx",
              customer_description: "xxx",
            },
          },
        },
        pricing_plan_types: {
          not_refundable: "Oferta no reembolsable",
          elastic: "Oferta elástica",
        },
      },
      errors: {
        models: {
          order: {
            inactive_product: "La oferta elegida ya no está disponible.",
            missing_order_customer_participants_data: "Fecha completa de los participantes.",
            too_high_product_quantity:
              "Este número %{unit_name_other} ya no está disponible. Elija un valor menor o igual a %{available_stock}.",
            customer_display_name_missing:
              "Complete al menos un valor del Cliente (nombre, dirección de correo electrónico o número de teléfono).",
            too_low_product_quantity: "Has elegido 0 paquetes. Elige al menos una persona.",
            agent_has_disabled_saas:
              "El agente tiene su cooperación SaaS con Tripsomnia deshabilitado. Tal orden es imposible en este momento.",
            supplier_has_disabled_saas:
              "El proveedor tiene su cooperación SaaS con Tripsomnia deshabilitado. Tal orden es imposible en este momento.",
            supplier_has_disabled_marketplace:
              "El proveedor tiene su cooperación con el mercado de Tripsomnia deshabilitado. Tal orden es imposible en este momento.",
            supplier_saas_subdomain_required:
              "El proveedor no tiene un dominio establecido para su sitio web de pedidos. Tal orden es imposible. Póngase en contacto con la administración de Tripsomnia para solucionar el problema.",
            agent_saas_subdomain_required:
              "El agente no tiene un dominio establecido para su sitio web de pedidos. Tal orden es imposible. Póngase en contacto con la administración de Tripsomnia para solucionar el problema.",
            confirmation_installment_impossible:
              "Desafortunadamente, actualmente es imposible pagar este pedido con un pago en línea. Elija otro perfil de pago si es posible, o contáctenos directamente.",
            stock_useby_date_passed:
              "La fecha de realización de esta oferta ya ha pasado. Es demasiado tarde para reservarlo ahora.",
            product_expired: "La oferta elegida ya no está disponible.",
          },
          order_item: {
            wrong_price_currency: "La moneda del precio para este tipo de artículo debe estar en: %{valid_currencias}.",
          },
          product: {
            must_be_empty_when_product_has_no_booking:
              'El valor %{value} no está permitido en el caso de ofertas con el tipo de pedido "Sin pedidos".',
            product_variant_with_percentage_amounts_defined:
              "Al menos una de las listas de precios de esta oferta tiene una de las 'Tarifas de servicio', 'Comisión', 'Tarifa de depósito bancario' como porcentaje. Antes de cambiar la moneda de las listas de precios a otra cosa que no sea PLN, cambie estos valores de porcentajes a cuotas.",
            product_pricelist_items_missing: "Complete al menos una categoría de precio.",
          },
          product_order_field: {
            pricing_disallowed_for_this_type:
              "Para este tipo de opción, la activación de la lista de precios no es posible.",
          },
          product_tag: {
            parent_must_have_the_same_type: "La etiqueta principal debe ser del mismo tipo que su subetiqueta.",
            parent_cant_be_self: "La etiqueta principal no puede ser ella misma.",
            parent_cant_be_its_child: "La etiqueta principal no puede ser su 'hijo al mismo tiempo.",
          },
        },
      },
      models: {
        admin_user: {
          one: "Administración",
          other: "Administradores",
        },
        attachment: {
          one: "Adjunto archivo",
          other: "Archivos adjuntos",
        },
        company: {
          one: "Empresa",
          other: "Compañías",
        },
        customer: {
          one: "Cliente",
          other: "Clientes",
        },
        list_option: {
          one: "Opcion a elegir",
          other: "Opciones a elegir",
        },
        order: {
          one: "Orden",
          other: "Pedidos",
        },
        order_installment: {
          one: "Entrega",
          other: "Cuotas",
        },
        order_item: {
          one: "Artículo pedido",
          other: "Artículos pedidos",
        },
        order_transfer: {
          one: "Pago / retiro",
          other: "Pagos / retiros",
        },
        payment_profile: {
          one: "Perfil de pago",
          other: "Perfiles de pago",
        },
        payment_profile_installment: {
          one: "Entrega",
          other: "Cuotas",
        },
        payment_profile_product_attachment: {
          one: "Perfil de pago relacionado",
          other: "Perfiles de pago relacionados",
        },
        pricing: {
          one: "Precio personalizado",
          other: "Precios personalizados",
        },
        product: {
          one: "Oferta",
          other: "Ofertas",
        },
        product_option: {
          one: "Opcion adicional",
          other: "Opciones adicionales",
        },
        product_option_value: {
          one: "Valor",
          other: "Valores",
        },
        product_order_field: {
          one: "Opción / campo adicional para completar",
          other: "Opciones / campos adicionales para completar",
        },
        product_pricelist_item: {
          one: "Categoría de precio",
          other: "Categorías de precios",
        },
        product_schedule: {
          one: "Regla de fechas",
          other: "Reglas de fechas",
        },
        product_tag: {
          one: "Etiqueta de oferta",
          other: "Etiquetas de oferta",
        },
        product_tags_category: {
          one: "Categoría de etiquetas de oferta",
          other: "Categorías de etiquetas de oferta",
        },
        product_variant: {
          one: "Tipos de oferta",
          other: "Tipos de oferta",
        },
        tag: {
          one: "Etiqueta",
          other: "Etiquetas",
        },
        view_collection_item: {
          one: "Artículo de colección",
          other: "Artículos de colección",
        },
        view_page: {
          one: "Subpágina",
          other: "Subpáginas",
        },
        view_section: {
          one: "Ver sección",
          other: "Ver secciones",
        },
        company_registration: {
          one: "Registro de la empresa",
          other: "Registros de empresas",
        },
      },
    },
    attributes: {
      abandoned: "Abandonado",
      accomodation: "Alojamiento",
      action: "Acción",
      active: "¿Activo?",
      additional_fee: "Recargo",
      additional_instructions: "Instrucciones adicionales",
      address: "Habla a",
      admin_user: "Administración",
      agent: "Agente",
      agent_commision: "Agente de comisión",
      agent_commision_amount: "Agente de comisión",
      agent_commision_amount_cents: "Comisión de agente [en groszy]",
      agent_commision_percent: "Agente de comisión [%]",
      agent_note: "Nota del agente privado",
      all_day_event: "¿Todo el día?",
      all_products: "Todas las ofertas",
      all_tagged_products: "Todas las ofertas (con esta etiqueta o sus subetiquetas)",
      amount: "Cantidad",
      amount_cents: "Cantidad",
      amount_percentage: "Cantidad porcentual",
      amount_type: "Método de fijación de precios",
      api_version: "Versión API",
      approved: "Confirmado",
      arrival_time: "llegada a",
      assignation_per_item: "por paquete",
      assignation_per_order: "Por orden",
      assignation_per_person: "por persona",
      attachments: "Archivos adjuntos",
      balance: "Saldo del cliente",
      balance_status: "Estado de pago",
      balance_status_for_today: "Estado de pago para hoy",
      bank_wire: "transferencia bancaria",
      bank_wire_account_description: "Detalles de transferencia bancaria",
      bank_wire_account_description_hint: "Solo puede editarlo el administrador principal.",
      birth_date: "Fecha de nacimiento",
      booking_type: "Tipo de reserva",
      boolean_value_type: "Casilla de verificación (sí / no)",
      build: "Crear orden",
      building: "Sequía",
      cancellation_policy: "Política de cancelación",
      cancelled: "Cancelado",
      cash: "En efectivo",
      categories: "Categorias",
      change_status: "Cambio de estado",
      companies_count: "Numero de empresas",
      company: "Empresa",
      company_approval_time_limit: "Límite de tiempo de confirmación de pedido de la empresa",
      company_approval_time_limit_exceeded: "Tiempo de confirmación de la empresa excedido",
      company_approval_time_limit_in_hours: "Límite de tiempo de confirmación de pedido de la empresa [en horas]",
      company_approve: "Confirmación de pedido de la empresa",
      company_automatic_invoice_amount: "Monto por liquidación automática con la Compañía",
      company_automatic_invoice_date: "Fecha de liquidación automática con la Compañía",
      company_cancel: "Pedido cancelado por la empresa",
      company_given_amount_through_online_deposit: "Monto transferido a la Compañía por pago online",
      company_invoice_id: "ID de factura de la empresa",
      company_name: "Nombre de la empresa",
      company_over_received_amount_through_online_deposit:
        "Saldo total de Tripsomnia a la Compañía, teniendo en cuenta solo los pagos online",
      company_received_amount_through_online_deposit: "Monto recibido de la Compañía por pago online",
      company_reject: "Rechazo de pedidos por empresa",
      company_remaining_invoice_amount: "Importe restante a liquidar con la empresa",
      company_tag: "Etiquetas de empresa",
      company_total_invoice_amount: "Importe total a liquidar con la empresa",
      confirm: "Pedido enviado",
      confirmation_installment: "Sirve como confirmación del pedido?",
      confirmation_installment_after_company_approval:
        "¿Pago de depósito en línea solo después de la confirmación del pedido?",
      confirmation_installment_after_company_approval_hint:
        "De lo contrario, el depósito en línea se realiza antes de enviar el pedido (es decir, al realizar el pedido).",
      confirmation_installment_after_company_approval_time_limit:
        "Límite de tiempo para el pago del depósito en línea, después de la confirmación del pedido de la Compañía.",
      confirmation_online_payment_time_limit_exceeded: "Tiempo de pago en línea excedido",
      country: "País",
      coupon: "Cupón / descuento",
      coupon_price: "Precio del vale",
      created_at: "Fecha de creación",
      currency: "Moneda",
      current_password: " Contraseña actual",
      current_sign_in_at: "Fecha de inicio de sesión actual",
      current_sign_in_ip: "IP de inicio de sesión actual",
      customer: "Cliente",
      customer_approval_time_limit: "Límite de tiempo de confirmación de oferta del cliente",
      customer_approval_time_limit_exceeded: "Tiempo de confirmación del cliente excedido",
      customer_approval_time_limit_in_hours: "Límite de tiempo de confirmación de oferta del cliente [en horas]",
      customer_automatic_invoice_amount: "Monto por liquidación automática con el Cliente",
      customer_email: "Dirección de correo electrónico del cliente",
      customer_full_name: "Nombre y apellido del cliente",
      customer_full_name_contains: "Nombre del cliente y apellido",
      customer_hints: "Consejos",
      customer_invoice_id: "ID de factura del cliente",
      customer_invoiced_amount: "Monto liquidado con el Cliente",
      customer_locale: "Idioma del cliente",
      customer_note: "Nota para el proveedor",
      customer_phone_number: "Número de teléfono del cliente",
      customer_remaining_invoice_amount: "Importe restante a liquidar con el Cliente",
      customer_requirements: "Requisitos",
      customer_rules_agreement: "Acuerdo del cliente sobre los términos y condiciones",
      customer_tag: "Etiqueta del cliente",
      customer_total_invoice_amount: "Importe restante a liquidar con el Cliente",
      customers_count: "Numero de clientes",
      dates: "fechas",
      datetime: "Fecha y hora",
      days_count: "Cantidad de días",
      default_marketplace_commision_amount: "Comisión predeterminada (Marketplace) [amount]",
      default_marketplace_commision_percentage: "Comisión predeterminada (Marketplace) [%]",
      default_marketplace_service_fee_amount: "Tarifa de servicio predeterminada (Marketplace) [amount]",
      default_marketplace_service_fee_percentage: "Tarifa de servicio predeterminada (Marketplace) [%]",
      default_saas_commision_amount: "Comisión predeterminada del sistema (SaaS) [amount]",
      default_saas_commision_percentage: "Comisión predeterminada del sistema (SaaS) [%]",
      departure_time: "salida a las",
      deprecated_v1_bank_wire_company_deposit: "Cuenta bancaria de la empresa",
      deprecated_v1_bank_wire_socialtravel_deposit: "Cuenta bancaria Tripsomnia",
      deprecated_v1_excludes_content: "El precio no incluye (v1)",
      deprecated_v1_includes_content: "El precio incluye (v1)",
      deprecated_v1_location_alternative_map_content: "Código de mapa alternativo en la página de oferta (e.g. iframe)",
      deprecated_v1_requirements_content: "Requisitos (v1)",
      description: "Descripción",
      discount: "Descuento",
      discount_amount: "Descuento",
      discount_amount_cents: "Descuento [en groszy]",
      discounted: "¿Oferta con descuento?",
      draft: "Sequía",
      email: "Dirección de correo electrónico",
      end_date: "Fecha final",
      end_time: "Hora de finalización",
      ends_at: "Fecha y hora de finalización",
      exact_amount: "Cantidad",
      exact_date: "Fecha específica",
      excluded_items: "El precio no incluye",
      expire: "Ofertas vencidas",
      expired: "Caducado",
      expired_at: "Fecha de vencimiento",
      expires_at: "Fecha de vencimiento",
      featured_price: "Precio presentado",
      featured_price_before_discount: "Precio presentado antes del descuento",
      file: "Expediente",
      finish: "Orden de acabado",
      finish_online_payment: "Finalizando el pago online",
      finished: "Terminado",
      first_name: "Nombre",
      fluid_date_booking: "Orden de bloque de longitud flexible (v2)",
      frontend_name: "Título (Frontend)",
      frontend_view: "Ver (Frontend)",
      full_name: "Nombre y apellido",
      full_person_name: "Nombre y apellido",
      fully_paid: "Pagado",
      global_role: "Rol global (PA)",
      highlights: "Lo más destacado",
      id: "ID",
      inactive: "No activo",
      included_items: "Precio incluye",
      includes_time: "Incluye tiempo?",
      increase_orders_amount_by_saas_commision: "Agregue la comisión del sistema (SaaS) al monto total del pedido",
      installments: "Cuotas de pago",
      internal_note: "Nota interna (disponible para todos)",
      invoice_date: "Fecha de liquidación",
      issuer: "Autor de acción",
      last_sign_in_at: "Última fecha de inicio de sesión",
      last_sign_in_ip: "IP de inicio de sesión actual",
      last_status_action: "Última acción",
      locale: "Idioma",
      location: "Ubicación",
      location_coordinates: "Coordenadas geográficas",
      location_lat: "Latitud",
      location_lng: "Longitud",
      location_name: "Nueva localización",
      locations: "Localización",
      logo_image: "Logo",
      main_company: "Empresa",
      main_image: "Foto principal",
      marketplace: "Mercado",
      marketplace_commision: "Comisión de Tripsomnia",
      marketplace_commision_amount: "Comisión de Tripsomnia",
      marketplace_commision_amount_cents: "Comisión de Tripsomnia [en groszy]",
      marketplace_commision_percent: "Comisión de Tripsomnia [%]",
      marketplace_featured_price: "Precio presentado (Marketplace)",
      marketplace_featured_price_before_discount: "Precio presentado antes del descuento (Marketplace)",
      marketplace_service_fee: "Tarifa de servicio de Tripsomnia [en groszy]",
      marketplace_service_fee_amount: "Tarifa de servicio de Tripsomnia",
      marketplace_service_fee_amount_cents: "Tarifa de servicio de Tripsomnia [en groszy]",
      marketplace_service_fee_percent: "Tarifa de servicio de Tripsomnia [%]",
      max_days_count: "Max. número de días",
      max_nights_count: "Max. número de días (24 horas)",
      max_number_value: "Max. valor numérico",
      max_order_stock_count: "Número total máximo de paquetes en el pedido",
      max_person_age: "Max. años",
      max_persons_count: "Max. número de personas",
      meta_description: "Descripción de la página (SEO)",
      meta_title: "Título de la página (SEO)",
      min_days_count: "Min. número de días",
      min_nights_count: "Min. número de días (24h)",
      min_order_stock_count: "Cantidad total mínima de paquetes en el pedido",
      min_person_age: "Min. años",
      min_persons_count: "Min. número de personas",
      name: "Nombre",
      nb_stock_useby_date: "Fecha de validez de la oferta ordenada",
      nb_stock_useby_days_limit: "X días después de la confirmación del pedido",
      nb_stock_useby_ends_at: "Fecha de finalización de la validez de la oferta ordenada",
      nb_stock_useby_starts_at: "Fecha de inicio de validez de la oferta ordenada",
      new_status: "Nuevo estado",
      nights_count: "Número de días (24 horas)",
      no_booking: "No hay pedidos",
      note: "Nota",
      number_value_multiplies_price:
        "Multiplique el precio de la opción por un valor numérico (seleccionado por el Cliente)",
      number_value_type: "Numero (0-n)",
      offers_count: "Numero de ofertas",
      on_stock_starts_at: "en oferta a partir del día",
      online_payment: "Pago en línea",
      order: "Orden",
      order_bill: "Cuenta",
      order_customer_participants: "Participantes",
      order_items: "Artículos pedidos",
      order_tag: "Etiqueta de pedidos",
      order_transfers: "Pagos y retiros",
      ordered_product_order_fields: "Opciones / campos adicionales para completar",
      ordered_product_pricelist_items: "Paquetes ordenados",
      orders: "Pedidos",
      orders_count: "Numero de ordenes",
      orders_marketplace_commision_amount_sum: "Comisión total del pedido",
      orders_total_amount_sum: "Cantidad total de pedidos",
      overpaid: "Pagado en exceso",
      paid_after_company_approval: "¿A pagar después de la confirmación de la empresa?",
      paid_amount: "Pagado",
      paid_amount_sum: "Pagado",
      paid_before_company_approval: "¿A pagar antes de la confirmación de la empresa?",
      paid_by_at: "Tiempo límite de pago",
      paid_by_at_formatted: {
        on_stock_starts_at: "en oferta a partir del día",
        x_days_after_order_company_approval: "%{count} después de la confirmación del pedido por parte de la Compañía",
        x_days_after_order_creation: "%{count} después de la creación del pedido",
        x_days_after_order_full_approval: "%{count} después de la confirmación completa del pedido",
        x_days_after_previous_installment:
          "%{count} después de la última entrega (o confirmación / envío del pedido, si es una primera entrega)",
        x_days_before_stock_starts_at: "%{count} antes de la fecha de inicio de la oferta",
        immediately: "antes de guardar la reserva",
      },
      paid_by_time_duration: "Tiempo (x) especificado en la fecha límite de pago",
      paid_by_type: "Tipo de plazo de pago",
      parent: "Padre",
      partly_paid: "Parcialmente pagado",
      password: "Contraseña",
      password_confirmation: "Confirmar contraseña",
      pause: "Pedido en espera",
      payment: "Pago",
      payment_completed: "Terminado",
      payment_failed: "Sin éxito",
      payment_in_progress: "Procesando",
      payment_operations: "Operaciones de pago",
      payment_profile: "Perfil de pago",
      payment_status: "Estado de pago",
      payment_type: "Tipo de pago",
      payment_type_offline: "Offline",
      payment_type_online: "Online",
      payments: "Pagos",
      pdf_voucher: "Comprobante de confirmación de pedido (PDF)",
      pending: "Esperando",
      per_group: "por grupo",
      per_item: "por paquete",
      per_order: "Por orden",
      per_person: "por persona",
      per_product: "por oferta",
      percentage_amount: "%",
      persons_count: "Número de personas",
      phone_number: "Número de teléfono",
      position: "Posición",
      price: "Precio",
      price_currency: "Moneda de precio",
      price_per_group: "precio por grupo",
      price_per_item: "precio por paquete",
      price_per_night: "precio por dia",
      price_per_order: "precio por pedido",
      price_per_person: "precio por persona",
      price_per_person_night: "precio por noche de invitado",
      price_per_product: "Precio por oferta",
      price_type: "Tipo de precio",
      pricing_per_night: "Lista de precios con precio por día (v1)",
      pricing_per_person: "Lista de precios con precio por persona.",
      pricing_per_person_night: "Lista de precios con precio por noche de invitado",
      pricing_per_product: "Lista de precios con precio total por oferta (v1)",
      priority: "Prioridades",
      product: "Oferta",
      product_highlights: "Ofertas destacadas",
      product_images: "Ofrecer fotos",
      product_name: "Nombre de oferta",
      product_option_values: "Valores para la selección",
      product_options: "Opciones adicionales",
      product_or_variant: "Oferta / Variante",
      product_order_fields: "Opciones / campo adicionales para completar",
      product_pricelist: "Lista de precios",
      product_pricelist_item: "Categoría de precio",
      product_pricelist_order_target: "Lista de precios",
      product_product_tags_id: "Etiquetas de oferta",
      product_quantity: "Numero de paquetes",
      product_short_description: "Descripción breve de la oferta",
      product_st_tags: "Etiquetas de Tripsomnia",
      product_tag: "Etiqueta",
      product_tags: "Etiquetas",
      product_tags_category: "Categoría de etiqueta",
      product_tags_id: "Etiqueta",
      product_tags_relation_type: "Tipo de relación de oferta",
      product_unit_name: {
        coupon: {
          one: "vale",
          other: "cupones",
        },
        person: {
          one: "persona",
          other: "personas",
        },
        product: {
          one: "paquete",
          other: "paquetes",
        },
        room: {
          one: "habitación",
          other: "habitaciones",
        },
      },
      product_variant: "Variante de oferta",
      product_variant_name: "Nombre de variante de oferta",
      product_variant_order_target: "Variante",
      product_variants_count: "Número de variantes de oferta",
      products_count: "Numero de ofertas",
      products_have_all_tags: "Conjunción (ofertas con todas las etiquetas de esta categoría)",
      products_have_one_tag: "Alternativa (ofertas con al menos una etiqueta de esta categoría)",
      published: "Publicado",
      published_at: "Fecha de publicación",
      refund: "Oferta de reembolso",
      refund_completed: "Terminado",
      refund_failed: "Ha fallado",
      refund_in_progress: "En progreso",
      refund_new: "Oficial",
      refund_none: "ninguna",
      refund_status: "Estado de reembolso",
      refunded: "Reintegrado",
      refunded_amount: "Reintegrado",
      refunded_amount_sum: "Reintegrado",
      rejected: "Rechazado",
      related_model: "Registro relacionado",
      remaining_amount: "Cantidad restante",
      remaining_total_amount: "Cantidad total",
      remaining_total_amount_sum: "Cantidad total",
      requires_company_approval: "¿El pedido requiere una confirmación de la empresa?",
      role: "Papel",
      saas: "SaaS",
      saas_featured_price: "Precio presentado (SaaS)",
      saas_featured_price_before_discount: "Precio presentado antes del descuento (SaaS)",
      saas_service_fee: "Tarifa de transacción de Tripsomnia",
      select_value_type: "Lista seleccionada",
      service_fee: "Tarifa de servicio",
      short_description: "Breve descripción",
      show_page_title: "Mostrar título del sitio web?",
      sign_in_count: "Número de inicios de sesión",
      slug: "Enlace acortado",
      slug_hint: "Deje este campo en blanco y se generará automáticamente.",
      special_offer: "Oferta especial",
      st_note: "Nota privada para empleados de Tripsomnia",
      start_date: "Fecha de inicio",
      start_dates: "Fecha de inicio",
      start_time: "Hora de inicio",
      start_times: "Hora de inicio",
      starts_at: "Fecha y hora de inicio",
      static_date_booking: "Orden de bloque de longitud fija (v2)",
      status: "Estado",
      stock_end_date: "Fecha final",
      stock_end_datetime: "Hora de salida",
      stock_ends_at: "Hora de salida",
      stock_start_date: "Fecha de inicio",
      stock_start_datetime: "Hora de llegada",
      stock_starts_at: "Hora de llegada",
      stock_time_range: "Fecha",
      stock_useby_time_range: "Fecha de realización",
      supplier: "Proveedor",
      supplier_note: "Nota privada del proveedor",
      tag: "Etiqueta",
      tagged_products: "Ofertas (para esta etiqueta)",
      tags: "Etiquetas",
      time_duration: "Duración",
      time_zone: "Zona horaria",
      time_zone_name: "Zona horaria",
      title: "Título",
      total_amount: "Cantidad total",
      total_amount_sum: "Cantidad total",
      total_base_amount: "Cantidad básica del pedido",
      total_discount: "Importe total de descuento",
      total_discount_amount: "Importe total de descuento",
      total_price: "Precio total",
      total_product_options_price: "Cantidad total para opciones adicionales",
      total_product_price: "Precio total por la oferta",
      total_product_price_before_discount: "Precio total de la oferta antes del descuento",
      total_stock_left: "Límite de oferta restante",
      total_stock_limit: "Límite de oferta",
      total_stock_used: "Oferta límite utilizado",
      transfer_type: "Método de pago",
      translations: "Traducciones",
      translations_name: "Título",
      trip: "Viaje",
      type: "Tipo",
      type_amount: "Cantidad",
      type_percent: "%",
      unpaid: "No pagado",
      updated_at: "Última actualización",
      v1_bank_wire_deposit: "Pago por transferencia bancaria",
      v1_bank_wire_deposit_amount: "Pago por transferencia bancaria",
      v1_bank_wire_deposit_amount_cents: "Pago por transferencia bancaria [en groszy]",
      v1_bank_wire_deposit_deadline: "Fecha límite de recargo por transferencia bancaria",
      v1_bank_wire_deposit_max_payment_date: "Fecha específica",
      v1_bank_wire_deposit_percent: "Pago por transferencia bancaria [%]",
      v1_bank_wire_deposit_postorder_days_limit: "X días después de la confirmación del pedido",
      v1_bank_wire_deposit_postorder_x_days: "%{value} días después de la confirmación del pedido",
      v1_bank_wire_deposit_prearrival_days_limit: "X antes de comenzar la oferta",
      v1_bank_wire_deposit_prearrival_x_days: "%{value} días antes del comienzo de la oferta",
      v1_cash_deposit: "Pago adicional en el acto (en moneda extranjera)",
      v1_cash_deposit_amount: "Pago adicional en el acto (en moneda extranjera)",
      v1_cash_deposit_amount_cents: "Pago adicional en el acto (en moneda extranjera) [en centavos]",
      v1_full_bank_wire_deposit: "Oferta a pagar en 100% por transferencia bancaria",
      v1_full_bank_wire_deposit_hint:
        "Marque si la oferta en lugar de pagarse en el acto debe pagarse mediante transferencia bancaria (100% del precio total).",
      v1_online_deposit: "Depósito en línea",
      v1_online_deposit_percent: "Deposite en línea [%]",
      v1_online_deposit_st_type: {
        deposit: {
          b: "depositar",
          d: "depositar",
          m: "depositar",
        },
        fee: {
          b: "pago",
          d: "pagos",
          m: "pago",
        },
        prepayment: {
          b: "depositar",
          d: "depositar",
          m: "depositar",
        },
      },
      v1_rest_deposit: "Restante por pagar en el acto",
      v1_rest_deposit_amount: "Restante por pagar en el acto",
      v1_rest_deposit_amount_cents: "Restante por pagar en el acto [en groszy / cents]",
      v1_st_company_debt_status: "Estado de liquidación de la empresa",
      v1_st_company_debt_status_amount_to_give: "Transferir pago a la empresa",
      v1_st_company_debt_status_amount_to_receive: "Obtenga una comisión de la compañía",
      v1_st_company_debt_status_short: "Estado de liquidación",
      v1_st_company_debt_status_zero_amount: "Colocado",
      v1_st_company_invoiced_amount: "Monto liquidado con la Compañía",
      v1_st_company_manually_given_amount: "Monto adicionalmente pagado a la Compañía",
      v1_st_company_manually_received_amount: "Monto adicional recibido de la Compañía",
      v1_st_remaining_given_amount: "Importe restante para la empresa",
      v1_st_remaining_received_amount: "Cantidad restante a recibir de la Compañía",
      v1_st_total_given_amount: "Monto total pagado a la Compañía",
      v1_st_total_over_received_amount: "Saldo total de Tripsomnia a la Compañía",
      v1_st_total_received_amount: "Monto total recibido de la Compañía",
      v2_pricing: "Lista de precios por categorías de precios (v2)",
      v2_static_date_booking: "Orden de bloque de longitud fija (v2)",
      value_type: "Tipo de opción",
      variant: "Variante",
      video_url: "URL del video (YouTube / Vimeo)",
      video_url_hint:
        "Si se agrega correctamente, el video debería aparecer en lugar de la foto (solo en el modo de visualización 'Carrusel').",
      view: "Ver",
      view_sections: "Ver secciones",
      waiting_for_company_approval: "Esperando empresa",
      waiting_for_confirmation_online_payment: "Esperando el pago del cliente",
      waiting_for_customer_approval: "Esperando a un cliente",
      website: "Sitio web",
      website_url: "Sitio web",
      week_days: "Días de la semana",
      x_days_after_order_company_approval: "x días después de la confirmación de la empresa",
      x_days_after_order_creation: "x días después de la creación del pedido",
      x_days_after_order_full_approval: "x días después de la confirmación completa del pedido",
      x_days_after_previous_installment:
        "X días después de la entrega anterior (o confirmación / envío del pedido si esta es la primera entrega)",
      x_days_before_stock_starts_at: "x días antes de la fecha de inicio de la oferta",
      x_price_per_item: "%{x} por paquete",
      x_price_per_item_night: "%{x} por paquete por noche",
      x_price_per_order: "%{X}",
      x_price_per_order_night: "%{x} por día",
      x_price_per_person: "%{x} por persona",
      x_price_per_person_night: "%{x} por noche de invitado",
      agent_service_fee: "Tarifa de servicio del agente",
      agent_service_fee_amount: "Tarifa de servicio del agente",
      agent_service_fee_amount_cents: "Tarifa de servicio del agente [en groszy]",
      agent_service_fee_percent: "Tarifa de servicio del agente [%]",
      agent_paid_amount: "Agente pagado",
      agent_received_amount: "Agente recibido",
      agent_remaining_paid_amount: "Por retirada del agente",
      agent_remaining_received_amount: "Cantidad restante para el agente",
      customer_paid_amount: "Cliente pagado",
      customer_received_amount: "Reembolsado al cliente",
      customer_remaining_paid_amount: "A cargo del cliente",
      customer_remaining_received_amount: "Para ser reembolsado al Cliente",
      socialtravel_paid_amount: "Tripsomnia pagada",
      socialtravel_received_amount: "Tripsomnia se retiró",
      socialtravel_remaining_paid_amount: "Por retirada de Tripsomnia",
      socialtravel_remaining_received_amount: "Cantidad restante para Tripsomnia",
      supplier_paid_amount: "Proveedor pagado",
      supplier_received_amount: "Proveedor recibido",
      supplier_remaining_paid_amount: "A cargo del proveedor",
      supplier_remaining_received_amount: "Importe restante para el proveedor",
      author_place: "Fuente",
      author_place_frontend: "Sitio web",
      author_place_partnerapp: "Panel de socios",
      product_locations: "Ofrecer ubicaciones",
      product_pickup_points: "Puntos de encuentro",
      customer_fields: "Campos para completar",
      priced_fields: "Opciones adicionales",
      product_id: "ID de oferta",
      product_variant_id: "ID de variante de oferta",
      pricelist: "Lista de precios",
      payment_profiles: "Perfiles de pago",
      remove_location_coordinates: "Coordenadas geográficas claras",
      test_mode: "Modo de prueba",
      saas_priority: "Prioridad (SaaS)",
      marketplace_priority: "Prioridad (Marketplace)",
      created_on: "Fecha de creación",
      updated_on: "Fecha de última edición",
      affiliate_commision: "Comisión de afiliados",
      affiliate_commision_amount: "Comisión de afiliados",
      affiliate: "Afiliado",
      confirmation_installment_amount: "Depósito en línea",
      bank_wire_account_description_placeholder: "Número de cuenta bancaria e información relacionada.",
      fully_refunded: "Reintegrado",
      over_refunded: "Sobre reembolsado",
      partly_refunded: "Reintegrado parcialmente",
      dotpay: "DotPay",
      paypal: "PayPal",
      agent_outcome: "Ingresos del agente",
      socialtravel_outcome: "Ingresos de Tripsomnia",
      supplier_outcome: "Ingresos del proveedor",
      total_company_outcome: "Ingresos de la empresa",
      agent_disbursement: "Desembolso del agente",
      agent_disbursement_id: "ID de desembolso del agente",
      customer_invoice_amount: "Monto por liquidación automática con el Cliente",
      doesnt_require_company_approval: "El pedido no requiere la confirmación de la Compañía",
      custom_online_payment: "Pago en línea personalizado",
      agent_bank_wire: "Transferencia bancaria del agente",
      supplier_bank_wire: "Transferencia bancaria de proveedores",
      agent_cash: "En efectivo del / al agente",
      supplier_cash: "En efectivo del / al proveedor",
      none: "Ninguna",
      expire_at: "Fecha de caducidad",
      publish_at: "Fecha de publicación",
      expire_from: "Fecha de caducidad",
      stripe: "Stripe",
      author_place_customerapp: "Nuevo sitio web",
      deprecated_v1_booking_type: "",
      deprecated_v1_location_address: "",
      deprecated_v1_location_description: "",
      deprecated_v1_location_full_address: "",
      deprecated_v1_location_full_address_hint_html: "",
      deprecated_v1_location_full_address_placeholder: "",
      deprecated_v1_order_target_type: "",
      deprecated_v1_pricing_type: "",
      deprecated_v1_product_type: "",
      price_show_cash_deposit_amount: "",
      price_show_coupon_price: "",
      price_show_discount_amount: "",
      price_show_discount_percent: "",
      price_show_marketplace_service_fee_amount: "",
      price_show_online_deposit_amount: "",
      price_show_price_per_person: "",
      price_show_total_amount: "",
      price_show_total_amount_with_cash_deposit: "",
      price_show_total_price: "",
      price_show_type: "",
      message: "",
      requested_date: "",
      seller: "",
      discount_percent: "",
      total_discount_amount_cents: "",
      total_price_cents: "",
      total_product_options_price_cents: "",
      total_product_price_before_discount_cents: "",
      total_product_price_cents: "",
      confirmation_installment_amount_cents: "",
      confirmation_installment_paid_amount: "",
      receptionist: "",
      available_to: "",
      available_from: "",
      product_type: "",
      pricing_plan_type: "",
    },
    errors: {
      messages: {
        already_exists: "Tal valor ya existe.",
        has_to_be_in_future: "Tiene que ser una cita en el futuro.",
        installment_not_supported: "Actualmente, esta combinación de pago no es compatible con el sistema Tripsomnia.",
        invalid_installments_position: "Las cuotas de pago tienen un pedido incorrecto.",
        invalid_online_payment_installments:
          'Las cuotas de pago tienen una combinación inadecuada de método de pago. Por el momento, una posible cuota "Pago en línea" debe ser el primer y único pago de este tipo.',
        invalid_participant_data: 'Datos de participante incorrectos "%{participant_name}".',
        invalid_participant_product_option_value:
          'Valor no válido en el campo "%{product_option_name}" para el participante "%{participant_name}".',
        invalid_phone_number_characters: "contiene caracteres no válidos (debe contener solo dígitos)",
        invalid_product_option_value: 'Valor no válido para la opción adicional "%{product_option_name}".',
        invalid_video_url:
          "Tiene un formato no válido. ¿Estás seguro de que es un enlace correcto al video de YouTube / Vimeo?",
        missing_participant_product_option_value:
          'Seleccione el valor en el campo "%{product_option_name}" para el participante "%{participant_name}".',
        missing_product_option_value:
          'Seleccione el valor para la opción adicional requerida "%{product_option_name}".',
        v1_invalid: "valor no permitido para modelos derivados de v1.",
        v1_invalid_installments_transfer_type:
          'Las cuotas de pago tienen una combinación inadecuada de método de pago. En el caso del pedido v1, debe ser una secuencia como "Pago en línea" -> "Cuenta bancaria" -> "Efectivo", con la posible omisión de estas cuotas.',
        invalid_participant_ordered_item:
          'Artículo de pedido no válido asignado al participante "%{participant_name}".',
        invalid_ordered_item_participants_count:
          'Número de participantes no válido para el artículo de pedido "%{ordered_item_name}".',
        empty: "Necesario",
        greater_than: "",
        too_short: "",
        greater_than_or_equal_to: "",
        less_than_or_equal_to: "",
        invalid: "",
      },
      action_impossible_error: {
        code: "",
        http_code: "",
        message: "",
      },
      record_not_found_error: {
        code: "",
        http_code: "",
        message: "",
      },
      wrong_product_order_field_error: {
        code: "",
        http_code: "",
        message: "",
      },
    },
    base: {
      choose: "Escoger",
      connection_error: "Se produjo un error de conexión al intentar conectarse con nuestro servidor.",
      date: {
        day: "Día",
        month: "Mes",
        year: "Año",
      },
      discount: "Descuento",
      discount_coupon: "Descuento",
      every_each: "cada",
      extend: "Ampliar",
      from: "de",
      from_x: "desde %{count}",
      from_x_to_y: "de %{x} a %{y}",
      in_weekdays_xyz: "en %{xyz}",
      loading: "Cargando",
      no: "No",
      read_more: "Lee mas",
      see_more: "Mostrar más",
      to: "a",
      to_x: "para %{count}",
      x_days: {
        one: "%{count} día",
        other: "%{count} días",
      },
      x_hours: {
        one: "%{count} hora",
        other: "%{count} horas",
      },
      x_minutes: {
        one: "%{count} minutos",
        other: "%{count} minutos",
      },
      x_nights: {
        one: "%{count} noche",
        other: "%{count} noches",
      },
      x_orders: {
        one: "%{count} orden",
        other: "%{count} pedidos",
      },
      x_persons: {
        one: "%{count} persona",
        other: "%{count} personas",
      },
      x_seconds: {
        one: "%{count} segundo",
        other: "%{count} segundos",
      },
      yes: "Si",
      x_years: {
        one: "%{count} año",
        other: "%{count} años",
      },
      choose_date: "Elige fecha",
      x_selected_records: {
        one: "%{count} seleccionado",
        other: "%{count} seleccionado",
      },
      since_x: "desde %{x}",
      since_x_until_y: "desde %{x} hasta %{y}",
      until_x: "hasta %{x}",
      for_x_days: {
        one: "para %{count} día",
        other: "por %{count} días",
      },
    },
    components: {
      view_sections: {
        title: {
          read_more: "Mostrar más ofertas",
        },
      },
    },
    date: {
      formats: {
        default: "%d-%m-%Y",
        long: "%A, %e %B %Y",
        short: "%d %b",
        short2: "",
      },
    },
    helpers: {
      select: {
        no_results_message: "No hay resultados",
        prompt: "Escoger",
      },
    },
    languages: {
      en: "Inglés",
      pl: "Polaco",
      ru: "Ruso",
      bg: "Búlgaro",
      hr: "Croata",
      cs: "Checo",
      da: "Danés",
      nl: "Holandés",
      et: "Estonio",
      fi: "Finlandés",
      fr: "Francés",
      de: "Alemán",
      el: "Griego",
      hu: "Húngaro",
      is: "Islandés",
      ga: "Irlandesa",
      it: "Italiano",
      lv: "Letón",
      lt: "Lituano",
      lb: "Luxemburgués",
      mk: "Macedónio",
      mt: "Maltés",
      pt: "Portugués",
      ro: "Rumano",
      sr: "Serbio",
      sk: "Eslovaco",
      sl: "Esloveno",
      es: "Español",
      sv: "Sueco",
      tr: "Turco",
      uk: "Ucranio",
      cy: "Galés",
      ar: "Arabe",
      ca: "Catalán",
      he: "Hebreo",
      th: "Tailandés",
      vi: "Vietnamita",
    },
    number: {
      currency: {
        format: {
          format: "%n %u",
        },
      },
    },
    order_actions: {
      send_approved_order_has_paid_online_deposit_company_sms: {
        sms_content: {
          marketplace:
            "El número de pedido %{order_id} es confirmado y pagado por el cliente. Detalles enviados por correo electrónico.",
          saas: "El número de pedido %{order_id} ha sido confirmado por el Cliente. Los detalles han sido enviados por correo electrónico.",
        },
      },
      send_order_awaits_approval_company_sms: {
        sms_content: {
          marketplace:
            "El número de pedido %{order_id} está esperando confirmación urgente. Los detalles han sido enviados por correo electrónico.",
          saas: "El número de pedido %{order_id} está esperando confirmación urgente. Los detalles han sido enviados por correo electrónico.",
        },
      },
      send_order_has_been_approved_customer_sms: {
        sms_content: {
          after_company_approval: {
            marketplace:
              "El número de pedido %{order_id} ha sido confirmado. Por favor haga un pago. Los detalles han sido enviados por correo electrónico.",
            saas: "Se ha confirmado el número de pedido %{order_id}. Por favor haga un pago. Los detalles han sido enviados por correo electrónico.",
          },
          default: {
            marketplace:
              "El número de pedido %{order_id} ha sido confirmado. Los detalles han sido enviados por correo electrónico.",
            saas: "El número de pedido %{order_id} ha sido confirmado. Los detalles han sido enviados por correo electrónico.",
          },
        },
      },
      send_order_has_been_rejected_customer_sms: {
        sms_content: {
          marketplace:
            "El pedido No. %{order_id} ha sido rechazado por la Compañía. Los detalles han sido enviados por correo electrónico.",
          saas: "El número de pedido %{order_id} ha sido rechazado. Los detalles han sido enviados por correo electrónico.",
        },
      },
      send_order_has_been_cancelled_customer_sms: {
        sms_content: {
          marketplace: "El número de pedido %{order_id} ha sido cancelado. Detalles enviados por correo electrónico.",
          saas: "La Compañía ha cancelado el número de pedido %{order_id}. Detalles enviados por correo electrónico.",
        },
      },
    },
    product_pricelist: {
      lowest_price_is_on: "El precio más bajo se aplica a% {schedule_range}.",
      price_name: "%{price} para %{people}",
      price_per_coupon: "precio por cupón",
      price_per_item: "precio por paquete / grupo",
      price_per_night: "precio por noche",
      price_per_product: "precio por producto",
      price_per_stay: "precio por estadía",
      price_per_tour: "precio por tour",
      sold_out_already: "Esta oferta ya se ha agotado.",
      x_coupons_left: {
        one: "Queda un cupón.",
        other: "Quedan %{count} cupones.",
      },
      x_stocks_left: "Solo %{count} por este precio.",
    },
    "social_travel/new_company_registration_form": {
      errors: {
        company_already_exists:
          "La empresa con esta dirección de correo electrónico ya estaba registrada en nuestro sitio web.",
      },
    },
    time: {
      formats: {
        long: "%A, %e %B %Y at %H:%M",
        short: "%e %b at %H:%M",
        time: "%H:%M",
        short2: "",
      },
    },
    view_collection_item_decorator: {
      offer_read_more: "Mostrar oferta",
      offers_read_more: "Ver ofertas",
    },
    frontend: {
      companies: {
        show: {
          reviews_title: "Opiniones sobre %{marketplace_name}",
          products_calendar: "Calendario de fechas",
          products: "Ofertas",
          reviews: "Opiniones",
          reviews_title_html: "Opiniones sobre %{marketplace_name}",
        },
      },
      company_orders: {
        approve: {
          action_impossible: "Operación imposible. ¿Quizá la prereserva ya haya sido confirmada o rechazada?",
          success:
            'La prereserva Núm. #%{id} de "%{product_name}" (cliente: %{customer_full_name}) ha sido confirmada.',
        },
        finish: {
          action_impossible: "Operación imposible. ¿Quizá la reserva ya ha sido realizada?",
          success: 'La reserva Núm. #%{id} de "%{product_name}" (cliente: %{customer_full_name}) ha sido realizada.',
        },
        reject: {
          action_impossible: "Operación imposible. ¿Quizá la prereserva ya haya sido confirmada o rechazada?",
          success: 'La prereserva Núm. #%{id} de "%{product_name}" (cliente: %{customer_full_name}) ha sido rechazada.',
          success_with_slot_deactivated:
            'La prereserva núm. #%{id} de "%{product_name}" (customer: %{customer_full_name}) ha sido rechazada. Además, la fecha de la reserva ha sido desactivada: no se aceptarán más prereservas para esta fecha.',
        },
        show: {
          admin_app_info_html:
            'Recomendamos iniciar sesión en nuestro <a href="%{partnerapp_order_url}"> panel para gestionar la disponibilidad </a>. A través de él puede gestionar sus ofertas y prereservas de los clientes.',
          approve_order: "Confirmar la reserva",
          finish_order: "Marcar como Realizado",
          order_name: 'Prereserva Núm. %{order_id} de "%{product_name}"',
          order_status: "Estado de la reserva: %{status_i18n}",
          reject_order: "Rechazar la prereserva",
        },
      },
      errors: {
        show: {
          general_error: "Vuelve a cargar la página.",
          general_error_hint_html:
            "Si el error vuelve a ocurrir, intente de nuevo dentro de un momento o reporte este problema, escribiéndonos a %{email}.",
          header: "Se ha producido un error %{error_code}",
          page_not_found: "No se ha encontrado la página seleccionada.",
          page_not_found_hint_html:
            'Vuelva a <a href="%{root_url}"> la página principal</a> o útilice el motor de búsqueda para encontrar la oferta de su interés.',
          title: "Error %{error_code}",
        },
      },
      orders: {
        confirm: {
          already_abandoned_error:
            "Esta prereserva ya ha sido cancelada. Para hacer otra, vuelva al primer paso del formulario de la prereserva.",
          already_confirmed_error:
            "Esta prereserva está en proceso de realización. Vuelva a cargar la página para hacer otra prereserva.",
        },
        new: {
          title: "Reservar: %{product_name}",
        },
        show: {
          title: "Prereserva Núm. %{id}",
        },
        update: {
          already_abandoned_error:
            "Esta prereserva ya se ha cancelado. Para hacer otra, vuelva al inicio del formulario.",
          already_confirmed_error:
            "Esta prereserva ya está en proceso de realización. Vuelva a cargar la página para iniciar otra prereserva.",
        },
      },
      products: {
        show: {
          draft_notice:
            "Estás viendo una oferta que no ha sido publicada. Otros usuarios de la página web la van a ver como no disponible (404).",
          instead_of: "en vez de",
          location_address: "Dirección",
          location_tips: "Indicaciones de cómo llegar",
          make_an_order: "Reservar",
          pay_on_the_spot: "Pagar en el lugar",
          product_shown_in_different_locale_notice:
            "Desgraciadamente, la descripción de la oferta en el idioma que ha seleccionado no existe.",
          product_unavailable: "No hay plazos",
          see_map: "Mostrar el mapa",
          select_product_variant: "Elija una opción",
          similar_locations_title: "Ver más ofertas en esta ubicación",
          similar_products_title: "Le gustarán también",
          youre_saving: "Ahorrará",
          pickup_points: "Puntos de recogida",
          custom_pickup_point_possible: "Recogida del hotel",
          reviews_title: "Opiniones sobre %{company_name}",
          recently_viewed_products_title: "Ofertas recientemente vistas",
          recently_viewed_products_and_categories_title: "Ofertas y categorías recientemente vistas",
          other_locations: "Otras ubicaciones",
          buy_product_cta_button: "Comprar",
          buy_coupon_cta_button: "Descargar el vale",
          see_product_availability_cta_button: "Mostrar disponibilidad",
          choose_coupon: "Elija una opción",
          offer_finished_cta_button: "La oferta ha acabado",
          coupon_finished: "El descuento ha acabado",
          product_finished: "La oferta ha acabado",
          product_expires_at: "La oferta acaba en %{datetime}",
          product_expired_notice: "La oferta que está viendo ha acabado. Ya no es posible hacer la reserva.",
          product_expired: "La oferta ha expirado",
          only_x_coupons_left: "Se han descargado %{total_stock_used} cupones.",
          nb_stock_useby_date_range: "Disponibles para usar %{date_range}",
          no_coupons_left: "La oferta se ha agotado. Se ha alcanzado el límite de ventas.",
          less_than_x_coupons_left: "Quedan menos de %{total_stock_left} cupones disponibles.",
          quicknav: {
            description: "Descripción",
            includes: "El precio incluye",
            requirements: "Requisitos",
            map: "Mapa",
            reviews: "Opiniones",
          },
          reviews_title_html: 'Opiniones sobre <a href="%{company_url}">%{company_name}</a>',
          not_available_notice: "",
        },
        search: {
          filter_query_title: "Buscar por texto",
          toggle_filters: "Filtrar los resultados",
          filter_query_placeholder: "Introduzca una frase de búsqueda",
          location_query_title: "Buscar en esta zona",
          location_query_label: "en el radio",
          location_query_placeholder: "¿Dónde?",
          date_query_title: "Fecha",
          categories_query_title: "Categorías",
          locations_query_title: "Regiones",
          locales_query_title: "Idioma",
          no_results_message:
            "Lo sentimos, no se han encontrado ningunas ofertas que coincidan con sus criterios de búsqueda. Trate de especificarlos de otra manera.",
          shown_results: "Mostrando resultados %{start} - %{end} de %{total_count}",
          previous_page: "Anterior",
          next_page: "Siguiente",
          site_title: {
            around_location: "Buscar cerca de %{location}",
            with_category_and_location: "Ofertas de la categoría %{category} en %{location}",
            with_category: "Ofertas de la categoría %{category}",
            with_location: "Ofertas en %{location}",
            default: "Ofertas",
          },
        },
        history: {
          site_title: "Ofertas recientemente vistas",
          viewed_products_title: "Recientemente ha visto",
          similar_to_viewed_products_title: "Le puede interesar también",
          viewed_products_tags_title: "Vea también",
        },
      },
      reviews: {
        new: {
          site_title: "Añade una opinión",
          review_details_title: "Su opinión",
          content_placeholder: "Describa brevemente qué le gustó y qué se podría mejorar.",
          rating_label: "Elija una puntuación...",
          personal_details_title: "Sus datos",
          locale_label: "Idioma",
          age_group_label: "Su edad",
          group_type_label: "Tipo de grupo",
          author_name_label: "Su nombre",
          author_email_label: "Su correo electrónico",
          st_details_title: "¿Cómo valoraría el proceso de la reserva?",
          st_rating_label: "Elija una puntuación...",
          st_feedback_placeholder: "¿Por qué?",
          submit: "Envíe la opinión",
          add_success_message: "Su opinión se ha añadido. ¡Gracias!",
          error_message: "Se ha producido un error al guardar el formulario.",
          review_for_given_order_already_exists:
            "Su opinión sobre este viaje ya se ha añadida. No es posible escribirla de nuevo ni editarla.",
          order_id: "Localizador",
          product: "Oferta",
          author_email_hint: "No lo vamos a mostrar a nadie.",
          add_review_title_about_product: 'Añada una opinión sobre "%{product_name}" y %{company_name}',
          add_review_title_about_company: "Añada una opinión sobre %{company_name}",
        },
      },
    },
    layouts: {
      application: {
        contact: {
          about_us: {
            title: "Quienes somos",
          },
          contact_us: {
            title: "Póngase en contacto con nosotros",
          },
          cooperating_with: {
            dotpay_payments: "Pagos a través de los sistemas DotPay y PayPal",
            title: "Colaboramos con",
          },
          see_us_on_facebook: {
            title: "Síguenos en Facebook",
          },
          write_to_us: {
            title: "Escríbanos",
          },
          payment_gateways: {
            title: "Métodos de pago",
            description: "Aceptamos pagos con tarjeta, por transferencia bancaria o PayPal.",
          },
        },
        footer: {
          about_us: "Quienes somos",
          careers: "Trabajo",
          cooperation: "Colaboración",
          faq: "FAQ",
          help: "Ayuda",
          privacy_policy: "Política de privacidad",
          rules_note_html: 'El uso de ste sitio web implica aceptación del <a href="%{rules_url}">reglamento</a>.',
        },
        guaranteed: {
          read_more: "Ve cómo funciona Tripsomnia.com",
          s1: {
            line1: "Ofertas cuidadosamente seleccionadas",
            line2: "de los mejores organizadores.",
            title: "Alta calidad",
          },
          s2: {
            line1: "Descuentos hasta un 50%!",
            line2: "Negociados especialmente para ti.",
            title: "Precios más bajos",
          },
          s3: {
            currency: "PLN",
            line1:
              "Pague en cuotas, en línea a través de nuestra plataforma de pago, directamente a la cuenta de la Empresa o en efectivo en el lugar.",
            title: "Pagos seguros",
          },
          s4: {
            line1: "Aventuras increíbles, tours, atracciones - todo en un solo lugar!",
            title: "Reservar en línea",
          },
          title: "Garantizamos",
        },
        navbar: {
          about_us: "Quienes somos",
          for_business: "Colaboración",
          products_calendar: "Calendario de fechas",
          search_placeholder: "Buscar una oferta, ubicación o categoría",
          products_history: "Historial (%{count})",
          contact: "Contacto",
          faq: "Las preguntas más frecuentes",
          open_chat: "Chat",
          cart: "Cesta (%{count})",
          finish_order: "Completa la prereserva: %{product_name} (%{total_amount})",
          company_reviews: "Opiniones",
        },
      },
      mailer: {
        greetings: "Un saludo,",
        marketplace: {
          footer_headline: "Tripsomnia. com - ¡Nos Gusta Viajar!",
        },
        footer_phone: "Tel.",
        footer_email: "Correo electrónico:",
      },
    },
    pdfs: {
      order_voucher: {
        cancellation_policy: "Política de cancelación",
        cancellation_policy_description:
          "Esta oferta no es reembolsable. La reserva no se podrá cambiar o cancelar. Si el participante está ausente, no se reembolsará el monto pagado.",
        company_details: "Datos de la empresa",
        contact_email: "Correo electrónico",
        contact_facebook_url: "Facebook",
        contact_full_address: "Dirección",
        contact_phone_number: "Número de teléfono de contacto",
        contact_website_url: "Página web",
        generated_date: "Generado: %{date}",
        got_any_questions: "¿Tienes preguntas?",
        order_details: "Sus datos de contacto",
        order_number: "Localizador",
        product_details: "Detalles de la oferta",
        st_headline: "Tripsomnia.com - Nos Encanta Viajar",
        title: "Confirmación de la reserva Núm. %{order_id}",
        wish_you_great_journey: "¡Qué tengas una experiencia inolvidable!",
        your_order: "Su prereserva",
        footer_phone: "Tel.",
        footer_email: "Correo electrónico:",
        code: "Código: %{code}",
      },
      slot_manifest: {
        customer_name_placeholder: "Prereserva",
        generated_on: "Fecha generada %{date}",
        page_title: "Manifiesto de la fecha",
      },
    },
    admin_user_mailer: {
      company_created_you_an_account: {
        action: "Establezca su contraseña",
        greeting: "¡Hola %{recipient}!",
        instruction:
          "La empresa %{company_name} ha creado una cuenta para usted en el panel de Tripsomnia donde va a poder gestionar las reservas y ofertas de viajes turísticos.",
        instruction_2:
          "Para iniciar la sesión en la página, pulse el enlace de abajo que le permitirá establecer su contraseña.",
        instruction_3: "Si no ha solicitado acceso a este sitio web, por favor, ignore este mensaje.",
        subject: "La empresa %{company_name} ha creado una cuenta para usted en el panel de los socios de Tripsomnia",
      },
      company_invited_you_to_become_a_member: {
        action: "Ir al Panel de la Empresa",
        greeting: "¡Hola %{recipient}!",
        instruction:
          "La empresa %{company_name} le ha asignado una cuenta en el panel de Tripsomnia donde va a poder gestionar las reservas y ofertas de viajes turísticos.",
        instruction_2: "Haga clic en el en siguiente enlace para acceder al panel.",
        subject: "La empresa %{company_name} le ha asignado acceso al Panel de socios de Tripsomnia",
      },
    },
    company_mailer: {
      agent_invitation_received: {
        action: "Ir al panel de la colaboración",
        greeting: "¡Hola %{company_name}!",
        instruction: "La empresa %{supplier_name} le ha invitado a la cooperación para que pueda vender sus ofertas.",
        instruction_2:
          "Haga clic en el en siguiente enlace para acceder al panel y ver los detalles de la colaboración.",
        subject: "La empresa %{supplier_name} le ha invitado a la cooperación",
      },
      company_and_user_created_agent_invitation_received: {
        action: "Establezca su contraseña",
        greeting: "¡Hola %{company_name}!",
        instruction: "La empresa %{supplier_name} le ha invitado a la cooperación para que pueda vender sus ofertas.",
        instruction_2: "",
        instruction_3:
          "Haga clic en el enlace de abajo para establecer su contraseña a la cuenta y ver los detalles de la colaboración.",
        subject: "La empresa %{supplier_name} le ha invitado a la cooperación",
      },
      company_created_and_agent_invitation_received: {
        action: "Ir al panel de la colaboración",
        greeting: "¡Hola %{company_name}!",
        instruction: "La empresa %{supplier_name} le ha invitado a la cooperación para que pueda vender sus ofertas.",
        instruction_2: "Haga clic en el enlace de abajo para acceder al panel y ver los detalles de la colaboración.",
        subject: "La empresa %{supplier_name} le ha invitado a la cooperación.",
      },
      company_registration_approved: {
        action: "Acceder al panel",
        greeting: "¡Hola %{company_name}!",
        instruction:
          "Le hemos creado una cuenta de la empresa %{company_name} en nuestro panel de Tripsomnia donde va a poder gestionar las reservas y ofertas de viajes turísticos.",
        instruction_2:
          'Haga clic en el enlace a continuación para ir al panel y ver los detalles de cooperación. El enlace está activo durante 48 horas, si no puede iniciar sesión dentro de estas horas, utilice la opción "Recordatorio de contraseña" para recuperar el acceso a la cuenta.',
        subject: "Se ha creado una cuenta de la empresa %{company_name} en el panel de Tripsomnia",
      },
      company_registration_approved_and_user_created: {
        action: "Establezca su contraseña",
        greeting: "¡Hola %{company_name}!",
        instruction:
          "Le hemos creado una cuenta de la empresa %{company_name} en nuestro panel de Tripsomnia donde va a poder gestionar las reservas y ofertas de viajes turísticos.",
        instruction_2: "",
        instruction_3:
          'Haga clic en el enlace a continuación para ir al panel y ver los detalles de cooperación. El enlace está activo durante 48 horas, si no puede iniciar sesión dentro de estas horas, utilice la opción "Recordatorio de contraseña" para recuperar el acceso a la cuenta.',
        subject: "Se ha creado una cuenta de la empresa %{company_name} en el panel de Tripsomnia",
      },
      company_registration_created: {
        action: "Ver los detalles de la inscripción",
        greeting: "¡Hola!",
        instruction: "Alguien ha rellenado el formulario de la inscripción con los siguientes datos:",
        subject: "La empresa %{company_name} solicita registrarse en el panel ST",
      },
      customer_review_submitted: {
        greeting: "¡Hola %{company_name}!",
        new_review_has_been_submitted: "Se ha añadido una opinión sobre su empresa en la plataforma de Tripsomnia.",
        action: "Ver la opinión",
        subject: "Se ha presentado una nueva opinión sobre su empresa",
      },
      company_and_user_created_supplier_invitation_received: {
        action: "Establece tu contraseña",
        greeting: "Hola %{nombre_proveedor}!",
        instruction:
          "La empresa %{agent_name} lo ha invitado a la cooperación de la agencia para que puedan vender sus ofertas.",
        instruction_2: "",
        instruction_3:
          "Haga clic en el enlace a continuación para configurar la contraseña de su cuenta y ver los detalles de cooperación.",
        subject: "La empresa %{agent_name} lo ha invitado a cooperar con la agencia.",
      },
      company_created_and_supplier_invitation_received: {
        action: "Ir al panel de cooperación",
        greeting: "Hola %{nombre_proveedor}!",
        instruction:
          "La empresa %{agent_name} lo ha invitado a la cooperación de la agencia para que puedan vender sus ofertas.",
        instruction_2: "Haga clic en el enlace a continuación para ir al panel y ver los detalles de cooperación.",
        subject: "La empresa %{agent_name} lo ha invitado a cooperar con la agencia",
      },
      supplier_invitation_received: {
        action: "Ir al panel de cooperación",
        greeting: "Hola %{nombre_proveedor}!",
        instruction:
          "La empresa %{agent_name} lo ha invitado a la cooperación de la agencia para que puedan vender sus ofertas.",
        instruction_2: "Haga clic en el enlace a continuación para ir al panel y ver los detalles de cooperación.",
        subject: "La empresa %{agent_name} lo ha invitado a cooperar con la agencia",
      },
    },
    order_mailer: {
      base: {
        company_approve_order: "Confirmar la prereserva",
        company_finish_order: "Marcar como Realizado",
        company_reject_order: "Rechazar la prereserva",
        company_see_order: "Ver la prereserva",
        customer_repeat_order: "Repita la reserva",
        customer_see_all_offers: "Ver todas las ofertas disponibles",
        customer_see_nearby_offers: "Ver otras ofertas en esta zona",
        customer_see_offer: "Ver la oferta",
        hello_company: "¡Bienvenido %{company_name}!",
        hello_customer: "Bienvenido %{customer_full_name},",
        order_status: "Estado de la reserva: %{status_i18n}",
        company_reject_order_and_deactivate_slot: "Rechazar la prereserva y dejar de vender en esta fecha",
      },
      company_order_footer: {
        line1_html: "Su oferta está disponible en el sitio web en el siguiente enlace: %{product_link}.",
        line2_html:
          'Puede gestionarla desde <a href="%{partnerapp_order_url}"> el panel para gestionar la disponibilidad</a>.',
      },
      order_about_to_start_reminder_company_email: {
        p1_html:
          'El viaje de %{customer_full_name} núm. %{order_id} de "%{product_name}" empieza ya dentro de %{days_to_start} días (%{stock_start_date}).',
        p2_html:
          'A modo de recordatorio, le enviamos los datos de su reserva. La confirmación de su reserva en su versión imprimible la hemos enviado en el correo anterior, pero si no puede encontrarlo, puede también bajar el archivo pdf haciendo clic en <a href="%{customer_pdf_order_url}">este enlace</a>.',
        subject:
          'La prereserva núm. %{order_id} de "%{product_name}" empieza dentro de %{days_to_start} días (cliente: %{customer_full_name})',
      },
      order_about_to_start_reminder_customer_email: {
        marketplace: {
          p1_html:
            '¡Su prereserva núm. %{order_id} de "%{product_name}" empieza ya dentro de %{days_to_start} días, esto es el %{stock_start_date}!',
          p2_html:
            'A modo de recordatorio, le enviamos los detalles de su reserva. La confirmación de la reserva en su versión imprimible la hemos enviado en el correo anterior, pero si no puede encontrarlo, puede también bajar el archivo pdf haciendo clic en <a href="%{customer_pdf_order_url}">este enlace</a>.',
        },
        saas: {
          p1_html:
            '¡Su reserva núm. %{order_id} de "%{product_name}" empieza ya dentro de %{days_to_start} días, esto es el %{stock_start_date}!',
          p2_html:
            'A modo de recordatorio, le enviamos los detalles de su reserva. La confirmación de la reserva en su versión imprimible la hemos enviado en el correo anterior, pero si no puede encontrarlo, puedes también bajar el archivo pdf haciendo clic en <a href="%{customer_pdf_order_url}">este enlace</a>.',
        },
        subject: 'Su viaje "%{product_name}" empieza dentro de %{days_to_start días',
      },
      order_company_approval_time_limit_exceeded_company_email: {
        line1:
          'Desgraciadamente, tuvimos que rechazar su prereserva núm. <%{order_id} a nombre de %{customer_full_name} de "%{product_name}" para la fecha de (%{stock_time_range}) debido a que no que no ha respondido en el plazo previsto.',
        line2:
          "Si no tiene plazas disponibles en la fecha seleccionada en esta prereserva, por favor, actualice la disponibilidad en el panel de los socios.",
        subject:
          "La prereserva núm. %{order_id} ha sido rechazada: no ha confirmado la prereserva en el plazo previsto (cliente: %{customer_full_name})",
        line1_html:
          'Desgraciadamente, tuvimos que rechazar la prereserva núm. <a href="%{partnerapp_order_url}">%{order_id}</a> a nombre de %{customer_full_name} de "%{product_name}" para la fecha de (%{stock_time_range}) debido a que no que no ha respondido en el plazo previsto.',
      },
      order_company_approval_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>Desgraciadamente, tuvimos que rechazar automáticamente su prereserva núm. <%{order_id} de "%{product_name}" (%{stock_time_range})</strong> por falta de respuesta de nuestro socio %{company_name} en el plazo previsto %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "El pago recibido %{confirmation_installment_paid_amount} será reembolsado a su cuenta bancaria en las siguientes 24 horas.",
        },
        saas: {
          line1_html:
            '<strong>Desgraciadamente, tuvimos que rechazar automáticamente su prereserva núm. <%{order_id} de "%{product_name}" (%{stock_time_range})</strong> por haber excedido el tiempo máximo previsto para la confirmación - %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "El pago recibido %{confirmation_installment_paid_amount} será reembolsado a su cuenta bancaria en las siguientes 24 horas.",
        },
        subject:
          "La prereserva núm. %{order_id} ha sido rechazada: no hemos recibido la confirmación de la prereserva en el plazo previsto",
      },
      order_current_status_customer_email: {
        marketplace: {
          p1: "Le enviamos el estado actual de su reserva.",
        },
        saas: {
          p1: "Le enviamos el estado actual de su reserva.",
        },
        subject: 'Reserva núm. %{order_id}, estado actual: %{status_i18n} ("%{product_name}")',
      },
      order_finished_add_opinion_reminder_customer_email: {
        marketplace: {
          add_review: "Añade su opinión",
          contact_us:
            "Si tiene algún comentario sobre el trabajo de nuestro sistema Tripsomnia o sobre el servicio al cliente, póngase en contacto con nosotros.",
          share_your_opinion_html:
            "Ayuda a otros turistas y expresa tu opinión sobre nosotros %{company_link} y nuestra oferta %{product_link}.",
          thank_you_html:
            "Gracias por hacer la prereserva a través de Tripsomnia.com y usar los servicios de la empresa.",
        },
        saas: {
          add_review: "Añada su opinión",
          contact_us:
            "Si tiene algún comentario sobre el trabajo de nuestro sistema Tripsomnia o sobre el servicio al cliente, póngase en contacto con nosotros.",
          share_your_opinion_html:
            "Ayuda a otros turistas y expresa tu opinión sobre nosotros %{company_link} y nuestra oferta %{product_link}.",
          thank_you_html: "Gracias por utilizar nuestros servicios.",
        },
        subject: 'Añada su opinión sobre: "%{product_name}" (%{company_name})',
      },
      order_is_approved_company_email: {
        no_online_deposit_subject: "Su prereserva núm. %{order_id} ha sido confirmada (cliente: %{customer_full_name})",
        online_deposit_after_company_approval_subject:
          "La reserva núm. %{order_id} ha sido confirmada y pagada (cliente: %{customer_full_name})",
        online_deposit_before_company_approval_subject:
          "La reserva núm. %{order_id} ha sido confirmada y pagada (cliente: %{customer_full_name})",
        online_deposit_paid:
          "El cliente ha pagado el anticipo %{confirmation_installment_paid_amount} de la prereserva núm. %{order_id} na %{product_name}. La prereserva ha sido confirmada.",
        order_approved: 'La prereserva núm. %{order_id} de "%{product_name}" ha sido confirmada.',
        order_cant_be_cancelled_now: "A partir de este momento ya no se puede cancelar esta prereserva.",
        order_infos_below:
          "Abajo encontrarás los detalles de la reserva. Adjuntamos el voucher pdf con la confirmación de la reserva que se ha enviado al cliente.",
        remember_to_set_order_as_finished:
          'Después de haber realizado la reserva, recuerde que debes marcarla como "Realizada".',
        voucher: {
          line1_html: "",
          line2_html: "",
        },
      },
      order_is_approved_customer_email: {
        marketplace: {
          bank_wire_deposit_additional_info:
            "En el título de la transferencia, ponga, por favor, solamente el localizador de la prereserva que está en esta confirmación. En caso contrario, no podremos garantizar que la transferencia sea liquidada a tiempo.",
          bank_wire_deposit_deadline_html:
            "<strong>No se olvide de hacer la transferencia a tiempo. </strong> Si no paga el adelanto en el plazo previsto, su prereserva podrá cancelarse.",
          bank_wire_deposit_make_html: "Por favor, efectúe el pago por transferencia bancaria.",
          bank_wire_deposit_required: "Su prereserva requiere un pago adicional a la cuenta.",
          order_approved_by_company:
            '¡Su prereserva núm. %{order_id} de "%{product_name}" ha sido confirmada por %{company_name}!',
          order_created: "¡Gracias por hacer la reserva a través de Tripsomnia.com!",
          order_data_and_deposit_received: "Hemos recibido toda la información necesaria, así como el pago.",
          order_data_received: "Hemos recibido toda la información necesaria.",
          this_is_confirmation:
            "Este correo electrónico es la confirmación de su reserva. Adjunta encontrarás la confirmación con la información más importante. Puede guardar la confirmación en su teléfono o imprimirla.",
          order_approved_by_customer: 'Su prereserva núm. %{order_id} de "%{product_name}" se ha confirmado.',
          voucher: {
            line1_html: "",
            line2_html: "",
          },
        },
        saas: {
          bank_wire_deposit_additional_info:
            "En el título de la transferencia, ponga por favor solamente el localizador de la prereserva que está en esta confirmación. En caso contrario, no podremos garantizar que la transferencia sea liquidada a tiempo.",
          bank_wire_deposit_deadline_html:
            "<strong>No se olvide que debe hacer la transferencia a tiempo. </strong> Si no paga el adelanto en el plazo previsto, su prereserva podrá cancelarse.",
          bank_wire_deposit_make_html: "Por favor, efectúe el pago por transferencia bancaria",
          bank_wire_deposit_required: "Su reserva requiere un pago adicional a la cuenta.",
          order_approved_by_company: 'Hemos confirmado su prereserva núm. %{order_id} de "%{product_name}"!',
          order_created: "¡Gracias por hacer la reserva!",
          order_data_and_deposit_received: "Hemos recibido toda la información necesaria, así como el pago.",
          order_data_received: "Hemos recibido toda la información necesaria.",
          this_is_confirmation:
            "Este correo electrónico es la confirmación de su prereserva. Adjunta encontrarás la confirmación con la información más importante. Puede guardar la confirmación en su teléfono o imprimirla.",
          order_approved_by_customer: 'Su prereserva núm. %{order_id} de "%{product_name}" ha sido confirmada.',
          voucher: {
            line1_html: "",
            line2_html: "",
          },
        },
        subject: 'Confirmación de la reserva núm. %{order_id} de "%{product_name}"',
      },
      order_is_waiting_for_company_approval_company_email: {
        confirmation_deadline_warning: "",
        future_online_deposit_info:
          "Si confirma la prereserva, el cliente tendrá %{confirmation_installment_after_company_approval_time_limit} horas para pagar %{confirmation_installment_st_name_d} en línea la cantidad de %{confirmation_installment_transaction_amount}.",
        order_received: 'Hemos recibido la prereserva núm. %{order_id} de "%{product_name}".',
        past_online_deposit_info:
          "El cliente ha realizado %{confirmation_installment_st_name_b} el pago en línea por la cantidad de %{confirmation_installment_paid_amount} para asegurar su prereserva. Si rechaza la prereserva %{confirmation_installment_st_name}, la cuota pagada en línea se reembolsará automáticamente al cliente.",
        please_confirm: "Por favor, confirme la prereserva hasta el %{pauses_at}.",
        subject: "La prereserva núm. %{order_id} está pendiente de confirmación (cliente: %{customer_full_name})",
        order_approved_by_customer: 'El cliente ha confirmado la prereserva núm. %{order_id} de "%{product_name}".',
        voucher: {
          line1_html: "",
          line2_html: "",
        },
      },
      order_is_waiting_for_company_approval_customer_email: {
        marketplace: {
          company_approval_deadline:
            "La empresa tiene %{company_approval_time_limit} para responderle, sin embargo, la mayoría de las empresas responde en una hora durante el horario laboral de la oficina.",
          order_is_waiting_for_company_approval:
            'La prereserva núm. %{order_id} de "%{product_name}" está ahora pendiente de confirmación de nuestro socio %{company_name}.',
          thank_you_for_order: "Gracias por hacer la prereserva a través de Tripsomnia.com.",
          thank_you_for_order_and_online_deposit:
            "Gracias por hacer la prereserva a través de Tripsomnia.com y realizar el pago en línea %{confirmation_installment_st_name_d} por %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "Si su prereserva se confirma, recibirá un correo electrónico con la confirmación de la reserva, junto con un enlace para realizar %{confirmation_installment_st_name_d} pago en línea por la cantidad de %{confirmation_installment_amount}. Desde el momento en el que la empresa confirma su reserva, tendrá %{confirmation_installment_after_company_approval_time_limit} para realizar la transferencia a través de nuestro sistema de pagos en línea.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "En caso de falta de pago en el plazo mencionado, su prereserva será automáticamente rechazada.",
          what_with_no_deposit_if_order_gets_approved:
            "Si su prereserva se confirma, recibirá un correo electrónico con la confirmación de la reserva, así como con la información acerca del pago.",
          what_with_paid_deposit_if_order_gets_approved:
            "Si su prereserva se confirma, el pago realizado será asignado a la reserva. Si la empresa %{company_link} rechaza la prereserva o no la confirma a tiempo, la cantidad de %{confirmation_installment_st_name} será automáticamente reembolsada a su cuenta bancaria en las próximas 24 horas.",
          thank_you_for_order_approval: "Gracias por haber confirmado la prereserva a través de Tripsomnia.com.",
        },
        saas: {
          company_approval_deadline:
            "Tenemos %{company_approval_time_limit} para contestarle, pero normalmente respondemos en 1 hora en el horario de nuestra oficina.",
          order_is_waiting_for_company_approval:
            'La prereserva núm. %{order_id} de "%{product_name}" está pendiente de nuestra confirmación.',
          thank_you_for_order: "Gracias por hacer la prereserva.",
          thank_you_for_order_and_online_deposit:
            "Gracias por hacer la prereserva y realizar el pago en línea %{confirmation_installment_st_name_d} por la cantidad de %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "Si confirmamos su prereserva, recibirá un correo electrónico con un enlace para realizar el pago %{confirmation_installment_st_name_d} en línea por la cantidad de %{confirmation_installment_amount}. Tiene %{confirmation_installment_after_company_approval_time_limit} a partir del momento en que se confirme la prereserva para realizar el pago por Dotpay.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "En caso de falta de pago en el plazo mencionado, su prereserva será automáticamente rechazada.",
          what_with_no_deposit_if_order_gets_approved:
            "Si confirmamos su prereserva, recibirá un correo electrónico con la confirmación y la información acerca del pago.",
          what_with_paid_deposit_if_order_gets_approved:
            "En caso de que nos veamos obligados a rechazar su prereserva o le dejemos expirar, el pago de %{confirmation_installment_st_name} en línea será automáticamente reembolsado a su cuenta bancaria en 24 horas. Podrá también ponerse en contacto con nosotros y elegir otra oferta.",
          thank_you_for_order_approval: "Gracias por haber confirmado la prereserva",
        },
        subject: 'La prereserva núm. %{order_id} está en espera de confirmación ("%{product_name}")',
      },
      order_is_waiting_for_confirmation_online_payment_company_email: {
        line1:
          'La prereserva núm. %{order_id} de "%{product_name} ha sido confirmada y actualmente está pendiente del pago del cliente %{confirmation_installment_transaction_amount} a través de nuestro sistema de pagos en línea.',
        line2:
          "En caso de falta del pago del cliente en el plazo previsto (esto es, hasta %{pauses_at}), la prereserva se cancelará automáticamente.",
        subject: "La prereserva núm. %{order_id} está pendiente del pago (cliente: %{customer_full_name})",
      },
      order_is_waiting_for_confirmation_online_payment_customer_email: {
        after_company_approval_subject:
          "La prereserva núm. %{order_id} actualmente está pendiente de pago (%{product_name})",
        default_subject: 'La prereserva núm. %{order_id} está pendiente de pago ("%{product_name}")',
        marketplace: {
          deadline_warning:
            "En caso de falta de pago en el plazo mencionado, su prereserva será automáticamente rechazada.",
          order_approved: 'La empresa ha confirmado su reserva núm. %{order_id} de "%{product_name}".',
          pay_button: "Pagar en línea",
          payment_deadline: "Plazo para el pago: %{pauses_at}",
          please_pay:
            "Por favor, realice el pago por la cantidad de %{confirmation_installment_transaction_amount} a través de nuestro sistema de pagos en línea seguro.",
        },
        saas: {
          deadline_warning:
            "En caso de falta de pago en el plazo mencionado, su prereserva será automáticamente rechazada.",
          order_approved: 'Hemos confirmado su prereserva núm. %{order_id} de "%{product_name}".',
          pay_button: "Pagar en línea",
          payment_deadline: "Plazo de pago: %{pauses_at}",
          please_pay:
            "Por favor, realice el pago por la cantidad de %{confirmation_installment_transaction_amount} a través de nuestro sistema de pagos en línea seguro.",
        },
      },
      order_is_waiting_for_customer_approval_customer_email: {
        marketplace: {
          action: "Confirmar la prereserva",
          approval_deadline: "",
          deadline_warning:
            "En caso de que no se confirme la prereserva en el plazo previsto arriba, su prereserva se cancelará automáticamente.",
          order_approved:
            'La empresa %{company_name} envia detalles de su prereserva núm. %{order_id} de "%{product_name}".',
          please_approve: "Por favor, confirme la prereserva a través del enlace de abajo.",
          approve_action: "Confirmar la prereserva",
          reject_action: "Rechazar la prereserva",
        },
        saas: {
          action: "Confirmar la prereserva",
          approval_deadline: "",
          deadline_warning:
            "En caso de que no se confirme su prereserva en el plazo previsto arriba, su prereserva se cancelará automáticamente.",
          order_approved: 'Hemos confirmado su prereserva núm. %{order_id} de "%{product_name}".',
          please_approve: "Por favor, confirme la prereserva través del enlace de abajo.",
          approve_action: "Confirmar la prereserva",
          reject_action: "Rechazar la prereserva",
        },
        subject: 'Por favor, confirme la prereserva núm. %{order_id} ("%{product_name}")',
      },
      order_online_deposit_time_limit_exceeded_company_email: {
        line1:
          'Nos vimos obligados a rechazar la prereserva núm. %{order_id} de %{customer_full_name} de "%{product_name}" (%{stock_time_range}) debido a falta de pago en línea del cliente en el plazo previsto. Póngase en contacto con el cliente para aclarar las circunstancias y hacerle volver.',
        subject:
          "La prereserva núm. %{order_id} ha sido rechazada: el cliente no ha pagado %{confirmation_installment_st_name_d} en el plazo previsto (cliente: %{customer_full_name})",
      },
      order_online_deposit_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>Desgraciadamente, tuvimos que rechazar su prereserva núm. %{order_id} de "%{product_name}"</strong> por falta de pago en el plazo previsto.',
          line2:
            "El pago recibido %{confirmation_installment_paid_amount} lo vamos a devolver a su cuenta en las siguientes 24 horas.",
          line3_html:
            "Si le gustaría volver a reservar la oferta, acceda a la subpágina con la oferta: %{product_link}",
        },
        saas: {
          line1_html:
            '<strong>Desgraciadamente, tuvimos que rechazar su prereserva núm. <%{order_id} de "%{product_name}" (%{stock_time_range})</strong> por falta de pago en el plazo previsto.',
          line2:
            "El pago recibido %{confirmation_installment_paid_amount} lo vamos a devolver a su cuenta en las siguientes 24 horas.",
          line3_html:
            "Si le gustaría volver a reservar la oferta, acceda a la subpágina con la oferta: %{product_link}",
        },
        subject:
          "La prereserva núm. %{order_id} ha sido rechazada: no ha pagado %{confirmation_installment_st_name_d} en el plazo previsto",
      },
      order_online_payment_reminder_customer_email: {
        marketplace: {
          contact_us_if_problems: "En caso de cualquier problema con la prereserva, póngase en contacto con nosotros.",
          line1:
            'Hasta ahora no hemos recibido el pago por su prereserva núm. %{order_id} de "%{product_name}". Por haber vencido el plazo previsto para el pago, nos vimos obligados a cancelarla. Sin embargo, puedes volver a hacerla reserva.',
          offer_details_below: "Abajo encontrarás los detalles de la oferta:",
        },
        saas: {
          contact_us_if_problems: "En caso de cualquier problema con la rezserva, póngase en contacto con nosotros.",
          line1:
            'Hasta ahora no hemos recibido el pago por su prereserva núm. %{order_id} de "%{product_name}". Por haber vencido el plazo previsto para el pago, nos vimos obligados a cancelarla. Sin embargo, puedes volver a hacer la reserva.',
          offer_details_below: "Abajo encontrarás los detalles de la oferta:",
        },
        subject: 'Acuérdese de completar la reseerva de "%{product_name}"',
      },
      order_company_rejected_company_email: {
        line1: 'Has rechazado la prereserva núm. %{order_id} de %{customer_full_name} de "%{product_name}".',
        line2: "Si quiere volver a ofrecer esta fecha, por favor, actualice la disponibilidad en la página.",
        subject: "La prereserva num. %{order_id} ha sido rechazada (cliente: %{customer_full_name})",
        line1_html:
          'Has rechazado la prereserva núm. <a href="%{partnerapp_order_url}">%{order_id}</a> de %{customer_full_name} de "%{product_name}".',
      },
      order_company_rejected_customer_email: {
        marketplace: {
          line1:
            'La empresa %{company_name} ha rechazado su prereserva núm. %{order_id} de "%{product_name}" debido a que no había plazas libres para %{stock_time_range}.',
          see_offer_html: "Ver la oferta en otras fechas: %{product_link}",
          confirmation_installment_refund_info:
            "El pago recibido %{confirmation_installment_paid_amount} será reembolsado a su cuenta bancaria en las siguientes 24 horas.",
        },
        saas: {
          line1:
            'Hemos rechazado su prereserva núm. %{order_id} de "%{product_name}" debido a que no había plazas libres para %{stock_time_range}.',
          see_offer_html: "Ver la oferta en otras fechas: %{product_link}",
          confirmation_installment_refund_info:
            "El pago recibido %{confirmation_installment_paid_amount} será reembolsado a tu cuenta bancaria en las siguientes 24 horas.",
        },
        subject: 'La prereserva núm. %{order_id} de "%{product_name}" ha sido rechazada',
      },
      order_customer_rejected_company_email: {
        line1: 'El cliente ha rechazado la prereserva núm. %{order_id} de %{customer_full_name} de "%{product_name}".',
        subject: "La prereserva núm. %{order_id} ha sido rechazada por el cliente (cliente: %{customer_full_name})",
      },
      order_customer_rejected_customer_email: {
        marketplace: {
          line1: 'Su prereserva núm. %{order_id} de "%{product_name}" ha sido rechazada.',
          see_offer_html: "Volver a ver la oferta: %{product_link}",
          confirmation_installment_refund_info:
            "El pago recibido %{confirmation_installment_paid_amount} será reembolsado a su cuenta bancaria en las siguientes 24 horas.",
        },
        saas: {
          line1: 'Su prereserva núm. %{order_id} de "%{product_name}" ha sido rechazada.',
          see_offer_html: "Volver a ver la oferta: %{product_link}",
          confirmation_installment_refund_info:
            "El pago recibido %{confirmation_installment_paid_amount} será reembolsado a su cuenta bancaria en las siguientes 24 horas.",
        },
        subject: 'Su prereserva núm. %{order_id} de "%{product_name}" ha sido rechazada.',
      },
      order_current_status_company_email: {
        line1: "Le enviamos el estado actual de su prereserva.",
        subject: "Prereserva núm. %{order_id}, estado actual: %{status_i18n} (cliente: %{customer_full_name})",
      },
      order_company_cancelled_company_email: {
        line1: 'La prereserva núm. %{order_id} de %{customer_full_name} de "%{product_name}" ha sido cancelada.',
        subject: "La prereserva núm. %{order_id} ha sido cancelada (cliente: %{customer_full_name})",
        line1_html:
          'La prereserva núm. <a href="%{partnerapp_order_url}">%{order_id}</a> de %{customer_full_name} de "%{product_name}" ha sido cancelada.',
      },
      order_company_cancelled_customer_email: {
        marketplace: {
          line1:
            '%{company_name} ha cancelado tu prereserva núm. %{order_id} de "%{product_name}" en %{stock_time_range}.',
          see_offer_html: "Ver la oferta en otras fechas: %{product_link}",
          confirmation_installment_refund_info:
            "El pago recibido %{confirmation_installment_paid_amount} será reembolsado a su cuenta bancaria en las siguientes 24 horas.",
        },
        saas: {
          line1: 'Hemos cancelado su prereserva núm. %{order_id} de "%{product_name}" para el %{stock_time_range}.',
          see_offer_html: "Ver ofertas en otras fechas: %{product_link}",
          confirmation_installment_refund_info:
            "El pago recibido %{confirmation_installment_paid_amount} será reembolsado a su cuenta bancaria en las siguientes 24 horas.",
        },
        subject: "El prereserva núm. %{order_id} ha sido cancelado",
      },
      order_abandonment_followup_customer_email: {
        see_product: "Volver a ver: %{product_name}",
        find_other_products_in_this_location: "Buscar otras ofertas en esta zona:",
        line1: 'Recientemente ha visto la oferta "%{product_name}". ¿Sigue interesado?',
        subject: 'Ver propuestas parecidas a "%{product_name}"',
        go_to_product: "Ver la oferta",
      },
    },
    papp: {
      components: {
        EditableBillRow: {
          placeholder: "Ingrese su nombre",
        },
        InstallmentFormSection: {
          exact_date_label: "Fecha exacta",
          how: "¿Cómo?",
          on_stock_starts_at_label: "Cuando comienza la oferta",
          paid_after_company_approval_label:
            "Si la fecha requiere confirmaciones, pídale al cliente que pague por adelantado primero",
          remaining_amount: "Cantidad restante",
          when: "¿Cuando?",
          whole_amount: "Cantidad entera",
          x_days_after_order_creation_label: "después de enviar el pedido",
          x_days_after_order_full_approval_label: "después de la aprobación del pedido",
          x_days_after_previous_installment_label: "después de la entrega anterior",
          x_days_before_stock_starts_at_label: "antes de comenzar la oferta",
          how_much: "¿Cuánto cuesta?",
          to: "¿A?",
        },
        InstallmentsListFormSection: {
          add_new: "Añadir nueva entrega",
        },
        LocationFormControl: {
          placeholder: "Ingrese ubicación",
        },
        MainView: {
          default_error_title: "Error de conexión del servidor",
          error_date: "Fecha de error",
          error_description: "Si el error vuelve a aparecer, contáctenos a través de %{email}.",
          error_id: "ID de error",
          loading: "Cargando",
          retry: "Rever",
        },
        MultipleDateFormControl: {
          add_new: "Agregar fecha",
        },
        MultipleInputFormControl: {
          placeholder: "Agrega otra línea",
        },
        MultipleTimeFormControl: {
          add_new: "Agregar una hora",
        },
        OrderSidebarPreview: {
          edit_slot: "Editar ranura",
          see_slot: "Ver fecha",
        },
        PaginationNavigation: {
          out_of: "de",
        },
        PaymentProfileProductAttachmentFormSection: {
          active: "Activo",
          additional_fee: "Pago",
          days_before_arrival_date_limit: "Fecha elegida",
          days_before_arrival_date_limit_label: "Por adelantado",
          installment: "Entrega",
          no_date_limit: "Siempre",
        },
        ProductCustomerOrderFieldFormSection: {
          add_list_option: "Agregar opción de lista",
          add_new: "Agregar nuevo",
          show_on_manifest: "Mostrar en la lista de participantes",
          value_required: "Valor requerido",
          value_type: "Tipo de valor",
        },
        ProductPricedOrderFieldFormSection: {
          add_list_option: "Agregar opción de lista",
          ask_customer: "Pregunta al cliente",
          different_currency_base_amount_note:
            "Las opciones adicionales definidas en una moneda distinta de la Moneda de la oferta siempre se cuentan más allá del costo base.",
          for_all_variants: "Para todas las variantes",
          remove: "Eliminar",
          show_on_manifest: "Mostrar en la lista de participantes",
          value_type: "Tipo de valor",
        },
        SlotsCalendar: {
          agenda: "Lista",
          allDay: "Todo el dia",
          availability_mode: "Disponibilidad",
          date: "Fecha",
          day: "Día",
          event: "Evento",
          month: "Mes",
          next: "próximo",
          previous: "Anterior",
          price_mode: "Precios",
          showMore: "%{count} więcej ...",
          time: "Hora",
          today: "Hoy",
          week: "Semana",
          slot_confirmed: "Fecha confirmada",
        },
        TagsInputFormControl: {
          addition_label: "Añadir:",
          no_results_message: "No hay resultados",
          placeholder: "Agregar siguiente",
        },
        TypeaheadInputFormControl: {
          no_results_message: "No hay resultados",
          placeholder: "Todo",
        },
        SaleWindowRuleFormGroup: {
          sale_starts_at_label: "Apertura de venta",
          sale_ends_at_label: "Cierre de venta",
          offset_label: "con antelación",
          from_date_label: "desde la fecha",
          until_date_label: "hasta la fecha",
          before_slot_start: "antes de la fecha",
          resolved_preview: "Para la fecha %{slot} corresponde al %{resolved}.",
        },
        UsebyDateRangeFormGroup: {
          days_limit_label: "x dias",
          days_since_order_creation: "días desde el pedido",
          ends_at_label: "hasta",
          starts_at_and_ends_at_label: "en días",
          starts_at_label: "desde el dia",
        },
        ProductsListItem: {
          preview_marketplace: "mostrar",
          preview_saas: "WWW",
          new_order: "Reserva",
          active_switch_label: "Activo",
          published_on_saas_switch_label: "WWW",
        },
        OrderedProductOrderFieldFormControl: {
          custom_location_name_placeholder: "Ingrese la dirección del cliente",
        },
        ProductsSelectControl: {
          blank_label: "Ninguna oferta asignada",
        },
      },
      order: {
        approve: "Confirmar",
        cancel_order: "Cancelar orden",
        confirm: "Enviar",
        customer_name_placeholder: "No hay información del cliente.",
        delete_order: "Eliminar el pedido",
        finish: "Terminar",
        redeliver_customer_order_email: "Enviar detalles del pedido",
        reject: "Rechazar",
        redeliver_supplier_order_email: "Enviar detalles del pedido al proveedor",
        finish_order: "Orden final",
        automatic_icon: "UNA",
        manual_icon: "M",
        no_stock_date: "Sin cita",
      },
      common: {
        search: "Buscar...",
        no_results_message: "No hay resultados",
        discard_changes_confirm_message: "No has guardado tus cambios. ¿Estás seguro de que quieres irte sin terminar?",
        go_back: "Regresa",
        remove: "Eliminar",
        save: "Salvar",
        none: "ninguna",
        poland: "Polonia",
        edit: "Editar",
        manage: "Gestionar",
        save_changes: "Guardar cambios",
        submit_success_message: "Cambios guardados.",
        default_value: "Por defecto: %{value}",
        attention: "aviso",
        no_name: "(sin nombre)",
        close: "Cerca",
        in_total: "Total",
        filters_title: "Filtrar",
        form_validation_error_message: "Uno de los campos en el formulario se completa incorrectamente.",
        cancel: "Cancelar",
        go_next: "Seguir",
        st_email: "cooperación@tripsomnia.com",
        st_phone_number: "+48 690 670 581",
        are_you_sure: "¿Estás seguro?",
        translations_locale: "Elegir locale",
        x_per_page: "%{count} por página",
        show_filters: "",
        hide_filters: "",
        download_csv: "",
        weekdayAbbreviations: ["", "", "", "", "", "", ""],
      },
      agents: {
        AgentsListView: {
          title: "Agentes",
          add_new: "Agente de invitación",
          no_records_title: "Sin agentes",
          no_records_message: "Ningún agente ha sido invitado a la cooperación todavía.",
          no_records_add_new_link: "Añadir nuevo?",
        },
        EditAgentCooperationView: {
          default_pricing: "Precio predeterminado",
          activate_all: "Activar todo",
          remove_confirm_message: "¿Seguro que quieres cancelar esta cooperación?",
          title: "Cooperación de la agencia",
          title_with_company_name: "Cooperación de la agencia con %{company_name}",
          products: "Ofertas",
          price_change: "Aumentar / disminuir en",
          gross_price: "Precio bruto",
          net_price: "Precio neto",
          include_product_options_price: "incluir opciones adicionales",
          st_cooperation_hint: {
            p1: "Cooperación con Tripsomnia",
            p2: "No puede editar nuestras condiciones de cooperación.",
            p3: "Si desea realizar algún cambio, comuníquese con su asistente por teléfono o correo electrónico: %{tel} o %{email}.",
          },
        },
        NewAgentPrompt: {
          title: "Nuevo agente",
          email_label: "Correo electrónico del agente",
          submit: "Invitar a la cooperación",
        },
        SuppliersListView: {
          title: "Proveedores",
          no_records_title: "No hay proveedores",
          no_records_message: "No se han recibido invitaciones de otro proveedor de cooperación de agencias.",
          add_new: "",
        },
      },
      app: {
        App: {
          fetch_app_error_title: "Error de conexión del servidor.",
        },
        ForbiddenView: {
          title: "Error 403",
          message: "Acceso denegado.",
        },
        LeftBar: {
          dashboard: "Tablero",
          calendar: "Calendario",
          orders: "Pedidos",
          products: "Ofertas",
          customers: "Clientes",
          agents: "Agentes",
          suppliers: "Proveedores",
          finances: "Finanzas",
          raports: "Informes",
          settings: "Configuraciones",
          reviews: "Comentarios",
          affiliate: "Finanzas",
          accommodation: "",
          connectly: "Connectly"
        },
        NotFoundView: {
          title: "error 404",
          message: "Página no encontrada",
        },
        requireAuth: {
          company_forbidden: "No tiene acceso a esa compañía (ID: %{company_id}).",
          no_companies_error_title: "No hay empresas vinculadas a su cuenta.",
        },
        TopBar: {
          logout: "Cerrar sesión",
          marketplace_homepage: "Tripsomania",
          new_order: "Reserva",
          saas_homepage: "Su sitio web",
          your_account: "Ajustes de usuario",
        },
      },
      auth: {
        LoginView: {
          send_confirmation_instructions_link: "Reenviar enlace de activación.",
          send_reset_password_instructions_link: "Recordar contraseña",
          send_unlock_instructions_link: "Mi cuenta esta bloqueada.",
          submit: "Iniciar sesión",
          title: "Inicie sesión en el panel de Tripsomnia",
        },
        ResetPasswordView: {
          submit: "Cambia la contraseña",
          title: "Genera una contraseña nueva",
        },
        SendResetPasswordInstructionsView: {
          email_help: "Le enviaremos un enlace para generar una nueva contraseña para su cuenta.",
          email_label: "Tu correo electrónico",
          submit: "Enviar",
          success_message:
            "Le enviamos un correo electrónico con un enlace para generar una nueva contraseña. Por favor revise su bandeja de entrada.",
          title: "Recordar contraseña",
        },
        index: {
          fetch_user_failed_message: "Su sesión ha caducado. Por favor inicie sesión de nuevo.",
        },
      },
      calendar: {
        CalendarView: {
          all_products: "Todos los productos",
          all_suppliers: "Todos los proveedores",
          title: "Calendario de reservas",
          filter_all: "Todas",
          filter_available: "Disponible",
          filter_awaiting: "En espera",
          filter_booked: "Reservado",
          show_inactive_offers: "Mostrar ofertas inactivas",
        },
        ShowSlotModal: {
          active_orders_title: "Órdenes activas",
          build_order: "Reserva",
          no_orders_message: "No hay pedidos para este día.",
          open_manifest: "Mostrar lista de participantes",
          open_manifest_failure_message: "Error al descargar la Lista de participantes.",
          other_orders_title: "Otras ordenes",
          download_manifest: "Descargar manifiesto",
          booked_orders_title: "Reservado",
          pending_orders_title: "Pendiente",
          awaiting_orders_title: "En espera",
          sale_window_title: "Ventana de venta",
          sale_starts_at_label: "Apertura de venta",
          sale_ends_at_label: "Cierre de venta",
          within_sale_window_yes: "Actualmente a la venta",
          within_sale_window_no: "Fuera de la ventana de venta",
          within_sale_window_past: "La fecha ya pasó",
          biledo_block_title: "Vinculación con Biledo",
          biledo_term_uuid: "Term UUID",
          biledo_pricelist_uuid: "Pricelist UUID",
          biledo_overwrite_warning: "Tu edición se sobrescribirá en la próxima sincronización con Biledo.",
        },
      },
      customers: {
        CustomersListView: {
          no_records_add_new_link: "¿Añadir?",
          no_records_message: "Aún no se ha creado ningún cliente.",
          no_records_title: "Sin clientes",
          title: "Clientes",
          query_filter: "Nombre, correo electrónico o teléfono.",
          add_new_customer: "Nuevo cliente",
        },
        EditCustomerModal: {
          existing_customer_title: "Edición del cliente",
          new_customer_title: "Nuevo cliente",
          remove_confirm_message: "¿Seguro que quieres eliminar a este cliente?",
        },
        ShowCustomerView: {
          no_name: "(sin nombre)",
          orders_title: "Pedidos",
          title: "cliente",
        },
      },
      dashboard: {
        DashboardView: {
          created_orders_number_label: "Número de pedidos creados",
          finished_orders_number_label: "pedidos terminados",
          finished_orders_total_amount_label: "Cantidad total de pedidos terminados",
          new_orders_title: "Nuevos pedidos (últimos 30 días)",
          no_graph_data_message: "No hay datos para mostrar estadísticas.",
          no_orders_waiting_message: "No hay pedidos para confirmar",
          orders_number_label: "pedidos",
          orders_waiting_for_your_approval_title: "Pedidos esperando confirmación",
          participants_number_label: "Participantes",
          see_all_orders: "Ver todo (%{count})",
          title: "Tablero",
          hint: {
            p1: "Comienza a vender tus ofertas",
            p2: "Cuenta de usuario completa y configuración de la empresa.",
            p3: "Agregue ofertas: descripción, precios y configuraciones de reserva, luego fechas.",
            p4: "Crea e inserta widgets en tu sitio web.",
            p5: "Recoja pedidos en línea de clientes o agréguelos usted mismo en el panel.",
            p6: "Si tiene alguna pregunta o inquietud, no dude en comunicarse con nosotros por teléfono %{tel} o por correo electrónico %{email}.",
            p2_html: "",
            p3_html: "",
            p4_html: "",
            p7: "",
            p6_html: "",
          },
          stats_title: "Estadísticas (%{date_from} -%{date_to})",
        },
      },
      finances: {
        FinancesListView: {
          no_records_message: "No se agregaron pedidos.",
          no_records_title: "No hay pedidos",
          title: "Finanzas",
          summary_row: "En total (para las filas %{start}-%end}):",
          create_agent_disbursement: "Desembolso del agente",
          agent_received_paid_th: "Agente recibido / pagado",
          socialtravel_received_paid_th: "Tripsomnia se retiró / pagó",
          supplier_received_paid_th: "Proveedor recibido / pagado",
          orders_count: "%{count} pedidos",
        },
      },
      settings: {
        SettingsLayout: {
          title: "Configuraciones",
          user: "Usuario",
          user_account_settings: "Ajustes de usuario",
          company: "Empresa",
          company_account_settings: "Detalles de la compañía",
          company_members_settings: "Acceso de usuarios",
          products_settings: "Configuraciones de oferta",
          payments_settings: "Configuraciones de pago",
          billing_settings: "Detalles de la factura",
          integrations: "Integraciones",
          marketplace_settings: "Marketplace Tripsomnia",
          saas_settings: "Su sitio web",
          widgets_settings: "Widgets",
          readonly_access_message:
            "No puede actualizar estos datos. Para hacerlo, inicie sesión como administrador de la empresa.",
          stripe: "Registro de pago",
        },
        BillingSettingsView: {
          title: "Detalles de la compañía",
          invoice_company_name_placeholder: "Por defecto: nombre de la empresa (%{default_value})",
          invoice_contact_email_placeholder:
            "Por defecto: dirección de correo electrónico de la empresa (%{default_value})",
          invoice_contact_phone_number_placeholder: "Por defecto: número de contacto de la empresa (%{default_value})",
          invoice_details_title: "Detalles de la factura",
          hint: {
            p1: "Detalles de la factura",
            p2: "Ingrese los datos de la compañía para las facturas",
          },
        },
        CompanyMembersView: {
          title: "Los usuarios",
          new_member: "Agregar usuario de la empresa",
          no_members: "Sin miembros",
          hint: {
            p1: "Agregar usuarios",
            p2: "Conceder acceso a su empresa a otros. Para una cuenta nueva, puede asignar derechos de administrador o empleado (acceso limitado).",
          },
        },
        CompanySettingsView: {
          title: "Detalles de la compañía",
          contact_details: "Datos de contacto de sus clientes.",
          contact_phone_number_placeholder: "p. ej. +48 690 670 581",
          notifications_details: "Datos para el procesamiento de pedidos",
          notifications_email_placeholder: "Por defecto: correo electrónico de la empresa (%{default_value})",
          notifications_email_label: "Direcciones para confirmar pedidos",
          notifications_phone_number_placeholder: "Por defecto: número de contacto de la empresa (%{default_value})",
          notifications_phone_number_label: "Número de celda (con código de país)",
          other_details: "Otros ajustes",
          hint: {
            p1: "Nombre",
            p2: "Nombre corto para la comunicación del Panel de socios",
            p3: "Foto de perfil",
            p4: "Visible en el Panel de socios y para los clientes. Es mejor insertar un logotipo de la empresa.",
            p5: "Detalles de contacto",
            p6: "Se mostrará al cliente en la confirmación del pedido.",
            p7: "Datos para el procesamiento de pedidos",
            p8: "A la dirección de correo electrónico presentada se le enviarán notificaciones y solicitudes de confirmación de pedido.",
            p9: "Lenguaje principal",
            p10: "En este idioma, nuestro sistema se comunicará con su empresa por correo electrónico.",
            p11: "Zona horaria",
            p12: "Las fechas de sus ofertas en el Panel se agregarán en la zona horaria seleccionada. Si cambia esta configuración, no afectará las fechas ya agregadas.",
          },
        },
        MarketplaceSettingsView: {
          title: "Marketplace Tripsomnia",
          marketplace_homepage_url_label: "La dirección de su empresa en martkeplace",
          hint: {
            p1: "El perfil de su empresa en Tripsomnia",
            p2: "La información se mostrará a los clientes en la subpágina de su empresa en nuestra plataforma de ventas Tripsomnia.",
          },
        },
        PaymentsSettingsView: {
          title: "Configuraciones de pago",
          your_profiles_title: "Sus perfiles de pago de clientes",
          marketplace_profiles_title: "Perfiles de pago de clientes de Tripsomnia",
          add_new_profile: "Agregar un nuevo perfil",
          hint: {
            p1: "Moneda de oferta predeterminada",
            p2: "Seleccione la moneda predeterminada para simplificar la configuración de ofertas.",
            p3: "Detalles de transferencia bancaria",
            p4: "La información que proporcione en este cuadro se enviará a los clientes que hayan reservado una oferta con un perfil de pago de cuenta bancaria.",
            p5: "Perfiles de pago para los clientes de su empresa.",
            p6: "dite y agregue perfiles de pago para los clientes de su empresa",
            p7: "Perfiles de pago para clientes de Tripsomnia",
            p8: "Ofrecemos estos perfiles de pago en nuestro marco de cooperación. Para editar estos perfiles, comuníquese con su asesor.",
          },
          no_your_profiles_warning:
            "Agregue al menos un perfil de pago para sus clientes. De lo contrario, no podrán realizar pedidos en su sitio web.",
          enable_for_all_product_variants: "Habilitar para todas las ofertas",
          access_possible_only_for_supplier:
            "La gestión de los perfiles de pago solo es posible si usted es proveedor de ofertas. Póngase en contacto con sus proveedores de ofertas para saber qué perfiles de pago están disponibles para",
          increase_orders_amount_by_saas_commision_label:
            "Agregue una tarifa por nuestra comisión del sistema al monto total del pedido",
          increase_orders_amount_by_saas_commision_enabled_hint: "El cliente cubrirá la tarifa del sistema.",
          increase_orders_amount_by_saas_commision_disabled_hint: "Su empresa cubrirá la tarifa del sistema.",
        },
        ProductsSettingsView: {
          title: "Configuraciones de oferta",
          hint: {
            p1: "Términos y Condiciones",
            p2: "Coloque aquí el texto de los Términos y condiciones que los clientes deberán aceptar al reservar sus ofertas.",
            p3: "Cupón móvil",
            p4: "Compruebe si requiere que el cliente imprima una confirmación / comprobante. Si no lo marca, los clientes podrán mostrar el pedido en su teléfono.",
          },
        },
        SaasSettingsView: {
          title: "Su sitio web",
          saas_homepage_url: "La dirección de su sitio web",
          contact_us_if_want_to_change: "Si desea cambiarlo, contáctenos.",
          hint: {
            p1: "Su sitio web",
            p2: "Esta información se mostrará a los clientes en su sitio web.",
          },
        },
        UserAccountView: {
          title: "Ajustes de usuario",
          site_settings_title: "Configuraciones de la cuenta",
          password_change_title: "cambia tu contraseña",
          hint: {
            p1: "Configuraciones de cuenta de usuario",
            p2: "Estas configuraciones solo afectan el área de su cuenta de usuario. No afectan la configuración principal de su empresa.",
          },
        },
        WidgetsSettingsView: {
          title: "Widgets",
          iframe: "IFrame",
          button: "Botón",
          navbar: "Barra de navegación",
          detect_from_visitor_browser: "Desde el navegador del usuario",
          locale: "Idioma del sitio web",
          currency: "Moneda del cliente",
          bubble: "Burbuja",
          active: "Publicar",
          scrollWidget: "",
          exitWidget: "",
        },
        ButtonWidgetView: {
          book_now: "Reservar ahora",
          small_size: "Pequeña",
          normal_size: "Normal",
          large_size: "Grande",
          bottom_right: "esquina inferior derecha",
          bottom_left: "esquina izquierda inferior",
          top_right: "esquina superior derecha",
          top_left: "Esquina superior izquierda",
          in_modal: "en modal",
          in_new_tab: "en nueva pestaña",
          title: "Botón",
          button_content: "Contenido del botón",
          open: "Abierto",
          color: "Color",
          size: "Talla",
          stick_to_window_corner: "Posición",
          generate_code: "Salvar",
          place_code_anywhere:
            "Coloque este código en cualquier lugar de su sitio. Le sugerimos que lo coloque al principio, justo antes de %{head}, o en el encabezado, justo antes de %{body_end}.",
          put_widget_anywhere:
            "En lugar de usar posiciones de widget fijas, también puede colocar el widget deseado en cualquier lugar que elija.",
          preview: "Avance",
          button_type: "Botón normal",
          flag_type: "Bandera",
          what_type: "Tipo de botón",
          center_right: "centro derecho",
          center_left: "centro izquierdo",
        },
        NavBarWidgetView: {
          new_link: "Agregar un elemento",
          our_products: "Nuestra oferta",
          products_calendar: "Calendario de ofertas",
          book: "Reserva",
          white_blue: "blanco con tono azul",
          white_teal: "blanco con tono verde",
          white_orange: "blanco con tono naranja",
          black_blue: "negro con tono azul",
          black_teal: "negro con tono verde",
          black_orange: "negro con tono naranja",
          blue: "azul",
          teal: "verde",
          orange: "naranja",
          to_window_bottom: "parte inferior de la ventana",
          to_window_top: "parte superior de la ventana",
          in_modal: "en modal",
          in_new_tab: "en una nueva ventana",
          none: "Nada que mostrar",
          company_name: "Nombre de empresa",
          company_logo: "Logo de la compañía",
          title: "Barra de navegación",
          show_company_name: "Mostrar nombre de la empresa",
          show_toggle_button: "Mostrar botón de alternar",
          open: "Abierto",
          color: "Color",
          stick: "Posición",
          cta_button: "Botón principal",
          navigation: "Pestañas",
          contact: "Contacto",
          generate_code: "Salvar",
          place_code_anywhere:
            "Coloque este código en cualquier lugar de su sitio. Le sugerimos que lo coloque al principio, justo antes de% {head}, o en el encabezado, justo antes de% {body_end}.",
          put_widget_anywhere: "A continuación, coloque el widget deseado en cualquier lugar que elija.",
          preview: "Avance",
          link_type_link: "Enlace",
          link_type_none: "Ninguna",
          link_type_text: "Contenido",
          link_type_phone: "Teléfono",
          link_type_email: "Email",
          link_type_custom_link: "Vínculo personalizado",
          black: "",
          white: "",
          green: "",
          type1: "",
          type2: "",
          type3: "",
          red: "",
          percentage: "",
          activity: "",
          cart: "",
          notification: "",
          offer: "",
          search: "",
          star: "",
          negotiate: "",
          discount: "",
          chat: ""
        },
        IframeWidgetView: {
          title: "IFrame",
          iframe_width: "Ancho del marco",
          iframe_height: "Altura del marco",
          generate_code: "Generar codigo",
          put_widget_anywhere: "Copie y pegue este código en cualquier lugar que desee.",
          preview: "Avance",
        },
        WidgetRouteFormSection: {
          homepage_page: "Página principal",
          products_list_page: "Listado de ofertas",
          products_calendar_page: "Calendario de ofertas",
          product_page: "Página de la oferta",
          new_order_page: "Formulario de reserva de oferta",
          on_slot_click_show_product: "Página de oferta",
          on_slot_click_new_order: "Formulario de reserva para una fecha específica",
          type: "Tipo",
          product: "Oferta",
          all_products: "Todas las ofertas",
          on_slot_click_action_type: "Haga clic en una fecha para abrir",
          reviews_page: "Página de comentarios",
          product_location_tag: "Ubicación",
          product_location_tag_page: "Página de ubicación",
          product_category_tag: "Categoría",
          product_category_tag_page: "Página de categoría",
          coupons_page: "Listado de promociones",
        },
        EditPaymentProfileModal: {
          profile_change_affects_all_products_warning:
            "Tenga en cuenta que cualquier cambio que realice aquí afectará todas las ofertas a todas las empresas a las que este perfil de pago está asignado actualmente.",
          remove_confirm_message: "¿Seguro que quieres eliminar este perfil de pago?",
          edit_profile_title: "Editar perfil de pago",
          new_profile_title: "Nuevo perfil de pago",
          name_label: "Nombre del perfil '",
          name_hint: "Se mostrará al cliente durante la creación del pedido, si tiene más de un perfil para elegir.",
          has_additional_fee_label: "Cuota Adicional",
          cancellation_policy_hint:
            "¿Hasta cuándo se puede cancelar el pedido? ¿A qué cantidad puede el cliente solicitar el reembolso?",
          installments_label: "Cuotas de pago",
          additional_fee_as_agent_fee_label: "Agregue la tarifa como tarifa de servicio del agente",
        },
        EditCompanyMemberModal: {
          edit_member_title: "Editar usuario de la empresa",
          new_member_title: "Agregar usuario de la empresa",
          remind_password: "Recordar contraseña",
        },
        BubbleWidgetView: {
          balloon_line1_value: "Todas las excursiones",
          balloon_line2_value: "¡Haz clic aquí para obtenerlos!",
          balloon_line1_label: "Primera línea de texto",
          balloon_line2_label: "Segunda línea de texto",
          generate_code: "Salvar",
          large_size: "Grande",
          normal_size: "Normal",
          place_code_anywhere:
            "Coloque este código en cualquier lugar de su sitio. Le sugerimos que lo coloque al principio, justo antes de %{head}, o en el encabezado, justo antes de %{body_end}.",
          placement: "Posición",
          preview: "Avance",
          put_widget_anywhere: "A continuación, coloque el widget deseado en cualquier lugar que elija.",
          small_size: "Pequeña",
          title: "Burbuja",
          bottom_left_corner: "esquina izquierda inferior",
          bottom_right_corner: "esquina inferior derecha",
          color_label: "Color",
          placement_label: "Posición",
          size_label: "Talla",
          top_left_corner: "Esquina superior izquierda",
          top_right_corner: "esquina superior derecha",
          show_after_label: "Mostrar widget después",
          show_balloon_after_label: "Mostrar descripción después",
          play_sound_label: "Reproducir sonido",
          animation_type: "",
          icon: "",
        },
        IndexWidgetsView: {
          header1: "Instrucciones de instalación de widgets",
          header2: "Widgets más antiguos",
          text1:
            "¡Lo alentamos a usar nuestros widgets en su sitio web! Para instalar un widget, copie y pegue el siguiente código en cualquier parte de su sitio web. Recomendamos pegar el código al principio, justo antes de la etiqueta </head>tag o antes de </body> </html>.",
          text2:
            "Como siguiente paso, puede editar el widget Bubble o Button, elegir la configuración adecuada, activar el widget y ver el efecto en su sitio web.",
          text3:
            "Es un placer informarle que hemos introducido una serie de cambios en nuestros widgets el 1 de marzo de 2019. Los widgets antiguos y su código permanecerán activos y seguirán funcionando, pero recomendamos realizar una actualización y usar nuevos widgets.",
          text4:
            "Anteriormente se mencionan las numerosas ventajas de los nuevos widgets. Para actualizar los widgets, elimine el código anterior y siga las instrucciones para la instalación de nuevos widgets. Si tiene alguna pregunta, no dude en contactarnos: info@tripsomnia.com",
          widgetCodeHasBeenCopied: "¡El código del widget se ha copiado correctamente!",
          widgetCodeHasnBeenCopied: "Copiar código de widget",
          copyWidgetCode: "",
        },
        StripeSettingsView: {
          title: "Registro de pago - Stripe",
          stripe_verification_failure: "Desafortunadamente, su registro en Stripe no fue exitoso.",
          stripe_verification: "",
          stripe_verification_success: "",
          line1_html: "",
          line2_html: "",
          line4_html: "",
          line3: "",
          line3_1: "",
          line3_2: "",
          line3_3: "",
          line3_4: "",
          line5_html: "",
          line6_html: "",
          line7: "",
          line1: "",
          line2: "",
        },
      },
      orders: {
        AddOrderTransferModal: {
          default_title: "Nuevo pago / reembolso",
          new_refund_title: "Nuevo reembolso",
          new_transfer_title: "Nuevo pago",
        },
        ChangeOrderScheduleSlotModal: {
          title: "Cambio de fecha de pedido",
        },
        EditOrderCustomerDetailsModal: {
          title: "Detalles del pedido",
          customer_details: "Detalles del cliente",
        },
        EditOrderInstallmentsModal: {
          title: "Solicitar cuotas de pago",
        },
        EditOrderItemsModal: {
          title: "Factura de pedido",
          changed_order_item_name: "Cambio: %{item_name}",
          changed_order_option_name: 'Cambie la opción de "%{prev_item_name}" a "%{next_item_name}"',
          removed_order_option_name: 'Eliminar la opción "%{prev_item_name}"',
          added_order_option_name: 'Añadiendo la opción "%{next_item_name}"',
          order_items_title: "Cuenta",
          order_item_index: "Posición",
          order_item_unit_price: "Precio por ítem",
          order_item_quantity: "Cantidad",
          order_item_total_price: "Total",
          add_new_order_item: "Agregar nueva posición",
          extra_participants_existing:
            "El número de participantes asignados a este pedido excede el número de personas elegidas en la factura. Elimínelos del orden haciendo clic en la cruz de la persona elegida.",
          installments_require_manual_change_warning:
            "Tenga en cuenta que las cantidades de las cuotas en este orden no se cambiarán automáticamente. Si desea cambiar sus importes, cámbielos editando el perfil de pago de este pedido después de cambiar la factura del pedido.",
        },
        NewOrderItemsForm: {
          select_agent: "Elige agente",
          reset_agent_commision: "Reiniciar",
          product_options: "Opciones adicionales",
          other_order_items: "Descanso",
          add_new_order_item: "Agregar nueva posición",
        },
        NewOrderPaymentsForm: {
          accept_deposit: "Toma un pago ahora",
          plan_payments: "Plan de pago",
          no_payments: "Ahora no (guardar como borrador)",
          deposit_accepted_as_agent: "(el pago se marcará como aceptado por el Agente)",
          deposit_accepted_as_supplier: "(el pago se marcará como aceptado por el proveedor)",
          only_deposit_now: "Solo deposite ahora",
          rest_payment: "Pagando el resto",
          order_status: "Estado del pedido",
          notify_customer: "Enviar notificación al cliente",
          notify_customer_impossible_no_customer_email_given:
            "Sin dirección de correo electrónico del Cliente, imposible enviar una notificación.",
          note_placeholder: "Añadir la nota",
          choose_payments_mode: "Elija la forma en que el cliente pagará el pedido.",
          choose_payments_mode_error: "Elija la forma en que el cliente pagará el pedido.",
          order_status_message: "Después de guardar esta reserva obtendrá el estado:",
        },
        NewOrderProductModal: {
          no_products_found: "No se encontraron ofertas.",
          static_date_booking_label: "Pedido para fecha especificada",
          with_custom_product_title: "Pedido personalizado (sin oferta)",
          choose_product_variant: "Elegir variante de oferta",
          default_title: "Nuevo orden",
          search_products: "Busca oferta",
          use_custom_product_button: "Pedido personalizado (sin oferta)",
          info1: "",
          order_name: "",
        },
        NewOrderModal: {
          confirm_abandon_message: "¿Seguro que quieres abandonar este pedido?",
          confirm_abandon_cancel: "No, vuelve al pedido",
          confirm_abandon_ok: "Sí, abandona el pedido",
          schedule_step_title: "Elige fecha",
          order_items_step_title: "Elige tus opciones",
          customer_details_step_title: "Complete los datos del cliente",
          payments_step_title: "Pagos",
          abandon_failed_message:
            "No pudimos abandonar su pedido. Probablemente todavía está en nuestra base de datos. Si desea cancelarlo, vaya a la subpágina de la oferta y elimínelo manualmente.",
          payments_step_profiles_instruction: "elige el método de pago",
          payments_step_choose_payments: "Elija la opción de pago en línea",
          payments_step_choose_payments_reseller: "Pague ahora por STRIPE",
          payments_step_choose_payments_customer: "Enviar enlace de pago",
          payments_step_choose_payments_reseller_hint1:
            "Elija esta opción y haga clic en Guardar para redirigirse al pago en línea ahora y pagar con tarjeta.",
          payments_step_choose_payments_reseller_hint2: "",
          payments_step_choose_payments_customer_hint1:
            "Elija esta opción y haga clic en Guardar para enviar un correo electrónico con el enlace de pago al cliente. Recuerde que debe agregar la dirección de correo electrónico del cliente en el paso del formulario anterior.",
          payments_step_choose_payments_customer_hint2: "",
          payments_step_prebook: "Reservar de antemano",
          payments_step_choose_payments_terminal_hint1: "",
          payments_step_choose_payments_terminal_hint2: "",
          payments_step_choose_payments_terminal: "",
        },
        OrderScheduleForm: {
          select_existing_slot: "Elegir fecha existente",
          upcoming_slots: "Las fechas más cercanas",
          no_slots_found: "No se encontraron fechas libres para esta oferta.",
          all_day: "[Todo el dia]",
          add_new_slot: "Agregar fecha",
        },
        OrdersListView: {
          title: "Pedidos",
          add_new_order: "Nuevo orden",
          no_orders_title: "No hay pedidos",
          no_orders_message: "No se ha agregado ninguna orden todavía.",
          no_orders_add_new_button: "¿Quieres crear?",
          customer_query_filter: "Nombre, correo electrónico o teléfono.",
          other_filters: "Otros",
          marketplace_filter: "Mercado",
          saas_filter: "SaaS",
          manual_filter: "Manual",
          automatic_filter: "Automático",
          requires_company_approval_filter: "Requiere confirmación del proveedor",
          doesnt_require_company_approval_filter: "No requiere confirmación del proveedor",
          no_booking_filter: "Sin reserva",
          static_date_booking_filter: "Con reserva",
          total_amount_currencies_filter: "Moneda",
          customer_payment_methods_filter: "Método de pago",
          with_agent_commision_filter: "Con comisión de agente",
          with_agent_service_fee_filter: "Con tarifa de servicio del agente",
          with_both_agent_commision_and_service_fee_filter: "Con comisión de agente y tarifa de servicio",
          with_saas_commision_filter: "Con comisión del sistema",
          customer_transfer_date_filter: "Fecha de pago",
          without_agent_commision_and_service_fee_filter: "Sin comisión de agente y tarifa de servicio",
          notes_filter: "Notas",
          with_notes_filter: "Con notas",
          notes_filter_placeholder: "Buscar el contenido de la nota",
          with_affiliate_filter: "Con afiliado",
          with_agent_filter: "Con el agente",
          with_agent: "",
          static_date_range_booking_filter: "",
        },
        ChangeOrderStatusPrompt: {
          title: "Cambiar estado del pedido",
          choose_new_status: "Elija el nuevo estado del pedido",
          save_and_notify_customer: "Guardar y enviar notificaciones al cliente",
          notify_supplier: "Notificar al proveedor",
          save_and_send_opinion_request: "Guardar y enviar solicitud de opinión al cliente",
        },
        ShowOrderView: {
          add_new_transfer: "Nuevo pago",
          add_new_refund: "Nuevo reembolso",
          edit_note: "Nota",
          change_status: "Cambiar Estado",
          print: "Impresión",
          customer_title: "Cliente",
          see_details: "(ver datos)",
          send_notification: "(enviar de nuevo)",
          order_items_title: "Cuenta",
          order_item_unit_price: "Precio por ítem",
          order_item_quantity: "Cantidad",
          payments_title: "Pagos",
          agent_title: "Acuerdo con el agente",
          activities_title: "Historial de pedidos",
          title: "Orden %{order_id}",
          approve_warning: "Confirmar",
          approve_until_warning: "Confirmar antes de %{date}",
          send_opinion_reminder_notification: '(envíe un recordatorio de "agregar revisión")',
          pay_now: {
            tooltip: {
              no_payment_needed: "Este pedido está totalmente pagado.",
              too_low_amount: "El monto del pago es demasiado bajo.",
            },
            0: "",
          },
        },
        utils: {
          confirm_approve_message: "¿Seguro que quieres confirmar este pedido?",
          confirm_reject_message: "¿Seguro que quieres rechazar este pedido?",
          confirm_finish_message: "¿Estás seguro de que deseas marcar este pedido como terminado?",
          confirm_cancel_message: "¿Estás seguro de que deseas cancelar este pedido?",
          confirm_delete_message: "¿Estás seguro de que deseas eliminar este pedido?",
          redeliver_customer_order_email_success_message:
            "Se envió un correo electrónico con la información del pedido al cliente.",
          redeliver_supplier_order_email_success_message:
            "Se ha enviado al proveedor un correo electrónico con información actualizada sobre el pedido.",
          create_agent_disbursement_success_message:
            "Los pedidos seleccionados se han desembolsado (ID de desembolso: %{agent_disbursement_id}).",
          redeliver_customer_order_opinion_reminder_email_success_message:
            "Se ha enviado al cliente una notificación por correo electrónico de agregar la revisión de un pedido.",
          send_opinion_request_to_customer: "Enviar solicitud de revisión al cliente",
        },
        OrderCustomerDetailsFormSection: {
          participants_details: "Datos de participantes",
        },
        EditOrderNotesModal: {
          title: "Pedidos",
        },
      },
      products: {
        EditProductView: {
          StepAdditional: {
            form_title: "Configuración de Tripsomnia",
            marketplace_settings: "Marketplace",
            saas_commision_settings: "Comisión / tarifa de servicio SaaS",
            hint: {
              p1: "Ajuste de la comisión",
              p2: "Puede encontrar el resto de configuraciones en Agentes.",
            },
          },
          StepAvailability: {
            all_product_variants: "Todas las variantes",
            remove_all_slots_confirm: {
              title: "Fecha de borrado",
              message: "¿Está seguro de que desea eliminar esta fecha y sus repeticiones adicionales?",
              confirm: "Eliminar todas las fechas de %{all_slots_initial_date}",
            },
            remove_single_slot_confirm: {
              title: "Fecha de borrado",
              message:
                "Esta fecha se repite. ¿Desea eliminar esta fecha y todas sus repeticiones adicionales o solo esta fecha en particular?",
              select_all_slots: "Ir a la edición de todas las fechas desde %{all_slots_initial_date}",
              confirm: "Eliminar solo esta fecha",
            },
            remove_booked_slot_alert: {
              message:
                "Eliminar esta fecha es imposible, ya que está reservado con pedidos activos. Si desea eliminarlo, primero debe cancelar los pedidos.",
              go_to_slot_view: "Ir a la vista de fecha",
            },
            remove_slot_confirm: {
              title: "Fecha de borrado",
              message: "¿Seguro que quieres eliminar esta fecha?",
              confirm: "Eliminar esta fecha",
            },
            edit_all_slots_confirm: {
              title: "Fecha de edición",
              message:
                "Ha realizado cambios en las repeticiones de esta fecha. ¿Estás seguro de que deseas sobrescribir este término y sus repeticiones posteriores?",
              confirm: "Cambiar todas las fechas de %{all_slots_initial_date}",
            },
            edit_single_slot_confirm: {
              title: "Fecha de edición",
              message:
                "Esta fecha se repite. ¿Desea sobrescribir solo esta fecha o ir a la edición de todas sus repeticiones adicionales?",
              select_all_slots: "Ir a la edición de todas las fechas desde %{all_slots_initial_date}",
              confirm: "Cambiar solo esta fecha",
            },
            add_slot: "Agregar fecha",
            add_many_slots: "Agregar muchas fechas",
            select_first_slot_date: "Elija fecha y hora del primer término",
            select_slot_date: "Elija fecha y hora del primer término",
            prices_title: "Lista de precios",
            no_prices_message:
              'No se han establecido precios predeterminados. Vaya a la pestaña "Precios" para ingresar a la lista de precios.',
            availability_title: "Disponibilidad",
            hint: {
              p1: "Antes de comenzar a agregar fechas de su oferta, ajuste el precio predeterminado y la configuración de reserva para esta oferta.",
              p2: "Agregar fecha",
              p3: "Para agregar una fecha, simplemente seleccione una fecha en el calendario, personalice las opciones y guarde los cambios.",
              p4: "Agregar varias fechas",
              p5: "Para agregar varias fechas, use la opción de repetición.",
            },
            normal_start_dates_assignation_type: "elegido",
            recursion_start_dates_assignation_type: "periódicamente",
            edit_slot: "Fecha de edición",
            repeat_on_days: "Repita en días",
            repeat_until: "Repetir hasta",
            repeat_in_hours: "Repetir en horas",
            repeat_slot: "Repetir fecha",
          },
          StepBookingSettings: {
            already_used_stock: "(%{used_stock} ya vendido)",
            nb_stock_useby_date_label: "Fecha de realización",
            nb_dont_require_company_approval_label: "Reserva instantanea",
            slots_will_be_removed_warning:
              "Al guardar los cambios, todas las fechas existentes de esta oferta, si las hay, se desactivarán y / o eliminarán.",
            form_title: "Configuraciones de reserva",
            static_date_booking_label: "¿Una oferta tiene fechas de reserva?",
            global_settings: "Configuración global",
            default_settings: "Configuración predeterminada para agregar nuevas disponibilidades",
            hint: {
              p1: "Seleccione si su oferta tiene una fecha de reserva en el calendario o si es una oferta sin reserva, p. un cupón o un cupón para ser usado bajo ciertas condiciones.",
              p2: "Límite de disponibilidad predeterminado / límite de oferta",
              p3: "Este será el valor predeterminado para cada nueva fecha agregada en el calendario. En caso de ofertas sin reserva, este será el límite total de la oferta.",
              p4: "Configuración de reserva predeterminada",
              p5: "Decida si acepta la reserva directa que no requiere su confirmación, o si prefiere tener control total sobre sus pedidos, y confirmará cada pedido individualmente.",
              p6: "Fecha de realización",
              p7: "En caso de cupón, cupón, descuento, también puede establecer un intervalo de fechas cuando se puede utilizar.",
            },
            enable_frontend_slots_listing_label: "Mostrar fechas de clientes en una lista en lugar de calendario",
            expire_at_label: "Fecha de vencimiento de la oferta",
            availability_limit_label: "",
          },
          StepCustomerFields: {
            customer_fields: "Formulario de cliente",
            participant_fields: "Formulario de participante",
            hint: {
              p1: "Campo de formulario de reserva",
              p2: "Seleccione qué campos se mostrarán a los clientes al realizar un pedido. Para cada campo, puede establecer si es obligatorio completarlo y si desea mostrarlo en la Lista de participantes.",
            },
          },
          ProductVariantMigrateModal: {
            copy_description_label: "Descripción",
            copy_pricelist_label: "Precios",
            copy_payments_label: "Pagos",
            copy_booking_settings_label: "Configuraciones de reserva",
            copy_pickup_points_label: "Punto de encuentro",
            copy_priced_fields_label: "Opciones adicionales",
            copy_customer_fields_label: "Campos para completar",
            copy_description_hint:
              'Se sobrescribirán todos los atributos en la pestaña "Descripciones" para la variante objetivo seleccionada.',
            copy_pricelist_hint:
              'Se sobrescribirán todos los atributos en la pestaña "Precios" para la variante objetivo seleccionada.',
            copy_payments_hint:
              'Se sobrescribirán todos los atributos en la pestaña "Pagos" para la variante objetivo seleccionada.',
            copy_booking_settings_hint:
              'Se sobrescribirán todos los atributos en la pestaña "Configuración de reserva" para la variante objetivo seleccionada.',
            copy_pickup_points_hint:
              'Se sobrescribirán todos los atributos en la pestaña "Punto de encuentro" para la variante objetivo seleccionada, así como el valor "Preguntar a cada persona individualmente sobre un punto de encuentro" en esta oferta.',
            copy_priced_fields_hint:
              'Todas las "Opciones adicionales" se sobrescribirán en la variante de oferta objetivo.',
            copy_customer_fields_hint:
              'Todos los "Campos para completar" se sobrescribirán en la variante de oferta objetivo.',
            title: "Copiar atributos de otra oferta / variante",
            source_variant: "Oferta fuente / variante",
            target_variant: "Oferta objetivo / variante",
            copy_label: "Copiar",
            submit: "Copiar datos",
          },
          StepDescription: {
            remove_variant: "Eliminar variante",
            migrate_data_from_other_product: "Copiar datos de otra oferta / variante",
            new_variant_default_name: "Variante %{index}",
            add_variant_message:
              "Si su oferta tiene varias opciones que no se pueden establecer en opciones adicionales, puede %{link}",
            add_variant_message_link: "agregue otra variante de oferta.",
            hint: {
              p1: "Nombre de oferta",
              p2: "Identifique claramente su oferta para que los clientes sepan lo que están mirando desde el principio.",
              p3: "Destacar",
              p4: "¿Qué es lo más importante en tu oferta? ¡Anime a sus clientes!",
              p5: "Descripción",
              p6: "Describa su oferta de forma precisa y clara: cuanto más precisa sea, menos dudas tendrá el cliente y más rápido decidirá ordenar su producto. Use encabezados y estilos de texto para resaltar los aspectos más importantes. Si tiene clientes de diferentes países, agregue más versiones de idioma de la oferta.",
              p7: "El precio incluye / El precio no incluye",
              p8: "Describa lo que está incluido y no incluido en el precio y cuáles son los precios adicionales.",
              p9: "Condiciones",
              p10: "Agregue términos especiales que los clientes deben cumplir para participar en la oferta.",
              p11: "Consejos",
              p12: "Agregue consejos para que el cliente lo ayude a prepararse para la participación.",
              p13: "Oferta de variantes",
              p14: "Si ofrece recorridos similares que difieren solo ligeramente, puede crear variantes del mismo recorrido. Además, puede copiar configuraciones particulares de otra oferta o variante.",
            },
          },
          StepLocation: {
            main_location_label: "Ubicación principal",
            other_locations_label: "Ubicaciones detalladas",
            new_pickup_point_title: "Nuevo punto de encuentro",
            edit_pickup_point_title: "Edición punto de encuentro",
            remove_pickup_point: "Eliminar punto de encuentro",
            add_new_pickup_point: "Agregar punto de encuentro",
            locations_title: "Ubicación de la oferta",
            pickup_points_title: "Puntos de encuentro",
            pickup_point_assignation_per_person_label:
              "Pregunte a cada persona individualmente sobre un punto de encuentro",
            additional_settings: "Otros ajustes",
            hint: {
              p1: "Ubicación de la oferta",
              p2: "Establezca la ubicación principal de su oferta y los puntos adicionales asociados con ella.",
              p3: "¿Ya tienes un mapa creado en Google Maps? Pegue el código para mostrarlo en la oferta.",
              p4: "Punto de encuentro",
              p5: "Agregue un punto de encuentro especificando la dirección, horarios de salida y regreso, y tarifas adicionales. Puede agregar instrucciones y corregir su ubicación en el mapa para ayudar a su cliente a llegar fácilmente al punto de encuentro.",
              p6: "Decida si el cliente selecciona un punto de encuentro para todo el pedido o si cada participante puede seleccionar su propio punto de encuentro.",
              p7: 'El cliente no siempre puede proporcionar un punto de encuentro al reservar. Decide si permites que el cliente responda "Aún no lo sé"',
              p8: "Si recoge el formulario del hotel u otro lugar del cliente, se les pedirá que ingresen su ubicación.",
              p9: "Direcciones",
              p10: "Puede proporcionar aquí instrucciones sobre cómo llegar a su lugar o establecer el área de recogida del cliente.",
            },
            pickup_points_price_per_person_label: "Cobrar tarifa de punto de encuentro de cada persona por separado",
            custom_pickup_point_name: "Recogida en el hotel",
            no_pickup_point_name: "Ubicación no especificada",
          },
          StepPayments: {
            supplier_profiles_title: "Elija los perfiles que estarán disponibles para sus clientes.",
            marketplace_profiles_title: "Elija los perfiles que estarán disponibles para los clientes de Tripsomnia",
            add_new_payment_profile: "Agregar nuevo perfil",
            form_title: "Perfiles de pago",
            hint: {
              p1: "Perfiles de pago",
              p2: "Determine cómo sus clientes pueden pagar su oferta. Determine el número y el monto de las cuotas, el método de pago y la política de cancelación.",
              p3: "Seleccione perfiles para sus clientes de los ya creados o agregue uno nuevo.",
              p4: "Seleccione perfiles para clientes de Tripsomnia de los ya creados o contáctenos para ajustar su cooperación en otros términos.",
            },
            no_supplier_profiles_warning:
              "Recomendamos activar al menos un perfil de pago en este canal para su oferta. De lo contrario, sus clientes no podrán realizar pedidos de esta oferta en su sitio web.",
            no_marketplace_profiles_warning:
              "Recomendamos activar al menos un perfil de pago en este canal para su oferta. De lo contrario, sus clientes no podrán realizar pedidos de esta oferta en Tripsomnia.com.",
            access_temporarily_enabled_only_for_supplier:
              "La vista previa de los perfiles de pago disponibles para esta oferta está disponible solo para el proveedor de la oferta por el momento. Si desea saber cuáles son los perfiles de pago disponibles para esta oferta, comuníquese con su proveedor.",
          },
          StepPhotos: {
            cover_photo: "Foto de cubierta",
            name_placeholder: "Ingrese su nombre",
            form_title: "Agrega fotos para hacer tu oferta más atractiva",
            click_or_drag_and_drop_to_add_photos:
              "Haga clic o arrastre los archivos a este cuadro para agregar una foto (s). Use solo .jpg, .jpeg .gif .png.",
            add_video: "o agregar video (YouTube/Vimeo)",
            add_video_submit: "Añadir",
            hint: {
              p1: "Agregue fotos interesantes que convenzan a sus clientes de usar exactamente su oferta. Puede firmar cada foto y también adjuntar un enlace al video. Todos los materiales pueden clasificarse en cualquier orden arrastrando sus miniaturas.",
              p2: "Asegúrese de utilizar solo materiales para los que tenga derechos de autor o que se hayan publicado bajo una licencia abierta para su reutilización comercial.",
            },
          },
          StepPricedFields: {
            form_title: "Opciones adicionales",
            add_new_field: "Nueva opción adicional",
            hint: {
              p1: "Configurar opciones adicionales para clientes",
              p2a: "Caja",
              p2b: "El cliente selecciona la opción Sí o No.",
              p3a: "Lista de selección",
              p3b: "El cliente selecciona una posición de la lista.",
              p4a: "Número",
              p4b: "El cliente elige un número del rango dado.",
              p5: "Decida si la pregunta se hace una vez para todo el pedido o por separado para cada participante.",
              p6: "Lista de participantes",
              p7: "Decida si el campo aparecerá en la Lista de participantes.",
              p8: "Debe llenarse",
              p9: "Decidir si el cliente debe completar el campo para realizar un pedido",
            },
          },
          StepPricelist: {
            form_title: "Precios",
            hint: {
              p1: "Debe elegir uno de los tres tipos de precios:",
              p2: "Precio por persona",
              p3: "Cree una lista de precios estándar para adultos, niños y personas mayores especificando límites de edad. También puede agregar una lista de precios para un grupo o una familia al establecer límites para los participantes o crear su propia categoría. Para cada posición de la lista de precios puede establecer una cantidad mínima y máxima de unidades a comprar (ej. compra mín. 3 entradas). Nota: los límites de personas y los límites de unidades no se pueden establecer simultáneamente.",
              p4: "Precio por paquete",
              p5: "Puede ofrecer paquetes para un número limitado de personas, p. Una bicicleta de agua para 1-4 personas.",
              p6: "Precio por pedido",
              p7: "Establezca un precio fijo para el pedido, independientemente del número de participantes, p. precio por alquilar un yate.",
            },
            persons_count: "Paz",
            persons_count_from: "Pax de",
            age_from: "Edad de",
            person_category_name: "Nombre de la categoría",
            add_new_item: "Agregar nuevo paquete",
            item_name: "Nombre del paquete",
            coupon_code_name: "Código de descuento",
            new_coupon_code_name: "Nuevo código de descuento",
            add_new_coupon: "Añadir nuevo descuento",
            coupon_codes_title: "Códigos de descuento",
            coupon_codes_description:
              "Si desea que enviemos un código de descuento específico a los clientes en el cupón que descargarán, especifique los códigos a continuación.",
            coupon_code_realisation_place_type_label: "¿Dónde puedes realizar el código de descuento?",
            coupon_codes_realisation_place_online_website:
              "en el sitio web en línea (por ejemplo, a través de un carrito de compras de comercio electrónico)",
            coupon_codes_realisation_place_manually: "manualmente (por teléfono o correo electrónico)",
            coupon_codes_realisation_place_custom: "personalizado",
            coupon_code_realisation_place_custom_description_placeholder:
              "Especifique cómo y dónde puede obtener el código de cupón",
            generate_coupon_codes: "Generar códigos de descuento aleatorios.",
            saas_featured_price: "",
          },
          menu: {
            description: "Descripción",
            add_locale: "Agregar / eliminar idioma",
            translate: "Traducir",
            translate_modal: {
              title: "Traducir la oferta",
              explanation: "Para traducir la oferta, agregue el idioma de destino en el menú a la izquierda sobre el botón 'Traducir' y guarde los cambios.",
              select_source_locale: "Seleccionar idioma de origen",
              select_locale: "Seleccionar idioma objetivo",
              submit: "Traducir",
            },
            pricelist: "Horario y precios",
            availability: "Disponibilidad",
            prices: "Precios",
            payments: "Pagos",
            booking_settings: "Configuraciones de reserva",
            photos: "Fotos",
            location: "Ubicacion y direcciones",
            priced_fields: "Opciones adicionales",
            customer_fields: "Campos para completar",
            additional_settings: "Configuración de Tripsomnia",
            title: "Oferta editar menú",
            accommodation_settings: "",
            integrations: ""
          },
          common: {
            remove_confirm_message: "¿Seguro que quieres eliminar esta oferta?",
            orders_button: "Pedidos",
            preview_st: "Avance",
            preview_saas: "WWW",
            save_success_message: "Los cambios en la oferta se guardaron.",
            remove_success_message: "La oferta fue eliminada.",
            add_photos_success_message: "Se agregaron fotos.",
          },
          StepAccommodationSettings: {
            form_title: "",
            accommodation_settings: {
              category: "",
              categoryOption: {
                one_person_room: "",
                two_person_room: "",
                three_person_room: "",
                four_person_room: "",
                multi_person_room: "",
                bed_in_multi_person_room: "",
                apartment: "",
                cottage: "",
                villa: "",
                holiday_house: "",
                tent: "",
              },
              categoryTitle: {
                room: "",
                bathroom: "",
                view: "",
                food_and_drinks: "",
              },
              categoryDescription: "",
            },
            default_total_stock_limit: "",
            accommodation_detail: {
              single_beds_count: "",
              double_beds_count: "",
              extra_beds_count: "",
              bathrooms_count: "",
              rooms_count: "",
              area: "",
            },
            presented_price: "",
            accommodationUnitSettings: "",
            facilities: "",
            accommodationUnitSettingsDescription: "",
            facilitiesDescription: "",
          },
          StepIntegrations: {
            log_integration_date: "",
            log_integration_action: "",
            log_integration_company_id: "",
            log_integration_uuid: "",
            filter_all_logs: "",
            filter_succeeded: "",
            filter_all_failed: ""
          }
        },
        ManageLocalesPrompt: {
          title: "Ofrecer versiones de idiomas",
          select_locale: "Elige lengua",
        },
        NewProductPrompt: {
          title: "Nueva oferta",
          name_placeholder: "Ingrese el nombre de la oferta",
          submit: "Crea una oferta",
          coupon_label: "Quiero agregar solo código con descuento",
          offer_type_header: "Elegir tipo de oferta",
          offer_type_standard_header: "Estándar",
          offer_type_standard_description:
            "Oferta con disponibilidad de fechas específicas - viajes de un día, recorridos por la ciudad, excursiones.",
          offer_type_coupon_header: "Descuento",
          offer_type_coupon_description:
            "Simplemente ofrezca - descuento sin reservar las fechas específicas, puede contener un código de descuento",
          offer_type_ticket_header: "Boleto",
          offer_type_ticket_description: "Tipo de oferta especial para atracciones, parques de atracciones, museos.",
          offer_type_voucher_header: "Vale",
          offer_type_voucher_description:
            "Cupones y cupones, que los clientes pueden comprar ahora y usar en el futuro.",
          offer_type_accommodation_header: "",
          offer_type_accommodation_description: "",
        },
        ProductsListView: {
          products: "Ofertas",
          settings: "Configuraciones",
          add_new_product: "Nueva oferta",
          no_products_message: "Aún no se han creado ofertas.",
          no_products_message_link: "Añade tu primera oferta!",
          no_products_title: "No hay ofertas.",
          search_top_bar: "",
        },
        StepAdditional: {
          hide_description_for_variants: "Ocultar variantes excepto 1er.",
        },
      },
      reviews: {
        ReviewsListView: {
          no_records_message: "Ninguno de tus clientes te ha dado una reseña todavía.",
          no_records_title: "Sin reseñas",
          title: "Comentarios",
        },
        EditReviewModal: {
          title: "revisión",
          remove_confirm_message: "¿Seguro que quieres eliminar esta crítica?",
        },
      },
      affiliate: {
        AffiliateListView: {
          no_records_message: "Aún no hay pedidos.",
          no_records_title: "No hay pedidos",
          summary_row: "En total (para las filas %{start}-%{end}):",
          title: "Programa de afiliados - estadísticas de pedidos",
        },
      },
      suppliers: {
        NewSupplierPrompt: {
          email_label: "",
        },
      },
      pagination: {
        show_10: "",
        show_20: "",
        show_30: "",
        show_50: "",
        show_100: "",
      },
      accommodation: {
        AccommodationSchedulerView: {
          title: "",
          calendarLink: "",
          noProductsInfo: "",
          availabilityTypes: {
            available_with_instant_booking: "",
            available_with_company_approval: "",
            no_changes: "",
          },
          productsHeader: "",
          pricingPlansHeader: "",
          availabilityTypeHeader: "",
          datesHeader: "",
          hintHeader: "",
          hintContent: "",
          errors: {
            maxDatesDifference: "",
            daysNotIncluded: "",
          },
          totalStockLimit: "",
        },
        AccommodationCalendarView: {
          title: "",
          schedulerLink: "Opciones avanzadas",
        },
        Accommodation: {
          totalStockLeftTypes: {
            noChanges: "",
            unavailable: "",
            specified: "",
          },
        },
      },
    },
    st: {
      pricelist_order_installment_item: {
        paid_by_cash: "en efectivo",
        paid_by_online_payment: "en línea",
        paid_by_bank_wire: "por transferencia bancaria",
        already_paid: "Pagado %{paid_by}",
        to_be_paid_right_now: "Pagar ahora",
        to_be_paid_right_after_company_approval: "Pagar después de la confirmación del pedido de la Compañía.",
        to_be_paid_on_spot: "Para pagar %{paid_by} en el acto",
        to_be_paid_until: "Para pagar %{paid_by} antes de %{date}",
        to_be_paid_after_previous_installment: "Para ser pagado %{paid_by} hasta %{date} después de la primera cuota",
        to_be_paid_now: "Pague %{paid_by} ahora",
        to_be_paid_after_order_creation: "Para ser pagado %{paid_by} hasta %{date} después del envío del pedido",
        to_be_paid_after_company_approval:
          "Se pagará %{paid_by} hasta %{date} después de la confirmación del pedido de la Compañía",
        to_be_paid_after_approval: "Para ser pagado %{paid_by} hasta %{date} después de la confirmación",
        to_be_paid_before_stock_start_date: "Se pagará %{paid_by} hasta %{date} antes del comienzo de la oferta",
        in_your_currency_it_is: "en su moneda es aproximadamente",
        payment_accepted_in_website_currency: "Moneda de pago",
        payment_accepted_in_company_currency: "Moneda de pago",
        payments_are_converted_with_following_rates: "Las tarifas se estiman sobre la base de las tarifas:",
        your_bank_can_issue_an_additional_fee_for_the_transaction:
          "Su banco puede cobrar una tarifa adicional por la transacción en una moneda extranjera.",
        to_supplier: "Proveedores",
        to_agent: "Agente",
        to_socialtravel: "A Tripsomnia",
        paid_by_dotpay: "por DotPay",
        paid_by_paypal: "por PayPal",
        marketplace_bank_wire_transfer_title: "Número de pedido de Tripsomnia %{order_id}",
        saas_bank_wire_transfer_title: "Número de pedido %{order_id}",
        bank_wire_transfer_details:
          'No tenga en cuenta este aviso si el pago ya se ha realizado. Si desea pagar el pedido, estos son los datos bancarios: %{account_description}. Título de la transferencia: "%{transfer_title}"',
        paid_by_payu: "por PayU",
        paid_by_stripe: "por Stripe",
        paid_by_terminal: "",
      },
      app_config: {
        saas_service_fee_name: "Tarifa de transacción",
        site_short_description:
          "¡Reserve on-line tours locales y atracciones turísticas de todo el mundo! Alojamiento Excursiones Atracciones en 1 lugar. Las ofertas turísticas más interesantes.",
        pdf_voucher_st_address_details: "Número de impuesto: 1132941467",
        tripsomnia_company_name: "Tripsomnia",
        tripsomnia_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_full_address: "Booking Platform Tripsomnia - A SocialTravel Company",
        tripsomnia_service_fee_name: "Tarifa de servicio de Tripsomnia",
        agent_service_fee_name: "Tarifa de servicio del agente",
        socialtravel_company_name: "SocialTravel",
        socialtravel_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_opening_hours: "lunes - viernes 9:00 - 17:00, sábado - domingo 11:00 - 17:00",
        socialtravel_service_fee_name: "Tarifa de servicio de Tripsomnia",
        socialtravel_contact_phone_number: "+48 690 670 581",
        tripsomnia_contact_phone_number: "+48 690 670 581",
      },
      create_agent_disbursement: {
        no_orders_error: "No se han seleccionado pedidos.",
        no_order_agent_error: "Uno de los pedidos seleccionados no tiene agente definido.",
        incorrect_order_company_error: "\nTodos los pedidos deben tener el mismo proveedor y agente.",
      },
    },
    countries: {
      pl: "Polonia",
    },
    customer_mailer: {
      order_marketing_info: {
        subject: "Tema",
      },
      reset_password: {
        action: "Establece tu contraseña",
        greeting: "Hola %{destinatario}!",
        instruction: "Acaba de crear su propia cuenta en Tripsomnia.",
        instruction_2: "",
        instruction_3: "Haga clic en el enlace a continuación para configurar la contraseña de su cuenta.",
        subject: "Acaba de crear su propia cuenta en Tripsomnia.",
      },
    },
    product_request_mailer: {
      customer_requested_discount_company_email: {
        hello_company: "¡Hola %{company_name}!",
        content: {
          line1: "¡La popularidad de su perfil en la plataforma Tripsomnia está aumentando!",
          line2:
            "Nuestros clientes están interesados en sus productos. A continuación encontrará una consulta de un cliente enviada según el perfil de su empresa en nuestro sitio web.",
          line3:
            "Haga clic en el enlace y complete el formulario o contáctenos en kontakt@socialtravel.pl para tomar el control del perfil de su empresa. Puede encontrar más información sobre quiénes somos y qué hacemos en nuestro sitio web getcoupon.tripsomnia.com",
        },
        details_header: "%{product-url}",
        customer_details_header: "Mensaje de un cliente",
        info: {
          line1_html: "Su perfil: %{company-url}.",
          line2_html: "Obtenga acceso para editar el perfil de la empresa %{get_company_access_url}",
          line3_html: "Sobre nosotros: getcoupon.tripsomnia.com",
        },
        subject: "",
      },
      customer_requested_discount: {
        content: {
          line1: "¡La popularidad de su perfil en la plataforma Tripsomnia está aumentando!",
        },
        info: {
          line1_html: "Su perfil: %{company-url}.",
          line2_html: "Obtenga acceso al perfil de la empresa %{get_company_access_url}.",
          line3_html: "Sobre nosotros: getcoupon.tripsomnia.com",
        },
        subject: "",
      },
      customer_requested_product: {
        subject: "Consulta de oferta del cliente - Tripsomnia",
      },
      customer_requested_product_company_email: {
        content: {
          line1: "Un cliente está interesado en su oferta y desea obtener más información.",
          line2:
            "El motivo por el que se envía una consulta puede ser la falta de disponibilidad, información insuficiente sobre la oferta o los deseos especiales de un cliente. Si es posible, actualice su oferta y comuníquese con el cliente.",
          line3: "Si necesita ayuda, contáctenos: info@tripsomnia.com",
        },
        customer_details_header: "Mensaje de un cliente",
        details_header_html: '<a href="%{product_link}">%{product_name}</a>',
        hello_company: "¡Hola %{company_name}!",
        info: {
          line1_html: 'El mensaje ha sido enviado en: <a href="%{product_link}"> enlace </a>.',
          line2_html:
            'Administre descripciones de sus ofertas y disponibilidad en el <a href="%{partnerapp_product_url}"> Panel de socios </a>.',
          line3_html:
            '¿Se te olvidó tu contraseña? Recupere la Contraseña haciendo clic <a href="%{partnerapp_reset_password_url}"> aquí </a>.',
        },
        subject: "",
      },
    },
    pl: {
      papp: {
        settings: {
          StripeSettingsView: {
            stripe_login_button: "Iniciar sesión Stripe",
            stripe_register_button: "",
          },
        },
      },
    },
    ordered_item: {
      accommodation: {
        name: {
          one: "",
          few: "",
          many: "",
          other: "",
        },
      },
      product: {
        name: "",
      },
    },
    en: {
      activerecord: {
        attributes: {
          pricing_plan: {
            preset: {
              elastic: {
                company_description: "",
                customer_description: "",
              },
              not_refundable: {
                company_description: "",
                customer_description: "",
              },
            },
          },
        },
      },
    },
  })),
  (I18n.translations.ru = I18n.extend(I18n.translations.ru || {}, {
    active_admin: {
      action_impossible: "Опериция невозможна.\n",
      action_success: "Оперция завершена успешно.",
      actual_at_x: "Данные на %{datetime}",
      add_tag_batch_action: {
        add_success: 'Тег "%{name}" удален из выбранных записей.',
        remove_instead: "Удалить тег из выбранных записей? (вместо того, чтобы добавить)",
        remove_success: 'Тег "%{name}" добавлен к выбранным записям.',
      },
      basic_details: "Основные данные",
      batch_actions: {
        button_label: "Действие на нескольких записях",
        labels: {
          add_category: "Приписать катекорию к",
          add_location: "Приписать локализацию к",
          add_product_st_tag: "Приписать тег Tripsomnia к",
          add_tag: "Приписать тег к",
          v1_st_balance_company_debt: "Расчитаться с компанией",
          add_admin_user: "Назначить пользователя-администратора для",
          add_payment_profile: "Припиши платежный профиль для",
          remove_payment_profile: "Удалить платежный профиль из",
        },
      },
      company_edit: {
        possible_to_edit_only_by_global_admin: "Редактировать может только главный администратор.",
      },
      company_registrations: {
        approve: "Подтвердить",
        reject: "Отклонить",
      },
      company_submit_monthly_invoicing_stats: {
        success: "Заказы были урегулированы.",
      },
      content_details: "Содержание",
      dashboard: "Панель управления",
      dashboard_page: {
        approved_orders: {
          title: "Заказы подтверждены",
        },
        search_orders: {
          submit: "Поиск",
          title: "Поиск заказов",
        },
        summary: {
          title: "Итог",
        },
        upcoming_orders: {
          title: "Входящие заказы",
        },
        waiting_for_company_approval_orders: {
          title: "Заказы, ожидающие подтверждения компании",
        },
        waiting_for_customer_approval_orders: {
          title: "Заказы, ожидающие подтверждения клиента",
        },
      },
      default_menu: {
        add_new: "Добавить",
        new_admin_company: "Добавить компании",
        new_admin_product_tag: "Добавить тег заказов",
        new_admin_product_tags_category: "Добавить категорию тегов заказов",
        others: "Остальные",
        users: "Пользователи",
      },
      delete_file: "Удалить файл",
      devise: {
        email: {
          title: "Довабить e-mail",
        },
        links: {
          resend_unlock_instructions: "Разблокировать аккаунт",
        },
        password: {
          title: "Пароль",
        },
        reset_password: {
          submit: "Восстановить пароль",
        },
        unlock: {
          submit: "Выслать инструкцию по восстановлению",
          title: "Разблокировать аккаунт",
        },
      },
      globalize: {
        language: {
          pl: "польский",
          en: "Английский",
          ru: "Русский",
        },
        translations: "Переводы",
      },
      go_back: "Назад",
      monthly_invoicing_stats: "Ежемесячные расчеты заказов",
      order_actions: {
        action_failed_error: "Не удалось выполнить действия из-за ошибки :%{error}",
        approve: "Подтвердить заказ",
        cancel: "Анулировать заказ",
        confirm: "Выслать заказ",
        finish: "Закончить заказ",
        redeliver_customer_order_email: "Выслать клиенту повторное письмо о заказе",
        reject: "Отклонить заказ",
        successfully_approved: "Заказ %{id} подтвержден.",
        successfully_cancelled: "Заказ %{id} отклонен",
        successfully_confirmed: "Заказ %{id} выслан",
        successfully_finished: 'Заказ %{id} отмечен как "Завершенный"',
        successfully_redelivered_customer_order_email:
          "Эл. письмо. с информацией о заказе выслано на почтовый ящик клиента %{customer_email}.",
        successfully_rejected: "Заказ %{id} отклонен.",
        view_stats: "Статистика заказов",
        redeliver_supplier_order_email: "Выслать доставщику эл.почту с информацией о заказе",
        successfully_redelivered_supplier_order_email:
          "Эл. письмо. с информацией о заказе выслано на почтовый ящик доставщика %{customer_email}.",
      },
      order_edit: {
        order_not_yet_confirmed_error:
          "Клиент еще не закончил этот заказ. Редактирование из панели администратора на данный момент невозможно.",
      },
      order_show: {
        activities: {
          email_message_email: "Почтовый адрес",
          email_message_subject: "Тема письма",
          order_status_updated_action: "Действие",
          order_status_updated_content: "Изменение статуса на %{status}",
          sms_message_content: "Содержание SMS",
          sms_message_phone_number: "№ телефона",
          title: "История заказа",
        },
      },
      order_show_company_invoice: {
        invoice_retrieval_error: "При загрузки PDF фактуры с iFirma произошла ошибка: %{error}",
      },
      order_show_customer_invoice: {
        invoice_retrieval_error: "При загрузки PDF фактуры с iFirma произошла ошибка: %{error}",
      },
      order_v1_st_balance_company_debt: {
        success: "Заказ № %{id} урегулирован с компанией.",
      },
      orders_stats: {
        average_orders_value_th: "Среднее число заказов од Х",
        in_average_th: "В среднем Х",
        in_total_th: "Всего Х",
        name_th: "Название Х",
        orders_count_th: "Количество заказов од Х",
        title: "Статистика заказов",
        total_orders_value_th: "Всего заказов од Х",
      },
      orders_v1_st_balance_company_debt: {
        success: "Выбранные заказы были урегулированы.",
      },
      preview: "Просмтореть",
      product_tags_index: {
        tag_stats: "%{products_count} с тегом, %{all_products_count} всего",
      },
      products_index: {
        batch_action_add_product_tag: {
          add_success: 'Тег "%{name}" добавлен к выбранному предложению.',
          remove_instead: "Удалить тег с выбранных предложений? ( вместо того, чтогбы добавить)",
          remove_success: 'Тег "%{name}" удален из выбранных предложений.',
        },
      },
      scopes: {
        abandoned: "Заброшено",
        all: "Все",
        approved: "Подтверждено",
        approved_finished_short: "Подтвердить / закончить",
        building: "Проект",
        cancelled: "Аннулировано",
        category: "Категории",
        company_tag: "Теги компаний",
        customer_tag: "Теги клиентов",
        deprecated_v1_accomodation: "Ночлеги",
        deprecated_v1_coupon: "Ваучеры / Скидки",
        deprecated_v1_special_offer: "Специальные предложения",
        deprecated_v1_trip: "Экскурсии",
        finished: "Завершено",
        future_customers: "Пришли",
        location: "Локализации",
        lost_customers: "Потерянные",
        marketplace: "Marketplace",
        order_tag: "Теги заказов",
        past_customers: "Прошли",
        product_st_tag: "Теги Tripsomnia",
        prospect_customers: "Потенциальные",
        rejected: "Отклонено",
        saas: "SaaS",
        waiting_for_company_approval: "Ожидается подтверждение компании",
        waiting_for_customer_approval: "Ожидаетя подтверждение клиента",
        product_company_tag: "Теги компании",
      },
      search_status: {
        current_filters: "Текущие фильтры:",
        current_scope: "Текущая область:",
        headline: "Область:",
        no_current_filters: "Не выбрано",
      },
      sidebars: {
        relation_no_results: "нет результатов.",
      },
      successfully_created: "%{model} успешно создан.",
      successfully_updated: "%{model} успешно принят.",
      tabs: {
        availability: "Доступность",
        base_details: "Основные данные",
        description: "Описание",
        images: "Фотографии",
        invoicing: "Расчеты",
        location: "Локализация",
        other_details: "Остальные параметры",
        pricelists: "Ценник",
        product_order_fields: "Дополнительные параметры",
        product_variants: "Варианты",
      },
      widgets: "Виджеты",
      wrong_lock_version_error:
        "Эта запись %{resource_name} была изменена. Откройте форму в новой вкладке и внесите свои изменения.",
      location_details: "Локализация",
      companies: {
        destroy: {
          action_impossible_company_has_orders_as_supplier:
            "Нельзя удалить эту компанию, так как у нее есть заказы и поставщик. Перед удалением компании следует удалить заказы.",
        },
      },
      pp_edit: "Редактировать в ПП",
      add_admin_user_batch_action: {
        remove_instead: "Удалить пользователя из выбранных компаний? (вместо добавления)",
        success: "Действие было успешно",
      },
      add_payment_profile_action: {
        success: "Профиль платежа был приписан выбранным рекордам",
      },
      pricing_plans: {
        new_elastic_plan: "",
        new_not_refundable_plan: "",
      },
      remove_payment_profile_action: {
        success: "Профиль платежа был устранен из выбранных рекордов",
      },
    },
    fe: {
      active_admin: {
        view_collection_item_nested_form: {
          toggle_show: "Показать / Убрать собственные а��рибуты",
        },
      },
      ckeditor: {
        subsection_expand: {
          content:
            "Содержание секции, которая будет по умолчанию скрыта,а пользователь сможет ее высветлить только после нажатия мышкой на название.",
          title: "Название секции",
        },
        subsection_read_more: {
          content: 'Содержание секции, которая, в случае длинного текста, будет сокращена до ссылки "Читать далее"',
          title: "Название секции",
        },
      },
      NewOrderCalendarForm: {
        help_tip: "Легенда (наведите курсор)",
        product_chosen: "Вы выбрали предложение %{name} на срок %{date_range}.",
        stock_available: "Срок доступен",
        stock_available_but_impossible_as_end: "Дата доступна, но закончить пребывание в этот день нельзя",
        stock_available_but_impossible_as_start: "Дата доступна, но начать пребывание в этот день нельзя",
        stock_busy: "Срок недоступен",
        stock_discounted: "Специальная цена",
        submit: "Дальше",
        previous_slots: "Предыдущие промежутки",
        next_slots: "Следующие промежутки",
        stock_confirmed: "Дата подтверждена",
      },
      NewOrderConfirmPricingForm: {
        submit: "Дальше",
      },
      NewOrderCustomerDetailsForm: {
        order_with_payment_requirement: "заказ с требованием оплаты",
        participant_name_with_number: "Участник № %{i}",
        required_fields: "обязательные поля",
        submit: {
          make_order: "Забронировать",
          next: "Дальше",
        },
      },
      NewOrderPaymentForm: {
        almost_booked: "Поздравляем! Еще минута и Вы закончите предзаказ.",
        almost_finished: "Поздравляем! Еще минута и Вы закончите заказ.",
        cancelled_if_not_paid: "Если платеж не будет осуществлен вовремя, ваш заказ будет автоматически отклонен.",
        dotpay_go_back_button: "Вернитесь к форме бронирования",
        order_with_payment_requirement: "заказ с требованием оплаты",
        pay_to_book: {
          marketplace:
            "Когда Вы только оплатите %{confirmation_installment_transaction_amount} при посредничестве безопасных платежу online, организатор сможет подтвердить Ваш заказ.",
          saas: "Когда Вы уплатите %{confirmation_installment_transaction_amount} по платежной системе, мы получим ваш заказ и сможем его окончательно подтвердить.",
        },
        pay_to_finish:
          "Когда Вы уплатите %{confirmation_installment_transaction_amount} по платежной системе, мы автоматически предоставим Вам ваучер pdf с данными вашего заказа.",
        payment_deadline: "Срок платежа: %{pauses_at}.",
        please_pay_online_deposit:
          "Пожалуйста, сделайте оплату %{confirmation_installment_transaction_amount} через нашу безопасную систему платежей онлайн.",
        safe_payments_guaranteed_by: "Безопасная оплата гарантируется",
        submit: {
          book_and_pay: "Забронируйте и оплатите сейчас %{price}",
          pay: "Оплатить сейчас %{price}",
          pay_with_dotpay: "Заплатить %{price} через систему электронных платежей",
          pay_with_paypal: "Заплатить %{price} через PayPal",
        },
        choose_payment_method: "Выберите способ оплаты:",
        pay_by_bank_wire: "банковским переводом",
        pay_by_credit_card:
          "Оплатите с помощью своей карты (без учетной записи PayPal) или войдите в систему и оплатите с помощью PayPal.",
        by_bank_wire: "банковским переводом",
        by_credit_card:
          "Заплати кредитной картой (Вам не нужно иметь или создавать учетную запись PayPal) или зарегистрируйся и заплати через PayPal.",
        by_bank_wire_or_credit_card: "Оплата банковской картой или онлайн-переводом.",
        by_paypal: "Зарегистрируйся, чтобы заплатить через PayPal.",
        pay_by_credit_card_or_paypal:
          "Оплатите с помощью своей карты (без учетной записи PayPal) или войдите в систему и оплатите с помощью PayPal.",
        by_payu: "Заплати дебетовой или кредитной картой",
        payu_button: "Оплатите через PayU",
      },
      NewOrderProductForm: {
        choose_payment_profile: "Выберите профиль платежа",
        items_count: "Количество %{items}",
        multiple_pricings_alert:
          'Внимание: из-за дато-продажных лимитов, мы не можем рассчитать всех %{product_quantity} %{items} на основе прайс-листа "%{product_pricelist_name}".',
        multiple_pricings_info: "Вместо этого, выбранная вами комбинация будет рассчитана следующим образом",
        custom_location_name_placeholder: "Впишите адрес, с которого организатор Вас заберет",
        submit: "Дальше",
      },
      NewOrderView: {
        building: "Бронируете",
        built: "Заказали",
        contact_us_if_problem_repeats: "Если ошибка будет появляться снова, просим связаться с нами: %{email}.",
        loading_failed:
          "Произошла ошибка во время загрузки данных предложения. Обновите страницуи и попробуйте еще раз.",
        loading_in_progress: "Загрузка данных...",
        marketplace: {
          additional_bank_wire_deposit_required: "Этот заказ требует дополнительного платежа на банковский счет.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "Наш партнер %{company_link} получит Ваш предварительный заказ сразу после сделанного Вами подтверждения. У нашего партнера есть  %{company_approval_time_limit} часов на ответ, однако большинство из них отвечает в течении одного часа во время местных рабочих часов.",
          bank_wire_deposit_deadline_warning:
            "Помните, пожалуйста, об осуществлении денежного перевода вовремя. Если Вы не уплатите аванса на банковский счет в указанном времени, ваш заказ может быть отменен. ",
          bank_wire_deposit_details: "Данные для банковского перевода",
          bank_wire_deposit_instructions:
            "В названии денежного перевода введите, пожалуйста, только номер заказа, находящийся в данном подтверждении. В другом случае мы не сможем гарантировать, что перевод будет зафиксирован вовремя.",
          building: "Бронируете",
          built: "Заказали",
          company_approved_your_order_request:
            'Наш партнер %{company_link} подтвердил Ваш предварительный заказ № %{order_id} на "%{product_name}".',
          company_received_your_order_request_and_has_to_approve_it:
            "Наш партнер %{company_link} получил Ваш предварительный заказ. У нашего партнера есть %{company_approval_time_limit} на ответ, однако большинство из них отвечает в течении одного часа во время местных рабочих часов.",
          contact_us_if_problem_repeats: "Если ошибка будет появляться снова, просим связаться с нами: %{email}.",
          customer_full_name: "Имя и фамилия заказчика",
          download_order_data_confirmation: "Загрузить подтверждение заказа",
          further_details: "Дальнейшая информация ",
          if_no_online_payment_your_order_will_be_cancelled: "В случае отсутствия оплаты, заказ будет аннулирован.",
          loading_failed: "Произошла ошибка при загрузке данных предложения. Пожалуйста, перезагрузите страницу.",
          loading_in_progress: "Загрузка данных...",
          order_is_waiting_for_company_approval: "Ваш заказ ожидает подтверждения партнера %{company_link}. ",
          order_name: "Заказ № %{id}",
          order_status: "Статус заказа",
          please_pay_bank_wire_deposit: "Пожалуйста, произведите оплату через банковский перевод.",
          repeat_payment: "Повторите платеж",
          share_us_to_friends:
            "Хотите знать о самых интересных предложениях и скидках? Кликните «Мне нравиться» либо порекомендуйте нас другим!",
          thank_you_for_order: "Благодарим за заказ!",
          thank_you_for_order_and_share_to_fb:
            "Благодарим за заказ. Помогите нам и порекомендуйте это предложение своим друзьям на Фейсбуке!    ",
          thank_you_for_order_request: "Благодарим Вас за оформление предварительного заказа.",
          we_received_all_required_order_informations: "Мы уже получили от Вас всю необходимую информацию.",
          we_received_all_required_order_informations_and_online_payment:
            "Мы уже получили от вас всю необходимую информацию и оплату.",
          we_sended_order_confirmation_to_your_email:
            "На ваш электронный адрес мы выслали подтверждение заказа в формате .pdf.",
          we_sended_order_request_confirmation_to_your_email:
            "На ваш электронный адрес мы выслали подтверждение вашего предварительного заказа.",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "Если заказ будет подтвержден, зафиксированная сумма пойдет на оплату заказа. Если партнер %{company_link} отвергнет вашу просьбу или не подтвердит ее вовремя, %{confirmation_installment_st_name} сумма аванса будет автоматически возвращена на ваш банковский счет в течении 24 часов. Вы можете тогда сделать заказ на другое предожение.",
          when_company_approves_we_will_send_online_payment_email:
            "В случае, если партнер %{company_link} подтвердит Ваш предварительный заказ, Вы получите эл. письмо вместе с ссылкой на оформление платежа онлайн на сумму %{confirmation_installment_amount}. У Вас %{confirmation_installment_after_company_approval_time_limit} од момента подтверждения заказа на реализацию платежа через систему электронных платежей.",
          when_company_approves_we_will_send_order_confirmation:
            "Если партнер %{company_link} подтвердит Ваш предварительный заказ, вы получите эл. письмо с подтверждением. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "Наш партнер %{company_link} получит Ваш предварительный заказ сразу после сделанного Вами подтверждения. У нашего партнера есть  %{company_approval_time_limit} часов на ответ, однако большинство из них отвечает в течении одного часа во время местных рабочих часов.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "После подтверждения платежа через систему электронных платежей, Вы получите эл. письмо с потверждением вашего заказа. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "Файл можно загрузить нажав на кнопку ниже.",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "В подтверждении заказа Вы получите также информацию на счет оставшейся суммы для оплаты на банковский счет. ",
          your_order_id: "Номер вашего заказа",
          your_order_is_fully_confirmed: "Ваш заказ уже подтвержден.",
          online_payment_failed: "К сожалению, ваш платеж по системe электронных платежей не получился.",
          order_is_waiting_for_online_payment_info:
            "Ваш заказ ждет сейчас информации от системы электронных платежей на счет осышествленного Вами платежа. ",
        },
        order_name: "Заказ № %{id}",
        saas: {
          additional_bank_wire_deposit_required: "Этот заказ требует дополнительного платежа на банковский счет.",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it:
            "Мы получили Ваш предварительный заказ сразу после осуществления платежа. У нас %{company_approval_time_limit} на ответ, но обычно мы отвечаем в течении часа во время работы нашего офиса.",
          bank_wire_deposit_deadline_warning:
            "Помните, пожалуйста, об осуществлении денежного перевода вовремя. Если Вы не уплатите аванса на банковский счет в указанном времени, ваш заказ может быть отменен. ",
          bank_wire_deposit_details: "Данные для банковского перевода",
          bank_wire_deposit_instructions:
            "В названии денежного перевода введите, пожалуйста, только номер заказа, находящийся в данном подтверждении. В другом случае мы не сможем гарантировать, что перевод будет зафиксирован вовремя.",
          company_approved_your_order_request:
            'Мы подтвердили Ваш предварительный заказ № %{order_id} на"%{product_name}".',
          company_received_your_order_request_and_has_to_approve_it:
            "Мы получили ваш предварительный заказ. У нас %{company_approval_time_limit} на ответ, но обычно мы отвчаем в течении одного часа во время работы офиса.",
          customer_full_name: "Имя и Фамилия заказчика",
          download_order_data_confirmation: "Загрузить подтверждение заказа ",
          further_details: "Больше информации",
          if_no_online_payment_your_order_will_be_cancelled: "В случае отсутствия оплаты, заказ будет аннулирован.",
          order_is_waiting_for_company_approval: "Ваш заказ ожидает нашего подтверждения.",
          order_status: "Статус заказа",
          please_pay_bank_wire_deposit: "Просим осуществить платеж через банковский перевод.",
          repeat_payment: "Повторите платеж",
          thank_you_for_order: "Благодарим за заказ!",
          thank_you_for_order_request: "Благодарим за предварительный заказ.",
          we_received_all_required_order_informations: "Мы уже получили всю необходимую информацию.",
          we_received_all_required_order_informations_and_online_payment:
            "Мы уже получили всю необходимую информацию и оплату.",
          we_sended_order_confirmation_to_your_email:
            "На ваш электронный адрес мы выслали подтверждение заказа в формате .pdf.",
          we_sended_order_request_confirmation_to_your_email:
            "На ваш электронный адрес мы выслали подтверждение вашего предварительного заказа.",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit:
            "Если мы будем вынуждены отвергнуть вашу просьбу или позволим ей истечь, онлайн %{confirmation_installment_st_name} будет автоматически возвращена на Ваш банковский счет в течении 24 часов. Вы можете также связаться с нами и выбрать другое предложение.",
          when_company_approves_we_will_send_online_payment_email:
            "В случае подтверждения предварительного заказа, Вы получите эл. письмо вместе с ссылкой к оформлению платежа онлайн на сумму %{confirmation_installment_amount}. У Вас %{confirmation_installment_after_company_approval_time_limit} с момента подтверждения заказа на осушествление платежа через систему электронных платежей.",
          when_company_approves_we_will_send_order_confirmation:
            "В случае подтверждения предварительного заказа, Вы получите эл. письмо с подтверждением. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it:
            "Мы получим ваш предварительный заказ сразу после отправления его. У нас %{company_approval_time_limit} на ответ, но обычно мы отвчаем в течении одного часа во время работы офиса.",
          when_payment_gets_approved_we_will_send_order_confirmation:
            "После подтверждения платежа через систему электронных платежей, Вы получите эл. письмо с потверждением вашего заказа. %{you_will_find_bank_wire_deposit_infos_in_order_confirmation}\n",
          you_can_download_order_data_confirmation_using_button_below_as_well:
            "Документ можно так же загрузить с помощью кнопки расположенной ниже.",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation:
            "В подтверждении заказа Вы получите также информацию на счет оставшейся суммы для оплаты на банковский счет. ",
          your_order_id: "Номер вашего заказа",
          your_order_is_fully_confirmed: "Ваш заказ уже подтвержден.",
          online_payment_failed: "К сожалению, ваш платеж по системe электронных платежей не получился.",
          order_is_waiting_for_online_payment_info: "Ваш заказ ждет сейчас информации о осышествленным Вами платеже. ",
        },
        step_number: "Шаг %{i}",
        title: "Заказ № %{order_id} - %{site_name}",
        show_on_map: "Показать на карте",
        marketplace_booking_unavailable_message_html:
          "К сожалению, на данный момент нет доступных сроков. Если Вы все же заинтересованы, напишите нам на %{email},позвоните на номер %{phone_number} либо %{open_chat} прямо сейчас.",
        saas_booking_unavailable_message_html:
          "К сожалению, на данный момент нет доступных сроков. Если Вы все же заинтересованы, напишите нам на %{email} либо позвоните на номер %{phone_number}.",
        open_chat: "начать чат с нашим консультантом",
        choose_date_step_title: "Выберите дату",
        fill_order_step_title: "Оформите заказ",
        confirm_payment_details_step_title: "Подтвердить детали платежа",
        fill_customer_details_step_title: "Укажите ваши данные",
        make_online_payment_step_title: "Заплатить онлайн через систему электронных платежей",
        order_is_waiting_for_your_approval: "Заказ ожидает Вашего подтверждения",
        click_below_to_approve: "Кликните ниже, чтобы подтвердить",
        reject_order: "Аннулировать заказ",
        approve_order: "Подтвердить заказ",
        approve_order_failed:
          "При подключении к серверу произошла ошибка. Пожалуйста, попробуйте еще раз. В случае дальнейших проблем, пожалуйста, обращайтесь к администрации сайта по эл. почте info@tripsomnia.com.",
        order_is_finished: "Ваш заказ отмечен как завершенный. ",
        we_havent_received_your_review_yet:
          "Мы пока еще не получили вашего отзыва о наших услугах. Поделитесь вашим мнением с другими пользователями!",
        write_a_review: "Напишите отзыв",
      },
      navbar_search: {
        products_count: "%{count} предложений",
        categories: "Категории",
        suppliers: "Доставщики",
        products: "Предложения",
        search_nearby: "Искать поблизости",
        search_query: "Искать по фразе",
      },
      new_order: {
        errors: {
          connection_error_during_saving: "Произошла ошибка во время сохранения заказа на сервере.",
          insufficient_product_quantity:
            "В выбранном количестве %{items} могут поместиться максимум %{max_persons_count} человек. Увеличьте количество %{items} до %{desired_quantity} либо уменьшите количество людей.",
          max_quantity_limit: "На данное предложение в выбранном сроке доступно максимально %{max_quantity} ваучеров.",
          missing_value: "Заполните поле.",
          personal_data_agreement_missing: "Вы должны дать согласие на обработку ваших персональных данных.",
          product_not_found: "Выбранное предложение не найдено.",
          product_schedule_slot_missing: "Выбранный срок предложения уже не доступен.",
          product_variant_not_found: "Выбранный вид предложения не найден.",
          rules_agreement_missing: "Вы должны одобрить правила нашего веб-сайта.",
          online_payment_impossible_for_selected_parameters:
            "К сожалению, онлайн оплата через %{payment_method} недоступен для этого заказа. Пожалуйста, выберите другой способ платежа.",
          partners_agreement_missing: "Нужно дать согласие на соглашение, касающееся данных партнеров.",
          rodo_agreement_missing: "Нужно дать согласие на переработку личных данных.",
        },
        marketplace_service_fee_tooltip:
          "С помощью этой оплаты мы финансируем деятельность веб-сайта и предоставление услуг, например, помощи во время поездки или обработки платежа.",
        saas_service_fee_tooltip:
          "С помощью этой оплаты мы финансируем деятельность веб-сайта и предоставление услуг, например: помощи во время поездки или обработки платежа.",
        v1_bank_wire_deposit_tooltip: {
          marketplace:
            "Данные банковского счета для осыществления денежного перевода, а также крайний срок осуществления платежа Вы получите в подтверждении заказа на указанный эл. адрес.",
          saas: "Данные счета для платежа и крайний срок оформления платежа Вы получите в подтверждении заказа на указанный в бланке эл. адрес. ",
        },
        v1_online_deposit_tooltip: {
          marketplace: {
            line1:
              "%{confirmation_installment_st_name} подтверждение онлайн создано для гарантии заказа. В случае Вашего отказа применяются условия отмены из данного предложения.",
            line2:
              "Наш партнер %{company_link} получит Ваш предварительный заказ сразу после Вами сделанного подтверждения. У нашего партнера есть  %{company_approval_time_limit} часов на ответ, однако большинство из них отвечает в течении одного часа во время местных рабочих часов.",
            line3:
              "Если наш партнер будет вынужден отвергнуть Вашу просьбу или позволит ей истечь, %{confirmation_installment_st_name} сумма предоплаты онлайн будет автоматически возвращена на Ваш банковский счет в течении 24 часов. Вы можете также связаться с нами и выбрать другое предложение.",
          },
          saas: {
            line1:
              "%{confirmation_installment_st_name} подтверждение онлайн создано для гарантии заказа. В случае Вашего отказа применяются условия отмены из данного предложения или, если они отсутствуют применяется наши общие условия.",
            line2:
              "Мы получим ваш предварительный заказ сразу после отправления его. У нас %{company_approval_time_limit} на ответ, но обычно мы от��чаем в течении одного часа во время работы офиса.",
            line3:
              "Если мы будем вынуждены отвергнуть вашу просьбу или позволим ей истечь, онлайн %{confirmation_installment_st_name} будет автоматически возвращена на Ваш банковский счет в течении 24 часов. Вы можете также связаться с нами и выбрать другое предложение.",
          },
        },
        confirmation_installment_st_name: {
          deposit: "Задаток",
          fee: "Оплата",
          prepayment: "Предоплата",
        },
        v1_rest_deposit_tooltip: {
          on_the_arrival: "Доплатите оставшуюся сумму в день начала предложения.",
          on_the_spot: "Доплатите оставшуюся сумму на месте.",
          trip: "Доплатите оставшуюся сумму в начале путевки или перед началом путевки в офисе.",
        },
      },
      order: {
        confirmation_installment_after_company_approval: "Уплатить после подтверждения заказа партнером.",
        new_order_name: "Новый заказ",
        order_name: "Заказ № %{order_id}",
        v1_online_deposit_now: "Нужно заплатить",
        stock_useby_time_range: {
          between: "",
          from: "",
          to: "",
        },
      },
      order_details: {
        bank_wire_deposit_account_description: "Данные дла денежного перевода",
        company_details: "Данные организатора",
        customer_details: "Данные заказчика",
        extra_paid_amount: "Кроме того, уплачено",
        marketplace_service_fee: "Плата за услуги\n",
        order_details: "Данные предложения",
        order_name: "Заказ № %{order_id}",
        overpaid_total_amount: "Переплачено",
        paid_amount: "Уплачено",
        product_details: "Данные предложения",
        refunded_amount: "Возвращено",
        remaining_total_amount: "Оставшаяся сумма",
        remaining_total_amount_short: "Нужно заплатить",
        saas_service_fee: "Плата за услуги",
        total_amount: "Сумма заказа",
        total_amount_short: "Вместе",
        to_be_paid_total_amount: "Общая сумма",
        coupon_offer_price: "Окончательная цена",
        coupon_offer_price_before_discount: "Общая цена",
        coupon_discount_amount: "Наша скидка",
        coupon_code_realisation_place_online_website_description:
          "Заказывая предложение на веб странице, впишите код с купона",
        coupon_code_realisation_place_manual_description:
          "Заказывая предложение по телефону улу эл. почтой, не забудьте упомянуть код с купона.",
        ends_at: "",
        starts_at: "",
      },
      personal_data_agreement: {
        label:
          "Я выражаю согласие на обработку моих личных данных через SocialTravel sp. z o.o. с целью реализации заказа",
        tooltip:
          "В то же время я подтверждаю, что ознакомлен с положением об обработке персональных данных в соответствии с Положением Европейского Парламента и Совета ЕС 2016/679 с 27 апреля 2016 «GDPR». Запрос о согласии представлен мне в выразительной и понятной форме. Вместе с тем, я ознакомлен, что предоставление данных сделано добровольно. Я был также проинформирован и даю свое согласие, что данные собираемые через SocialTravel sp. z o.o., Ал. Князя Юзефа Понятовского, 1, 03-901 Варшава, Польша, были добровольно мной представлены с целю оброботки моего заказа, а также что данные те не будут открыты для доступа другим субъектам.",
      },
      pricelist_expiration_countdown: {
        discount_ends_today: "Уценка заканчивается сегодня в %{expires_at}.",
        discount_ends_tomorrow: "Уценка заканчивается завтра в %{expires_at}.",
        product_about_to_finish: "Это предложение скоро закончится.",
        product_finished: "Это предложение уже закончилось.",
        x_days_left_to_end_of_discount: {
          one: "Остался 1 день до конца специального предложения!",
          few: "Осталось %{count} дня до конца специального предложения!",
          many: "Осталось %{count} дней до конца специального предложения!",
          other: "Осталось %{count} дня до конца специального предложения!",
        },
        x_left_to_end_of_discount: "Осталось %{time} до конца уценки!",
      },
      products_map: {
        buy_product: "Забронировать срок",
      },
      reservation_calendar: {
        only_x_in_this_price: "Только %{count} в этой цене",
        per_night: " / ночь",
        valid_on: "Обязывает",
        last_stocks: "Последние места",
      },
      rules_agreement: {
        marketplace: {
          label:
            "Одобряю %{link} и даю свое согласие на предоставление услуг компанией Tripsomnia перед истечением срока на отклонение от контракта.",
          link: "Правила веб-сайта",
        },
        saas: {
          label:
            "Одобряю %{link} и даю свое согласие на предоставление услуг Организатором перед истечением срока на отклонение от контракта.",
          link: "Правила Организатора",
        },
      },
      sidebar_section_order: {
        order_details: "Данные заказа",
        title: "Ваш заказ",
      },
      sidebar_section_product: {
        extend: "Развернуть",
        product_details: "Информации о предложении",
      },
      common: {
        site_title: "Tripsomnia",
        loading_failed_message: "Произошла ошибка при загрузке данных.",
        click_to_load_again: "Нажмите здесь, чтобы перезагрузить.",
        loading_message: "Загрузка данных...",
        show_more: "Покзазать больше",
        next_page: "Следующая страница",
        previous_page: "Предыдущая страница",
        zendesk_livechat_window_title: "Поддержка",
        zendesk_livechat_concierge_name: "Обслуживание клиентов",
        zendesk_livechat_concierge_title: "Мы здесь, чтобы вам помочь!",
        close: "Закрыть",
      },
      ProductsCalendarWidget: {
        site_title: "Календарь сроков",
      },
      ReviewsListWidget: {
        no_reviews_yet: "Еще нет отзывов.",
        add_first_review: "Хотите добавить первый?",
        add_new_review: "Напишите отзыв",
        total_count: {
          one: "%{formatted_count} отзыв",
          few: "%{formatted_count} отзыва",
          many: "%{formatted_count} отзывов",
          other: "%{formatted_count} отзывa",
        },
        average_rating: "Средняя оценка",
        rating: "Счет",
      },
      PaymentMethodsHelper: {
        cash_tooltip: "Платеж наличными на месте",
        online_tooltip: "100% для онлайн оплаты",
        online_plus_cash_tooltip: "Заплатите онлайн предоплату сейчас + остальную часть заплтите наличными на месте",
      },
      products_listing: {
        medium_priority: "Рекомендуется",
        high_priority: "Лучшее предложение",
      },
      bslanding: {
        about_us_contact_form: {
          loading_message: "Загрузка...",
          success_message: "Сообщение успешно отправлено.",
          failure_message: "При отправке сообщения произошла ошибка.",
        },
        for_companies_contact_form: {
          loading_message: "Загрузка...",
          success_message: "Запрос успешно выслан. Мы ответим вам в скором времени.",
          failure_message: "При отправке сообщения произошла ошибка.",
        },
      },
      CouponsWidget: {
        title: "Выберите свое предложение",
        discount_amount: "%{amount} скидка",
        until_product_offer_ends: "%{timeDuration} до конца",
        only_x_coupons_left: "Скачано %{total_stock_used} купонов.",
        stock_useby_date_range: "Можно использовать %{date_range}",
        order_price: "Окончательная цена",
        order_price_before_discount: "Общая цена",
        order_discount_amount: "Наша скидка",
        build_order_button: "Получить ваучер",
        build_order_failed:
          "Возникли проблемы при попытке получения деталей этого предложения. Попробуйте еще раз либо выберите другое предложение.",
        confirm_order_button: "Скачать ваучер",
        confirm_order_failed:
          "Возникли проблемы во время сохранения данных. Попробуйте еще раз либо выберите другое предложение.",
        form_title: "Написать свои данные",
        confirm_order_succeded:
          "Мы успешно сгенерировали ваш ваучер! Проверьте свой почтовый ящик, мы выслали вам ваш ваучер по эл. почте.",
        product_short_description: "Ключевые информации ",
        product_description: "Описание продукта",
        product_variant_short_description: "Описание предложения",
        product_customer_requirements: "Требования клиента",
        extend_infos: "Показать детали »",
        get_coupon: "Скачать купон",
        hint_title: "Воспользуйтесь нашим промо-акциями",
        hint_content:
          "<ol><li>Выберите интересующую вас акцию.</li><li>Посмотрите ее описание и условия.</li><li>Предоставьте запрошенные данные и загрузите купон.</li><li>Используйте купон на скидку при бронировании.</li></ol>",
        less_than_x_coupons_left: "Доступно менее %{total_stock_left} купонов.",
        no_results_alert: "К сожалению, у нас больше нет купонов. Повторите попытку позже.",
      },
      partners_agreement: {
        label:
          "Я соглашаюсь на переработку моих личных данных через доверенных партнеров SocialTravel с целью реализации заказа.",
        tooltip:
          "Добровольно выражаю свое согласие с положением об обработке персональных данных в соответствии с Положением Европейского Парламента и Совета ЕС 2016/679 с 27 апреля 2016 «GDPR» на переработку и сбор моих личных данных через доверенных партнеров с целью коммуникации и реализации моего заказа, а также поддержки после продажы.",
      },
      rodo_agreement: {
        label:
          "Я сознателен моих прав, возникающих со статьи 7 генерального регламента о защите персональных данных (GDPR)",
        tooltip:
          "В то же время я подтверждаю, что ознакомлен с положением об обработке персональных данных в соответствии с Положением Европейского Парламента и Совета ЕС 2016/679 с 27 апреля 2016 «GDPR». Запрос о согласии представлен мне в выразительной и понятной форме. Вместе с тем, я ознакомлен, что предоставление данных сделано добровольно. Я был также проинформирован и даю свое согласие, что данные собираемые через SocialTravel sp. z o.o., были добровольно мной представлены с целю оброботки моего заказа, а также что данные те не будут открыты для доступа другим субъектам.",
      },
      tripsomnia_contact_email: "info@tripsomnia.com",
      tripsomnia_contact_phone_number: "+48 690 670 581",
    },
    ransack: {
      predicates: {
        eq: "равняется",
      },
    },
    api: {
      base: {
        unauthorized: "Доступ запрещен. Пожалуйста, авторизуйтесь еще раз.",
        company_inactive: "Выбранная фирма неактивна. Выберите другую либо постарайтесь ее активировать.",
        disabled: "",
        secret_invalid: "",
      },
    },
    activerecord: {
      attributes: {
        admin_user: {
          companies: "Управляемые компании",
          companies_ids: "Управляемые компании",
          company_admin: "Company Admin",
          company_employee: "Сотрудник",
          editor_admin: "Editor Admin (TP)",
          global_admin: "Global Admin (SS)",
          main_admin: "Main Admin (S)",
          default_new_company_role: "Роль по умолчанию для новых компманий",
        },
        agent_cooperation: {
          fixed_gross_pricing: "Фискированные цены брутто",
          fixed_net_pricing: "Фиксированные цены нетто",
          pricing_type: "Способ установления цен",
          realtime_pricing: "Текущие цены",
          st_fixed_gross_pricing: "Фиксированные цены брутто",
          st_fixed_net_pricing: "Фискированные цене нетто",
          st_realtime_pricing: "Текущие цены",
        },
        company: {
          accepts_printed_customer_vouchers: "Принимаете ли Вы от клиентов распечатанные ваучеры, выставленные нами?",
          admin_users: "Пользователи компании",
          admin_users_ids: "Пользователи компании",
          contact_email: "Адрес эл. почты",
          contact_email_placeholder: "Контактных адрес эл. почты",
          contact_facebook_url: "Адрес фанпейджа на Facebook",
          contact_facebook_url_placeholder: "Адрес Вашей страницы на Facebook",
          contact_full_address: "Адрес офиса",
          contact_full_address_placeholder: "напр. ул. Бородина 14/28\n12-345 Красноярск\nВторой подьезд",
          contact_languages: "Контактные языки",
          contact_languages_placeholder: "Языки, на которых клиенты могут к Вам обращаться.",
          contact_opening_hours: "Облуга клиента в",
          contact_opening_hours_placeholder: "Рабочее время Вашего офиса (нп. ПН-ПТ 08:00 - 16:00)",
          contact_phone_number: "Контактный телефон",
          contact_phone_number_placeholder: "Контактный телефон",
          contact_website_url: "Веб-страница",
          contact_website_url_placeholder: "Адрес веб-страницы",
          default_product_price_currency: "Валюта по умолчанию для новых предложений",
          general_terms: "Правила",
          general_terms_placeholder:
            "Правила для Ваших клиентов, которые они должны будут подтвердить при оформлении заказа.",
          invoice_city: "Город",
          invoice_company_name: "Название компании",
          invoice_country_name: "Страна",
          invoice_data: "Данные к фактуре",
          invoice_email: "Адрес эл. почты",
          invoice_nip: "ИНН",
          invoice_phone_number: "Номер телефона",
          invoice_postal_code: "Почтовый код",
          invoice_street_address: "Улица, № дома и квартиры",
          locale: "Основной язык",
          logo_image: "Профильное фото / лого",
          marketplace_cover_image: "Фоновое изображение (Tripsomnia)",
          marketplace_meta_description: "Описание страницы (SEO) (Marketplace)",
          marketplace_meta_title: "Название страницы (SEO) (Marketplace)",
          marketplace_name: "Публичное название (Marketplace)",
          marketplace_short_description: "Краткое описание (Marketplace)",
          marketplace_short_description_placeholder:
            "Краткое описание Вашей компании, которое будет висеть на странице Вашей компании в Tripsomnia.com",
          name: "Название компании",
          name_placeholder: "Лимит - 100 знаков.",
          notifications_email: "Адрес эл. почты для уведомлений",
          notifications_phone_number: "Контактный телефон для уведомлений",
          public_name: "Публичное название",
          saas_cover_image: "Фоновое изображение (Tripsomnia)",
          saas_meta_description: "Описание страницы (SEO) (SaaS)",
          saas_meta_title: "Название страницы (SEO) (SaaS)",
          saas_name: "Публичное название (SaaS)",
          saas_short_description: "Краткое описание (SaaS)",
          saas_short_description_placeholder:
            "Краткое описание Вашей компании, которое будет висеть на странице Вашей главное странице.",
          saas_subdomain: "Поддомент SaaS",
          active: "Активно?",
          default_products_enable_frontend_slots_listing: "Вместо календаря, показывать список дат",
          enable_saas: "Включить SaaS",
          enable_marketplace: "Включить Marketplace",
          affiliate_commision_calculation_type: "Способ вычисления комиссионных аффилиата",
          agent_earnings_percentage: "Процент от заработка агента от заказа (комиссионные + плата за услуги)",
          total_base_amount_percentage: "Процент от базовой стоимости заказа",
        },
        company_member: {
          company_admin: "Администратор",
          company_employee: "Сотрудник",
          editor_admin: "Editor Admin (TP)",
          global_admin: "Global Admin (SS)",
          main_admin: "Main Admin (S)",
        },
        customer: {
          display_name: "Название",
          full_name: "Имя и фамилия",
          full_name_contains: "Имя и фамилия",
          future: "Будущий",
          lost: "Потеряно",
          orders_company_id: "Заказ: Компания",
          orders_product_id: "Заказ: Предложение",
          orders_product_name: "Заказ: Название предложения",
          orders_product_product_tags_id: "Заказ: Теги предложения",
          orders_product_variant_id: "Заказ: Вариант предложения",
          orders_status: "Заказ: Статус",
          origin: "Источник",
          past: "Прошлый",
          prospect: "Потенциальный",
        },
        installment: {
          confirmation_after_company_approval: "Служит в качестве подтверждения заказа после подтверждения компанией",
          confirmation_before_company_approval: "Служит в качестве подтверждения заказа до подтверждения компанией",
          remaining_amount: "Оставшаяся сумма",
          whole_amount: "Вся сумма",
        },
        order: {
          additional_information: "Дополнительная информация для клиента",
          confirmed_at: "Дата отправки",
          customer_display_name: "Название клиета",
          manual: "Ручной заказ",
          marketplace: "Заказ Marketplace",
          product_additional_pickup_instructions: "Подсказки по отъезду",
          product_customer_hints: "Подсказки по путешествию",
          product_customer_requirements: "Условия",
          product_excluded_items: "В цену не входит",
          product_included_items: "В цену входит",
          product_price_currency: "Валюта предложения",
          saas: "Заказ SaaS",
          status_short: {
            waiting_for_company_approval: "В ожидании компании",
            waiting_for_customer_approval: "В ожидании клиента",
          },
          stock_useby_ends_at: "Конец срока действительности заказа",
          stock_useby_starts_at: "Начала срока действительности заказа",
          automatic: "Автоматический заказ",
          source: "Источник",
          pickup_point: "Место встречи",
          agent_disbursement_status: "Статус выплаты агента",
          uncleared: "Не очиещено",
          cleared: "Очищено",
          coupon_code_name: "Купонных код",
          author_place_cwa: "Новая страница",
          author_place_frontend: "Страница www",
          author_place_partner: "",
        },
        order_customer_participant: {
          display_name: "Участник № %{i}",
        },
        order_installment: {
          amount_hint: "Имеет значение, только если не было отмечемо поле «Оставшаяся сумма?»",
          confirmation_installment_hint: "Возможно только в случае первого взноса по методу оплаты «Онлайн-платеж».\n",
          paid_after_company_approval_hint:
            'Имеет значение, только если отмечено поле "Служит в качестве подтверждения заказа?"',
          paid_by_at_hint: "Имеет смысл только тогда, когда «Тип определения» равняется значению «Определенная дата»",
          paid_by_time_duration_hint:
            "Имеет смысл, за исключением «Тип определения» равняется значению «Определенная дата»",
          remaining_amount: "Оставшаяся сумма?",
          remaining_amount_hint: "Возможно только в случае последнего взноса.",
          account_description: "Название банковского счета",
        },
        order_item: {
          base_item: "Основная позиция?",
          item_type: "Тип позиции",
          marketplace_service_fee: "Плата за услуги Tripsomnia",
          name: "Название позиции",
          order_summary: "Всего",
          payment_profile_service_fee: "Плата за профиль платежа",
          product_coupon: "Купон",
          product_custom: "Нестандартный предмет",
          product_item: "Предмет предложения",
          product_option: "Дополнительный параметр",
          product_refund: "Возврат",
          quantity: "Количество позиций",
          saas_service_fee: "Плата за транзакцию Tripsomnia",
          service_fee: "Плата за услуги",
          unit_price: "Цена за штуку",
        },
        order_status_history: {
          abandon: "Отменить заказ",
          auto_refund_issued: "Автоматический возврат платежа клиенту",
          build: "Оформить заказ",
          company_approval_time_limit_exceeded: "Конец срока для подтверждения заказа со стороны компании",
          company_approve: "Компания подтвердила заказ",
          company_cancel: "Компания отменила заказ",
          company_reject: "Компания отклонила заказ",
          confirm: "Оформление заказа",
          confirmation_online_payment_time_limit_exceeded: "Конец срока для онлайн-платежей",
          customer_approval_time_limit_exceeded: "Конец срока для подтверждения заказа со стороны клиента",
          customer_approve: "Подтверждение заказа со стороны клиента",
          expire: "Заказ просрочен",
          finish: "Окончание заказа",
          finish_online_payment: "Оконание онлайн-платежа",
          manual_status_change: "Мануальное изменение статуса заказа",
          pause: "Конец срока для подтверждения",
        },
        order_transfer: {
          agent: "Агент",
          bank_wire: "Банковский перевод",
          cash: "Наличные",
          custom: "Собственный",
          customer: "Клиент",
          dotpay: "Система электронных платежей",
          online_payment: "Онлайн-платеж",
          receiver: "До",
          sender: "От",
          socialtravel: "Tripsomnia",
          source_payload: "Примечание об источнике",
          source_type: "Источник платежа",
          transfer_type: "Способ оплаты",
          transferred_at: "Дата платежа",
          refund_type: "Способ возврата",
          refunded_at: "Дата возврата",
          from_customer_frontend_name: "Оплачен с помощью %{transfer_type} %{transfer_date}",
          to_customer_frontend_name: "Возмещено %{transfer_type} дня %{transfer_date}",
          customer_to_supplier_backend_name: "Клиент заплатил Поставщику %{transfer_type} %{transfer_date}",
          customer_to_agent_backend_name: "Клиент заплатил Агенту %{transfer_type} %{transfer_date}",
          customer_to_socialtravel_backend_name: "Клиент заплатил Tripsomnia %{transfer_type} %{transfer_date}",
          company_to_customer_backend_name: "Поставщик возместил клиенту %{transfer_type} дня %{transfer_date}",
          company_to_agent_backend_name: "Поставщик возместил агенту %{transfer_type} дня %{transfer_date}",
          company_to_socialtravel_backend_name: "Поставщик заплатил Tripsomnia %{transfer_type} дня %{transfer_date}",
          agent_to_customer_backend_name: "Агент возместил Tripsomnia %{transfer_type} дня %{transfer_date}",
          agent_to_supplier_backend_name: "Агент заплатил поставщику %{transfer_type} дня %{transfer_date}",
          agent_to_socialtravel_backend_name: "Агент заплатил Tripsomnia %{transfer_type} дня %{transfer_date}",
          socialtravel_to_customer_backend_name: "Tripsomnia возместила клиенту %{transfer_type} дня %{transfer_date}",
          socialtravel_to_agent_backend_name: "Tripsomnia заплатила агенту %{transfer_type} дня %{transfer_date}",
          socialtravel_to_supplier_backend_name:
            "Tripsomnia заплатила поставщику %{transfer_type} дня %{transfer_date}",
          supplier_to_agent_backend_name: "",
          supplier_to_customer_backend_name: "Поставщик возвратил клиенту %{transfer_type} %{transfer_date}",
          supplier_to_socialtravel_backend_name: "Поставщик заплатил Tripsomnia %{transfer_type} %{transfer_date}",
        },
        payment_profile: {
          additional_fee: "Дополнительная плата",
          additional_fee_name: "Название дополнительной платы",
          additional_fee_percentage: "Дополнительная плата (в процентах)",
          companies: "Приделенные компании",
          companies_ids: "Приделенные компании",
          default_additional_fee_name: "Плата за выбранный профиль платежа",
          has_additional_fee: "Взимать дополнительную сервисную плату при оформлении заказом с этим профилем?",
          marketplace: "Профиль Marketplace",
          saas: "Профиль SaaS",
          additional_fee_as_agent_fee: "Добавить в качестве платы за услуги Агента",
        },
        payment_profile_installment: {
          amount: "Сумма взноса",
          amount_percentage: "Сумма взноса в процентах (% от основной суммы заказа)",
          increase_amount_by_marketplace_commision: "Увеличьте взнос на сумму комиссионных Tripsomnia",
          increase_amount_by_marketplace_service_fee: "Увеличьте взнос на сумму платы за услуги Tripsomnia",
          account_description: "Данные банковского счета",
        },
        payment_profile_product_attachment: {
          date_limit_type: "Вид ограничения по времени ",
          date_limit_type_label: "Ограничить по времени",
          days_before_arrival_date_limit: "От Х до Y дней до начала предложения",
          max_days_before_arrival: "Максимальное количество дней до начала предложения",
          min_days_before_arrival: "Минимальное количество дней до начала предложения",
          no_date_limit: "Без ограничений",
        },
        pricing: {
          absolute_amount: "В цифрах := ",
          absolute_amount_cents: "В цифрах := ",
          absolute_percentage: "В процентах :=",
          relative_amount: "В цифрах +/-",
          relative_amount_cents: "В цифрах +/-",
          relative_percentage: "В процентах +/-",
        },
        product: {
          categories: "Категории",
          product_company_tags: "Теги",
          active: "Активно",
          included_items_placeholder: "напр. Питание",
          excluded_items_placeholder: "напр. Страховка",
          customer_requirements_placeholder: "напр. минимальный возвраст 18 либо совершеннолетний опекун",
          customer_hints_placeholder: "напр. Не забудьте взять с собой теплую обувь.",
          highlights_placeholder: "напр. Привлекательная поездка для пары",
          categories_placeholder: "Добавить категорию",
          enable_frontend_slots_listing: "Включить список сроков вместо календаря",
          coupon_code_realisation_place_type: "Место реализации кода купона",
          coupon_code_realisation_place_custom_description: "Описание места реализации кода купона",
        },
        product_option: {
          all_product_variants: "Все варианты",
          required: "Значение должно быть выполнено клиентом",
        },
        product_integration: {
          auto_update_description: "auto update description",
          auto_update_images: "auto update photos",
          auto_update_prices: "auto update price",
          auto_update_calendar: "auto update calendar"
        },
        product_order_field: {
          "ProductOrderField::BigText": "Большое текстовое поле",
          "ProductOrderField::Boolean": "Поле выбора (Checkbox)",
          "ProductOrderField::Date": "Дата",
          "ProductOrderField::Email": "Адрес эл. почты",
          "ProductOrderField::Geopoint": "Географические положение",
          "ProductOrderField::List": "Список выбора",
          "ProductOrderField::Number": "Количество",
          "ProductOrderField::PhoneNumber": "Номер телефона",
          "ProductOrderField::Text": "Текстовое поле",
          assignation_per_person_label: "Выбор параметра для участника (по умолчанию: для заказа)",
          assignation_type: "Способ выполнения",
          customer_hint: "Подсказка для клиента",
          customer_hint_placeholder: "Подсказка, которая будет отображаться клиенту в форме",
          list_options: "Значения",
          max_value: "Максимальное значение",
          min_value: "Минимальное значение",
          multiply_price_by_nights_count: "Помножьте цену на длительность пребывания (количество суток)",
          order_value_required: "Требуемое значение",
          presets: {
            customer_email: {
              frontend_name: "Адрес эл. почты",
              name: "Адрес эл. почы заказчика",
            },
            customer_full_name: {
              frontend_name: "Имя и фамилия",
              name: "Имя и фамилия заказчика",
            },
            customer_note: {
              customer_hint:
                "Здесь Вы можете написать ваши специальные желания или просьбы. Их реализаци не гарантируется, но мы постараемся выполнить ваши ожидания.",
              frontend_name: "Сообщение для организатора",
              name: "Сообщение для организатора",
            },
            customer_phone_number: {
              customer_hint: "Контактный номер на случай вопросов по бронированию.",
              frontend_name: "Контактный телефон",
              name: "Номер телефона заказчика",
            },
            participant_birth_date: {
              frontend_name: "День рождения",
              name: "День рождения участника",
            },
            participant_email: {
              frontend_name: "Адрес эл. почты",
              name: "Адрес эл. почты участника",
            },
            participant_full_name: {
              frontend_name: "Имя и фамилия",
              name: "Имя и фамилия участника",
            },
            participant_phone_number: {
              frontend_name: "Контактный телефон",
              name: "Номер телефона участника",
            },
            customer_city: {
              frontend_name: "Город",
              name: "Город клиента",
            },
            customer_postal_code: {
              frontend_name: "Почтовый индекс",
              name: "Почтовый индекс клиента",
            },
            customer_country: {
              frontend_name: "Страна",
              name: "Страна клиента",
            },
            customer_hotel_name: {
              name: "Oтеля",
              customer_hint:
                "Подай, если ты владеешь такой информацией, название гостиницы и адрес, a также номер в ней.",
            },
            customer_dates_of_stay: {
              name: "Срок пребывания",
            },
          },
          price_included_in_order_base_amount: "Добавить цену параметра к цене основного заказа",
          price_none: "Отсутсвует",
          price_type: "Способ расчета цен",
          product_variants: "Варианты предложения",
          product_variants_assignation_all: "Все варианты",
          product_variants_assignation_some: "Некоторые варианты",
          product_variants_assignation_type: "Способ присвоения вариантам",
          product_variants_ids: "Варианты",
          show_on_manifest: "Показать на перечне",
          type: "Тип значения",
          "ProductOrderField::PickupPoint": "Место встречи",
          undefined_pickup_point_option_name: "Не указано",
          custom_pickup_point_option_name: "Трансфер из отеля",
          custom_pickup_point_display_name: "Адрес клиента: %{custom_location_name}",
          "ProductOrderField::Country": "Странца",
          custom_field: "Дополнительное поле",
        },
        product_pricelist_item: {
          preset_fixed: "Общий прайс-лист",
          preset_id: "Тип категории",
          preset_item: "Предмет",
          preset_person_adult: "Взрослый",
          preset_person_child: "Ребенок",
          preset_person_custom: "Собственная категория",
          preset_person_everyone: "Человек",
          preset_person_group_1_plus_2: "Семья 1+2",
          preset_person_group_1_plus_3: "Семья 1+3",
          preset_person_group_2_plus_1: "Семья 2+1",
          preset_person_group_2_plus_2: "Семья 2+2",
          preset_person_group_2_plus_3: "Семья 2+3",
          preset_person_group_custom: "Группа",
          preset_person_group_double: "2 человека",
          preset_person_group_family_of_3: "Семья из 3 человек",
          preset_person_group_family_of_4: "Семься из 4 человек",
          preset_person_group_family_of_5: "Семья из 5 человек",
          preset_person_group_quad: "4 человека",
          preset_person_group_single: "1 человек",
          preset_person_group_triple: "3 человека",
          preset_person_infant: "Младенец",
          preset_person_normal: "Обычный",
          preset_person_reduced: "Льготный",
          preset_person_senior: "Старший / Пенсионер",
          preset_person_student: "Студент",
          preset_person_teenager: "Несовершеннолетний",
          price_type: "Тип цены",
        },
        product_schedule_slot: {
          availability_type: "Тип доступности",
          available_with_company_approval: "Резервация при подтверждении со стороны компании",
          available_with_instant_booking: "Немедленное бронирование",
          date: "Срок",
          datetime: "Время и дата",
          total_stock_left: "Остальная доступность",
          total_stock_limit: "Лимит доступности",
          total_stock_used: "Недоступные места",
          active: "Доступно",
          available_with_instant_booking_help: "Все заказы подтверждаются автоматически",
          available_with_company_approval_help: "Принимаете все запросы и подтверждаете все заказы.",
          confirmed: "Подтверждено",
        },
        product_tag: {
          category: "Категория",
          location: "Локализация",
          parent: "Главный тег",
          product_st_tag: "Тег Tripsomnia",
          product_company_tag: "Тег компании",
          show_on_fe_listing: "Показать ярлык в списке предложений",
          show_on_fe_product_page: "Показать ярлык на подстранице предложения",
          fe_color: "Цвет фронтэнда",
        },
        product_variant: {
          additional_pickup_instructions: "Дополнительные подсказки по направлению",
          allow_custom_pickup_point: "Трансфер из отеля",
          allow_no_pickup_point: 'Позволить клиенту выбрать параметр "Местo всречи: Неизвестно"',
          custom_pickup_point_additional_fee: "Дополнительная оплата",
          default: "Вариант по умолчанию?",
          default_requires_company_approval: "По умолчанию требуется подтверждение со стороны компании",
          default_total_stock_limit: "Лимит доступности по умолчанию",
          nb_requires_company_approval: "Требует подтверждения со соторны компании",
          nb_stock_useby_days_limit: "Срок действительности заказа (количество дней)",
          nb_stock_useby_ends_at: "Конец срока действительности заказа",
          nb_stock_useby_starts_at: "Начала срока действительности заказа",
          nb_total_stock_left: "Оставшийся лимит продаж",
          nb_total_stock_limit: "Лимит продаж",
          nb_total_stock_used: "Занятый лимит продажи",
          pickup_points_assignation_type: "Способ распределения мест встречи в заказе",
          pricelist_by_item: "Цена за предмет",
          pricelist_by_order: "Общий прайс-лист",
          pricelist_by_person: "Цена за человека",
          pricelist_type: "Тип прайс-листа",
          additional_pickup_instructions_placeholder: "Добавить поксказку",
          coupon_discount_amount: "Размер скидки от купона",
          coupon_discount_percentage: "Процент скидки от купона",
          coupon_offer_price_before_discount: "Ценей перед скидкой от купона",
          coupon_offer_price: "Цена после скидки от купона",
        },
        view_collection_item: {
          related_model: "Прикрепленная запись",
        },
        view_section: {
          name: "Название",
          show_name: "Показывать название?",
          type: "Тип секции",
          types: {
            "ViewSection::CompanyProducts": "Компания - список предложений",
            "ViewSection::CustomCollection": "Собственная коллекция",
            "ViewSection::CustomContent": "Собственное содержание",
            "ViewSection::CustomCover": "Собственная обложка",
            "ViewSection::ProductTagChildren": "Теги предложеий - список подтегов",
            "ViewSection::ProductTagProducts": "Теги предложений - список предложений",
            "ViewSection::ProductTagsCategoryProducts": "Категория тегов предложений - список предложений",
            "ViewSection::ProductTagsCategoryTags": "Категория тегов предложений - список подтегов",
            "ViewSection::ViewedProducts": "Недавно просмотренные предложения",
            "ViewSection::SimilarToViewedProducts": "Предложения, похожие на недавно просмотренные ",
            "ViewSection::ViewedProductsTags": "Категории и места недавно просмотренных предложений",
          },
          view_collection_items_limit: "Лимит отображения записей",
          view_mode: "Режим отображения",
          view_modes: {
            cards_listing: "Список широких карт",
            cards_slider: "Слайдер продольных карт",
            extended_cards_listing: "Списокб широких расшширенных карт",
            items_carousel: "Карусель",
            products_map: "Карта",
            wide_cards_slider: "Слайдер широких карт",
            wide_cards_listing: "Листинг широких страниц",
          },
          with_similar_items: "Показать похожие предметы",
        },
        activity: {
          customer_email_sent_title: "Клиенту (%{recipient_email}) отправлено эл. письмо",
          customer_email_sent_content: "Тема: %{email_subject}",
          customer_sms_sent_title: "Клиенту (%{recipient_phone_number}) выслано SMS",
          customer_sms_sent_content: "Содержание: %{sms_content}",
          order_status_updated_content: 'Новый статус заказа: "%{new_status}"',
          review_created_title: "Клиент добавил отзыв о Вас с оценкой %{rating}/%{max_rating}",
          review_created_content: "Содержание отзыва: %{content}",
          customer_to_supplier_order_transfer_created_title: "Клиент заплатил Поставщику %{amount}",
          customer_to_agent_order_transfer_created_title: "Клиент заплатил Агенту %{amount}",
          customer_to_socialtravel_order_transfer_created_title: "Клиент заплатил Tripsomnii %{amount}",
          company_to_customer_order_transfer_created_title: "Поставщик вернул Клиенту %{amount}",
          company_to_agent_order_transfer_created_title: "Поставщик передал Агенту %{amount}",
          company_to_socialtravel_order_transfer_created_title: "Поставщик передал Tripsomnii %{amount}",
          agent_to_customer_order_transfer_created_title: "Агент передал Клиенту %{amount}",
          agent_to_supplier_order_transfer_created_title: "Агент передал Поставщику %{amount}",
          agent_to_socialtravel_order_transfer_created_title: "Агент передал Tripsomnii %{amount}",
          socialtravel_to_customer_order_transfer_created_title: "Tripsomnia вернула Клиенту %{amount}",
          socialtravel_to_agent_order_transfer_created_title: "Tripsomnia передала Агенту %{amount}",
          socialtravel_to_supplier_order_transfer_created_title: "Tripsomnia передала Поставщику %{amount}",
          supplier_email_sent_content: "Тема: %{email_subject}",
          supplier_email_sent_title: "Отправлено эл. письмо Поставщику (%{recipient_email})",
          supplier_sms_sent_content: "Содержание: %{sms_content}",
          supplier_sms_sent_title: "SMS отправлен Поставщику (%{recipient_phone_number})",
          customer_sms_send_failed_content: "Ошибка: %{error_message}",
          customer_sms_send_failed_title:
            "Произошла ошибка при отправке сообщения СМС клиенту: (%{recipient_phone_number})",
          supplier_sms_send_failed_content: "Ошибка: %{error_message}",
          supplier_sms_send_failed_title:
            "Произошла ошибка при отправлении SMSа к Поставщику (%{recipient_phone_number})",
          payment_issued_title: "Начато: операция оплаты клиента %{source} (%{amount})",
          payment_in_progress_title: "Выполняется: операция оплаты клиента %{source} (%{amount})",
          payment_completed_title: "Выполнено: операция оплаты клиента %{source} (%{amount})",
          payment_failed_title: "Не выполнено: операция оплаты клиента %{source} (%{amount})",
          refund_issued_title: "Начато: операция возмещения средств клиенту %{source} (%{amount})",
          refund_in_progress_title: "Выполняется: операция возмещения средств клиенту %{source} (%{amount})",
          refund_completed_title: "Выполнено: операция возмещения средств клиенту %{source} (%{amount})",
          refund_failed_title: "Не выполнено: операция возмещения средств клиенту %{source} (%{amount})",
          sms_send_failed_content: "Ошибка: %{error_message}",
          sms_send_failed_title: "При попытке выслать SMS (%{recipient_phone_number}) произошла ошибка ",
          sms_sent_content: "Содержание: %{sms_content}",
          sms_sent_title: "Отправлено SMS (%{recipient_phone_number})",
          supplier_to_agent_order_transfer_created_title: "Поставщик переместил агенту %{amount}",
          supplier_to_customer_order_transfer_created_title: "Поставщик вернул клиенту %{amount}",
          supplier_to_socialtravel_order_transfer_created_title: "Поставщик переместил Tripsomnia %{amount}",
        },
        product_pickup_point: {
          additional_instructions_placeholder: "Добавить подробное описание места встречи",
        },
        review: {
          single: "1 человек",
          couple: "Пара",
          friends: "Знакомые",
          family: "Семья",
          age_group: "Возрастная группа",
          group_type: "Вид группы",
          author_name: "Имя рецензента",
          author_email: "Адрес эл. почты",
          content: "Содержание",
          rating: "Общая оценка",
          st_feedback: "Отзыв о Tripsomnia",
          st_rating: "Оценка Tripsomnia",
          rating_1: "Очень плохо",
          rating_2: "Плохо",
          rating_3: "Прилично",
          rating_4: "Хорошо",
          rating_5: "Великолепно",
          st_rating_1: "Очень плохо",
          st_rating_2: "Плохо",
          st_rating_3: "Прилично",
          st_rating_4: "Хорошо",
          st_rating_5: "Замечательно",
          verified: "Отзыв проверен",
          "18-24": "18-24 лет",
          "25-30": "25-30 лет",
          "31-40": "31-40 лет",
          "41-60": "41-60 лет",
          "60+": "60+ лет",
          anonymous: "Гость",
        },
        coupon_code: {
          total_stock_left: "Осталось использований",
          total_stock_limit: "Количество использований",
          total_stock_used: "Уже использовано",
        },
        product_variant_additional_detail: {
          category: {
            one_person_room: "",
            two_person_room: "",
            three_person_room: "",
            four_person_room: "",
            multi_person_room: "",
            bed_in_multi_person_room: "",
            apartment: "",
            cottage: "",
            villa: "",
            holiday_house: "",
            tent: "",
          },
        },
        product_types: {
          voucher: "",
          accommodation: "",
          coupon: "",
          standard: "",
          ticket: "",
        },
        pricing_plan: {
          preset: {
            elastic: {
              name: "",
              company_description: "",
              customer_description: "",
            },
            not_refundable: {
              name: "",
              company_description: "",
              customer_description: "",
            },
          },
        },
        pricing_plan_types: {
          not_refundable: "",
          elastic: "",
        },
      },
      errors: {
        models: {
          order: {
            inactive_product: "Выбранное предложение уже не действительно.",
            missing_order_customer_participants_data: "Выполните даты участников",
            too_high_product_quantity:
              "Это число %{unit_name_other} больше недоступно. Выберите значение меньшее или равное %{available_stock}.",
            customer_display_name_missing:
              "Выполните хотя бы одно поле с информацией о заказчике (имя, фамилия, эл. почта либо номер телефона).",
            too_low_product_quantity: "Выбрано 0 пакетов. Выберите по крайней мере одного человека.",
            agent_has_disabled_saas: "У выбранного Агента отключена возможность создавать заказы SaaS.",
            supplier_has_disabled_saas: "У выбранного Поставщика отключена возможность создавать заказы SaaS.",
            supplier_has_disabled_marketplace:
              "У выбранного Поставщика отключена возможность создавать заказы Marketplace.",
            supplier_saas_subdomain_required:
              "Поставщик не приделил домены для своего сайта. Такой зазак невозможен. Пожалуйста, свяжитесь с администрацией Tripsomnia чтобы разрешить эту проблему.",
            agent_saas_subdomain_required:
              "Агент не приделил домены для своего сайта. Такой зазак невозможен. Пожалуйста, свяжитесь с администрацией Tripsomnia чтобы разрешить эту проблему.",
            confirmation_installment_impossible:
              "К сожалению, на данный момент за данный заказ нельзя заплатить онлайн. Если возможно, выберите другой способ оплаты либо свяжитесь напраямую с нами.",
            stock_useby_date_passed:
              "Время реализации данного предложения уже истекло. На данный момент нельз�� бронировать.",
            product_expired: "Выбранное предложение более недоступно.",
          },
          order_item: {
            wrong_price_currency: "Валюта цены на такие объекты должны находиться в пределах следующих значений:",
          },
          product: {
            must_be_empty_when_product_has_no_booking:
              'Значение %{value} недопустимо в случае предложений с типом заказа "Заказ отсутствует".',
            product_variant_with_percentage_amounts_defined:
              "По крайнер мере у одной цены в данном предложении значение «Сервисная плата», «Комиссия», «Дополнительная оплата на банковский счет»  выражено в процентах. Перед сменой валюты в прайс-листе на любую другую, кроме PLN, поменяйте значение с процентов на число.",
            product_pricelist_items_missing: "Выполните по крайней мере одну ценовую категорию.",
          },
          product_order_field: {
            pricing_disallowed_for_this_type: "Нельзя включить прайс-лист для этого типа параметра.",
          },
          product_tag: {
            parent_must_have_the_same_type: "Главный тег должен быть того же самого вида, что и подтег.",
            parent_cant_be_self: "Главный маркер маркера не может быть этим самим маркером.",
            parent_cant_be_its_child: "Главный маркер маркера не может быть в то же время его второстепенным маркером.",
          },
        },
      },
      models: {
        admin_user: {
          one: "Администратор",
          few: "Администратора",
          many: "Администраторов",
          other: "Администраторы",
        },
        attachment: {
          one: "Прикрепленный файл",
          few: "Прикрепленных файла",
          many: "Прикрепленных файлов",
          other: "Прикрепленные файлы",
        },
        company: {
          one: "Компания",
          few: "Компании",
          many: "Компаний",
          other: "Компании",
        },
        customer: {
          one: "Клиент",
          few: "Клиентаhttps://localise.biz/socialtravel/socialtravel-rails/translate#plural-1",
          many: "Клиентов",
          other: "Клиенты",
        },
        list_option: {
          one: "Параметр для выбора",
          few: "Параметра для выбора",
          many: "Параметров для выбора",
          other: "Параметры для выбора",
        },
        order: {
          one: "Заказ",
          few: "Заказа",
          many: "Заказов",
          other: "Заказы",
        },
        order_installment: {
          one: "Рассрочка платежа",
          few: "Рассрочки платежа",
          many: "Рассрочек платежа",
          other: "Рассрочки платежа",
        },
        order_item: {
          one: "Предмет заказа",
          few: "Предмета заказа",
          many: "Предметов заказа",
          other: "Предметы заказа",
        },
        order_transfer: {
          one: "Взнос / вывод денег",
          few: "Взноса / вывода денег",
          many: "Взносов / выводов денег",
          other: "Взносы / выводы денег",
        },
        payment_profile: {
          one: "Профиль платежа",
          few: "Профиля платежей",
          many: "Профилей платежей",
          other: "Профили платежей",
        },
        payment_profile_installment: {
          one: "Рассрочка платежа",
          few: "Рассрочки платежа",
          many: "Рассрочек платежа",
          other: "Рассрочки платежа",
        },
        payment_profile_product_attachment: {
          one: "Привязанный профиль платежа",
          few: "Привязанных профиля платежей",
          many: "Привязанных профилей платежей",
          other: "Привязанные профили платежей",
        },
        pricing: {
          one: "Собственная цена",
          few: "Собственные цены",
          many: "Собственных цен",
          other: "Собственные цены",
        },
        product: {
          one: "Предложение",
          few: "Предложения",
          many: "Предложений",
          other: "Предложения",
        },
        product_option: {
          one: "Дополнительный параметр",
          few: "Дополнительные параметры",
          many: "Дополнительных параметров",
          other: "Дополнительные параметры",
        },
        product_option_value: {
          one: "Значение",
          few: "Значения",
          many: "Значений",
          other: "Значения",
        },
        product_order_field: {
          one: "Дополнительный параметр / к выполнению",
          few: "Дополнительных параметра / к выполнению",
          many: "Дополнительных параметров / к выполнению",
          other: "Дополнительные параметры / к выполнению",
        },
        product_pricelist_item: {
          one: "Ценовая категория",
          few: "Ценовые категории",
          many: "Ценовых категорий",
          other: "Ценовые категории",
        },
        product_schedule: {
          one: "Правило сроков",
          few: "Правила сроков",
          many: "Правил сроков",
          other: "Правила сроков",
        },
        product_tag: {
          one: "Тег предложений",
          few: "Тега предложений",
          many: "Тегов предложений",
          other: "Тега предложений",
        },
        product_tags_category: {
          one: "Категория тегов предложний",
          few: "Категории тегов предложний",
          many: "Категорий тегов предложний",
          other: "Категории тегов предложний",
        },
        product_variant: {
          one: "Вариант предложений",
          few: "Варианта предложений",
          many: "Вариантов предложений",
          other: "Варианты предложений",
        },
        tag: {
          one: "Тег",
          few: "Тега",
          many: "Тегов",
          other: "Тега",
        },
        view_collection_item: {
          one: "Предмет колекции",
          few: "Предмета колекции",
          many: "Предметов колекции",
          other: "Предметы колекции",
        },
        view_page: {
          one: "Подсайт",
          few: "Подсайта",
          many: "Подсайтов",
          other: "Подсайта",
        },
        view_section: {
          one: "Секция вида",
          few: "Секции вида",
          many: "Секций вида",
          other: "Секции вида",
        },
        company_registration: {
          one: "Регистрация компании",
          few: "Регистрация компаний",
          many: "Регистрация компаний",
          other: "Регистрация компаний",
        },
      },
    },
    attributes: {
      abandoned: "Заброшено",
      accomodation: "Ночлег",
      action: "Действие",
      active: "Аквитно?",
      additional_fee: "Дополнительная плата",
      additional_instructions: "Дополнительные инструкции",
      address: "Адрес",
      admin_user: "Администратор",
      agent: "Агент",
      agent_commision: "Комиссионные агента",
      agent_commision_amount: "Комиссионные агента",
      agent_commision_amount_cents: "Комиссионные агента [в грошах]",
      agent_commision_percent: "Комиссионные агента [процент]",
      agent_note: "Приватное примечание агента",
      all_day_event: "Срок на весь день?",
      all_products: "Все предложения",
      all_tagged_products: "Все предложения (приписанные до данного тега либо его подтегов)",
      amount: "Сумма",
      amount_cents: "Сумма",
      amount_percentage: "Сумма в процентах",
      amount_type: "Метод расчета суммы",
      api_version: "Версия API",
      approved: "Подтверждено",
      arrival_time: "прибытие в",
      assignation_per_item: "за пакет заказа",
      assignation_per_order: "за заказ",
      assignation_per_person: "за участника",
      attachments: "Прикрепленный файл",
      balance: "Баланс клиента",
      balance_status: "Статус платы",
      balance_status_for_today: "Статус платы на сегодняшний день",
      bank_wire: "Банковский перевод",
      bank_wire_account_description: "Данные счета для банковского перевода",
      bank_wire_account_description_hint: "Редактировать может только главный администратор",
      birth_date: "День рождения",
      booking_type: "Тип заказа",
      boolean_value_type: "Checkbox (да/нет)",
      build: "Оформление заказа",
      building: "Проект",
      cancellation_policy: "Политика отмены",
      cancelled: "Аннулировано",
      cash: "Наличные",
      categories: "Категории",
      change_status: "Изменение статуса",
      companies_count: "Количество компаний",
      company: "Компания",
      company_approval_time_limit: "Временной лимит на подтверждение заказа со стороны компании",
      company_approval_time_limit_exceeded: "Превышение времени ожидания подтверждения со стороны компании",
      company_approval_time_limit_in_hours: "Лимит времени ожидания подтверждения со стороны компании [в часах]",
      company_approve: "Подтверждение заказа со стороны компании",
      company_automatic_invoice_amount: "Сумма автоматического расчета с компанией",
      company_automatic_invoice_date: "Дата автоматического расчета с компанией",
      company_cancel: "Отмена заказа со стороны компании",
      company_given_amount_through_online_deposit: "Сумма, переданная компании онлайн платежем",
      company_invoice_id: "ID инвойса компании",
      company_name: "Название компании",
      company_over_received_amount_through_online_deposit:
        "Общий баланс Tripsomnia по отношению к компаниям, принимая во внимание только онлайн платежи",
      company_received_amount_through_online_deposit: "Сумма, полученная от ком��ании онлайн платежем",
      company_reject: "Отклонение заказа со стороны компании",
      company_remaining_invoice_amount: "Оставшаяся сумма, которую нужно рассчитать  с компанией",
      company_tag: "Тег фирм",
      company_total_invoice_amount: "Полная сумма для расчета с компанией",
      confirm: "Отправка подтверждения",
      confirmation_installment: "Служит в качестве подтверждение заказа?",
      confirmation_installment_after_company_approval: "Онлайн предоплата только перед подтверждением заказа?",
      confirmation_installment_after_company_approval_hint:
        "В противном случае онлайн предоплата выполняется еще перед отправкой заказа (т.е. во время оформления заказа клиентом)",
      confirmation_installment_after_company_approval_time_limit:
        "Лимит времени онлайн предоплаты, после подтверждения заказа со стороны компании",
      confirmation_online_payment_time_limit_exceeded: "Превышение времени ожидания онлайн платежа",
      country: "Страна",
      coupon: "Купон / Скидка",
      coupon_price: "Цена ваучера",
      created_at: "Дата создания",
      currency: "Валюта",
      current_password: "Текущий пароль",
      current_sign_in_at: "Дата текущего входа",
      current_sign_in_ip: "IP текущего входа",
      customer: "Клиент",
      customer_approval_time_limit: "Лимит времени подтверждения заказа со стороны клиента",
      customer_approval_time_limit_exceeded: "Превышение времени подтверждения заказа со стороны клиента",
      customer_approval_time_limit_in_hours: "Лимит времени подтверждения заказа со стороны клиента [в часах]",
      customer_automatic_invoice_amount: "Сумма автоматического расчета с клиентом",
      customer_email: "Адрес эл. почты клиента",
      customer_full_name: "Имя и фамилия клиента",
      customer_full_name_contains: "Имя и фамилия клиента",
      customer_hints: "Подсказки по путешествию",
      customer_invoice_id: "ID инвойса клиента",
      customer_invoiced_amount: "Расчитанная сумма с клиентом",
      customer_locale: "Язык клиента",
      customer_note: "Сообщение для организатора",
      customer_phone_number: "Телефон клиента",
      customer_remaining_invoice_amount: "Оставшаяся сумма для расчета с клиентом",
      customer_requirements: "Условия",
      customer_rules_agreement: "Соглашение на условия с клиентом",
      customer_tag: "Тег клиентов",
      customer_total_invoice_amount: "Вся сумма для расчета с клиентом",
      customers_count: "Колличество клиентов",
      dates: "Даты",
      datetime: "Дата и время",
      days_count: "Количество дней",
      default_marketplace_commision_amount: "Комиссионные по умолчанию (Marketplace) [в числах]",
      default_marketplace_commision_percentage: "Комиссионные по умолчанию (Marketplace) [в процентах]",
      default_marketplace_service_fee_amount: "Плата за услуги по умолчанию (Marketplace) [в числах]",
      default_marketplace_service_fee_percentage: "Плата за услуги по умолчанию (Marketplace) [в процентах]",
      default_saas_commision_amount: "Плата за услуги по умолчанию (Saas) [в числах]",
      default_saas_commision_percentage: "Плата за услуги по умолчанию (SaaS) [в процентах]",
      departure_time: "выезд в ",
      deprecated_v1_bank_wire_company_deposit: "Банковский счет компании",
      deprecated_v1_bank_wire_socialtravel_deposit: "Банковский счет Tripsomnia",
      deprecated_v1_excludes_content: "В цену не входит (v1)",
      deprecated_v1_includes_content: "В цену входит (v1)",
      deprecated_v1_location_alternative_map_content: "Альтернативный код карты на страцине предложения (напр. iframe)",
      deprecated_v1_requirements_content: "Условия (v1)",
      description: "Описание",
      discount: "Скидка",
      discount_amount: "Скидка",
      discount_amount_cents: "Скидка [в грошах]",
      discounted: "Предложение переоценено?",
      draft: "Проект",
      email: "Адрес эл. почты",
      end_date: "Дата окончания",
      end_time: "Время окончания",
      ends_at: "Дата и время окончания",
      exact_amount: "В цифрах",
      exact_date: "Определенная дата",
      excluded_items: "В цену не входит",
      expire: "Истечение заказа",
      expired: "Истечекло",
      expired_at: "Дата истечения",
      expires_at: "Дата истечения",
      featured_price: "Представленная цена",
      featured_price_before_discount: "Представленная цена перед скидкой",
      file: "Файл",
      finish: "Завершение заказа",
      finish_online_payment: "Завершение онлайн платежа",
      finished: "Завершено",
      first_name: "Имя",
      fluid_date_booking: "Заказ блока с изменяемой длиной (v2)",
      frontend_name: "Название (Frontend)",
      frontend_view: "Вид (Frontend)",
      full_name: "Имя и фамилия",
      full_person_name: "Имя и фамилия",
      fully_paid: "Оплачено",
      global_role: "Global role (PA)",
      highlights: "Ключевые слова",
      id: "ID",
      inactive: "Неактивно",
      included_items: "В цену входит",
      includes_time: "Содержит время?",
      increase_orders_amount_by_saas_commision: "Добавьте комиссионные системы (SaaS) к полной сумме заказа",
      installments: "Рассрочка платежа",
      internal_note: "Заметка, доступная для всех",
      invoice_date: "Дата расчета",
      issuer: "Автор действия",
      last_sign_in_at: "Дата последнего входа",
      last_sign_in_ip: "IP текущего входа",
      last_status_action: "Последнее действие",
      locale: "Язык",
      location: "Локализация",
      location_coordinates: "Географические координаты",
      location_lat: "Широта",
      location_lng: "Долгота",
      location_name: "Название местности",
      locations: "Локализация",
      logo_image: "Лого",
      main_company: "Компания",
      main_image: "Главное фото",
      marketplace: "Marketplace",
      marketplace_commision: "Комиссионные Tripsomnia",
      marketplace_commision_amount: "Комиссионные Tripsomnia",
      marketplace_commision_amount_cents: "Комиссионные Tripsomnia [в грошах]",
      marketplace_commision_percent: "Комиссионные Tripsomnia [в процентах]",
      marketplace_featured_price: "Представленная цена (Marketplace)",
      marketplace_featured_price_before_discount: "Представленная цена перед скидкой (Marketplace)",
      marketplace_service_fee: "Плата за услуги Tripsomnia",
      marketplace_service_fee_amount: "Плата за услуги Tripsomnia",
      marketplace_service_fee_amount_cents: "Плата за услуги Tripsomnia [в грошах]",
      marketplace_service_fee_percent: "Плата за услуги Tripsomnia [проценты]",
      max_days_count: "Максимальное количество дней",
      max_nights_count: "Максимальное количество суток",
      max_number_value: "Максимальное численное значение",
      max_order_stock_count: "Максимальное общее количество пакетво в заказе",
      max_person_age: "Максимальный возраст",
      max_persons_count: "Максимальное количество людей",
      meta_description: "Описание страницы (SEO)",
      meta_title: "Название страницы (SEO)",
      min_days_count: "Минимальное количество дней",
      min_nights_count: "Минимальное количество суток",
      min_order_stock_count: "Минипальное общее количество пакетов в заказе",
      min_person_age: "Минимальный возраст",
      min_persons_count: "Минимальное количество людей",
      name: "Название",
      nb_stock_useby_date: "Срок действительности заказа",
      nb_stock_useby_days_limit: "Х дней после подтверждения заказа",
      nb_stock_useby_ends_at: "Конец срока действительности заказа",
      nb_stock_useby_starts_at: "Начала срока действительности заказа",
      new_status: "Новый статус",
      nights_count: "Количество суток",
      no_booking: "Нет заказов",
      note: "Примечание",
      number_value_multiplies_price: "Помножьте цену параметра на численное значение (выбранное клиентом)",
      number_value_type: "Число (0-n)",
      offers_count: "Количество предложений",
      on_stock_starts_at: "в день начала предложения",
      online_payment: "Онлайн платеж",
      order: "Заказ",
      order_bill: "Счет",
      order_customer_participants: "Участники",
      order_items: "Предмет заказа",
      order_tag: "Тег заказов",
      order_transfers: "Взнос / вывод денег",
      ordered_product_order_fields: "Дополнительные параметры / выполнено",
      ordered_product_pricelist_items: "Заказанные пакеты",
      orders: "Заказы",
      orders_count: "Количество заказов",
      orders_marketplace_commision_amount_sum: "Общая сумма комиссионных за заказы",
      orders_total_amount_sum: "Сумма заказов",
      overpaid: "Переплачено",
      paid_after_company_approval: "Оплата после подтверждения компанией?",
      paid_amount: "Вплачено",
      paid_amount_sum: "Вплачено",
      paid_before_company_approval: "Оплата перед подтверждением компанией?",
      paid_by_at: "Срок взноса",
      paid_by_at_formatted: {
        on_stock_starts_at: "в день начала предложения",
        x_days_after_order_company_approval: "%{count} после подтверждения заказа компанией",
        x_days_after_order_creation: "%{count} после оформления заказа",
        x_days_after_order_full_approval: "%{count} после полного подтверждения заказа",
        x_days_after_previous_installment:
          "%{count} после последнего взноса (либо подтверждения / отправки подтверждения, если это первый взнос)",
        x_days_before_stock_starts_at: "%{count} до начала предложения",
        immediately: "перед сохранением заказа",
      },
      paid_by_time_duration: "Период времени (x), указанный в сроке платежа",
      paid_by_type: "Способ определения срока взноса",
      parent: "Родитель",
      partly_paid: "Частично оплачено",
      password: "Пароль",
      password_confirmation: "Подтвердите пароль",
      pause: "Задержка заказа",
      payment: "Платеж",
      payment_completed: "Закончено",
      payment_failed: "Безуспешно",
      payment_in_progress: "В процессе",
      payment_operations: "Операции платежей",
      payment_profile: "Профиль плетежа",
      payment_status: "Статус платежа",
      payment_type: "Тип платежа",
      payment_type_offline: "Офлайн",
      payment_type_online: "Онлайн",
      payments: "Платежи",
      pdf_voucher: "Ваучер с подтверждением заказа (PDF)",
      pending: "Ожидает",
      per_group: "за группу",
      per_item: "за пакет",
      per_order: "за заказ",
      per_person: "за человека",
      per_product: "за предложение",
      percentage_amount: "В процентах",
      persons_count: "Количество человек",
      phone_number: "телефон",
      position: "Позиция",
      price: "Цена",
      price_currency: "Валюта цены",
      price_per_group: "цена за группу",
      price_per_item: "цена за пакет",
      price_per_night: "цена за сутки",
      price_per_order: "цена за заказ",
      price_per_person: "цена за человека",
      price_per_person_night: "цена за человека за сутки",
      price_per_product: "цена за предложение",
      price_type: "Тип цены",
      pricing_per_night: "Прайс ликст с ценой за сутки (v1)",
      pricing_per_person: "Прайс-лист с ценой за человека",
      pricing_per_person_night: "Прайс-лист с ценой за человека за сутки",
      pricing_per_product: "Прайс-лист с полной ценой за предложение (v1)",
      priority: "Приоритет",
      product: "Предложение",
      product_highlights: "Ключевые слова предложения",
      product_images: "Фотографии предложения",
      product_name: "Название предложения",
      product_option_values: "Значение для выбора",
      product_options: "Дополнительные параметры",
      product_or_variant: "Предложение / Вариа��т",
      product_order_fields: "Дополнительные параметры / нужно выполнить",
      product_pricelist: "Прайс-лист ",
      product_pricelist_item: "Ценовая категория",
      product_pricelist_order_target: "Прайс-лист",
      product_product_tags_id: "Тег предложения",
      product_quantity: "Количество пакетов",
      product_short_description: "Короткое описание предложения",
      product_st_tags: "Теги Tripsomnia",
      product_tag: "Тег",
      product_tags: "Теги",
      product_tags_category: "Категория тегов",
      product_tags_id: "Тег",
      product_tags_relation_type: "Тип отношений предложений",
      product_unit_name: {
        coupon: {
          one: "ваучер",
          few: "ваучера",
          many: "ваучеры",
          other: "ваучеры",
        },
        person: {
          one: "человек",
          few: "человека",
          many: "человек",
          other: "человека",
        },
        product: {
          one: "пакет",
          few: "пакета",
          many: "пакетов",
          other: "пакета",
        },
        room: {
          one: "комната",
          few: "комнаты",
          many: "комнат",
          other: "комнаты",
        },
      },
      product_variant: "Вариант предложения",
      product_variant_name: "Название варианта предложения",
      product_variant_order_target: "Вариант",
      product_variants_count: "Количество вариантов предложения",
      products_count: "Количество предложений",
      products_have_all_tags: "Сопряжение (предложение припысано ко всем тегам в этой категории)",
      products_have_one_tag: "Альтернатива (предложение приписано по крайней мере к одному из тегов этой категории)",
      published: "Опубликовано",
      published_at: "Дата публикации",
      refund: "Возврат заказа",
      refund_completed: "Завершено",
      refund_failed: "Безуспешно",
      refund_in_progress: "В процессе",
      refund_new: "Поручен",
      refund_none: "отсутствует",
      refund_status: "Статус возврат",
      refunded: "Возвращено",
      refunded_amount: "Возвращено",
      refunded_amount_sum: "Возвращено",
      rejected: "Отклонено",
      related_model: "Прикрепленная запись",
      remaining_amount: "Оставшаяся сумма",
      remaining_total_amount: "Осталось заплатить",
      remaining_total_amount_sum: "Do zapłaty",
      requires_company_approval: "Заказ требует подтверждения компании?",
      role: "Роль",
      saas: "SaaS",
      saas_featured_price: "Представленная цена (SaaS)",
      saas_featured_price_before_discount: "Представленная цена перед скидкой (Marketplace)",
      saas_service_fee: "Плата за транзакцию Tripsomnia",
      select_value_type: "Список выбора",
      service_fee: "Плата за услуги",
      short_description: "Короткое описание",
      show_page_title: "Поазывать название страницы?",
      sign_in_count: "Количество входов",
      slug: "Короткая ссылка",
      slug_hint: "Если оставите поле пустым, оно будет сгенерировано автоматически",
      special_offer: "Специальное предложение",
      st_note: "Заметка только для сотрудников Tripsomnia",
      start_date: "Дата начала",
      start_dates: "Дата начала",
      start_time: "Время начала",
      start_times: "Время начала",
      starts_at: "Дата и время начала",
      static_date_booking: "Заказ блока с определенной длиной (v2)",
      status: "Статус",
      stock_end_date: "Конец срока",
      stock_end_datetime: "Время выезда",
      stock_ends_at: "Время выезда",
      stock_start_date: "Начало срока",
      stock_start_datetime: "Время приезда",
      stock_starts_at: "Время приезда",
      stock_time_range: "Срок",
      stock_useby_time_range: "Срок реализации",
      supplier: "Поставщик",
      supplier_note: "Приватное примечание поставщика",
      tag: "Тег",
      tagged_products: "Предложения (приписанные до данного тега)",
      tags: "Теги",
      time_duration: "Продолжительность",
      time_zone: "Часовой пояс",
      time_zone_name: "Часовой пояс",
      title: "Название",
      total_amount: "Сумма заказа",
      total_amount_sum: "Сумма заказа",
      total_base_amount: "Основная сумма за заказ",
      total_discount: "Полная скидка",
      total_discount_amount: "Полная скидка",
      total_price: "Полная цена",
      total_product_options_price: "Общая сумма за дополнительные параметры",
      total_product_price: "Полная цена за предложение",
      total_product_price_before_discount: "Полная цена за предложение перед скидкой",
      total_stock_left: "Оставшийся лимит продажи",
      total_stock_limit: "Лимит продажи",
      total_stock_used: "Использованный лимит продажи",
      transfer_type: "Способ оплаты",
      translations: "Переводы",
      translations_name: "Название",
      trip: "Экскурсия",
      type: "Тип",
      type_amount: "В числах",
      type_percent: "В процентах",
      unpaid: "Неоплачено",
      updated_at: "Дата последнего изменения",
      v1_bank_wire_deposit: "Дополнительная оплата на банковский счет\n",
      v1_bank_wire_deposit_amount: "Дополнительная оплата на банковский счет\n",
      v1_bank_wire_deposit_amount_cents: "Дополнительная оплата на банковский счет [в грошах]\n",
      v1_bank_wire_deposit_deadline: "Срок дополнительной оплаты на банковский счет",
      v1_bank_wire_deposit_max_payment_date: "Определенная дата",
      v1_bank_wire_deposit_percent: "Дополнительная оплата на банковский счет [в процентах]\n ",
      v1_bank_wire_deposit_postorder_days_limit: "Х дней после подтверждения заказа",
      v1_bank_wire_deposit_postorder_x_days: "%{value} дней после подтверждения заказа",
      v1_bank_wire_deposit_prearrival_days_limit: "Х дней до начала предложения",
      v1_bank_wire_deposit_prearrival_x_days: "%{value} дней перед началом предложения",
      v1_cash_deposit: "Дополнительная плата на месте (в иностранной валюте)",
      v1_cash_deposit_amount: "Дополнительная плата на месте (в иностранной валюте)",
      v1_cash_deposit_amount_cents: "Дополнительная плата на месте (в иностранной валюте) [в центах]",
      v1_full_bank_wire_deposit: "Платеж за предложение в 100% через банковский перевод",
      v1_full_bank_wire_deposit_hint:
        "Отметьте, если вместо оплаты на месте предложение должно быть оплачено на банковский счет (в размере 100% от общей цены предложения).",
      v1_online_deposit: "Онлайн предоплата",
      v1_online_deposit_percent: "Онлайн предоплата [проценты]",
      v1_online_deposit_st_type: {
        deposit: {
          b: "аванс",
          d: "авансы",
          m: "аванс",
        },
        fee: {
          b: "платеж",
          d: "платежа",
          m: "платеж",
        },
        prepayment: {
          b: "предоплату",
          d: "предоплаты",
          m: "предоплата",
        },
      },
      v1_rest_deposit: "Оставшаяся сумма, которую нужно заплатить на месте",
      v1_rest_deposit_amount: "Оставшаяся сумма, которую нужно заплатить на месте",
      v1_rest_deposit_amount_cents: "Оставшаяся сумма, которую нужно заплатить на месте [в грошах/центах]",
      v1_st_company_debt_status: "Статус расчета с компанией",
      v1_st_company_debt_status_amount_to_give: "Передать взнос компании",
      v1_st_company_debt_status_amount_to_receive: "Побрать комиссионные од компнии",
      v1_st_company_debt_status_short: "Статус расчета",
      v1_st_company_debt_status_zero_amount: "Рассчитан",
      v1_st_company_invoiced_amount: "Сумма, рассчитанная с Компанией",
      v1_st_company_manually_given_amount: "Сумма дополнительно, переданная компании",
      v1_st_company_manually_received_amount: "Сумма, дополнительно полученная от компании",
      v1_st_remaining_given_amount: "Оставшаяся сумма, которую нужно передать компании",
      v1_st_remaining_received_amount: "Оставшаяся сумма, которую побрать од компании",
      v1_st_total_given_amount: "Общая сумма, переданная компании",
      v1_st_total_over_received_amount: "Общий баланс Tripsomnia по отношению к компании",
      v1_st_total_received_amount: "Общая сумма, полученная от компании",
      v2_pricing: "Прайс-лист по ценовым категориям (v2)",
      v2_static_date_booking: "Заказ блока с определенной длиной (v2)",
      value_type: "Тип значения",
      variant: "Вариант",
      video_url: "Видео URL (YouTube / Vimeo)",
      video_url_hint: "Если выполнено, вместо изображения появится фильм (только в режиме просмотроа «Карусель»)",
      view: "Вид",
      view_sections: "Секция вида",
      waiting_for_company_approval: "Ожидает подтверждения от компании",
      waiting_for_confirmation_online_payment: "Ожидает платежа от клиента",
      waiting_for_customer_approval: "Ожидает подтверждения от клиента",
      website: "Веб-страница",
      website_url: "Веб-страница",
      week_days: "Дни недели",
      x_days_after_order_company_approval: "х дней после подтверждения компанией",
      x_days_after_order_creation: "x днех после оформления заказа",
      x_days_after_order_full_approval: "x днех после полного подтверждения заказа",
      x_days_after_previous_installment:
        "x дней после после первого взноса (или подтверждения / высылки подтверждения в случае первого взноса)",
      x_days_before_stock_starts_at: "x дней до начала предложения",
      x_price_per_item: "%{x} за пакет",
      x_price_per_item_night: "%{x} за пакет за ночь",
      x_price_per_order: "%{x}",
      x_price_per_order_night: "%{x} за сутки",
      x_price_per_person: "%{x} с человека",
      x_price_per_person_night: "%{x} с человека за сутки",
      agent_service_fee: "Плата за услуги агента",
      agent_service_fee_amount: "Плата за услуги агента",
      agent_service_fee_amount_cents: "Плата за услуги агента [в грошах]",
      agent_service_fee_percent: "Плата за услуги агента [проценты]",
      agent_paid_amount: "Агент передал",
      agent_received_amount: "Агент получил",
      agent_remaining_paid_amount: "Побрать от агента",
      agent_remaining_received_amount: "Передать агенту",
      customer_paid_amount: "Клиент заплатил",
      customer_received_amount: "Клиенту вернули",
      customer_remaining_paid_amount: "Клиенту осталось заплатить",
      customer_remaining_received_amount: "Клиенту осталось вернуть",
      socialtravel_paid_amount: "Tripsomnia передало",
      socialtravel_received_amount: "Tripsomnia взяло",
      socialtravel_remaining_paid_amount: "Осталось побрать от Tripsomnia",
      socialtravel_remaining_received_amount: "Осталось передать Tripsomnia",
      supplier_paid_amount: "Поставщик передал",
      supplier_received_amount: "Поставщик получил",
      supplier_remaining_paid_amount: "Оплачивается поставщиком\n",
      supplier_remaining_received_amount: "Осталось передать поставщику",
      author_place: "Источник",
      author_place_frontend: "Веб-страница",
      author_place_partnerapp: "Панель партнера",
      product_locations: "Локализация предложения",
      product_pickup_points: "Места встреч",
      customer_fields: "Поле для заполнения",
      priced_fields: "Дополнительные параметры",
      product_id: "ID предложения",
      product_variant_id: "ID варианта предложения",
      pricelist: "Прайс-лист",
      payment_profiles: "Прифили платежей ",
      remove_location_coordinates: "Очистить географические координаты",
      test_mode: "Тестовый режим",
      saas_priority: "Приоритет (SaaS)",
      marketplace_priority: "Приоритет (Marketplace)",
      created_on: "Дата создания",
      updated_on: "Дата последнего изменения",
      affiliate_commision: "Комиссионные аффилиата",
      affiliate_commision_amount: "Комиссионные аффилиата",
      affiliate: "Филиал",
      confirmation_installment_amount: "Онлайн предоплата ",
      bank_wire_account_description_placeholder: "Номер банковского счета и дополнительная информация.",
      fully_refunded: "Возмещено",
      over_refunded: "Черезчур возмещено",
      partly_refunded: "Частично возмещено",
      dotpay: "DotPay",
      paypal: "PayPal",
      agent_outcome: "Доходы агента",
      socialtravel_outcome: "Доход Tripsomnia ",
      supplier_outcome: "Доход поставщика",
      total_company_outcome: "Доход компании",
      agent_disbursement: "Выплата агента",
      agent_disbursement_id: "ID выплаты агента",
      customer_invoice_amount: "Сумма для автоматического расчета с клиентом.",
      doesnt_require_company_approval: "Заказ не требует подтверждения компании",
      custom_online_payment: "Пользовательский онлайн платеж",
      agent_bank_wire: "Банковский перевод агента",
      supplier_bank_wire: "Банковксий перевод поставщика",
      agent_cash: "Наличными от/для агента",
      supplier_cash: "Наличнымы от/для поставщика",
      none: "Ничего",
      expire_at: "Срок истечения",
      publish_at: "Дата публикации",
      expire_from: "",
      stripe: "Stripe",
      author_place_customerapp: "Новая страница",
      deprecated_v1_booking_type: "Тип заказа (v1)",
      deprecated_v1_location_address: "Адрес",
      deprecated_v1_location_description: "Подсказки по приезду",
      deprecated_v1_location_full_address: "Полный адрес",
      deprecated_v1_location_full_address_hint_html:
        '<div class="u-inline-block">\n  <strong>Format:</strong><br />\n  Название помещения<br />\n  Улица, № дома и квартирыbr />\n  Почтовый код, город<br />\n  Провинция / воеводство\n</div> <div class="u-inline-block">\n  <strong>Например:</strong><br />\n  Hotel pod Stuletnim Drzewem<br />\n  ul. Kowalskich 24/3<br />\n  64-000 Kościan<br />\n  Wielkopolska<br />\n</div>\n',
      deprecated_v1_location_full_address_placeholder:
        'Отель "Дырявый Котел"\nул. Кривая 14\n12-345 Лондон\nВеликобритания',
      deprecated_v1_order_target_type: "Цель заказа (v1)",
      deprecated_v1_pricing_type: "Тип прайс-листа (v1)",
      deprecated_v1_product_type: "Тип предложения (v1)",
      price_show_cash_deposit_amount: "Сумма, которую нужно заплатить на месте в иностранной валюте",
      price_show_coupon_price: "Цена ваучера",
      price_show_discount_amount: "Специальная скидка",
      price_show_discount_percent: "Специальная скидка [в процентах]",
      price_show_marketplace_service_fee_amount: "Плата за услуги",
      price_show_online_deposit_amount: "Онлайн предоплата",
      price_show_price_per_person: "Цена за человека (цена за предложение / количество людей)",
      price_show_total_amount: "Сумма заказа (цена за предложение + плата за услуги)",
      price_show_total_amount_with_cash_deposit:
        "Вся суммая за закак (вместе с суммой, которую нужно заплатить на месте в иностарнной валюте)",
      price_show_total_price: "Цена за предложение",
      price_show_type: "Способ представления цен",
      message: "",
      requested_date: "",
      seller: "",
      discount_percent: "Скидка [процент]",
      total_discount_amount_cents: "Общая скидка [в копейках]",
      total_price_cents: "",
      total_product_options_price_cents: "",
      total_product_price_before_discount_cents: "Полная цена за предложение до скидки [в грошах/центах]",
      total_product_price_cents: "Полная цена предложения [в грошах/центах]",
      confirmation_installment_amount_cents: "Предоплата онлайн [в грошах]",
      confirmation_installment_paid_amount: "Заплачено онлайн",
      receptionist: "Резервирующий",
      available_to: "Доступная к",
      available_from: "Доступная од",
      product_type: "",
      pricing_plan_type: "",
    },
    errors: {
      messages: {
        already_exists: "такое значение не существует.",
        has_to_be_in_future: "должна быть дата в будущем.",
        installment_not_supported: "Такая комбинация рассрочек на данный момент не поддерживается системой Tripsomnia.",
        invalid_installments_position: "Недопустимое чередование рассрочки платежей.",
        invalid_online_payment_installments:
          "Недопустимая комбинация платежей в рассрочке. На данный момент возможный взнос типа «Онлайн платеж» должен быть первым и единственным платежом данного типа.",
        invalid_participant_data: 'Неправильные данные об участнике "%{participant_name}".',
        invalid_participant_product_option_value:
          'Недопустимое значение в поле "%{product_option_name}" для участника "%{participant_name}".',
        invalid_phone_number_characters: "содержит недопустимые знаки (должны быть только цифры)",
        invalid_product_option_value: 'Недопустимое значение для дополнительного параметра "%{product_option_name}".',
        invalid_video_url: "недопустимый формат. Вы уверены, что это правильная ссылка на видео YouTube/Vimeo?",
        missing_participant_product_option_value:
          'Выберите значеие в поле "%{product_option_name}" для участника "%{participant_name}".',
        missing_product_option_value: 'Выберите значение требуемого дополнителного параметра "%{product_option_name}".',
        v1_invalid: "недопустимое значение для моделей версии v1. ",
        v1_invalid_installments_transfer_type:
          "Недопустимая комбинация платежей в рассрочке. В случае заказа v1 порядок должен быть следующий: «Онлайн платеж» -> «Банковский счет» -> «Наличные», с возможностью пропустить некоторые взносы.",
        invalid_participant_ordered_item: 'Неправильный предмет договора назначенный участнику "%{participant_name}".',
        invalid_ordered_item_participants_count:
          'Неправильное количество участников для предмета заказа "%{ordered_item_name}".',
        empty: "Обязательное поле",
        greater_than: "Пожалуйста, введите сумму больше 0.",
        too_short: "Текст слишком короткий.",
        greater_than_or_equal_to: "Значение должно быть меньше или равно %{count}.",
        less_than_or_equal_to: "Значение должно быть меньше или равно %{count}.",
        invalid: "",
      },
      action_impossible_error: {
        code: "",
        http_code: "",
        message: "",
      },
      record_not_found_error: {
        code: "",
        http_code: "",
        message: "",
      },
      wrong_product_order_field_error: {
        code: "",
        http_code: "",
        message: "",
      },
    },
    base: {
      choose: "Выбрать",
      connection_error: "Ошибка подключения к серверу",
      date: {
        day: "День",
        month: "Месяц",
        year: "Год",
      },
      discount: "Скидка",
      discount_coupon: "Скидочный купон",
      every_each: "что, каждый",
      extend: "Развернуть",
      from: "oт",
      from_x: "от %{count}",
      from_x_to_y: "от %{x} до %{y}",
      in_weekdays_xyz: "в %{xyz}",
      loading: "Загрузка",
      no: "Нет",
      read_more: "Читать дальше",
      see_more: "Показать больше",
      to: "до",
      to_x: "до %{count}",
      x_days: {
        one: "%{count} день",
        few: "%{count} дня",
        many: "%{count} дней",
        other: "%{count} дня",
      },
      x_hours: {
        one: "%{count} час",
        few: "%{count} часа",
        many: "%{count} часов",
        other: "%{count} часа",
      },
      x_minutes: {
        one: "%{count} минута",
        few: "%{count} минуты",
        many: "%{count} минут",
        other: "%{count} минуты",
      },
      x_nights: {
        one: "%{count} ночь",
        few: "%{count} ночи",
        many: "%{count} ночей",
        other: "%{count} ночи",
      },
      x_orders: {
        one: "%{count} заказ",
        few: "%{count} заказа",
        many: "%{count} заказов",
        other: "%{count} заказа",
      },
      x_persons: {
        one: "%{count} человек",
        few: "%{count} человека",
        many: "%{count} человек",
        other: "%{count} человека",
      },
      x_seconds: {
        one: "%{count} секунда",
        few: "%{count} секунды",
        many: "%{count} секунд",
        other: "%{count} секунды",
      },
      yes: "Да",
      x_years: {
        one: "%{count} год",
        few: "%{count} года",
        many: "%{count} лет",
        other: "%{count} года",
      },
      choose_date: "Выберите дату",
      x_selected_records: {
        one: "Выбран %{count} ",
        few: "Выбрано %{count}",
        many: "Выбрано %{count}",
        other: "%{count} выбрано",
      },
      since_x: "от %{x}",
      since_x_until_y: "от %{x} до %{y}",
      until_x: "до %{x}",
      for_x_days: {
        one: "%{count} день",
        few: "%{count} дня",
        many: "%{count} дней",
        other: "в течение %{count} дней",
      },
    },
    components: {
      view_sections: {
        title: {
          read_more: "Показать больше предложений",
        },
      },
    },
    date: {
      formats: {
        default: "%d-%m-%Y",
        long: "%A, %e %B %Y",
        short: "%d %b",
        short2: "%e %B %Y",
      },
    },
    helpers: {
      select: {
        no_results_message: "Нет результатов",
        prompt: "Выберите",
      },
    },
    languages: {
      en: "английский",
      pl: "польский",
      ru: "русский",
      bg: "болгарский",
      hr: "хорватский",
      cs: "чешский",
      da: "датский",
      nl: "голландский",
      et: "эстонский",
      fi: "финский",
      fr: "французский",
      de: "немецкий",
      el: "греческий",
      hu: "венгерский",
      is: "исландский",
      ga: "ирландский",
      it: "итальянский",
      lv: "латышский",
      lt: "литовский",
      lb: "люксембургский",
      mk: "македонский",
      mt: "мальтийский",
      pt: "португальский",
      ro: "румынский",
      sr: "сербский",
      sk: "словацкий",
      sl: "словенский",
      es: "испанский",
      sv: "шведский",
      tr: "турецкий",
      uk: "украинский",
      cy: "валлийский",
      ar: "арабский",
      ca: "каталонский",
      he: "иврит",
      th: "тайский",
      vi: "вьетнамский",
    },
    number: {
      currency: {
        format: {
          format: "%n %u",
        },
      },
    },
    order_actions: {
      send_approved_order_has_paid_online_deposit_company_sms: {
        sms_content: {
          marketplace:
            "Заказ № %{order_id} подтвержден и оплачен клиентом. Подробности заказа отправлены по эл. почте.",
          saas: "Заказ № %{order_id} подтвержден и оплачен клиентом. Подробности заказа отправлены по эл. почте.",
        },
      },
      send_order_awaits_approval_company_sms: {
        sms_content: {
          marketplace: "Заказ № %{order_id} требует срочного подтверждения. Подробности отправлены по эл. почте.",
          saas: "Заказ № %{order_id} требует срочного подтверждения. Подробности отправлены по эл. почте.",
        },
      },
      send_order_has_been_approved_customer_sms: {
        sms_content: {
          after_company_approval: {
            marketplace:
              "Заказ № %{order_id} подтвержден. Просим осуществить платеж. Подробности отправлены по эл. почте.",
            saas: "Заказ № %{order_id} подтвержден. Просим осуществить платеж. Подробности отправлены по эл. почте.",
          },
          default: {
            marketplace: "Заказ № %{order_id} подтвержден. Подробности отправлены по эл. почте.",
            saas: "Заказ № %{order_id} подтвержден. Подробности отправлены по эл. почте.",
          },
        },
      },
      send_order_has_been_rejected_customer_sms: {
        sms_content: {
          marketplace: "Заказ № %{order_id} отклонено партнером. Подробности отправлены в эл. листе.",
          saas: "Заказ № %{order_id} отклонен. Подробности отправлены по эл. почте.",
        },
      },
      send_order_has_been_cancelled_customer_sms: {
        sms_content: {
          marketplace: "Заказ № %{order_id} аннулирован партнером. Подробности отправлены на эл. почте.",
          saas: "Заказ № %{order_id} аннулирован партнером. Подробности отправлены на эл. почте.",
        },
      },
    },
    product_pricelist: {
      lowest_price_is_on: "Самая ниская цена действительна для %{schedule_range}.",
      price_name: "%{price} для %{people}",
      price_per_coupon: "цена за ваучер",
      price_per_item: "цена за пакетный тур/ группу",
      price_per_night: "цена за ночь",
      price_per_product: "цена за предложение",
      price_per_stay: "цена за пребывание",
      price_per_tour: "цена за путевку",
      sold_out_already: "Ваучеры на  это предложение уже распроданы.",
      x_coupons_left: {
        one: "Остался один ваучер.",
        few: "Осталось %{count} ваучера.",
        many: "Осталось %{count} ваучеров.",
        other: "Осталось %{count} ваучера.",
      },
      x_stocks_left: "Только %{count} в этой цене.",
    },
    "social_travel/new_company_registration_form": {
      errors: {
        company_already_exists: "Компания с таким электронным адресом уже зарегистрирована на нашем сайте.",
      },
    },
    time: {
      formats: {
        long: "%A, %e %B %Y в %H:%M",
        short: "%e %b o %H:%M",
        time: "%H:%M",
        short2: "%e %B %Y",
      },
    },
    view_collection_item_decorator: {
      offer_read_more: "Узнать больше",
      offers_read_more: "Показать предложения",
    },
    frontend: {
      companies: {
        show: {
          reviews_title: "Отзывы о %{marketplace_name}",
          products_calendar: "Календарь сроков",
          products: "Предложения",
          reviews: "Мнения",
          reviews_title_html: "Мнения о %{marketplace_name}",
        },
      },
      company_orders: {
        approve: {
          action_impossible: "Недопустимая операция. Возможно, заказ уже подтвержден или отклонен?",
          success: 'Заказ № #%{id} на "%{product_name}" (клиент: %{customer_full_name}) подтвержден.',
        },
        finish: {
          action_impossible: "Недопустимая операция. Возможно, заказ уже закончен?",
          success: 'Заказ № #%{id} на "%{product_name}" (клиент: %{customer_full_name}) закончен.',
        },
        reject: {
          action_impossible: "Недопустимая операция. Возможно, заказ уже подтвержден или отклонен?",
          success: 'Заказ № #%{id} на "%{product_name}" (клиент: %{customer_full_name}) был отклонен.',
          success_with_slot_deactivated:
            'Заказ № #%{id} на "%{product_name}" (клиент: %{customer_full_name}) был отклонен. Кроме того, выбранная дата бронирования была деактивироана - последующие заказы на данный срок не будут приняты.',
        },
        show: {
          admin_app_info_html:
            'Рекомендуем войти в нашу <a href="%{partnerapp_order_url}">панель управления доступностью</a>. Пользуясь ею, Вы можете управлять предложениями и заказами клиентов.',
          approve_order: "Подтвердите заказ",
          finish_order: "Обозначь как Законченное",
          order_name: 'Заказ № %{order_id} на"%{product_name}"',
          order_status: "Статус заказа: %{status_i18n}",
          reject_order: "Отклонить заказ",
        },
      },
      errors: {
        show: {
          general_error: "Попробуйте еще раз обновить страницу.",
          general_error_hint_html:
            "Если ошибка повторяется, попробуйте еще раз через несколько минут или сообщите нам о данной ошибке по эл. почте %{email}.",
          header: "Произошла ошибка %{error_code}",
          page_not_found: "Выбранная страница не наидена.",
          page_not_found_hint_html:
            'Вернитесь на <a href="%{root_url}">главную страницу</a> веб-сайта или используйте поиск, чтобы найти интересующее Вас предложение.',
          title: "Ошибка %{error_code}",
        },
      },
      orders: {
        confirm: {
          already_abandoned_error:
            "Данный заказ уже отменен. Чтобы разместить новый заказ, вернитесь к первому шагу бланка заказа. ",
          already_confirmed_error: "Данный заказ уже в исполнении. Обновите страницу, чтобы разместить новый заказ.",
        },
        new: {
          title: "Забронировать: %{product_name}",
        },
        show: {
          title: "Заказ № %{id}",
        },
        update: {
          already_abandoned_error: "Данный заказ уже отменен. Чтобы разместить новый заказ, вернитесь к началу бланка.",
          already_confirmed_error: "Данный заказ уже в исполнении. Обновите страницу, чтобы разместить новый заказ.",
        },
      },
      products: {
        show: {
          draft_notice:
            "Вы просматриваете сейчас предложение, которое еще не опубликовано. Для остальных пользователей веб-сайта данная страница будет недоступная (404).",
          instead_of: "вместо",
          location_address: "Адрес",
          location_tips: "Как добраться",
          make_an_order: "Забронировать",
          pay_on_the_spot: "Заплатить на месте",
          product_shown_in_different_locale_notice:
            "К сожалению, у этого предложения нет еще описания на выбранном Вами языке.",
          product_unavailable: "Отсутсвуют сроки",
          see_map: "Показать на карте",
          select_product_variant: "Выбрать ",
          similar_locations_title: "Показать больше предложений в этой локализации",
          similar_products_title: "Вас также могут заинтересовать",
          youre_saving: "Экономите",
          pickup_points: "Местро встречи",
          custom_pickup_point_possible: "Трансфер из отеля",
          reviews_title: "Отзывы о %{company_name}",
          recently_viewed_products_title: "Недавно просматриваемые предложения",
          recently_viewed_products_and_categories_title: "Недавно просматриваемые предложения и категории",
          other_locations: "Другие адреса",
          buy_product_cta_button: "Купить",
          buy_coupon_cta_button: "Скачать ваучер",
          see_product_availability_cta_button: "Показать доступность",
          choose_coupon: "Выбрать опцию",
          offer_finished_cta_button: "Предложение окончено",
          coupon_finished: "Уценка закончена",
          product_finished: "Предложение окончено",
          product_expires_at: "Предложение истекает %{datetime}",
          product_expired_notice:
            "Предложение, которое вы просматриваете, истекло. На данный момент бронирование невозможно.",
          product_expired: "Предложение истекло",
          only_x_coupons_left: "Скачано %{total_stock_used} купонов.",
          nb_stock_useby_date_range: "Можно использовать %{date_range}",
          no_coupons_left: "Распродано. Лимит продаж достигнут.",
          less_than_x_coupons_left: "Доступно менее %{total_stock_left} купонов.",
          quicknav: {
            description: "Описание",
            includes: "Цена включает",
            requirements: "Запросы / Требования",
            map: "Карта",
            reviews: "Рецензия",
          },
          reviews_title_html: 'Мнения о <a href="%{company_url}">%{company_name}</a>',
          not_available_notice: "",
        },
        search: {
          filter_query_title: "Искать по тексту",
          toggle_filters: "Фильтровать результат",
          filter_query_placeholder: "Введите фразы для поиска",
          location_query_title: "Поблизсоти",
          location_query_label: "Искать предложения на расстоянии",
          location_query_placeholder: "Впишите место",
          date_query_title: "Срок",
          categories_query_title: "Категории",
          locations_query_title: "Регионы",
          locales_query_title: "Язык",
          no_results_message:
            "К сожалению, предложений по поданному месту поиска не найдено. Попробуйте иначе указать место.",
          shown_results: "Показывается %{start} - %{end}  из %{total_count}",
          previous_page: "Предвдущая страница",
          next_page: "Следующая страница",
          site_title: {
            around_location: "Поблизости %{location}",
            with_category_and_location: "Предложения из категории %{category} в %{location}",
            with_category: "Предложения из категории %{category}",
            with_location: "Предложения в %{location}",
            default: "Предложения",
          },
        },
        history: {
          site_title: "Недавно просмотренные предложения",
          viewed_products_title: "Вы недавно просматривало",
          similar_to_viewed_products_title: "Это вас также заинтересует",
          viewed_products_tags_title: "Смотрите также",
        },
      },
      reviews: {
        new: {
          site_title: "Добавить отзыв",
          review_details_title: "Ваш отзыв",
          content_placeholder: "Опишите несколькими словами, что было хорошо, а что можно улучшить.",
          rating_label: "Выберите оценку...",
          personal_details_title: "Ваши данные",
          locale_label: "Язык",
          age_group_label: "Ваш возраст ",
          group_type_label: "Вид группы",
          author_name_label: "Ваше имя",
          author_email_label: "Ваш эл. адрес",
          st_details_title: "Как Вы оцениваете процесс бронирования?",
          st_rating_label: "Выберите оценку...",
          st_feedback_placeholder: "Почему?",
          submit: "Отправить отзыв",
          add_success_message: "Ваш отзыв добавлен. Спасибо!",
          error_message: "При сохранении формы произошла ошибка.",
          review_for_given_order_already_exists:
            "Отзыв об этом заказе уже добавлен. Перезапись или редактирование отзыва невозможное.\n",
          order_id: "Номер заказа",
          product: "Предложение",
          author_email_hint: "Не будем его никому показывать.",
          add_review_title_about_product: 'Добавить отзыв о "%{product_name}" и %{company_name}',
          add_review_title_about_company: "Добавить отзыв о %{company_name}",
        },
      },
    },
    layouts: {
      application: {
        contact: {
          about_us: {
            title: "О нас",
          },
          contact_us: {
            title: "Свяжитесь с нами",
          },
          cooperating_with: {
            dotpay_payments: "Платежи обрабатываются системой электронных платежей",
            title: "Сотрудничаем с",
          },
          see_us_on_facebook: {
            title: "Следите за нами на Фейсбуке",
          },
          write_to_us: {
            title: "Свяжитесь с нами",
          },
          payment_gateways: {
            title: "Платежные шлюзы\n",
            description: "Мы поддерживаем оплаты с помощью кредитных карт, банковских переводов и PayPal.",
          },
        },
        footer: {
          about_us: "О нас",
          careers: "Карьера",
          cooperation: "Сотрудничество",
          faq: "FAQ",
          help: "Помощь",
          privacy_policy: "Политика конфиденциальности",
          rules_note_html: 'Использование данного ве��-сайта означает принятие <a href="%{rules_url}"> правил</a>.',
        },
        guaranteed: {
          read_more: "Проверьте, как работает Tripsomnia",
          s1: {
            line1: "Тщательно подобранные предложения",
            line2: "и надежные партнеры.",
            title: "Самое высокое качество",
          },
          s2: {
            line1: "Скидки даже до 50%!",
            line2: "Сниженные цены специально для Вас.",
            title: "Самые низкие цены",
          },
          s3: {
            currency: "PLN",
            line1: "Оплата в рассрочку, непосредственно на партнерский счет или наличными на месте.",
            title: "Безопасные платежи",
          },
          s4: {
            line1: "Интереснейшие предложения, путевки и размещения - все в одном месте!",
            title: "Бронировать онлайн",
          },
          title: "Гарантируем",
        },
        navbar: {
          about_us: "О нас",
          for_business: "сотрудничество",
          products_calendar: "Календарь сроков",
          search_placeholder: "Поиск предложения, локализации или категории",
          products_history: "история (%{count})",
          contact: "Контакт",
          faq: "Часто задаваемые вопросы",
          open_chat: "Чат",
          cart: "Корзина (%{count})",
          finish_order: "Завершите заказ: %{product_name} (%{total_amount})",
          company_reviews: "Отзывы",
        },
      },
      mailer: {
        greetings: "С наилучшими пожеланиями,",
        marketplace: {
          footer_headline: "Tripsomnia.com - Мы Любим Путешествовать!",
        },
        footer_phone: "Тел.",
        footer_email: "E-mail:",
      },
    },
    pdfs: {
      order_voucher: {
        cancellation_policy: "Условия отмены",
        cancellation_policy_description:
          "Предложение безвозвратное. Нет возможности изменения или отмены заказа. В случае отсутствия участника, уплаченные средства не возвращаются.",
        company_details: "Данные организатора",
        contact_email: "Адрес электронной почты",
        contact_facebook_url: "Фейсбук",
        contact_full_address: "Адрес",
        contact_phone_number: "Контактный телефон",
        contact_website_url: "Веб-страница",
        generated_date: "Генерировано: %{date}",
        got_any_questions: "Возникли вопросы?",
        order_details: "Ваши контактные данные",
        order_number: "Номер заказа",
        product_details: "Подробности предложения",
        st_headline: "Tripsomnia (SocialTravel Sp. z o.o.)",
        title: "Подтверждение заказа № %{order_id}",
        wish_you_great_journey: "Мы желаем вам незабываемых впечатлений!",
        your_order: "Ваш заказ",
        footer_phone: "Тел.",
        footer_email: "E-mail: ",
        code: "",
      },
      slot_manifest: {
        customer_name_placeholder: "Заказ",
        generated_on: "Дата генерирования %{date}",
        page_title: "манифест",
      },
    },
    admin_user_mailer: {
      company_created_you_an_account: {
        action: "Выберите пароль",
        greeting: "Здраствуйте, %{recipient}!",
        instruction:
          "Фирма %{company_name} создала дла вас аккаунт в панели Tripsomnia, используемого для обработки заказов и туристических предложений.",
        instruction_2: "Кликните на ссылку ниже что войти в сервис и установить свой пароль.",
        instruction_3: "Если Вы не запрашивали доступ к этому сервису, пожалуйста, проигнорируйте это сообщение.",
        subject: "Фирма %{company_name} создала дла вас аккаунт в панели партнера Tripsomnia",
      },
      company_invited_you_to_become_a_member: {
        action: "Перейти к панелю компании",
        greeting: "Здравстуйте, %{recipient}!",
        instruction:
          "Фирма %{company_name} уделила вам доступ к аккаунту в панели партнера Tripsomnia, используемого для обработки заказов и туристических предложений.",
        instruction_2: "Кликните на ссылку ниже, чтобы перейти в панель.",
        subject: "Фирма %{company_name} уделила Вам доступ в панели партнера Tripsomnia",
      },
    },
    company_mailer: {
      agent_invitation_received: {
        action: "Перейти к панели сотрудничества",
        greeting: "Здравствуйте, %{company_name}!",
        instruction:
          "Фирма %{supplier_name} пригласила Вас к сотрудничеству с агентством, чтобы вы могли продавать их предложения.",
        instruction_2: "Кликните на ссылку ниже, чтобы перейти к панели и увидеть подробности сотрудничества.",
        subject: "Фирма %{supplier_name} предлагает Вам агентское сотрудничество",
      },
      company_and_user_created_agent_invitation_received: {
        action: "Выберите пароль",
        greeting: "Здравствуйте, %{company_name}!",
        instruction:
          "Фирма %{supplier_name} пригласила Вас к сотрудничеству с агентством, чтобы вы могли продавать их предложения.",
        instruction_2: "Нет перевода в английском языке",
        instruction_3:
          "Кликните на ссылку ниже, чтобы выбрать пароль для своего аккаунта и увидеть подробности сотрудничества.",
        subject: "Фирма %{supplier_name} предлагает Вам агентское сотрудничество",
      },
      company_created_and_agent_invitation_received: {
        action: "Перейти к панели сотрудничества",
        greeting: "Здравствуйте, %{company_name}!",
        instruction:
          "Фирма %{supplier_name} пригласила Вас к сотрудничеству с агентством, чтобы вы могли продавать их предложения.",
        instruction_2: "Кликните на ссылку ниже, чтобы перейти к панели и увидеть подробности сотрудничества.",
        subject: "Фирма %{supplier_name} предлагает Вам агентское сотрудничество",
      },
      company_registration_approved: {
        action: "Перейти к панели ",
        greeting: "Здравствуйте, %{company_name}!",
        instruction:
          "Мы создали для вас аккаунт компании %{company_name} в нашей панели Tripsomnia для управления заказами и туристическими предложениями.",
        instruction_2:
          "Кликните на ссылку ниже, чтобы перейти к панели и увидеть подробности сотрудничества. Ссылка активна в течение 48 часов. Если вы не можете войти в эти часы, воспользуйтесь опцией «Напоминание пароля» для восстановления доступа к учетной записи.",
        subject: "В панели Tripsomnia был создан аккаунт компании %{company_name}",
      },
      company_registration_approved_and_user_created: {
        action: "Выберите пароль",
        greeting: "Здравствуйте, %{company_name}!",
        instruction:
          "Мы создали для вас аккаунт компании %{company_name} в нашей панели Tripsomnia для управления заказами и туристическими предложениями.",
        instruction_2: "Нет перевода в английском языке",
        instruction_3:
          "Кликните на ссылку ниже, чтобы перейти к панели и увидеть подробности сотрудничества. Ссылка активна в течение 48 часов. Если вы не можете войти в эти часы, воспользуйтесь опцией «Напоминание пароля» для восстановления доступа к учетной записи.",
        subject: "В панели Tripsomnia был создан аккаунт компании %{company_name}",
      },
      company_registration_created: {
        action: "Показать подробности регистрации",
        greeting: "Здравствуйте!",
        instruction: "Кто-то выполнил регистрационный бланк компании следующими даными:",
        subject: "Фирма %{company_name} хочет зарегестрировать вас в панели Tripsomnia",
      },
      customer_review_submitted: {
        greeting: "Здравствуйте %{company_name}!",
        new_review_has_been_submitted: "На платформе Tripsomnia нет еще отзывов о Вас. ",
        action: "Посмотреть отзыв",
        subject: "Добавлено новый отзыв о Вас",
      },
      company_and_user_created_supplier_invitation_received: {
        action: "Придумайте свой пароль",
        greeting: "Привет, %{supplier_name}!",
        instruction: "Фирма %{agent_name} пригласила вас к сотрудничеству, чтобы они могли продавать ваши предложения.",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
      company_created_and_supplier_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
      supplier_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
    },
    order_mailer: {
      base: {
        company_approve_order: "Подтвердите заказ",
        company_finish_order: "Обозначь как Законченное",
        company_reject_order: "Отклонить заказ",
        company_see_order: "Показать заказ",
        customer_repeat_order: "Повторить заказ",
        customer_see_all_offers: "Показать все доступные предложения",
        customer_see_nearby_offers: "Показать другие предложения в окрестности",
        customer_see_offer: "Узнать больше",
        hello_company: "Здравствуйте, %{company_name}!",
        hello_customer: "Здравствуйте, %{customer_full_name},",
        order_status: "Статус заказа: %{status_i18n}",
        company_reject_order_and_deactivate_slot: "Отклонить заказ и исключить этот день c продаж",
      },
      company_order_footer: {
        line1_html: "Твое предложение доступно в сервисе по ссылке: %{product_link}.",
        line2_html: 'Можешь ею управлять из <a href="%{partnerapp_order_url}">панели управления</a>.',
      },
      order_about_to_start_reminder_company_email: {
        p1_html:
          'Заказ клиента %{customer_full_name} № %{order_id} на "%{product_name}" начинается через %{days_to_start} дней (%{stock_start_date}).',
        p2_html:
          'В качестве напоминания мы выслали Вам детали заказа. Подтверждение заказа в версии для печати мы выслали в предыдущем письме. Если Вы не можете найти файл в формате PDF, его можно скачать <a href="%{customer_pdf_order_url}">здесь</a>.',
        subject:
          'Подтвержденный заказ № %{order_id} на "%{product_name}" начинается через %{days_to_start} дней (клиент: %{customer_full_name})',
      },
      order_about_to_start_reminder_customer_email: {
        marketplace: {
          p1_html:
            'Ваш заказ № %{order_id} на "%{product_name}" начинается уже через %{days_to_start} дней, т.е. в %{stock_start_date}!',
          p2_html:
            'В качестве напоминания мы выслали Вам детали заказа. Подтверждение заказа в версии для печати мы выслали в предыдущем письме. Если Вы не можете найти файл в формате PDF, его можно скачать <a href="%{customer_pdf_order_url}">здесь</a>.',
        },
        saas: {
          p1_html:
            'Ваш заказ № %{order_id} на "%{product_name}" начинается уже через %{days_to_start} дней, т.е. в %{stock_start_date}!',
          p2_html:
            'В качестве напоминания мы выслали Вам детали заказа. Подтверждение заказа в версии для печати мы выслали в предыдущем письме. Если Вы не можете найти файл в формате PDF, его можно скачать <a href="%{customer_pdf_order_url}">здесь</a>.',
        },
        subject: 'Ваш заказ "%{product_name}" начинается',
      },
      order_company_approval_time_limit_exceeded_company_email: {
        line1:
          'К сожалению, мы были вынуждены отклонить предзаказ № %{order_id} от %{customer_full_name} на "%{product_name}" (%{stock_time_range}) в связи с отсутствием Вашего ответа в установленном сроке.',
        line2:
          "Если в установленном в предложении сроке нет достпуных мест, пожалуйста обновите доступность мест в панели партнера.",
        subject:
          "Заказ № %{order_id} был отклонен - Вы не подтвердили заказ в установленном сроке (клиент: %{customer_full_name})",
        line1_html:
          'К сожалению, мы были вынуждены отклонить вступительный заказ № <a href="%{partnerapp_order_url}">%{order_id}</a> от %{customer_full_name} до "%{product_name}" с датой (%{stock_time_range}), в связи с отсутствием Твоего ответа на запрос в течение требуемого срока.',
      },
      order_company_approval_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>К сожалению, мы были вынуждены автоматически отклонить ваш заказ № %{order_id} на"%{product_name}" (%{stock_time_range})</strong> в связи с тем, что наш партнер %{company_name} не ответил на Ваш заказ в установленном сроке. %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
        },
        saas: {
          line1_html:
            '<strong>К сожалению, мы были вынуждены автоматически отклонить заказ № %{order_id} на "%{product_name}" (%{stock_time_range})</strong> в связи с превышением маскимального времени ожидания подтверждения - %{company_approval_time_limit}.',
          confirmation_installment_refund_info:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
        },
        subject: "Заказ № %{order_id} был отклонен, так как мы не получили подтверждения заказа в установленном сроке",
      },
      order_current_status_customer_email: {
        marketplace: {
          p1: "Высылаем Вам актуальный статсу заказа.",
        },
        saas: {
          p1: "Высылаем Вам актуальный статсу заказа.",
        },
        subject: 'Заказ № %{order_id}, актуальный статус: %{status_i18n} ("%{product_name}")',
      },
      order_finished_add_opinion_reminder_customer_email: {
        marketplace: {
          add_review: "Добавить отзыв",
          contact_us:
            "Если у вас есть какие-либо комментарии относительно работы нашей системы и обслуживания клиентов Tripsomnia.com, пожалуйста, свяжитесь с нами!",
          share_your_opinion_html:
            "Помогите другим туристам и выразите свое мнение о нашем партнере %{company_link} и предложении %{product_link}.",
          thank_you_html: "Большое спасибо за Ваш заказ на Tripsomnia и использование услуг нашего партнера.",
        },
        saas: {
          add_review: "Добавить отзыв",
          contact_us:
            "Если у вас есть какие-либо комментарии относительно работы нашей системы и обслуживания клиентов Tripsomnia.com, пожалуйста, свяжитесь с нами!",
          share_your_opinion_html:
            "Помогите другим туристам и выразите свое мнение о нас %{company_link} и предложении %{product_link}.",
          thank_you_html: "Спасибо за использование наших сервисов.",
        },
        subject: 'Добавтье отзыв о "%{product_name}" (%{company_name})',
      },
      order_is_approved_company_email: {
        no_online_deposit_subject: "Заказ № %{order_id} подтвержден (клиент: %{customer_full_name})",
        online_deposit_after_company_approval_subject:
          "Заказ № %{order_id} подтвержден и оплачен (клиент: %{customer_full_name})",
        online_deposit_before_company_approval_subject:
          "Заказ № %{order_id} оплачен и потвержден (клиент: %{customer_full_name})",
        online_deposit_paid:
          "Клиент оплатил аванс %{confirmation_installment_paid_amount} на заказ № %{order_id} на %{product_name}. Заказу приделен статус «подтвержден».",
        order_approved: 'Заказ № %{order_id} на "%{product_name}" подтвержден.',
        order_cant_be_cancelled_now: "С этого момента Вы не можете отменить данный заказ.",
        order_infos_below:
          "Ниже Вы найдете подробную информацию о заказе. К письму прикреплен PDF ваучер, подтверждающий заказ, который также был отправлен клиенту.",
        remember_to_set_order_as_finished: 'После реализации заказа отметьте его как "Завершен".',
        voucher: {
          line1_html: "",
          line2_html: "",
        },
      },
      order_is_approved_customer_email: {
        marketplace: {
          bank_wire_deposit_additional_info:
            "В описании банковского перевода введите пожаулйста только номер заказа, который находится в этом подтверждении. В противном случае, мы не можем гарантировать, что перевод будет зафиксирован вовремя.\n",
          bank_wire_deposit_deadline_html:
            "<strong>Не забудьте вовремя сделать банковский перевод.</strong> Если Вы не внесете предоплату на банковский счет в установленном сроке, Ваш заказ может быть аннулирован.",
          bank_wire_deposit_make_html: "Пожалуйста, произведите оплату через банковский перевод.",
          bank_wire_deposit_required: "Этот заказ требует дополнительной оплаты на счет.",
          order_approved_by_company:
            'Ваш заказ № %{order_id} на "%{product_name}" был подтвержден организатором %{company_name}!',
          order_created: "Благодарим за Ваш заказ на Tripsomnia.com!",
          order_data_and_deposit_received: "Мы уже получили всю необходимую информацию и оплату.",
          order_data_received: "Мы уже получили всю необходимую информацию.",
          this_is_confirmation:
            "Это сообщение является подтверждением Вашего заказа. В приложении к письму Вы найдете подтверждение с важнейшими информациями. Вы должны забрать его с собой на телефоне или разпечатать.",
          order_approved_by_customer: 'Ваш заказ № %{order_id} на "%{product_name}" подтвержден.',
          voucher: {
            line1_html:
              "Резервирование с использованием <strong>Туристического Купона</strong>. По приезде на место реализуй Купон, а также доплати возможную разницу в цене.",
            line2_html:
              "Чтобы использовать купон, предоставьте продавцу <strong>сумму, которую вы хотите заплатить, и номер купона</strong>. Затем введите <strong>код авторизации платежа</strong>, который вы получите по SMS во время выполнения. Организатор также может связаться с вами заранее по телефону или электронной почте, чтобы обменять ваучер на подтверждение бронирования.",
          },
        },
        saas: {
          bank_wire_deposit_additional_info:
            "В описании банковского перевода введите пожаулйста только номер заказа, который находится в этом подтверждении. В противном случае, мы не можем гарантировать, что перевод будет зафиксирован вовремя.\n",
          bank_wire_deposit_deadline_html:
            "<strong>Не забудьте вовремя сделать банковский перевод.</strong> Если Вы не внесете предоплату на банковский счет в установленном сроке, Ваш заказ может быть аннулирован.",
          bank_wire_deposit_make_html: "Пожалуйста, произведите оплату через банковский перевод.",
          bank_wire_deposit_required: "Этот заказ требует дополнительной оплаты на счет.",
          order_approved_by_company: 'Ваш заказ № %{order_id} на "%{product_name}" подтвержден!',
          order_created: "Благодарим за Ваш заказ!",
          order_data_and_deposit_received: "Мы уже получили всю необходимую информацию и оплату.",
          order_data_received: "Мы уже получили всю необходимую информацию.",
          this_is_confirmation:
            "Это сообщение является подтверждением Вашего заказа. В приложении к письму Вы найдете подтверждение с важнейшими информациями. Вы должны забрать его с собой на телефоне или разпечатать.",
          order_approved_by_customer: 'Ваш заказ № %{order_id} на "%{product_name}" подтвержден.',
          voucher: {
            line1_html: "",
            line2_html: "",
          },
        },
        subject: 'Подтверждение заказа № %{order_id} на "%{product_name}"',
      },
      order_is_waiting_for_company_approval_company_email: {
        confirmation_deadline_warning:
          'Пожалуйста проверте подробности заказа и кликните "Подтверди заказ", если в состоянии его реализовать.\nВ случае отсутствия подтверждения в течение установленного срока заказ будет отклонен. Если вы не можете выполнить заказ в течение указанного времени, пожалуйста, нажмите кнопку «Отклонить заказ». Вы можете также отбросить заказ и прекратить продажу этого предложения в эти дни, кликая соответствующую кнопку.',
        future_online_deposit_info:
          "После того, как Вы подтвердите заказ, у клиента будет %{confirmation_installment_after_company_approval_time_limit} часов, чтобы оплатить авансом %{confirmation_installment_transaction_amount} за заказ.",
        order_received: 'Мы получили предзаказ № %{order_id} на"%{product_name}".',
        past_online_deposit_info:
          "Клиент зделал перевод %{confirmation_installment_st_name_b} на сумму %{confirmation_installment_paid_amount}, чтобы подтвердить предварительный заказ. В случае, если вы аннулируете заказ, %{confirmation_installment_st_name} будет автоматически возвращена на банковский счет клиента.",
        please_confirm: "Пожалуйста, подтвердите заказ в установленном сроке до %{pauses_at}.",
        subject: "Заказ № %{order_id} ожидает подтверждения (клиент: %{customer_full_name})",
        order_approved_by_customer: 'Клиент подтвердил предзаказ № %{order_id} на "%{product_name}".',
        voucher: {
          line1_html: "",
          line2_html: "",
        },
      },
      order_is_waiting_for_company_approval_customer_email: {
        marketplace: {
          company_approval_deadline:
            "У нашего партнера есть %{company_approval_time_limit}, чтобы ответить. В большинстве случает наш партнер отвечает в течение 1 часа в рабочее время.",
          order_is_waiting_for_company_approval:
            'Заказ № %{order_id} на "%{product_name}" ожидает подтверждения от нашего партнера %{company_name}.',
          thank_you_for_order: "благодарим за Ваш предзаказ на Tripsomnia.com!",
          thank_you_for_order_and_online_deposit:
            "благодарим за Ваш предзаказ на Tripsomnia.com и за %{confirmation_installment_st_name_d} онлайн на сумму %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "В случае подтверждения предварительного заказа, Вы получите эл. письмо вместе с ссылкой к оформлению платежа %{confirmation_installment_st_name_d} онлайн на сумму %{confirmation_installment_amount}. После того как наш партнер подтвердит заказ, у Вас будет %{confirmation_installment_after_company_approval_time_limit} с момента подтверждения заказа на осушествление платежа через систему электронных платежей.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "В случае отсутствия платежа в течение установленного срока Ваш заказ будет автоматически отклонен.",
          what_with_no_deposit_if_order_gets_approved:
            "Если Ваш заказ будет подтвержден, Вы получите по эл. почте потверждение заказа с информацией о платеже.",
          what_with_paid_deposit_if_order_gets_approved:
            "Если заказ будет подтвержден, зафиксированная сумма аванса пойдет на оплату заказа. Если наш партнер будет вынужден отвергнуть вашу просьбу или не подтвердит ее вовремя, сумма аванса будет автоматически возвращена на ваш банковский счет в течении 24 часов. Тогда Вы можете зделать заказ на другое предложение.",
          thank_you_for_order_approval: "благорим за подтверждения предзаказа посредничеством портала SocialTrave.pl",
        },
        saas: {
          company_approval_deadline:
            "У нас есть %{company_approval_time_limit}, чтобы ответить, но обычно мы отвечаем в течение 1 часа в рабочее время.",
          order_is_waiting_for_company_approval:
            'Заказ № %{order_id} на "%{product_name}" ожидает нашего подтверждения.',
          thank_you_for_order: "благодарим за Ваш предзаказ.",
          thank_you_for_order_and_online_deposit:
            "благодарим за Ваш предзаказ и за %{confirmation_installment_st_name_d} онлайн на сумму %{confirmation_installment_paid_amount}.",
          what_with_future_deposit_if_order_gets_approved_l1:
            "В случае подтверждения предварительного заказа, Вы получите эл. письмо вместе с ссылкой к оформлению платежа %{confirmation_installment_st_name_d} онлайн на сумму %{confirmation_installment_amount}. У Вас %{confirmation_installment_after_company_approval_time_limit} с момента подтверждения заказа на осушествление платежа через систему электронных платежей.",
          what_with_future_deposit_if_order_gets_approved_l2:
            "В случае отсутствия платежа в течение установленного срока Ваш заказ будет автоматически отклонен.",
          what_with_no_deposit_if_order_gets_approved:
            "В случае подтверждения предварительного заказа, Вы получите эл. письмо вместе с информацией касательно платежа. ",
          what_with_paid_deposit_if_order_gets_approved:
            "Если мы будем вынуждены отвергнуть вашу просьбу или позволим ей истечь, онлайн %{confirmation_installment_st_name} будет автоматически возвращена на Ваш банковский счет в течении 24 часов. Вы можете также связаться с нами и выбрать другое предложение.",
          thank_you_for_order_approval: "благорим за подтверждения предзаказа.",
        },
        subject: 'Заказ № %{order_id} ожидает подтверждения ("%{product_name}")',
      },
      order_is_waiting_for_confirmation_online_payment_company_email: {
        line1:
          'Заказ № %{order_id} на "%{product_name}" подтвержден и ожидает платежа  со стороны клиента %{confirmation_installment_transaction_amount} через нашу систему онлайн платежей. ',
        line2: "В случае если клиент не заплатит до установленного срока, заказ будет автоматически аннулирован.",
        subject: "Заказ № %{order_id} ожидает платежа (клиент: %{customer_full_name})",
      },
      order_is_waiting_for_confirmation_online_payment_customer_email: {
        after_company_approval_subject: "Заказ № %{order_id} ожидает платежа (%{product_name})",
        default_subject: 'Заказ № %{order_id} ожидает оплаты ("%{product_name}")',
        marketplace: {
          deadline_warning:
            "В случае отсутствия платежа в течение установленного срока Ваш заказ будет автоматически отклонен.",
          order_approved: 'Наш партнер подтвердил Ваш заказ № %{order_id} на"%{product_name}".',
          pay_button: "Заплатить онлайн через систему электронных платежей",
          payment_deadline: "Срок платежа: %{pauses_at}",
          please_pay:
            "Пожалуйста, сделайте оплату %{confirmation_installment_transaction_amount} через нашу безопасную систему платежей онлайн.",
        },
        saas: {
          deadline_warning:
            "В случае отсутствия платежа в течение установленного срока Ваш заказ будет автоматически отклонен.",
          order_approved: 'Мы получили Ваш предварительный заказ № %{order_id} на "%{product_name}".',
          pay_button: "Заплатить онлайн через систему электронных платежей",
          payment_deadline: "Срок платежа: %{pauses_at}",
          please_pay:
            "Пожалуйста, сделайте оплату %{confirmation_installment_transaction_amount} через нашу безопасную систему платежей онлайн.",
        },
      },
      order_is_waiting_for_customer_approval_customer_email: {
        marketplace: {
          action: "Подтвердите заказ",
          approval_deadline: "",
          deadline_warning:
            "В случае отсутствия подтверждения в течение установленного срока Ваш заказ будет автоматически аннулирован.",
          order_approved:
            'Наш партнер %{company_name} прислал подробности Твоего заказа № %{order_id} на"%{product_name}".',
          please_approve: "Пожалуйста, подтвердите заказ по ссылке ниже.",
          approve_action: "Подтвердить заказ",
          reject_action: "Отклонить заказ",
        },
        saas: {
          action: "Подтвердите заказ",
          approval_deadline: "",
          deadline_warning:
            "В случае отсутствия подтверждения в течение установленного срока Ваш заказ будет автоматически аннулирован.",
          order_approved: 'Ваш заказ № %{order_id} на "%{product_name}" подтвержден.',
          please_approve: "Пожалуйста, подтвердите заказ по ссылке ниже.",
          approve_action: "Подтвердить заказ",
          reject_action: "Отклонить заказ",
        },
        subject: 'Пожалуйста, подтвердите заказ № %{order_id} ("%{product_name}")',
      },
      order_online_deposit_time_limit_exceeded_company_email: {
        line1:
          'К сожалению, мы были вынуждены отклонить предзаказ № %{order_id} от%{customer_full_name} на"%{product_name}" (%{stock_time_range}) в связи с отсутствием платежа в установленном сроке. Свяжитесь с клиентем, чтобы выяснить подробности.',
        subject:
          "Заказ № %{order_id} был отклонен - клиент не вплатил %{confirmation_installment_st_name_d} в установленном сроке (клиент: %{customer_full_name})",
      },
      order_online_deposit_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html:
            '<strong>К сожалению, мы были вынуждены автоматически отклонить ваш заказ № %{order_id} на"%{product_name}"</strong> в связи с отсутствием платежа в установленном сроке.',
          line2:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
          line3_html: "Если хотите повторно сделать заказ, перейдите на страницу предложения: %{product_link}",
        },
        saas: {
          line1_html:
            '<strong>К сожалению, мы были вынуждены автоматически отклонить ваш заказ № %{order_id} на"%{product_name}" (%{stock_time_range})</strong> в связи с отсутствием платежа в установленном сроке.',
          line2:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
          line3_html: "Если хотите повторно сделать заказ, перейдите на страницу предложения: %{product_link}",
        },
        subject:
          "Заказ № %{order_id} был отклонен - Вы не вплатили %{confirmation_installment_st_name_d} в установленном сроке",
      },
      order_online_payment_reminder_customer_email: {
        marketplace: {
          contact_us_if_problems: "Если у Вас возникли проблемы заказом, пожалуйста, свяжитесь с нами.",
          line1:
            'Мы не зафиксировали оплаты за Ваш предварительный заказ № %{order_id} на "%{product_name}". Из-за превышения максимального времени ожидания мы вынеждены были аннулировать Ваш заказ. Тем не менее, Вы можете еще раз произвести заказ.',
          offer_details_below: "Ниже вы найдете подробности предложения:",
        },
        saas: {
          contact_us_if_problems: "Если у Вас возникли проблемы заказом, пожалуйста, свяжитесь с нами.",
          line1:
            'Мы не зафиксировали оплаты за Ваш предварительный заказ № %{order_id} на "%{product_name}". Из-за превышения максимального времени ожидания мы вынеждены были аннулировать Ваш заказ. Тем не менее, Вы можете еще раз произвести заказ.',
          offer_details_below: "Ниже вы найдете подробности предложения:",
        },
        subject: 'Напоминаем Вам о завершении заказа на "%{product_name}"',
      },
      order_company_rejected_company_email: {
        line1: 'Вы отклонили предварительный заказ № %{order_id} от %{customer_full_name} на "%{product_name}".',
        line2:
          "Если Вы хотите изменить дату, лимит продаж или другие настройки, мы просим Вас о выполнении актуализации в Панели Партнера.",
        subject: "Заказ № %{order_id} был отклонен (клиент: %{customer_full_name})",
        line1_html:
          'Вы отклонили предварительный заказ № <a href="%{partnerapp_order_url}">%{order_id} </a> от %{customer_full_name} до "%{product_name}".',
      },
      order_company_rejected_customer_email: {
        marketplace: {
          line1:
            'В связи с отсутсвием доступных мест в данном часовым промежутке, наш партнер был вынужден отклонить Ваш заказ № %{order_id} на "%{product_name}".',
          see_offer_html: "Показать это предложение в других промежутках: %{product_link}",
          confirmation_installment_refund_info:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
        },
        saas: {
          line1:
            'В связи с отсутсвием доступных мест в данном промежутке мы были вынуждены отклонить Ваш заказ № %{order_id} на "%{product_name}".',
          see_offer_html: "Показать это предложение в других промежутках: %{product_link}",
          confirmation_installment_refund_info:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
        },
        subject: 'Заказ № %{order_id} на "%{product_name}" был отклонен',
      },
      order_customer_rejected_company_email: {
        line1: 'Клиент отклонил предзаказ №  %{order_id} от %{customer_full_name} на "%{product_name}".',
        subject: "Заказ № %{order_id} был отклонен клиентов (клиент: %{customer_full_name})",
      },
      order_customer_rejected_customer_email: {
        marketplace: {
          line1: 'Ваш заказ № %{order_id} на "%{product_name}" у нашего партнера %{company_name} был отклонен.',
          see_offer_html: "Показать предложение еще раз: %{product_link}",
          confirmation_installment_refund_info:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
        },
        saas: {
          line1: 'Ваш заказ № %{order_id} на "%{product_name}" был отклонен.',
          see_offer_html: "Показать предложение еще раз: %{product_link}",
          confirmation_installment_refund_info:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
        },
        subject: 'Заказ № %{order_id} на "%{product_name}" был отклонен.',
      },
      order_current_status_company_email: {
        line1: "Текущий статус заказа:",
        subject: "Заказ № %{order_id}, статус: %{status_i18n} (клиент: %{customer_full_name})",
      },
      order_company_cancelled_company_email: {
        line1: 'Заказ № %{order_id} от %{customer_full_name} на "%{product_name}" был отменен.',
        subject: "Заказ № %{order_id} был аннулирован (клиент: %{customer_full_name})",
        line1_html:
          'Заказ № <a href="%{partnerapp_order_url}">%{order_id}</a> от %{customer_full_name} до "%{product_name}" отменен.',
      },
      order_company_cancelled_customer_email: {
        marketplace: {
          line1:
            'Партнер %{company_name} аннулировал Ваш заказ № %{order_id} на "%{product_name}" на %{stock_time_range}.',
          see_offer_html: "Показать это предложение в других промежутках: %{product_link}",
          confirmation_installment_refund_info:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
        },
        saas: {
          line1: 'Му аннулировали Ваш заказ № %{order_id} на "%{product_name}" на %{stock_time_range}.',
          see_offer_html: "Показать это предложение в других промежутках: %{product_link}",
          confirmation_installment_refund_info:
            "Полученную вплату %{confirmation_installment_paid_amount} мы вернем на Ваш счет в течение ближайших 24 часов.",
        },
        subject: 'Заказ № %{order_id} на "%{product_name}" был аннулирован',
      },
      order_abandonment_followup_customer_email: {
        see_product: "Показать еще раз: %{product_name}",
        find_other_products_in_this_location: "Найти другие предложения в подобном месте:\n",
        line1: 'недавно вы просматривали следующее предложение: "%{product_name}". Вы до сих пор ним заинтересованы?',
        subject: 'Посмотрите предложения похожие к "%{product_name}"',
        go_to_product: "Узнать больше",
      },
    },
    papp: {
      components: {
        EditableBillRow: {
          placeholder: "Впиши название",
        },
        InstallmentFormSection: {
          exact_date_label: "Конкретная дата",
          how: "Как?",
          on_stock_starts_at_label: "В день старта предложения",
          paid_after_company_approval_label: "В случае заказов с подтверждением, требуй от клиента предоплаты",
          remaining_amount: "Оставшаяся сумма",
          when: "Когда?",
          whole_amount: "Вся сумма",
          x_days_after_order_creation_label: "После отправления заказа",
          x_days_after_order_full_approval_label: "После подтверждения заказа",
          x_days_after_previous_installment_label: "После предыдущего взноса",
          x_days_before_stock_starts_at_label: "До начала заказа",
          how_much: "Сколько?",
          to: "До?",
        },
        InstallmentsListFormSection: {
          add_new: "Добавить еще один взнос",
        },
        LocationFormControl: {
          placeholder: "Укажите локализацию",
        },
        MainView: {
          default_error_title: "Ошибка подключения к серверу",
          error_date: "Дата события",
          error_description: "Если ошибка повторяется, свяжитесь с нами по эл. почте.",
          error_id: "Номер ошибки",
          loading: "Загрузка...",
          retry: "Попробовать снова",
        },
        MultipleDateFormControl: {
          add_new: "Укажите дату",
        },
        MultipleInputFormControl: {
          placeholder: "Добавить новую линию",
        },
        MultipleTimeFormControl: {
          add_new: "Укажите время",
        },
        OrderSidebarPreview: {
          edit_slot: "Изменить срок",
          see_slot: "Показать срок",
        },
        PaginationNavigation: {
          out_of: "Из",
        },
        PaymentProfileProductAttachmentFormSection: {
          active: "Активный",
          additional_fee: "Платеж",
          days_before_arrival_date_limit: "Выбранные даты",
          days_before_arrival_date_limit_label: "Заранее",
          installment: "Взнос",
          no_date_limit: "Всегда",
        },
        ProductCustomerOrderFieldFormSection: {
          add_list_option: "Добавить позицию в список",
          add_new: "Добавить новое поле",
          show_on_manifest: "Показать подробный перечень",
          value_required: "Требуемое значение",
          value_type: "Тип значения",
        },
        ProductPricedOrderFieldFormSection: {
          add_list_option: "Добавить позицию в список",
          ask_customer: "Спросить клиента",
          different_currency_base_amount_note:
            "Дополнительные параметры определенные в валюте, отличной от валюты предложения, всегда считаются отдельно от первичной цены.",
          for_all_variants: "Для всех вариантов",
          remove: "Удалить параметр",
          show_on_manifest: "Показать подробный перечень",
          value_type: "Тип значения",
        },
        SlotsCalendar: {
          agenda: "Список",
          allDay: "Весь день",
          availability_mode: "Доступность",
          date: "Дата",
          day: "День",
          event: "Срок",
          month: "Месяц",
          next: "Следующий",
          previous: "Предыдущий",
          price_mode: "Цены",
          showMore: "%{count} больше...",
          time: "Время",
          today: "Сегодня",
          week: "Неделя",
          slot_confirmed: "Дата подтверждена",
        },
        TagsInputFormControl: {
          addition_label: "Добавить:",
          no_results_message: "Без результатов",
          placeholder: "Добавить ",
        },
        TypeaheadInputFormControl: {
          no_results_message: "Без результатов",
          placeholder: "Все",
        },
        SaleWindowRuleFormGroup: {
          sale_starts_at_label: "Открытие продаж",
          sale_ends_at_label: "Закрытие продаж",
          offset_label: "заранее",
          from_date_label: "с даты",
          until_date_label: "до даты",
          before_slot_start: "до начала",
          resolved_preview: "Для даты %{slot} это %{resolved}.",
        },
        UsebyDateRangeFormGroup: {
          days_limit_label: "х дни",
          days_since_order_creation: "дней от даты заказа",
          ends_at_label: "до дня",
          starts_at_and_ends_at_label: "в днях",
          starts_at_label: "Со дня",
        },
        ProductsListItem: {
          preview_marketplace: "Показать",
          preview_saas: "веб-страницы",
          new_order: "Забронировать",
          active_switch_label: "Активно",
          published_on_saas_switch_label: "WWW",
        },
        OrderedProductOrderFieldFormControl: {
          custom_location_name_placeholder: "Впишите адрес клиента",
        },
        ProductsSelectControl: {
          blank_label: "Нет назначенного предложения ",
        },
      },
      order: {
        approve: "Подтвердить",
        cancel_order: "Отменить/аннулировать заказ",
        confirm: "Забронировать",
        customer_name_placeholder: "Нет данных о клиенте",
        delete_order: "Удалить заказ",
        finish: "Завершить",
        redeliver_customer_order_email: "Выслать подробности заказа",
        reject: "Отклонить ",
        redeliver_supplier_order_email: "Выслать доставщику подробности заказа",
        finish_order: "Завершить заказ",
        automatic_icon: "А",
        manual_icon: "М",
        no_stock_date: "Нет даты",
      },
      common: {
        search: "Поиск...",
        no_results_message: "Ничего не найдено.",
        discard_changes_confirm_message: "Хотите покинуть страницу, не сохранив изменений?",
        go_back: "Вернуться",
        remove: "Удалить",
        save: "Сохранить",
        none: "Отсутствует",
        poland: "Польша",
        edit: "Редактировать",
        manage: "Управлять",
        save_changes: "Сохранить изменения",
        submit_success_message: "Изменения сохранены.",
        default_value: "По умолчанию: %{value}",
        attention: "Внимание\n",
        no_name: "(без названия)",
        close: "Закрыть",
        in_total: "Итого",
        filters_title: "Фильтровать",
        form_validation_error_message: "Одно из полей формы заполнено неправильно.\n",
        cancel: "Отменить",
        go_next: "Дальше",
        st_email: "cooperation@tripsomnia.com",
        st_phone_number: "+48 690 670 581",
        are_you_sure: "Вы уверены?",
        translations_locale: "Выберите ",
        x_per_page: "%{count} / страница",
        show_filters: "Показать фильтры",
        hide_filters: "Скрыть фильтры",
        download_csv: "Скачать CSV",
        weekdayAbbreviations: ["пн.", "вт.", "ср.", "чт.", "пт.", "сб.", "вс."],
      },
      agents: {
        AgentsListView: {
          title: "Агенты",
          add_new: "Новый агент",
          no_records_title: "Нет агентов",
          no_records_message: "Вы еще не предложили никому сотрудничества.",
          no_records_add_new_link: "Предложить сотрудничество первому агенту?",
        },
        EditAgentCooperationView: {
          default_pricing: "Ставки по умолчанию",
          activate_all: "Предоставь все",
          remove_confirm_message: "Вы уверены, что хотите прервать это агентское сотрудничество?",
          title: "Агентское сотрудничество",
          title_with_company_name: "Агентское сотрудничество с %{company_name}",
          products: "Предложения",
          price_change: "Увеличение / уменьшение",
          gross_price: "Цена брутто",
          net_price: "Цена нетто",
          include_product_options_price: "добавить цену дополнительных параметров",
          st_cooperation_hint: {
            p1: "Сотрудничество с Tripsomnia",
            p2: "Вы не можете изменить условий сотрудничества с нами.",
            p3: "Если вы хотите какие-либо изменения, пожалуйста, свяжитесь с опекуном по эл. почте либо по телефону: %{email} / %{tel}",
          },
        },
        NewAgentPrompt: {
          title: "Новый агент",
          email_label: "Впишите адрес e-mail агента",
          submit: "Предложить сотрудничество",
        },
        SuppliersListView: {
          title: "Доставщики",
          no_records_title: "Нет доставщиков",
          no_records_message: "На данный момент нет предложений об агентском сотрудничестве",
          add_new: "Пригласи к сотрудничеству организатора",
        },
      },
      app: {
        App: {
          fetch_app_error_title: "Ошибка подключения к серверу",
        },
        ForbiddenView: {
          title: "Ошибка 403",
          message: "Доступ запрещен",
        },
        LeftBar: {
          dashboard: "Панель управления",
          calendar: "Календарь",
          orders: "Заказы",
          products: "Предложения",
          customers: "Клиенты",
          agents: "Агенты",
          suppliers: "Доставщики",
          finances: "Финансы",
          raports: "Рапорты",
          settings: "Параметры",
          reviews: "Отзывы",
          affiliate: "Финансы",
          accommodation: "Проживание",
          connectly: "Connectly"
        },
        NotFoundView: {
          title: "Ошибка 404",
          message: "Страница не найдена",
        },
        requireAuth: {
          company_forbidden: "У вас нет доступа к этой фирме (ID: %{company_id}).",
          no_companies_error_title: "К вашему аккаунта не привязана ни одна компания.",
        },
        TopBar: {
          logout: "Выйти",
          marketplace_homepage: "Tripsomania.com",
          new_order: "Забронировать",
          saas_homepage: "Ваша веб-страница",
          your_account: "Настройки пользователя",
        },
      },
      auth: {
        LoginView: {
          send_confirmation_instructions_link: "Выслать повторно ссылку",
          send_reset_password_instructions_link: "Забыли пароль?\n",
          send_unlock_instructions_link: "Мой аккаунт заблокирован",
          submit: "Войти",
          title: "Вход в панель Tripsomnia.com",
        },
        ResetPasswordView: {
          submit: "Изменить пароль",
          title: "Генерировать новый пароль",
        },
        SendResetPasswordInstructionsView: {
          email_help: "Вы вышлем вам письмо с ссылкой к генератору новых паролей для вашегоаккаунта",
          email_label: "Ваш адрес e-mail",
          submit: "Выслать",
          success_message:
            "Мы выслали письмо на ваш почтовый адрес с ссылкой к генератору новый паролей. Проверьте вашу почту.",
          title: "Забыли пароль?",
        },
        index: {
          fetch_user_failed_message: "Ваше соединение разорвано. Пожалуйста, войдите снова.",
        },
      },
      calendar: {
        CalendarView: {
          all_products: "Все предложения",
          all_suppliers: "Все доставщики",
          title: "Календарь резерваций",
          filter_all: "Все",
          filter_available: "Доступно",
          filter_awaiting: "Ожидает",
          filter_booked: "Забронировано",
          show_inactive_offers: "Показать неактивные предложения",
        },
        ShowSlotModal: {
          active_orders_title: "Активные заказы",
          build_order: "Забронировать",
          no_orders_message: "Нет заказов на данный срок.",
          open_manifest: "Показать подробный перечень.",
          open_manifest_failure_message: "Произошла ошибка при загрузке перечня",
          other_orders_title: "Оставшиеся заказы",
          download_manifest: "Скачать манифест",
          booked_orders_title: "Забронировано",
          pending_orders_title: "В ожидании",
          awaiting_orders_title: "Ожидает",
          sale_window_title: "Окно продаж",
          sale_starts_at_label: "Открытие продаж",
          sale_ends_at_label: "Закрытие продаж",
          within_sale_window_yes: "В продаже",
          within_sale_window_no: "Вне окна продаж",
          within_sale_window_past: "Дата уже прошла",
          biledo_block_title: "Связь с Biledo",
          biledo_term_uuid: "Term UUID",
          biledo_pricelist_uuid: "Pricelist UUID",
          biledo_overwrite_warning: "Ваше изменение будет перезаписано при следующей синхронизации с Biledo.",
        },
      },
      customers: {
        CustomersListView: {
          no_records_add_new_link: "Добавить?",
          no_records_message: "Пока еще не создан ни один клиент.",
          no_records_title: "Нет клиентов",
          title: "Клиенты",
          query_filter: "Фамилия клиента, адрес электронной почты или телефон",
          add_new_customer: "Новый клиент",
        },
        EditCustomerModal: {
          existing_customer_title: "Редактировать клиента",
          new_customer_title: "Новый клиент",
          remove_confirm_message: "Вы уверены, что хотите удалить клиента?",
        },
        ShowCustomerView: {
          no_name: "(без названия)",
          orders_title: "Заказы",
          title: "Клиент",
        },
      },
      dashboard: {
        DashboardView: {
          created_orders_number_label: "Количество созданных заказов",
          finished_orders_number_label: "количество выполненных заказов",
          finished_orders_total_amount_label: "Сумма за выполненные заказы",
          new_orders_title: "Новые заказые (за последние 30 дней)",
          no_graph_data_message: "Нет данных для вывода статистики.\n",
          no_orders_waiting_message: "Нет заказов, ожидающих подтверждения.",
          orders_number_label: "заказов",
          orders_waiting_for_your_approval_title: "Заказы ожидают подтверждения\n",
          participants_number_label: "участников",
          see_all_orders: "Показать все (%{count})",
          title: "Панель управления",
          hint: {
            p1: "Начните продавать ваши предложения",
            p2: "Выполните настройки учетной записи пользователя и компании.\n",
            p3: "Добавить предложения: описание, параметры цен и бронирования, сроки.",
            p4: "Создать и поместить виджеты на ваш веб-сайт.",
            p5: "Принимайте заказы онлайн от клиентов или добавляйте их самостоятельно в панели.",
            p6: "В случае сомнений или вопросов свяжитесь, пожалуйста, с нами по чату, телефону %{tel} или по электронной почте %{email}.",
            p2_html:
              'Завершите настройки учетной записи вашей компании, выбрав вкладку <a href="https://panel.tripsomnia.com/c/100/settings/company/account" target="_blank">Dane firmy</a>.',
            p3_html:
              'Подтвердите свой аккаунт в системе онлайн-платежей на подвкладке <a href="https://panel.tripsomnia.com/c/100/settings/company/stripe" target="_blank">Rejestracja płatności</a>',
            p4_html:
              'Добавьте предложения, выбрав раздел <a href="https://panel.tripsomnia.com/c/100/products" target="_blank">Oferty</a>, в левой части экрана. Более подробную информацию о том, как правильно добавить предложение можно найти в <a href="http://partners.tripsomnia.com/183/tworzenie-ofert-wycieczek-i-atrakcji/" target="_blank">bazie wiedzy</a>.',
            p7: "Если у вас есть вопросы или проблемы, свяжитесь с нами в чате, по телефону %{tel} или по электронной почте %{email}.",
            p6_html:
              'Узнайте больше о Панели Партнера и воспользоваться ее расширенными возможностями, чтобы продать свои предложения как можно более эффективно, прочитав наш <a href="http://partners.tripsomnia.com/category/panel-partnera/" target="_blank">bazę wiedzy</a>.',
          },
          stats_title: "Статистики (%{date_from} - %{date_to})",
        },
      },
      finances: {
        FinancesListView: {
          no_records_message: "Пока еще не добавлено ни одного заказа.",
          no_records_title: "Нет заказов.",
          title: "Финансы",
          summary_row: "Сумма (для строк %{start}-%{end}):",
          create_agent_disbursement: "Выплата агента",
          agent_received_paid_th: "Агент получил / отдал",
          socialtravel_received_paid_th: "Tripsomnia сняля / оплатила",
          supplier_received_paid_th: "Поставщик получил / вернул\n",
          orders_count: "%{count} заказов",
        },
      },
      settings: {
        SettingsLayout: {
          title: "Параметры",
          user: "Пользователь",
          user_account_settings: "Настройки пользователя",
          company: "Фирма",
          company_account_settings: "Данные фирмы",
          company_members_settings: "Пользователи и права",
          products_settings: "Параметры предложений",
          payments_settings: "Параметры платежей",
          billing_settings: "Данные к фактуре",
          integrations: "Интерграция",
          marketplace_settings: "Marketplace Tripsomnia",
          saas_settings: "Ваша веб-страница",
          widgets_settings: "Виджеты",
          readonly_access_message:
            "Вы не можете обновить эту информацию. Чтобы это сделать, нужно зайти в качестве администратора.",
          stripe: "Регистрация платежа",
        },
        BillingSettingsView: {
          title: "Данные фирмы",
          invoice_company_name_placeholder: "По умолчанию: название компании (%{default_value})",
          invoice_contact_email_placeholder: "По умолчанию: почтовый адрес компании (%{default_value})",
          invoice_contact_phone_number_placeholder: "По умолчанию: контактный номер компании (%{default_value})",
          invoice_details_title: "Данные к фактуре",
          hint: {
            p1: "Данные для расчетов\n",
            p2: "Укажите данные компании, на основе которых будем приготовливать инвойсы",
          },
        },
        CompanyMembersView: {
          title: "Активные пользователи",
          new_member: "Добавить пользователя",
          no_members: "Нет участников",
          hint: {
            p1: "Добавление пользователей",
            p2: "Предоставление доступ другим лицам к вашей компании. Новому аккаунту вы можете дать права администратора или сотрудника (ограниченный доступ).\n",
          },
        },
        CompanySettingsView: {
          title: "Данные фирмы",
          contact_details: "Контактная информация для ваших клиентов\n",
          contact_phone_number_placeholder: "напр. +48 690 670 581",
          notifications_details: "Данные для обработки заказа",
          notifications_email_placeholder: "По умолчанию: aдрес электронной почты компании (%{default_value})",
          notifications_email_label: "Адрес для подтверждения заказов",
          notifications_phone_number_placeholder: "По умолчанию: контактный телефон компании (%{default_value})",
          notifications_phone_number_label: "Номер мобильного телефона с кодом страны",
          other_details: "Остальные параметры",
          hint: {
            p1: "Название",
            p2: "Краткое название для коммуникации в Панели партнера.",
            p3: "Фотография профиля",
            p4: "Видимый в Панели Партнера и для клиентов. Лучше всего вставить лого компании.",
            p5: "Контактная информация",
            p6: "Будут показаны клиенту в подтверждении заказа.",
            p7: "Данные для обработки заказа",
            p8: "На указанный адрес электронной почты будут отправлены уведомления и запросы о подтверждении заказа.",
            p9: "Главный язык",
            p10: "На этом языке наша система будет взаимодействовать с вашей компанией по электронной почте.",
            p11: "Часовой пояс",
            p12: "Вы вводите даты предложений в данном часовом поясе. Если измените этот параметр он не повлияет на добавленные уже сроки.",
          },
        },
        MarketplaceSettingsView: {
          title: "Marketplace Tripsomnia",
          marketplace_homepage_url_label: "Адрес вашей компании на marketplace",
          hint: {
            p1: "Профиль вашей компании в Tripsomnia",
            p2: "Эта информация будет показана клиентам на подстранице вашей компании на нашей продажной платформе Tripsomnia.",
          },
        },
        PaymentsSettingsView: {
          title: "Параметры платежей",
          your_profiles_title: "Профили платежей для ваших клиентов",
          marketplace_profiles_title: "Профили платежей для клиентов Tripsomnia.com",
          add_new_profile: "Добавить новый профиль",
          hint: {
            p1: "Валюта предложений по умолчанию",
            p2: "Выбрать валюты по умолчанию для простейшой конфигурации предложения.",
            p3: "Данные банковского счета",
            p4: "Информация, которую вы предоставите в этом окне будет отправлена клиентам, которые заказывают с профилем оплаты на ваш банковский счет.",
            p5: "Профили платежей для ваших клиентов",
            p6: "Добавляйте и редактируйте профили оплаты для клиентов важей компании. ",
            p7: "Профили платежей для клиентов Tripsomnia",
            p8: "Эти профили оплаты, предлагаемые нами в рамках нашего сотрудничества. Чтобы изменить эти профили, обратитесь к консультанту.\n",
          },
          no_your_profiles_warning:
            "Добавьт хотя бы один профиль платежа для Ваших клиентов. В противном случае они не смогут составить заказы на Вашей веб-странице",
          enable_for_all_product_variants: "Включить для всех предложений",
          access_possible_only_for_supplier:
            "Изменение профилей платежей доступно только поставщикам предложений. Свяжитесь со своим поставщиком, чтобы узнать какие профили платежей доступны для",
          increase_orders_amount_by_saas_commision_label:
            "Добавить оплату за наши системные комиссионные к полной стоимости заказа",
          increase_orders_amount_by_saas_commision_enabled_hint: "Комиссионные оплатит клиент",
          increase_orders_amount_by_saas_commision_disabled_hint: "Комиссионные оплатит ваша компания",
        },
        ProductsSettingsView: {
          title: "Пареметры предложений",
          hint: {
            p1: "Условия",
            p2: "Вставьте здесь текст условий, которые клиенты должны будут принять бронируя ваши предложения.",
            p3: "Мобильный ваучер",
            p4: "Отметите, пожалуйста, требуете ли Вы от клиентов расспечатанную версию подтверждения / ваучера. Если вы не помеитите эту опцию, клиенты могут показывать заказ на смартфоне.",
          },
        },
        SaasSettingsView: {
          title: "Ваша веб-страница",
          saas_homepage_url: "Адрес вашей веб-страницы",
          contact_us_if_want_to_change: "Свяжитесь с нами, если хотите изменить страницу.",
          hint: {
            p1: "Ваш веб-сайт",
            p2: "Эта информация будет показана клиентам на вашей веб-странице.\n",
          },
        },
        UserAccountView: {
          title: "Настройки пользователя",
          site_settings_title: "Настройки аккаунта",
          password_change_title: "Изменить пароль",
          hint: {
            p1: "Настройки учетной записи пользователя",
            p2: "Эти параметры влияют только на ваш аккаунт пользователя. Они не влияют на основные параметры компании.",
          },
        },
        WidgetsSettingsView: {
          title: "Виджеты",
          iframe: "IFrame",
          button: "Кнопка",
          navbar: "Панель навигации",
          detect_from_visitor_browser: "Настройки веб-браузера пользователя",
          locale: "Язык страницы",
          currency: "Валюта клиента",
          bubble: "Пузырь",
          active: "Активировать",
          scrollWidget: "Активировать всплывающий виджет после прокрутки до конца страницы",
          exitWidget: "Активировать всплывающий виджет, когда клиент пытается покинуть страницу",
        },
        ButtonWidgetView: {
          book_now: "Забронировать",
          small_size: "Маленький",
          normal_size: "Средний",
          large_size: "Большой",
          bottom_right: "нижний правый угол",
          bottom_left: "нижний левый угол",
          top_right: "верхний правый угол",
          top_left: "верхний левый угол",
          in_modal: "в модальном окне",
          in_new_tab: "в новом окне",
          title: "Кнопка",
          button_content: "Содержание кнопки",
          open: "Открыть",
          color: "Цвет",
          size: "Размер",
          stick_to_window_corner: "Положение",
          generate_code: "Сохранить",
          place_code_anywhere:
            "Поместите этот код в любом месте страницы. Мы предлагаем поместить его в самом начале, перед %{head}, либо в самом конце, перед %{body_end}.",
          put_widget_anywhere:
            "Если Вы не хотите выбирать позицию виджета на странице по умолчанию, вставьте следующий код в место, которое Вы выбрали на веб-сайте.",
          preview: "Предпросмотр",
          button_type: "Нормальное нажатие",
          flag_type: "Флаг",
          what_type: "Виды нажатий",
          center_right: "справа посередине",
          center_left: "слева посередине",
        },
        NavBarWidgetView: {
          new_link: "Добавить элемент",
          our_products: "Наше предложение",
          products_calendar: "Календарь сроков",
          book: "Забронировать",
          white_blue: "Белый с оттенком синего",
          white_teal: "Белый с морским оттенком",
          white_orange: "Белый с оттенком оранжевого",
          black_blue: "Черный с оттенком синего",
          black_teal: "Черный с морским оттенком",
          black_orange: "Черный с оттенком оранжевого",
          blue: "Синий",
          teal: "Морской",
          orange: "Оранжевый",
          to_window_bottom: "в конце страницы",
          to_window_top: "в начале станицы",
          in_modal: "в модальном окне",
          in_new_tab: "в новом окне",
          none: "Отсутствует.",
          company_name: "Название компании",
          company_logo: "Лого компании",
          title: "Панель навигации",
          show_company_name: "Показать название компании",
          show_toggle_button: "Показать кнопку «Свернуть / Развернуть»",
          open: "Открыть",
          color: "Цвет",
          stick: "Положение",
          cta_button: "Главная кнопка",
          navigation: "Закладки",
          contact: "Контакт",
          generate_code: "Сохранить",
          place_code_anywhere:
            "Поместите этот код в любом месте страницы. Мы предлагаем поместить его в самом начале, перед %{head}, либо в самом конце, перед %{body_end}.",
          put_widget_anywhere: "Следующий шаг - поместить виджет в выбранное вами место.",
          preview: "Предпросмотр",
          link_type_link: "Ссылка",
          link_type_none: "отсутствует",
          link_type_text: " Текст",
          link_type_phone: "Телефон",
          link_type_email: "Эл. почта",
          link_type_custom_link: "Своя ссылка",
          black: "черный",
          white: "белый",
          green: "зеленый",
          type1: "Тип 1",
          type2: "Тип 2",
          type3: "Тип 3",
          red: "красный",
          percentage: "процентов",
          activity: "предложение",
          cart: "корзина",
          notification: "уведомление",
          offer: "скидка",
          search: "поиск",
          star: "звездочка",
          negotiate: "",
          discount: "",
          chat: ""
        },
        IframeWidgetView: {
          title: "IFrame",
          iframe_width: "Ширина Iframe",
          iframe_height: "Высота Iframe",
          generate_code: "Генерировать код",
          put_widget_anywhere: "Скопируй и вклей нижеупомянутый код в избранном Тобой месте на Вашем сайте.\n",
          preview: "Предпросмотр",
        },
        WidgetRouteFormSection: {
          homepage_page: "Главная сраница",
          products_list_page: "Список предложений",
          products_calendar_page: "Календарь сроков",
          product_page: "Подстраница предложения",
          new_order_page: "Форма бронирования предложения",
          on_slot_click_show_product: "Подстраница предложения",
          on_slot_click_new_order: "Форма бронирования на данный срок",
          type: "Вид",
          product: "Предложение",
          all_products: "Все предложения",
          on_slot_click_action_type: "При нажатии на срок откроется",
          reviews_page: "Отзывы",
          product_location_tag: "Локализация",
          product_location_tag_page: "Локализация",
          product_category_tag: "Категория",
          product_category_tag_page: "Страница категорий",
          coupons_page: "Список купонов",
        },
        EditPaymentProfileModal: {
          profile_change_affects_all_products_warning:
            "Не забывайте, что произведённые здесь изменения влияют на все предложения, к которым на данный момент привязан этот профиль оплаты.",
          remove_confirm_message: "Вы уверены, что хотите удалить этот профиль платежа?",
          edit_profile_title: "Редактировать профиль платежа ",
          new_profile_title: "Новый профил платежа\n",
          name_label: "Название профиля",
          name_hint:
            "Будет показан клиенту в процессе оформления заказа, если у него будет выбор из более чем одного профиля.",
          has_additional_fee_label: "Дополнительная опция ",
          cancellation_policy_hint:
            "До каких пор можно отменить заказ? На какую сумму можно подать заявку на возмещение?",
          installments_label: "Рассрочка платежа",
          additional_fee_as_agent_fee_label: "Добавить в качестве платы за услуги Агента",
        },
        EditCompanyMemberModal: {
          edit_member_title: "Редактируй пользователя",
          new_member_title: "Добавить пользователя",
          remind_password: "Напомнить пароль",
        },
        BubbleWidgetView: {
          balloon_line1_value: "Все экскурсии",
          balloon_line2_value: "Кликните сюда, чтобы их получить!",
          balloon_line1_label: "Первая строчка текста",
          balloon_line2_label: "Вторая строчка текста",
          generate_code: "Сохранить",
          large_size: "Широкий",
          normal_size: "Нормальный",
          place_code_anywhere:
            "Поместите этот код куда угодно на вашей веб-странице. Мы рекомендуем разместить код в начале, перед %{head}, либо в head, прямо перед %{body_end}.",
          placement: "Положение",
          preview: "Предпоказ",
          put_widget_anywhere: "После этого поместите виджет там, где вам будет угодно.",
          small_size: "Маленький",
          title: "Пузырь",
          bottom_left_corner: "левый нижний угол",
          bottom_right_corner: "правый нижний угол",
          color_label: "Цвет",
          placement_label: "Положение",
          size_label: "Размер",
          top_left_corner: "левых верхний угол",
          top_right_corner: "правый верхний угол",
          show_after_label: "Показать виджет после",
          show_balloon_after_label: "Показать текст после\n",
          play_sound_label: "Воспроизводить звук",
          animation_type: "Анимация",
          icon: "Значок",
        },
        IndexWidgetsView: {
          header1: "Инструкция по установке виджетов",
          header2: "Предыдущие виджеты",
          text1:
            "Приглашаем Вас воспользоваться виджетами на вашем сайте. Для начала просто поместите приведенный ниже код в любое место на странице. Мы предлагаем вам поставить его в начале, непосредственно перед </head>, lub pod jej koniec, tuż przed </body></html>.",
          text2:
            "Затем вы можете перейти к редактированию виджетов Bubble или Button, выбрать соответствующие настройки, активировать выбранный виджет и сразу же просмотреть эффект на своем веб-сайте.",
          text3:
            "Мы рады сообщить, что с 1 марта 2019 года мы внесли изменения в наши виджеты. Старые виджеты и их коды останутся активными и будут работать всегда, но мы рекомендуем перейти на новую, улучшенную версию виджетов.",
          text4:
            "Новые виджеты лучше!\nО том, почему стоит начать пользоваться новыми виджетами можно прочитать выше. Для замены необходимо стереть старые коды и следовать инструкциям для новых виджетов. В случае каких-либо сомнений, пожалуйста, свяжитесь с нами по адресу info@tripsomnia.com",
          widgetCodeHasBeenCopied: "Код виджета был успешно скопирован!",
          widgetCodeHasnBeenCopied: "Скопируйте код виджета",
          copyWidgetCode: "Скопировать код виджета",
        },
        StripeSettingsView: {
          title: "Соединиться c Stripe",
          stripe_verification_failure: "К сожалению, ваша регистрация в Stripe не удалась.",
          stripe_verification:
            "Нажмите на ссылку ниже, чтобы войти в панель управления Stripe и просмотреть свои настройки, баланс счета и историю выплат. Вы также можете обновить свои данные. Для этого Вам понадобится номер телефона, который Вы указали при регистрации, чтобы подтвердить свою личность.",
          stripe_verification_success: "Регистрация в STRIPE успешно завершена.",
          line1_html: "",
          line2_html:
            "Начиная верификацию вы будете перенаправлены непосредственно к формуляру Stripe, заполнение которого займет менее 10 минут.",
          line4_html:
            "В случае вопросов или технических проблем, свяжитесь с нами:\n+ 48 690-670-581, info@tripsomnia.com",
          line3: "Для регистрации в Stripe Вам необходимо:",
          line3_1: "Адрес электронной почты",
          line3_2: "Номера телефона, на который придет код смс-верификации",
          line3_3: "Документ, удостоверяющий личность (паспорт, водительские права)",
          line3_4: "Данные Вашей компании",
          line5_html:
            "Stripe также попросит ввести веб-сайт Вашей компании. <strong>Если у вас нет собственного домена, введите: tripsomnia.com</strong>",
          line6_html:
            'Для получения более подробной информации о том, как правильно зарегистрироваться в Stripe, перейдите по ссылке <a href="https://stripe.com/docs/account/activate" target="_blank">tutaj</a>.',
          line7:
            "Если у вас есть какие-либо вопросы или технические проблемы, наша команда к вашим услугам по телефону: +48 512 154 254, info@tripsomnia.com или в чате.",
          line1:
            "Заботясь о высочайших стандартах безопасности онлайн-транзакций, Tripsomnia.com сотрудничает с глобальным поставщиком услуг приёма платежных Stripe. Верификация в Stripe необходима для приема безопасных онлайн-платежей от клиентов из всех каналов продаж и для автоматического расчета заказов после их выполнения путем перевода средств на ваш банковский счет.",
          line2:
            "Начиная верификацию Вы будете перенаправлены непосредственно к форме Stripe, заполнение которой займет менее 10 минут.",
        },
      },
      orders: {
        AddOrderTransferModal: {
          default_title: "Новый взнос / возврат",
          new_refund_title: "Новый возврат",
          new_transfer_title: "Новый взнос",
        },
        ChangeOrderScheduleSlotModal: {
          title: "Изменение срока заказа",
        },
        EditOrderCustomerDetailsModal: {
          title: "Данные заказа",
          customer_details: "Данные заказчика",
        },
        EditOrderInstallmentsModal: {
          title: "Рассрочка платежа суммы заказа",
        },
        EditOrderItemsModal: {
          title: "Счет заказа",
          changed_order_item_name: "Изменение: %{item_name}",
          changed_order_option_name: 'Изменение опции с "%{prev_item_name}" на "%{next_item_name}"',
          removed_order_option_name: 'Удаление опции "%{prev_item_name}"',
          added_order_option_name: 'Добавление опции "%{next_item_name}"',
          order_items_title: "Счет",
          order_item_index: "Позиция",
          order_item_unit_price: "Цена за шт.",
          order_item_quantity: "Количество штук",
          order_item_total_price: "Итого",
          add_new_order_item: "Добавить новую позицию",
          extra_participants_existing:
            "Участников в заказе больше, чем в указано в счету. Удалите их из заказа, нажав на крестик около имени.",
          installments_require_manual_change_warning:
            "Обратите внимание, что количество платежей для этого заказа не будет изменяться автоматически. Если хотите изменить количество, измените способ платежа за заказ после изменения инвойса.",
        },
        NewOrderItemsForm: {
          select_agent: "Выберать агента",
          reset_agent_commision: "Перезагрузить",
          product_options: "Дополнительные параметры",
          other_order_items: "Остальные",
          add_new_order_item: "Добавить новую позицию",
        },
        NewOrderPaymentsForm: {
          accept_deposit: "Принять платеж сейчас",
          plan_payments: "Запланировать платеж",
          no_payments: "Не сейчас (сохранить эскиз)",
          deposit_accepted_as_agent: "(платеж будет помечен как принятый aгентом)",
          deposit_accepted_as_supplier: "(платеж будет помечен как принятый pоставщиком)",
          only_deposit_now: "Сейчас только депозит",
          rest_payment: "Доплатить оставшуюся сумму",
          order_status: "Статус заказа",
          notify_customer: "Отправить уведомление клиенту",
          notify_customer_impossible_no_customer_email_given:
            "Нет адреса электронной почты клиента, отправить уведомление невозможно.",
          note_placeholder: "Добавить заметку",
          choose_payments_mode: "Выберите способ оплаты для клиента.",
          choose_payments_mode_error: "Выберите способ оплаты для клиента.",
          order_status_message: "После сохранения заказа его статус будет изменен на:",
        },
        NewOrderProductModal: {
          no_products_found: "Не найдено ни одного предложения.",
          static_date_booking_label: "Заказ является бронированием на конкретный срок?",
          with_custom_product_title: "Нестандартное предложение",
          choose_product_variant: "Выбрать вариант предложения",
          default_title: "Новое предложение",
          search_products: "Поиск предложения",
          use_custom_product_button: "Нестандартное предложение",
          info1:
            "Вы можете оформить бронирование по желанию клиента и отправить ему ссылку для оплаты онлайн. Бронирование не будет связано ни с одним существующим предложением. Введите название бронирования, которое проинформирует клиента о том, что он заказал. При желании добавьте столько деталей бронирования, сколько считаете нужным: цена включает, не включает и т. д.",
          order_name: "Название резервирования",
        },
        NewOrderModal: {
          confirm_abandon_message: "Вы уверены, что хотите покинуть это предложние?",
          confirm_abandon_cancel: "Нет, вернуться к заказу",
          confirm_abandon_ok: "Да, покинуть заказ",
          schedule_step_title: "Укажите дату",
          order_items_step_title: "Укажите счет заказа",
          customer_details_step_title: "Введите данные клиента",
          payments_step_title: "Oплата",
          abandon_failed_message:
            "Мы не могли покинуть ваш заказ. Вероятно, он был сохранен в базе данных. Если вы хотите отменить его, перейдите к подстраницы предложения и удалить его вручную.",
          payments_step_profiles_instruction: "Выберите профиль оплаты",
          payments_step_choose_payments: "Выберите способ оплаты заказа",
          payments_step_choose_payments_reseller: "Плати за клиента",
          payments_step_choose_payments_customer: "Отправить ссылку на платеж",
          payments_step_choose_payments_reseller_hint1:
            "Выберите эту опцию, чтобы иметь возможность немедленно оплатить заказ безопасным онлайн-платежом.",
          payments_step_choose_payments_reseller_hint2: "",
          payments_step_choose_payments_customer_hint1:
            "Выберите эту опцию, если хотите отправить клиенту электронное письмо со ссылкой для оплаты. В предыдущем шаге необходимо указать адрес электронной почты клиента.",
          payments_step_choose_payments_customer_hint2: "",
          payments_step_prebook: "Предзаказ",
          payments_step_choose_payments_terminal_hint1:
            "Введите сумму заказа на платежном терминале Tripsomnia и примите оплату от покупателя.",
          payments_step_choose_payments_terminal_hint2:
            "Если платеж был принят успешно, запиши заказ, чтобы завершить резервирование. Заказ будет сложен, и клиент получит подтверждение по электронной почте.",
          payments_step_choose_payments_terminal: "100% оплата через терминал Tripsomnia.",
        },
        OrderScheduleForm: {
          select_existing_slot: "Выбрать существующий срок",
          upcoming_slots: "Ближайшие сроки",
          no_slots_found: "Свободные сроки для этого предложения не найдены",
          all_day: "[Весь день]",
          add_new_slot: "Добавить срок",
        },
        OrdersListView: {
          title: "Заказы",
          add_new_order: "Новый заказ",
          no_orders_title: "Нет заказов",
          no_orders_message: "Пока еще не добавлено ни одного заказа.",
          no_orders_add_new_button: "Хотите создать?",
          customer_query_filter: "Имя клиента, адрес электронной почты или телефон",
          other_filters: "Другое",
          marketplace_filter: "Marketplace",
          saas_filter: "SaaS",
          manual_filter: "Вручную",
          automatic_filter: "Автоматически",
          requires_company_approval_filter: "Требуется подтверждение поставщика",
          doesnt_require_company_approval_filter: "Не требуется подтверждение поставщика",
          no_booking_filter: "Без резервации",
          static_date_booking_filter: "С резервацией",
          total_amount_currencies_filter: "Валюта",
          customer_payment_methods_filter: "Способ платежа",
          with_agent_commision_filter: "Вместе с комиссионными агента",
          with_agent_service_fee_filter: "Вместе с сервисной оплатой агента",
          with_both_agent_commision_and_service_fee_filter: "Вместе с комиссионными и сервисной оплатой",
          with_saas_commision_filter: "Вместе с ситемной комиссией",
          customer_transfer_date_filter: "Дата платежа",
          without_agent_commision_and_service_fee_filter: "Без комиссии и платы за услуги Агента",
          notes_filter: "Заметки",
          with_notes_filter: "С заметками",
          notes_filter_placeholder: "Искать в содержимом заметки",
          with_affiliate_filter: "С партнером",
          with_agent_filter: "С агентом",
          with_agent: "С Агентом",
          static_date_range_booking_filter: "Ночлег",
        },
        ChangeOrderStatusPrompt: {
          title: "Изменение статуса заказа",
          choose_new_status: "Выберите новый статус заказа",
          save_and_notify_customer: "Сохранить и отправить уведомление клиенту",
          notify_supplier: "Уведомить доставщика",
          save_and_send_opinion_request: "Сохраненит и отправить запрос клиенту об отзыве",
        },
        ShowOrderView: {
          add_new_transfer: "Новый взнос",
          add_new_refund: "Новый возврат",
          edit_note: "Заметка",
          change_status: "Изменить статус заказа",
          print: "Распечатать",
          customer_title: "Клиент",
          see_details: "(показать данные)",
          send_notification: "(отправить уведомление)",
          order_items_title: "Счет",
          order_item_unit_price: "Цена за шт.",
          order_item_quantity: "Количество шт.",
          payments_title: "Платежи",
          agent_title: "Расчет с aгетнтом",
          activities_title: "История заказа",
          title: "Заказ %{order_id}",
          approve_warning: "Подтвердить",
          approve_until_warning: "Подтвердите до %{date}",
          send_opinion_reminder_notification: "(oтправить просьбу добавить отзыв)",
          pay_now: {
            tooltip: {
              no_payment_needed: "Этот заказ полностью оплачен.",
              too_low_amount: "Сумма платежа слишком мала.",
            },
            0: "Оплата через STRIPE",
          },
        },
        utils: {
          confirm_approve_message: "Вы уверены, что хотите подтвердить этот заказ?",
          confirm_reject_message: "Вы уверены, что хотите отклонить этот заказ?",
          confirm_finish_message: "Вы уверены, что хотите пометить этот заказ как завершенный?",
          confirm_cancel_message: "Вы уверены, что хотите отменить этот заказ?",
          confirm_delete_message: "Вы уверены, что хотите удалить этот заказ?",
          redeliver_customer_order_email_success_message: "Эл. почта с информацией о заказе была выслана клиенту.",
          redeliver_supplier_order_email_success_message: "Эл. почта с информацией о заказе была выслана доставщику.",
          create_agent_disbursement_success_message:
            "Выбранные заказы были урегулированы (Номер расчета: %{agent_disbursement_id}).",
          redeliver_customer_order_opinion_reminder_email_success_message:
            "Уведомление о добавлении отзыва о заказе отправлено клиенту по эл. почте.",
          send_opinion_request_to_customer: "Отправить запрос клиенту с просьбой об отзыве",
        },
        OrderCustomerDetailsFormSection: {
          participants_details: "Данные участников",
        },
        EditOrderNotesModal: {
          title: "Заметка",
        },
      },
      products: {
        EditProductView: {
          StepAdditional: {
            form_title: "Параметры Tripsomnia",
            marketplace_settings: "Marketplace",
            saas_commision_settings: "Комиссия / Плата за услуги SaaS",
            hint: {
              p1: "Параметры комиссии",
              p2: "Остальные параметры найдете в Агентах.",
            },
          },
          StepAvailability: {
            all_product_variants: "Все варианты",
            remove_all_slots_confirm: {
              title: "Удаление срока",
              message: "Вы уверены, что хотите удалить этот срок и ее последующие повторы?\n",
              confirm: "Удалить все сроки от %{all_slots_initial_date}",
            },
            remove_single_slot_confirm: {
              title: "Удаление срока",
              message: "Этот срок повторяется. Вы хотите удалить этот срок и все его повторы или только данный срок?",
              select_all_slots: "Перейдите к редакции всех сроков от %{all_slots_initial_date}",
              confirm: "Удалить только этот срок",
            },
            remove_booked_slot_alert: {
              message:
                "Удалить этот срок невозможно - он забронирожанный активным заказом. Если вы хотите его удалить, впервые отмените заказ.",
              go_to_slot_view: "Перейти к виду срока",
            },
            remove_slot_confirm: {
              title: "Удаление срока",
              message: "Вы уверены, что хотите удалить этот срок?",
              confirm: "Удалить этот срок",
            },
            edit_all_slots_confirm: {
              title: "Редактировать срок",
              message:
                "Внесены изменения в повторы срока. Вы уверены, что хотите перезаписать этот срок и его последующие повторы?\n",
              confirm: "Поменять все сроки с %{all_slots_initial_date}",
            },
            edit_single_slot_confirm: {
              title: "Редактировать срок",
              message:
                "Этот срок повторяется. Вы желаете перезаписать только данный срок или перейти к редакции его всех последующих повторов?",
              select_all_slots: "Перейти к редакции всех сроков с %{all_slots_initial_date}",
              confirm: "Изменить тольро этот срок",
            },
            add_slot: "Добавить срок",
            add_many_slots: "Добавить несколько сроков",
            select_first_slot_date: "Укажите дату и время первого срока",
            select_slot_date: "Укажите дату и время срока",
            prices_title: "Прайс-лист",
            no_prices_message:
              "Вы не определили цен по умолчанию. Перейдите к закладке «Цены», чтобы ввести прайс-листы.",
            availability_title: "Доступность",
            hint: {
              p1: "Перед тем, как начнете добавлять сроки вашего предложения, настройте параметры по умолчанию цены и бронирования для данного предложения.",
              p2: "Добавить срок",
              p3: "Для того, чтобы добавить один срок просто выберите дату в календаре, настройте параметры и сохраните изменения.",
              p4: "Добавить несколько сроков",
              p5: "Для того, чтобы добавить несколько сроков используйте опцию повторения срока.",
            },
            normal_start_dates_assignation_type: "выбранные",
            recursion_start_dates_assignation_type: "циклично",
            edit_slot: "Редактировать срок",
            repeat_on_days: "Повторять в дни",
            repeat_until: "Повторять до",
            repeat_in_hours: "Повторять в часы",
            repeat_slot: "Повторять срок",
          },
          StepBookingSettings: {
            already_used_stock: "(%{used_stock} уже продано)",
            nb_stock_useby_date_label: "Срок реализации",
            nb_dont_require_company_approval_label: "Предоставьте клиетам без подтверждения компании",
            slots_will_be_removed_warning:
              "Во время сохранения изменений, мы отключим и / или удалим все текущие сроки этого предложения, если такие существуют.",
            form_title: "Параметры бронирования",
            static_date_booking_label: "У предложения есть бронирование срока?",
            global_settings: "Глобальные параметры",
            default_settings: "Параметры по умолчанию",
            hint: {
              p1: "Выберите, имеет ли ваше предложение бронирование сроков в календаре, или это предложение без бронирования, например ваучера для использования на определенных условиях.",
              p2: "Лимит доступности / продажи по умолчанию ",
              p3: "Это будет значение по умолчанию для каждого нового срока, добавленного в календаре. Оно является общим лимитом продажи для предложения, в случае предложений без бронирожания.",
              p4: "Настройки бронирования по умолчанию ",
              p5: "Решите, принимаете ли Вы срочные заказы, которые не требуют вашего подтверждения, или предпочитаете иметь полный контроль над заказами и будете подтверждать отдельно каждый заказ.\n",
              p6: "Срок реализации",
              p7: "В случае ваучера вы можете также установить промежуток дат, в котором он может быть использован.",
            },
            enable_frontend_slots_listing_label: "Покаяывать клиентом список сроков вместо календаря",
            expire_at_label: "Срок истечения",
            availability_limit_label: "Ограничение срока доступности предложения к покупке / скачивания через клиента.",
          },
          StepCustomerFields: {
            customer_fields: "Форма заказчика",
            participant_fields: "Форма для участников",
            hint: {
              p1: "Поля формы бронирования",
              p2: "Выберите поля, которые будет показаны клиентом во время размещения заказа. Для каждого поля вы можете определить, должно ли оно быть обязательно заполнено, и хотите ли вы, чтобы включит это поле в список участников.",
            },
          },
          ProductVariantMigrateModal: {
            copy_description_label: "Описание",
            copy_pricelist_label: "Цены",
            copy_payments_label: "Платежи",
            copy_booking_settings_label: "Параметры бронирования",
            copy_pickup_points_label: "Места встречи",
            copy_priced_fields_label: "Дополнительные параметры",
            copy_customer_fields_label: "Поля для заполнения ",
            copy_description_hint:
              "Перезаписаны будут все дополнительные атрибуты из закладки «Описание» для выбранного целевого варианта.",
            copy_pricelist_hint:
              "Перезаписаны будут все дополнительные атрибуты из закладки «Цены» для выбранного целевого варианта.",
            copy_payments_hint:
              "Перезаписаны будут все дополнительные атрибуты из закладки «Платежи» для выбранного целевого варианта.",
            copy_booking_settings_hint:
              "Перезаписаны будут все дополнительные атрибуты из закладки «Параметры бронирования» для выбранного целевого варианта.",
            copy_pickup_points_hint:
              "Перезаписаны будут все дополнительные атрибуты из закладки «Места встречи» для выбранного целевого варианта, а также значение «Спросить отдельно каждого участника о месте встречи» в данном предложении.",
            copy_priced_fields_hint: "Перезаписаны будут все «Дополнительные опции» для выбранного целевого варианта.",
            copy_customer_fields_hint:
              "Перезаписаны будут всеПерезаписаны будут все дополнительные атрибуты из закладки «Поля для заполнения» для выбранного целевого варианта. «Поля для заполнения» для выбранного целевого варианта.",
            title: "Копировать атрибуты из другого предложения / варианта",
            source_variant: "Вариант источника",
            target_variant: "Целевой вариант",
            copy_label: "Копировать",
            submit: "Копировать данные",
          },
          StepDescription: {
            remove_variant: "Удалить вариант",
            migrate_data_from_other_product: "Копировать данные из другого предложения / варианта",
            new_variant_default_name: "Вариант %{index}",
            add_variant_message:
              "Если у вашего предложения различные версии, которые можно установить с помощью дополнительных опций, вы можете %{link}",
            add_variant_message_link: "добавить следующий вариант предложения.",
            hint: {
              p1: "Название предложения",
              p2: "Ясно определите название вашего предложения, чтобы оно было сразу понятным клиенту.",
              p3: "Oсновные моменты",
              p4: "Что самое главное в вашем предложении? Поощрите ваших клиентов!",
              p5: "Описание",
              p6: "Точно и четко опишите ваше предложение - чем более точно вы это сделаете, тем меньше сомнений и вопрос��в будет у клиентов и они быстрее смогут сделать заказ. Используйте заголовки и стайлинг текста для выделения важнейших аспектов. Если у вас есть клиенты из разных стран, добавьте больше языковых версий предложения.",
              p7: "В цену включено / В цену не включено",
              p8: "Опишите, что включено в цену предложения, а за что надо заплатить дополнительно и каковы цены.",
              p9: "Условия",
              p10: "Добавьте особые условия, которые должны выполнить клиенты для участия в предложении.",
              p11: "Подсказки по путешествию",
              p12: "Добавьте советы для клиентов, которые помогут им хорошо подготовиться к участию в вашим предложении.",
              p13: "Варианты предложения",
              p14: "Если в вашем проедложении схожие путевки, которые отличаются друг от друга только небольшими элементами, вы можете создать вариант одного и того же путешествия. Кроме того, вы можете скопировать настройки из других заранее подготовленных предложений или вариантов.",
            },
          },
          StepLocation: {
            main_location_label: "Главная локализация",
            other_locations_label: "Конкретная локализация",
            new_pickup_point_title: "Новое место встречи",
            edit_pickup_point_title: "Редактировать место встречи",
            remove_pickup_point: "Удалить место встречи",
            add_new_pickup_point: "Добавить место встречи",
            locations_title: "Локализация предложения",
            pickup_points_title: "Места встреч",
            pickup_point_assignation_per_person_label: "Спросить отдельно каждого участника о месте встречи",
            additional_settings: "Остальные параметры",
            hint: {
              p1: "Локализации предложения",
              p2: "Установить основную локалозацию вашего предложения и дополнительные места связанные с ним.\n",
              p3: "Вы уже создали карту на Google maps? Вставьте код, чтобы показать ее в предложении.",
              p4: "Места встреч",
              p5: "Добавить место встречи, определяя адрес, возможное время отезда и возврата, а также дополнительную плату. Вы можете добавить инструкции и исправить положение кнопки на карте, чтобы помочь клиенту добраться в определенное место.",
              p6: "Определите - клиент должен выбрать одно место встречи для целого заказа или каждый участник может указать свое место встречи. ",
              p7: "Клиент не всегда в состоянии указать место встречи во время бронирования. Определите позволяете ли вы клиентам давать ответ «Я пока не знаю».",
              p8: "Если вы предлагаете возможность приезда к клиенту, он должен будет подать место.",
              p9: "Подсказки по преизду",
              p10: "Вы можете указат' здесь инструкции как доехать к вашей локализации или например доступ к зоне клиента.",
            },
            pickup_points_price_per_person_label: "Рассчитывать оплату за проезд от каждого участника отдельно",
            custom_pickup_point_name: "Забрать из гостиницы",
            no_pickup_point_name: "Неопределенное место",
          },
          StepPayments: {
            supplier_profiles_title: "Укажите профили, которые будут доступные для ваших клиентов",
            marketplace_profiles_title: "Укажите профили, которые будут доступные для клиентов Tripsomnia",
            add_new_payment_profile: "Добавить новый профиль",
            form_title: "Профили платежей  ",
            hint: {
              p1: "Профили платежей",
              p2: "Определите как клиенты могут заплатить за ваше предложение. Установите количество и сумму рассрочек, способ оплаты, а также условия отмены. ",
              p3: "Выберите профили для ваших клиентов из уже созданных или создайте новые. ",
              p4: "Выберите профили для клиентов Tripsomnia из существующих или свяжитесь с нами, чтобы определить другие условия сотрудничества.",
            },
            no_supplier_profiles_warning:
              "Советуем включить как минимум один профиль платежа в этом канале для Вашего предложения. В противном случае клиенты Вашей веб-страницы не смогут выполнить заказ на предложение.",
            no_marketplace_profiles_warning:
              "Советуем включить как минимум один профиль платежа в этом канале для Вашего предложения. В противном случае клиенты SocialTravel.pl не смогут выполнить заказ на предложение.",
            access_temporarily_enabled_only_for_supplier:
              "Предпросмотр доступных способов платежа для этого заказа пока что доступен только поставщику. Обратитесь к своему поставщику, чтобы получить информацию о способах платежа.",
          },
          StepPhotos: {
            cover_photo: "Фото обложки ",
            name_placeholder: "Введите название",
            form_title: "Добавьте фотографии, чтобы сделать предложение более привлекательным",
            click_or_drag_and_drop_to_add_photos:
              "Нажмите или перетащите файлы в поле, чтобы добавить фото / фотографии.",
            add_video: "или добавьте видео (YouTube/Vimeo)",
            add_video_submit: "Добавить",
            hint: {
              p1: "Добавьте интересные фотографии, которые убедят клиентов, чтобы воспользоваться именно вашим предложением. Вы можете подписать каждую фотографию и прикрепить ссылку на видео. Все материалы можете разместить в любом порядке путем перетаскивания их миниатюр.\n",
              p2: "Помните, чтобы пользоваться только материалами, на которые у вас есть авторские права или которые доступны на открытой лицензии для повторного использования в коммерческих целях.",
            },
          },
          StepPricedFields: {
            form_title: "Дополнительные параметры",
            add_new_field: "Новая дополнительная опция",
            hint: {
              p1: "Настройка дополнительных параметров для клиентов",
              p2a: "Флажок (Checkbox)",
              p2b: "Клиент выбирает опцию «да» или «нет».",
              p3a: "Список выбора",
              p3b: "Клиент выбирает одну позицию из списка.",
              p4a: "Количество",
              p4b: "Клиент выбирает количество из указанного диапазона.",
              p5: "Определите - вопрос должен быть задан один раз для всего заказа или по отдельности для каждого участника.",
              p6: "Список участников",
              p7: "Решите, будет ли это поле учтено на списоке участников.",
              p8: "Требуется заполнить",
              p9: "Решите, должен ли клиент заполнить поле, чтобы сделать запрос",
            },
          },
          StepPricelist: {
            form_title: "Цены",
            hint: {
              p1: "Вы должны выбрать один из трех типов указания цен:",
              p2: "Цена за человека",
              p3: "Создайте стандартный прайс-лист для взрослых, детей, старших, определяя ограничения по возрасту. Вы также можете добавить прайс-лист для группы, семьи установляя ограничения участников или создать собственную категорию. Для каждой позиции прайс-листа можно установить минимальное и максимальное количество единиц для покупки (например, мин. 3 билета). Внимание: лимиты по количеству человек и лимиты по количеству единиц нельзя устанавливать одновременно.",
              p4: "Цена за пакетный тур",
              p5: "Вы можете предлогать пакетные туры для ограниченного числа участников, например катамаран для 1-4 людей.\n",
              p6: "Цена за заказ",
              p7: "Определите цену за заказ независимо от количества участников, например за прокат яхты.",
            },
            persons_count: "Человек",
            persons_count_from: "Людей из",
            age_from: "Возраст от",
            person_category_name: "Название категории",
            add_new_item: "Добавить пакет",
            item_name: "Название пакета",
            coupon_code_name: "Купонный код",
            new_coupon_code_name: "Новый купонных код",
            add_new_coupon: "Добавить новый купон",
            coupon_codes_title: "Купонные коды",
            coupon_codes_description:
              "Если вы хотите, чтобы мы высылали клиентам конкретные купонные коды, пожалуйста, укажите это коды ниже.",
            coupon_code_realisation_place_type_label: "Где можно реализовать код с купона?",
            coupon_codes_realisation_place_online_website:
              "на веб странице (напр. через корзины покупок в интернет магазинах)",
            coupon_codes_realisation_place_manually: "вручную (по телефону либо эл. почте)",
            coupon_codes_realisation_place_custom: "пользовательский",
            coupon_code_realisation_place_custom_description_placeholder:
              "Укажите, как и где можно реализовать код с купона",
            generate_coupon_codes: "Генерация случайных купонных кодов",
            saas_featured_price: "Цена на Вашей странице",
          },
          menu: {
            description: "Описание",
            add_locale: "Добавить / удалить язык",
            translate: "Перевести",
            translate_modal: {
              title: "Перевести предложение",
              explanation: "Чтобы перевести предложение, добавьте целевой язык в меню слева над кнопкой «Перевести» и сохраните изменения.",
              select_source_locale: "Выберите язык источника",
              select_locale: "Выбрать целевой язык",
              submit: "Перевести",
            },
            pricelist: "Расписание и цены",
            availability: "Доступность",
            prices: "Цены",
            payments: "Платежи",
            booking_settings: "Параметры бронирования",
            photos: "Фотографии",
            location: "Локализация и проезд",
            priced_fields: "Дополнительные параметры",
            customer_fields: "Поля для заполнения",
            additional_settings: "Параметры Tripsomnia",
            title: "Меню предложения",
            accommodation_settings: "Настройки ночлегов",
            integrations: ""
          },
          common: {
            remove_confirm_message: "Вы уверены, что хотите удалить это предложение?",
            orders_button: "Заказы",
            preview_st: "Предпросмотр",
            preview_saas: "веб-сайта",
            save_success_message: "Изменения в предложении сохранены. ",
            remove_success_message: "Предложение удалено.",
            add_photos_success_message: "Фотографии добавлены.",
          },
          StepAccommodationSettings: {
            form_title: "Настройки ночлегов",
            accommodation_settings: {
              category: "Тип жилого помещения",
              categoryOption: {
                one_person_room: "Одноместный номер",
                two_person_room: "Двухместный номер",
                three_person_room: "Трехместный номер",
                four_person_room: "Четырехместный номер",
                multi_person_room: "Общей номер",
                bed_in_multi_person_room: "Кровать в общем номере",
                apartment: "Апартамент",
                cottage: "Домик",
                villa: "Вилла",
                holiday_house: "Дом отдыха",
                tent: "Палатка",
              },
              categoryTitle: {
                room: "Комнаты/Салоны",
                bathroom: "Ванная комната",
                view: "Вид",
                food_and_drinks: "Питание",
              },
              categoryDescription:
                "Выберите, к какому типу жилья относится предложение, а затем определите, сколько единиц / единиц будет доступно для продажи по умолчанию каждый день, Вы будете иметь возможность изменить это значение позже для выбранных дат в соответствии с Вашими потребностями.",
            },
            default_total_stock_limit: "Количество доступных единиц по умолчанию",
            accommodation_detail: {
              single_beds_count: "Количество односпальных кроватей",
              double_beds_count: "Количество двуспальных кроватей",
              extra_beds_count: "Количество дополнительных кроватей",
              bathrooms_count: "Количество санузлов",
              rooms_count: "Кол-во комнат/спален",
              area: "Площадь",
            },
            presented_price: 'Указание цены "од"',
            accommodationUnitSettings: "Настройки жилой единицы",
            facilities: "Удобства",
            accommodationUnitSettingsDescription:
              "Введите количество односпальных, двуспальных кроватей и возможных дополнительных кроватей. Эта информация определит, сколько человек может остаться на ночь в одной единице выбранного типа проживания. Затем введите цену, которая будет базовой ценой, представленной Вашим клиентам. Сообщите клиенту о количестве ванных комнат, комнат/спален и площади, которые относятся к одной единице выбранного типа проживания. Эта информация появится на стороне предложения.",
            facilitiesDescription: "Отметьте, какие удобства Ваши гости могут ожидать от проживания в этом типе жилья.",
          },
          StepIntegrations: {
            log_integration_date: "",
            log_integration_action: "",
            log_integration_company_id: "",
            log_integration_uuid: "",
            filter_all_logs: "",
            filter_succeeded: "",
            filter_all_failed: ""
          }
        },
        ManageLocalesPrompt: {
          title: "Языковые версии предложения",
          select_locale: "Выбрать язык",
        },
        NewProductPrompt: {
          title: "Новое предложение",
          name_placeholder: "Введите название предложения",
          submit: "Создайте предложение",
          coupon_label: "Это купонное предложение",
          offer_type_header: "Выберите тип предложения",
          offer_type_standard_header: "Стандарт",
          offer_type_standard_description:
            "Предложение с резервированием термина - однодневные экскурсии, факультативные экскурсии и другое.",
          offer_type_coupon_header: "Скидка",
          offer_type_coupon_description:
            "Простое предложение скидки - без бронирования даты, может содержать сгенерированный код скидки.",
          offer_type_ticket_header: "Билет",
          offer_type_ticket_description: "Тип предложения предназначен для аттракционов, парков развлечений, музеев.",
          offer_type_voucher_header: "Ваучер",
          offer_type_voucher_description:
            "Купоны и безвозвратные ваучеры, которые клиент покупает ранее, а использует в будущем.",
          offer_type_accommodation_header: "Проживание",
          offer_type_accommodation_description:
            "Предложение с ценником за ночь. Для предложений гостиниц, пансионатов и т.п.",
        },
        ProductsListView: {
          products: "Предложения",
          settings: "Параметры",
          add_new_product: "Новое предложение",
          no_products_message: "Еще не было создано ни одно предложение.",
          no_products_message_link: "Добавьте ваше первое предложение!",
          no_products_title: "Нет предложений.",
          search_top_bar: "Поиск предложений, локаций, организаторов",
        },
        StepAdditional: {
          hide_description_for_variants: "Скрыть варианты предложения кроме первого.",
        },
      },
      reviews: {
        ReviewsListView: {
          no_records_message: "Ни один из ваших клиентов не оставил Вам отзыва. ",
          no_records_title: "Нет отзывов",
          title: "Отзывы",
        },
        EditReviewModal: {
          title: "Отзыв",
          remove_confirm_message: "Вы уверены, что хотите удалить этот отзыв?",
        },
      },
      affiliate: {
        AffiliateListView: {
          no_records_message: "У Вас нет еще заказов.",
          no_records_title: "Нет заказов. ",
          summary_row: "Всего (для рядов %{start}-%{end}):",
          title: "Аффилиатская программа - статистики заказа",
        },
      },
      suppliers: {
        NewSupplierPrompt: {
          email_label: "Введите адрес электронной почты организатора",
        },
      },
      pagination: {
        show_10: "Показать 10",
        show_20: "Показать 20",
        show_30: "Показать 30",
        show_50: "Показать 50",
        show_100: "Показать 100",
      },
      accommodation: {
        AccommodationSchedulerView: {
          title: "Введите изменения в ценах и наличие предложений проживания",
          calendarLink: "Показать календарь",
          noProductsInfo: "Чтобы использовать этот параметр, у вас должно быть хотя бы одно предложение.",
          availabilityTypes: {
            available_with_instant_booking: "Мгновенное бронирование",
            available_with_company_approval: "Резервирование по запросу",
            no_changes: "Без изменений",
          },
          productsHeader: "Предложения / типы номеров",
          pricingPlansHeader: "Тарифные планы",
          availabilityTypeHeader: "Режим резервации",
          datesHeader: "Выберите даты, чтобы внести изменения",
          hintHeader: "",
          hintContent: "",
          errors: {
            maxDatesDifference: "Диапазон не может быть больше, чем %{maxDatesDifference} дней.",
            daysNotIncluded: "Диапазон дат не включает в себя выбранные дни.",
          },
          totalStockLimit: "",
        },
        AccommodationCalendarView: {
          title: "Календарь цен и наличия жилья",
          schedulerLink: "Установите цены",
        },
        Accommodation: {
          totalStockLeftTypes: {
            noChanges: "",
            unavailable: "",
            specified: "",
          },
        },
      },
    },
    st: {
      pricelist_order_installment_item: {
        paid_by_cash: "наличными",
        paid_by_online_payment: "онлайн",
        paid_by_bank_wire: "на банковский счет",
        already_paid: "Вплачено %{paid_by}",
        to_be_paid_right_now: "К оплате",
        to_be_paid_right_after_company_approval: "К оплате после подтверждения партнера.",
        to_be_paid_on_spot: "К оплате %{paid_by} на месте ",
        to_be_paid_until: "К оплате %{paid_by} до %{date}",
        to_be_paid_after_previous_installment:
          "После последнего взноса на оплату %{paid_by} установлен срок до %{date}",
        to_be_paid_now: "К оплате %{paid_by} на данный момент",
        to_be_paid_after_order_creation: "После заказа на оплату %{paid_by} установлен срок до %{date}",
        to_be_paid_after_company_approval:
          "После подтверждения компанией заказа на оплату %{paid_by} установлен срок до %{date}",
        to_be_paid_after_approval: "После подтверждения заказа на оплату %{paid_by} установлен срок до %{date}",
        to_be_paid_before_stock_start_date: "Перед началом предложения на оплату %{paid_by} установлен срок до %{date}",
        in_your_currency_it_is: "В вашей валюте это приблизительно ",
        payment_accepted_in_website_currency: "Валюта платежа",
        payment_accepted_in_company_currency: "Валюта платежа",
        payments_are_converted_with_following_rates: "Оплаты рассчитываются на основе следующих курсов:",
        your_bank_can_issue_an_additional_fee_for_the_transaction:
          "Ваш банк может взимать дополнительную плату за операции в иностранной валюте.",
        to_supplier: "Доставщику",
        to_agent: "Агенту",
        to_socialtravel: "Tripsomnia",
        paid_by_dotpay: "через DotPay",
        paid_by_paypal: "через PayPal",
        marketplace_bank_wire_transfer_title: "Tripsomnia Заказ № %{order_id}",
        saas_bank_wire_transfer_title: "Заказ № %{order_id}",
        bank_wire_transfer_details:
          'Если Вы уже сделали платеж, вам не нужно ничего делать. Если нет, тогда мы предоставляем Вам данные для перевода: %{account_description}. Название перевода: "%{transfer_title}"',
        paid_by_payu: "через PayU",
        paid_by_stripe: "через Stripe",
        paid_by_terminal: "через терминал",
      },
      app_config: {
        saas_service_fee_name: "Плата за транзакцию",
        site_short_description:
          "Забронируйте онлайн местные экскурсии и туристические достопримечательности со всего мира! Эксркусии, Достопримечательности в 1 месте. Самые лучшие туристические предложения.",
        pdf_voucher_st_address_details: "ИНН: 1132941467; ul. Grodzka 42/1, 31-044 Cracow, Poland",
        tripsomnia_company_name: "Tripsomnia\n",
        tripsomnia_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_full_address:
          "Платформа бронированья экскурсий Tripsomnia (Компания SocialTravel)\nИНН: 1132941467 \nАл. Князя Юзефа Понятовского, 1\n03-901 Варшава, Польша",
        tripsomnia_service_fee_name: "Плата за услуги",
        agent_service_fee_name: "Плата за услуги агента",
        socialtravel_company_name: "SocialTravel",
        socialtravel_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_opening_hours: "Понедельник - Пятница 9:00 - 17:00, Суббота - Воскресенье 11:00 - 17:00",
        socialtravel_service_fee_name: "Плата за услуги SocialTravel.pl",
        socialtravel_contact_phone_number: "+48 690 670 581",
        tripsomnia_contact_phone_number: "+48 690 670 581",
      },
      create_agent_disbursement: {
        no_orders_error: "Не выбрано ни одного заказа.",
        no_order_agent_error: "К одному из выбранных заказов не приписан агент.",
        incorrect_order_company_error: "Все заказы должны иметь поставщиков и агентов.",
      },
    },
    countries: {
      pl: "Польша",
    },
    customer_mailer: {
      order_marketing_info: {
        subject: "",
      },
      reset_password: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
    },
    product_request_mailer: {
      customer_requested_discount_company_email: {
        hello_company: "Привет, %{company_name}!",
        content: {
          line1: "Популярность вашего профиля на платформе Tripsomnia растет!",
          line2:
            "Наши клиенты заинтересованы в вашей продукции. Ниже вы найдете запрос клиента, отправленный в ответ на визитку вашей компании на нашем портале.",
          line3:
            "Щелкните ссылку и заполните форму или свяжитесь с нами по адресу kontakt@socialtravel.pl, чтобы получить контроль над профилем вашей компании. Вы можете узнать больше о том, кто мы и чем занимаемся, на нашем веб-сайте: pobierzkupon.socialtravel.pl.",
        },
        details_header: "",
        customer_details_header: "Сообщение от клиента",
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "Спрашивать у клиентов о предложении из портала Tripsomnia",
      },
      customer_requested_discount: {
        content: {
          line1: "",
        },
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "",
      },
      customer_requested_product: {
        subject: "",
      },
      customer_requested_product_company_email: {
        content: {
          line1: "",
          line2: "",
          line3: "",
        },
        customer_details_header: "",
        details_header_html: '<a href="%{product_link}">%{product_name}</a>',
        hello_company: "",
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "Спрашивать у клиентов о предложении из портала Tripsomnia",
      },
    },
    pl: {
      papp: {
        settings: {
          StripeSettingsView: {
            stripe_login_button: "Войти в Stripe",
            stripe_register_button: "Регистрация в Stripe",
          },
        },
      },
    },
    ordered_item: {
      accommodation: {
        name: {
          one: "",
          few: "",
          many: "",
          other: "",
        },
      },
      product: {
        name: "",
      },
    },
    en: {
      activerecord: {
        attributes: {
          pricing_plan: {
            preset: {
              elastic: {
                company_description: "",
                customer_description: "",
              },
              not_refundable: {
                company_description: "",
                customer_description: "",
              },
            },
          },
        },
      },
    },
  })),
  (I18n.translations.it = I18n.extend(I18n.translations.it || {}, {
    active_admin: {
      action_impossible: "",
      action_success: "",
      actual_at_x: "",
      add_tag_batch_action: {
        add_success: "",
        remove_instead: "",
        remove_success: "",
      },
      basic_details: "",
      batch_actions: {
        button_label: "",
        labels: {
          add_category: "",
          add_location: "",
          add_product_st_tag: "",
          add_tag: "",
          v1_st_balance_company_debt: "",
          add_admin_user: "",
          add_payment_profile: "",
          remove_payment_profile: "",
        },
      },
      company_edit: {
        possible_to_edit_only_by_global_admin: "",
      },
      company_registrations: {
        approve: "",
        reject: "",
      },
      company_submit_monthly_invoicing_stats: {
        success: "",
      },
      content_details: "",
      dashboard: "",
      dashboard_page: {
        approved_orders: {
          title: "",
        },
        search_orders: {
          submit: "",
          title: "",
        },
        summary: {
          title: "",
        },
        upcoming_orders: {
          title: "",
        },
        waiting_for_company_approval_orders: {
          title: "",
        },
        waiting_for_customer_approval_orders: {
          title: "",
        },
      },
      default_menu: {
        add_new: "",
        new_admin_company: "",
        new_admin_product_tag: "",
        new_admin_product_tags_category: "",
        others: "",
        users: "",
      },
      delete_file: "",
      devise: {
        email: {
          title: "",
        },
        links: {
          resend_unlock_instructions: "",
        },
        password: {
          title: "",
        },
        reset_password: {
          submit: "",
        },
        unlock: {
          submit: "",
          title: "",
        },
      },
      globalize: {
        language: {
          pl: "",
          en: "",
          ru: "",
        },
        translations: "",
      },
      go_back: "",
      monthly_invoicing_stats: "",
      order_actions: {
        action_failed_error: "",
        approve: "",
        cancel: "",
        confirm: "",
        finish: "",
        redeliver_customer_order_email: "",
        reject: "",
        successfully_approved: "",
        successfully_cancelled: "",
        successfully_confirmed: "",
        successfully_finished: "",
        successfully_redelivered_customer_order_email: "",
        successfully_rejected: "",
        view_stats: "",
        redeliver_supplier_order_email: "",
        successfully_redelivered_supplier_order_email: "",
      },
      order_edit: {
        order_not_yet_confirmed_error: "",
      },
      order_show: {
        activities: {
          email_message_email: "",
          email_message_subject: "",
          order_status_updated_action: "",
          order_status_updated_content: "",
          sms_message_content: "",
          sms_message_phone_number: "",
          title: "",
        },
      },
      order_show_company_invoice: {
        invoice_retrieval_error: "",
      },
      order_show_customer_invoice: {
        invoice_retrieval_error: "",
      },
      order_v1_st_balance_company_debt: {
        success: "",
      },
      orders_stats: {
        average_orders_value_th: "",
        in_average_th: "",
        in_total_th: "",
        name_th: "",
        orders_count_th: "",
        title: "",
        total_orders_value_th: "",
      },
      orders_v1_st_balance_company_debt: {
        success: "",
      },
      preview: "",
      product_tags_index: {
        tag_stats: "",
      },
      products_index: {
        batch_action_add_product_tag: {
          add_success: "",
          remove_instead: "",
          remove_success: "",
        },
      },
      scopes: {
        abandoned: "",
        all: "",
        approved: "",
        approved_finished_short: "",
        building: "",
        cancelled: "",
        category: "",
        company_tag: "",
        customer_tag: "",
        deprecated_v1_accomodation: "",
        deprecated_v1_coupon: "",
        deprecated_v1_special_offer: "",
        deprecated_v1_trip: "",
        finished: "",
        future_customers: "",
        location: "",
        lost_customers: "",
        marketplace: "",
        order_tag: "",
        past_customers: "",
        product_st_tag: "",
        prospect_customers: "",
        rejected: "",
        saas: "",
        waiting_for_company_approval: "",
        waiting_for_customer_approval: "",
        product_company_tag: "",
      },
      search_status: {
        current_filters: "",
        current_scope: "",
        headline: "",
        no_current_filters: "",
      },
      sidebars: {
        relation_no_results: "",
      },
      successfully_created: "",
      successfully_updated: "",
      tabs: {
        availability: "",
        base_details: "",
        description: "",
        images: "",
        invoicing: "",
        location: "",
        other_details: "",
        pricelists: "",
        product_order_fields: "",
        product_variants: "",
      },
      widgets: "",
      wrong_lock_version_error: "",
      location_details: "",
      companies: {
        destroy: {
          action_impossible_company_has_orders_as_supplier: "",
        },
      },
      pp_edit: "",
      add_admin_user_batch_action: {
        remove_instead: "",
        success: "",
      },
      add_payment_profile_action: {
        success: "",
      },
      pricing_plans: {
        new_elastic_plan: "",
        new_not_refundable_plan: "",
      },
      remove_payment_profile_action: {
        success: "",
      },
    },
    fe: {
      active_admin: {
        view_collection_item_nested_form: {
          toggle_show: "",
        },
      },
      ckeditor: {
        subsection_expand: {
          content: "",
          title: "",
        },
        subsection_read_more: {
          content: "",
          title: "",
        },
      },
      NewOrderCalendarForm: {
        help_tip: "",
        product_chosen: "",
        stock_available: "",
        stock_available_but_impossible_as_end: "",
        stock_available_but_impossible_as_start: "",
        stock_busy: "",
        stock_discounted: "",
        submit: "",
        previous_slots: "",
        next_slots: "",
        stock_confirmed: "",
      },
      NewOrderConfirmPricingForm: {
        submit: "",
      },
      NewOrderCustomerDetailsForm: {
        order_with_payment_requirement: "",
        participant_name_with_number: "",
        phone_number_help: "",
        required_fields: "",
        submit: {
          make_order: "",
          next: "",
        },
      },
      NewOrderPaymentForm: {
        almost_booked: "",
        almost_finished: "",
        cancelled_if_not_paid: "",
        dotpay_go_back_button: "",
        order_with_payment_requirement: "",
        pay_to_book: {
          marketplace: "",
          saas: "",
        },
        pay_to_finish: "",
        payment_deadline: "",
        please_pay_online_deposit: "",
        safe_payments_guaranteed_by: "",
        submit: {
          book_and_pay: "",
          pay: "",
          pay_with_dotpay: "",
          pay_with_paypal: "",
        },
        choose_payment_method: "",
        pay_by_bank_wire: "",
        pay_by_credit_card: "",
        by_bank_wire: "",
        by_credit_card: "",
        by_bank_wire_or_credit_card: "",
        by_paypal: "",
        pay_by_credit_card_or_paypal: "",
        by_payu: "",
        payu_button: "",
      },
      NewOrderProductForm: {
        choose_payment_profile: "",
        items_count: "",
        multiple_pricings_alert: "",
        multiple_pricings_info: "",
        custom_location_name_placeholder: "",
        submit: "",
      },
      NewOrderView: {
        building: "",
        built: "",
        contact_us_if_problem_repeats: "",
        loading_failed: "",
        loading_in_progress: "",
        marketplace: {
          additional_bank_wire_deposit_required: "",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it: "",
          bank_wire_deposit_deadline_warning: "",
          bank_wire_deposit_details: "",
          bank_wire_deposit_instructions: "",
          building: "",
          built: "",
          company_approved_your_order_request: "",
          company_received_your_order_request_and_has_to_approve_it: "",
          contact_us_if_problem_repeats: "",
          customer_full_name: "",
          download_order_data_confirmation: "",
          further_details: "",
          if_no_online_payment_your_order_will_be_cancelled: "",
          loading_failed: "",
          loading_in_progress: "",
          order_is_waiting_for_company_approval: "",
          order_name: "",
          order_status: "",
          please_pay_bank_wire_deposit: "",
          repeat_payment: "",
          share_us_to_friends: "",
          thank_you_for_order: "",
          thank_you_for_order_and_share_to_fb: "",
          thank_you_for_order_request: "",
          we_received_all_required_order_informations: "",
          we_received_all_required_order_informations_and_online_payment: "",
          we_sended_order_confirmation_to_your_email: "",
          we_sended_order_request_confirmation_to_your_email: "",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit: "",
          when_company_approves_we_will_send_online_payment_email: "",
          when_company_approves_we_will_send_order_confirmation: "",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it: "",
          when_payment_gets_approved_we_will_send_order_confirmation: "",
          you_can_download_order_data_confirmation_using_button_below_as_well: "",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation: "",
          your_order_id: "",
          your_order_is_fully_confirmed: "",
          online_payment_failed: "",
          order_is_waiting_for_online_payment_info: "",
        },
        order_name: "",
        saas: {
          additional_bank_wire_deposit_required: "",
          after_payment_had_been_approved_company_received_your_order_request_and_has_to_approve_it: "",
          bank_wire_deposit_deadline_warning: "",
          bank_wire_deposit_details: "",
          bank_wire_deposit_instructions: "",
          company_approved_your_order_request: "",
          company_received_your_order_request_and_has_to_approve_it: "",
          customer_full_name: "",
          download_order_data_confirmation: "",
          further_details: "",
          if_no_online_payment_your_order_will_be_cancelled: "",
          order_is_waiting_for_company_approval: "",
          order_status: "",
          please_pay_bank_wire_deposit: "",
          repeat_payment: "",
          thank_you_for_order: "",
          thank_you_for_order_request: "",
          we_received_all_required_order_informations: "",
          we_received_all_required_order_informations_and_online_payment: "",
          we_sended_order_confirmation_to_your_email: "",
          we_sended_order_request_confirmation_to_your_email: "",
          when_company_approves_ok_when_company_rejects_we_will_refund_your_online_deposit: "",
          when_company_approves_we_will_send_online_payment_email: "",
          when_company_approves_we_will_send_order_confirmation: "",
          when_payment_gets_approved_company_will_receive_your_order_request_and_has_to_approve_it: "",
          when_payment_gets_approved_we_will_send_order_confirmation: "",
          you_can_download_order_data_confirmation_using_button_below_as_well: "",
          you_will_find_bank_wire_deposit_infos_in_order_confirmation: "",
          your_order_id: "",
          your_order_is_fully_confirmed: "",
          online_payment_failed: "",
          order_is_waiting_for_online_payment_info: "",
        },
        step_number: "",
        title: "",
        show_on_map: "",
        marketplace_booking_unavailable_message_html: "",
        saas_booking_unavailable_message_html: "",
        open_chat: "",
        choose_date_step_title: "",
        fill_order_step_title: "",
        confirm_payment_details_step_title: "",
        fill_customer_details_step_title: "",
        make_online_payment_step_title: "",
        order_is_waiting_for_your_approval: "",
        click_below_to_approve: "",
        reject_order: "",
        approve_order: "",
        approve_order_failed: "",
        order_is_finished: "",
        we_havent_received_your_review_yet: "",
        write_a_review: "",
      },
      navbar_search: {
        products_count: "",
        categories: "",
        suppliers: "",
        products: "",
        search_nearby: "",
        search_query: "",
      },
      new_order: {
        errors: {
          connection_error_during_saving: "",
          insufficient_product_quantity: "",
          max_quantity_limit: "",
          missing_value: "",
          personal_data_agreement_missing: "",
          product_not_found: "",
          product_schedule_slot_missing: "",
          product_variant_not_found: "",
          rules_agreement_missing: "",
          online_payment_impossible_for_selected_parameters: "",
          partners_agreement_missing: "",
          rodo_agreement_missing: "",
        },
        marketplace_service_fee_tooltip: "",
        saas_service_fee_tooltip: "",
        v1_bank_wire_deposit_tooltip: {
          marketplace: "",
          saas: "",
        },
        v1_online_deposit_tooltip: {
          marketplace: {
            line1: "",
            line2: "",
            line3: "",
          },
          saas: {
            line1: "",
            line2: "",
            line3: "",
          },
        },
        confirmation_installment_st_name: {
          deposit: "",
          fee: "",
          prepayment: "",
        },
        v1_rest_deposit_tooltip: {
          on_the_arrival: "",
          on_the_spot: "",
          trip: "",
        },
      },
      order: {
        confirmation_installment_after_company_approval: "",
        new_order_name: "",
        order_name: "",
        v1_online_deposit_now: "",
        stock_useby_time_range: {
          between: "",
          from: "",
          to: "",
        },
      },
      order_details: {
        bank_wire_deposit_account_description: "",
        company_details: "",
        customer_details: "",
        extra_paid_amount: "",
        marketplace_service_fee: "",
        order_details: "",
        order_name: "",
        overpaid_total_amount: "",
        paid_amount: "",
        product_details: "",
        refunded_amount: "",
        remaining_total_amount: "",
        remaining_total_amount_short: "",
        saas_service_fee: "",
        total_amount: "",
        total_amount_short: "",
        to_be_paid_total_amount: "",
        coupon_offer_price: "",
        coupon_offer_price_before_discount: "",
        coupon_discount_amount: "",
        coupon_code_realisation_place_online_website_description: "",
        coupon_code_realisation_place_manual_description: "",
        ends_at: "",
        starts_at: "",
      },
      personal_data_agreement: {
        label: "",
        tooltip: "",
      },
      pricelist_expiration_countdown: {
        discount_ends_today: "",
        discount_ends_tomorrow: "",
        product_about_to_finish: "",
        product_finished: "",
        x_days_left_to_end_of_discount: {
          one: "",
          other: "",
        },
        x_left_to_end_of_discount: "",
      },
      products_map: {
        buy_product: "",
      },
      reservation_calendar: {
        only_x_in_this_price: "",
        per_night: "",
        valid_on: "",
        last_stocks: "",
      },
      rules_agreement: {
        marketplace: {
          label: "",
          link: "",
        },
        saas: {
          label: "",
          link: "",
        },
      },
      sidebar_section_order: {
        order_details: "",
        title: "",
      },
      sidebar_section_product: {
        extend: "",
        product_details: "",
      },
      common: {
        site_title: "",
        loading_failed_message: "",
        click_to_load_again: "",
        loading_message: "",
        show_more: "",
        next_page: "",
        previous_page: "",
        zendesk_livechat_window_title: "",
        zendesk_livechat_concierge_name: "",
        zendesk_livechat_concierge_title: "",
        close: "",
      },
      ProductsCalendarWidget: {
        site_title: "",
      },
      ReviewsListWidget: {
        no_reviews_yet: "",
        add_first_review: "",
        add_new_review: "",
        total_count: {
          one: "",
          other: "",
        },
        average_rating: "",
        rating: "",
      },
      PaymentMethodsHelper: {
        cash_tooltip: "",
        online_tooltip: "",
        online_plus_cash_tooltip: "",
      },
      products_listing: {
        medium_priority: "",
        high_priority: "",
      },
      bslanding: {
        about_us_contact_form: {
          loading_message: "",
          success_message: "",
          failure_message: "",
        },
        for_companies_contact_form: {
          loading_message: "",
          success_message: "",
          failure_message: "",
        },
      },
      CouponsWidget: {
        title: "",
        discount_amount: "",
        until_product_offer_ends: "",
        only_x_coupons_left: "",
        stock_useby_date_range: "",
        order_price: "",
        order_price_before_discount: "",
        order_discount_amount: "",
        build_order_button: "",
        build_order_failed: "",
        confirm_order_button: "",
        confirm_order_failed: "",
        form_title: "",
        confirm_order_succeded: "",
        product_short_description: "",
        product_description: "",
        product_variant_short_description: "",
        product_customer_requirements: "",
        extend_infos: "",
        get_coupon: "",
        hint_title: "",
        hint_content: "",
        less_than_x_coupons_left: "",
        no_results_alert: "",
      },
      partners_agreement: {
        label: "",
        tooltip: "",
      },
      rodo_agreement: {
        label: "",
        tooltip: "",
      },
      tripsomnia_contact_email: "",
      tripsomnia_contact_phone_number: "",
    },
    ransack: {
      predicates: {
        eq: "",
      },
    },
    api: {
      base: {
        unauthorized: "",
        company_inactive: "",
        disabled: "",
        secret_invalid: "",
      },
    },
    activerecord: {
      attributes: {
        admin_user: {
          companies: "",
          companies_ids: "",
          company_admin: "",
          company_employee: "",
          editor_admin: "",
          global_admin: "",
          main_admin: "",
          default_new_company_role: "",
        },
        agent_cooperation: {
          fixed_gross_pricing: "",
          fixed_net_pricing: "",
          pricing_type: "",
          realtime_pricing: "",
          st_fixed_gross_pricing: "",
          st_fixed_net_pricing: "",
          st_realtime_pricing: "",
        },
        company: {
          accepts_printed_customer_vouchers: "",
          admin_users: "",
          admin_users_ids: "",
          contact_email: "",
          contact_email_placeholder: "",
          contact_facebook_url: "",
          contact_facebook_url_placeholder: "",
          contact_full_address: "",
          contact_full_address_placeholder: "",
          contact_languages: "",
          contact_languages_placeholder: "",
          contact_opening_hours: "",
          contact_opening_hours_placeholder: "",
          contact_phone_number: "",
          contact_phone_number_placeholder: "",
          contact_website_url: "",
          contact_website_url_placeholder: "",
          default_product_price_currency: "",
          general_terms: "",
          general_terms_placeholder: "",
          invoice_city: "",
          invoice_company_name: "",
          invoice_country_name: "",
          invoice_data: "",
          invoice_email: "",
          invoice_nip: "",
          invoice_phone_number: "",
          invoice_postal_code: "",
          invoice_street_address: "",
          locale: "",
          logo_image: "",
          marketplace_cover_image: "",
          marketplace_meta_description: "",
          marketplace_meta_title: "",
          marketplace_name: "",
          marketplace_short_description: "",
          marketplace_short_description_placeholder: "",
          name: "",
          name_placeholder: "",
          notifications_email: "",
          notifications_phone_number: "",
          public_name: "",
          saas_cover_image: "",
          saas_meta_description: "",
          saas_meta_title: "",
          saas_name: "",
          saas_short_description: "",
          saas_short_description_placeholder: "",
          saas_subdomain: "",
          active: "",
          default_products_enable_frontend_slots_listing: "",
          enable_saas: "",
          enable_marketplace: "",
          affiliate_commision_calculation_type: "",
          agent_earnings_percentage: "",
          total_base_amount_percentage: "",
        },
        company_member: {
          company_admin: "",
          company_employee: "",
          editor_admin: "",
          global_admin: "",
          main_admin: "",
        },
        customer: {
          display_name: "",
          full_name: "",
          full_name_contains: "",
          future: "",
          lost: "",
          orders_company_id: "",
          orders_product_id: "",
          orders_product_name: "",
          orders_product_product_tags_id: "",
          orders_product_variant_id: "",
          orders_status: "",
          origin: "",
          past: "",
          prospect: "",
        },
        installment: {
          confirmation_after_company_approval: "",
          confirmation_before_company_approval: "",
          remaining_amount: "",
          whole_amount: "",
        },
        order: {
          additional_information: "",
          confirmed_at: "",
          customer_display_name: "",
          manual: "",
          marketplace: "",
          product_additional_pickup_instructions: "",
          product_customer_hints: "",
          product_customer_requirements: "",
          product_excluded_items: "",
          product_included_items: "",
          product_price_currency: "",
          saas: "",
          status_short: {
            waiting_for_company_approval: "",
            waiting_for_customer_approval: "",
          },
          stock_useby_ends_at: "",
          stock_useby_starts_at: "",
          automatic: "",
          source: "",
          pickup_point: "",
          agent_disbursement_status: "",
          uncleared: "",
          cleared: "",
          coupon_code_name: "",
          author_place_cwa: "",
          author_place_frontend: "",
          author_place_partner: "",
        },
        order_customer_participant: {
          display_name: "",
        },
        order_installment: {
          amount_hint: "",
          confirmation_installment_hint: "",
          paid_after_company_approval_hint: "",
          paid_by_at_hint: "",
          paid_by_time_duration_hint: "",
          remaining_amount: "",
          remaining_amount_hint: "",
          account_description: "",
        },
        order_item: {
          base_item: "",
          item_type: "",
          marketplace_service_fee: "",
          name: "",
          order_summary: "",
          payment_profile_service_fee: "",
          product_coupon: "",
          product_custom: "",
          product_item: "",
          product_option: "",
          product_refund: "",
          quantity: "",
          saas_service_fee: "",
          service_fee: "",
          unit_price: "",
        },
        order_status_history: {
          abandon: "",
          auto_refund_issued: "",
          build: "",
          company_approval_time_limit_exceeded: "",
          company_approve: "",
          company_cancel: "",
          company_reject: "",
          confirm: "",
          confirmation_online_payment_time_limit_exceeded: "",
          customer_approval_time_limit_exceeded: "",
          customer_approve: "",
          expire: "",
          finish: "",
          finish_online_payment: "",
          manual_status_change: "",
          pause: "",
        },
        order_transfer: {
          agent: "",
          bank_wire: "",
          cash: "",
          custom: "",
          customer: "",
          dotpay: "",
          online_payment: "",
          receiver: "",
          sender: "",
          socialtravel: "",
          source_payload: "",
          source_type: "",
          transfer_type: "",
          transferred_at: "",
          refund_type: "",
          refunded_at: "",
          from_customer_frontend_name: "",
          to_customer_frontend_name: "",
          customer_to_supplier_backend_name: "",
          customer_to_agent_backend_name: "",
          customer_to_socialtravel_backend_name: "",
          company_to_customer_backend_name: "",
          company_to_agent_backend_name: "",
          company_to_socialtravel_backend_name: "",
          agent_to_customer_backend_name: "",
          agent_to_supplier_backend_name: "",
          agent_to_socialtravel_backend_name: "",
          socialtravel_to_customer_backend_name: "",
          socialtravel_to_agent_backend_name: "",
          socialtravel_to_supplier_backend_name: "",
          supplier_to_agent_backend_name: "",
          supplier_to_customer_backend_name: "",
          supplier_to_socialtravel_backend_name: "",
        },
        payment_profile: {
          additional_fee: "",
          additional_fee_name: "",
          additional_fee_percentage: "",
          companies: "",
          companies_ids: "",
          default_additional_fee_name: "",
          has_additional_fee: "",
          marketplace: "",
          saas: "",
          additional_fee_as_agent_fee: "",
        },
        payment_profile_installment: {
          amount: "",
          amount_percentage: "",
          increase_amount_by_marketplace_commision: "",
          increase_amount_by_marketplace_service_fee: "",
          account_description: "",
        },
        payment_profile_product_attachment: {
          date_limit_type: "",
          date_limit_type_label: "",
          days_before_arrival_date_limit: "",
          max_days_before_arrival: "",
          min_days_before_arrival: "",
          no_date_limit: "",
        },
        pricing: {
          absolute_amount: "",
          absolute_amount_cents: "",
          absolute_percentage: "",
          relative_amount: "",
          relative_amount_cents: "",
          relative_percentage: "",
        },
        product: {
          categories: "",
          product_company_tags: "",
          active: "",
          included_items_placeholder: "",
          excluded_items_placeholder: "",
          customer_requirements_placeholder: "",
          customer_hints_placeholder: "",
          highlights_placeholder: "",
          categories_placeholder: "",
          enable_frontend_slots_listing: "",
          coupon_code_realisation_place_type: "",
          coupon_code_realisation_place_custom_description: "",
        },
        product_option: {
          all_product_variants: "",
          required: "",
        },
        product_integration: {
          auto_update_description: "auto update description",
          auto_update_images: "auto update photos",
          auto_update_prices: "auto update price",
          auto_update_calendar: "auto update calendar"
        },
        product_order_field: {
          "ProductOrderField::BigText": "",
          "ProductOrderField::Boolean": "",
          "ProductOrderField::Date": "",
          "ProductOrderField::Email": "",
          "ProductOrderField::Geopoint": "",
          "ProductOrderField::List": "",
          "ProductOrderField::Number": "",
          "ProductOrderField::PhoneNumber": "",
          "ProductOrderField::Text": "",
          assignation_per_person_label: "",
          assignation_type: "",
          customer_hint: "",
          customer_hint_placeholder: "",
          list_options: "",
          max_value: "",
          min_value: "",
          multiply_price_by_nights_count: "",
          order_value_required: "",
          presets: {
            customer_email: {
              frontend_name: "",
              name: "",
            },
            customer_full_name: {
              frontend_name: "",
              name: "",
            },
            customer_note: {
              customer_hint: "",
              frontend_name: "",
              name: "",
            },
            customer_phone_number: {
              customer_hint: "",
              frontend_name: "",
              name: "",
            },
            participant_birth_date: {
              frontend_name: "",
              name: "",
            },
            participant_email: {
              frontend_name: "",
              name: "",
            },
            participant_full_name: {
              frontend_name: "",
              name: "",
            },
            participant_phone_number: {
              frontend_name: "",
              name: "",
            },
            customer_city: {
              frontend_name: "",
              name: "",
            },
            customer_postal_code: {
              frontend_name: "",
              name: "",
            },
            customer_country: {
              frontend_name: "",
              name: "",
            },
            customer_hotel_name: {
              name: "",
              customer_hint: "",
            },
            customer_dates_of_stay: {
              name: "",
            },
          },
          price_included_in_order_base_amount: "",
          price_none: "",
          price_type: "",
          product_variants: "",
          product_variants_assignation_all: "",
          product_variants_assignation_some: "",
          product_variants_assignation_type: "",
          product_variants_ids: "",
          show_on_manifest: "",
          type: "",
          "ProductOrderField::PickupPoint": "",
          undefined_pickup_point_option_name: "",
          custom_pickup_point_option_name: "",
          custom_pickup_point_display_name: "",
          "ProductOrderField::Country": "",
          custom_field: "",
        },
        product_pricelist_item: {
          preset_fixed: "",
          preset_id: "",
          preset_item: "",
          preset_person_adult: "",
          preset_person_child: "",
          preset_person_custom: "",
          preset_person_everyone: "",
          preset_person_group_1_plus_2: "",
          preset_person_group_1_plus_3: "",
          preset_person_group_2_plus_1: "",
          preset_person_group_2_plus_2: "",
          preset_person_group_2_plus_3: "",
          preset_person_group_custom: "",
          preset_person_group_double: "",
          preset_person_group_family_of_3: "",
          preset_person_group_family_of_4: "",
          preset_person_group_family_of_5: "",
          preset_person_group_quad: "",
          preset_person_group_single: "",
          preset_person_group_triple: "",
          preset_person_infant: "",
          preset_person_normal: "",
          preset_person_reduced: "",
          preset_person_senior: "",
          preset_person_student: "",
          preset_person_teenager: "",
          price_type: "",
        },
        product_schedule_slot: {
          availability_type: "",
          available_with_company_approval: "",
          available_with_instant_booking: "",
          date: "",
          datetime: "",
          total_stock_left: "",
          total_stock_limit: "",
          total_stock_used: "",
          active: "",
          available_with_instant_booking_help: "",
          available_with_company_approval_help: "",
          confirmed: "",
        },
        product_tag: {
          category: "",
          location: "",
          parent: "",
          product_st_tag: "",
          product_company_tag: "",
          show_on_fe_listing: "",
          show_on_fe_product_page: "",
          fe_color: "",
        },
        product_variant: {
          additional_pickup_instructions: "",
          allow_custom_pickup_point: "",
          allow_no_pickup_point: "",
          custom_pickup_point_additional_fee: "",
          default: "",
          default_requires_company_approval: "",
          default_total_stock_limit: "",
          nb_requires_company_approval: "",
          nb_stock_useby_days_limit: "",
          nb_stock_useby_ends_at: "",
          nb_stock_useby_starts_at: "",
          nb_total_stock_left: "",
          nb_total_stock_limit: "",
          nb_total_stock_used: "",
          pickup_points_assignation_type: "",
          pricelist_by_item: "",
          pricelist_by_order: "",
          pricelist_by_person: "",
          pricelist_type: "",
          additional_pickup_instructions_placeholder: "",
          coupon_discount_amount: "",
          coupon_discount_percentage: "",
          coupon_offer_price_before_discount: "",
          coupon_offer_price: "",
        },
        view_collection_item: {
          related_model: "",
        },
        view_section: {
          name: "",
          show_name: "",
          type: "",
          types: {
            "ViewSection::CompanyProducts": "",
            "ViewSection::CustomCollection": "",
            "ViewSection::CustomContent": "",
            "ViewSection::CustomCover": "",
            "ViewSection::ProductTagChildren": "",
            "ViewSection::ProductTagProducts": "",
            "ViewSection::ProductTagsCategoryProducts": "",
            "ViewSection::ProductTagsCategoryTags": "",
            "ViewSection::ViewedProducts": "",
            "ViewSection::SimilarToViewedProducts": "",
            "ViewSection::ViewedProductsTags": "",
          },
          view_collection_items_limit: "",
          view_mode: "",
          view_modes: {
            cards_listing: "",
            cards_slider: "",
            extended_cards_listing: "",
            items_carousel: "",
            products_map: "",
            wide_cards_slider: "",
            wide_cards_listing: "",
          },
          with_similar_items: "",
        },
        activity: {
          customer_email_sent_title: "",
          customer_email_sent_content: "",
          customer_sms_sent_title: "",
          customer_sms_sent_content: "",
          order_status_updated_content: "",
          review_created_title: "",
          review_created_content: "",
          customer_to_supplier_order_transfer_created_title: "",
          customer_to_agent_order_transfer_created_title: "",
          customer_to_socialtravel_order_transfer_created_title: "",
          company_to_customer_order_transfer_created_title: "",
          company_to_agent_order_transfer_created_title: "",
          company_to_socialtravel_order_transfer_created_title: "",
          agent_to_customer_order_transfer_created_title: "",
          agent_to_supplier_order_transfer_created_title: "",
          agent_to_socialtravel_order_transfer_created_title: "",
          socialtravel_to_customer_order_transfer_created_title: "",
          socialtravel_to_agent_order_transfer_created_title: "",
          socialtravel_to_supplier_order_transfer_created_title: "",
          supplier_email_sent_content: "",
          supplier_email_sent_title: "",
          supplier_sms_sent_content: "",
          supplier_sms_sent_title: "",
          customer_sms_send_failed_content: "",
          customer_sms_send_failed_title: "",
          supplier_sms_send_failed_content: "",
          supplier_sms_send_failed_title: "",
          payment_issued_title: "",
          payment_in_progress_title: "",
          payment_completed_title: "",
          payment_failed_title: "",
          refund_issued_title: "",
          refund_in_progress_title: "",
          refund_completed_title: "",
          refund_failed_title: "",
          sms_send_failed_content: "",
          sms_send_failed_title: "",
          sms_sent_content: "",
          sms_sent_title: "",
          supplier_to_agent_order_transfer_created_title: "",
          supplier_to_customer_order_transfer_created_title: "",
          supplier_to_socialtravel_order_transfer_created_title: "",
        },
        product_pickup_point: {
          additional_instructions_placeholder: "",
        },
        review: {
          single: "",
          couple: "",
          friends: "",
          family: "",
          age_group: "",
          group_type: "",
          author_name: "",
          author_email: "",
          content: "",
          rating: "",
          st_feedback: "",
          st_rating: "",
          rating_1: "",
          rating_2: "",
          rating_3: "",
          rating_4: "",
          rating_5: "",
          st_rating_1: "",
          st_rating_2: "",
          st_rating_3: "",
          st_rating_4: "",
          st_rating_5: "",
          verified: "",
          "18-24": "",
          "25-30": "",
          "31-40": "",
          "41-60": "",
          "60+": "",
          anonymous: "",
        },
        coupon_code: {
          total_stock_left: "",
          total_stock_limit: "",
          total_stock_used: "",
        },
        product_variant_additional_detail: {
          category: {
            one_person_room: "",
            two_person_room: "",
            three_person_room: "",
            four_person_room: "",
            multi_person_room: "",
            bed_in_multi_person_room: "",
            apartment: "",
            cottage: "",
            villa: "",
            holiday_house: "",
            tent: "",
          },
        },
        product_types: {
          voucher: "",
          accommodation: "",
          coupon: "",
          standard: "",
          ticket: "",
        },
        pricing_plan: {
          preset: {
            elastic: {
              name: "",
              company_description: "",
              customer_description: "",
            },
            not_refundable: {
              name: "",
              company_description: "",
              customer_description: "",
            },
          },
        },
        pricing_plan_types: {
          not_refundable: "",
          elastic: "",
        },
      },
      errors: {
        models: {
          order: {
            inactive_product: "",
            missing_order_customer_participants_data: "",
            too_high_product_quantity: "",
            customer_display_name_missing: "",
            too_low_product_quantity: "",
            agent_has_disabled_saas: "",
            supplier_has_disabled_saas: "",
            supplier_has_disabled_marketplace: "",
            supplier_saas_subdomain_required: "",
            agent_saas_subdomain_required: "",
            confirmation_installment_impossible: "",
            stock_useby_date_passed: "",
            product_expired: "",
          },
          order_item: {
            wrong_price_currency: "",
          },
          product: {
            must_be_empty_when_product_has_no_booking: "",
            product_variant_with_percentage_amounts_defined: "",
            product_pricelist_items_missing: "",
          },
          product_order_field: {
            pricing_disallowed_for_this_type: "",
          },
          product_tag: {
            parent_must_have_the_same_type: "",
            parent_cant_be_self: "",
            parent_cant_be_its_child: "",
          },
        },
      },
      models: {
        admin_user: {
          one: "",
          other: "",
        },
        attachment: {
          one: "",
          other: "",
        },
        company: {
          one: "",
          other: "",
        },
        customer: {
          one: "",
          other: "",
        },
        list_option: {
          one: "",
          other: "",
        },
        order: {
          one: "",
          other: "",
        },
        order_installment: {
          one: "",
          other: "",
        },
        order_item: {
          one: "",
          other: "",
        },
        order_transfer: {
          one: "",
          other: "",
        },
        payment_profile: {
          one: "",
          other: "",
        },
        payment_profile_installment: {
          one: "",
          other: "",
        },
        payment_profile_product_attachment: {
          one: "",
          other: "",
        },
        pricing: {
          one: "",
          other: "",
        },
        product: {
          one: "",
          other: "",
        },
        product_option: {
          one: "",
          other: "",
        },
        product_option_value: {
          one: "",
          other: "",
        },
        product_order_field: {
          one: "",
          other: "",
        },
        product_pricelist_item: {
          one: "",
          other: "",
        },
        product_schedule: {
          one: "",
          other: "",
        },
        product_tag: {
          one: "",
          other: "",
        },
        product_tags_category: {
          one: "",
          other: "",
        },
        product_variant: {
          one: "",
          other: "",
        },
        tag: {
          one: "",
          other: "",
        },
        view_collection_item: {
          one: "",
          other: "",
        },
        view_page: {
          one: "",
          other: "",
        },
        view_section: {
          one: "",
          other: "",
        },
        company_registration: {
          one: "",
          other: "",
        },
      },
    },
    attributes: {
      abandoned: "",
      accomodation: "",
      action: "",
      active: "",
      additional_fee: "",
      additional_instructions: "",
      address: "",
      admin_user: "",
      agent: "",
      agent_commision: "",
      agent_commision_amount: "",
      agent_commision_amount_cents: "",
      agent_commision_percent: "",
      agent_note: "",
      all_day_event: "",
      all_products: "",
      all_tagged_products: "",
      amount: "",
      amount_cents: "",
      amount_percentage: "",
      amount_type: "",
      api_version: "",
      approved: "",
      arrival_time: "",
      assignation_per_item: "",
      assignation_per_order: "",
      assignation_per_person: "",
      attachments: "",
      balance: "",
      balance_status: "",
      balance_status_for_today: "",
      bank_wire: "",
      bank_wire_account_description: "",
      bank_wire_account_description_hint: "",
      birth_date: "",
      booking_type: "",
      boolean_value_type: "",
      build: "",
      building: "",
      cancellation_policy: "",
      cancelled: "",
      cash: "",
      categories: "",
      change_status: "",
      companies_count: "",
      company: "",
      company_approval_time_limit: "",
      company_approval_time_limit_exceeded: "",
      company_approval_time_limit_in_hours: "",
      company_approve: "",
      company_automatic_invoice_amount: "",
      company_automatic_invoice_date: "",
      company_cancel: "",
      company_given_amount_through_online_deposit: "",
      company_invoice_id: "",
      company_name: "",
      company_over_received_amount_through_online_deposit: "",
      company_received_amount_through_online_deposit: "",
      company_reject: "",
      company_remaining_invoice_amount: "",
      company_tag: "",
      company_total_invoice_amount: "",
      confirm: "",
      confirmation_installment: "",
      confirmation_installment_after_company_approval: "",
      confirmation_installment_after_company_approval_hint: "",
      confirmation_installment_after_company_approval_time_limit: "",
      confirmation_online_payment_time_limit_exceeded: "",
      country: "",
      coupon: "",
      coupon_price: "",
      created_at: "",
      currency: "",
      current_password: "",
      current_sign_in_at: "",
      current_sign_in_ip: "",
      customer: "",
      customer_approval_time_limit: "",
      customer_approval_time_limit_exceeded: "",
      customer_approval_time_limit_in_hours: "",
      customer_automatic_invoice_amount: "",
      customer_email: "",
      customer_full_name: "",
      customer_full_name_contains: "",
      customer_hints: "",
      customer_invoice_id: "",
      customer_invoiced_amount: "",
      customer_locale: "",
      customer_note: "",
      customer_phone_number: "",
      customer_remaining_invoice_amount: "",
      customer_requirements: "",
      customer_rules_agreement: "",
      customer_tag: "",
      customer_total_invoice_amount: "",
      customers_count: "",
      dates: "",
      datetime: "",
      days_count: "",
      default_marketplace_commision_amount: "",
      default_marketplace_commision_percentage: "",
      default_marketplace_service_fee_amount: "",
      default_marketplace_service_fee_percentage: "",
      default_saas_commision_amount: "",
      default_saas_commision_percentage: "",
      departure_time: "",
      deprecated_v1_bank_wire_company_deposit: "",
      deprecated_v1_bank_wire_socialtravel_deposit: "",
      deprecated_v1_excludes_content: "",
      deprecated_v1_includes_content: "",
      deprecated_v1_location_alternative_map_content: "",
      deprecated_v1_requirements_content: "",
      description: "",
      discount: "",
      discount_amount: "",
      discount_amount_cents: "",
      discounted: "",
      draft: "",
      email: "",
      end_date: "",
      end_time: "",
      ends_at: "",
      exact_amount: "",
      exact_date: "",
      excluded_items: "",
      expire: "",
      expired: "",
      expired_at: "",
      expires_at: "",
      featured_price: "",
      featured_price_before_discount: "",
      file: "",
      finish: "",
      finish_online_payment: "",
      finished: "",
      first_name: "",
      fluid_date_booking: "",
      frontend_name: "",
      frontend_view: "",
      full_name: "",
      full_person_name: "",
      fully_paid: "",
      global_role: "",
      highlights: "",
      id: "",
      inactive: "",
      included_items: "",
      includes_time: "",
      increase_orders_amount_by_saas_commision: "",
      installments: "",
      internal_note: "",
      invoice_date: "",
      issuer: "",
      last_sign_in_at: "",
      last_sign_in_ip: "",
      last_status_action: "",
      locale: "",
      location: "",
      location_coordinates: "",
      location_lat: "",
      location_lng: "",
      location_name: "",
      locations: "",
      logo_image: "",
      main_company: "",
      main_image: "",
      marketplace: "",
      marketplace_commision: "",
      marketplace_commision_amount: "",
      marketplace_commision_amount_cents: "",
      marketplace_commision_percent: "",
      marketplace_featured_price: "",
      marketplace_featured_price_before_discount: "",
      marketplace_service_fee: "",
      marketplace_service_fee_amount: "",
      marketplace_service_fee_amount_cents: "",
      marketplace_service_fee_percent: "",
      max_days_count: "",
      max_nights_count: "",
      max_number_value: "",
      max_order_stock_count: "",
      max_person_age: "",
      max_persons_count: "",
      meta_description: "",
      meta_title: "",
      min_days_count: "",
      min_nights_count: "",
      min_order_stock_count: "",
      min_person_age: "",
      min_persons_count: "",
      name: "",
      nb_stock_useby_date: "",
      nb_stock_useby_days_limit: "",
      nb_stock_useby_ends_at: "",
      nb_stock_useby_starts_at: "",
      new_status: "",
      nights_count: "",
      no_booking: "",
      note: "",
      number_value_multiplies_price: "",
      number_value_type: "",
      offers_count: "",
      on_stock_starts_at: "",
      online_payment: "",
      order: "",
      order_bill: "",
      order_customer_participants: "",
      order_items: "",
      order_tag: "",
      order_transfers: "",
      ordered_product_order_fields: "",
      ordered_product_pricelist_items: "",
      orders: "",
      orders_count: "",
      orders_marketplace_commision_amount_sum: "",
      orders_total_amount_sum: "",
      overpaid: "",
      paid_after_company_approval: "",
      paid_amount: "",
      paid_amount_sum: "",
      paid_before_company_approval: "",
      paid_by_at: "",
      paid_by_at_formatted: {
        on_stock_starts_at: "",
        x_days_after_order_company_approval: "",
        x_days_after_order_creation: "",
        x_days_after_order_full_approval: "",
        x_days_after_previous_installment: "",
        x_days_before_stock_starts_at: "",
        immediately: "",
      },
      paid_by_time_duration: "",
      paid_by_type: "",
      parent: "",
      partly_paid: "",
      password: "",
      password_confirmation: "",
      pause: "",
      payment: "",
      payment_completed: "",
      payment_failed: "",
      payment_in_progress: "",
      payment_operations: "",
      payment_profile: "",
      payment_status: "",
      payment_type: "",
      payment_type_offline: "Offline",
      payment_type_online: "Online",
      payments: "",
      pdf_voucher: "",
      pending: "",
      per_group: "",
      per_item: "",
      per_order: "",
      per_person: "",
      per_product: "",
      percentage_amount: "",
      persons_count: "",
      phone_number: "",
      position: "",
      price: "",
      price_currency: "",
      price_per_group: "",
      price_per_item: "",
      price_per_night: "",
      price_per_order: "",
      price_per_person: "",
      price_per_person_night: "",
      price_per_product: "",
      price_type: "",
      pricing_per_night: "",
      pricing_per_person: "",
      pricing_per_person_night: "",
      pricing_per_product: "",
      priority: "",
      product: "",
      product_highlights: "",
      product_images: "",
      product_name: "",
      product_option_values: "",
      product_options: "",
      product_or_variant: "",
      product_order_fields: "",
      product_pricelist: "",
      product_pricelist_item: "",
      product_pricelist_order_target: "",
      product_product_tags_id: "",
      product_quantity: "",
      product_short_description: "",
      product_st_tags: "",
      product_tag: "",
      product_tags: "",
      product_tags_category: "",
      product_tags_id: "",
      product_tags_relation_type: "",
      product_unit_name: {
        coupon: {
          one: "",
          other: "",
        },
        person: {
          one: "",
          other: "",
        },
        product: {
          one: "",
          other: "",
        },
        room: {
          one: "",
          other: "",
        },
      },
      product_variant: "",
      product_variant_name: "",
      product_variant_order_target: "",
      product_variants_count: "",
      products_count: "",
      products_have_all_tags: "",
      products_have_one_tag: "",
      published: "",
      published_at: "",
      refund: "",
      refund_completed: "",
      refund_failed: "",
      refund_in_progress: "",
      refund_new: "",
      refund_none: "",
      refund_status: "",
      refunded: "",
      refunded_amount: "",
      refunded_amount_sum: "",
      rejected: "",
      related_model: "",
      remaining_amount: "",
      remaining_total_amount: "",
      remaining_total_amount_sum: "",
      requires_company_approval: "",
      role: "",
      saas: "",
      saas_featured_price: "",
      saas_featured_price_before_discount: "",
      saas_service_fee: "",
      select_value_type: "",
      service_fee: "",
      short_description: "",
      show_page_title: "",
      sign_in_count: "",
      slug: "",
      slug_hint: "",
      special_offer: "",
      st_note: "",
      start_date: "",
      start_dates: "",
      start_time: "",
      start_times: "",
      starts_at: "",
      static_date_booking: "",
      status: "",
      stock_end_date: "",
      stock_end_datetime: "",
      stock_ends_at: "",
      stock_start_date: "",
      stock_start_datetime: "",
      stock_starts_at: "",
      stock_time_range: "",
      stock_useby_time_range: "",
      supplier: "",
      supplier_note: "",
      tag: "",
      tagged_products: "",
      tags: "",
      time_duration: "",
      time_zone: "",
      time_zone_name: "",
      title: "",
      total_amount: "",
      total_amount_sum: "",
      total_base_amount: "",
      total_discount: "",
      total_discount_amount: "",
      total_price: "",
      total_product_options_price: "",
      total_product_price: "",
      total_product_price_before_discount: "",
      total_stock_left: "",
      total_stock_limit: "",
      total_stock_used: "",
      transfer_type: "",
      translations: "",
      translations_name: "",
      trip: "",
      type: "",
      type_amount: "",
      type_percent: "",
      unpaid: "",
      updated_at: "",
      v1_bank_wire_deposit: "",
      v1_bank_wire_deposit_amount: "",
      v1_bank_wire_deposit_amount_cents: "",
      v1_bank_wire_deposit_deadline: "",
      v1_bank_wire_deposit_max_payment_date: "",
      v1_bank_wire_deposit_percent: "",
      v1_bank_wire_deposit_postorder_days_limit: "",
      v1_bank_wire_deposit_postorder_x_days: "",
      v1_bank_wire_deposit_prearrival_days_limit: "",
      v1_bank_wire_deposit_prearrival_x_days: "",
      v1_cash_deposit: "",
      v1_cash_deposit_amount: "",
      v1_cash_deposit_amount_cents: "",
      v1_full_bank_wire_deposit: "",
      v1_full_bank_wire_deposit_hint: "",
      v1_online_deposit: "",
      v1_online_deposit_percent: "",
      v1_online_deposit_st_type: {
        deposit: {
          b: "",
          d: "",
          m: "",
        },
        fee: {
          b: "",
          d: "",
          m: "",
        },
        prepayment: {
          b: "",
          d: "",
          m: "",
        },
      },
      v1_rest_deposit: "",
      v1_rest_deposit_amount: "",
      v1_rest_deposit_amount_cents: "",
      v1_st_company_debt_status: "",
      v1_st_company_debt_status_amount_to_give: "",
      v1_st_company_debt_status_amount_to_receive: "",
      v1_st_company_debt_status_short: "",
      v1_st_company_debt_status_zero_amount: "",
      v1_st_company_invoiced_amount: "",
      v1_st_company_manually_given_amount: "",
      v1_st_company_manually_received_amount: "",
      v1_st_remaining_given_amount: "",
      v1_st_remaining_received_amount: "",
      v1_st_total_given_amount: "",
      v1_st_total_over_received_amount: "",
      v1_st_total_received_amount: "",
      v2_pricing: "",
      v2_static_date_booking: "",
      value_type: "",
      variant: "",
      video_url: "",
      video_url_hint: "",
      view: "",
      view_sections: "",
      waiting_for_company_approval: "",
      waiting_for_confirmation_online_payment: "",
      waiting_for_customer_approval: "",
      website: "",
      website_url: "",
      week_days: "",
      x_days_after_order_company_approval: "",
      x_days_after_order_creation: "",
      x_days_after_order_full_approval: "",
      x_days_after_previous_installment: "",
      x_days_before_stock_starts_at: "",
      x_price_per_item: "",
      x_price_per_item_night: "",
      x_price_per_order: "",
      x_price_per_order_night: "",
      x_price_per_person: "",
      x_price_per_person_night: "",
      agent_service_fee: "",
      agent_service_fee_amount: "",
      agent_service_fee_amount_cents: "",
      agent_service_fee_percent: "",
      agent_paid_amount: "",
      agent_received_amount: "",
      agent_remaining_paid_amount: "",
      agent_remaining_received_amount: "",
      customer_paid_amount: "",
      customer_received_amount: "",
      customer_remaining_paid_amount: "",
      customer_remaining_received_amount: "",
      socialtravel_paid_amount: "",
      socialtravel_received_amount: "",
      socialtravel_remaining_paid_amount: "",
      socialtravel_remaining_received_amount: "",
      supplier_paid_amount: "",
      supplier_received_amount: "",
      supplier_remaining_paid_amount: "",
      supplier_remaining_received_amount: "",
      author_place: "",
      author_place_frontend: "",
      author_place_partnerapp: "",
      product_locations: "",
      product_pickup_points: "",
      customer_fields: "",
      priced_fields: "",
      product_id: "",
      product_variant_id: "",
      pricelist: "",
      payment_profiles: "",
      remove_location_coordinates: "",
      test_mode: "",
      saas_priority: "",
      marketplace_priority: "",
      created_on: "",
      updated_on: "",
      affiliate_commision: "",
      affiliate_commision_amount: "",
      affiliate: "",
      confirmation_installment_amount: "",
      bank_wire_account_description_placeholder: "",
      fully_refunded: "",
      over_refunded: "",
      partly_refunded: "",
      dotpay: "",
      paypal: "",
      agent_outcome: "",
      socialtravel_outcome: "",
      supplier_outcome: "",
      total_company_outcome: "",
      agent_disbursement: "",
      agent_disbursement_id: "",
      customer_invoice_amount: "",
      doesnt_require_company_approval: "",
      custom_online_payment: "",
      agent_bank_wire: "",
      supplier_bank_wire: "",
      agent_cash: "",
      supplier_cash: "",
      none: "",
      expire_at: "",
      publish_at: "",
      expire_from: "",
      stripe: "Stripe",
      author_place_customerapp: "",
      deprecated_v1_booking_type: "",
      deprecated_v1_location_address: "",
      deprecated_v1_location_description: "",
      deprecated_v1_location_full_address: "",
      deprecated_v1_location_full_address_hint_html: "",
      deprecated_v1_location_full_address_placeholder: "",
      deprecated_v1_order_target_type: "",
      deprecated_v1_pricing_type: "",
      deprecated_v1_product_type: "",
      price_show_cash_deposit_amount: "",
      price_show_coupon_price: "",
      price_show_discount_amount: "",
      price_show_discount_percent: "",
      price_show_marketplace_service_fee_amount: "",
      price_show_online_deposit_amount: "",
      price_show_price_per_person: "",
      price_show_total_amount: "",
      price_show_total_amount_with_cash_deposit: "",
      price_show_total_price: "",
      price_show_type: "",
      message: "",
      requested_date: "",
      seller: "",
      discount_percent: "",
      total_discount_amount_cents: "",
      total_price_cents: "",
      total_product_options_price_cents: "",
      total_product_price_before_discount_cents: "",
      total_product_price_cents: "",
      confirmation_installment_amount_cents: "",
      confirmation_installment_paid_amount: "",
      receptionist: "",
      available_to: "",
      available_from: "",
      product_type: "",
      pricing_plan_type: "",
    },
    errors: {
      messages: {
        already_exists: "",
        has_to_be_in_future: "",
        installment_not_supported: "",
        invalid_installments_position: "",
        invalid_online_payment_installments: "",
        invalid_participant_data: "",
        invalid_participant_product_option_value: "",
        invalid_phone_number_characters: "",
        invalid_product_option_value: "",
        invalid_video_url: "",
        missing_participant_product_option_value: "",
        missing_product_option_value: "",
        v1_invalid: "",
        v1_invalid_installments_transfer_type: "",
        invalid_participant_ordered_item: "",
        invalid_ordered_item_participants_count: "",
        empty: "",
        greater_than: "",
        too_short: "",
        greater_than_or_equal_to: "",
        less_than_or_equal_to: "",
        invalid: "",
      },
      action_impossible_error: {
        code: "",
        http_code: "",
        message: "",
      },
      record_not_found_error: {
        code: "",
        http_code: "",
        message: "",
      },
      wrong_product_order_field_error: {
        code: "",
        http_code: "",
        message: "",
      },
    },
    base: {
      choose: "",
      connection_error: "",
      date: {
        day: "",
        month: "",
        year: "",
      },
      discount: "",
      discount_coupon: "",
      every_each: "",
      extend: "",
      from: "",
      from_x: "",
      from_x_to_y: "",
      in_weekdays_xyz: "",
      loading: "",
      no: "",
      read_more: "",
      see_more: "",
      to: "",
      to_x: "",
      x_days: {
        one: "",
        other: "",
      },
      x_hours: {
        one: "",
        other: "",
      },
      x_minutes: {
        one: "",
        other: "",
      },
      x_nights: {
        one: "",
        other: "",
      },
      x_orders: {
        one: "",
        other: "",
      },
      x_persons: {
        one: "",
        other: "",
      },
      x_seconds: {
        one: "",
        other: "",
      },
      yes: "",
      x_years: {
        one: "",
        other: "",
      },
      choose_date: "",
      x_selected_records: {
        one: "",
        other: "",
      },
      since_x: "",
      since_x_until_y: "",
      until_x: "",
      for_x_days: {
        one: "",
        other: "",
      },
    },
    components: {
      view_sections: {
        title: {
          read_more: "",
        },
      },
    },
    date: {
      formats: {
        default: "",
        long: "",
        short: "",
        short2: "",
      },
    },
    helpers: {
      select: {
        no_results_message: "",
        prompt: "",
      },
    },
    languages: {
      en: "",
      pl: "",
      ru: "",
      bg: "",
      hr: "",
      cs: "",
      da: "",
      nl: "",
      et: "",
      fi: "",
      fr: "",
      de: "",
      el: "",
      hu: "",
      is: "",
      ga: "",
      it: "",
      lv: "",
      lt: "",
      lb: "",
      mk: "",
      mt: "",
      pt: "",
      ro: "",
      sr: "",
      sk: "",
      sl: "",
      es: "",
      sv: "",
      tr: "",
      uk: "",
      cy: "",
      ar: "",
      ca: "",
      he: "",
      th: "",
      vi: "",
    },
    number: {
      currency: {
        format: {
          format: "",
        },
      },
    },
    order_actions: {
      send_approved_order_has_paid_online_deposit_company_sms: {
        sms_content: {
          marketplace: "",
          saas: "",
        },
      },
      send_order_awaits_approval_company_sms: {
        sms_content: {
          marketplace: "",
          saas: "",
        },
      },
      send_order_has_been_approved_customer_sms: {
        sms_content: {
          after_company_approval: {
            marketplace: "",
            saas: "",
          },
          default: {
            marketplace: "",
            saas: "",
          },
        },
      },
      send_order_has_been_rejected_customer_sms: {
        sms_content: {
          marketplace: "",
          saas: "",
        },
      },
      send_order_has_been_cancelled_customer_sms: {
        sms_content: {
          marketplace: "",
          saas: "",
        },
      },
    },
    product_pricelist: {
      lowest_price_is_on: "",
      price_name: "",
      price_per_coupon: "",
      price_per_item: "",
      price_per_night: "",
      price_per_product: "",
      price_per_stay: "",
      price_per_tour: "",
      sold_out_already: "",
      x_coupons_left: {
        one: "",
        other: "",
      },
      x_stocks_left: "",
    },
    "social_travel/new_company_registration_form": {
      errors: {
        company_already_exists: "",
      },
    },
    time: {
      formats: {
        long: "",
        short: "",
        time: "",
        short2: "",
      },
    },
    view_collection_item_decorator: {
      offer_read_more: "",
      offers_read_more: "",
    },
    frontend: {
      companies: {
        show: {
          reviews_title: "",
          products_calendar: "",
          products: "",
          reviews: "",
          reviews_title_html: "",
        },
      },
      company_orders: {
        approve: {
          action_impossible: "",
          success: "",
        },
        finish: {
          action_impossible: "",
          success: "",
        },
        reject: {
          action_impossible: "",
          success: "",
          success_with_slot_deactivated: "",
        },
        show: {
          admin_app_info_html: "",
          approve_order: "",
          finish_order: "",
          order_name: "",
          order_status: "",
          reject_order: "",
        },
      },
      errors: {
        show: {
          general_error: "",
          general_error_hint_html: "",
          header: "",
          page_not_found: "",
          page_not_found_hint_html: "",
          title: "",
        },
      },
      orders: {
        confirm: {
          already_abandoned_error: "",
          already_confirmed_error: "",
        },
        new: {
          title: "",
        },
        show: {
          title: "",
        },
        update: {
          already_abandoned_error: "",
          already_confirmed_error: "",
        },
      },
      products: {
        show: {
          draft_notice: "",
          instead_of: "",
          location_address: "",
          location_tips: "",
          make_an_order: "",
          pay_on_the_spot: "",
          product_shown_in_different_locale_notice: "",
          product_unavailable: "",
          see_map: "",
          select_product_variant: "",
          similar_locations_title: "",
          similar_products_title: "",
          youre_saving: "",
          pickup_points: "",
          custom_pickup_point_possible: "",
          reviews_title: "",
          recently_viewed_products_title: "",
          recently_viewed_products_and_categories_title: "",
          other_locations: "",
          buy_product_cta_button: "",
          buy_coupon_cta_button: "",
          see_product_availability_cta_button: "",
          choose_coupon: "",
          offer_finished_cta_button: "",
          coupon_finished: "",
          product_finished: "",
          product_expires_at: "",
          product_expired_notice: "",
          product_expired: "",
          only_x_coupons_left: "",
          nb_stock_useby_date_range: "",
          no_coupons_left: "",
          less_than_x_coupons_left: "",
          quicknav: {
            description: "",
            includes: "",
            requirements: "",
            map: "",
            reviews: "",
          },
          reviews_title_html: "",
          not_available_notice: "",
        },
        search: {
          filter_query_title: "",
          toggle_filters: "",
          filter_query_placeholder: "",
          location_query_title: "",
          location_query_label: "",
          location_query_placeholder: "",
          date_query_title: "",
          categories_query_title: "",
          locations_query_title: "",
          locales_query_title: "",
          no_results_message: "",
          shown_results: "",
          previous_page: "",
          next_page: "",
          site_title: {
            around_location: "",
            with_category_and_location: "",
            with_category: "",
            with_location: "",
            default: "",
          },
        },
        history: {
          site_title: "",
          viewed_products_title: "",
          similar_to_viewed_products_title: "",
          viewed_products_tags_title: "",
        },
      },
      reviews: {
        new: {
          site_title: "",
          review_details_title: "",
          content_placeholder: "",
          rating_label: "",
          personal_details_title: "",
          locale_label: "",
          age_group_label: "",
          group_type_label: "",
          author_name_label: "",
          author_email_label: "",
          st_details_title: "",
          st_rating_label: "",
          st_feedback_placeholder: "",
          submit: "",
          add_success_message: "",
          error_message: "",
          review_for_given_order_already_exists: "",
          order_id: "",
          product: "",
          author_email_hint: "",
          add_review_title_about_product: "",
          add_review_title_about_company: "",
        },
      },
    },
    layouts: {
      application: {
        contact: {
          about_us: {
            title: "",
          },
          contact_us: {
            title: "",
          },
          cooperating_with: {
            dotpay_payments: "",
            title: "",
          },
          see_us_on_facebook: {
            title: "",
          },
          write_to_us: {
            title: "",
          },
          payment_gateways: {
            title: "",
            description: "",
          },
        },
        footer: {
          about_us: "",
          careers: "",
          cooperation: "",
          faq: "",
          help: "",
          privacy_policy: "",
          rules_note_html: "",
        },
        guaranteed: {
          read_more: "",
          s1: {
            line1: "",
            line2: "",
            title: "",
          },
          s2: {
            line1: "",
            line2: "",
            title: "",
          },
          s3: {
            currency: "",
            line1: "",
            title: "",
          },
          s4: {
            line1: "",
            title: "",
          },
          title: "",
        },
        navbar: {
          about_us: "",
          for_business: "",
          products_calendar: "",
          search_placeholder: "",
          products_history: "",
          contact: "",
          faq: "",
          open_chat: "",
          cart: "",
          finish_order: "",
          company_reviews: "",
        },
      },
      mailer: {
        greetings: "",
        marketplace: {
          footer_headline: "",
        },
        footer_phone: "",
        footer_email: "",
      },
    },
    pdfs: {
      order_voucher: {
        cancellation_policy: "",
        cancellation_policy_description: "",
        company_details: "",
        contact_email: "",
        contact_facebook_url: "",
        contact_full_address: "",
        contact_phone_number: "",
        contact_website_url: "",
        generated_date: "",
        got_any_questions: "",
        order_details: "",
        order_number: "",
        product_details: "",
        st_headline: "",
        title: "",
        wish_you_great_journey: "",
        your_order: "",
        footer_phone: "",
        footer_email: "",
        code: "",
      },
      slot_manifest: {
        customer_name_placeholder: "",
        generated_on: "",
        page_title: "",
      },
    },
    admin_user_mailer: {
      company_created_you_an_account: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
      company_invited_you_to_become_a_member: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
    },
    company_mailer: {
      agent_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
      company_and_user_created_agent_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
      company_created_and_agent_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
      company_registration_approved: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
      company_registration_approved_and_user_created: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
      company_registration_created: {
        action: "",
        greeting: "",
        instruction: "",
        subject: "",
      },
      customer_review_submitted: {
        greeting: "",
        new_review_has_been_submitted: "",
        action: "",
        subject: "",
      },
      company_and_user_created_supplier_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
      company_created_and_supplier_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
      supplier_invitation_received: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        subject: "",
      },
    },
    order_mailer: {
      base: {
        company_approve_order: "",
        company_finish_order: "",
        company_reject_order: "",
        company_see_order: "",
        customer_repeat_order: "",
        customer_see_all_offers: "",
        customer_see_nearby_offers: "",
        customer_see_offer: "",
        hello_company: "",
        hello_customer: "",
        order_status: "",
        company_reject_order_and_deactivate_slot: "",
      },
      company_order_footer: {
        line1_html: "",
        line2_html: "",
      },
      order_about_to_start_reminder_company_email: {
        p1_html: "",
        p2_html: "",
        subject: "",
      },
      order_about_to_start_reminder_customer_email: {
        marketplace: {
          p1_html: "",
          p2_html: "",
        },
        saas: {
          p1_html: "",
          p2_html: "",
        },
        subject: "",
      },
      order_company_approval_time_limit_exceeded_company_email: {
        line1: "",
        line2: "",
        subject: "",
        line1_html: "",
      },
      order_company_approval_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html: "",
          confirmation_installment_refund_info: "",
        },
        saas: {
          line1_html: "",
          confirmation_installment_refund_info: "",
        },
        subject: "",
      },
      order_current_status_customer_email: {
        marketplace: {
          p1: "",
        },
        saas: {
          p1: "",
        },
        subject: "",
      },
      order_finished_add_opinion_reminder_customer_email: {
        marketplace: {
          add_review: "",
          contact_us: "",
          share_your_opinion_html: "",
          thank_you_html: "",
        },
        saas: {
          add_review: "",
          contact_us: "",
          share_your_opinion_html: "",
          thank_you_html: "",
        },
        subject: "",
      },
      order_is_approved_company_email: {
        no_online_deposit_subject: "",
        online_deposit_after_company_approval_subject: "",
        online_deposit_before_company_approval_subject: "",
        online_deposit_paid: "",
        order_approved: "",
        order_cant_be_cancelled_now: "",
        order_infos_below: "",
        remember_to_set_order_as_finished: "",
        voucher: {
          line1_html: "",
          line2_html: "",
        },
      },
      order_is_approved_customer_email: {
        marketplace: {
          bank_wire_deposit_additional_info: "",
          bank_wire_deposit_deadline_html: "",
          bank_wire_deposit_make_html: "",
          bank_wire_deposit_required: "",
          order_approved_by_company: "",
          order_created: "",
          order_data_and_deposit_received: "",
          order_data_received: "",
          this_is_confirmation: "",
          order_approved_by_customer: "",
          voucher: {
            line1_html: "",
            line2_html: "",
          },
        },
        saas: {
          bank_wire_deposit_additional_info: "",
          bank_wire_deposit_deadline_html: "",
          bank_wire_deposit_make_html: "",
          bank_wire_deposit_required: "",
          order_approved_by_company: "",
          order_created: "",
          order_data_and_deposit_received: "",
          order_data_received: "",
          this_is_confirmation: "",
          order_approved_by_customer: "",
          voucher: {
            line1_html: "",
            line2_html: "",
          },
        },
        subject: "",
      },
      order_is_waiting_for_company_approval_company_email: {
        confirmation_deadline_warning: "",
        future_online_deposit_info: "",
        order_received: "",
        past_online_deposit_info: "",
        please_confirm: "",
        subject: "",
        order_approved_by_customer: "",
        voucher: {
          line1_html: "",
          line2_html: "",
        },
      },
      order_is_waiting_for_company_approval_customer_email: {
        marketplace: {
          company_approval_deadline: "",
          order_is_waiting_for_company_approval: "",
          thank_you_for_order: "",
          thank_you_for_order_and_online_deposit: "",
          what_with_future_deposit_if_order_gets_approved_l1: "",
          what_with_future_deposit_if_order_gets_approved_l2: "",
          what_with_no_deposit_if_order_gets_approved: "",
          what_with_paid_deposit_if_order_gets_approved: "",
          thank_you_for_order_approval: "",
        },
        saas: {
          company_approval_deadline: "",
          order_is_waiting_for_company_approval: "",
          thank_you_for_order: "",
          thank_you_for_order_and_online_deposit: "",
          what_with_future_deposit_if_order_gets_approved_l1: "",
          what_with_future_deposit_if_order_gets_approved_l2: "",
          what_with_no_deposit_if_order_gets_approved: "",
          what_with_paid_deposit_if_order_gets_approved: "",
          thank_you_for_order_approval: "",
        },
        subject: "",
      },
      order_is_waiting_for_confirmation_online_payment_company_email: {
        line1: "",
        line2: "",
        subject: "",
      },
      order_is_waiting_for_confirmation_online_payment_customer_email: {
        after_company_approval_subject: "",
        default_subject: "",
        marketplace: {
          deadline_warning: "",
          order_approved: "",
          pay_button: "",
          payment_deadline: "",
          please_pay: "",
        },
        saas: {
          deadline_warning: "",
          order_approved: "",
          pay_button: "",
          payment_deadline: "",
          please_pay: "",
        },
      },
      order_is_waiting_for_customer_approval_customer_email: {
        marketplace: {
          action: "",
          approval_deadline: "",
          deadline_warning: "",
          order_approved: "",
          please_approve: "",
          approve_action: "",
          reject_action: "",
        },
        saas: {
          action: "",
          approval_deadline: "",
          deadline_warning: "",
          order_approved: "",
          please_approve: "",
          approve_action: "",
          reject_action: "",
        },
        subject: "",
      },
      order_online_deposit_time_limit_exceeded_company_email: {
        line1: "",
        subject: "",
      },
      order_online_deposit_time_limit_exceeded_customer_email: {
        marketplace: {
          line1_html: "",
          line2: "",
          line3_html: "",
        },
        saas: {
          line1_html: "",
          line2: "",
          line3_html: "",
        },
        subject: "",
      },
      order_online_payment_reminder_customer_email: {
        marketplace: {
          contact_us_if_problems: "",
          line1: "",
          offer_details_below: "",
        },
        saas: {
          contact_us_if_problems: "",
          line1: "",
          offer_details_below: "",
        },
        subject: "",
      },
      order_company_rejected_company_email: {
        line1: "",
        line2: "",
        subject: "",
        line1_html: "",
      },
      order_company_rejected_customer_email: {
        marketplace: {
          line1: "",
          see_offer_html: "",
          confirmation_installment_refund_info: "",
        },
        saas: {
          line1: "",
          see_offer_html: "",
          confirmation_installment_refund_info: "",
        },
        subject: "",
      },
      order_customer_rejected_company_email: {
        line1: "",
        subject: "",
      },
      order_customer_rejected_customer_email: {
        marketplace: {
          line1: "",
          see_offer_html: "",
          confirmation_installment_refund_info: "",
        },
        saas: {
          line1: "",
          see_offer_html: "",
          confirmation_installment_refund_info: "",
        },
        subject: "",
      },
      order_current_status_company_email: {
        line1: "",
        subject: "",
      },
      order_company_cancelled_company_email: {
        line1: "",
        subject: "",
        line1_html: "",
      },
      order_company_cancelled_customer_email: {
        marketplace: {
          line1: "",
          see_offer_html: "",
          confirmation_installment_refund_info: "",
        },
        saas: {
          line1: "",
          see_offer_html: "",
          confirmation_installment_refund_info: "",
        },
        subject: "",
      },
      order_abandonment_followup_customer_email: {
        see_product: "",
        find_other_products_in_this_location: "",
        line1: "",
        subject: "",
        go_to_product: "",
      },
    },
    papp: {
      components: {
        EditableBillRow: {
          placeholder: "",
        },
        InstallmentFormSection: {
          exact_date_label: "",
          how: "",
          on_stock_starts_at_label: "",
          paid_after_company_approval_label: "",
          remaining_amount: "",
          when: "",
          whole_amount: "",
          x_days_after_order_creation_label: "",
          x_days_after_order_full_approval_label: "",
          x_days_after_previous_installment_label: "",
          x_days_before_stock_starts_at_label: "",
          how_much: "",
          to: "",
        },
        InstallmentsListFormSection: {
          add_new: "",
        },
        LocationFormControl: {
          placeholder: "",
        },
        MainView: {
          default_error_title: "",
          error_date: "",
          error_description: "",
          error_id: "",
          loading: "",
          retry: "",
        },
        MultipleDateFormControl: {
          add_new: "",
        },
        MultipleInputFormControl: {
          placeholder: "",
        },
        MultipleTimeFormControl: {
          add_new: "",
        },
        OrderSidebarPreview: {
          edit_slot: "",
          see_slot: "",
        },
        PaginationNavigation: {
          out_of: "",
        },
        PaymentProfileProductAttachmentFormSection: {
          active: "",
          additional_fee: "",
          days_before_arrival_date_limit: "",
          days_before_arrival_date_limit_label: "",
          installment: "",
          no_date_limit: "",
        },
        ProductCustomerOrderFieldFormSection: {
          add_list_option: "",
          add_new: "",
          show_on_manifest: "",
          value_required: "",
          value_type: "",
        },
        ProductPricedOrderFieldFormSection: {
          add_list_option: "",
          ask_customer: "",
          different_currency_base_amount_note: "",
          for_all_variants: "",
          remove: "",
          show_on_manifest: "",
          value_type: "",
        },
        SlotsCalendar: {
          agenda: "",
          allDay: "",
          availability_mode: "",
          date: "",
          day: "",
          event: "",
          month: "",
          next: "",
          previous: "",
          price_mode: "",
          showMore: "",
          time: "",
          today: "",
          week: "",
          slot_confirmed: "",
        },
        TagsInputFormControl: {
          addition_label: "",
          no_results_message: "",
          placeholder: "",
        },
        TypeaheadInputFormControl: {
          no_results_message: "",
          placeholder: "",
        },
        SaleWindowRuleFormGroup: {
          sale_starts_at_label: "",
          sale_ends_at_label: "",
          offset_label: "",
          from_date_label: "",
          until_date_label: "",
          before_slot_start: "",
          resolved_preview: "",
        },
        UsebyDateRangeFormGroup: {
          days_limit_label: "",
          days_since_order_creation: "",
          ends_at_label: "",
          starts_at_and_ends_at_label: "",
          starts_at_label: "",
        },
        ProductsListItem: {
          preview_marketplace: "",
          preview_saas: "",
          new_order: "",
          active_switch_label: "",
          published_on_saas_switch_label: "",
        },
        OrderedProductOrderFieldFormControl: {
          custom_location_name_placeholder: "",
        },
        ProductsSelectControl: {
          blank_label: "",
        },
      },
      order: {
        approve: "",
        cancel_order: "",
        confirm: "",
        customer_name_placeholder: "",
        delete_order: "",
        finish: "",
        redeliver_customer_order_email: "",
        reject: "",
        redeliver_supplier_order_email: "",
        finish_order: "",
        automatic_icon: "",
        manual_icon: "",
        no_stock_date: "",
      },
      common: {
        search: "",
        no_results_message: "",
        discard_changes_confirm_message: "",
        go_back: "",
        remove: "",
        save: "",
        none: "",
        poland: "",
        edit: "",
        manage: "",
        save_changes: "",
        submit_success_message: "",
        default_value: "",
        attention: "",
        no_name: "",
        close: "",
        in_total: "",
        filters_title: "",
        form_validation_error_message: "",
        cancel: "",
        go_next: "",
        st_email: "",
        st_phone_number: "+48 690 670 581",
        are_you_sure: "",
        translations_locale: "",
        x_per_page: "",
        show_filters: "",
        hide_filters: "",
        download_csv: "",
        weekdayAbbreviations: ["", "", "", "", "", "", ""],
      },
      agents: {
        AgentsListView: {
          title: "",
          add_new: "",
          no_records_title: "",
          no_records_message: "",
          no_records_add_new_link: "",
        },
        EditAgentCooperationView: {
          default_pricing: "",
          activate_all: "",
          remove_confirm_message: "",
          title: "",
          title_with_company_name: "",
          products: "",
          price_change: "",
          gross_price: "",
          net_price: "",
          include_product_options_price: "",
          st_cooperation_hint: {
            p1: "",
            p2: "",
            p3: "",
          },
        },
        NewAgentPrompt: {
          title: "",
          email_label: "",
          submit: "",
        },
        SuppliersListView: {
          title: "",
          no_records_title: "",
          no_records_message: "",
          add_new: "",
        },
      },
      app: {
        App: {
          fetch_app_error_title: "",
        },
        ForbiddenView: {
          title: "",
          message: "",
        },
        LeftBar: {
          dashboard: "",
          calendar: "",
          orders: "",
          products: "",
          customers: "",
          agents: "",
          suppliers: "",
          finances: "",
          raports: "",
          settings: "",
          reviews: "",
          affiliate: "",
          accommodation: "",
          connectly: "Connectly"
        },
        NotFoundView: {
          title: "",
          message: "",
        },
        requireAuth: {
          company_forbidden: "",
          no_companies_error_title: "",
        },
        TopBar: {
          logout: "",
          marketplace_homepage: "",
          new_order: "",
          saas_homepage: "",
          your_account: "",
        },
      },
      auth: {
        LoginView: {
          send_confirmation_instructions_link: "",
          send_reset_password_instructions_link: "",
          send_unlock_instructions_link: "",
          submit: "",
          title: "",
        },
        ResetPasswordView: {
          submit: "",
          title: "",
        },
        SendResetPasswordInstructionsView: {
          email_help: "",
          email_label: "",
          submit: "",
          success_message: "",
          title: "",
        },
        index: {
          fetch_user_failed_message: "",
        },
      },
      calendar: {
        CalendarView: {
          all_products: "",
          all_suppliers: "",
          title: "",
          filter_all: "",
          filter_available: "",
          filter_awaiting: "",
          filter_booked: "",
          show_inactive_offers: "",
        },
        ShowSlotModal: {
          active_orders_title: "",
          build_order: "",
          no_orders_message: "",
          open_manifest: "",
          open_manifest_failure_message: "",
          other_orders_title: "",
          download_manifest: "",
          booked_orders_title: "",
          pending_orders_title: "",
          awaiting_orders_title: "",
          sale_window_title: "",
          sale_starts_at_label: "",
          sale_ends_at_label: "",
          within_sale_window_yes: "",
          within_sale_window_no: "",
          within_sale_window_past: "",
          biledo_block_title: "",
          biledo_term_uuid: "",
          biledo_pricelist_uuid: "",
          biledo_overwrite_warning: "",
        },
      },
      customers: {
        CustomersListView: {
          no_records_add_new_link: "",
          no_records_message: "",
          no_records_title: "",
          title: "",
          query_filter: "",
          add_new_customer: "",
        },
        EditCustomerModal: {
          existing_customer_title: "",
          new_customer_title: "",
          remove_confirm_message: "",
        },
        ShowCustomerView: {
          no_name: "",
          orders_title: "",
          title: "",
        },
      },
      dashboard: {
        DashboardView: {
          created_orders_number_label: "",
          finished_orders_number_label: "",
          finished_orders_total_amount_label: "",
          new_orders_title: "",
          no_graph_data_message: "",
          no_orders_waiting_message: "",
          orders_number_label: "",
          orders_waiting_for_your_approval_title: "",
          participants_number_label: "",
          see_all_orders: "",
          title: "",
          hint: {
            p1: "",
            p2: "",
            p3: "",
            p4: "",
            p5: "",
            p6: "",
            p2_html: "",
            p3_html: "",
            p4_html: "",
            p7: "",
            p6_html: "",
          },
          stats_title: "",
        },
      },
      finances: {
        FinancesListView: {
          no_records_message: "",
          no_records_title: "",
          title: "",
          summary_row: "",
          create_agent_disbursement: "",
          agent_received_paid_th: "",
          socialtravel_received_paid_th: "",
          supplier_received_paid_th: "",
          orders_count: "",
        },
      },
      settings: {
        SettingsLayout: {
          title: "",
          user: "",
          user_account_settings: "",
          company: "",
          company_account_settings: "",
          company_members_settings: "",
          products_settings: "",
          payments_settings: "",
          billing_settings: "",
          integrations: "",
          marketplace_settings: "",
          saas_settings: "",
          widgets_settings: "",
          readonly_access_message: "",
          stripe: "",
        },
        BillingSettingsView: {
          title: "",
          invoice_company_name_placeholder: "",
          invoice_contact_email_placeholder: "",
          invoice_contact_phone_number_placeholder: "",
          invoice_details_title: "",
          hint: {
            p1: "",
            p2: "",
          },
        },
        CompanyMembersView: {
          title: "",
          new_member: "",
          no_members: "",
          hint: {
            p1: "",
            p2: "",
          },
        },
        CompanySettingsView: {
          title: "",
          contact_details: "",
          contact_phone_number_placeholder: "",
          notifications_details: "",
          notifications_email_placeholder: "",
          notifications_email_label: "",
          notifications_phone_number_placeholder: "",
          notifications_phone_number_label: "",
          other_details: "",
          hint: {
            p1: "",
            p2: "",
            p3: "",
            p4: "",
            p5: "",
            p6: "",
            p7: "",
            p8: "",
            p9: "",
            p10: "",
            p11: "",
            p12: "",
          },
        },
        MarketplaceSettingsView: {
          title: "",
          marketplace_homepage_url_label: "",
          hint: {
            p1: "",
            p2: "",
          },
        },
        PaymentsSettingsView: {
          title: "",
          your_profiles_title: "",
          marketplace_profiles_title: "",
          add_new_profile: "",
          hint: {
            p1: "",
            p2: "",
            p3: "",
            p4: "",
            p5: "",
            p6: "",
            p7: "",
            p8: "",
          },
          no_your_profiles_warning: "",
          enable_for_all_product_variants: "",
          access_possible_only_for_supplier: "",
          increase_orders_amount_by_saas_commision_label: "",
          increase_orders_amount_by_saas_commision_enabled_hint: "",
          increase_orders_amount_by_saas_commision_disabled_hint: "",
        },
        ProductsSettingsView: {
          title: "",
          hint: {
            p1: "",
            p2: "",
            p3: "",
            p4: "",
          },
        },
        SaasSettingsView: {
          title: "",
          saas_homepage_url: "",
          contact_us_if_want_to_change: "",
          hint: {
            p1: "",
            p2: "",
          },
        },
        UserAccountView: {
          title: "",
          site_settings_title: "",
          password_change_title: "",
          hint: {
            p1: "",
            p2: "",
          },
        },
        WidgetsSettingsView: {
          title: "",
          iframe: "",
          button: "",
          navbar: "",
          detect_from_visitor_browser: "",
          locale: "",
          currency: "",
          bubble: "",
          active: "",
          scrollWidget: "",
          exitWidget: "",
        },
        ButtonWidgetView: {
          book_now: "",
          small_size: "",
          normal_size: "",
          large_size: "",
          bottom_right: "",
          bottom_left: "",
          top_right: "",
          top_left: "",
          in_modal: "",
          in_new_tab: "",
          title: "",
          button_content: "",
          open: "",
          color: "",
          size: "",
          stick_to_window_corner: "",
          generate_code: "",
          place_code_anywhere: "",
          put_widget_anywhere: "",
          preview: "",
          button_type: "",
          flag_type: "",
          what_type: "",
          center_right: "",
          center_left: "",
        },
        NavBarWidgetView: {
          new_link: "",
          our_products: "",
          products_calendar: "",
          book: "",
          white_blue: "",
          white_teal: "",
          white_orange: "",
          black_blue: "",
          black_teal: "",
          black_orange: "",
          blue: "",
          teal: "",
          orange: "",
          to_window_bottom: "",
          to_window_top: "",
          in_modal: "",
          in_new_tab: "",
          none: "",
          company_name: "",
          company_logo: "",
          title: "",
          show_company_name: "",
          show_toggle_button: "",
          open: "",
          color: "",
          stick: "",
          cta_button: "",
          navigation: "",
          contact: "",
          generate_code: "",
          place_code_anywhere: "",
          put_widget_anywhere: "",
          preview: "",
          link_type_link: "",
          link_type_none: "",
          link_type_text: "",
          link_type_phone: "",
          link_type_email: "",
          link_type_custom_link: "",
          black: "",
          white: "",
          green: "",
          type1: "",
          type2: "",
          type3: "",
          red: "",
          percentage: "",
          activity: "",
          cart: "",
          notification: "",
          offer: "",
          search: "",
          star: "",
          negotiate: "",
          discount: "",
          chat: ""
        },
        IframeWidgetView: {
          title: "",
          iframe_width: "",
          iframe_height: "",
          generate_code: "",
          put_widget_anywhere: "",
          preview: "",
        },
        WidgetRouteFormSection: {
          homepage_page: "",
          products_list_page: "",
          products_calendar_page: "",
          product_page: "",
          new_order_page: "",
          on_slot_click_show_product: "",
          on_slot_click_new_order: "",
          type: "",
          product: "",
          all_products: "",
          on_slot_click_action_type: "",
          reviews_page: "",
          product_location_tag: "",
          product_location_tag_page: "",
          product_category_tag: "",
          product_category_tag_page: "",
          coupons_page: "",
        },
        EditPaymentProfileModal: {
          profile_change_affects_all_products_warning: "",
          remove_confirm_message: "",
          edit_profile_title: "",
          new_profile_title: "",
          name_label: "",
          name_hint: "",
          has_additional_fee_label: "",
          cancellation_policy_hint: "",
          installments_label: "",
          additional_fee_as_agent_fee_label: "",
        },
        EditCompanyMemberModal: {
          edit_member_title: "",
          new_member_title: "",
          remind_password: "",
        },
        BubbleWidgetView: {
          balloon_line1_value: "",
          balloon_line2_value: "",
          balloon_line1_label: "",
          balloon_line2_label: "",
          generate_code: "",
          large_size: "",
          normal_size: "",
          place_code_anywhere: "",
          placement: "",
          preview: "",
          put_widget_anywhere: "",
          small_size: "",
          title: "",
          bottom_left_corner: "",
          bottom_right_corner: "",
          color_label: "",
          placement_label: "",
          size_label: "",
          top_left_corner: "",
          top_right_corner: "",
          show_after_label: "",
          show_balloon_after_label: "",
          play_sound_label: "",
          animation_type: "",
          icon: "",
        },
        IndexWidgetsView: {
          header1: "",
          header2: "",
          text1: "",
          text2: "",
          text3: "",
          text4: "",
          widgetCodeHasBeenCopied: "",
          widgetCodeHasnBeenCopied: "",
          copyWidgetCode: "",
        },
        StripeSettingsView: {
          title: "",
          stripe_verification_failure: "",
          stripe_verification: "",
          stripe_verification_success: "",
          line1_html: "",
          line2_html: "",
          line4_html: "",
          line3: "",
          line3_1: "",
          line3_2: "",
          line3_3: "",
          line3_4: "",
          line5_html: "",
          line6_html: "",
          line7: "",
          line1: "",
          line2: "",
        },
      },
      orders: {
        AddOrderTransferModal: {
          default_title: "",
          new_refund_title: "",
          new_transfer_title: "",
        },
        ChangeOrderScheduleSlotModal: {
          title: "",
        },
        EditOrderCustomerDetailsModal: {
          title: "",
          customer_details: "",
        },
        EditOrderInstallmentsModal: {
          title: "",
        },
        EditOrderItemsModal: {
          title: "",
          changed_order_item_name: "",
          changed_order_option_name: "",
          removed_order_option_name: "",
          added_order_option_name: "",
          order_items_title: "",
          order_item_index: "",
          order_item_unit_price: "",
          order_item_quantity: "",
          order_item_total_price: "",
          add_new_order_item: "",
          extra_participants_existing: "",
          installments_require_manual_change_warning: "",
        },
        NewOrderItemsForm: {
          select_agent: "",
          reset_agent_commision: "",
          product_options: "",
          other_order_items: "",
          add_new_order_item: "",
        },
        NewOrderPaymentsForm: {
          accept_deposit: "",
          plan_payments: "",
          no_payments: "",
          deposit_accepted_as_agent: "",
          deposit_accepted_as_supplier: "",
          only_deposit_now: "",
          rest_payment: "",
          order_status: "",
          notify_customer: "",
          notify_customer_impossible_no_customer_email_given: "",
          note_placeholder: "",
          choose_payments_mode: "",
          choose_payments_mode_error: "",
          order_status_message: "",
        },
        NewOrderProductModal: {
          no_products_found: "",
          static_date_booking_label: "",
          with_custom_product_title: "",
          choose_product_variant: "",
          default_title: "",
          search_products: "",
          use_custom_product_button: "",
          info1: "",
          order_name: "",
        },
        NewOrderModal: {
          confirm_abandon_message: "",
          confirm_abandon_cancel: "",
          confirm_abandon_ok: "",
          schedule_step_title: "",
          order_items_step_title: "",
          customer_details_step_title: "",
          payments_step_title: "",
          abandon_failed_message: "",
          payments_step_profiles_instruction: "",
          payments_step_choose_payments: "",
          payments_step_choose_payments_reseller: "",
          payments_step_choose_payments_customer: "",
          payments_step_choose_payments_reseller_hint1: "",
          payments_step_choose_payments_reseller_hint2: "",
          payments_step_choose_payments_customer_hint1: "",
          payments_step_choose_payments_customer_hint2: "",
          payments_step_prebook: "",
          payments_step_choose_payments_terminal_hint1: "",
          payments_step_choose_payments_terminal_hint2: "",
          payments_step_choose_payments_terminal: "",
        },
        OrderScheduleForm: {
          select_existing_slot: "",
          upcoming_slots: "",
          no_slots_found: "",
          all_day: "",
          add_new_slot: "",
        },
        OrdersListView: {
          title: "",
          add_new_order: "",
          no_orders_title: "",
          no_orders_message: "",
          no_orders_add_new_button: "",
          customer_query_filter: "",
          other_filters: "",
          marketplace_filter: "",
          saas_filter: "",
          manual_filter: "",
          automatic_filter: "",
          requires_company_approval_filter: "",
          doesnt_require_company_approval_filter: "",
          no_booking_filter: "",
          static_date_booking_filter: "",
          total_amount_currencies_filter: "",
          customer_payment_methods_filter: "",
          with_agent_commision_filter: "",
          with_agent_service_fee_filter: "",
          with_both_agent_commision_and_service_fee_filter: "",
          with_saas_commision_filter: "",
          customer_transfer_date_filter: "",
          without_agent_commision_and_service_fee_filter: "",
          notes_filter: "",
          with_notes_filter: "",
          notes_filter_placeholder: "",
          with_affiliate_filter: "",
          with_agent_filter: "",
          with_agent: "",
          static_date_range_booking_filter: "",
        },
        ChangeOrderStatusPrompt: {
          title: "",
          choose_new_status: "",
          save_and_notify_customer: "",
          notify_supplier: "",
          save_and_send_opinion_request: "",
        },
        ShowOrderView: {
          add_new_transfer: "",
          add_new_refund: "",
          edit_note: "",
          change_status: "",
          print: "",
          customer_title: "",
          see_details: "",
          send_notification: "",
          order_items_title: "",
          order_item_unit_price: "",
          order_item_quantity: "",
          payments_title: "",
          agent_title: "",
          activities_title: "",
          title: "",
          approve_warning: "",
          approve_until_warning: "",
          send_opinion_reminder_notification: "",
          pay_now: {
            tooltip: {
              no_payment_needed: "",
              too_low_amount: "",
            },
            0: "",
          },
        },
        utils: {
          confirm_approve_message: "",
          confirm_reject_message: "",
          confirm_finish_message: "",
          confirm_cancel_message: "",
          confirm_delete_message: "",
          redeliver_customer_order_email_success_message: "",
          redeliver_supplier_order_email_success_message: "",
          create_agent_disbursement_success_message: "",
          redeliver_customer_order_opinion_reminder_email_success_message: "",
          send_opinion_request_to_customer: "",
        },
        OrderCustomerDetailsFormSection: {
          participants_details: "",
        },
        EditOrderNotesModal: {
          title: "",
        },
      },
      products: {
        EditProductView: {
          StepAdditional: {
            form_title: "",
            marketplace_settings: "",
            saas_commision_settings: "",
            hint: {
              p1: "",
              p2: "",
            },
          },
          StepAvailability: {
            all_product_variants: "",
            remove_all_slots_confirm: {
              title: "",
              message: "",
              confirm: "",
            },
            remove_single_slot_confirm: {
              title: "",
              message: "",
              select_all_slots: "",
              confirm: "",
            },
            remove_booked_slot_alert: {
              message: "",
              go_to_slot_view: "",
            },
            remove_slot_confirm: {
              title: "",
              message: "",
              confirm: "",
            },
            edit_all_slots_confirm: {
              title: "",
              message: "",
              confirm: "",
            },
            edit_single_slot_confirm: {
              title: "",
              message: "",
              select_all_slots: "",
              confirm: "",
            },
            add_slot: "",
            add_many_slots: "",
            select_first_slot_date: "",
            select_slot_date: "",
            prices_title: "",
            no_prices_message: "",
            availability_title: "",
            hint: {
              p1: "",
              p2: "",
              p3: "",
              p4: "",
              p5: "",
            },
            normal_start_dates_assignation_type: "",
            recursion_start_dates_assignation_type: "",
            edit_slot: "",
            repeat_on_days: "",
            repeat_until: "",
            repeat_in_hours: "",
            repeat_slot: "",
          },
          StepBookingSettings: {
            already_used_stock: "",
            nb_stock_useby_date_label: "",
            nb_dont_require_company_approval_label: "",
            slots_will_be_removed_warning: "",
            form_title: "",
            static_date_booking_label: "",
            global_settings: "",
            default_settings: "",
            hint: {
              p1: "",
              p2: "",
              p3: "",
              p4: "",
              p5: "",
              p6: "",
              p7: "",
            },
            enable_frontend_slots_listing_label: "",
            expire_at_label: "",
            availability_limit_label: "",
          },
          StepCustomerFields: {
            customer_fields: "",
            participant_fields: "",
            hint: {
              p1: "",
              p2: "",
            },
          },
          ProductVariantMigrateModal: {
            copy_description_label: "",
            copy_pricelist_label: "",
            copy_payments_label: "",
            copy_booking_settings_label: "",
            copy_pickup_points_label: "",
            copy_priced_fields_label: "",
            copy_customer_fields_label: "",
            copy_description_hint: "",
            copy_pricelist_hint: "",
            copy_payments_hint: "",
            copy_booking_settings_hint: "",
            copy_pickup_points_hint: "",
            copy_priced_fields_hint: "",
            copy_customer_fields_hint: "",
            title: "",
            source_variant: "",
            target_variant: "",
            copy_label: "",
            submit: "",
          },
          StepDescription: {
            remove_variant: "",
            migrate_data_from_other_product: "",
            new_variant_default_name: "",
            add_variant_message: "",
            add_variant_message_link: "",
            hint: {
              p1: "",
              p2: "",
              p3: "",
              p4: "",
              p5: "",
              p6: "",
              p7: "",
              p8: "",
              p9: "",
              p10: "",
              p11: "",
              p12: "",
              p13: "",
              p14: "",
            },
          },
          StepLocation: {
            main_location_label: "",
            other_locations_label: "",
            new_pickup_point_title: "",
            edit_pickup_point_title: "",
            remove_pickup_point: "",
            add_new_pickup_point: "",
            locations_title: "",
            pickup_points_title: "",
            pickup_point_assignation_per_person_label: "",
            additional_settings: "",
            hint: {
              p1: "",
              p2: "",
              p3: "",
              p4: "",
              p5: "",
              p6: "",
              p7: "",
              p8: "",
              p9: "",
              p10: "",
            },
            pickup_points_price_per_person_label: "",
            custom_pickup_point_name: "",
            no_pickup_point_name: "",
          },
          StepPayments: {
            supplier_profiles_title: "",
            marketplace_profiles_title: "",
            add_new_payment_profile: "",
            form_title: "",
            hint: {
              p1: "",
              p2: "",
              p3: "",
              p4: "",
            },
            no_supplier_profiles_warning: "",
            no_marketplace_profiles_warning: "",
            access_temporarily_enabled_only_for_supplier: "",
          },
          StepPhotos: {
            cover_photo: "",
            name_placeholder: "",
            form_title: "",
            click_or_drag_and_drop_to_add_photos: "",
            add_video: "",
            add_video_submit: "",
            hint: {
              p1: "",
              p2: "",
            },
          },
          StepPricedFields: {
            form_title: "",
            add_new_field: "",
            hint: {
              p1: "",
              p2a: "",
              p2b: "",
              p3a: "",
              p3b: "",
              p4a: "",
              p4b: "",
              p5: "",
              p6: "",
              p7: "",
              p8: "",
              p9: "",
            },
          },
          StepPricelist: {
            form_title: "",
            hint: {
              p1: "",
              p2: "",
              p3: "",
              p4: "",
              p5: "",
              p6: "",
              p7: "",
            },
            persons_count: "",
            persons_count_from: "",
            age_from: "",
            person_category_name: "",
            add_new_item: "",
            item_name: "",
            coupon_code_name: "",
            new_coupon_code_name: "",
            add_new_coupon: "",
            coupon_codes_title: "",
            coupon_codes_description: "",
            coupon_code_realisation_place_type_label: "",
            coupon_codes_realisation_place_online_website: "",
            coupon_codes_realisation_place_manually: "",
            coupon_codes_realisation_place_custom: "",
            coupon_code_realisation_place_custom_description_placeholder: "",
            generate_coupon_codes: "",
            saas_featured_price: "",
          },
          menu: {
            description: "",
            add_locale: "",
            translate: "",
            translate_modal: {
              title: "",
              explanation: "",
              select_source_locale: "",
              select_locale: "",
              submit: "",
            },
            pricelist: "",
            availability: "",
            prices: "",
            payments: "",
            booking_settings: "",
            photos: "",
            location: "",
            priced_fields: "",
            customer_fields: "",
            additional_settings: "",
            title: "",
            accommodation_settings: "",
            integrations: ""
          },
          common: {
            remove_confirm_message: "",
            orders_button: "",
            preview_st: "",
            preview_saas: "",
            save_success_message: "",
            remove_success_message: "",
            add_photos_success_message: "",
          },
          StepAccommodationSettings: {
            form_title: "",
            accommodation_settings: {
              category: "",
              categoryOption: {
                one_person_room: "",
                two_person_room: "",
                three_person_room: "",
                four_person_room: "",
                multi_person_room: "",
                bed_in_multi_person_room: "",
                apartment: "",
                cottage: "",
                villa: "",
                holiday_house: "",
                tent: "",
              },
              categoryTitle: {
                room: "",
                bathroom: "",
                view: "",
                food_and_drinks: "",
              },
              categoryDescription: "",
            },
            default_total_stock_limit: "",
            accommodation_detail: {
              single_beds_count: "",
              double_beds_count: "",
              extra_beds_count: "",
              bathrooms_count: "",
              rooms_count: "",
              area: "",
            },
            presented_price: "",
            accommodationUnitSettings: "",
            facilities: "",
            accommodationUnitSettingsDescription: "",
            facilitiesDescription: "",
          },
          StepIntegrations: {
            log_integration_date: "",
            log_integration_action: "",
            log_integration_company_id: "",
            log_integration_uuid: "",
            filter_all_logs: "",
            filter_succeeded: "",
            filter_all_failed: ""
          }
        },
        ManageLocalesPrompt: {
          title: "",
          select_locale: "",
        },
        NewProductPrompt: {
          title: "",
          name_placeholder: "",
          submit: "",
          coupon_label: "",
          offer_type_header: "",
          offer_type_standard_header: "",
          offer_type_standard_description: "",
          offer_type_coupon_header: "",
          offer_type_coupon_description: "",
          offer_type_ticket_header: "",
          offer_type_ticket_description: "",
          offer_type_voucher_header: "",
          offer_type_voucher_description: "",
          offer_type_accommodation_header: "",
          offer_type_accommodation_description: "",
        },
        ProductsListView: {
          products: "",
          settings: "",
          add_new_product: "",
          no_products_message: "",
          no_products_message_link: "",
          no_products_title: "",
          search_top_bar: "",
        },
        StepAdditional: {
          hide_description_for_variants: "",
        },
      },
      reviews: {
        ReviewsListView: {
          no_records_message: "",
          no_records_title: "",
          title: "",
        },
        EditReviewModal: {
          title: "",
          remove_confirm_message: "",
        },
      },
      affiliate: {
        AffiliateListView: {
          no_records_message: "",
          no_records_title: "",
          summary_row: "",
          title: "",
        },
      },
      suppliers: {
        NewSupplierPrompt: {
          email_label: "",
        },
      },
      pagination: {
        show_10: "",
        show_20: "",
        show_30: "",
        show_50: "",
        show_100: "",
      },
      accommodation: {
        AccommodationSchedulerView: {
          title: "",
          calendarLink: "",
          noProductsInfo: "",
          availabilityTypes: {
            available_with_instant_booking: "",
            available_with_company_approval: "",
            no_changes: "",
          },
          productsHeader: "",
          pricingPlansHeader: "",
          availabilityTypeHeader: "",
          datesHeader: "",
          hintHeader: "",
          hintContent: "",
          errors: {
            maxDatesDifference: "",
            daysNotIncluded: "",
          },
          totalStockLimit: "",
        },
        AccommodationCalendarView: {
          title: "",
          schedulerLink: "",
        },
        Accommodation: {
          totalStockLeftTypes: {
            noChanges: "",
            unavailable: "",
            specified: "",
          },
        },
      },
    },
    st: {
      pricelist_order_installment_item: {
        paid_by_cash: "",
        paid_by_online_payment: "",
        paid_by_bank_wire: "",
        already_paid: "",
        to_be_paid_right_now: "",
        to_be_paid_right_after_company_approval: "",
        to_be_paid_on_spot: "",
        to_be_paid_until: "",
        to_be_paid_after_previous_installment: "",
        to_be_paid_now: "",
        to_be_paid_after_order_creation: "",
        to_be_paid_after_company_approval: "",
        to_be_paid_after_approval: "",
        to_be_paid_before_stock_start_date: "",
        in_your_currency_it_is: "",
        payment_accepted_in_website_currency: "",
        payment_accepted_in_company_currency: "",
        payments_are_converted_with_following_rates: "",
        your_bank_can_issue_an_additional_fee_for_the_transaction: "",
        to_supplier: "",
        to_agent: "",
        to_socialtravel: "",
        paid_by_dotpay: "",
        paid_by_paypal: "",
        marketplace_bank_wire_transfer_title: "",
        saas_bank_wire_transfer_title: "",
        bank_wire_transfer_details: "",
        paid_by_payu: "",
        paid_by_stripe: "",
        paid_by_terminal: "",
      },
      app_config: {
        saas_service_fee_name: "",
        site_short_description: "",
        pdf_voucher_st_address_details: "",
        tripsomnia_company_name: "",
        tripsomnia_contact_email: "",
        tripsomnia_contact_full_address: "",
        tripsomnia_service_fee_name: "",
        agent_service_fee_name: "",
        socialtravel_company_name: "",
        socialtravel_contact_email: "info@tripsomnia.com",
        tripsomnia_contact_opening_hours: "",
        socialtravel_service_fee_name: "",
        socialtravel_contact_phone_number: "",
        tripsomnia_contact_phone_number: "+48 690 670 581",
      },
      create_agent_disbursement: {
        no_orders_error: "",
        no_order_agent_error: "",
        incorrect_order_company_error: "",
      },
    },
    countries: {
      pl: "",
    },
    customer_mailer: {
      order_marketing_info: {
        subject: "",
      },
      reset_password: {
        action: "",
        greeting: "",
        instruction: "",
        instruction_2: "",
        instruction_3: "",
        subject: "",
      },
    },
    product_request_mailer: {
      customer_requested_discount_company_email: {
        hello_company: "",
        content: {
          line1: "",
          line2: "",
          line3: "",
        },
        details_header: "",
        customer_details_header: "",
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "",
      },
      customer_requested_discount: {
        content: {
          line1: "",
        },
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "",
      },
      customer_requested_product: {
        subject: "",
      },
      customer_requested_product_company_email: {
        content: {
          line1: "",
          line2: "",
          line3: "",
        },
        customer_details_header: "",
        details_header_html: '<a href="%{product_link}">%{product_name}</a>',
        hello_company: "",
        info: {
          line1_html: "",
          line2_html: "",
          line3_html: "",
        },
        subject: "",
      },
    },
    pl: {
      papp: {
        settings: {
          StripeSettingsView: {
            stripe_login_button: "",
            stripe_register_button: "",
          },
        },
      },
    },
    ordered_item: {
      accommodation: {
        name: {
          one: "",
          few: "",
          many: "",
          other: "",
        },
      },
      product: {
        name: "",
      },
    },
    en: {
      activerecord: {
        attributes: {
          pricing_plan: {
            preset: {
              elastic: {
                company_description: "",
                customer_description: "",
              },
              not_refundable: {
                company_description: "",
                customer_description: "",
              },
            },
          },
        },
      },
    },
  }));



// WEBPACK FOOTER //
// ./src/i18n/translations.js